
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g7CEg", function(module, exports) {
$parcel$export(module.exports, "UniformWrapper", function () { return $85ecc4bac898c23a$export$227673ab846fab74; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $dNSrU = parcelRequire("dNSrU");

var $5HK05 = parcelRequire("5HK05");

var $7WM7y = parcelRequire("7WM7y");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $3d4V3 = parcelRequire("3d4V3");

var $7GVWk = parcelRequire("7GVWk");

var $hu7gH = parcelRequire("hu7gH");

var $eNxv9 = parcelRequire("eNxv9");

var $g70ym = parcelRequire("g70ym");

var $9rnwe = parcelRequire("9rnwe");
const $85ecc4bac898c23a$var$resolveRenderer = ({ type: type })=>{
    const MissingComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $g70ym.UniformMissingComponent), {
            componentName: type
        });
    return (0, $eNxv9.default)[type] ?? MissingComponent;
};
const $85ecc4bac898c23a$export$227673ab846fab74 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const preloadedComposition = typeof window !== "undefined" ? window._uniformPreloadedComposition : null;
    const initialData = preloadedComposition || composition;
    const [baseComposition, setBaseComposition] = (0, $1oC0p.useState)(initialData);
    const [personalizedComposition, setPersonalizedComposition] = (0, $1oC0p.useState)(initialData);
    const [isFetched, setIsFetched] = (0, $1oC0p.useState)(!!initialData);
    const [shouldRender404, setShouldRender404] = (0, $1oC0p.useState)(false);
    // Listen for postMessage events to update composition dynamically
    // Only enabled if allowPostMessage flag is set and in non-production environments
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window === "undefined") return;
        // Only enable if allowPostMessage flag is set
        if (!isAllowPostMessage) return;
        const handleMessage = async (event)=>{
            // Check if message is for updating Uniform composition
            if (event.data?.type === "UNIFORM_COMPOSITION_UPDATE" && event.data?.composition) try {
                const compositionData = event.data.composition;
                // If composition is wrapped in compositionApiResponse, extract it
                const rawComposition = compositionData.compositionApiResponse?.composition || compositionData;
                // Enhance the composition
                const enhancedComp = await (0, $3d4V3.enhanceComposition)(rawComposition);
                // Update state to trigger re-render
                setBaseComposition(enhancedComp);
                setIsFetched(true);
                console.log("Uniform composition updated via postMessage");
            } catch (error) {
                console.error("Error processing composition from postMessage:", error);
            }
        };
        window.addEventListener("message", handleMessage);
        return ()=>{
            window.removeEventListener("message", handleMessage);
        };
    }, [
        isAllowPostMessage
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // When isAllowPostMessage is true and compositionId is in the URL,
        // we need to fetch from the Canvas API even if initialData exists
        // (because initialData may be EMPTY_COMPOSITION from SSR).
        const hasCompositionIdInUrl = typeof window !== "undefined" && new URLSearchParams(window.location.search).has("compositionId");
        if (initialData && !(isAllowPostMessage && hasCompositionIdInUrl)) return;
        const addNoIndexTag = ()=>{
            if (typeof document !== "undefined") {
                let robotsMeta = document.querySelector('meta[name="robots"]');
                if (!robotsMeta) {
                    robotsMeta = document.createElement("meta");
                    robotsMeta.setAttribute("name", "robots");
                    document.head.appendChild(robotsMeta);
                }
                robotsMeta.setAttribute("content", "noindex,nofollow");
            }
        };
        const fetchFromCanvasApi = async (compositionId, projectId, apiKey, previewLocale)=>{
            const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
            // On localhost, proxy through the local dev server (avoids CORS + keeps
            // the API key out of the browser even in local dev).
            // On staging/prod, proxy through wac-management-service which holds the
            // Uniform API key server-side — never call uniform.app directly from the
            // browser as that triggers CORS errors.
            const buildCanvasUrl = (state)=>{
                if (isLocalhost) return `/api/uniform-canvas-proxy?compositionId=${encodeURIComponent(compositionId)}&state=${state}&projectId=${encodeURIComponent(projectId)}&apiKey=${encodeURIComponent(apiKey)}&locale=${encodeURIComponent(previewLocale)}`;
                const wacmanBase = undefined ?? "";
                return `${wacmanBase}/api/v1/uniform/composition/get?compositionId=${encodeURIComponent(compositionId)}&projectId=${encodeURIComponent(projectId)}&state=${encodeURIComponent(state)}&locale=${encodeURIComponent(previewLocale)}`;
            };
            // No credentials needed — WACMAN supplies the Uniform API key
            // server-side. On localhost the dev-server proxy also handles auth.
            const res = await fetch(buildCanvasUrl("64"), {});
            if (!res.ok) {
                // Fall back to draft state if published not found
                const draftRes = await fetch(buildCanvasUrl("0"), {});
                if (!draftRes.ok) {
                    console.error(`Canvas API error: ${draftRes.status}`);
                    setShouldRender404(true);
                    setIsFetched(true);
                    return;
                }
                const draftData = await draftRes.json();
                const enhancedComp = await (0, $3d4V3.enhanceComposition)(draftData.composition);
                setBaseComposition(enhancedComp);
                setShouldRender404(false);
                setIsFetched(true);
                console.log("uniform-preview: composition loaded from Canvas API (draft)");
                return;
            }
            const data = await res.json();
            const enhancedComp = await (0, $3d4V3.enhanceComposition)(data.composition);
            setBaseComposition(enhancedComp);
            setShouldRender404(false);
            setIsFetched(true);
            console.log("uniform-preview: composition loaded from Canvas API (published)");
        };
        // oxlint-disable-next-line complexity
        // eslint-disable-next-line complexity
        const fetchComposition = async ()=>{
            if (typeof window === "undefined") return;
            const { path: path, locale: locale } = (0, $hu7gH.parseRoute)(window.location);
            if (path === "uniform-preview" && isAllowPostMessage === true) {
                // Check for compositionId query param — if present, fetch directly
                // from the Uniform Canvas API instead of waiting for postMessage.
                // This is the preferred approach for migration validation as it
                // avoids the fragile postMessage/localStorage chunking flow.
                const params = new URLSearchParams(window.location.search);
                const compositionId = params.get("compositionId");
                const projectId = params.get("projectId");
                const apiKey = params.get("apiKey");
                if (compositionId && projectId && apiKey) {
                    // Get locale from query param or default to en-US
                    // This is required to resolve localized parameters correctly
                    const previewLocale = params.get("locale") || "en-US";
                    console.log("uniform-preview: fetching composition directly from Canvas API", {
                        compositionId: compositionId,
                        projectId: projectId,
                        locale: previewLocale
                    });
                    try {
                        await fetchFromCanvasApi(compositionId, projectId, apiKey, previewLocale);
                    } catch (error) {
                        console.error("Error fetching composition from Canvas API:", error);
                        setShouldRender404(true);
                        setIsFetched(true);
                    }
                    return;
                }
                console.log("uniform-preview with allowPostMessage - waiting for postMessage");
                return;
            }
            const slug = path.startsWith("/") ? path.substring(1) : path;
            const cdn = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacCompositionCutover) ? "https://wac-management-service--comp-prd.us-east-1.prod.public.atl-paas.net/" : "https://wac-uniform-promotion--production.us-east-1.prod.public.atl-paas.net/";
            const cdnPath = `release/${locale}/${slug}/composition.json`;
            const cdnComposition = `${cdn}${cdnPath.replace(/\/\//g, "/")}`;
            try {
                const req = await fetch(cdnComposition);
                setShouldRender404(req.status !== 200);
                if (req.status === 404) {
                    setIsFetched(true);
                    return;
                }
                const file = await req.json();
                const enhancedComp = await (0, $3d4V3.enhanceComposition)(file.compositionApiResponse.composition);
                setBaseComposition(enhancedComp);
                setShouldRender404(false);
                setIsFetched(true);
                if (enhancedComp?.parameters?.["noIndex"]?.value) addNoIndexTag();
            } catch (error) {
                console.error("Error fetching composition from CDN:", error);
                setShouldRender404(true);
                setIsFetched(true);
            }
        };
        fetchComposition();
    }, [
        initialData,
        composition,
        isAllowPostMessage
    ]);
    const { user: user } = (0, $7GVWk.useUserContext)();
    const { context: context } = (0, $dNSrU.useUniformContext)();
    const { personalizationValues: personalizationValues } = (0, $9rnwe.useWAEContext)();
    (0, $1oC0p.useMemo)(()=>{
        context.update({
            quirks: {
                ...personalizationValues
            }
        });
    }, [
        context,
        personalizationValues
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const tokens = new Map([
            [
                "{{name}}",
                user?.name || ""
            ]
        ]);
        let jsonString = JSON.stringify(baseComposition);
        if (jsonString) {
            jsonString = jsonString.replace(/\{\{[a-zA-Z-]*\}\}/g, (match)=>{
                return tokens.get(match) || match;
            });
            setPersonalizedComposition(JSON.parse(jsonString));
        }
        const updateQuirks = async ()=>{
            if (!user?.name) return;
            const quirks = {
                ...context.quirks,
                name: user.name
            };
            await context.update({
                quirks: quirks
            });
        };
        updateQuirks();
    }, [
        user?.name,
        context,
        baseComposition
    ]);
    if (isUniformPlayground) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformPlayground), {
        behaviorTracking: "onLoad",
        resolveRenderer: $85ecc4bac898c23a$var$resolveRenderer,
        contextualEditingEnhancer: ({ composition: composition })=>(0, $3d4V3.enhanceComposition)(composition)
    });
    return shouldRender404 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}) : isFetched && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformComposition), {
            data: (0, $5HK05.expectContent)(personalizedComposition || baseComposition),
            behaviorTracking: "onLoad",
            resolveRenderer: $85ecc4bac898c23a$var$resolveRenderer,
            contextualEditingEnhancer: ({ composition: composition })=>(0, $3d4V3.enhanceComposition)(composition)
        })
    });
};

});
parcelRegister("3d4V3", function(module, exports) {
$parcel$export(module.exports, "enhanceComposition", function () { return $bea8ea4430d263c8$export$c6905b5a726736f3; });

var $f2QWG = parcelRequire("f2QWG");

var $hoxx0 = parcelRequire("hoxx0");

var $6GrXU = parcelRequire("6GrXU");

var $3lGAh = parcelRequire("3lGAh");

var $hM3sF = parcelRequire("hM3sF");

var $6Vl9e = parcelRequire("6Vl9e");

var $gVC4y = parcelRequire("gVC4y");
const $bea8ea4430d263c8$var$rtfToHTMLEnhancer = ({ parameter: parameter })=>{
    if (typeof parameter === "string") return parameter;
    return (0, $gVC4y.richTextToHTML)(parameter.value);
};
const $bea8ea4430d263c8$var$customerStoryBodyEnhancer = ({ parameter: parameter })=>{
    const result = parameter.value;
    // @ts-expect-error - type mismatch
    if (result.storyText) // @ts-expect-error - type mismatch
    result.storyText = (0, $gVC4y.richTextToHTML)(// @ts-expect-error - type mismatch
    result.storyText);
    return result;
};
const $bea8ea4430d263c8$export$8012d36ea1a85499 = async ({ component: component })=>{
    const parameters = component.parameters;
    const locale = parameters.roadmapFeaturesLocale.value;
    const roadmapName = parameters.roadmapName?.value ?? "Cloud";
    return (0, $hoxx0.getRoadmapFeatures)({
        limit: (0, $hoxx0.ROADMAP_FEATURES_INITIAL_PAGE_SIZE),
        locale: locale,
        roadmapName: roadmapName
    });
};
const $bea8ea4430d263c8$export$62885b6f3404cc9d = new (0, $f2QWG.EnhancerBuilder)()// don't implement for richText param type, as that is Uniform rich text, not Contentful
.parameterName("story", $bea8ea4430d263c8$var$customerStoryBodyEnhancer).parameterName([
    "richText",
    "feature1RichText",
    "feature2RichText",
    "feature3RichText"
], $bea8ea4430d263c8$var$rtfToHTMLEnhancer)// @ts-expect-error - type mismatch
.parameterName("comparePlansData", (0, $6GrXU.comparePlansEnhancer)).component("pricingCalculator", (builder)=>{
    builder.data("comparePlansData", (0, $hM3sF.pricingCalculatorEnhancer));
})// @ts-expect-error - type mismatch
.parameterName("tableData", (0, $6Vl9e.tableDataEnhancer)).component("roadmapFeatures", (builder)=>{
    builder.data("data", $bea8ea4430d263c8$export$8012d36ea1a85499);
}).component("filterableGallery", (builder)=>{
    builder.parameterName("items", (0, $3lGAh.contentfulIncludesEnhancer));
});
const $bea8ea4430d263c8$export$c6905b5a726736f3 = async (composition)=>{
    await (0, $f2QWG.enhance)({
        composition: composition,
        enhancers: $bea8ea4430d263c8$export$62885b6f3404cc9d,
        context: {}
    });
    return composition;
};

});
parcelRegister("hoxx0", function(module, exports) {
$parcel$export(module.exports, "ROADMAP_FEATURES_INITIAL_PAGE_SIZE", function () { return $8fefb655ffdbd82b$export$8b80ff538f17d2ea; });
$parcel$export(module.exports, "ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE", function () { return $8fefb655ffdbd82b$export$926c841e781e53f7; });
$parcel$export(module.exports, "getRoadmapFeatures", function () { return $8fefb655ffdbd82b$export$67db44fab066fc1c; });

var $1dWiR = parcelRequire("1dWiR");

var $eRzlV = parcelRequire("eRzlV");

var $79QIK = parcelRequire("79QIK");
const $8fefb655ffdbd82b$export$8b80ff538f17d2ea = 50;
const $8fefb655ffdbd82b$export$926c841e781e53f7 = 1000;
const $8fefb655ffdbd82b$export$6fbfab67b98d8352 = ()=>{
    /* istanbul ignore next */ return typeof window === "undefined" ? "fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8" : window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
};
const $8fefb655ffdbd82b$var$CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES = $8fefb655ffdbd82b$export$6fbfab67b98d8352();
const $8fefb655ffdbd82b$export$67db44fab066fc1c = async (args)=>{
    const limit = args.limit;
    const skip = args.skip;
    const locale = args.locale;
    const roadmapName = args.roadmapName;
    const exchanges = [
        (0, $1dWiR.fetchExchange)
    ];
    const client = new (0, $1dWiR.Client)({
        url: (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL),
        exchanges: exchanges,
        fetchOptions: ()=>{
            return {
                headers: {
                    Authorization: `Bearer ${$8fefb655ffdbd82b$var$CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
                }
            };
        }
    });
    const queryVariables = {
        limit: limit,
        skip: skip,
        locale: locale,
        roadmapNames: [
            roadmapName
        ]
    };
    const data = await client.query((0, $79QIK.RoadmapFeaturesQuery), queryVariables);
    return data.data;
};

});
parcelRegister("79QIK", function(module, exports) {
$parcel$export(module.exports, "RoadmapFeaturesQuery", function () { return $83fe1e6c7d9c135a$export$f2d0bd81df38ebd7; });

var $1dWiR = parcelRequire("1dWiR");
const $83fe1e6c7d9c135a$export$f2d0bd81df38ebd7 = (0, $1dWiR.gql)`
    query (
        $limit: Int
        $skip: Int
        $locale: String
        $roadmapNames: [String!]!
    ) {
        roadmapFeatureCollection(
            limit: $limit
            skip: $skip
            locale: $locale
            order: [statusOrder_ASC, sys_publishedAt_DESC]
            where: { roadmaps: { name_in: $roadmapNames } }
        ) {
            total
            items {
                title
                description {
                    json
                }
                status {
                    roadmapStatusNameExternal
                }
                appsCollection(limit: 30) {
                    items {
                        roadmapAppNameExternal
                        filterQueryParam
                    }
                }
                category {
                    queryParameter
                    roadmapCategoryNameExternal
                }
                relatedLinksCollection(locale: $locale, limit: 5) {
                    items {
                        ctaButtonText
                        ctaUrl
                    }
                }
                timeFrame
                slug
                pid
                statusOrder
            }
        }
        taxonomyRoadmapAppCollection(
            locale: $locale
            where: { roadmaps: { name_in: $roadmapNames } }
        ) {
            items {
                roadmapAppNameExternal
                filterQueryParam
            }
        }
        taxonomyRoadmapCategoryCollection(
            locale: $locale
            where: { roadmaps: { name_in: $roadmapNames } }
        ) {
            items {
                roadmapCategoryNameExternal
                queryParameter
            }
        }
        taxonomyRoadmapStatusCollection(locale: $locale) {
            items {
                roadmapStatusNameExternal
            }
        }
    }
`;

});


parcelRegister("6GrXU", function(module, exports) {
$parcel$export(module.exports, "getContentfulEnvironment", function () { return $46eb17ab9643138a$export$9e751421e780b92; });
$parcel$export(module.exports, "comparePlansEnhancer", function () { return $46eb17ab9643138a$export$b4d2dbc8f604aa9e; });

var $dkcYJ = parcelRequire("dkcYJ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $eRzlV = parcelRequire("eRzlV");

var $gVC4y = parcelRequire("gVC4y");
const $46eb17ab9643138a$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $46eb17ab9643138a$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $46eb17ab9643138a$export$9e751421e780b92 = ()=>{
    if ((0, $eRzlV.isProduction)()) return "master";
    const isCcpStaging = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9034WacPricingCcpStaging);
    return isCcpStaging ? "ccp_staging" : "master";
};
const $46eb17ab9643138a$export$b4d2dbc8f604aa9e = async ({ parameter: parameter })=>{
    const plans = parameter.value;
    if (!plans?.length) return parameter.value;
    const shouldStripExcessData = (0, $gVC4y.getShouldStripExcessData)();
    if (shouldStripExcessData) (0, $gVC4y.stripContentfulMetadata)(parameter.value);
    const disableEnhancer = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).waePricingDisableComparePlansEnhancer);
    if (disableEnhancer) return plans;
    const contentfulEnvironment = $46eb17ab9643138a$export$9e751421e780b92();
    const productCatalogClient = new (0, $dkcYJ.ProductCatalogClient)(String($46eb17ab9643138a$var$PRODUCT_CATALOG_DELIVERY_KEY), String($46eb17ab9643138a$var$PRODUCT_CATALOG_SPACE), contentfulEnvironment);
    const skus = plans.map((plan)=>plan.fields.sku);
    const ccpPricingData = await productCatalogClient.getCCPPricingData(skus);
    return plans.map((plan)=>({
            ...plan,
            pricingPlan: ccpPricingData[plan.fields.sku]
        }));
};

});

parcelRegister("3lGAh", function(module, exports) {
$parcel$export(module.exports, "isContentfulEnvelope", function () { return $4de904912e8f9f99$export$b0c8e3f5240af3fc; });
$parcel$export(module.exports, "contentfulIncludesEnhancer", function () { return $4de904912e8f9f99$export$fbc34e765720c7f9; });
function $4de904912e8f9f99$export$b0c8e3f5240af3fc(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value) && Array.isArray(value.items);
}
const $4de904912e8f9f99$export$fbc34e765720c7f9 = ({ parameter: parameter })=>{
    const response = parameter.value;
    if (Array.isArray(response)) return {
        items: response
    };
    const rawItems = response?.items ?? [];
    const includedEntries = response?.includes?.Entry;
    if (!Array.isArray(includedEntries) || includedEntries.length === 0) return {
        items: rawItems,
        total: response?.total,
        limit: response?.limit,
        skip: response?.skip
    };
    const entryMap = new Map(includedEntries.map((entry)=>[
            entry.sys.id,
            entry
        ]));
    const stitchedItems = rawItems.map((item)=>{
        if (typeof item !== "object" || item === null) return item;
        const typedItem = item;
        const fields = typedItem["fields"];
        if (typeof fields !== "object" || fields === null) return item;
        const stitchedFields = $4de904912e8f9f99$var$stitchFields(fields, entryMap, new Set());
        return {
            ...typedItem,
            fields: stitchedFields
        };
    });
    return {
        items: stitchedItems,
        total: response?.total,
        limit: response?.limit,
        skip: response?.skip
    };
};
/**
 * Walks a `fields` object and replaces any Contentful Link stubs with their
 * resolved entries from the entryMap. Handles both single links and arrays.
 */ function $4de904912e8f9f99$var$stitchFields(fields, entryMap, visited) {
    return Object.fromEntries(Object.entries(fields).map(([key, value])=>[
            key,
            $4de904912e8f9f99$var$stitchValue(value, entryMap, visited)
        ]));
}
function $4de904912e8f9f99$var$stitchValue(value, entryMap, visited) {
    if (Array.isArray(value)) return value.map((v)=>$4de904912e8f9f99$var$stitchValue(v, entryMap, visited));
    if ($4de904912e8f9f99$var$isLinkStub(value)) {
        const sys = value["sys"];
        const id = sys?.["id"];
        if (!id) return value;
        if (visited.has(id)) return value;
        const resolved = entryMap.get(id);
        if (!resolved) return value;
        return {
            ...resolved,
            fields: $4de904912e8f9f99$var$stitchFields(resolved.fields, entryMap, new Set(visited).add(id))
        };
    }
    return value;
}
function $4de904912e8f9f99$var$isLinkStub(value) {
    if (typeof value !== "object" || value === null) return false;
    const sys = value["sys"];
    if (typeof sys !== "object" || sys === null) return false;
    return sys["type"] === "Link";
}

});

parcelRegister("hM3sF", function(module, exports) {
$parcel$export(module.exports, "pricingCalculatorEnhancer", function () { return $afcda22f81ac1a98$export$ac6781ae0dd681b3; });

var $dkcYJ = parcelRequire("dkcYJ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $6GrXU = parcelRequire("6GrXU");

var $hhIJy = parcelRequire("hhIJy");

var $5hAGJ = parcelRequire("5hAGJ");

var $6dQnb = parcelRequire("6dQnb");
const $afcda22f81ac1a98$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $afcda22f81ac1a98$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $afcda22f81ac1a98$export$ac6781ae0dd681b3 = async ({ component: component })=>{
    const waePricingGqlEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).waePricingGql);
    const parameters = component.parameters;
    if (parameters?.comparePlansData || !waePricingGqlEnabled) return undefined;
    const urlSlug = parameters.urlSlug?.value;
    if (!urlSlug) throw new Error("no urlSlug provided");
    const locale = parameters.componentLocale?.value ?? "en-US";
    const content = await (0, $5hAGJ.getPricingCalculatorContent)({
        urlSlug: urlSlug,
        locale: locale
    });
    if (!content) throw new Error("pricing calculator content is empty");
    const offeringSkusArray = (0, $6dQnb.getOfferingSkusArrayByUrlSlug)(urlSlug);
    if (!offeringSkusArray) throw new Error(`No offering SKUs found for urlSlug: "${urlSlug}"`);
    const planLimitConfigs = (0, $6dQnb.getPlanLimitConfigsByUrlSlug)(urlSlug);
    if (!planLimitConfigs) throw new Error(`No plan limit configs found for urlSlug: "${urlSlug}"`);
    const contentfulEnvironment = (0, $6GrXU.getContentfulEnvironment)();
    const productCatalogClient = new (0, $dkcYJ.ProductCatalogClient)(String($afcda22f81ac1a98$var$PRODUCT_CATALOG_DELIVERY_KEY), String($afcda22f81ac1a98$var$PRODUCT_CATALOG_SPACE), contentfulEnvironment);
    const ccpPricingData = await productCatalogClient.getCCPPricingData(offeringSkusArray);
    return (0, $hhIJy.getComparePlansDataFromGqlContent)(content, planLimitConfigs, ccpPricingData);
};

});
parcelRegister("hhIJy", function(module, exports) {
$parcel$export(module.exports, "getComparePlansDataFromGqlContent", function () { return $25f2f495ff1f99ec$export$38e6c92d574132a9; });
function $25f2f495ff1f99ec$export$38e6c92d574132a9(gqlContent, planLimitConfigs, ccpPricingData) {
    const items = gqlContent.pricingCollection.items[0]?.comparePlansCollection.items ?? [];
    return items.flatMap((item, index)=>{
        const sku = planLimitConfigs[index]?.offeringSku ?? "";
        const pricingPlan = ccpPricingData[sku];
        if (!pricingPlan) return [];
        return [
            {
                fields: {
                    planTitleInternal: "",
                    planTitleExternal: item.planTitleExternal,
                    planOneLiner: item.planOneLiner,
                    sku: sku,
                    highlightedFeaturesTitle: item.highlightedFeaturesTitle ?? "",
                    highlightedFeaturesContainer: item.highlightedFeaturesContainerCollection.items.map((feature)=>({
                            fields: {
                                highlightedFeatureTitleInternal: "",
                                highlightedFeatureTitleExternal: feature.highlightedFeatureTitleExternal,
                                highlightedFeatureDetails: feature.highlightedFeatureDetails?.json,
                                highlightedLabel: feature.callOut ?? undefined
                            }
                        })),
                    microCta: item.microCtaCollection.items.map((cta)=>({
                            fields: {
                                ctaMicrocopyNameInternal: "",
                                ctaMicrocopyTitleExternal: cta.ctaMicrocopyTitleExternal,
                                ctaButtonText: cta.ctaButtonText,
                                ctaUrl: cta.ctaUrl
                            }
                        })),
                    relatedProduct: []
                },
                pricingPlan: pricingPlan
            }
        ];
    });
}

});

parcelRegister("5hAGJ", function(module, exports) {
$parcel$export(module.exports, "getPricingCalculatorContent", function () { return $933ba02cc7733faf$export$1a2450c4de286d22; });

var $2iZII = parcelRequire("2iZII");

var $jPnzY = parcelRequire("jPnzY");
const $933ba02cc7733faf$export$1a2450c4de286d22 = async (args)=>{
    const { urlSlug: urlSlug, locale: locale } = args;
    const client = (0, $2iZII.getContentfulGqlClient)();
    const result = await client.query((0, $jPnzY.pricingCalculatorContentQuery), {
        urlSlug: urlSlug,
        locale: locale
    });
    return result.data;
};

});
parcelRegister("2iZII", function(module, exports) {
$parcel$export(module.exports, "getContentfulGqlClient", function () { return $914a19f06f37855a$export$c55ca49fcae63941; });

var $1dWiR = parcelRequire("1dWiR");

var $eRzlV = parcelRequire("eRzlV");
const $914a19f06f37855a$var$getContentfulDeliveryKey = ()=>{
    return typeof window === "undefined" ? "fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8" : window["CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES"];
};
let $914a19f06f37855a$var$contentfulGqlClient;
const $914a19f06f37855a$export$c55ca49fcae63941 = ()=>{
    if ($914a19f06f37855a$var$contentfulGqlClient) return $914a19f06f37855a$var$contentfulGqlClient;
    const deliveryKey = $914a19f06f37855a$var$getContentfulDeliveryKey();
    $914a19f06f37855a$var$contentfulGqlClient = new (0, $1dWiR.Client)({
        url: (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL),
        exchanges: [
            (0, $1dWiR.fetchExchange)
        ],
        fetchOptions: ()=>({
                headers: {
                    Authorization: `Bearer ${deliveryKey}`
                }
            })
    });
    return $914a19f06f37855a$var$contentfulGqlClient;
};

});

parcelRegister("jPnzY", function(module, exports) {
$parcel$export(module.exports, "pricingCalculatorContentQuery", function () { return $969650c1f1b7aafc$export$d1373c2ad7bc60be; });

var $1dWiR = parcelRequire("1dWiR");
const $969650c1f1b7aafc$export$d1373c2ad7bc60be = (0, $1dWiR.gql)`
    query pricingCalculatorContent($urlSlug: String!, $locale: String!) {
        pricingCollection(
            where: { urlSlug: $urlSlug }
            locale: $locale
            limit: 1
        ) {
            items {
                pricingTitleInternal
                headline {
                    json
                }
                comparePlansCollection(limit: 10) {
                    items {
                        planTitleExternal
                        planOneLiner
                        microCtaCollection(limit: 15) {
                            items {
                                ... on CallToActionMicrocopy {
                                    ctaMicrocopyTitleExternal
                                    ctaButtonText
                                    ctaUrl
                                }
                            }
                        }
                        highlightedFeaturesTitle
                        highlightedFeaturesContainerCollection(limit: 15) {
                            items {
                                highlightedFeatureDetails {
                                    json
                                }
                                highlightedFeatureTitleExternal
                                callOut
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("6dQnb", function(module, exports) {
$parcel$export(module.exports, "getOfferingSkusArrayByUrlSlug", function () { return $400e01adc37d92c1$export$ad60229e511290bd; });
$parcel$export(module.exports, "getPlanLimitConfigsByUrlSlug", function () { return $400e01adc37d92c1$export$1d51d8a481926a; });

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $gcAZd = parcelRequire("gcAZd");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");
const $400e01adc37d92c1$export$ad60229e511290bd = (urlSlug)=>{
    const urlSlugToSkusArray = {
        "jira": (0, $j1ORI.jiraOfferingSkusArray),
        "confluence": (0, $29JVp.confluenceOfferingSkusArray),
        "bitbucket": (0, $aTHox.bitbucketOfferingSkusArray),
        "loom": (0, $4utnL.loomOfferingSkusArray),
        "compass": (0, $7dhmX.compassOfferingSkusArray),
        "guard": (0, $44C4o.guardOfferingSkusArray),
        "rovo-dev": (0, $9Nmuw.rovoDevOfferingSkusArray),
        "product-discovery": (0, $lc7EO.jpdOfferingSkusArray)(),
        "service-management": (0, $gcAZd.jsmOfferingSkusArray),
        "service": (0, $fEBe5.serviceCollectionOfferingSkusArray),
        "strategy": (0, $hGYMM.strategyCollectionOfferingSkusArray),
        "teamwork": (0, $YmHME.teamworkCollectionOfferingSkusArray)
    };
    return urlSlugToSkusArray[urlSlug];
};
const $400e01adc37d92c1$export$1d51d8a481926a = (urlSlug)=>{
    const urlSlugToPlanLimitConfigs = {
        "jira": (0, $j1ORI.jiraPlanLimitConfigs),
        "confluence": (0, $29JVp.confluencePlanLimitConfigs),
        "bitbucket": (0, $aTHox.bitbucketPlanLimitConfigs),
        "loom": (0, $4utnL.loomPlanLimitConfigs),
        "compass": (0, $7dhmX.compassPlanLimitConfigs),
        "guard": (0, $44C4o.guardPlanLimitConfigs),
        "rovo-dev": (0, $9Nmuw.rovoDevPlanLimitConfigs),
        "product-discovery": (0, $lc7EO.jpdPlanLimitConfigs)(),
        "service-management": (0, $gcAZd.jsmPlanLimitConfigs),
        "service": (0, $fEBe5.serviceCollectionPlanLimitConfigs),
        "strategy": (0, $hGYMM.strategyCollectionPlanLimitConfigs),
        "teamwork": (0, $YmHME.teamworkCollectionPlanLimitConfigs)
    };
    return urlSlugToPlanLimitConfigs[urlSlug];
};

});
parcelRegister("gcAZd", function(module, exports) {
$parcel$export(module.exports, "jsmOfferingSkusArray", function () { return $ff47f9ee8d194adc$export$efd16829e921ffb8; });
$parcel$export(module.exports, "jsmPlanLimitConfigs", function () { return $ff47f9ee8d194adc$export$9e62e4d7dc794618; });
const $ff47f9ee8d194adc$export$be354061b07829a8 = "MONTHLY";
const $ff47f9ee8d194adc$export$2295858875312a6f = 75;
const $ff47f9ee8d194adc$export$66d53803b4a2565a = 201;
const $ff47f9ee8d194adc$export$38631f866342776a = {
    free: "jira-servicedesk-free",
    standard: "jira-servicedesk-standard",
    premium: "jira-servicedesk-premium",
    enterprise: "jira-servicedesk-enterprise-sku"
};
const $ff47f9ee8d194adc$export$efd16829e921ffb8 = Object.values($ff47f9ee8d194adc$export$38631f866342776a);
const $ff47f9ee8d194adc$export$9e62e4d7dc794618 = [
    {
        planName: "Free",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $ff47f9ee8d194adc$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});



parcelRegister("6Vl9e", function(module, exports) {
$parcel$export(module.exports, "tableDataEnhancer", function () { return $1789d6dbd0c18f10$export$230f7887d8fcf17f; });

var $gVC4y = parcelRequire("gVC4y");
const $1789d6dbd0c18f10$export$230f7887d8fcf17f = async ({ parameter: parameter })=>{
    const shouldStripExcessData = (0, $gVC4y.getShouldStripExcessData)();
    if (shouldStripExcessData) (0, $gVC4y.stripContentfulMetadata)(parameter.value);
    parameter.value?.forEach((featureGroup)=>{
        featureGroup.fields.features.forEach((feature)=>{
            if (typeof feature.fields.description === "object" && feature.fields.description?.nodeType === "document") feature.fields.description = (0, $gVC4y.richTextToHTML)(feature.fields.description);
            if (shouldStripExcessData) $1789d6dbd0c18f10$var$trimRelevantPlans(feature);
        });
    });
    return parameter.value;
};
function $1789d6dbd0c18f10$var$trimRelevantPlans(feature) {
    feature.fields.relevantPlan?.forEach((plan)=>{
        if (plan.fields) plan.fields = {
            planTitleExternal: plan.fields.planTitleExternal
        };
    });
    feature.fields.featureAdditionalInformation?.forEach((info)=>{
        info.fields?.relevantPlan?.forEach((plan)=>{
            if (plan.fields) plan.fields = {
                planTitleExternal: plan.fields.planTitleExternal
            };
        });
    });
}

});


parcelRegister("eNxv9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ccc1f30aa8c203e0$export$2e2bcd8739ae039; });

var $ksvEJ = parcelRequire("ksvEJ");

var $iLjCW = parcelRequire("iLjCW");

var $4JOZV = parcelRequire("4JOZV");

var $lqBhQ = parcelRequire("lqBhQ");

var $3wpTl = parcelRequire("3wpTl");

var $1d9MG = parcelRequire("1d9MG");

var $jgyhc = parcelRequire("jgyhc");

var $aiWEP = parcelRequire("aiWEP");

var $fZxve = parcelRequire("fZxve");

var $7v1H9 = parcelRequire("7v1H9");

var $8hbU0 = parcelRequire("8hbU0");
parcelRequire("eWth0");
var $aghrj = parcelRequire("aghrj");

var $6SooZ = parcelRequire("6SooZ");

var $4h1q1 = parcelRequire("4h1q1");

var $k1kqo = parcelRequire("k1kqo");

var $jswU3 = parcelRequire("jswU3");

var $82Z9J = parcelRequire("82Z9J");

var $9eDC1 = parcelRequire("9eDC1");

var $hStuA = parcelRequire("hStuA");

var $8MWwK = parcelRequire("8MWwK");

var $5nbaa = parcelRequire("5nbaa");

var $gQYRi = parcelRequire("gQYRi");

var $ijBWj = parcelRequire("ijBWj");

var $Ms48M = parcelRequire("Ms48M");

var $kEr7H = parcelRequire("kEr7H");

var $cDjwJ = parcelRequire("cDjwJ");

var $gl1tq = parcelRequire("gl1tq");

var $hvVOW = parcelRequire("hvVOW");

var $2m9G1 = parcelRequire("2m9G1");

var $6nTac = parcelRequire("6nTac");

var $2540f = parcelRequire("2540f");

var $j6nXt = parcelRequire("j6nXt");

var $8JW63 = parcelRequire("8JW63");

var $jK7xK = parcelRequire("jK7xK");

var $856b3 = parcelRequire("856b3");

var $2bofd = parcelRequire("2bofd");

var $3VYCw = parcelRequire("3VYCw");

var $g0xMT = parcelRequire("g0xMT");

var $76Hra = parcelRequire("76Hra");

var $89oar = parcelRequire("89oar");
parcelRequire("ccVGG");
var $hTiWM = parcelRequire("hTiWM");

var $7d42O = parcelRequire("7d42O");

var $wwZ1W = parcelRequire("wwZ1W");

var $f7IMH = parcelRequire("f7IMH");

var $jGtmE = parcelRequire("jGtmE");

var $dr4ha = parcelRequire("dr4ha");

var $2XwEb = parcelRequire("2XwEb");

var $2oS3p = parcelRequire("2oS3p");

var $6JkkA = parcelRequire("6JkkA");

var $1ij5s = parcelRequire("1ij5s");

var $3jkl6 = parcelRequire("3jkl6");

var $bkhKq = parcelRequire("bkhKq");

var $6jbRM = parcelRequire("6jbRM");

var $g9CPg = parcelRequire("g9CPg");

var $ks0ka = parcelRequire("ks0ka");

var $71BPb = parcelRequire("71BPb");

var $bmNwd = parcelRequire("bmNwd");

var $5c1uT = parcelRequire("5c1uT");

var $f8O2Y = parcelRequire("f8O2Y");

var $96bxg = parcelRequire("96bxg");

var $iSxa6 = parcelRequire("iSxa6");

var $lATol = parcelRequire("lATol");

var $3E1lH = parcelRequire("3E1lH");

var $7xYdG = parcelRequire("7xYdG");

var $gebIf = parcelRequire("gebIf");

var $9tius = parcelRequire("9tius");

var $8HKOE = parcelRequire("8HKOE");

var $aT8t4 = parcelRequire("aT8t4");

var $eNJPT = parcelRequire("eNJPT");

var $lPMtR = parcelRequire("lPMtR");

var $4oasi = parcelRequire("4oasi");

var $exkom = parcelRequire("exkom");

var $6smfw = parcelRequire("6smfw");

var $2Oxuw = parcelRequire("2Oxuw");

var $4Aw5W = parcelRequire("4Aw5W");

var $4LrCk = parcelRequire("4LrCk");

var $v15B3 = parcelRequire("v15B3");

var $71GXn = parcelRequire("71GXn");

var $3DCiB = parcelRequire("3DCiB");

var $acEyk = parcelRequire("acEyk");

var $ies6q = parcelRequire("ies6q");

var $dXwUh = parcelRequire("dXwUh");

var $aeR15 = parcelRequire("aeR15");

var $kfc2o = parcelRequire("kfc2o");

var $3rWcE = parcelRequire("3rWcE");

var $j4sH0 = parcelRequire("j4sH0");

var $evFps = parcelRequire("evFps");

var $eWY7v = parcelRequire("eWY7v");

var $gSQsG = parcelRequire("gSQsG");

var $gP8Hr = parcelRequire("gP8Hr");

var $cwpkM = parcelRequire("cwpkM");
parcelRequire("aSmcz");
var $eFi9k = parcelRequire("eFi9k");

var $11uBo = parcelRequire("11uBo");

var $hnLdc = parcelRequire("hnLdc");

var $hTage = parcelRequire("hTage");

var $3QKwy = parcelRequire("3QKwy");

var $lEcJc = parcelRequire("lEcJc");

var $1GX5U = parcelRequire("1GX5U");

var $fzMpf = parcelRequire("fzMpf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ccc1f30aa8c203e0$var$UNIFORM_DEFINITIONS = {
    accordion: (0, $4JOZV.default),
    animationWrapper: (0, $lqBhQ.default),
    articleCta: (0, $3wpTl.default),
    backgroundVideoContainer: (0, $1d9MG.default),
    bannerAlert: (0, $jgyhc.default),
    bitbucketSearchIntegration: (0, $aiWEP.default),
    bleedingImageHero: (0, $fZxve.default),
    blockContainer: (0, $8MWwK.default),
    blogNewsGallery: (0, $7v1H9.default),
    bodyContent: (0, $8hbU0.default),
    button: (0, $6SooZ.default),
    callToAction: (0, $4h1q1.default),
    card: (0, $k1kqo.default),
    collectionPricingHero: (0, $jswU3.default),
    columnLayout: (0, $82Z9J.UniformColumnLayout),
    confluenceAnimatedHero: (0, $9eDC1.default),
    connector: (0, $hStuA.default),
    contentBlock: (0, $5nbaa.default),
    contextualBanditsContainer: (0, $ijBWj.default),
    contextualBanditsVariant: (0, $Ms48M.default),
    ctaWithPolygonBackground: (0, $8HKOE.default),
    customerBodyContent: (0, $aghrj.default),
    customerGallery: (0, $kEr7H.default),
    customerStat: (0, $cDjwJ.default),
    customerStoriesDetailsHero: (0, $gl1tq.default),
    customerTestimonials: (0, $hvVOW.default),
    designRefreshBar: (0, $2m9G1.default),
    designRefreshHeading: (0, $6nTac.default),
    embeddedVideo: (0, $8JW63.default),
    enhancedBanner: (0, $jK7xK.default),
    downloadRow: (0, $2540f.default),
    downloadTable: (0, $j6nXt.default),
    expand: (0, $856b3.default),
    featuresHighlight: (0, $g0xMT.default),
    globalFooter: (0, $iLjCW.GlobalFooter),
    globalNav: (0, $7d42O.default),
    graphPaperReveal: (0, $wwZ1W.default),
    heading: (0, $f7IMH.default),
    heroCarouselSection: (0, $jGtmE.default),
    heroScrollToEnlargeContainer: (0, $dr4ha.default),
    heroSection: (0, $2XwEb.default),
    jsmLoggedInHeroSection: (0, $g9CPg.default),
    horizontalDivider: (0, $2oS3p.default),
    image: (0, $6JkkA.default),
    imageV2: (0, $1ij5s.default),
    integration: (0, $3jkl6.default),
    invisibleContent: (0, $bkhKq.default),
    productCardBlock: (0, $4oasi.default),
    roadmapFeatures: (0, $exkom.default),
    rovoChatContainer: (0, $2Oxuw.default),
    rovoChatBox: (0, $6smfw.default),
    rovoChatHeader: (0, $4Aw5W.default),
    scrollableHeroCards: (0, $v15B3.default),
    filterableGallery: (0, $89oar.default),
    filterableItem: (0, $hTiWM.default),
    jiraTemplatesTabContentSubgridLayout: (0, $6jbRM.default),
    link: (0, $ks0ka.default),
    list: (0, $71BPb.default),
    listv2: (0, $bmNwd.default),
    logos: (0, $5c1uT.default),
    lozenge: (0, $f8O2Y.default),
    migrationPlaceholder: (0, $96bxg.default),
    mobileApp: (0, $iSxa6.default),
    modal: (0, $lATol.default),
    page: (0, $3E1lH.default),
    pagination: (0, $7xYdG.default),
    panel: (0, $gebIf.default),
    personalizationContainer: (0, $9tius.default),
    pricingCalculator: (0, $aT8t4.default),
    pricingTable: (0, $eNJPT.default),
    productCard: (0, $lPMtR.default),
    pullQuote: (0, $ksvEJ.PullQuote),
    rovoHero: (0, $4LrCk.default),
    sideNav: (0, $71GXn.default),
    sideNavCollection: (0, $3DCiB.default),
    sideNavLink: (0, $acEyk.default),
    signUpForm: (0, $ies6q.default),
    slidingLayout: (0, $aeR15.default),
    subProduct: (0, $j4sH0.default),
    singleTab: (0, $dXwUh.default),
    splitBackgroundContainer: (0, $kfc2o.default),
    statsSection: (0, $3rWcE.UniformStatsSection),
    statsigExperimentContainer: (0, $2bofd.default),
    statsigFeatureGateContainer: (0, $3VYCw.default),
    subColumnLayout: (0, $82Z9J.UniformSubColumnLayout),
    tabs12Col: (0, $evFps.default),
    tabs8Col: (0, $eWY7v.default),
    teamworkGraph: (0, $gSQsG.default),
    templateModalButton: (0, $gP8Hr.default),
    templatePreview: (0, $cwpkM.default),
    filterableCard: (0, $76Hra.default),
    contentfulGalleryContainer: (0, $gQYRi.default),
    templatesSearchBar: (0, $eFi9k.default),
    text: (0, $11uBo.default),
    textWithIcon: (0, $hnLdc.default),
    variant: (0, $3QKwy.default),
    variantContainer: (0, $lEcJc.default),
    valueProps: (0, $hTage.default),
    video: (0, $1GX5U.default),
    videoCarousel: (0, $fzMpf.default)
};
var $ccc1f30aa8c203e0$export$2e2bcd8739ae039 = $ccc1f30aa8c203e0$var$UNIFORM_DEFINITIONS;

});
parcelRegister("ksvEJ", function(module, exports) {
$parcel$export(module.exports, "PullQuote", function () { return $e3e126ce9d25b04e$export$f32a6ca59ed1d5d5; });
/* pull-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $e3e126ce9d25b04e$export$f32a6ca59ed1d5d5 = ({ quote: quote, quoteRichTextString: quoteRichTextString, authorName: authorName, authorDetails: authorDetails, size: size = "small", variant: variant = "basic", alignment: alignment = "start" })=>{
    const quoteComponent = quoteRichTextString ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_hmk91wug _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kt912u0 _aetr1lzr",
            size === "large" && variant === "basic" ? "callout-lg" : "callout"
        ]),
        dangerouslySetInnerHTML: {
            __html: quoteRichTextString
        }
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_hmk91wug _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kt912u0 _aetr1lzr",
            size === "large" && variant === "basic" ? "callout-lg" : "callout"
        ]),
        children: quote
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _zulpu2gc _1rjcpxbi",
            alignment === "center" && "_y3gn1h6o",
            variant === "cutout" && "_zulppxbi _1mou74w7 _kqswh2mm _11q7tnrf _18zrxy5q _1rjcpxbi _1kt9b3bt _1cs8stnw _iajm1ld3 _z5wtidpf _1mp41osq _kfgt82ui _1s6ktnrf _tgsm13jo _aetrb3bt _18postnw _1guf11s5 _g0nfidpf _z0ai1osq _1qdg12bs _16r2tnrf _1oj4iz7d _umua1k7u _z4r91k7u _ecdx172j _tnqlq4g3 _ryq61nat _1l5u1lev _1ruvtyve _z1a1webb"
        ]),
        style: {
            "--_jxcf9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.saffron"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("blockquote", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: quoteComponent
            }),
            (authorName || authorDetails) && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    authorName && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_k48p53lb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "body-lg"
                        ]),
                        children: authorName
                    }),
                    authorDetails && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "eyebrow-md"
                        ]),
                        children: authorDetails
                    })
                ]
            })
        ]
    });
};
const $e3e126ce9d25b04e$var$commonStyling = null;
const $e3e126ce9d25b04e$var$centeredStyling = null;
const $e3e126ce9d25b04e$var$cutoutStyling = null;
const $e3e126ce9d25b04e$var$quoteContainerStyling = null;
const $e3e126ce9d25b04e$var$quoteStyling = null;
const $e3e126ce9d25b04e$var$authorNameStyling = null;
const $e3e126ce9d25b04e$var$authorDetailsStyling = null;

});

parcelRegister("4JOZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a332e2a761197bf6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $6cu9L = parcelRequire("6cu9L");

var $lTkkF = parcelRequire("lTkkF");
const $a332e2a761197bf6$var$UniformAccordion = (props)=>{
    const { header: header, textBody: textBody, richText: richText } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6cu9L.Accordion), {
        header: header,
        content: richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : textBody
    });
};
var $a332e2a761197bf6$export$2e2bcd8739ae039 = $a332e2a761197bf6$var$UniformAccordion;

});
parcelRegister("6cu9L", function(module, exports) {
$parcel$export(module.exports, "Accordion", function () { return $77686e2e3b01bc1f$export$a766cd26d0d69044; });
/* accordion.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $1uTEn = parcelRequire("1uTEn");
const $77686e2e3b01bc1f$export$a766cd26d0d69044 = (props)=>{
    const { header: header, content: content } = props;
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const handleToggle = (0, $1oC0p.useCallback)((event)=>{
        setIsOpen(event.currentTarget.open);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("details", {
        onToggle: handleToggle,
        className: (0, $2jatx.default)([
            "_1bsb1osq _179r1k0a _tw1z1t97 _1yt41ejb _5hz21ep1 _1qs01ule _mcmzidpf _16zyzryt _85r11k5h _4i3s1doz _2xj61a5r _1hy91ytf _1mng1wug"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("summary", {
                className: (0, $2jatx.default)([
                    "_80omtlke _1e0c1txw _4cvrv2br _1bah1yb4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "card-title-sm"
                        ]),
                        children: header
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1uTEn.TogglerIcon), {
                        icon: isOpen ? "minus" : "plus"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1q51pxbi"
                ]),
                children: content
            })
        ]
    });
};
const $77686e2e3b01bc1f$var$containerCss = null;
const $77686e2e3b01bc1f$var$headerContainerCss = null;
const $77686e2e3b01bc1f$var$headerCss = null;
const $77686e2e3b01bc1f$var$contentCss = null;

});
parcelRegister("1uTEn", function(module, exports) {
$parcel$export(module.exports, "TogglerIcon", function () { return $2ac222beeecd6cd9$export$bc229f4f272e226c; });
/* toggler-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $2ac222beeecd6cd9$export$bc229f4f272e226c = (props)=>{
    const { icon: icon } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q71ep1 _2rko1ssb _4t3i1tcg _v56488n5 _1bsb1tcg _1ul91tcg _wtqc14w8 _pmf41sub _ts4v19bv _49x519bv _1mf219bv _12h0b3bt _s971b3bt _229db3bt _1st5stnw _vuffstnw _kd02stnw _hpnvidpf _kzlzidpf _sdl2idpf _yj65idpf _y2jtidpf _1v8kidpf _10t5idpf _tz0cidpf _11hpidpf _l73cidpf _1ewaidpf _12tkidpf _107ycd5j _1br2cd5j _qnpfcd5j _aze81wug _8u7c1wug _19dq1wug _144j14y2 _iui614y2 _6v8s14y2 _1faz1wug _1ew01wug _3r7i1wug _1oz314y2 _18xc14y2 _u63c14y2 _1xlyyh40 _kotoyh40 _6zj4yh40 _6zj41wug _ornayh40 _19dq14y2 _6v8s1wug _3r7i14y2 _u63c1wug",
            icon
        ]),
        "aria-hidden": "true",
        style: {
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        }
    });
};
const $2ac222beeecd6cd9$var$togglerIconCss = null;

});



parcelRegister("lqBhQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc3ec1ef37643663$export$2e2bcd8739ae039; });
/* animation-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $bNzAT = parcelRequire("bNzAT");
const $cc3ec1ef37643663$var$UniformAnimationWrapper = ({ animationName: animationName, duration: duration = "motion.duration.0ms", easing: easing = "motion.easing.constant", delay: delay = "motion.delay.0ms", fillMode: fillMode = "none", trigger: trigger = "in-view" })=>{
    const [triggered, setTriggered] = (0, $1oC0p.useState)(trigger === "load");
    const ref = (0, $1oC0p.useRef)(null);
    const isInViewMode = trigger === "in-view" || trigger === "in-view-once";
    (0, $1oC0p.useEffect)(()=>{
        if (!isInViewMode || !ref.current) return;
        const el = ref.current;
        const observer = new IntersectionObserver(([entry])=>{
            if (!entry) return;
            if (entry.isIntersecting) setTriggered(true);
            else if (trigger === "in-view") setTriggered(false);
        }, {
            threshold: 0.1
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        trigger,
        isInViewMode
    ]);
    // Restart animation when re-entering view in "in-view" mode so it replays from the beginning
    (0, $1oC0p.useEffect)(()=>{
        if (trigger !== "in-view" || !triggered || !ref.current) return;
        const el = ref.current;
        el.style.animationName = "none";
        el.offsetHeight; // force reflow
        el.style.animationName = "";
    }, [
        trigger,
        triggered
    ]);
    const animationStyles = {
        // We will want to add logic to this to allow fades and only limit the translations, scales and other motion.
        // For right now we simply do not animate until we get clarity on design intent long term for WAC Refresh 2026
        "@media (prefers-reduced-motion: no-preference)": {
            animationName: (0, $bNzAT.default)(animationName),
            animationDuration: (0, $bNzAT.default)(duration),
            animationTimingFunction: (0, $bNzAT.default)(easing),
            animationDelay: (0, $bNzAT.default)(delay),
            animationFillMode: fillMode,
            animationPlayState: triggered ? "running" : "paused"
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        className: (0, $2jatx.default)([
            "_1cro18mb _wqfn1oj7 _1e0reic5 _sl5pz1s3 _dqw8pyqb _1c1q16gb",
            "animation-wrapper"
        ]),
        style: {
            "--_suaiuv": (0, $6ZVlx.default)((0, $bNzAT.default)(animationName)),
            "--_pnuefe": (0, $6ZVlx.default)((0, $bNzAT.default)(duration)),
            "--_1a43xu8": (0, $6ZVlx.default)((0, $bNzAT.default)(easing)),
            "--_2ye55a": (0, $6ZVlx.default)((0, $bNzAT.default)(delay)),
            "--_1jen591": (0, $6ZVlx.default)(fillMode),
            "--_1hs1tbk": (0, $6ZVlx.default)(triggered ? "running" : "paused")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content"
        })
    });
};
var $cc3ec1ef37643663$export$2e2bcd8739ae039 = $cc3ec1ef37643663$var$UniformAnimationWrapper;

});

parcelRegister("3wpTl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f7cd193ad4e26d6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $73mLU = parcelRequire("73mLU");

var $lTkkF = parcelRequire("lTkkF");
const $1f7cd193ad4e26d6$var$UniformArticleCta = (props)=>{
    const articleCtaProps = {
        ...props,
        copy: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.copy
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $73mLU.ArticleCta), {
        ...articleCtaProps,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "ctaSection",
            "data-event": "clicked"
        }
    });
};
var $1f7cd193ad4e26d6$export$2e2bcd8739ae039 = $1f7cd193ad4e26d6$var$UniformArticleCta;

});
parcelRegister("73mLU", function(module, exports) {
$parcel$export(module.exports, "ArticleCta", function () { return $858e9386dc2085cf$export$441e3def6ec0f6dd; });
/* article-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $858e9386dc2085cf$var$containerStyle = null;
const $858e9386dc2085cf$var$copyContainerStyle = null;
const $858e9386dc2085cf$var$ctaContainerStyle = null;
const $858e9386dc2085cf$var$noWrapLinkStyle = null;
const $858e9386dc2085cf$var$marginZeroCss = null;
const $858e9386dc2085cf$export$441e3def6ec0f6dd = (props)=>{
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `article-cta-title-${uniqueId}`;
    const buttonId = `article-cta-button-${uniqueId}`;
    const linkId = `article-cta-link-${uniqueId}`;
    const copyElement = typeof props.copy === "string" ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1mouze3t"
        ]),
        children: props.copy
    }) : props.copy;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1ybm _2rkovwyg _1yt4xy5q _1e0c1txw _zulpxy5q _1bsb1ns9 _6ssj1ejb _1gde1bp4"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1b66 _1bah1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        id: titleId,
                        className: (0, $2jatx.default)([
                            "_1mouze3t",
                            "card-title"
                        ]),
                        children: props.title
                    }),
                    props.copy && copyElement
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi _1bah1h6o _4cvr1h6o _ag851y6m",
                    "_sjfo1q9c"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                        id: buttonId,
                        variant: "primary",
                        size: "small",
                        color: "blue",
                        href: props.buttonHref,
                        ariaLabelledby: `${buttonId} ${titleId}`,
                        dataEventProps: props.dataEventProps,
                        children: props.buttonText
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        id: linkId,
                        text: props.linkText,
                        href: props.linkHref,
                        ariaLabelledby: `${linkId} ${titleId}`,
                        "aria-label": props.linkText,
                        dataEventProps: props.dataEventProps
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("1d9MG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44015486d9fa361e$export$2e2bcd8739ae039; });
/* background-video-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $f6WjX = parcelRequire("f6WjX");
const $44015486d9fa361e$var$containerStyles = null;
const $44015486d9fa361e$var$contentStyles = null;
const $44015486d9fa361e$var$svgOverlayStyles = null;
const $44015486d9fa361e$var$backgroundVideoStyles = null;
const $44015486d9fa361e$var$headingStyles = null;
const $44015486d9fa361e$var$descriptionStyles = null;
const $44015486d9fa361e$var$controlButtonStyles = null;
const $44015486d9fa361e$var$UniformBackgroundVideoContainer = (props)=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const [isVisible, setIsVisible] = (0, $1oC0p.useState)(false);
    const videoRef = (0, $1oC0p.useRef)(null);
    const [isPlaying, setPlaying] = (0, $1oC0p.useState)(false);
    const { firePlayPauseClicked: firePlayPauseClicked } = (0, $f6WjX.useBackgroundVideoContainerAnalytics)();
    const [hasEnded, setHasEnded] = (0, $1oC0p.useState)(false);
    const [currentVideoSource, setCurrentVideoSource] = (0, $1oC0p.useState)("");
    const [windowWidth, setWindowWidth] = (0, $1oC0p.useState)(typeof globalThis.window !== "undefined" ? globalThis.window.innerWidth : 1200);
    const [holeWidth, setHoleWidth] = (0, $1oC0p.useState)(1); // Separate width for rectangle
    const [holeHeight, setHoleHeight] = (0, $1oC0p.useState)(1); // Separate height for rectangle
    const [holeRadius, setHoleRadius] = (0, $1oC0p.useState)(300);
    const [containerDimensions, setContainerDimensions] = (0, $1oC0p.useState)({
        width: 0,
        height: 0
    });
    const intl = (0, $8e22h.default)();
    const prefersReducedMotion = typeof globalThis.window !== "undefined" ? globalThis.window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
    // can turn the feature flag on to disable the overlay if it's glitchy
    const isAnimationOverlayEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7823AnimationOverlayOption);
    const computedWidth = containerDimensions.width || 1200;
    const computedHeight = containerDimensions.height || 700;
    const getVideoSource = (0, $1oC0p.useCallback)((width)=>{
        if (width >= 1024) return props.videoSourceDesktop;
        if (width >= 768) return props.videoSourceTablet;
        return props.videoSourceMobile;
    }, [
        props.videoSourceDesktop,
        props.videoSourceTablet,
        props.videoSourceMobile
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const handleResize = ()=>{
            if (typeof globalThis.window !== "undefined") setWindowWidth(globalThis.window.innerWidth);
        };
        const updateVideoSource = (newSource)=>{
            if (newSource === currentVideoSource) return;
            setCurrentVideoSource(newSource);
            if (!videoRef.current) return;
            if (isPlaying) {
                const currentTime = videoRef.current.currentTime;
                videoRef.current.src = newSource;
                videoRef.current.load();
                videoRef.current.currentTime = currentTime;
                videoRef.current.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
            } else {
                videoRef.current.src = newSource;
                videoRef.current.load();
            }
        };
        const initialSource = getVideoSource(windowWidth);
        updateVideoSource(initialSource);
        if (typeof globalThis.window !== "undefined") {
            globalThis.window.addEventListener("resize", handleResize);
            return ()=>globalThis.window.removeEventListener("resize", handleResize);
        }
        return undefined;
    }, [
        windowWidth,
        currentVideoSource,
        isPlaying,
        getVideoSource
    ]);
    const togglePlay = ()=>{
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
                firePlayPauseClicked("pause");
            } else {
                videoRef.current.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
                firePlayPauseClicked("play");
            }
        }
    };
    const handleVideoPlay = ()=>{
        setPlaying(true);
        setHasEnded(false);
    };
    const handleVideoPause = ()=>setPlaying(false);
    const handleVideoEnded = ()=>{
        setPlaying(false);
        setHasEnded(true);
    };
    const startHoleAnimation = (0, $1oC0p.useCallback)((containerElement)=>{
        const containerWidth = containerElement.offsetWidth;
        const containerHeight = containerElement.offsetHeight;
        setContainerDimensions({
            width: containerWidth,
            height: containerHeight
        });
        setTimeout(()=>{
            const startTime = Date.now();
            const duration = 800;
            const startSize = 1;
            const animationInterval = setInterval(()=>{
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = 1 - Math.pow(1 - progress, 3); // ease-out cubic
                const currentHoleWidth = startSize + (containerWidth - startSize) * easedProgress;
                const currentHoleHeight = startSize + (containerHeight - startSize) * easedProgress;
                const currentRadius = 300 * (1 - Math.min(progress * 1.5, 1));
                setHoleWidth(currentHoleWidth);
                setHoleHeight(currentHoleHeight);
                setHoleRadius(currentRadius);
                if (progress >= 1) clearInterval(animationInterval);
            }, 16);
        }, 800);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry?.isIntersecting) {
                setIsVisible(true);
                if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
                if (!prefersReducedMotion && containerRef.current && isAnimationOverlayEnabled) startHoleAnimation(containerRef.current);
                else if (containerRef.current && isAnimationOverlayEnabled) {
                    const containerWidth = containerRef.current.offsetWidth;
                    const containerHeight = containerRef.current.offsetHeight;
                    setContainerDimensions({
                        width: containerWidth,
                        height: containerHeight
                    });
                    setHoleWidth(containerWidth);
                    setHoleHeight(containerHeight);
                    setHoleRadius(0);
                }
            }
        }, {
            threshold: 0.3
        });
        if (containerRef.current) observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, [
        prefersReducedMotion,
        startHoleAnimation,
        isAnimationOverlayEnabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_bfhkmt5y _kqswh2mm _1reo15vq _18m915vq _4t3i1j7z _1gdlbcwg _1knekdgb"
        ]),
        style: {
            "--video-width-mobile": props.videoWidthMobile ? `${props.videoWidthMobile}px` : "500px",
            "--video-height-mobile": props.videoHeightMobile ? `${props.videoHeightMobile}px` : "700px",
            "--video-width-tablet": props.videoWidthTablet ? `${props.videoWidthTablet}px` : "800px",
            "--video-height-tablet": props.videoHeightTablet ? `${props.videoHeightTablet}px` : "1000px",
            "--video-width-desktop": props.videoWidthDesktop ? `${props.videoWidthDesktop}px` : "1200px",
            "--video-height-desktop": props.videoHeightDesktop ? `${props.videoHeightDesktop}px` : "700px",
            "--_1ex89o1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                ref: videoRef,
                src: currentVideoSource,
                muted: true,
                loop: props.videoLoop || false,
                playsInline: true,
                onPlay: handleVideoPlay,
                onPause: handleVideoPause,
                onEnded: handleVideoEnded,
                className: (0, $2jatx.default)([
                    "_kqswstnw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152tidpf _u7coidpf _1pbykb7n _1e021l2x _rjxp1l2x _4t3i1j7z _1j7jwqo7 _19tlwqo7 _1gdlbcwg _nqop1vnc _1a5h1vnc _1knekdgb"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _kqswh2mm _1pbycs5v _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _y3gn1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _p12f1osq _4t3i1osq _1bsbbxu3 _w19jrnt7 _v5641v33 _1s4p1erl _14u4kb7n _22qt1amc",
                    isVisible ? "animate-reveal" : ""
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_18s812pl _16cqcd5j",
                            "video-heading"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: props.videoHeading
                    }),
                    props.videoDescription && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_163ycd5j",
                            "video-description"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: props.videoDescription
                    }),
                    props.videoCta && props.videoCtaLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        "aria-label": props.videoCta,
                        href: props.videoCtaLink,
                        text: props.videoCta,
                        type: "primary",
                        bgColor: "bgBlackBlue",
                        dataEventProps: {
                            "data-product-key": "uniform",
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "videoContainer"
                        }
                    })
                ]
            }),
            !hasEnded && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: togglePlay,
                "aria-label": intl.formatMessage(isPlaying ? {
                    id: "uniform-video.pause",
                    defaultMessage: "Pause"
                } : {
                    id: "uniform-video.play",
                    defaultMessage: "Play"
                }),
                "aria-pressed": isPlaying,
                className: (0, $2jatx.default)([
                    "_80omtlke _tzy41ou4 _bfhk1j28 _syazcd5j _19it1axk _2rko17td _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7copxbi _16l4kb7n _1ygb8djs _1ah3yh40 _19lvkb7n _w8l5dlk8"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill")),
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                },
                children: isPlaying ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                    label: intl.formatMessage({
                        id: "uniform-video.pause",
                        defaultMessage: "Pause"
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                    label: intl.formatMessage({
                        id: "uniform-video.play",
                        defaultMessage: "Play"
                    })
                })
            }),
            isAnimationOverlayEnabled && /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                viewBox: `0 0 ${computedWidth} ${computedHeight}`,
                preserveAspectRatio: "none",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1pby11wp _lcxvglyw _1r04idpf _1bsb1osq _4t3i1osq _1lmqglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("mask", {
                            id: "hole-mask",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                                    width: computedWidth,
                                    height: computedHeight,
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                                    x: computedWidth / 2 - holeWidth / 2,
                                    y: computedHeight / 2 - holeHeight / 2,
                                    width: holeWidth,
                                    height: holeHeight,
                                    rx: holeRadius,
                                    ry: holeRadius,
                                    fill: "black"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: computedWidth,
                        height: computedHeight,
                        fill: (0, $kbpa7.wacToken)("color.neutral.light0"),
                        mask: "url(#hole-mask)"
                    })
                ]
            })
        ]
    });
};
var $44015486d9fa361e$export$2e2bcd8739ae039 = $44015486d9fa361e$var$UniformBackgroundVideoContainer;

});
parcelRegister("f6WjX", function(module, exports) {
$parcel$export(module.exports, "useBackgroundVideoContainerAnalytics", function () { return $6a37d2f15d9a1bb5$export$b171fc3ce9294fa; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $6a37d2f15d9a1bb5$export$b171fc3ce9294fa() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const firePlayPauseClicked = (0, $1oC0p.useCallback)((label)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "playPause",
            source: "backgroundVideoContainer",
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        firePlayPauseClicked: firePlayPauseClicked
    };
}

});


parcelRegister("jgyhc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f03812964141fa1$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $2HoYQ = parcelRequire("2HoYQ");
const $4f03812964141fa1$var$UniformBannerAlert = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HoYQ.BannerAlert), {
        ...props,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "bannerAlert",
            "data-event": "clicked"
        }
    });
};
var $4f03812964141fa1$export$2e2bcd8739ae039 = $4f03812964141fa1$var$UniformBannerAlert;

});
parcelRegister("2HoYQ", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return $88b6e8b9726997a4$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $dE0sS = parcelRequire("dE0sS");

var $2gCne = parcelRequire("2gCne");
const $88b6e8b9726997a4$var$containerStyles = null;
const $88b6e8b9726997a4$var$paragraphStyles = null;
const $88b6e8b9726997a4$var$textStyles = null;
const $88b6e8b9726997a4$var$primaryInlineLinkStyles = null;
const $88b6e8b9726997a4$var$closeIconStyles = null;
const $88b6e8b9726997a4$export$4eb8f3e4e539379b = ({ id: id, text: text, linkText: linkText, linkUrl: linkUrl, ariaLabel: ariaLabel, dataEventProps: dataEventProps })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const bannerStorageItem = `BannerAlert_dismiss-${id}`;
    const closeLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $2jatx.default)([
                "_bfhk1ybm _kqswh2mm _y4tioahv _d2ikoahv _1rjcutpp _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            style: {
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    "aria-label": closeLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, "1");
                        createAnalyticsEvent({
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "linkButton",
                            attributes: {
                                page_path: location?.pathname,
                                url: location?.href,
                                label: closeLabel,
                                labelEnglish: "Close",
                                event: "clicked",
                                eventComponent: "linkButton",
                                eventContainer: "bannerAlertClose"
                            }
                        }).fire();
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
                        size: "20",
                        color: (0, $kbpa7.wacToken)("color.primary.black")
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _10hl1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1lvau2gc"
                                ]),
                                children: text
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_tkqh1ule _sd3jutpp _dzos1o8l _1od5idpf"
                                ]),
                                children: linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    "aria-label": linkText,
                                    text: linkText,
                                    href: linkUrl,
                                    type: "inline",
                                    dataEventProps: dataEventProps,
                                    ariaLabel: ariaLabel
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("aiWEP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd88dea26fec7209$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $k8XNp = parcelRequire("k8XNp");
const $cd88dea26fec7209$var$UniformBitbucketSearchIntegration = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k8XNp.BitbucketPipelinesIntegrations), {});
};
var $cd88dea26fec7209$export$2e2bcd8739ae039 = $cd88dea26fec7209$var$UniformBitbucketSearchIntegration;

});
parcelRegister("k8XNp", function(module, exports) {
$parcel$export(module.exports, "BitbucketPipelinesIntegrations", function () { return $28b3e37fdfde712f$export$741f4d4a3a2b287c; });

var $7VQPk = parcelRequire("7VQPk");

var $kdQMu = parcelRequire("kdQMu");

var $gvpkz = parcelRequire("gvpkz");
const $28b3e37fdfde712f$export$741f4d4a3a2b287c = ()=>{
    const { items: items, categories: categories, loading: loading, error: error } = (0, $gvpkz.usePipesData)();
    if (loading) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: "Loading integrations\u2026"
    });
    if (error) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: "Failed to load integrations."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kdQMu.IntegrationsSearchGrid), {
        items: items,
        categories: categories
    });
};

});
parcelRegister("kdQMu", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSearchGrid", function () { return $4edc21c9abdc48ad$export$9b532486e289a2c2; });
/* integrations-search-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $iVmQ7 = parcelRequire("iVmQ7");

var $g3ie4 = parcelRequire("g3ie4");
// ============================================================================
// Colors
// ============================================================================
const $4edc21c9abdc48ad$var$TEXT_PRIMARY = (0, $kbpa7.wacToken)("color.extended.blue1000"); // N900
const $4edc21c9abdc48ad$var$TEXT_SECONDARY = (0, $kbpa7.wacToken)("color.neutral.light800"); // N600
const $4edc21c9abdc48ad$var$TEXT_LINK = (0, $kbpa7.wacToken)("color.primary.blue"); // B700
const $4edc21c9abdc48ad$var$BORDER_COLOR = (0, $kbpa7.wacToken)("color.neutral.light300"); // N40
// ============================================================================
// Styles
// ============================================================================
const $4edc21c9abdc48ad$var$layoutStyle = null;
const $4edc21c9abdc48ad$var$sidebarStyle = null;
const $4edc21c9abdc48ad$var$mainStyle = null;
const $4edc21c9abdc48ad$var$mobileFiltersStyle = null;
// Sidebar heading — "Discover" in black, slightly larger
const $4edc21c9abdc48ad$var$sidebarHeadingStyle = null;
const $4edc21c9abdc48ad$var$resetButtonStyle = null;
const $4edc21c9abdc48ad$var$categoryListStyle = null;
const $4edc21c9abdc48ad$var$categoryItemStyle = null;
// Category buttons — black text, NO background on hover, blue text on hover
const $4edc21c9abdc48ad$var$categoryButtonBaseStyle = null;
// Active category — blue text, bold, NO background
const $4edc21c9abdc48ad$var$categoryButtonActiveStyle = null;
// Mobile select
const $4edc21c9abdc48ad$var$mobileSelectRowStyle = null;
const $4edc21c9abdc48ad$var$mobileLabelStyle = null;
const $4edc21c9abdc48ad$var$mobileSelectStyle = null;
// Breadcrumb — bigger, no bold on active category
const $4edc21c9abdc48ad$var$breadcrumbStyle = null;
const $4edc21c9abdc48ad$var$breadcrumbActiveStyle = null;
// Results header
const $4edc21c9abdc48ad$var$resultsHeaderStyle = null;
// Search
const $4edc21c9abdc48ad$var$searchWrapperStyle = null;
const $4edc21c9abdc48ad$var$searchInputStyle = null;
const $4edc21c9abdc48ad$var$clearButtonStyle = null;
// Grid
const $4edc21c9abdc48ad$var$gridStyle = null;
// Empty state
const $4edc21c9abdc48ad$var$emptyStateStyle = null;
// ============================================================================
// Helpers
// ============================================================================
const $4edc21c9abdc48ad$var$buildCategoryId = (label)=>label.toLowerCase().replace(/\s+/g, "");
const $4edc21c9abdc48ad$export$9b532486e289a2c2 = ({ items: items, categories: categories })=>{
    const [activeCategoryId, setActiveCategoryId] = (0, $1oC0p.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $1oC0p.useState)("");
    const [modalItem, setModalItem] = (0, $1oC0p.useState)(null);
    const activeCategoryLabel = (0, $1oC0p.useMemo)(()=>{
        if (!activeCategoryId) return "All categories";
        return categories.find((c)=>c.id === activeCategoryId)?.label ?? "All categories";
    }, [
        categories,
        activeCategoryId
    ]);
    const filteredItems = (0, $1oC0p.useMemo)(()=>{
        const term = searchTerm.trim().toLowerCase();
        return items.filter((item)=>{
            const catMatch = !activeCategoryId || $4edc21c9abdc48ad$var$buildCategoryId(item.category || "Other") === activeCategoryId;
            const searchMatch = !term || item.name.toLowerCase().includes(term) || item.description.toLowerCase().includes(term) || item.tags.some((t)=>t.toLowerCase().includes(term));
            return catMatch && searchMatch;
        });
    }, [
        items,
        activeCategoryId,
        searchTerm
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulpxy5q _na0i1bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("aside", {
                        className: (0, $2jatx.default)([
                            "_1bsbp3fh _1o9zidpf _1mjbglyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h5", {
                                className: (0, $2jatx.default)([
                                    "_18s812pl _1wyb7vkz _k48pni7l _syazw3q9 _1e0c1txw _4cvr1h6o _zulpu2gc _1p1dangw"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: "Discover"
                                    }),
                                    activeCategoryId && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: "|"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setActiveCategoryId(null),
                                                className: (0, $2jatx.default)([
                                                    "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1wybdlk8 _syazqs6p _9oik1r31 _1bnx8stv _jf4cnqa1"
                                                ]),
                                                style: {
                                                    "--_nf3ash": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_LINK)
                                                },
                                                children: "Reset"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                                className: (0, $2jatx.default)([
                                    "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                        className: (0, $2jatx.default)([
                                            "_6rth1y44"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>setActiveCategoryId(null),
                                            className: (0, $2jatx.default)([
                                                "_1bsb1osq _y3gn1e5h _11q7glyw _19itglyw _2rko1y44 _1yt41bs6 _80omtlke _1wybdlk8 _ect48q0o _syazw3q9 _v5641y4z _30l3qs6p",
                                                activeCategoryId === null && "_k48pni7l _syazqs6p"
                                            ]),
                                            style: {
                                                "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY),
                                                "--_nf3ash": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_LINK)
                                            },
                                            children: [
                                                "All categories (",
                                                items.length,
                                                ")"
                                            ]
                                        })
                                    }),
                                    categories.map((cat)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                            className: (0, $2jatx.default)([
                                                "_6rth1y44"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setActiveCategoryId(cat.id),
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _y3gn1e5h _11q7glyw _19itglyw _2rko1y44 _1yt41bs6 _80omtlke _1wybdlk8 _ect48q0o _syazw3q9 _v5641y4z _30l3qs6p",
                                                    activeCategoryId === cat.id && "_k48pni7l _syazqs6p"
                                                ]),
                                                style: {
                                                    "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY),
                                                    "--_nf3ash": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_LINK)
                                                },
                                                children: [
                                                    cat.label,
                                                    " (",
                                                    cat.count,
                                                    ")"
                                                ]
                                            })
                                        }, cat.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0cglyw _1mjb1ule _1eglpxbi"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulputpp"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            className: (0, $2jatx.default)([
                                                "_1wyb7vkz _k48pni7l _syazw3q9"
                                            ]),
                                            style: {
                                                "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                            },
                                            children: "Discover"
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                                            value: activeCategoryId ?? "",
                                            onChange: (e)=>setActiveCategoryId(e.target.value || null),
                                            className: (0, $2jatx.default)([
                                                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1yt41bs6 _2rko1y44 _19it895m _1wybdlk8 _ect48q0o _bfhkcd5j _syazw3q9 _80omtlke"
                                            ]),
                                            style: {
                                                "--_16labcr": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$BORDER_COLOR),
                                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                                "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("option", {
                                                    value: "",
                                                    children: [
                                                        "All categories (",
                                                        items.length,
                                                        ")"
                                                    ]
                                                }),
                                                categories.map((cat)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("option", {
                                                        value: cat.id,
                                                        children: [
                                                            cat.label,
                                                            " (",
                                                            cat.count,
                                                            ")"
                                                        ]
                                                    }, cat.id))
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wyb7vkz _k48pbfng _syazw3q9 _18s812pl"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: "Integrations / "
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazw3q9 _k48pbfng"
                                        ]),
                                        style: {
                                            "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                        },
                                        children: activeCategoryLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h5", {
                                className: (0, $2jatx.default)([
                                    "_1wybdlk8 _k48pni7l _syazw3q9 _1p1dangw _1dyzt94y _18s8ivgg"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                },
                                children: [
                                    filteredItems.length,
                                    " ",
                                    filteredItems.length === 1 ? "Result" : "Results"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _6rth1ejb"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value),
                                        "aria-label": "Search integrations",
                                        className: (0, $2jatx.default)([
                                            "_1bsb1osq _ca0q19bv _u5f31ylp _n3td19bv _19bv7vkz _2rko1y44 _19it895m _1wybdlk8 _ect48q0o _syazw3q9 _bfhkcd5j _vchhusvi _12ji1r31 _1qu2glyw _12y31o36 _858uqs6p _1idr1mx4"
                                        ]),
                                        style: {
                                            "--_16labcr": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$BORDER_COLOR),
                                            "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY),
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                            "--_nf3ash": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_LINK),
                                            "--_1oflnjk": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_SECONDARY)
                                        }
                                    }),
                                    searchTerm && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setSearchTerm(""),
                                        "aria-label": "Clear search",
                                        className: (0, $2jatx.default)([
                                            "_kqswstnw _1xi21crf _154i1ssb _t9ec1i34 _11q7glyw _19itglyw _1wybf6fq _80omtlke _syaz1mx4 _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _vwz4kb7n _30l3w3q9"
                                        ]),
                                        style: {
                                            "--_1oflnjk": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_SECONDARY),
                                            "--_ctyyjv": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_PRIMARY)
                                        },
                                        children: "\xd7"
                                    })
                                ]
                            }),
                            filteredItems.length > 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c11p5 _yv0e10lg _zulpv47k"
                                ]),
                                children: filteredItems.map((item)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVmQ7.IntegrationsSearchCard), {
                                        item: item,
                                        onClick: setModalItem
                                    }, item.repositoryPath))
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_y3gn1h6o _1rjcoahv _1wyb7vkz _syaz1mx4"
                                ]),
                                style: {
                                    "--_1oflnjk": (0, $6ZVlx.default)($4edc21c9abdc48ad$var$TEXT_SECONDARY)
                                },
                                children: "No Results"
                            })
                        ]
                    })
                ]
            }),
            modalItem && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3ie4.IntegrationsSearchModal), {
                item: modalItem,
                onClose: ()=>setModalItem(null)
            })
        ]
    });
};

});
parcelRegister("iVmQ7", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSearchCard", function () { return $2d97ae6a4a79e242$export$dbc4feda1f27ad36; });
/* integrations-search-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
// ============================================================================
// Colors
// ============================================================================
const $2d97ae6a4a79e242$var$TEXT_PRIMARY = (0, $kbpa7.wacToken)("color.extended.blue1000");
const $2d97ae6a4a79e242$var$TEXT_SECONDARY = (0, $kbpa7.wacToken)("color.neutral.light800");
const $2d97ae6a4a79e242$var$TEXT_TAG_SELECTED = (0, $kbpa7.wacToken)("color.extended.blue1000");
// ============================================================================
// Styles
// ============================================================================
const $2d97ae6a4a79e242$var$cardStyle = null;
const $2d97ae6a4a79e242$var$logoAreaStyle = null;
const $2d97ae6a4a79e242$var$logoStyle = null;
const $2d97ae6a4a79e242$var$titleStyle = null;
const $2d97ae6a4a79e242$var$descriptionStyle = null;
const $2d97ae6a4a79e242$var$tagsContainerStyle = null;
const $2d97ae6a4a79e242$var$tagButtonBaseStyle = null;
const $2d97ae6a4a79e242$var$tagButtonSelectedStyle = null;
const $2d97ae6a4a79e242$var$expandButtonStyle = null;
// ============================================================================
// Constants
// ============================================================================
const $2d97ae6a4a79e242$var$MAX_VISIBLE_TAGS = 3;
const $2d97ae6a4a79e242$export$dbc4feda1f27ad36 = ({ item: item, onClick: onClick })=>{
    const [selectedTag, setSelectedTag] = (0, $1oC0p.useState)(null);
    const [expanded, setExpanded] = (0, $1oC0p.useState)(false);
    const visibleTags = item.tags.slice(0, $2d97ae6a4a79e242$var$MAX_VISIBLE_TAGS);
    const hiddenTags = item.tags.slice($2d97ae6a4a79e242$var$MAX_VISIBLE_TAGS);
    const hasHiddenTags = hiddenTags.length > 0;
    const tagsToRender = expanded ? item.tags : visibleTags;
    const handleTagClick = (0, $1oC0p.useCallback)((e, tag)=>{
        e.stopPropagation();
        setSelectedTag((prev)=>prev === tag ? null : tag);
    }, []);
    const handleExpandClick = (0, $1oC0p.useCallback)((e)=>{
        e.stopPropagation();
        setExpanded((prev)=>!prev);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        onClick: ()=>onClick?.(item),
        "aria-label": item.name,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _bfhkcd5j _2rkoftgi _1yt41ejb _80omtlke _16qst7xp _v5641gli _4t3i1osq _vchhusvi _19itglyw _11q7glyw _y3gn1e5h _11c81kw7 _syaz1kw7 _1dbz130s _1llwp1qy _1ygb8djs _1ah3yh40"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthpxbi _1e0c1txw _4cvr1h6o _1bah1h6o _4t3iys9h"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: item.logo,
                    alt: item.name,
                    loading: "lazy",
                    className: (0, $2jatx.default)([
                        "_p12fys9h _c71lys9h _5ral1f51"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_18s861nu _ect48q0o _1wyb7vkz _k48pni7l _vwz419ii _syazw3q9 _1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjcs5v _sudp1e54 _1nmz1hna"
                ]),
                style: {
                    "--_ctyyjv": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_PRIMARY)
                },
                children: item.name
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_18s812pl _ect48q0o _1wybdlk8 _vwz4bs82 _syazw3q9 _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0ccj1k _1yyj11wp _sudp1e54 _1reo15vq _18m915vq"
                ]),
                style: {
                    "--_ctyyjv": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_PRIMARY)
                },
                children: item.description
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1n261g80 _zulpi2wt _1pfh1wug"
                ]),
                children: [
                    tagsToRender.map((tag)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            onClick: (e)=>handleTagClick(e, tag),
                            className: (0, $2jatx.default)([
                                "_11q7150w _19itglyw _2rko1y44 _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _ect48q0o _1wyb1crf _syaz1mx4 _80omtlke _v564ezw5 _irr3xv17",
                                selectedTag === tag && "_bfhkmmjq _syaz15cs _k48pni7l"
                            ]),
                            style: {
                                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                                "--_1oflnjk": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_SECONDARY),
                                "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                                "--_1ayut75": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light500")),
                                "--_12r9gtj": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_TAG_SELECTED)
                            },
                            children: tag
                        }, tag)),
                    hasHiddenTags && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: handleExpandClick,
                        "aria-label": expanded ? "Show fewer tags" : "Show more tags",
                        className: (0, $2jatx.default)([
                            "_11q7150w _19itglyw _2rko1y44 _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _ect48q0o _1wyb1crf _syaz1mx4 _80omtlke _k48pni7l _v564mvc0 _irr3xv17"
                        ]),
                        style: {
                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                            "--_1oflnjk": (0, $6ZVlx.default)($2d97ae6a4a79e242$var$TEXT_SECONDARY),
                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                        },
                        children: expanded ? "\xd7" : "..."
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("g3ie4", function(module, exports) {
$parcel$export(module.exports, "IntegrationsSearchModal", function () { return $ef5116a4464ba208$export$5104ff47239f45a7; });
/* integrations-search-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $10a00 = parcelRequire("10a00");
// ============================================================================
// Colors
// ============================================================================
const $ef5116a4464ba208$var$TEXT_PRIMARY = (0, $kbpa7.wacToken)("color.extended.blue1000");
const $ef5116a4464ba208$var$TEXT_SECONDARY = (0, $kbpa7.wacToken)("color.neutral.light800");
const $ef5116a4464ba208$var$TEXT_LINK = (0, $kbpa7.wacToken)("color.primary.blue");
const $ef5116a4464ba208$var$BG_CODE = (0, $kbpa7.wacToken)("color.neutral.light100");
const $ef5116a4464ba208$var$BORDER_COLOR = (0, $kbpa7.wacToken)("color.neutral.light300");
// ============================================================================
// Styles
// ============================================================================
// Fix 1 & 4: Restructured overlay into wrapper + backdrop button
// Wrapper is purely for positioning (no click handler, no background)
const $ef5116a4464ba208$var$wrapperStyle = null;
// Backdrop is a proper <button> — fixes a11y errors
// Uses wacToken + opacity instead of hard-coded rgba()
const $ef5116a4464ba208$var$backdropStyle = null;
// Fix 2: Use ADS elevation token instead of hard-coded boxShadow
const $ef5116a4464ba208$var$modalOuterStyle = null;
const $ef5116a4464ba208$var$modalInnerStyle = null;
const $ef5116a4464ba208$var$closeButtonStyle = null;
const $ef5116a4464ba208$var$logoAreaStyle = null;
const $ef5116a4464ba208$var$logoImgStyle = null;
const $ef5116a4464ba208$var$titleStyle = null;
const $ef5116a4464ba208$var$descriptionStyle = null;
const $ef5116a4464ba208$var$versionStyle = null;
const $ef5116a4464ba208$var$yamlSectionStyle = null;
const $ef5116a4464ba208$var$yamlHeadingStyle = null;
const $ef5116a4464ba208$var$yamlCodeBlockStyle = null;
// Fix 3: Container-level styles ONLY — no nested selectors.
// All child element styles moved to MARKDOWN_CONTENT_STYLES below.
const $ef5116a4464ba208$var$markdownContainerStyle = null;
const $ef5116a4464ba208$var$readmeLoadingStyle = null;
const $ef5116a4464ba208$var$buttonsAreaStyle = null;
const $ef5116a4464ba208$var$visitRepoButtonStyle = null;
// ============================================================================
// Scoped styles for README child elements
//
// Injected via a <style> tag so they bypass Compiled's no-nested-selectors
// rule. These target child elements within .bb-readme-content.
// wacToken() and token() return CSS var() expressions, so they work
// fine inside template literal CSS strings.
// ============================================================================
const $ef5116a4464ba208$var$scope = (0, $10a00.README_SCOPE_CLASS);
const $ef5116a4464ba208$var$MARKDOWN_CONTENT_STYLES = `
  .${$ef5116a4464ba208$var$scope} h1 {
    font-size: 18px;
    font-weight: 600;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-150, 12px)"};
  }

  .${$ef5116a4464ba208$var$scope} h2 {
    font-size: 16px;
    font-weight: 600;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: ${"var(--ds-space-250, 20px)"} 0 ${"var(--ds-space-100, 8px)"};
  }

  .${$ef5116a4464ba208$var$scope} h3 {
    font-size: 14px;
    font-weight: 600;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-100, 8px)"};
  }

  .${$ef5116a4464ba208$var$scope} p {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: 0 0 ${"var(--ds-space-150, 12px)"};
  }

  .${$ef5116a4464ba208$var$scope} ul,
  .${$ef5116a4464ba208$var$scope} ol {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin: 0 0 ${"var(--ds-space-150, 12px)"};
    padding-inline-start: ${"var(--ds-space-300, 24px)"};
  }

  .${$ef5116a4464ba208$var$scope} li {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    margin-block-end: ${"var(--ds-space-050, 4px)"};
  }

  .${$ef5116a4464ba208$var$scope} pre {
    background-color: ${$ef5116a4464ba208$var$BG_CODE};
    border-radius: 4px;
    padding: ${"var(--ds-space-200, 16px)"};
    overflow-x: auto;
    margin: 0 0 ${"var(--ds-space-150, 12px)"};
    border: 1px solid ${$ef5116a4464ba208$var$BORDER_COLOR};
  }

  .${$ef5116a4464ba208$var$scope} code {
    font-family: SFMono-Medium, 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace;
    font-size: 13px;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
  }

  .${$ef5116a4464ba208$var$scope} p code,
  .${$ef5116a4464ba208$var$scope} li code,
  .${$ef5116a4464ba208$var$scope} td code {
    background-color: ${$ef5116a4464ba208$var$BG_CODE};
    border-radius: 3px;
    padding: 2px 6px;
    font-size: 12px;
  }

  .${$ef5116a4464ba208$var$scope} table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 ${"var(--ds-space-150, 12px)"};
    font-size: 13px;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
  }

  .${$ef5116a4464ba208$var$scope} th,
  .${$ef5116a4464ba208$var$scope} td {
    border: 1px solid ${$ef5116a4464ba208$var$BORDER_COLOR};
    padding: ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"};
    text-align: left;
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
  }

  .${$ef5116a4464ba208$var$scope} th {
    background-color: ${$ef5116a4464ba208$var$BG_CODE};
    font-weight: 600;
  }

  .${$ef5116a4464ba208$var$scope} a {
    color: ${$ef5116a4464ba208$var$TEXT_LINK};
    text-decoration: none;
  }

  .${$ef5116a4464ba208$var$scope} a:hover {
    text-decoration: underline;
  }

  .${$ef5116a4464ba208$var$scope} strong {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
    font-weight: 600;
  }

  .${$ef5116a4464ba208$var$scope} em {
    color: ${$ef5116a4464ba208$var$TEXT_PRIMARY};
  }
`;
// Combine syntax highlighting + markdown content styles
const $ef5116a4464ba208$var$ALL_README_STYLES = (0, $10a00.SYNTAX_STYLES) + $ef5116a4464ba208$var$MARKDOWN_CONTENT_STYLES;
const $ef5116a4464ba208$export$5104ff47239f45a7 = ({ item: item, onClose: onClose })=>{
    const modalRef = (0, $1oC0p.useRef)(null);
    const [readmeHtml, setReadmeHtml] = (0, $1oC0p.useState)(null);
    const [readmeLoading, setReadmeLoading] = (0, $1oC0p.useState)(true);
    // Fetch README when modal opens
    (0, $1oC0p.useEffect)(()=>{
        let cancelled = false;
        const loadReadme = async ()=>{
            setReadmeLoading(true);
            const html = await (0, $10a00.fetchReadmeHtml)(item.repositoryPath);
            if (!cancelled) {
                setReadmeHtml(html);
                setReadmeLoading(false);
            }
        };
        loadReadme();
        return ()=>{
            cancelled = true;
        };
    }, [
        item.repositoryPath
    ]);
    // Close on Escape
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === "Escape") onClose();
    }, [
        onClose
    ]);
    (0, $1oC0p.useEffect)(()=>{
        document.addEventListener("keydown", handleKeyDown);
        document.body.style.overflow = "hidden";
        modalRef.current?.focus();
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = "";
        };
    }, [
        handleKeyDown
    ]);
    const repoUrl = `https://bitbucket.org/${item.repositoryPath}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1r04idpf _1e0c1txw _4cvr1h6o _1bah1h6o _1pby15gg _1yt41ejb _vchhusvi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: onClose,
                "aria-label": "Close dialog",
                tabIndex: -1,
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _bfhk9c0g _tzy4105o _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80om73ad"
                ]),
                style: {
                    "--_sse8eq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark900"))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": item.name,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _bfhkcd5j _2rkoftgi _p12f1yw0 _1bsb1osq _c71l1us8 _1e0c1txw _2lx21bp4 _16qs130s _1pbykb7n"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        "aria-label": "Close",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tpxbi _rjxppxbi _11q7glyw _19itglyw _1wyb1tcg _80omtlke _syaz1mx4 _vwz4kb7n _1yt4u2gc _2rko1y44 _1pbykb7n _30l3w3q9 _irr31lhl"
                        ]),
                        style: {
                            "--_1oflnjk": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_SECONDARY),
                            "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY),
                            "--_npmk8l": (0, $6ZVlx.default)($ef5116a4464ba208$var$BG_CODE)
                        },
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        ref: modalRef,
                        tabIndex: -1,
                        className: (0, $2jatx.default)([
                            "_1yt4xy5q _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_6rthpxbi _1e0c1txw _4cvr1h6o _1bah1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: item.logo,
                                    alt: item.name,
                                    className: (0, $2jatx.default)([
                                        "_p12fys9h _c71lys9h _5ral1f51"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_18s861nu _ect48q0o _1wybgktf _k48pni7l _syazw3q9"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                },
                                children: item.name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_18s812pl _ect48q0o _1wybdlk8 _vwz4bs82 _syazw3q9"
                                ]),
                                style: {
                                    "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                },
                                children: item.description
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_18s81km1 _ect48q0o _1wybw1gv _syaz1mx4"
                                ]),
                                style: {
                                    "--_1oflnjk": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_SECONDARY)
                                },
                                children: item.version
                            }),
                            readmeLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_y3gn1h6o _1yt41ejb _1wybdlk8 _syaz1mx4"
                                ]),
                                style: {
                                    "--_1oflnjk": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_SECONDARY)
                                },
                                children: "Loading documentation\u2026"
                            }) : readmeHtml ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("style", {
                                        dangerouslySetInnerHTML: {
                                            __html: $ef5116a4464ba208$var$ALL_README_STYLES
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_ect48q0o _1wybdlk8 _vwz4yu22 _syazw3q9",
                                            (0, $10a00.README_SCOPE_CLASS)
                                        ]),
                                        dangerouslySetInnerHTML: {
                                            __html: readmeHtml
                                        },
                                        style: {
                                            "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                children: item.yml && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_6rth1ejb"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                            className: (0, $2jatx.default)([
                                                "_1wyb7vkz _k48pni7l _ect48q0o _syazw3q9 _18s861nu"
                                            ]),
                                            style: {
                                                "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                            },
                                            children: "YAML Definition"
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("pre", {
                                            className: (0, $2jatx.default)([
                                                "_bfhk1lhl _2rko1y44 _1yt4pxbi _1reo1wug _ect410ur _1wybw1gv _vwz4bs82 _syazw3q9 _o572qvpr _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                            ]),
                                            style: {
                                                "--_npmk8l": (0, $6ZVlx.default)($ef5116a4464ba208$var$BG_CODE),
                                                "--_ctyyjv": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_PRIMARY)
                                            },
                                            children: item.yml
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt41lhf _mqm2895m _1e0c1txw _1bah1y6m"
                        ]),
                        style: {
                            "--_16labcr": (0, $6ZVlx.default)($ef5116a4464ba208$var$BORDER_COLOR)
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: repoUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: (0, $2jatx.default)([
                                "_1e0c1o8l _1yt41pyq _bfhkqs6p _syazcd5j _19itglyw _2rko1y44 _ect48q0o _1wybdlk8 _k48pni7l _80omtlke _4bfu1r31 _1hmsglyw _ajmmnqa1 _16l4q80t"
                            ]),
                            style: {
                                "--_nf3ash": (0, $6ZVlx.default)($ef5116a4464ba208$var$TEXT_LINK),
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            },
                            children: "Visit Repo"
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("10a00", function(module, exports) {
$parcel$export(module.exports, "fetchReadmeHtml", function () { return $832c920d7c16dbe1$export$184de531c3da8b72; });
$parcel$export(module.exports, "SYNTAX_STYLES", function () { return $832c920d7c16dbe1$export$a6ba3cea863bf06e; });
$parcel$export(module.exports, "README_SCOPE_CLASS", function () { return $832c920d7c16dbe1$export$69ff8761afe2a1fd; });

var $5QRrh = parcelRequire("5QRrh");
// ============================================================================
// YAML syntax highlighting
// ============================================================================
const $832c920d7c16dbe1$var$highlightYamlLine = (line)=>{
    if (!line.trim()) return line;
    // Full-line comments
    if (/^\s*#/.test(line)) return `<span class="c">${line}</span>`;
    let result = line;
    // Quoted strings "..."
    result = result.replace(/"([^"]*?)"/g, '<span class="s">"$1"</span>');
    // YAML keys before colon
    result = result.replace(/^(\s*(?:[-*]\s+)?)([A-Za-z_][\w.-]*)(:\s*)/, '$1<span class="k">$2</span>$3');
    return result;
};
const $832c920d7c16dbe1$var$addYamlSyntaxHighlighting = (html)=>{
    return html.replace(/<pre><code(?:\s[^>]*)?>([\s\S]*?)<\/code><\/pre>/gi, (_match, codeContent)=>{
        const normalized = codeContent.replace(/<br\s*\/?>/gi, "\n");
        const highlighted = normalized.split("\n").map((line)=>$832c920d7c16dbe1$var$highlightYamlLine(line)).join("<br>");
        return `<pre><code class="language-yaml">${highlighted}</code></pre>`;
    });
};
// ============================================================================
// Pipe table → <table> conversion
// ============================================================================
const $832c920d7c16dbe1$var$parsePipeRow = (line)=>{
    const trimmed = line.replace(/^\|/, "").replace(/\|$/, "");
    return trimmed.split("|").map((cell)=>cell.trim());
};
const $832c920d7c16dbe1$var$convertPipeTablesToHtml = (html)=>{
    return html.replace(/<p>([\s\S]*?)<\/p>/g, (match, innerContent)=>{
        const lines = innerContent.split(/<br\s*\/?>|\n/).map((l)=>l.trim()).filter((l)=>l.length > 0);
        if (lines.length < 3) return match;
        const pipeLines = lines.filter((l)=>l.includes("|"));
        if (pipeLines.length < lines.length * 0.8) return match;
        const separatorIndex = lines.findIndex((line)=>line.includes("|") && line.includes("-") && line.replace(/[|\s:-]/g, "").length === 0);
        if (separatorIndex < 1) return match;
        const headerLines = lines.slice(0, separatorIndex);
        const bodyLines = lines.slice(separatorIndex + 1).filter((line)=>line.includes("|"));
        if (bodyLines.length === 0) return match;
        let table = "<table><thead>";
        headerLines.forEach((line)=>{
            table += "<tr>";
            $832c920d7c16dbe1$var$parsePipeRow(line).forEach((cell)=>{
                table += `<th>${cell}</th>`;
            });
            table += "</tr>";
        });
        table += "</thead><tbody>";
        bodyLines.forEach((line)=>{
            table += "<tr>";
            $832c920d7c16dbe1$var$parsePipeRow(line).forEach((cell)=>{
                table += `<td>${cell}</td>`;
            });
            table += "</tr>";
        });
        table += "</tbody></table>";
        return table;
    });
};
// ============================================================================
// Asterisk list fix
// ============================================================================
const $832c920d7c16dbe1$var$fixAsterisksAsListItems = (html)=>{
    return html.replace(/<pre><code(?:\s[^>]*)?>([\s\S]*?)<\/code><\/pre>/gi, (match, codeContent)=>{
        const fixed = codeContent.replace(/^(\s*)\* /gm, "$1- ");
        return match.replace(codeContent, fixed);
    });
};
// ============================================================================
// Basic markdown → HTML fallback
// ============================================================================
const $832c920d7c16dbe1$var$convertBasicMarkdown = (md)=>{
    let html = md;
    html = html.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    // Code blocks
    html = html.replace(/```(\w*)\n([\s\S]*?)```/g, (_match, _lang, code)=>`<pre><code>${code.trim()}</code></pre>`);
    // Inline code
    html = html.replace(/`([^`]+)`/g, "<code>$1</code>");
    // Headings
    html = html.replace(/^### (.+)$/gm, "<h3>$1</h3>");
    html = html.replace(/^## (.+)$/gm, "<h2>$1</h2>");
    html = html.replace(/^# (.+)$/gm, "<h1>$1</h1>");
    // Bold
    html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    // Italic
    html = html.replace(/\*(.+?)\*/g, "<em>$1</em>");
    // Links
    html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
    // Unordered lists
    html = html.replace(/^[\-\*] (.+)$/gm, "<li>$1</li>");
    html = html.replace(/((?:<li>.*<\/li>\n?)+)/g, "<ul>$1</ul>");
    // Paragraphs
    html = html.split("\n\n").map((block)=>{
        const trimmed = block.trim();
        if (!trimmed) return "";
        if (/^<[a-z]/.test(trimmed)) return trimmed;
        return `<p>${trimmed.replace(/\n/g, "<br>")}</p>`;
    }).join("\n");
    return html;
};
// ============================================================================
// Post-processing pipeline
// ============================================================================
const $832c920d7c16dbe1$var$postProcessReadmeHtml = (html)=>{
    let processed = html;
    processed = $832c920d7c16dbe1$var$fixAsterisksAsListItems(processed);
    processed = $832c920d7c16dbe1$var$convertPipeTablesToHtml(processed);
    processed = $832c920d7c16dbe1$var$addYamlSyntaxHighlighting(processed);
    return processed;
};
const $832c920d7c16dbe1$export$184de531c3da8b72 = async (repositoryPath)=>{
    try {
        // Try README.md first
        const rawUrl = `https://api.bitbucket.org/2.0/repositories/${repositoryPath}/src/master/README.md`;
        const res = await fetch(rawUrl, {
            headers: {
                Accept: "text/html"
            }
        });
        if (res.ok) {
            const text = await res.text();
            const html = text.trim().startsWith("<") ? text : $832c920d7c16dbe1$var$convertBasicMarkdown(text);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5QRrh))).sanitize($832c920d7c16dbe1$var$postProcessReadmeHtml(html));
        }
        // Fallback: pipe.md
        const pipeUrl = `https://api.bitbucket.org/2.0/repositories/${repositoryPath}/src/master/pipe.md`;
        const pipeRes = await fetch(pipeUrl, {
            headers: {
                Accept: "text/html"
            }
        });
        if (pipeRes.ok) {
            const text = await pipeRes.text();
            const html = text.trim().startsWith("<") ? text : $832c920d7c16dbe1$var$convertBasicMarkdown(text);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5QRrh))).sanitize($832c920d7c16dbe1$var$postProcessReadmeHtml(html));
        }
        return null;
    } catch  {
        return null;
    }
};
const $832c920d7c16dbe1$export$a6ba3cea863bf06e = `
  .bb-readme-content .k,
  .bb-readme-content .kn,
  .bb-readme-content .kd,
  .bb-readme-content .kp,
  .bb-readme-content .kt {
    color: #0052CC;
    font-weight: 600;
  }

  .bb-readme-content .s,
  .bb-readme-content .s1,
  .bb-readme-content .s2,
  .bb-readme-content .se,
  .bb-readme-content .sb,
  .bb-readme-content .sc,
  .bb-readme-content .sd,
  .bb-readme-content .sh,
  .bb-readme-content .si,
  .bb-readme-content .sx,
  .bb-readme-content .sr,
  .bb-readme-content .ss {
    color: #36B37E;
  }

  .bb-readme-content .c,
  .bb-readme-content .c1,
  .bb-readme-content .cm,
  .bb-readme-content .cp,
  .bb-readme-content .cs,
  .bb-readme-content .ch {
    color: #6B778C;
    font-style: italic;
  }

  .bb-readme-content .nf,
  .bb-readme-content .nb,
  .bb-readme-content .nc,
  .bb-readme-content .ni,
  .bb-readme-content .ne,
  .bb-readme-content .nd {
    color: #6554C0;
  }

  .bb-readme-content .mi,
  .bb-readme-content .mf,
  .bb-readme-content .mh,
  .bb-readme-content .mo,
  .bb-readme-content .mb,
  .bb-readme-content .il {
    color: #FF5630;
  }

  .bb-readme-content .o,
  .bb-readme-content .p,
  .bb-readme-content .ow {
    color: #091E42;
  }

  .bb-readme-content .n,
  .bb-readme-content .na,
  .bb-readme-content .no,
  .bb-readme-content .nv,
  .bb-readme-content .nn,
  .bb-readme-content .nt,
  .bb-readme-content .nx,
  .bb-readme-content .bp,
  .bb-readme-content .vc,
  .bb-readme-content .vg,
  .bb-readme-content .vi,
  .bb-readme-content .vm {
    color: #091E42;
  }
`;
const $832c920d7c16dbe1$export$69ff8761afe2a1fd = "bb-readme-content";

});



parcelRegister("gvpkz", function(module, exports) {
$parcel$export(module.exports, "usePipesData", function () { return $510982361a72aabd$export$82afdb6e66ce8c05; });

var $1oC0p = parcelRequire("1oC0p");
const $510982361a72aabd$var$PIPES_JSON_URL = "https://bitbucket.org/bitbucketpipelines/official-pipes/raw/master/pipes.prod.json";
const $510982361a72aabd$var$buildCategoryId = (label)=>label.toLowerCase().replace(/\s+/g, "");
const $510982361a72aabd$export$82afdb6e66ce8c05 = (jsonUrl)=>{
    const [items, setItems] = (0, $1oC0p.useState)([]);
    const [loading, setLoading] = (0, $1oC0p.useState)(true);
    const [error, setError] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        let cancelled = false;
        const run = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const res = await fetch(jsonUrl || $510982361a72aabd$var$PIPES_JSON_URL);
                if (!res.ok) throw new Error(`Failed to fetch pipes data: ${res.status}`);
                const data = await res.json();
                if (!cancelled) setItems(data);
            } catch (err) {
                if (!cancelled) setError(err instanceof Error ? err : new Error("Unknown error fetching pipes data"));
            } finally{
                if (!cancelled) setLoading(false);
            }
        };
        run();
        return ()=>{
            cancelled = true;
        };
    }, [
        jsonUrl
    ]);
    const categories = (0, $1oC0p.useMemo)(()=>{
        const counts = new Map();
        items.forEach((item)=>{
            const label = item.category || "Other";
            counts.set(label, (counts.get(label) ?? 0) + 1);
        });
        return Array.from(counts.entries()).map(([label, count])=>({
                id: $510982361a72aabd$var$buildCategoryId(label),
                label: label,
                count: count
            })).sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        items
    ]);
    return {
        items: items,
        categories: categories,
        loading: loading,
        error: error
    };
};

});



parcelRegister("fZxve", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32c5d817419f263d$export$2e2bcd8739ae039; });
/* bleeding-image-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lqyi6 = parcelRequire("lqyi6");

var $2axoc = parcelRequire("2axoc");

var $bSVv5 = parcelRequire("bSVv5");
const $32c5d817419f263d$export$5460398cf21adb2e = "#191919";
/**
 * `colorAgainst` value passed to {@link Button} so it picks the white text +
 * white outline treatment intended for dark surfaces (`secondary_against_black`
 * in the underlying button style map).
 */ const $32c5d817419f263d$var$BUTTON_COLOR_AGAINST_DARK_BG = "black";
const $32c5d817419f263d$var$sectionStyles = null;
const $32c5d817419f263d$var$rowStyles = null;
const $32c5d817419f263d$var$contentBlockSlotStyles = null;
const $32c5d817419f263d$var$imageSlotStyles = null;
/**
 * Inline `<img>` styles for the bleeding image. Renders the image at the
 * width of its slot with proportional height so there is never any
 * letterboxing whitespace around it. `display: block` removes the inline
 * baseline gap that would otherwise add a few pixels under the image.
 */ const $32c5d817419f263d$var$imageElementStyles = null;
/**
 * `UniformBleedingImageHero` is a Uniform-registered pattern component that
 * composes a {@link ContentBlock} (left, heading + body only) and a
 * {@link Image} (right) inside a flexbox row, with a locally rendered
 * {@link Button} acting as the call-to-action. The image is rendered at a
 * fixed width per breakpoint and uses a negative right margin to bleed past
 * the right edge of the viewport (clipped by the section's `overflow-x:
 * clip`). On mobile the layout stacks and the image is shown in full.
 *
 * ----------------------------------------------------------------------------
 * Layout decision (Option X)
 * ----------------------------------------------------------------------------
 * Earlier iterations of this component used the WAC `ColumnLayout`'s 12-column
 * grid with the content block on cols 1–6 and the image on cols 5–12. After
 * comparing that against the GWP-11478 Figma frames, the design turns out to
 * be a flex layout of two **fixed-width** children (e.g. content block 312–
 * 668px, image 844–1438px) — not a fluid 12-col grid — which is why the
 * heading and body wrap as designed. Switching to a fixed-width flex row
 * matches the Figma exactly while still letting the image bleed past the
 * right edge thanks to the section's `overflow-x: clip`.
 *
 * ----------------------------------------------------------------------------
 * CTA architecture decision (recorded for future maintainers)
 * ----------------------------------------------------------------------------
 * `UniformContentBlock` *can* render its own button via `buttonLabel` /
 * `buttonHref` / `buttonVariant`, but its internal `renderCta` hardcodes
 * `colorAgainst` to `"white"` for every background except the WAC blue
 * (`#1868DB`), where it forces `"other"`. There is no code path that yields
 * `colorAgainst="black"` (the value required for white text + white outline
 * on a dark surface — see `getButtonVariant` in `button.tsx`, which maps it
 * to the `secondary_against_black` style).
 *
 * Two paths to fix the wrong-button-on-dark-bg:
 *   - Option A: patch ContentBlock so dark `backgroundColor` triggers
 *     `colorAgainst="black"`. Correct at the right layer; would also fix the
 *     latent bug for any future dark-bg ContentBlock consumers.
 *   - Option C (chosen here): keep ContentBlock for heading + body only and
 *     render the CTA `Button` ourselves with `colorAgainst="black"`.
 *
 * Option C was chosen for **this** PR for scope and risk reasons:
 *   1. It keeps every change inside `bleeding-image-hero/`, with zero blast
 *      radius on the shared `ContentBlock` (which is rendered in many places
 *      across WAC).
 *   2. ContentBlock currently has no other dark-bg consumers, so the latent
 *      bug isn't actively breaking anything in production today.
 *   3. The Option A patch is a clean, scoped follow-up that can ship in its
 *      own PR (with its own visual review of any newly dark-bg consumers)
 *      without blocking GWP-11478.
 *
 * If a second dark-bg consumer appears, prefer migrating both this component
 * and the new one to Option A so the dark-mode CTA logic lives in exactly
 * one place.
 */ const $32c5d817419f263d$var$UniformBleedingImageHero = ({ heading: heading, bodyText: bodyText, ctaLabel: ctaLabel, ctaUrl: ctaUrl, mediaImageUrl: mediaImageUrl, mediaAlt: mediaAlt, backgroundColor: backgroundColor, buttonVariant: buttonVariant = "secondary" })=>{
    // Resolve the background color defensively. Destructuring defaults only
    // apply when the prop is strictly `undefined`; Uniform's authoring runtime
    // can emit `null` or `""` for unset string parameters, both of which would
    // bypass a destructured default and leave the section unstyled. Treat any
    // falsy value as "use the default" so the dark surface is always painted.
    const resolvedBackgroundColor = backgroundColor && backgroundColor.trim() !== "" ? backgroundColor : $32c5d817419f263d$export$5460398cf21adb2e;
    const sectionBackgroundStyle = {
        backgroundColor: resolvedBackgroundColor
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        style: sectionBackgroundStyle,
        "data-testid": "bleeding-image-hero",
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _1reozryt _1e0c1txw _2lx21bp4 _4cvr1h6o _18zrxy5q _1rjc1jfw _1wfq1wqb _15vt68cl _16imidpf _d2ik1wqb _exxm68cl _12z7bv7e _14mbclpc"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_p12f1m6w _1i7q1kzw _1e0c1txw _2lx21bp4 _4cvr1fhb _1bsb1osq _zulp1jfw _1lp7vrvc _19wgidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _bfhk1j28 _kqswh2mm _1e0c1txw _2lx21bp4 _zulp1jfw _4cvr1y6m _14b5eo28 _p7vbidpf _19wg1jfw _1waf1jfw _1yd31jfw _glte1vif _6ru51erl _a64kxncg _h140xncg _1rghxncg _1pbykb7n"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                            title: heading,
                            titleAs: "h2",
                            text: bodyText,
                            backgroundColor: resolvedBackgroundColor
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            variant: buttonVariant,
                            responsiveSize: {
                                mobile: "small",
                                tablet: "small",
                                desktop: "large",
                                xl_desktop: "large"
                            },
                            colorAgainst: $32c5d817419f263d$var$BUTTON_COLOR_AGAINST_DARK_BG,
                            href: ctaUrl,
                            "aria-label": `${ctaLabel}, ${heading}`,
                            dataEventProps: {
                                "data-product-key": "uniform",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "heroSection",
                                "data-label": ctaLabel,
                                "data-label-english": ctaLabel
                            },
                            children: ctaLabel
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _bfhk1j28 _1reoewfl _18m9ewfl _1o9zidpf _14b5n0dd _1lva1fgt _1ywm1wug _16im1ejb _glten0dd _161b1f6i _6ru57hph _1oyhltga"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: mediaImageUrl,
                        alt: mediaAlt,
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _1bsb1osq _4t3i1wug _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};
var $32c5d817419f263d$export$2e2bcd8739ae039 = $32c5d817419f263d$var$UniformBleedingImageHero;

});

parcelRegister("7v1H9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aee83d009c5ce128$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $lP7A9 = parcelRequire("lP7A9");

var $ixBPH = parcelRequire("ixBPH");

var $30iuM = parcelRequire("30iuM");

var $kDYqJ = parcelRequire("kDYqJ");
const $aee83d009c5ce128$var$UniformBlogNewsGallery = ({ cards: cards, isMotionAvailable: isMotionAvailable, motionDelay: motionDelay, motionForward: transformForward, motionBackward: transformBackward })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = (0, $f2QWG.flattenValues)(cards);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kDYqJ.GalleryContainer), {
        isMotionAvailable: isMotionAvailable,
        motionDelay: motionDelay,
        gap: {
            belowMd: (0, $lP7A9.default)("space.300"),
            aboveMd: (0, $lP7A9.default)("space.400")
        },
        children: flattenedCards.map((card, index)=>{
            if (card) {
                if ("dates" in card) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "entry-item",
                    style: {
                        // @ts-expect-error -- CSS custom property not in CSSProperties type
                        "--gc-item-i": index
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ixBPH.BlogEventCard), {
                        date: card.dates,
                        location: card.location,
                        title: card.title,
                        link: {
                            href: card.ctaUrl,
                            text: card.ctaText,
                            dataEventProps: {
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "cardSection",
                                "data-product-key": "uniform",
                                "data-label": card.ctaText
                            }
                        },
                        image: {
                            src: card.imageUrl,
                            alt: card.imageAlt ?? ""
                        },
                        motionConfig: transformForward && transformBackward ? {
                            transformForward: transformForward,
                            transformBackward: transformBackward
                        } : undefined
                    })
                }, index);
                else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "entry-item",
                    style: {
                        // @ts-expect-error -- CSS custom property not in CSSProperties type
                        "--gc-item-i": index
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $30iuM.BlogNewsCard), {
                        color: card.color,
                        label: card.label,
                        title: card.title,
                        link: {
                            href: card.ctaUrl,
                            text: card.ctaText,
                            dataEventProps: {
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "cardSection",
                                "data-product-key": "uniform",
                                "data-label": card.ctaText
                            }
                        },
                        image: {
                            src: card.imageUrl,
                            alt: card.imageAlt ?? ""
                        },
                        motionConfig: transformForward && transformBackward ? {
                            transformForward: transformForward,
                            transformBackward: transformBackward
                        } : undefined
                    })
                }, index);
            }
        })
    });
};
var $aee83d009c5ce128$export$2e2bcd8739ae039 = $aee83d009c5ce128$var$UniformBlogNewsGallery;

});
parcelRegister("ixBPH", function(module, exports) {
$parcel$export(module.exports, "BlogEventCard", function () { return $6d0a169d80108741$export$fe664c335408d8a7; });
/* blog-event-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lfTOg = parcelRequire("lfTOg");

var $kQCok = parcelRequire("kQCok");

var $kbpa7 = parcelRequire("kbpa7");

var $30iuM = parcelRequire("30iuM");
const $6d0a169d80108741$export$fe664c335408d8a7 = (props)=>{
    const { date: date, location: location, ...rest } = props;
    const intl = (0, $8e22h.default)();
    const eventMeta = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulpv47k _syazcd5j"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp12x7"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lfTOg))), {
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_ect4bzd7 _k48pbfng _syazcd5j _fz897vkz _1ol91tcg _1wybdlk8 _vwz4gktf"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: date
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp12x7"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kQCok))), {
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_ect4bzd7 _k48pbfng _syazcd5j _fz897vkz _1ol91tcg _1wybdlk8 _vwz4gktf"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: location
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $30iuM.BlogNewsCard), {
        ...rest,
        color: "blue",
        label: intl.formatMessage({
            id: "BlogEventCard.eventLabel",
            defaultMessage: "Event"
        }),
        eventMeta: eventMeta
    });
};
const $6d0a169d80108741$var$metaRowStyles = null;
const $6d0a169d80108741$var$metaItemStyles = null;
const $6d0a169d80108741$var$metaTextStyles = null;

});
parcelRegister("kQCok", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a077d34b75af68b5a629fa3ed5b43193>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2d671b5674b6132$var$_react = $f2d671b5674b6132$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f2d671b5674b6132$var$_baseNew = $f2d671b5674b6132$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f2d671b5674b6132$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2d671b5674b6132$var$LocationIcon = (props)=>/*#__PURE__*/ $f2d671b5674b6132$var$_react.default.createElement($f2d671b5674b6132$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$f2d671b5674b6132$var$LocationIcon.displayName = 'LocationIcon';
var $f2d671b5674b6132$var$_default = module.exports.default = $f2d671b5674b6132$var$LocationIcon;

});

parcelRegister("30iuM", function(module, exports) {
$parcel$export(module.exports, "BlogNewsCard", function () { return $42a200ec897943d3$export$54efd7df5b33350e; });
/* blog-news-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $jE3Ci = parcelRequire("jE3Ci");
const $42a200ec897943d3$export$54efd7df5b33350e = (props)=>{
    const { color: color, label: label, title: title, link: link, image: image, eventMeta: eventMeta, motionConfig: motionConfig } = props;
    const bgColor = $42a200ec897943d3$var$colorToToken[color];
    const ariaLabel = `${link.text}: ${title}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkovwyg _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1kw7 _1o9zidpf _kqswh2mm _14b5uuw1 _glte122r _6ru514gx _1bsb1178 _4t3i1ns9 _1pa0120f _sxoihppo _1cc51kli _13g2hppo _nrxub3bt _1m1hstnw _7bwcidpf _m6k41e03 _t9ecy7a9 _dk9v15m1 _2miggktf",
            motionConfig?.transformForward && "_t9ecg30n _dk9vwey4"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_lzpz63": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease40-out")),
            "--_1oyjq9z": (0, $6ZVlx.default)(motionConfig?.transformForward),
            "--_1vdjstz": (0, $6ZVlx.default)(motionConfig?.transformBackward)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq _kqswh2mm _179v1osq _14j11ekt _n2qi1dfr _ym5m1ule _126412vt _aetrb3bt _1hfk1kw7 _18postnw _1gufidpf _13w1idpf _1qdgutpp _clh3xjh3 _1bqqidpf _qc5o12vt",
                    "blog-news-card-media"
                ]),
                style: {
                    backgroundColor: bgColor,
                    "--_od2r4w": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.delay.250ms")),
                    "--_1gcs969": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease60-in"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: image.src,
                    alt: image.alt,
                    className: "blog-news-card-image"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpv47k _1yt4l4ej _6yttv47k _1yag1ejb _kz8fxy5q _p03c121t _oxk4121t _123p121t _1cay121t"
                ]),
                style: {
                    backgroundColor: bgColor,
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                        appearance: $42a200ec897943d3$var$colorToLozenge[color],
                        text: label
                    }),
                    eventMeta,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ud3ocd5j",
                            "card-title-sm"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        type: "primary",
                        bgColor: "bgBlackBlue",
                        href: link.href,
                        text: link.text,
                        "aria-label": ariaLabel,
                        ariaLabel: ariaLabel,
                        className: "blog-news-card-link",
                        dataEventProps: link.dataEventProps
                    })
                ]
            })
        ]
    });
};
const $42a200ec897943d3$var$colorToToken = {
    purple: (0, $kbpa7.wacToken)("color.extended.purple800"),
    green: (0, $kbpa7.wacToken)("color.extended.lime800"),
    orange: (0, $kbpa7.wacToken)("color.extended.orange700"),
    blue: (0, $kbpa7.wacToken)("color.extended.blue800")
};
const $42a200ec897943d3$var$colorToLozenge = {
    purple: "purple",
    green: "lime",
    orange: "saffron",
    blue: "blue"
};
const $42a200ec897943d3$var$cardStyles = null;
const $42a200ec897943d3$var$imageWrapperStyles = null;
const $42a200ec897943d3$var$contentStyles = null;
const $42a200ec897943d3$var$titleStyles = null;

});


parcelRegister("kDYqJ", function(module, exports) {
$parcel$export(module.exports, "GalleryContainer", function () { return $a4e19702d625b9e1$export$2a3350e530f2dd7b; });
/* gallery-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $d4i8K = parcelRequire("d4i8K");

var $bwWCK = parcelRequire("bwWCK");

var $kbpa7 = parcelRequire("kbpa7");

var $6C7e6 = parcelRequire("6C7e6");
// All CSS Custom Properties prefixed --gc-scroll are to power scroll driven animations on sub elements
// Additional necessary @property rules appear in root index.css file
// Based on: https://www.bram.us/2023/10/23/css-scroll-detection/
const $a4e19702d625b9e1$var$scrollAnimations = null;
const $a4e19702d625b9e1$var$galleryStyles = null;
const $a4e19702d625b9e1$var$scrollableStyles = null;
const $a4e19702d625b9e1$var$scrollableAnimation = null;
// Applied when all content fits within the viewport — centers the inner row and removes bleed/scroll behaviour
const $a4e19702d625b9e1$var$scrollableCenteredStyles = null;
const $a4e19702d625b9e1$var$innerStyles = null;
const $a4e19702d625b9e1$var$entryFrames = null;
const $a4e19702d625b9e1$var$entrySetup = null;
const $a4e19702d625b9e1$var$entryAnimation = null;
const $a4e19702d625b9e1$var$controlsStyles = null;
const $a4e19702d625b9e1$var$controlsHiddenStyles = null;
const $a4e19702d625b9e1$var$SCROLL_BUFFER = 40;
const $a4e19702d625b9e1$export$2a3350e530f2dd7b = ({ isMotionAvailable: isMotionAvailable, motionDelay: motionDelay, gap: gap, showEntry: showEntry = true, children: children })=>{
    const scrollRef = (0, $1oC0p.useRef)(null);
    const innerRef = (0, $1oC0p.useRef)(null);
    // True when the inner content row fits entirely within the scroll container's visible width
    const [isFitting, setIsFitting] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const scrollEl = scrollRef.current;
        const innerEl = innerRef.current;
        if (!scrollEl || !innerEl) return;
        const observer = new ResizeObserver(()=>{
            // clientWidth = visible width of the scroll container (excludes scrollbar)
            // scrollWidth of inner = natural width of all content
            setIsFitting(innerEl.scrollWidth <= scrollEl.clientWidth - (0, $6C7e6.WCL_GRID_PADDING_SM) * 2);
        });
        observer.observe(scrollEl);
        observer.observe(innerEl);
        return ()=>observer.disconnect();
    }, []);
    const { ref: firstItemRef, inView: isStartVisible } = (0, $jKShK.useInView)({
        root: scrollRef?.current,
        threshold: 1
    });
    const { ref: lastItemRef, inView: isEndVisible } = (0, $jKShK.useInView)({
        root: scrollRef?.current,
        threshold: 1
    });
    const handleChange = (0, $1oC0p.useCallback)((direction)=>{
        const el = scrollRef.current;
        if (!el) return;
        const pageAmount = Math.min((0, $6C7e6.WCL_GRID_MAX_WIDTH), el.clientWidth);
        el.scrollTo({
            top: 0,
            left: el.scrollLeft + (pageAmount - $a4e19702d625b9e1$var$SCROLL_BUFFER) * direction,
            behavior: (0, $d4i8K.isReducedMotion)() ? "auto" : "smooth"
        });
    }, []);
    // Entry animation trigger
    const { ref: containerRef, inView: isGalleryInView } = (0, $jKShK.useInView)({
        threshold: 0.25,
        triggerOnce: true
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvrh9n0 _zulpxy5q _pdlm1jfw",
            "gallery-container"
        ]),
        style: gap ? {
            "--gc-gap-below-md": `${gap.belowMd}`,
            "--gc-gap-above-md": `${gap.aboveMd}`
        } : undefined,
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: scrollRef,
                className: (0, $2jatx.default)([
                    "_1bsb1osq _18m915vq _1reo1wug _kpfhglyw _1q511ejb _1dm8q5uf _rjfvx6dd _18zr28yr _14hb28yr _1iuf1vi7 _9yq41wqb _769mosjt _o36flmuv",
                    isMotionAvailable && "",
                    isMotionAvailable && "_1croaodx _1e0rp3kn _dqw81hrf _nzidwgdq _jg2w1f51",
                    isFitting && "_1e0c1txw _1bah1h6o _18zridpf _14hbidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    ref: innerRef,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _4cvrh9n0 _1bsb1ris _8hxmvhui _zulpuls2 _n1xi2el6 _co9xv2br _6jyt1h6o _tv8cbags _s9z0bags _v564yks3 _1mz7grv1 _1f2l10dv _extx102y",
                        motionDelay && "_1oecnvsi",
                        showEntry && "",
                        showEntry && "_1j84z12g _olpvkb7n _n2e2ilt9 _13ngw1p3 _1m70hppo _14ht1mi5 _1bn0eoah _1h13trqk",
                        showEntry && isGalleryInView && "_1h13o91m"
                    ]),
                    style: {
                        "--_13opc34": (0, $6ZVlx.default)(motionDelay),
                        "--_lzpz63": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease40-out"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": "true",
                            ref: firstItemRef
                        }),
                        children,
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": "true",
                            ref: lastItemRef
                        })
                    ]
                })
            }),
            !isFitting && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                horizontalAlignment: "end",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_v56415ls",
                        isStartVisible && isEndVisible && "_tzy4idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bwWCK.GalleryControls), {
                        isFirstItemVisible: isStartVisible,
                        isLastItemVisible: isEndVisible,
                        onPrevious: ()=>handleChange(-1),
                        onNext: ()=>handleChange(1),
                        size: "large"
                    })
                })
            })
        ]
    });
};

});
parcelRegister("bwWCK", function(module, exports) {
$parcel$export(module.exports, "GalleryControls", function () { return $76423b87eeed5131$export$7a451794fcccf70c; });
/* gallery-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");
const $76423b87eeed5131$var$arrowCss = null;
const $76423b87eeed5131$var$containerCss = null;
const $76423b87eeed5131$var$buttonBaseCss = null;
const $76423b87eeed5131$var$buttonLargeCss = null;
const $76423b87eeed5131$var$counterCss = null;
const $76423b87eeed5131$export$7a451794fcccf70c = ({ showCounter: showCounter = false, currentCount: currentCount, totalCount: totalCount, onPrevious: onPrevious, onNext: onNext, isFirstItemVisible: isFirstItemVisible, isLastItemVisible: isLastItemVisible, size: size })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const fireGalleryControlClicked = (0, $1oC0p.useCallback)((direction)=>{
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "galleryControlButton",
            eventType: "ui",
            eventComponent: "button",
            source: "gallery-controls",
            attributes: {
                direction: direction
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handlePreviousClick = (0, $1oC0p.useCallback)(()=>{
        fireGalleryControlClicked("previous");
        onPrevious();
    }, [
        fireGalleryControlClicked,
        onPrevious
    ]);
    const handleNextClick = (0, $1oC0p.useCallback)(()=>{
        fireGalleryControlClicked("next");
        onNext();
    }, [
        fireGalleryControlClicked,
        onNext
    ]);
    const isLarge = size === "large";
    const counterTypographyClass = size === "small" ? "body-sm" : "body-md";
    const isAtFirstItem = currentCount !== undefined && currentCount < 2;
    const isAtLastItem = totalCount !== undefined && currentCount !== undefined && currentCount >= totalCount;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "group",
        "aria-label": intl.formatMessage({
            id: "gallery-controls.group-label",
            defaultMessage: "Gallery navigation"
        }),
        className: (0, $2jatx.default)([
            "_1e0c116y _2lx2vrvc _4cvr1h6o _zulpu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handlePreviousClick,
                disabled: isFirstItemVisible || isAtFirstItem,
                "aria-label": intl.formatMessage({
                    id: "gallery-controls.previous",
                    defaultMessage: "Previous slide"
                }),
                "data-testid": "gallery-controls-previous",
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _19itglyw _2rko1osq _80omtlke _1o9zidpf _2lx21bp4 _bfhk1hlo _syazcd5j _tzy4kb7n _1bsb1ylp _4t3i1ylp _ca0qw1gv _u5f319bv _n3tdw1gv _19bv19bv _irr318q9 _1di618q9 _1q8wqjb0 _cun9r2ho _1j55clii _j5dh73ad _1ygb7g83 _1ah3yh40",
                    isLarge && "_glte1wqb _165t1wqb _oqic13pm _1rmjo7ao _cjbt13pm _pnmbo7ao"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_nmjf06": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.navy"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    viewBox: "0 0 29 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": "true",
                    style: {
                        transform: "scaleX(-1)"
                    },
                    className: (0, $2jatx.default)([
                        "_1o9zidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.5361 19.1287C19.6575 20.0074 18.2322 20.0074 17.3535 19.1287C16.4748 18.25 16.4748 16.8248 17.3535 15.9461L21.248 12.0525L2.25 12.0525C1.00754 12.0523 0 11.045 0 9.80254C0.000234604 8.56023 1.00769 7.55276 2.25 7.55254L21.0654 7.55254L17.3535 3.84063C16.475 2.96202 16.4751 1.53765 17.3535 0.658987C18.2322 -0.219692 19.6575 -0.219692 20.5361 0.658987L27.8291 7.95293C28.4154 8.35896 28.8006 9.03537 28.8008 9.80254C28.8008 10.2822 28.6493 10.7265 28.3936 11.0916C28.2867 11.3125 28.1433 11.5206 27.96 11.7039L20.5361 19.1287Z",
                        fill: "currentColor"
                    })
                })
            }),
            showCounter && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1ul91ylp _y3gn1h6o _uiztglyw",
                    counterTypographyClass
                ]),
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                "data-testid": "gallery-controls-counter",
                "aria-label": intl.formatMessage({
                    id: "gallery-controls.counter",
                    defaultMessage: "{current} of {total} slide"
                }, {
                    current: currentCount,
                    total: totalCount
                }),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    "aria-hidden": "true",
                    children: [
                        currentCount,
                        "/",
                        totalCount
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleNextClick,
                disabled: isLastItemVisible || isAtLastItem,
                "aria-label": intl.formatMessage({
                    id: "gallery-controls.next",
                    defaultMessage: "Next slide"
                }),
                "data-testid": "gallery-controls-next",
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _19itglyw _2rko1osq _80omtlke _1o9zidpf _2lx21bp4 _bfhk1hlo _syazcd5j _tzy4kb7n _1bsb1ylp _4t3i1ylp _ca0qw1gv _u5f319bv _n3tdw1gv _19bv19bv _irr318q9 _1di618q9 _1q8wqjb0 _cun9r2ho _1j55clii _j5dh73ad _1ygb7g83 _1ah3yh40",
                    isLarge && "_glte1wqb _165t1wqb _oqic13pm _1rmjo7ao _cjbt13pm _pnmbo7ao"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_nmjf06": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.navy"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    viewBox: "0 0 29 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    "aria-hidden": "true",
                    className: (0, $2jatx.default)([
                        "_1o9zidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.5361 19.1287C19.6575 20.0074 18.2322 20.0074 17.3535 19.1287C16.4748 18.25 16.4748 16.8248 17.3535 15.9461L21.248 12.0525L2.25 12.0525C1.00754 12.0523 0 11.045 0 9.80254C0.000234604 8.56023 1.00769 7.55276 2.25 7.55254L21.0654 7.55254L17.3535 3.84063C16.475 2.96202 16.4751 1.53765 17.3535 0.658987C18.2322 -0.219692 19.6575 -0.219692 20.5361 0.658987L27.8291 7.95293C28.4154 8.35896 28.8006 9.03537 28.8008 9.80254C28.8008 10.2822 28.6493 10.7265 28.3936 11.0916C28.2867 11.3125 28.1433 11.5206 27.96 11.7039L20.5361 19.1287Z",
                        fill: "currentColor"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("6C7e6", function(module, exports) {
$parcel$export(module.exports, "WCL_GRID_PADDING_SM", function () { return $81b780189e42eff8$export$b6a202009036377d; });
$parcel$export(module.exports, "WCL_GRID_MAX_WIDTH", function () { return $81b780189e42eff8$export$cdaac998f92baf77; });
//exporting as individual constants to enable higher compatibility with Compiled.css
const $81b780189e42eff8$export$b6a202009036377d = 32;
const $81b780189e42eff8$export$9b938c72abc88e32 = 60;
const $81b780189e42eff8$export$9068ae6f3b567069 = 136;
const $81b780189e42eff8$export$cdaac998f92baf77 = 1152;
const $81b780189e42eff8$export$44616040654c6b2d = 1648;

});



parcelRegister("8hbU0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7b29fa8567cae1d0$export$2e2bcd8739ae039; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $gA8LO = parcelRequire("gA8LO");

var $64xAu = parcelRequire("64xAu");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $2axoc = parcelRequire("2axoc");

var $6iX8D = parcelRequire("6iX8D");

var $bSVv5 = parcelRequire("bSVv5");

var $2smMv = parcelRequire("2smMv");

var $ksvEJ = parcelRequire("ksvEJ");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");
const $7b29fa8567cae1d0$var$UniformBodyContent = ({ body: body })=>{
    const intl = (0, $8e22h.default)();
    const customComponentRenderer = (node)=>{
        switch(node.data.target.sys.contentType.sys.id){
            case "embeddedVideoAsset":
                {
                    const embeddedVideoAssetData = node.data.target.fields;
                    let embeddedVideoThumbnail = undefined;
                    if (embeddedVideoAssetData.embedAssetOverlayOl) {
                        const orangeLogicThumbnail = embeddedVideoAssetData.embedAssetOverlayOl.fields;
                        const imageUrl = orangeLogicThumbnail.assetJson ? orangeLogicThumbnail.assetJson.imageUrl : orangeLogicThumbnail.assetUrl ?? "";
                        embeddedVideoThumbnail = {
                            src: imageUrl,
                            alt: orangeLogicThumbnail.alt ?? ""
                        };
                    } else if (embeddedVideoAssetData.embedAssetOverlay) embeddedVideoThumbnail = {
                        src: embeddedVideoAssetData.embedAssetOverlay.fields.file.url,
                        alt: embeddedVideoAssetData.embedAssetOverlay.fields.description,
                        contentType: embeddedVideoAssetData.embedAssetOverlay.fields.file.contentType
                    };
                    if (!embeddedVideoAssetData.embedded) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
                            embedUrl: embeddedVideoAssetData.embedded,
                            thumbnail: embeddedVideoThumbnail,
                            title: embeddedVideoAssetData.embeddedVideoAssetNameExternal ?? ""
                        })
                    });
                }
            case "proTipComponent":
                {
                    const proTipComponentData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2smMv.Panel), {
                            panelType: "pro-tip",
                            label: proTipComponentData.proTipNameExternal,
                            description: proTipComponentData.proTipRichText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: (0, $gA8LO.documentToHtmlString)(proTipComponentData.proTipRichText)
                                }
                            }) : proTipComponentData.proTipText ?? ""
                        })
                    });
                }
            case "callOutComponent":
                {
                    const callOutComponentData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2smMv.Panel), {
                            panelType: "highlight",
                            label: callOutComponentData.callOutComponentTitleExternal,
                            description: callOutComponentData.callOutText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                text: (0, $gA8LO.documentToHtmlString)(callOutComponentData.callOutText)
                            }) : ""
                        })
                    });
                }
            case "callOut":
                {
                    const callOutData = node.data.target.fields;
                    const imageUrl = callOutData.orangeLogicImage?.fields.assetJson ? callOutData.orangeLogicImage?.fields.assetJson.imageUrl : callOutData.orangeLogicImage?.fields.assetUrl ?? undefined;
                    const sideBySideContentCss = null;
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi",
                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulppxbi"
                        ]),
                        children: [
                            imageUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                src: imageUrl,
                                alt: callOutData.orangeLogicImage?.fields.alt ?? "",
                                style: callOutData.orangeLogicImage?.fields.width ? {
                                    width: callOutData.orangeLogicImage?.fields.width
                                } : undefined
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                                title: callOutData.callOutTitleExternal,
                                text: callOutData.callOutShortDescription ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                    text: (0, $gA8LO.documentToHtmlString)(callOutData.callOutShortDescription)
                                }) : "",
                                callToActionProps: callOutData.callToActionText && callOutData.urlLink ? {
                                    link: {
                                        text: callOutData.callToActionText,
                                        href: callOutData.urlLink
                                    }
                                } : undefined
                            })
                        ]
                    });
                }
            case "beforeYouBeginComponent":
                {
                    const beforeYouBeginData = node.data.target.fields;
                    const beforeYouBeginContainerCss = null;
                    const individualItemContainerCss = null;
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi",
                            "_bfhk150w _1yt4xy5q _zulppxbi _1e0c1txw _2lx21bp4"
                        ]),
                        style: {
                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                        },
                        children: [
                            beforeYouBeginData.time && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: "beforeYouBegin.time",
                                            defaultMessage: "Time"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        children: beforeYouBeginData.time
                                    })
                                ]
                            }),
                            beforeYouBeginData.audience && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: "beforeYouBegin.audience",
                                            defaultMessage: "Audience"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                        text: (0, $gA8LO.documentToHtmlString)(beforeYouBeginData.audience)
                                    })
                                ]
                            }),
                            beforeYouBeginData.prerequisite && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _19wgu2gc _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                        className: "eyebrow-lg",
                                        children: intl.formatMessage({
                                            id: "beforeYouBegin.prerequisite",
                                            defaultMessage: "Prerequisite"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                                        text: (0, $gA8LO.documentToHtmlString)(beforeYouBeginData.prerequisite)
                                    })
                                ]
                            })
                        ]
                    });
                }
            case "orangeLogicAsset":
                {
                    const orangeLogicAssetData = node.data.target.fields;
                    const imageUrl = orangeLogicAssetData.assetJson ? orangeLogicAssetData.assetJson.imageUrl : orangeLogicAssetData.assetUrl ?? undefined;
                    if (imageUrl === undefined) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _1e0c1txw _1bah1h6o",
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: imageUrl,
                            alt: orangeLogicAssetData.alt ?? "",
                            caption: orangeLogicAssetData.caption,
                            style: orangeLogicAssetData.width ? {
                                width: orangeLogicAssetData.width
                            } : undefined
                        })
                    });
                }
            case "callToActionMicrocopy":
                {
                    const callToActionMicrocopyData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            href: callToActionMicrocopyData.ctaUrl,
                            dataEventProps: {
                                "data-product-key": "uniform",
                                "data-event-component": "linkButton",
                                "data-event-container": "bodyContentInline",
                                "data-event": "clicked"
                            },
                            children: callToActionMicrocopyData.ctaButtonText
                        })
                    });
                }
            case "codeBlock":
                {
                    const codeBlockData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                        text: `<pre><code>${codeBlockData.code}</code></pre>`
                    });
                }
            default:
                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
        }
    };
    const renderContentfulRichTextNodes = (nodes)=>{
        return nodes.map((node)=>{
            switch(node.nodeType){
                case "embedded-entry-block":
                    return customComponentRenderer(node);
                case "embedded-asset-block":
                    {
                        const embeddedAssetBlockData = node.data.target;
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: embeddedAssetBlockData.fields.file.url,
                            alt: embeddedAssetBlockData.fields.description,
                            style: $7b29fa8567cae1d0$var$embeddedItemStyles
                        });
                    }
                case "blockquote":
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                        quote: "",
                        quoteRichTextString: $7b29fa8567cae1d0$var$parseRichTextStringForOnlyContentInsideParagraphs((0, $gA8LO.documentToHtmlString)({
                            nodeType: (0, $64xAu.BLOCKS).DOCUMENT,
                            content: node.content,
                            data: {}
                        }))
                    });
                default:
                    {
                        const headingRenderer = (node, next)=>{
                            const headingNumber = node.nodeType.split("-")[1];
                            const marks = node.content?.at(0)?.marks ?? [];
                            marks?.filter((mark)=>mark.type.includes("id:"));
                            const id = marks[0]?.type.replace("id:", "");
                            return `<h${headingNumber}${id ? ` id="${id}"` : ""}>${next(node.content)}</h${headingNumber}>`;
                        };
                        const options = {
                            renderNode: {
                                [(0, $64xAu.BLOCKS).HEADING_2]: headingRenderer,
                                [(0, $64xAu.BLOCKS).HEADING_3]: headingRenderer,
                                [(0, $64xAu.BLOCKS).HEADING_4]: headingRenderer,
                                [(0, $64xAu.BLOCKS).HEADING_5]: headingRenderer,
                                [(0, $64xAu.BLOCKS).HEADING_6]: headingRenderer
                            }
                        };
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                            text: (0, $gA8LO.documentToHtmlString)({
                                nodeType: (0, $64xAu.BLOCKS).DOCUMENT,
                                content: [
                                    $7b29fa8567cae1d0$var$parseRichTextNodesForInlineEntries(node)
                                ],
                                data: {}
                            }, options)
                        });
                    }
            }
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "body-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1srcpxbi _e3fzidpf _1cmiidpf _ynj4idpf _b289idpf"
        ]),
        children: renderContentfulRichTextNodes(body.content)
    });
};
const $7b29fa8567cae1d0$var$embeddedItemStyles = {
    maxWidth: "100%",
    marginBlock: "var(--ds-space-200, 16px)"
};
const $7b29fa8567cae1d0$var$bodyContainerCss = null;
const $7b29fa8567cae1d0$var$parseRichTextStringForOnlyContentInsideParagraphs = (richTextString)=>{
    const paragraphRegex = /<p\b[^>]*>(.*?)<\/p>/gi;
    const matches = Array.from(richTextString.matchAll(paragraphRegex));
    return matches ? matches.map((m)=>m[1]).join() : richTextString;
};
const $7b29fa8567cae1d0$var$parseRichTextNodesForInlineEntries = (node)=>{
    if (node.nodeType.split("-")[0] === "heading" && node.content && node.content.length > 1) {
        // check if anchor exists in heading node
        const anchorIndex = node.content.findIndex((innerNode)=>innerNode.nodeType === (0, $64xAu.INLINES).EMBEDDED_ENTRY && innerNode.data.target?.sys?.contentType.sys.id === "anchorLink");
        if (anchorIndex > 0) {
            const anchorLinkData = node.content.at(anchorIndex)?.data.target?.fields;
            const contentCopy = node.content.slice(); // node.content is uneditable. need to copy to make changes
            const headerTextNode = contentCopy.at(0);
            if (headerTextNode && headerTextNode.marks) {
                // set mark id:<id> on header text node
                const newHeaderTextNode = {
                    ...headerTextNode,
                    marks: [
                        ...headerTextNode.marks,
                        {
                            type: `id:${anchorLinkData.id}`
                        }
                    ]
                };
                contentCopy.splice(anchorIndex, 1);
                return {
                    ...node,
                    content: [
                        newHeaderTextNode,
                        ...contentCopy.slice(1)
                    ]
                };
            }
        }
    }
    return node;
};
var $7b29fa8567cae1d0$export$2e2bcd8739ae039 = $7b29fa8567cae1d0$var$UniformBodyContent;

});
parcelRegister("64xAu", function(module, exports) {
"use strict";
var $46bd2b9c21a7b5bb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $46bd2b9c21a7b5bb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $46bd2b9c21a7b5bb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $46bd2b9c21a7b5bb$var$__createBinding(exports1, m, p);
};
var $46bd2b9c21a7b5bb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $46bd2b9c21a7b5bb$var$__createBinding(result, mod, k);
    }
    $46bd2b9c21a7b5bb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaWithNodeType = module.exports.helpers = module.exports.EMPTY_DOCUMENT = module.exports.MARKS = module.exports.INLINES = module.exports.BLOCKS = void 0;

var $gtF1Z = parcelRequire("gtF1Z");
Object.defineProperty(module.exports, "BLOCKS", {
    enumerable: true,
    get: function() {
        return $gtF1Z.BLOCKS;
    }
});

var $joEAx = parcelRequire("joEAx");
Object.defineProperty(module.exports, "INLINES", {
    enumerable: true,
    get: function() {
        return $joEAx.INLINES;
    }
});

var $KxfKT = parcelRequire("KxfKT");
Object.defineProperty(module.exports, "MARKS", {
    enumerable: true,
    get: function() {
        return $KxfKT.MARKS;
    }
});

$46bd2b9c21a7b5bb$var$__exportStar((parcelRequire("d6bJ5")), module.exports);

$46bd2b9c21a7b5bb$var$__exportStar((parcelRequire("i0KlZ")), module.exports);

$46bd2b9c21a7b5bb$var$__exportStar((parcelRequire("lSrCb")), module.exports);

var $jcvXp = parcelRequire("jcvXp");
Object.defineProperty(module.exports, "EMPTY_DOCUMENT", {
    enumerable: true,
    get: function() {
        return $jcvXp.EMPTY_DOCUMENT;
    }
});

var $46bd2b9c21a7b5bb$var$helpers = $46bd2b9c21a7b5bb$var$__importStar((parcelRequire("lHRA2")));
module.exports.helpers = $46bd2b9c21a7b5bb$var$helpers;

var $gNeDz = parcelRequire("gNeDz");
Object.defineProperty(module.exports, "getSchemaWithNodeType", {
    enumerable: true,
    get: function() {
        return $gNeDz.getSchemaWithNodeType;
    }
});

});
parcelRegister("gtF1Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $bfef2ead0526aeb7$var$BLOCKS;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($bfef2ead0526aeb7$var$BLOCKS || (module.exports.BLOCKS = $bfef2ead0526aeb7$var$BLOCKS = {}));

});

parcelRegister("joEAx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $e1efbe36794f9c51$var$INLINES;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($e1efbe36794f9c51$var$INLINES || (module.exports.INLINES = $e1efbe36794f9c51$var$INLINES = {}));

});

parcelRegister("KxfKT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */ var $08be175e69ccd2d5$var$MARKS;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($08be175e69ccd2d5$var$MARKS || (module.exports.MARKS = $08be175e69ccd2d5$var$MARKS = {}));

});

parcelRegister("d6bJ5", function(module, exports) {
"use strict";
var $9894ee7e238fa515$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9894ee7e238fa515$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1_MARKS = module.exports.V1_NODE_TYPES = module.exports.TEXT_CONTAINERS = module.exports.HEADINGS = module.exports.CONTAINERS = module.exports.VOID_BLOCKS = module.exports.TABLE_BLOCKS = module.exports.LIST_ITEM_BLOCKS = module.exports.TOP_LEVEL_BLOCKS = void 0;

var $gtF1Z = parcelRequire("gtF1Z");

var $joEAx = parcelRequire("joEAx");

var $KxfKT = parcelRequire("KxfKT");
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */ module.exports.TOP_LEVEL_BLOCKS = [
    $gtF1Z.BLOCKS.PARAGRAPH,
    $gtF1Z.BLOCKS.HEADING_1,
    $gtF1Z.BLOCKS.HEADING_2,
    $gtF1Z.BLOCKS.HEADING_3,
    $gtF1Z.BLOCKS.HEADING_4,
    $gtF1Z.BLOCKS.HEADING_5,
    $gtF1Z.BLOCKS.HEADING_6,
    $gtF1Z.BLOCKS.OL_LIST,
    $gtF1Z.BLOCKS.UL_LIST,
    $gtF1Z.BLOCKS.HR,
    $gtF1Z.BLOCKS.QUOTE,
    $gtF1Z.BLOCKS.EMBEDDED_ENTRY,
    $gtF1Z.BLOCKS.EMBEDDED_ASSET,
    $gtF1Z.BLOCKS.EMBEDDED_RESOURCE,
    $gtF1Z.BLOCKS.TABLE
];
/**
 * Array of all allowed block types inside list items
 */ module.exports.LIST_ITEM_BLOCKS = [
    $gtF1Z.BLOCKS.PARAGRAPH,
    $gtF1Z.BLOCKS.HEADING_1,
    $gtF1Z.BLOCKS.HEADING_2,
    $gtF1Z.BLOCKS.HEADING_3,
    $gtF1Z.BLOCKS.HEADING_4,
    $gtF1Z.BLOCKS.HEADING_5,
    $gtF1Z.BLOCKS.HEADING_6,
    $gtF1Z.BLOCKS.OL_LIST,
    $gtF1Z.BLOCKS.UL_LIST,
    $gtF1Z.BLOCKS.HR,
    $gtF1Z.BLOCKS.QUOTE,
    $gtF1Z.BLOCKS.EMBEDDED_ENTRY,
    $gtF1Z.BLOCKS.EMBEDDED_ASSET,
    $gtF1Z.BLOCKS.EMBEDDED_RESOURCE
];
module.exports.TABLE_BLOCKS = [
    $gtF1Z.BLOCKS.TABLE,
    $gtF1Z.BLOCKS.TABLE_ROW,
    $gtF1Z.BLOCKS.TABLE_CELL,
    $gtF1Z.BLOCKS.TABLE_HEADER_CELL
];
/**
 * Array of all void block types
 */ module.exports.VOID_BLOCKS = [
    $gtF1Z.BLOCKS.HR,
    $gtF1Z.BLOCKS.EMBEDDED_ENTRY,
    $gtF1Z.BLOCKS.EMBEDDED_ASSET,
    $gtF1Z.BLOCKS.EMBEDDED_RESOURCE
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */ module.exports.CONTAINERS = ($9894ee7e238fa515$var$_a = {}, $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.OL_LIST] = [
    $gtF1Z.BLOCKS.LIST_ITEM
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.UL_LIST] = [
    $gtF1Z.BLOCKS.LIST_ITEM
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.LIST_ITEM] = module.exports.LIST_ITEM_BLOCKS, $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.QUOTE] = [
    $gtF1Z.BLOCKS.PARAGRAPH
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.TABLE] = [
    $gtF1Z.BLOCKS.TABLE_ROW
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.TABLE_ROW] = [
    $gtF1Z.BLOCKS.TABLE_CELL,
    $gtF1Z.BLOCKS.TABLE_HEADER_CELL
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.TABLE_CELL] = [
    $gtF1Z.BLOCKS.PARAGRAPH,
    $gtF1Z.BLOCKS.UL_LIST,
    $gtF1Z.BLOCKS.OL_LIST
], $9894ee7e238fa515$var$_a[$gtF1Z.BLOCKS.TABLE_HEADER_CELL] = [
    $gtF1Z.BLOCKS.PARAGRAPH
], $9894ee7e238fa515$var$_a);
/**
 * Array of all heading levels
 */ module.exports.HEADINGS = [
    $gtF1Z.BLOCKS.HEADING_1,
    $gtF1Z.BLOCKS.HEADING_2,
    $gtF1Z.BLOCKS.HEADING_3,
    $gtF1Z.BLOCKS.HEADING_4,
    $gtF1Z.BLOCKS.HEADING_5,
    $gtF1Z.BLOCKS.HEADING_6
];
/**
 * Array of all block types that may contain text and inline nodes.
 */ module.exports.TEXT_CONTAINERS = $9894ee7e238fa515$var$__spreadArray([
    $gtF1Z.BLOCKS.PARAGRAPH
], module.exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */ module.exports.V1_NODE_TYPES = [
    $gtF1Z.BLOCKS.DOCUMENT,
    $gtF1Z.BLOCKS.PARAGRAPH,
    $gtF1Z.BLOCKS.HEADING_1,
    $gtF1Z.BLOCKS.HEADING_2,
    $gtF1Z.BLOCKS.HEADING_3,
    $gtF1Z.BLOCKS.HEADING_4,
    $gtF1Z.BLOCKS.HEADING_5,
    $gtF1Z.BLOCKS.HEADING_6,
    $gtF1Z.BLOCKS.OL_LIST,
    $gtF1Z.BLOCKS.UL_LIST,
    $gtF1Z.BLOCKS.LIST_ITEM,
    $gtF1Z.BLOCKS.HR,
    $gtF1Z.BLOCKS.QUOTE,
    $gtF1Z.BLOCKS.EMBEDDED_ENTRY,
    $gtF1Z.BLOCKS.EMBEDDED_ASSET,
    $joEAx.INLINES.HYPERLINK,
    $joEAx.INLINES.ENTRY_HYPERLINK,
    $joEAx.INLINES.ASSET_HYPERLINK,
    $joEAx.INLINES.EMBEDDED_ENTRY,
    'text'
];
/**
 * Marks before `superscript` & `subscript` release.
 */ module.exports.V1_MARKS = [
    $KxfKT.MARKS.BOLD,
    $KxfKT.MARKS.CODE,
    $KxfKT.MARKS.ITALIC,
    $KxfKT.MARKS.UNDERLINE
];

});

parcelRegister("i0KlZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lSrCb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jcvXp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DOCUMENT = void 0;

var $gtF1Z = parcelRequire("gtF1Z");
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ module.exports.EMPTY_DOCUMENT = {
    nodeType: $gtF1Z.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $gtF1Z.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};

});

parcelRegister("lHRA2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInline = $fcd72d09a811ef65$var$isInline;
module.exports.isBlock = $fcd72d09a811ef65$var$isBlock;
module.exports.isText = $fcd72d09a811ef65$var$isText;

var $gtF1Z = parcelRequire("gtF1Z");

var $joEAx = parcelRequire("joEAx");
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $fcd72d09a811ef65$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $fcd72d09a811ef65$var$isInline(node) {
    return $fcd72d09a811ef65$var$hasValue($joEAx.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $fcd72d09a811ef65$var$isBlock(node) {
    return $fcd72d09a811ef65$var$hasValue($gtF1Z.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $fcd72d09a811ef65$var$isText(node) {
    return node.nodeType === 'text';
}

});

parcelRegister("gNeDz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaWithNodeType = $c39c9393711ba206$var$getSchemaWithNodeType;
function $c39c9393711ba206$var$getSchemaWithNodeType(nodeType) {
    try {
        return require("./generated/".concat(nodeType, ".json"));
    } catch (error) {
        throw new Error("Schema for nodeType \"".concat(nodeType, "\" was not found."));
    }
}

});


parcelRegister("2smMv", function(module, exports) {
$parcel$export(module.exports, "Panel", function () { return $98eab9054c032be6$export$2ddb90ad54e5f587; });
/* panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $fyJbN = parcelRequire("fyJbN");

var $kSqS5 = parcelRequire("kSqS5");
const $98eab9054c032be6$export$2ddb90ad54e5f587 = (props)=>{
    const isProTip = props.panelType === "pro-tip";
    const descriptionComponent = typeof props.description === "string" ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        children: props.description
    }) : props.description;
    const panelContainerCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkovwyg _bfhk150w _1yt4vkk0 _1e0c1txw _zulpqpm6 _1gde1bp4 _8164u2gc _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _14x5u2gc _62yh1m3h"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
            "--_zffskx": (0, $6ZVlx.default)(isProTip ? "var(--ds-space-300, 24px)" : "var(--ds-space-400, 32px)"),
            "--_1ormm8b": (0, $6ZVlx.default)(isProTip ? "var(--ds-space-100, 8px)" : "10px")
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: isProTip ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kSqS5.ProTipIcon), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fyJbN.ErrorIcon), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "eyebrow-lg",
                        children: props.label
                    }),
                    descriptionComponent
                ]
            })
        ]
    });
};

});
parcelRegister("fyJbN", function(module, exports) {
$parcel$export(module.exports, "ErrorIcon", function () { return $2a2632c6ae6dea63$export$19bc16ee58e19b3d; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");
const $2a2632c6ae6dea63$export$19bc16ee58e19b3d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.11 7.65833C20.2574 5.51123 23.7394 5.51212 25.8873 7.65833L36.839 18.61C38.8523 20.6236 38.9794 23.8109 37.2177 25.9711L36.839 26.3873L25.8873 37.339C23.7395 39.4865 20.2578 39.4865 18.11 37.339L7.15833 26.3873C5.01212 24.2394 5.01123 20.7574 7.15833 18.61L18.11 7.65833ZM22.0013 27.9987C20.4828 27.9987 19.2517 29.2302 19.2513 30.7487C19.2513 32.2674 20.4826 33.4987 22.0013 33.4987C23.5195 33.4979 24.7513 32.267 24.7513 30.7487C24.751 29.2306 23.5193 27.9994 22.0013 27.9987ZM19.9388 11.4987V25.2487H24.0638V11.4987H19.9388Z",
            fill: (0, $kbpa7.wacToken)("color.neutral.light1000")
        })
    });
};

});

parcelRegister("kSqS5", function(module, exports) {
$parcel$export(module.exports, "ProTipIcon", function () { return $2cc3abe193b9fea5$export$878ebefa84ac806a; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");
const $2cc3abe193b9fea5$export$878ebefa84ac806a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "88",
        height: "88",
        viewBox: "0 0 76 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M60.5935 36.8029C60.9647 34.7229 61.1567 32.5181 61.1567 30.1757C61.1567 27.8333 60.9583 25.5677 60.5807 23.4621C58.3343 10.9373 49.6303 3.21893 37.4287 1.23173C35.3455 0.895727 33.1631 0.719727 30.8943 0.719727C28.6255 0.719727 26.2511 0.905327 24.0879 1.27013C11.8799 3.30853 3.19506 11.0109 0.939063 23.4621C0.558263 25.5645 0.359863 27.8045 0.359863 30.1757C0.359863 32.5469 0.555063 34.7229 0.926263 36.8029C3.16306 49.2413 11.8575 56.9565 24.0847 58.9949C26.2479 59.3565 28.5231 59.5453 30.8911 59.5453C33.2591 59.5453 35.3455 59.3725 37.4255 59.0333C49.6463 57.0493 58.3535 49.3117 60.5871 36.8029H60.5935Z",
                fill: (0, $kbpa7.wacToken)("color.extended.lime600")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.3296 29.9547L64.728 5.58032L73.3808 13.5931L39.3936 42.7675L23.3936 28.0251L31.7136 18.4187L41.3264 29.9579L41.3296 29.9547Z",
                fill: (0, $kbpa7.wacToken)("color.secondary.navy")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M60.5871 23.4621C59.9215 19.7693 58.6959 16.4861 56.9839 13.6509L41.3327 29.9549L31.7199 18.4157L23.3999 28.0221L39.3999 42.7645L60.7503 24.4381C60.7023 24.1085 60.6511 23.7821 60.5935 23.4589L60.5871 23.4621Z",
                fill: (0, $kbpa7.wacToken)("color.secondary.navy")
            })
        ]
    });
};

});



parcelRegister("eWth0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("aghrj")).default; });

var $aghrj = parcelRequire("aghrj");

});
parcelRegister("aghrj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4cbd318bfd44317a$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $9Kroa = parcelRequire("9Kroa");
const $4cbd318bfd44317a$export$d9468344d3651243 = (body)=>{
    if (!body) return {};
    const { story: story, richText: richText, image: image, embeddedVideoLink: embeddedVideoLink, imageCaption: imageCaption } = body;
    const formattedBody = {
        storyText: story?.storyText ?? richText ?? undefined,
        bodyAsset: $4cbd318bfd44317a$var$formatBodyAsset(story?.bodyAsset ?? image),
        embeddedVideoLink: story?.embeddedVideoLink ?? embeddedVideoLink ?? undefined,
        bodyAssetCaption: story?.bodyAssetCaption ?? imageCaption ?? undefined,
        quote: $4cbd318bfd44317a$var$formatQuote(story?.quote)
    };
    // Remove undefined properties
    return Object.fromEntries(Object.entries(formattedBody).filter(([_, value])=>value !== undefined));
};
// eslint-disable-next-line complexity
const $4cbd318bfd44317a$var$formatBodyAsset = (bodyAsset)=>{
    if (!bodyAsset?.fields) return undefined;
    const { fields: fields } = bodyAsset;
    return {
        name: fields.title,
        size: fields.file?.details?.size,
        fileName: fields.file?.fileName ?? null,
        height: fields.file?.details?.image?.height ?? null,
        width: fields.file?.details?.image?.width ?? null,
        url: fields.file?.url,
        description: fields.description ?? null,
        contentType: fields.file?.contentType ?? null
    };
};
const $4cbd318bfd44317a$var$formatQuote = (quote)=>{
    if (!quote?.fields) return undefined;
    const { fields: fields } = quote;
    return {
        quote: fields.advocateQuote,
        authorName: fields.advocateName,
        authorDetails: fields.advocateJobTitle
    };
};
/**
 * @deprecated - Please use UniformBodyContent at /uniform/components/body-content instead
 */ const $4cbd318bfd44317a$var$UniformBodyContent = (props)=>{
    const bodyComponent = (0, $1oC0p.useMemo)(()=>$4cbd318bfd44317a$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Kroa.BodyContent), {
        ...props,
        story: bodyComponent
    });
};
var $4cbd318bfd44317a$export$2e2bcd8739ae039 = $4cbd318bfd44317a$var$UniformBodyContent;

});
parcelRegister("9Kroa", function(module, exports) {
$parcel$export(module.exports, "BodyContent", function () { return $484d9f987682576e$export$36cf6d64005c1ddf; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $gA8LO = parcelRequire("gA8LO");

var $ftgEA = parcelRequire("ftgEA");

var $6iX8D = parcelRequire("6iX8D");

var $ksvEJ = parcelRequire("ksvEJ");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");
function $484d9f987682576e$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $gA8LO.documentToHtmlString)(richText);
}
const $484d9f987682576e$export$36cf6d64005c1ddf = ({ story: story })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "customer-story-article-content",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb"
        ]),
        children: [
            story?.storyText && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_rrz6idpf _1cobidpf _7exw1ejb _1o6v1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                    text: $484d9f987682576e$var$getRichText(story.storyText)
                })
            }),
            story?.quote && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "10",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                    quote: story.quote.quote,
                    authorName: story.quote.authorName,
                    authorDetails: story.quote.authorDetails,
                    alignment: "start",
                    variant: story.quote.heroQuote ? "cutout" : "basic"
                })
            }),
            story?.bodyAsset && story?.embeddedVideoLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
                embedUrl: story.embeddedVideoLink,
                thumbnail: {
                    src: story.bodyAsset.url,
                    alt: story.bodyAsset.description ?? ""
                },
                title: "",
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event": "clicked",
                    "data-event-component": "embeddedVideo",
                    "data-event-container": "bodyContentInline"
                }
            }),
            story?.bodyAsset && !story?.embeddedVideoLink && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                        src: story.bodyAsset.url ?? "",
                        alt: story.bodyAsset.description ?? "",
                        contentType: story.bodyAsset.contentType,
                        baseWidth: 856,
                        className: (0, $2jatx.default)([
                            "_p12f1osq _1bsbmebt _195g1wug"
                        ]),
                        style: {
                            "--_1396dc4": (0, $6ZVlx.default)(story.bodyAsset.width ? `${story.bodyAsset.width}px` : "100%")
                        }
                    }),
                    story.bodyAssetCaption && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "fine-print"
                        ]),
                        children: story.bodyAssetCaption
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("6SooZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ab26b742cd3a699c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $lqyi6 = parcelRequire("lqyi6");
const $ab26b742cd3a699c$var$UniformButton = ({ text: text, href: href, size: size, variant: variant, colorAgainst: colorAgainst, mobileSize: mobileSize, tabletSize: tabletSize, desktopSize: desktopSize, xlDesktopSize: xlDesktopSize })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        href: href,
        size: size,
        variant: variant,
        colorAgainst: colorAgainst,
        responsiveSize: mobileSize && tabletSize && desktopSize && xlDesktopSize && {
            mobile: mobileSize,
            tablet: tabletSize,
            desktop: desktopSize,
            xl_desktop: xlDesktopSize
        },
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "button",
            "data-event": "clicked"
        },
        children: text
    });
};
var $ab26b742cd3a699c$export$2e2bcd8739ae039 = $ab26b742cd3a699c$var$UniformButton;

});

parcelRegister("4h1q1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f39a289a0539a8be$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $2Uedv = parcelRequire("2Uedv");

var $lTkkF = parcelRequire("lTkkF");
const $f39a289a0539a8be$var$UniformCallToAction = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Uedv.BottomCallToAction), {
        title: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformRichText: {
                type: "root",
                version: 1,
                children: props.title.root.children?.at(0)?.children
            }
        }),
        emphasisColor: props.emphasisColor,
        body: !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.body) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "body"
        }) : undefined,
        button: props.buttonLabel && props.buttonHref ? {
            buttonHref: props.buttonHref,
            buttonLabel: props.buttonLabel,
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "ctaSection",
                "data-event": "clicked"
            }
        } : undefined
    });
};
var $f39a289a0539a8be$export$2e2bcd8739ae039 = $f39a289a0539a8be$var$UniformCallToAction;

});
parcelRegister("2Uedv", function(module, exports) {
$parcel$export(module.exports, "BottomCallToAction", function () { return $c3e386a025d6cfc5$export$c9eb72e23dbe5cf6; });
/* bottom-call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $c3e386a025d6cfc5$var$containerStyles = null;
const $c3e386a025d6cfc5$var$innerContainerStyles = null;
const $c3e386a025d6cfc5$var$buttonContainerStyles = null;
// Rich-text `p` sits inside TypographyStyles, where refresh adds `p, .body-md` at lg+ with a
// direct font-size that overrides inheritance from `.card-title-sm`. Target paragraphs here so
// copy matches card-title-sm (same tokens as typography-styles `.card-title-sm` base + md).
const $c3e386a025d6cfc5$var$bodyCopyStyles = null;
const $c3e386a025d6cfc5$export$c9eb72e23dbe5cf6 = ({ title: title, emphasisColor: emphasisColor, body: body, button: button })=>{
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `bottom-cta-title-${uniqueId}`;
    const buttonId = `bottom-cta-button-${uniqueId}`;
    const emphasisStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1hlo _1rjcxncg _cg41cd5j _haj1cd5j _811zcd5j _125xcd5j _1afj1h6o _10so1h6o _14iu1h6o _31ku1h6o _1n46idpf _122gidpf _efi8idpf _clfdidpf _if5yidpf _1phwidpf _17o1idpf _11pqidpf _1gnpidpf _1bygidpf _1ql6idpf _q0a5idpf _7e5bidpf _o7a8idpf _5h4jidpf _c3k8idpf"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "8",
            tabletLayout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulputpp _16imxncg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        id: titleId,
                        className: (0, $2jatx.default)([
                            emphasisColor && "_r7o3eibj _cq6tn7od",
                            "h1-lg"
                        ]),
                        style: {
                            "--_1qfmyyb": (0, $6ZVlx.default)(emphasisColor)
                        },
                        children: title
                    }),
                    body ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1csa1pz4 _q7gq1cby _1adi1fw0 _zcqx1k8s _ecfqnl7k _125xcd5j _31ku1h6o _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _p0o31k92 _15tu1slo _cbmh1k92 _17bi1slo _1vdo1fw0 _wphkpxbi",
                            "card-title-sm"
                        ]),
                        style: {
                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: body
                    }) : null,
                    button && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1q51xy5q"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            id: buttonId,
                            href: button.buttonHref,
                            responsiveSize: {
                                mobile: "small",
                                tablet: "small",
                                desktop: "large",
                                xl_desktop: "large"
                            },
                            ariaLabelledby: `${buttonId} ${titleId}`,
                            dataEventProps: button.dataEventProps,
                            children: button.buttonLabel
                        })
                    })
                ]
            })
        })
    });
};

});


parcelRegister("k1kqo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $adfabc9115480b1c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $NtjLk = parcelRequire("NtjLk");

var $lTkkF = parcelRequire("lTkkF");

var $jQ0cd = parcelRequire("jQ0cd");
const $adfabc9115480b1c$var$getBodyText = (props)=>{
    if (!props.body && !props.richText) return undefined;
    if (props.richText) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
        text: props.richText
    });
    return props.body;
};
const $adfabc9115480b1c$var$UniformCard = (props)=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(props.linkUrl?.toString() ?? "");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
        align: props.alignment,
        orientation: props.orientation,
        columns: props.columns,
        background: props.background,
        eyebrow: props.eyebrow ? props.eyebrow : undefined,
        logo: props.logo,
        title: props.title ? props.title : undefined,
        titleAs: props.titleAs,
        body: $adfabc9115480b1c$var$getBodyText(props),
        callToAction: props.linkUrl && props.linkText ? {
            text: props.linkText,
            href: localizedHref,
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "card",
                "data-event": "clicked",
                "data-label": props.dataLabel,
                "data-label-english": props.dataLabelEnglish
            }
        } : undefined,
        image: props.imageUrl ? {
            src: props.imageUrl,
            alt: props.imageAlt ?? ""
        } : undefined,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                paddingIncluded: props.iconPaddingIncluded
            }
        } : undefined,
        spotIllustration: props.spotIllustrationUrl ? {
            src: props.spotIllustrationUrl,
            alt: props.spotIllustrationAlt,
            width: props.spotIllustrationWidth
        } : undefined
    });
};
var $adfabc9115480b1c$export$2e2bcd8739ae039 = $adfabc9115480b1c$var$UniformCard;

});

parcelRegister("jswU3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6d4cfc38fdffaa9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $6jr7X = parcelRequire("6jr7X");

var $kU0PA = parcelRequire("kU0PA");

var $jfojT = parcelRequire("jfojT");
const $f6d4cfc38fdffaa9$var$UniformCollectionPricingHero = (props)=>{
    if (props.collectionType === "teamwork") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jfojT.TeamworkCollectionPricingHero), {});
    if (props.collectionType === "strategy") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kU0PA.StrategyCollectionPricingHero), {});
    if (props.collectionType === "service") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6jr7X.ServiceCollectionPricingHero), {});
    return null;
};
var $f6d4cfc38fdffaa9$export$2e2bcd8739ae039 = $f6d4cfc38fdffaa9$var$UniformCollectionPricingHero;

});
parcelRegister("6jr7X", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionPricingHero", function () { return $17930c441541a572$export$5eff9997197d8e50; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $17930c441541a572$export$5eff9997197d8e50 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        orientation: "vertical",
        collectionImage: {
            height: 48,
            width: 168,
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wq7706lsya8q6fb1sj2k15h48h450ssr.svg",
            alt: "Service Collection"
        },
        products: [
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7jcq40x67167gax15ux7b27r5r575tk5.svg",
                    alt: "Jira Service Management"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/466ke7l5j3i276s3p7k5660c525ru38d.svg",
                    alt: "Customer Service Management"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hgm0up275i80h6m7b5j3f8t68a7fcp4.svg",
                    alt: "Assets"
                }
            },
            {
                name: "Rovo",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6kq772n08c357g2p82f8bnw824do06dn.svg",
                    alt: "Rovo"
                }
            }
        ]
    });
};

});

parcelRegister("kU0PA", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionPricingHero", function () { return $0f9946b2ee41705a$export$4a5cc933f6e8553a; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $0f9946b2ee41705a$export$4a5cc933f6e8553a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg",
            alt: "Strategy Collection"
        },
        products: [
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/hd3m515u7j3s37rldpf0dgeb7m383j4s.svg",
                    alt: "Align"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/241h1u1khig63kccl1fe3hisqom3q007/fl_keep_metadata/Apps-Talent.svg",
                    alt: "Talent"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/24e3l0ul76q4fpa4l2mmc7t00k202322.svg",
                    alt: "Focus"
                }
            }
        ]
    });
};

});


parcelRegister("82Z9J", function(module, exports) {
$parcel$export(module.exports, "UniformColumnLayout", function () { return $3f1a8340323fe0b9$export$23133ddca0202abb; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return $3f1a8340323fe0b9$export$8807233e43f557a9; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");
const $3f1a8340323fe0b9$var$slotWrapper = ({ items: items })=>{
    return items.map((element, index)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            children: element
        }, index);
    });
};
const $3f1a8340323fe0b9$export$23133ddca0202abb = ({ layout: layout = "12", tabletLayout: tabletLayout, mobileLayout: mobileLayout, paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, mobileReverseOrder: mobileReverseOrder })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: layout,
        tabletLayout: tabletLayout,
        mobileLayout: mobileLayout,
        paddingTopv2: paddingTopv2,
        paddingBottomv2: paddingBottomv2,
        verticalAlignment: verticalAlignment,
        renderAsList: renderAsList,
        mobileReverseOrder: mobileReverseOrder,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $3f1a8340323fe0b9$var$slotWrapper : undefined
        })
    });
};
const $3f1a8340323fe0b9$export$8807233e43f557a9 = ({ layout: layout = "12", tabletLayout: tabletLayout, mobileLayout: mobileLayout, paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, mobileReverseOrder: mobileReverseOrder })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.SubColumnLayout), {
        layout: layout,
        tabletLayout: tabletLayout,
        mobileLayout: mobileLayout,
        paddingTopv2: paddingTopv2,
        paddingBottomv2: paddingBottomv2,
        verticalAlignment: verticalAlignment,
        renderAsList: renderAsList,
        mobileReverseOrder: mobileReverseOrder,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $3f1a8340323fe0b9$var$slotWrapper : undefined
        })
    });
}; // Both components are exported as named exports above

});

parcelRegister("9eDC1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f9940d7299757e5$export$2e2bcd8739ae039; });
/* confluence-animated-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $01zo5 = parcelRequire("01zo5");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $4f9940d7299757e5$var$backgroundColorMap = {
    blue100: (0, $kbpa7.wacToken)("color.extended.blue100"),
    primaryBlack: (0, $kbpa7.wacToken)("color.primary.black"),
    light100: (0, $kbpa7.wacToken)("color.neutral.light100")
};
const $4f9940d7299757e5$var$sectionCss = null;
const $4f9940d7299757e5$var$cardContainerCss = null;
const $4f9940d7299757e5$var$cardCss = null;
const $4f9940d7299757e5$var$cardTextCss = null;
const $4f9940d7299757e5$var$cardHeadingCss = null;
const $4f9940d7299757e5$var$cardBodyTextCss = null;
const $4f9940d7299757e5$var$controlButtonStyles = null;
const $4f9940d7299757e5$var$videoContainerCss = null;
const $4f9940d7299757e5$export$235b37640a653467 = ({ title: title, bodytext: bodytext, image: image, altText: altText })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    const [isPlaying, setPlaying] = (0, $1oC0p.useState)(false);
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const prefersReducedMotion = typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
    const togglePlay = ()=>{
        const label = isPlaying ? "pause" : "play";
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "playPause",
            source: "confluenceAnimatedHero",
            attributes: {
                label: label
            }
        }).fire();
        if (videoRef.current) {
            if (isPlaying) videoRef.current.pause();
            else videoRef.current.play().catch(()=>{
            // Ignore error likely due to autoplay restrictions or browser power saving
            });
        }
    };
    const handleVideoPlay = ()=>setPlaying(true);
    const handleVideoPause = ()=>setPlaying(false);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz _kqswh2mm _1k9hgrho _1mj31wqb _162p1nty _1xjr1nty _1scc1gha _1nr41gha _1axucs5v _15z31nut _hauj1nut _188c150m _y5pt150m _11za1o02 _1rgq1o02 _tnzz120m _s118120m _ikf21klr _18zx1klr _zcbv1osq _mezj1osq _12l01wug _bna71wug _eq9p15vq _pzs515vq _175j15vq _dknm15vq _1gbl1wug _1cr61wug _qpgx1wug _1hlx1wug _1d2pidpf _1874idpf _s93b1wug _10ew1wug _1th61xym _k9x81xym _1wi11m52 _1biu1m52 _ldg0vwyg _dzwgvwyg _8wcmcd5j _d3lpcd5j _1dhb130s _t1ov130s _1sdaagmp _ktt3agmp",
            "single-hero-card"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "text-container",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_gxfkidpf _tfg1idpf _16yqidpf _15zyidpf _14dwidpf _1u6jidpf _1ikgidpf _1p3yidpf _1niwidpf _a15ridpf _12k0idpf _1fx6idpf _104aidpf _10pqidpf _5ybeidpf _1avnidpf _1cmpidpf _174lidpf _tlu6idpf _kopkidpf _4s33idpf _lychidpf _zzhoidpf _x9vnidpf _65gh10nf _18ko10nf _17ie10nf _1dlt10nf _1t9o10nf _1x5u10nf _1g4p1ejb _1l3z1ejb _1qkw1ejb _8znu1ejb _vh191ejb _ret01ejb _kgcl1nn1 _1m1k1nn1 _b08d1nn1 _1bau1nn1 _zmdp1nn1 _1r881nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-heading"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                            node: title["root"] || title
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1axaidpf _420lidpf _195sidpf _thjjidpf _jhbppxbi _1yq31k8s _zcsk1nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-body"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                            node: bodytext["root"] || bodytext
                        })
                    })
                ]
            }),
            image?.includes(".mp4") ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _npsn1dfr _1y2k1osq _z18o1osq",
                    "imagery video video-container"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        ref: videoRef,
                        src: image,
                        autoPlay: !prefersReducedMotion,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        onPlay: handleVideoPlay,
                        onPause: handleVideoPause,
                        onLoadedMetadata: ()=>{
                            if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{
                            // Ignore error likely due to autoplay restrictions or browser power saving
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        className: (0, $2jatx.default)([
                            "_80omtlke _tzy41ou4 _bfhk1j28 _syazcd5j _19it1axk _2rko17td _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7co1jfw _16l4kb7n _w8l5dlk8",
                            "control-button"
                        ]),
                        onClick: togglePlay,
                        "aria-label": intl.formatMessage(isPlaying ? {
                            id: "uniform-video.pause",
                            defaultMessage: "Pause"
                        } : {
                            id: "uniform-video.play",
                            defaultMessage: "Play"
                        }),
                        "aria-pressed": isPlaying,
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill"))
                        },
                        children: isPlaying ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                            label: intl.formatMessage({
                                id: "uniform-video.pause",
                                defaultMessage: "Pause"
                            })
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                            label: intl.formatMessage({
                                id: "uniform-video.play",
                                defaultMessage: "Play"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: image,
                alt: altText ?? ""
            })
        ]
    });
};
const $4f9940d7299757e5$var$UniformConfluenceAnimatedHero = ({ confluenceHeroCards: confluenceHeroCards, imagesWidth: imagesWidth, imagesHeight: imagesHeight, flattenData: flattenData = true, backgroundColor: backgroundColor = "blue100" })=>{
    if (flattenData) confluenceHeroCards = (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    confluenceHeroCards);
    const [inview, setInview] = (0, $1oC0p.useState)(false);
    const [hasScrolled, setHasScrolled] = (0, $1oC0p.useState)(false);
    const [moveUpValue, setMoveUpValue] = (0, $1oC0p.useState)(120);
    const containerRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY <= 50) {
                setInview(false);
                setHasScrolled(false);
                return;
            } else setHasScrolled(true);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasScrolled || !containerRef.current) return;
        const io = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) setInview(true);
            });
        }, {
            threshold: 0.5
        });
        io.observe(containerRef.current);
        return ()=>{
            io.disconnect();
        };
    }, [
        hasScrolled
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const updateMoveUpValue = ()=>{
            if (!containerRef.current) return;
            const textContainers = containerRef.current.querySelectorAll(".text-container");
            let maxHeight = 0;
            textContainers.forEach((container)=>{
                const height = container.offsetHeight;
                maxHeight = Math.max(maxHeight, height);
            });
            const calculatedMoveUp = maxHeight + 16;
            setMoveUpValue(calculatedMoveUp);
        };
        const timeoutId = setTimeout(updateMoveUpValue, 100);
        document?.fonts?.ready?.then(updateMoveUpValue);
        window.addEventListener("resize", updateMoveUpValue);
        return ()=>{
            clearTimeout(timeoutId);
            window.removeEventListener("resize", updateMoveUpValue);
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_v5641r9r _lwq31qpa _ia4wwomy _mbuvwomy",
            "scroll-hero" + (inview ? " inview" : " outview")
        ]),
        style: {
            "--moveup": `-${moveUpValue}px`,
            "--imagesWidth": imagesWidth,
            "--imagesHeight": imagesHeight,
            "background": $4f9940d7299757e5$var$backgroundColorMap[backgroundColor]
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: containerRef,
            className: (0, $2jatx.default)([
                "_1e0c11p5 _1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _zulp14hz _1dsl1tcg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx _1vsw1vi7 _1j8b16hb _1wafpxbi _1bah1h6o _1ojfg8ja _3qvcg8ja _1utg36zz _1fjs36zz _12n71qqw _xlt1xncg _131yxncg _bkwyglyw _xon5glyw _128dglyw _q8ukglyw _4y3qglyw _uzo21qqw",
                inview ? "inview" : "outview"
            ]),
            style: {
                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
            },
            children: confluenceHeroCards.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($4f9940d7299757e5$export$235b37640a653467, {
                    title: card.cardTitle,
                    bodytext: card.cardDescription,
                    image: card.cardImageOrVideo,
                    altText: card.cardImageAlt ?? ""
                }, index))
        })
    });
};
var $4f9940d7299757e5$export$2e2bcd8739ae039 = $4f9940d7299757e5$var$UniformConfluenceAnimatedHero;

});

parcelRegister("hStuA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70c5c0076527144c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $fsuqf = parcelRequire("fsuqf");
const $70c5c0076527144c$var$UniformConnector = ({ title: title, text: text, linkText: linkText, linkHref: linkHref, customerQuotes: customerQuotes, mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos, flattenData: flattenData = true })=>{
    if (flattenData) {
        customerQuotes = (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        customerQuotes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mobileLogos = (0, $f2QWG.flattenValues)(mobileLogos);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tabletLogos = (0, $f2QWG.flattenValues)(tabletLogos);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        desktopLogos = (0, $f2QWG.flattenValues)(desktopLogos);
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fsuqf.Connector), {
        title: title,
        text: text,
        linkText: linkText,
        linkHref: linkHref,
        linkDataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "connector"
        },
        customerQuotes: customerQuotes,
        mobileLogos: mobileLogos,
        tabletLogos: tabletLogos,
        desktopLogos: desktopLogos
    });
};
var $70c5c0076527144c$export$2e2bcd8739ae039 = $70c5c0076527144c$var$UniformConnector;

});
parcelRegister("fsuqf", function(module, exports) {
$parcel$export(module.exports, "Connector", function () { return $0d5223a79dc9016a$export$b2278035370d6017; });
/* connector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");

var $kdSM2 = parcelRequire("kdSM2");

var $jiDxV = parcelRequire("jiDxV");
const $0d5223a79dc9016a$export$b2278035370d6017 = ({ title: title, text: text, linkText: linkText, linkHref: linkHref, linkDataEventProps: linkDataEventProps, customerQuotes: customerQuotes, mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `connector-title-${uniqueId}`;
    const buttonId = `connector-button-${uniqueId}`;
    const linkId = `connector-link-${uniqueId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1rjc1epz _bfhk1hlo _1e0c1txw _2lx21bp4 _zulpoahv",
            isWacRefresh && "_bfhk1rga _1rjc16xz _zulp16xz _1t2pys9h _2osnys9h _133i1wqb _81641wqb"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                layout: isWacRefresh ? "6-6" : "5-7",
                tabletLayout: isWacRefresh ? "12" : undefined,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_cg41cd5j _125xcd5j _xsmr1h6o",
                            isWacRefresh && "_cg411hlo _125x1hlo _xsmr1e5h",
                            "contentBlock"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                id: titleId,
                                className: (0, $2jatx.default)([
                                    "_1pfhxy5q _6rthu2gc _476didpf",
                                    isWacRefresh && "_1pfhidpf _6rthidpf"
                                ]),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mouidpf",
                                    isWacRefresh && "_1pfhutpp",
                                    isWacRefresh ? "body-lg" : undefined
                                ]),
                                children: text
                            }),
                            linkText && linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh1ejb _6rthxy5q _srwz1ejb"
                                ]),
                                children: isWacRefresh ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    id: buttonId,
                                    href: linkHref,
                                    variant: "secondary",
                                    colorAgainst: "white",
                                    responsiveSize: {
                                        mobile: "small",
                                        tablet: "small",
                                        desktop: "large",
                                        xl_desktop: "large"
                                    },
                                    ariaLabelledby: `${buttonId} ${titleId}`,
                                    dataEventProps: linkDataEventProps,
                                    children: linkText
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    id: linkId,
                                    "aria-label": linkText,
                                    ariaLabelledby: `${linkId} ${titleId}`,
                                    text: linkText,
                                    href: linkHref,
                                    type: "primary",
                                    bgColor: "bgBlackBlue",
                                    ...linkDataEventProps && {
                                        dataEventProps: linkDataEventProps
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kdSM2.CustomerQuoteCarousel), {
                        customerQuotes: customerQuotes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jiDxV.LogosMarquee), {
                mobileLogos: mobileLogos,
                tabletLogos: tabletLogos,
                desktopLogos: desktopLogos
            })
        ]
    });
};
var $0d5223a79dc9016a$export$2e2bcd8739ae039 = $0d5223a79dc9016a$export$b2278035370d6017;
const $0d5223a79dc9016a$var$containerCss = null;
const $0d5223a79dc9016a$var$refreshContainerCss = null;
const $0d5223a79dc9016a$var$lightTextCss = null;
const $0d5223a79dc9016a$var$refreshTextBlockCss = null;
const $0d5223a79dc9016a$var$titleCss = null;
const $0d5223a79dc9016a$var$refreshTitleCss = null;
const $0d5223a79dc9016a$var$textCss = null;
const $0d5223a79dc9016a$var$refreshBodyTextCss = null;
const $0d5223a79dc9016a$var$linkCss = null;

});
parcelRegister("kdSM2", function(module, exports) {
$parcel$export(module.exports, "CustomerQuoteCarousel", function () { return $6e4e4b8ac7dd4aed$export$abab76d12bbd8406; });
/* customer-quote-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7IesZ = parcelRequire("7IesZ");

var $9BG80 = parcelRequire("9BG80");

var $bwWCK = parcelRequire("bwWCK");

var $bSVv5 = parcelRequire("bSVv5");

var $ksvEJ = parcelRequire("ksvEJ");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");
const $6e4e4b8ac7dd4aed$var$messages = {
    previousSlide: {
        id: "customer-quote-carousel.previous-slide",
        defaultMessage: "Previous slide"
    },
    nextSlide: {
        id: "customer-quote-carousel.next-slide",
        defaultMessage: "Next slide"
    }
};
const $6e4e4b8ac7dd4aed$export$abab76d12bbd8406 = ({ customerQuotes: customerQuotes })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const [activeQuoteIndex, setActiveQuoteIndex] = (0, $1oC0p.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const prevSlide = (0, $1oC0p.useCallback)(()=>{
        if (activeQuoteIndex > 0) {
            setActiveQuoteIndex(activeQuoteIndex - 1);
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "previousSlide",
                source: "customerQuoteCarousel",
                attributes: {
                    label: "previous slide"
                }
            }).fire();
        }
    }, [
        activeQuoteIndex,
        createAnalyticsEvent
    ]);
    const nextSlide = (0, $1oC0p.useCallback)(()=>{
        if (activeQuoteIndex < customerQuotes.length - 1) {
            setActiveQuoteIndex(activeQuoteIndex + 1);
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "nextSlide",
                source: "customerQuoteCarousel",
                attributes: {
                    label: "next slide"
                }
            }).fire();
        }
    }, [
        activeQuoteIndex,
        customerQuotes.length,
        createAnalyticsEvent
    ]);
    const intl = (0, $8e22h.default)();
    const logoSection = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: customerQuotes.map(({ companyLogo: companyLogo }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": index !== activeQuoteIndex,
                className: (0, $2jatx.default)([
                    "_nd5lgbua _3um015tv _1bsb11ux _4t3i1ylp"
                ]),
                style: {
                    "--_neqv2r": (0, $6ZVlx.default)(index === activeQuoteIndex ? "visible" : "hidden")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: companyLogo[0]?.src,
                    alt: companyLogo[0]?.alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        objectPosition: "left"
                    }
                })
            }, index))
    });
    const quoteSection = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9",
            "_tfwpidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
            quote: customerQuotes[activeQuoteIndex]?.quote,
            authorName: customerQuotes[activeQuoteIndex]?.advocateName,
            authorDetails: customerQuotes[activeQuoteIndex]?.advocateJobTitle
        })
    });
    const legacyNavigationButtons = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: prevSlide,
                disabled: activeQuoteIndex === 0,
                "aria-label": intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.previousSlide),
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                ]),
                style: {
                    "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000")),
                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                    ]),
                    style: {
                        "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                        "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                        label: intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.previousSlide)
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_cg4111ib _125x11ib _1tjq11ib",
                    "_1bsb183y _1mouidpf"
                ]),
                style: {
                    "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                },
                children: `${activeQuoteIndex + 1}/${customerQuotes.length}`
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: nextSlide,
                disabled: activeQuoteIndex === customerQuotes.length - 1,
                "aria-label": intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.nextSlide),
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                ]),
                style: {
                    "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000")),
                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                    ]),
                    style: {
                        "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                        "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                        label: intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.nextSlide)
                    })
                })
            })
        ]
    });
    if (isWacRefresh) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rkovwyg _bfhk1nc2 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_2rkogktf _bfhkcd5j _1yt4oahv _15tx1ejb",
                    "_cg41r2ho _125xr2ho _1tjqr2ho",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulp1ejb _9959vrvc _a64koahv"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb11ux _1y9l1fhb"
                                ]),
                                children: logoSection
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
                                ]),
                                children: quoteSection
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bahesu3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bwWCK.GalleryControls), {
                            showCounter: true,
                            currentCount: activeQuoteIndex + 1,
                            totalCount: customerQuotes.length,
                            onPrevious: ()=>setActiveQuoteIndex(activeQuoteIndex - 1),
                            onNext: ()=>setActiveQuoteIndex(activeQuoteIndex + 1),
                            size: "small"
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rkovwyg _bfhk1nc2 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_cg4111ib _125x11ib _1tjq11ib",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                    "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                        ]),
                        children: [
                            logoSection,
                            legacyNavigationButtons
                        ]
                    }),
                    quoteSection
                ]
            })
        ]
    });
};
const $6e4e4b8ac7dd4aed$var$lightTextCss = null;
const $6e4e4b8ac7dd4aed$var$refreshTextCss = null;
const $6e4e4b8ac7dd4aed$var$carouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshCarouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshQuoteLayoutCss = null;
const $6e4e4b8ac7dd4aed$var$refreshLogoContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshQuoteContentCss = null;
const $6e4e4b8ac7dd4aed$var$refreshControlsContainerCss = null;
const $6e4e4b8ac7dd4aed$var$logoAndButtonContainerCss = null;
const $6e4e4b8ac7dd4aed$var$gridCss = null;
const $6e4e4b8ac7dd4aed$var$overlapGridItemCss = null;
const $6e4e4b8ac7dd4aed$var$buttonsContainerCss = null;
const $6e4e4b8ac7dd4aed$var$slideNumberCss = null;
const $6e4e4b8ac7dd4aed$var$buttonCss = null;
const $6e4e4b8ac7dd4aed$var$chevronCirlceCss = null;
const $6e4e4b8ac7dd4aed$var$hiddenCarouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$hiddenQuoteCss = null;
const $6e4e4b8ac7dd4aed$var$visibilityHiddenCss = null;
const $6e4e4b8ac7dd4aed$var$overrideQuotePadding = null;

});

parcelRegister("jiDxV", function(module, exports) {
$parcel$export(module.exports, "LogosMarquee", function () { return $c23f1eb8211a66c2$export$143c39d1bfa1977e; });
/* logos-marquee.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $bSVv5 = parcelRequire("bSVv5");

var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");
const $c23f1eb8211a66c2$var$Logo = ({ src: src, href: href, alt: alt, ariaHidden: ariaHidden, tabIndex: tabIndex, isWacRefresh: isWacRefresh })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (0, $1oC0p.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "connectorLogo",
            source: "connector",
            attributes: {
                label: alt
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        alt
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        "aria-hidden": ariaHidden,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: href,
            tabIndex: tabIndex,
            onClick: handleClick,
            className: (0, $2jatx.default)([
                "_1e0c1txw _bfhk1nc2 _2rkovwyg _1bah1h6o _4cvr1h6o _tnruys9h _1rfmys9h",
                isWacRefresh ? "_bfhkcd5j _2rko1tcg _19pkt94y _1dbz130s" : "_irr35k8o"
            ]),
            style: {
                "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3i1wqb _1bsb1wqb _19pk19bv _2hwx19bv _otyr19bv _18u019bv",
                    isWacRefresh && "_4t3i8ved _1bsb8ved _19pk1trj _2hwx1trj _otyr1trj _18u01trj _1kne8vuz _1s4p8vuz _3wvk1crf _1fbn1crf _1uby1crf _1t0r1crf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: src,
                    alt: alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $c23f1eb8211a66c2$export$143c39d1bfa1977e = ({ mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    // Default to true (running); correct to false after mount if the user prefers reduced motion.
    // We do this in useEffect (not useState initializer) to avoid SSR/hydration mismatches,
    // since window.matchMedia is not available on the server.
    const [running, setRunning] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) setRunning(false);
    }, []);
    tabletLogos = tabletLogos?.length === 0 ? desktopLogos : tabletLogos;
    mobileLogos = mobileLogos?.length === 0 ? desktopLogos : mobileLogos;
    // @ts-expect-error Added to prevent undefined type errors
    const mobileLogosLength = mobileLogos.length;
    // @ts-expect-error Added to prevent undefined type errors
    const tabletLogosLength = tabletLogos.length;
    const desktopLogosLength = desktopLogos.length;
    mobileLogos = [
        // @ts-expect-error Added to prevent undefined type errors
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos
    ];
    tabletLogos = [
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos
    ];
    desktopLogos = [
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos
    ];
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handlePlayPauseClick = (0, $1oC0p.useCallback)(()=>{
        const next = !running;
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "marqueePlayPause",
            source: "connector",
            attributes: {
                label: next ? "play" : "pause"
            }
        }).fire();
        setRunning(next);
    }, [
        running,
        createAnalyticsEvent
    ]);
    const pauseLabel = intl.formatMessage({
        id: "connector-logo-marquee.pause",
        defaultMessage: "Pause"
    });
    const playLabel = intl.formatMessage({
        id: "connector-logo-marquee.play",
        defaultMessage: "Play"
    });
    const playPauseButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _1e0c1txw _1bahh9n0 _85i51b66"
            ]),
            children: isWacRefresh ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                isPlaying: running,
                onToggle: ()=>setRunning((r)=>!r),
                mediaLabel: intl.formatMessage({
                    id: "connector-logo-marquee.media-label",
                    defaultMessage: "connector logos"
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handlePlayPauseClick,
                "aria-pressed": running,
                "aria-label": running ? pauseLabel : playLabel,
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _1reoewfl _18m9ewfl _d0altlke"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3 _1tjq11ib"
                    ]),
                    style: {
                        "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                        "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500")),
                        "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                    },
                    children: running ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                        label: pauseLabel
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                        label: playLabel
                    })
                })
            })
        })
    });
    const logosList = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44vc8cz _1y0c4ukn",
                    "_16uvtrqk",
                    "_181nglyw",
                    isWacRefresh && "_1q511b66 _85i5pxbi"
                ]),
                style: {
                    "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                },
                children: mobileLogos.map((logo, index)=>{
                    const isOriginal = index < mobileLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44v7abo _1y0c4ukn",
                    "_16uvtrqk",
                    "_dm25glyw _sugaglyw",
                    isWacRefresh && "_1q511b66 _85i5pxbi"
                ]),
                style: {
                    "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                },
                children: tabletLogos.map((logo, index)=>{
                    const isOriginal = index < tabletLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44vhu9l _1y0c4ukn",
                    "_16uvtrqk",
                    "_1mjbglyw",
                    isWacRefresh && "_1q511b66 _85i5pxbi"
                ]),
                style: {
                    "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                },
                children: desktopLogos.map((logo, index)=>{
                    const isOriginal = index < desktopLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m9ewfl _kqswh2mm _1e0c1txw _2lx21bp4 _zulputpp"
        ]),
        children: [
            logosList,
            playPauseButton
        ]
    });
};
const $c23f1eb8211a66c2$var$linkCss = null;
const $c23f1eb8211a66c2$var$nonRefreshLinkHoverCss = null;
const $c23f1eb8211a66c2$var$refreshLinkCss = null;
const $c23f1eb8211a66c2$var$logoCss = null;
const $c23f1eb8211a66c2$var$refreshLogoCss = null;
const $c23f1eb8211a66c2$var$listCss = null;
const $c23f1eb8211a66c2$var$refreshListPaddingCss = null;
const $c23f1eb8211a66c2$var$marqueeContainerCss = null;
const $c23f1eb8211a66c2$var$marqueeButtonContainerCss = null;
const $c23f1eb8211a66c2$var$marqueeButtonCss = null;
const $c23f1eb8211a66c2$var$buttonCirlceCss = null;
const $c23f1eb8211a66c2$var$listContainerCss = null;
const $c23f1eb8211a66c2$var$animationKeyframesCss = null;
const $c23f1eb8211a66c2$var$pauseOnHoverCss = null;
const $c23f1eb8211a66c2$var$desktopCss = null;
const $c23f1eb8211a66c2$var$tabletCss = null;
const $c23f1eb8211a66c2$var$mobileCss = null;

});
parcelRegister("jElRc", function(module, exports) {
$parcel$export(module.exports, "PlayPauseControls", function () { return $ccd69261239402ec$export$17b97ca49a11c070; });
/* play-pause-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $kbpa7 = parcelRequire("kbpa7");
const $ccd69261239402ec$export$17b97ca49a11c070 = ({ isPlaying: isPlaying, onToggle: onToggle, mediaLabel: mediaLabel })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleToggleClick = (0, $1oC0p.useCallback)(()=>{
        const intent = isPlaying ? "pause" : "play";
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "playPauseControlButton",
            eventType: "ui",
            eventComponent: "button",
            source: "play-pause-controls",
            attributes: {
                intent: intent
            }
        }).fire();
        onToggle();
    }, [
        createAnalyticsEvent,
        isPlaying,
        onToggle
    ]);
    const playLabel = mediaLabel ? intl.formatMessage({
        id: "play-pause-controls.play-with-label",
        defaultMessage: "Play {mediaLabel}"
    }, {
        mediaLabel: mediaLabel
    }) : intl.formatMessage({
        id: "play-pause-controls.play",
        defaultMessage: "Play"
    });
    const pauseLabel = mediaLabel ? intl.formatMessage({
        id: "play-pause-controls.pause-with-label",
        defaultMessage: "Pause {mediaLabel}"
    }, {
        mediaLabel: mediaLabel
    }) : intl.formatMessage({
        id: "play-pause-controls.pause",
        defaultMessage: "Pause"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: handleToggleClick,
        "aria-label": isPlaying ? pauseLabel : playLabel,
        "aria-pressed": isPlaying,
        "data-testid": "play-pause-controls",
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1yt4ze3t _bfhk1j28 _19itglyw _2rko1osq _80omtlke _4t3i1ylp _1bsb1ylp _1ygb7g83 _1ah3yh40"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhku4vp _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _1o9zidpf _4t3i1ylp _1bsb1ylp _1gdlzwfg _zzrmzwfg _irr3xv17 _1di6xv17"
            ]),
            style: {
                "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
                "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_syaz1hlo _1e0c1txw _vwz4idpf"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: isPlaying ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                    label: "",
                    size: "medium",
                    color: "currentColor"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                    label: "",
                    size: "medium",
                    color: "currentColor"
                })
            })
        })
    });
};
const $ccd69261239402ec$var$controlButtonCss = null;
const $ccd69261239402ec$var$buttonCircleCss = null;
/** Figma: black glyphs on the neutral circular background */ const $ccd69261239402ec$var$iconGlyphCss = null;

});




parcelRegister("8MWwK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a017d13ccc1f2d6e$export$2e2bcd8739ae039; });
/* container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");

var $lTkkF = parcelRequire("lTkkF");

var $6ltia = parcelRequire("6ltia");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $je135 = parcelRequire("je135");
const $a017d13ccc1f2d6e$var$UniformContainer = ({ spacing: spacing, horizontalAlignment: horizontalAlignment = "default", verticalAlignment: verticalAlignment = "default", orientation: orientation = {
    mobile: "vertical"
}, gapv2: gapv2 = {
    mobile: "0"
}, hat: hat, pants: pants, backgroundColor: backgroundColor, extendBackgroundColor: extendBackgroundColor, backgroundImageUrl: backgroundImageUrl, backgroundImageFit: backgroundImageFit = "cover", position: position, sticky: sticky = false, stickyOnPage: stickyOnPage = false, roundedCorners: roundedCorners = false, responsiveHiding: responsiveHiding, overflow: overflow = "visible", label: label, tagType: Component = "div", maxWidth: maxWidth })=>{
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition?.data?._id;
    const tracker = (0, $je135.useScrollTracking)(label ?? "", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    const spacingObject = {
        mobile: {
            marginTop: spacing?.mobile?.marginTop ?? "0",
            marginBottom: spacing?.mobile?.marginBottom ?? "0",
            marginLeft: spacing?.mobile?.marginLeft ?? "0",
            marginRight: spacing?.mobile?.marginRight ?? "0",
            paddingTop: spacing?.mobile?.paddingTop ?? "0",
            paddingBottom: spacing?.mobile?.paddingBottom ?? "0",
            paddingLeft: spacing?.mobile?.paddingLeft ?? "0",
            paddingRight: spacing?.mobile?.paddingRight ?? "0"
        },
        tablet: {
            marginTop: spacing?.tablet?.marginTop ?? spacing?.mobile?.marginTop ?? "0",
            marginBottom: spacing?.tablet?.marginBottom ?? spacing?.mobile?.marginBottom ?? "0",
            marginLeft: spacing?.tablet?.marginLeft ?? spacing?.mobile?.marginLeft ?? "0",
            marginRight: spacing?.tablet?.marginRight ?? spacing?.mobile?.marginRight ?? "0",
            paddingTop: spacing?.tablet?.paddingTop ?? spacing?.mobile?.paddingTop ?? "0",
            paddingBottom: spacing?.tablet?.paddingBottom ?? spacing?.mobile?.paddingBottom ?? "0",
            paddingLeft: spacing?.tablet?.paddingLeft ?? spacing?.mobile?.paddingLeft ?? "0",
            paddingRight: spacing?.tablet?.paddingRight ?? spacing?.mobile?.paddingRight ?? "0"
        },
        desktop: {
            marginTop: spacing?.desktop?.marginTop ?? spacing?.tablet?.marginTop ?? spacing?.mobile?.marginTop ?? "0",
            marginBottom: spacing?.desktop?.marginBottom ?? spacing?.tablet?.marginBottom ?? spacing?.mobile?.marginBottom ?? "0",
            marginLeft: spacing?.desktop?.marginLeft ?? spacing?.tablet?.marginLeft ?? spacing?.mobile?.marginLeft ?? "0",
            marginRight: spacing?.desktop?.marginRight ?? spacing?.tablet?.marginRight ?? spacing?.mobile?.marginRight ?? "0",
            paddingTop: spacing?.desktop?.paddingTop ?? spacing?.tablet?.paddingTop ?? spacing?.mobile?.paddingTop ?? "0",
            paddingBottom: spacing?.desktop?.paddingBottom ?? spacing?.tablet?.paddingBottom ?? spacing?.mobile?.paddingBottom ?? "0",
            paddingLeft: spacing?.desktop?.paddingLeft ?? spacing?.tablet?.paddingLeft ?? spacing?.mobile?.paddingLeft ?? "0",
            paddingRight: spacing?.desktop?.paddingRight ?? spacing?.tablet?.paddingRight ?? spacing?.mobile?.paddingRight ?? "0"
        }
    };
    const marginStyles = null;
    const paddingStyles = null;
    (0, $1oC0p.useEffect)(()=>{
        (0, $lTkkF.updateStickyNavOffset)();
    }, []);
    const hiddenMobileStyle = null;
    const hiddenTabletStyle = null;
    const hiddenDesktopStyle = null;
    // determine text color based on background color luminance
    const getTextColor = (bgColor)=>{
        if (!bgColor) return undefined;
        try {
            // white text for dark backgrounds, dark text for light backgrounds
            return (0, $6ltia.isDarkColor)(bgColor) ? (0, $kbpa7.wacToken)("color.neutral.light0") : (0, $kbpa7.wacToken)("color.primary.black");
        } catch (error) {
            // invalid color format, return undefined to use default
            console.error("Invalid backgroundColor format:", bgColor, error);
            return undefined;
        }
    };
    const textColor = getTextColor(backgroundColor);
    const colorStyle = null;
    // Map backgroundImageFit to the corresponding CSS background-size value
    const backgroundSizeMap = {
        cover: "cover",
        contain: "contain",
        fill: "100% 100%"
    };
    const backgroundImageInlineStyle = backgroundImageUrl ? {
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: backgroundSizeMap[backgroundImageFit],
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    } : undefined;
    const gapObject = {
        mobile: gapv2.mobile ?? "0",
        tablet: gapv2?.tablet ?? gapv2.mobile ?? "0",
        desktop: gapv2?.desktop ?? gapv2?.tablet ?? gapv2.mobile ?? "0"
    };
    const innerStyle = null;
    const innerStyleFullHeight = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        tablet: orientation?.tablet || orientation.mobile || "vertical",
        desktop: orientation?.desktop || orientation?.tablet || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    const verticalAlignmentValue = verticalAlignment === "center" ? "center" : verticalAlignment === "end" ? "flex-end" : "flex-start";
    const horizontalAlignmentValue = horizontalAlignment === "center" ? "center" : horizontalAlignment === "start" ? "flex-start" : horizontalAlignment === "end" ? "flex-end" : "initial";
    const hiddenOnMobile = responsiveHiding?.includes("mobile");
    const hiddenOnTablet = responsiveHiding?.includes("tablet");
    const hiddenOnDesktop = responsiveHiding?.includes("desktop");
    const overflowStyle = null;
    const outerHeightFullStyle = null;
    const responsiveSectionDividerHeightsStyles = null;
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsbauwl _4t3i1cn3 _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _11q7wvjo",
            hat && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6kwvjo",
            hat && "_1cs8h2mm _iajm18y9",
            hat && hat === "high-right" ? "_tgsmkyn1" : hat === "high-left" ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2wvjo",
            pants && "_18poh2mm _19nq1osq",
            pants && hat && "_18poh2mm _19nq1e6p",
            pants && pants === "high-right" ? "_1oj4snn3" : pants === "high-left" ? "_1oj4df5m" : "_1oj41mhh"
        ])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)(Component, {
        ref: (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7603UniformPageDwellTime) && label ? tracker?.ref : null,
        className: (0, $2jatx.default)([
            "_vhvk1xho _wsfyeyca _11nbax5h _tqhlzoxj _9s88d2ta _1rcb14zp",
            "_1pfhanyo _6rthpu7k _ahbq5tu6 _12l21ubn _kiya1jt3 _1ob9vj1y _1ywm6esm _1lva1cm9 _1mt1153n _1tntw79i _3l1a4z27 _161b1c8k",
            "_14lsaxbu _9if11u00",
            verticalAlignment === "end" && "_4t3i1osq",
            hat && !extendBackgroundColor && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6kwvjo",
            hat && !extendBackgroundColor && hat === "high-right" ? "_tgsmkyn1" : hat === "high-left" ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && !extendBackgroundColor && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2wvjo",
            pants && !extendBackgroundColor && pants === "high-right" ? "_1oj4snn3" : pants === "high-left" ? "_1oj4df5m" : "_1oj41mhh",
            hiddenOnMobile && "_sugaglyw",
            hiddenOnTablet && "_kzviglyw",
            hiddenOnDesktop && "_dm25glyw",
            "_1idncgrn",
            extendBackgroundColor && "_kqswh2mm",
            extendBackgroundColor && hat && "_1q511m3o",
            extendBackgroundColor && pants && "_85i51aiy",
            stickyOnPage && "_kqsw1if8 _152txohi _1pbyqfx8"
        ]),
        style: {
            ...backgroundImageInlineStyle,
            "--_9ux5rl": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).mobile}px` : "0px"),
            "--_eu2x2b": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).mobile}px` : "0px"),
            "--_up8d13": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).tablet}px` : "0px"),
            "--_alf06v": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).tablet}px` : "0px"),
            "--_138i2bk": (0, $6ZVlx.default)(hat ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).desktop}px` : "0px"),
            "--_1r8eu8k": (0, $6ZVlx.default)(pants ? `${(0, $lTkkF.SECTION_DIVIDER_HEIGHTS).desktop}px` : "0px"),
            "--_gbj3vn": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.marginTop + ")"),
            "--_1ml8i62": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.marginBottom + ")"),
            "--_eitxkt": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.marginLeft + ")"),
            "--_17oyghn": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.marginRight + ")"),
            "--_13w6wc6": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.marginTop + ")"),
            "--_1g7gc60": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.marginBottom + ")"),
            "--_1w7fn9j": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.marginLeft + ")"),
            "--_y26vmc": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.marginRight + ")"),
            "--_12q7gcg": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.marginTop + ")"),
            "--_1unjz24": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.marginBottom + ")"),
            "--_6sej3x": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.marginLeft + ")"),
            "--_4gatm0": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.marginRight + ")"),
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_srel9g": (0, $6ZVlx.default)(textColor),
            "--_lyok2l": (0, $6ZVlx.default)(overflow)
        },
        children: [
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q7wvjo _1bsb1osq _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
                    verticalAlignment === "end" && "_4t3i1osq",
                    extendBackgroundColor && "_bfhk1j28 _kqswh2mm _1pbykb7n",
                    "_1q5117qr _85i51lcc _bozg1k1r _y4ti1one _1wafbrnf _1yd32emj _1wfq1myb _15vt1nm0 _26vx19ue _40tu16pv _d2ik8srg _exxmep75",
                    "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6",
                    orientationObject.mobile === "horizontal" && "_4cvrop21 _1bah8u0b",
                    orientationObject.tablet === "horizontal" && "_q8t5op21 _e8gh8u0b",
                    orientationObject.desktop === "horizontal" && "_1jsvop21 _msup8u0b",
                    orientationObject.mobile === "vertical" && "_4cvr8u0b _1bahop21",
                    orientationObject.tablet === "vertical" && "_q8t58u0b _e8ghop21",
                    orientationObject.desktop === "vertical" && "_1jsv8u0b _msupop21",
                    position && "_kqsw1fhc",
                    sticky && "_kqsw1if8 _152txohi",
                    roundedCorners && "_2rkovwyg _1reo15vq _18m915vq",
                    maxWidth && "_p12fd0ge _195g1wug"
                ]),
                style: {
                    "--_rkv8x9": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.mobile + ")"),
                    "--_9wptik": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.tablet + ")"),
                    "--_3wdyhk": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.desktop + ")"),
                    "--_16fd4zu": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.paddingTop + ")"),
                    "--_1j5swcl": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.paddingBottom + ")"),
                    "--_u69j6n": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.paddingLeft + ")"),
                    "--_o2jkov": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.mobile.paddingRight + ")"),
                    "--_703coj": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.paddingTop + ")"),
                    "--_1fsgwhq": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.paddingBottom + ")"),
                    "--_13hg674": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.paddingLeft + ")"),
                    "--_1qs0f4o": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.tablet.paddingRight + ")"),
                    "--_pqmqgy": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.paddingTop + ")"),
                    "--_1ybsets": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.paddingBottom + ")"),
                    "--_okopco": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.paddingLeft + ")"),
                    "--_x42pdd": (0, $6ZVlx.default)("var(--ds-space-" + spacingObject.desktop.paddingRight + ")"),
                    "--_pv2ypa": (0, $6ZVlx.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
                    "--_dek1s0": (0, $6ZVlx.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
                    "--_1ng513r": (0, $6ZVlx.default)(orientationObject.desktop === "horizontal" ? "row" : "column"),
                    "--_7phn4c": (0, $6ZVlx.default)(verticalAlignmentValue),
                    "--_7e5uq9": (0, $6ZVlx.default)(horizontalAlignmentValue),
                    "--_1ia45kk": (0, $6ZVlx.default)(position),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_1oqf9ha": (0, $6ZVlx.default)(maxWidth)
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "component"
                })
            })
        ]
    });
};
const $a017d13ccc1f2d6e$var$hatCommonStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorHatStyle = null;
const $a017d13ccc1f2d6e$var$hatHighLeft = null;
const $a017d13ccc1f2d6e$var$hatHighRight = null;
const $a017d13ccc1f2d6e$var$hatPolygon = null;
const $a017d13ccc1f2d6e$var$pantsCommonStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorPantsStyle = null;
const $a017d13ccc1f2d6e$var$extendedBackgroundColorPantsWithHatStyle = null;
const $a017d13ccc1f2d6e$var$pantsHighLeft = null;
const $a017d13ccc1f2d6e$var$pantsHighRight = null;
const $a017d13ccc1f2d6e$var$pantsPolygon = null;
var $a017d13ccc1f2d6e$export$2e2bcd8739ae039 = $a017d13ccc1f2d6e$var$UniformContainer;

});

parcelRegister("5nbaa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d2a96969d170342b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $2axoc = parcelRequire("2axoc");

var $lTkkF = parcelRequire("lTkkF");

var $jQ0cd = parcelRequire("jQ0cd");
const $d2a96969d170342b$var$UniformContentBlock = (props)=>{
    const localizedLinkHref = (0, $jQ0cd.useLocalizedHref)(props.linkHref?.path ?? "");
    const localizedButtonHref = (0, $jQ0cd.useLocalizedHref)(props.buttonHref?.path ?? "");
    const callToActionProps = $d2a96969d170342b$var$transformCtaProps({
        ...props,
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        titleAppearsAs: props.titleAppearsAs,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: props.imageAlt ?? ""
        } : undefined,
        imageAspectRatio: props.imageAspectRatio,
        spotIllustration: props.spotIllustrationUrl ? {
            src: props.spotIllustrationUrl,
            width: props.spotIllustrationWidth
        } : undefined,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: props.iconAlt ?? "",
                paddingIncluded: props.iconPaddingIncluded
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor,
        hat: props.hat,
        pants: props.pants
    });
};
function $d2a96969d170342b$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!buttonHref?.path && !!buttonLabel;
    const isLink = !!linkHref?.path && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "contentBlock",
                    "data-event": "clicked",
                    "data-label": buttonLabel
                }
            } : undefined,
            buttonText: buttonLabel ?? undefined,
            buttonVariant: buttonVariant ?? undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "contentBlock",
                    "data-event": "clicked",
                    "data-label": linkText
                }
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $d2a96969d170342b$export$2e2bcd8739ae039 = $d2a96969d170342b$var$UniformContentBlock;

});

parcelRegister("gQYRi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b941cbe43c103c23$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $foNCS = parcelRequire("foNCS");

var $17RBn = parcelRequire("17RBn");

var $kf4PU = parcelRequire("kf4PU");

var $9rnwe = parcelRequire("9rnwe");

var $66vFr = parcelRequire("66vFr");

var $2wD1w = parcelRequire("2wD1w");
const $b941cbe43c103c23$var$DEFAULT_CONTENTFUL_LOCALE = "en-US";
const $b941cbe43c103c23$var$SUPPORTED_CONTENTFUL_LOCALES = new Set(Object.values((0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)));
const $b941cbe43c103c23$var$toContentfulLocale = (pageLocale)=>{
    if (!pageLocale) return $b941cbe43c103c23$var$DEFAULT_CONTENTFUL_LOCALE;
    const mapped = (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[pageLocale];
    if (mapped) return mapped;
    if ($b941cbe43c103c23$var$SUPPORTED_CONTENTFUL_LOCALES.has(pageLocale)) return pageLocale;
    return $b941cbe43c103c23$var$DEFAULT_CONTENTFUL_LOCALE;
};
const $b941cbe43c103c23$var$ContentfulGalleryContainer = ({ contentType: contentType = "productTemplate" })=>{
    const intlLocale = (0, $17RBn.useLocale)();
    const { locale: contextLocale } = (0, $9rnwe.useWAEContext)();
    const locale = $b941cbe43c103c23$var$toContentfulLocale(contextLocale ?? intlLocale);
    const loadContentfulItems = (0, $1oC0p.useCallback)(({ loaded: loaded })=>(0, $2wD1w.getContentfulGalleryItems)({
            contentType: contentType,
            loaded: loaded,
            locale: locale
        }), [
        contentType,
        locale
    ]);
    const currentRegistration = (0, $1oC0p.useMemo)(()=>({
            loader: loadContentfulItems
        }), [
        loadContentfulItems
    ]);
    const { extraItems: extraItems } = (0, $66vFr.useBackfill)({
        seedCount: 0,
        loader: loadContentfulItems
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $foNCS.FilterableGalleryLoaderProvider), {
        currentRegistration: currentRegistration,
        extraItems: extraItems,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content"
        })
    });
};
var $b941cbe43c103c23$export$2e2bcd8739ae039 = $b941cbe43c103c23$var$ContentfulGalleryContainer;

});
parcelRegister("foNCS", function(module, exports) {
$parcel$export(module.exports, "FilterableGalleryLoaderProvider", function () { return $c182ab1694ebe7b9$export$cb57cc654ea9ab7; });
$parcel$export(module.exports, "useFilterableGalleryLoader", function () { return $c182ab1694ebe7b9$export$6b88636f926b4970; });
$parcel$export(module.exports, "useIsInsideLoaderProvider", function () { return $c182ab1694ebe7b9$export$1bb59d992149f403; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $c182ab1694ebe7b9$var$FilterableGalleryLoaderContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $c182ab1694ebe7b9$export$cb57cc654ea9ab7 = ({ children: children, onLoaderRegistered: onLoaderRegistered = ()=>undefined, currentRegistration: currentRegistration = null, extraItems: extraItems = [], setExtraItems: setExtraItems = ()=>undefined })=>{
    // Owned internally so neither the container nor the standalone gallery has
    // to thread it through props; the gallery publishes, the search bar reads.
    const [galleryConfig, setGalleryConfig] = (0, $1oC0p.useState)(null);
    const value = (0, $1oC0p.useMemo)(()=>({
            registerLoader: onLoaderRegistered,
            currentRegistration: currentRegistration,
            extraItems: extraItems,
            setExtraItems: setExtraItems,
            galleryConfig: galleryConfig,
            registerGalleryConfig: setGalleryConfig
        }), [
        onLoaderRegistered,
        currentRegistration,
        extraItems,
        setExtraItems,
        galleryConfig
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($c182ab1694ebe7b9$var$FilterableGalleryLoaderContext.Provider, {
        value: value,
        children: children
    });
};
const $c182ab1694ebe7b9$export$6b88636f926b4970 = ()=>(0, $1oC0p.useContext)($c182ab1694ebe7b9$var$FilterableGalleryLoaderContext);
const $c182ab1694ebe7b9$export$1bb59d992149f403 = ()=>(0, $1oC0p.useContext)($c182ab1694ebe7b9$var$FilterableGalleryLoaderContext) !== null;

});

parcelRegister("66vFr", function(module, exports) {
$parcel$export(module.exports, "useBackfill", function () { return $4a1cb0c0d46e1d62$export$c65af1cb6431e0ed; });

var $1oC0p = parcelRequire("1oC0p");
const $4a1cb0c0d46e1d62$export$c65af1cb6431e0ed = ({ seedCount: seedCount, loader: loader, keyExtractor: keyExtractor = $4a1cb0c0d46e1d62$var$defaultKeyExtractor })=>{
    const [state, setState] = (0, $1oC0p.useState)({
        extraItems: [],
        isLoading: false,
        error: null
    });
    const mountedRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const keyExtractorRef = (0, $1oC0p.useRef)(keyExtractor);
    keyExtractorRef.current = keyExtractor;
    const hasFetchedRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useEffect)(()=>{
        hasFetchedRef.current = false;
        setState({
            extraItems: [],
            isLoading: false,
            error: null
        });
    }, [
        loader,
        seedCount
    ]);
    const fetch = (0, $1oC0p.useCallback)(async ()=>{
        if (!loader || hasFetchedRef.current) return;
        setState((prev)=>({
                ...prev,
                isLoading: true,
                error: null
            }));
        try {
            const extra = await loader({
                skip: seedCount,
                limit: 0,
                total: 0,
                loaded: seedCount
            });
            if (!mountedRef.current) return;
            hasFetchedRef.current = true;
            const seen = new Set();
            const deduped = extra.filter((item)=>{
                const key = keyExtractorRef.current(item);
                if (key === undefined) return true;
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
            setState({
                extraItems: deduped,
                isLoading: false,
                error: null
            });
        } catch (err) {
            if (!mountedRef.current) return;
            setState({
                extraItems: [],
                isLoading: false,
                error: err
            });
        }
    }, [
        loader,
        seedCount
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!loader) return;
        if (typeof requestIdleCallback !== "undefined") {
            const id = requestIdleCallback(fetch);
            return ()=>cancelIdleCallback(id);
        }
        fetch();
    }, [
        fetch,
        loader
    ]);
    return state;
};
function $4a1cb0c0d46e1d62$var$defaultKeyExtractor(item) {
    if (typeof item !== "object" || item === null) return undefined;
    const record = item;
    const sys = record["sys"];
    if (typeof sys === "object" && sys !== null) {
        const id = sys["id"];
        if (typeof id === "string") return id;
    }
    return undefined;
}

});

parcelRegister("2wD1w", function(module, exports) {
$parcel$export(module.exports, "getContentfulGalleryItems", function () { return $e132d2285c53e8e3$export$8a5165f5eef5e7ce; });

var $2iZII = parcelRequire("2iZII");

var $ezTvi = parcelRequire("ezTvi");

var $ixJzr = parcelRequire("ixJzr");
const $e132d2285c53e8e3$var$GQL_FETCH_LIMIT = 100;
const $e132d2285c53e8e3$var$contentfulGalleryDataSources = {
    productTemplate: {
        fetchPage: $e132d2285c53e8e3$var$fetchProductTemplatePage,
        mapItem: (item)=>(0, $ezTvi.mapTemplateItem)(item)
    }
};
const $e132d2285c53e8e3$export$8a5165f5eef5e7ce = async ({ contentType: contentType, loaded: loaded, locale: locale })=>{
    const dataSource = $e132d2285c53e8e3$var$contentfulGalleryDataSources[contentType];
    const cacheKey = $e132d2285c53e8e3$var$getCacheKey({
        contentType: contentType,
        loaded: loaded,
        locale: locale
    });
    const cached = $e132d2285c53e8e3$var$getWindowCache(cacheKey);
    if (cached) return cached;
    const firstPage = await dataSource.fetchPage({
        limit: $e132d2285c53e8e3$var$GQL_FETCH_LIMIT,
        skip: loaded,
        locale: locale
    });
    const allItems = firstPage.items.map(dataSource.mapItem);
    const remainingSkips = $e132d2285c53e8e3$var$getRemainingSkips({
        loaded: loaded,
        total: firstPage.total,
        limit: $e132d2285c53e8e3$var$GQL_FETCH_LIMIT
    });
    const remainingPages = await Promise.all(remainingSkips.map((skip)=>dataSource.fetchPage({
            limit: $e132d2285c53e8e3$var$GQL_FETCH_LIMIT,
            skip: skip,
            locale: locale
        })));
    for (const page of remainingPages)allItems.push(...page.items.map(dataSource.mapItem));
    $e132d2285c53e8e3$var$setWindowCache(cacheKey, allItems);
    return allItems;
};
async function $e132d2285c53e8e3$var$fetchProductTemplatePage({ limit: limit, skip: skip, locale: locale }) {
    const result = await (0, $2iZII.getContentfulGqlClient)().query((0, $ixJzr.allProductTemplatesQuery), {
        limit: limit,
        skip: skip,
        locale: locale
    }).toPromise();
    const collection = result.data?.productTemplateCollection;
    return {
        total: collection?.total ?? 0,
        items: collection?.items ?? []
    };
}
function $e132d2285c53e8e3$var$getRemainingSkips({ loaded: loaded, total: total, limit: limit }) {
    const skips = [];
    for(let skip = loaded + limit; skip < total; skip += limit)skips.push(skip);
    return skips;
}
function $e132d2285c53e8e3$var$getCacheKey({ contentType: contentType, loaded: loaded, locale: locale }) {
    return `__UTG_${contentType.toUpperCase()}_LOCALE_${locale}_FROM_${loaded}__`;
}
function $e132d2285c53e8e3$var$getWindowCache(key) {
    const cached = window[key];
    return Array.isArray(cached) ? cached : null;
}
function $e132d2285c53e8e3$var$setWindowCache(key, items) {
    window[key] = items;
}

});
parcelRegister("ezTvi", function(module, exports) {
$parcel$export(module.exports, "mapTemplateItem", function () { return $edb519131f937f33$export$48a2c256ae09d4f0; });
const $edb519131f937f33$var$toAssetEnvelope = (asset)=>asset ? {
        fields: {
            file: {
                url: asset.url ?? "",
                title: asset.title ?? ""
            }
        }
    } : null;
const $edb519131f937f33$var$isPresent = (value)=>value !== null && value !== undefined;
/**
 * Maps the contributor union into the same resolved shape the SSR/Uniform fetch
 * produces, so search resolves the same `fields.contributor.*` paths on
 * backfilled and seed items.
 */ function $edb519131f937f33$var$mapContributor(contributor) {
    if (!contributor) return null;
    if (contributor.__typename === "Author") return {
        fields: {
            authorNameExternal: contributor.authorNameExternal ?? "",
            organization: contributor.organization ? {
                fields: {
                    organizationNameExternal: contributor.organization.organizationNameExternal ?? ""
                }
            } : null
        }
    };
    if (contributor.__typename === "CompanyNameInternal") return {
        fields: {
            organizationNameExternal: contributor.organizationNameExternal ?? ""
        }
    };
    return null;
}
function $edb519131f937f33$export$48a2c256ae09d4f0(item) {
    const categories = (item.categoryCollection?.items ?? []).filter($edb519131f937f33$var$isPresent).map((cat)=>({
            sys: {
                id: cat.sys.id
            },
            fields: {
                urlSlug: cat.urlSlug ?? "",
                categoryNameExternal: cat.categoryNameExternal ?? "",
                shortDescriptionOneLiner: cat.shortDescriptionOneLiner ?? ""
            }
        }));
    const products = (item.productCollection?.items ?? []).filter($edb519131f937f33$var$isPresent).map((prod)=>({
            sys: {
                id: prod.sys.id
            },
            fields: {
                internalTitle: prod.internalTitle ?? "",
                url: prod.url ?? "",
                productNameReference: {
                    fields: {
                        productName: prod.productNameReference?.productName ?? ""
                    }
                },
                icon: $edb519131f937f33$var$toAssetEnvelope(prod.icon)
            }
        }));
    return {
        sys: {
            id: item.sys.id
        },
        fields: {
            templateNameInternal: item.templateNameInternal ?? "",
            templateNameExternal: item.templateNameExternal ?? "",
            oneLinerHeadline: item.oneLinerHeadline ?? "",
            fullUrlSlug: item.fullUrlSlug ?? "",
            templateIcon: $edb519131f937f33$var$toAssetEnvelope(item.templateIcon),
            templateThumbnail: $edb519131f937f33$var$toAssetEnvelope(item.templateThumbnail),
            contributor: $edb519131f937f33$var$mapContributor(item.contributor),
            category: categories,
            product: products
        }
    };
}

});

parcelRegister("ixJzr", function(module, exports) {
$parcel$export(module.exports, "allProductTemplatesQuery", function () { return $21e67e04eb912a5d$export$487101c30f9a39d8; });

var $1dWiR = parcelRequire("1dWiR");
const $21e67e04eb912a5d$export$487101c30f9a39d8 = (0, $1dWiR.gql)`
    query allProductTemplates($limit: Int, $skip: Int, $locale: String!) {
        productTemplateCollection(limit: $limit, skip: $skip, locale: $locale) {
            total
            items {
                sys {
                    id
                }
                templateNameInternal
                templateNameExternal
                oneLinerHeadline
                fullUrlSlug
                templateIcon {
                    url
                    title
                }
                templateThumbnail {
                    url
                    title
                }
                contributor {
                    __typename
                    ... on Author {
                        authorNameExternal
                        organization {
                            organizationNameExternal
                        }
                    }
                    ... on CompanyNameInternal {
                        organizationNameExternal
                    }
                }
                categoryCollection(limit: 10, locale: $locale) {
                    items {
                        sys {
                            id
                        }
                        urlSlug
                        categoryNameExternal
                        shortDescriptionOneLiner
                    }
                }
                productCollection(limit: 5, locale: $locale) {
                    items {
                        sys {
                            id
                        }
                        internalTitle
                        url
                        productNameReference {
                            productName
                        }
                        icon {
                            url
                            title
                        }
                    }
                }
            }
        }
    }
`;

});



parcelRegister("ijBWj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63970a701463a0fa$export$2e2bcd8739ae039; });
/* contextual-bandits-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $8e22h = parcelRequire("8e22h");

var $lr38U = parcelRequire("lr38U");

var $eY3N6 = parcelRequire("eY3N6");

var $fcO7r = parcelRequire("fcO7r");

var $kbpa7 = parcelRequire("kbpa7");

var $l7lLR = parcelRequire("l7lLR");

var $gIKKj = parcelRequire("gIKKj");

var $eRzlV = parcelRequire("eRzlV");

var $iSeHD = parcelRequire("iSeHD");

var $3o1l4 = parcelRequire("3o1l4");
const $63970a701463a0fa$var$WRAPPER_STYLES = null;
const $63970a701463a0fa$var$PANEL_STYLES = null;
const $63970a701463a0fa$var$PANEL_EXPANDED_STYLES = null;
// Inner row that keeps the panel name and the variant <select> side-by-side
// while the experiment-override toggle stacks beneath them.
const $63970a701463a0fa$var$PANEL_ROW_STYLES = null;
const $63970a701463a0fa$var$LABEL_STYLES = null;
const $63970a701463a0fa$var$SELECT_STYLES = null;
const $63970a701463a0fa$var$EXPERIMENT_TOGGLE_ROW_STYLES = null;
const $63970a701463a0fa$var$EXPERIMENT_TOGGLE_ROW_EXPANDED_STYLES = null;
const $63970a701463a0fa$var$EXPERIMENT_TOGGLE_LABEL_STYLES = null;
// Small native checkbox sized to fit alongside the existing variant <select>.
const $63970a701463a0fa$var$EXPERIMENT_TOGGLE_CHECKBOX_STYLES = null;
const $63970a701463a0fa$var$OVERRIDE_DEFAULT = "default";
const $63970a701463a0fa$var$getBootstrapAnonymousId = ()=>typeof window !== "undefined" && window.featureGateBootstrapValues?.identifiers?.analyticsAnonymousId || "";
/**
 * Identity wrapper for `<UniformSlot>`. Renders whatever `items` array it is
 * given, in order. Used as the base wrapper when delegating selection to a
 * higher-level wrapper, and on the `default` slot.
 */ const $63970a701463a0fa$var$VariantSelector = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: props.items.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                children: item
            }, `variant-${index}`))
    });
/**
 * Renders the `variants` slot but slices its `items` array down to a single
 * entry by index, so only the chosen variant is mounted.
 */ const $63970a701463a0fa$var$renderChosenVariant = (chosenVariantIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "variants",
        wrapperComponent: (slotProps)=>$63970a701463a0fa$var$VariantSelector({
                ...slotProps,
                items: [
                    slotProps.items[chosenVariantIndex]
                ]
            })
    });
const $63970a701463a0fa$var$useIsEnrolledInExperiment = ({ experimentId: experimentId = "" })=>{
    const hasExperimentId = experimentId.length > 0;
    const experimentStatus = (0, $gIKKj.useExperiment)({
        experimentName: experimentId,
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            // Do not fire exposure when there is no experiment to expose to.
            fireExperimentExposure: hasExperimentId,
            typeGuard: (value)=>typeof value === "boolean"
        },
        targeting: {
            // Skip targeting evaluation entirely when no experiment is set.
            cohort: ()=>hasExperimentId
        },
        metadata: {
            description: "Contextual Bandits Experiment - configured in Uniform",
            expectedReleaseDate: "unknown - configured in Uniform",
            expectedRuntime: "unknown - configured in Uniform",
            context: {
                urls: []
            }
        }
    });
    return hasExperimentId && experimentStatus.type === "enrolled" && experimentStatus.value;
};
const $63970a701463a0fa$var$toggleExperimentOverride = (setExperimentOverride)=>{
    setExperimentOverride((prev)=>!prev);
};
const $63970a701463a0fa$export$638c979adda786d8 = async ({ locale: locale = "en-US", anonymousId: anonymousId, subAnchor: subAnchor = "", channel: channel = "", utmContent: utmContent = "" } = {})=>{
    const aggClient = new (0, $lr38U.AGGClient)({
        gatewayUrl: (0, $eRzlV.isProduction)() ? "https://www.atlassian.com/gateway/api/graphql" : "https://wac.stg.internal.atlassian.com/gateway/api/graphql"
    });
    const query = `
query WacAnchorJourneyJsm {
  growthRecommendations {
    recommendations(
      context: {
        tenantId: "",
        product: "jira",
        subproduct: "servicemanagement",
        containers: null,
        sessionId: "",
        locale: "${locale}",
        orgId: "",
        workspaceId: null,
        useCase: "wacAnchorJourneyJsm",
        anonymousId: "${anonymousId}",
        custom: {
          subAnchor: "${subAnchor}",
          channel: "${channel}",
          utmContent: "${utmContent}"
        }
      },
      first: 1,
      rerank: []
    ) {
      ... on GrowthRecRecommendations {
        data {
          entityId,
          reasons
        },
        context {
          sessionId
        }
      }
      ... on QueryError {
        identifier
        message
      }
    }
  }
}
`;
    const result = await aggClient.query(query, {});
    return result.data;
};
const $63970a701463a0fa$export$dc41ccf6827e5b03 = (data)=>{
    const recommendations = data?.growthRecommendations?.recommendations;
    if (!recommendations) {
        console.error("No recommendations found in wacAnchorJourneyJsm GRS response.");
        return [];
    }
    if (Array.isArray(recommendations.data)) return recommendations.data.map(({ entityId: entityId })=>entityId);
    console.error("Unknown response format for wacAnchorJourneyJsm GRS recommendations", recommendations);
    return [];
};
const $63970a701463a0fa$export$2f54b0fbfb30f444 = (data)=>data?.growthRecommendations?.recommendations?.context?.sessionId ?? null;
const $63970a701463a0fa$var$getVariantId = (variant)=>{
    const variantId = variant.parameters?.["id"]?.value;
    return typeof variantId === "string" ? variantId : null;
};
const $63970a701463a0fa$var$getBanditChosenIndex = (recommendationEntityIds, variantSlots)=>{
    const recommendationEntityId = recommendationEntityIds[0];
    if (!recommendationEntityId) return null;
    const matchingVariantIndex = variantSlots.findIndex((variant)=>$63970a701463a0fa$var$getVariantId(variant) === recommendationEntityId);
    return matchingVariantIndex >= 0 ? matchingVariantIndex : null;
};
const $63970a701463a0fa$var$UniformContextualBanditsContainer = (props)=>{
    const isProd = (0, $eRzlV.isProduction)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition?.data?._id;
    // Stable reference to the `variants` slot entries. Required so authors can
    // see how many variant candidates exist and so downstream selection logic
    // does not re-run on every render.
    const variantSlots = (0, $1oC0p.useMemo)(()=>props.component.slots?.["variants"] ?? [], [
        props.component.slots
    ]);
    const variantSlotsRef = (0, $1oC0p.useRef)(variantSlots);
    (0, $1oC0p.useEffect)(()=>{
        variantSlotsRef.current = variantSlots;
    }, [
        variantSlots
    ]);
    // Dev-only override. In production this stays at `OVERRIDE_DEFAULT` and the
    // <select> is never rendered, so the value has no effect.
    const [override, setOverride] = (0, $1oC0p.useState)($63970a701463a0fa$var$OVERRIDE_DEFAULT);
    const [isExperimentOverridden, setIsExperimentOverridden] = (0, $1oC0p.useState)(false);
    const [isPanelExpanded, setIsPanelExpanded] = (0, $1oC0p.useState)(false);
    const [banditRecommendationEntityIds, setBanditRecommendationEntityIds] = (0, $1oC0p.useState)([]);
    const intl = (0, $8e22h.default)();
    const locale = intl.locale;
    const anonymousId = analyticsClient?.getAnonymousId() ?? $63970a701463a0fa$var$getBootstrapAnonymousId();
    const { data: personalizationValues } = (0, $3o1l4.useUserSegments)();
    const subAnchor = personalizationValues?.[(0, $3o1l4.UserSegmentTypes).SUB_ANCHOR];
    const channel = personalizationValues?.[(0, $3o1l4.UserSegmentTypes).CHANNEL];
    const utmContent = personalizationValues?.[(0, $3o1l4.UserSegmentTypes).UTM_CONTENT];
    const banditChosenIndex = (0, $1oC0p.useMemo)(()=>$63970a701463a0fa$var$getBanditChosenIndex(banditRecommendationEntityIds, variantSlots), [
        banditRecommendationEntityIds,
        variantSlots
    ]);
    const chosenVariantIndex = !isProd && override !== $63970a701463a0fa$var$OVERRIDE_DEFAULT ? override : banditChosenIndex;
    const isEnrolledInExperiment = $63970a701463a0fa$var$useIsEnrolledInExperiment({
        experimentId: props.experimentId
    });
    const variantChosen = chosenVariantIndex !== null && variantSlots[chosenVariantIndex];
    const isEnrolledInExperimentPlusOverride = !props.experimentId || isEnrolledInExperiment || isExperimentOverridden && !isProd;
    const shouldRenderVariant = isEnrolledInExperimentPlusOverride && variantChosen;
    const renderedVariant = shouldRenderVariant ? $63970a701463a0fa$var$renderChosenVariant(chosenVariantIndex) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "default",
        wrapperComponent: $63970a701463a0fa$var$VariantSelector
    });
    (0, $1oC0p.useEffect)(()=>{
        // Guard against SSR — AGGClient makes a network call that should only
        // happen in the browser, where anonymousId/sessionId/etc. are available.
        if (typeof window === "undefined") return;
        let cancelled = false;
        (async ()=>{
            let recommendationEntityIds = [];
            try {
                const response = await $63970a701463a0fa$export$638c979adda786d8({
                    locale: locale,
                    anonymousId: anonymousId,
                    subAnchor: subAnchor,
                    channel: channel,
                    utmContent: utmContent
                });
                recommendationEntityIds = $63970a701463a0fa$export$dc41ccf6827e5b03(response);
                const recoSessionId = $63970a701463a0fa$export$2f54b0fbfb30f444(response);
                if (recoSessionId) (0, $l7lLR.setGrsDataToLocalStorage)({
                    recoSessionId: recoSessionId,
                    recoEntityId: recommendationEntityIds[0] ?? ""
                }, (0, $fcO7r.ProductKey).JIRA_SERVICE_MANAGEMENT);
                if (!cancelled) setBanditRecommendationEntityIds(recommendationEntityIds);
            } catch (error) {
                console.error("Failed to fetch GRS recommendations", error);
            } finally{
                if (cancelled) return;
                const currentVariantSlots = variantSlotsRef.current;
                const resolvedChosenVariantIndex = $63970a701463a0fa$var$getBanditChosenIndex(recommendationEntityIds, currentVariantSlots);
                const resolvedVariant = resolvedChosenVariantIndex !== null ? currentVariantSlots[resolvedChosenVariantIndex] : undefined;
                const resolvedShouldRenderVariant = isEnrolledInExperimentPlusOverride && resolvedVariant;
                const resolvedSelectedVariantKey = resolvedShouldRenderVariant && resolvedVariant ? $63970a701463a0fa$var$getVariantId(resolvedVariant) ?? `variant_${resolvedChosenVariantIndex}` : "default";
                if (analyticsClient) createAnalyticsEvent({
                    name: "waeBanditVariantRender",
                    action: "banditVariantRender",
                    actionSubject: "uniformPage",
                    eventType: "screen",
                    source: window.location.pathname,
                    attributes: {
                        containerName: props.name,
                        path: window.location.pathname,
                        compositionId: compositionId,
                        variantName: resolvedSelectedVariantKey,
                        status: resolvedSelectedVariantKey,
                        recommendations: recommendationEntityIds
                    }
                }).fire();
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        analyticsClient,
        anonymousId,
        channel,
        compositionId,
        createAnalyticsEvent,
        isEnrolledInExperimentPlusOverride,
        locale,
        props.name,
        subAnchor,
        utmContent
    ]);
    if (isProd) return renderedVariant;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                onMouseEnter: ()=>setIsPanelExpanded(true),
                onMouseLeave: ()=>setIsPanelExpanded(false),
                onFocus: ()=>setIsPanelExpanded(true),
                onBlur: (event)=>{
                    if (!event.currentTarget.contains(event.relatedTarget)) setIsPanelExpanded(false);
                },
                className: (0, $2jatx.default)([
                    "_kqswstnw _152t1b66 _rjxp1b66 _1pbyrpof _1e0c116y _2lx21bp4 _4cvr1fhb _syaz15cr _19itidpf _2rkoftgi _p12fgx0z _1yt4jjoz _bfhk1tj6 _18k91p0y _tzy4x7ai _v5641baa",
                    isPanelExpanded && "_bfhk1tj6 _18k91m5u _tzy4kb7n _1yt412x7"
                ]),
                style: {
                    "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                        className: (0, $2jatx.default)([
                            "_1e0c116y _4cvr1h6o _gy1p1b66 _1ul9idpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1skh _vwz4cjiy _k48p1fw0 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1ul9idpf _p12f11ux"
                                ]),
                                children: props.name
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                                "aria-label": `Contextual bandits variant override for ${props.useCaseId}`,
                                value: String(override),
                                onChange: (event)=>{
                                    const next = event.target.value;
                                    setOverride(next === $63970a701463a0fa$var$OVERRIDE_DEFAULT ? $63970a701463a0fa$var$OVERRIDE_DEFAULT : Number(next));
                                },
                                className: (0, $2jatx.default)([
                                    "_19itidpf _2rkow7q6 _1yt41ppf _1wyb19bv _vwz4cjiy _k48p1fw0 _80omtlke _syazi7uo _bfhkvuon _1ygb7g83 _1ah3yh40"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                        value: $63970a701463a0fa$var$OVERRIDE_DEFAULT,
                                        children: "default"
                                    }),
                                    variantSlots.map((_, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("option", {
                                            value: index,
                                            children: [
                                                "variant ",
                                                index
                                            ]
                                        }, index))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": !isPanelExpanded,
                        className: (0, $2jatx.default)([
                            "_1reo15vq _18m915vq _c71lidpf _1pfhidpf _tzy4idpf _lcxvglyw _t9ecr915 _v564rl08",
                            isPanelExpanded && "_c71lzwfg _1pfhu2gc _tzy4kb7n _lcxv1wug _t9ec1kli"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                            title: props.experimentId ? `Force experiment "${props.experimentId}" to behave as enrolled in non-production environments. Does not affect real Statsig enrollment.` : "No experimentId is configured on this contextual bandits container, so there is no experiment to override.",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1wpz1fhb _1bah1yb4 _gy1pu2gc _1wyb1skh _vwz4cjiy _k48p1fw0 _80omtlke _uiztglyw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: "Experiment Override"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    type: "checkbox",
                                    "aria-label": `Force experiment enrollment override for ${props.useCaseId}`,
                                    disabled: !props.experimentId,
                                    checked: isExperimentOverridden,
                                    // Removed from the tab order while the row is
                                    // collapsed and visually hidden. Restored when the
                                    // panel is hovered / focused.
                                    tabIndex: isPanelExpanded ? 0 : -1,
                                    onChange: ()=>$63970a701463a0fa$var$toggleExperimentOverride(setIsExperimentOverridden),
                                    className: (0, $2jatx.default)([
                                        "_1bsb1crf _4t3i1crf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1j551ou4 _j5dh13gf _1ygb7g83 _1ah3yh40"
                                    ])
                                })
                            ]
                        })
                    })
                ]
            }),
            renderedVariant
        ]
    });
};
var $63970a701463a0fa$export$2e2bcd8739ae039 = $63970a701463a0fa$var$UniformContextualBanditsContainer;

});

parcelRegister("Ms48M", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce67b152ccdba354$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");
const $ce67b152ccdba354$var$UniformContextualBanditsVariant = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "content"
    });
};
var $ce67b152ccdba354$export$2e2bcd8739ae039 = $ce67b152ccdba354$var$UniformContextualBanditsVariant;

});

parcelRegister("kEr7H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23264f0466262a10$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $2O9Y7 = parcelRequire("2O9Y7");

var $6XpQD = parcelRequire("6XpQD");

var $kDYqJ = parcelRequire("kDYqJ");
const $23264f0466262a10$var$UniformCustomerGallery = ({ items: items, isMotionAvailable: isMotionAvailable, motionDelay: motionDelay, motionForward: transformForward, motionBackward: transformBackward })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedItems = (0, $f2QWG.flattenValues)(items);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kDYqJ.GalleryContainer), {
        isMotionAvailable: isMotionAvailable,
        motionDelay: motionDelay,
        children: flattenedItems.map((item, index)=>{
            if (item) {
                if ("quote" in item) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "entry-item",
                    style: {
                        // @ts-expect-error -- CSS custom property not in CSSProperties type
                        "--gc-item-i": index
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2O9Y7.CustomerQuote), {
                        logoSrc: item.companyLogo?.at(0)?.src ?? "",
                        logoAlt: item.companyLogo?.at(0)?.alt ?? "",
                        name: item.advocateName ?? "",
                        title: item.advocateJobTitle ?? "",
                        company: item.companyName ?? "",
                        quote: item.quote ?? "",
                        ctaLinkText: item.ctaLinkText,
                        ctaLinkUrl: item.ctaUrl,
                        ctaLinkDataEventProps: item.ctaLinkText ? {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "customersSection",
                            "data-product-key": "uniform",
                            "data-label": item.ctaLinkText
                        } : undefined,
                        imageSrc: item.advocateHeadshot?.at(0)?.src ?? "",
                        imageAlt: item.advocateHeadshot?.at(0)?.alt,
                        color: item.color,
                        motionConfig: transformForward && transformBackward ? {
                            transformForward: transformForward,
                            transformBackward: transformBackward
                        } : undefined
                    })
                }, index);
                else if ("statNumber" in item) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "entry-item",
                    style: {
                        // @ts-expect-error -- CSS custom property not in CSSProperties type
                        "--gc-item-i": index
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6XpQD.CustomerStat), {
                        logoSrc: item.logo?.at(0)?.src ?? "",
                        logoAlt: item.logo?.at(0)?.alt ?? "",
                        statValue: item.statNumber?.toString() ?? "",
                        statModifier: item.statModifier,
                        description: item.description ?? "",
                        linkText: item.ctaText,
                        linkHref: item.ctaUrl,
                        linkDataEventProps: item.ctaText ? {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "customersSection",
                            "data-product-key": "uniform",
                            "data-label": item.ctaText
                        } : undefined,
                        color: item.color,
                        motionConfig: transformForward && transformBackward ? {
                            transformForward: transformForward,
                            transformBackward: transformBackward
                        } : undefined
                    })
                }, index);
            }
        })
    });
};
var $23264f0466262a10$export$2e2bcd8739ae039 = $23264f0466262a10$var$UniformCustomerGallery;

});
parcelRegister("2O9Y7", function(module, exports) {
$parcel$export(module.exports, "CustomerQuote", function () { return $a9e6bc4742132548$export$615b20b92b568a40; });
/* customer-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $a9e6bc4742132548$export$3855eab3480168d5 = (color)=>{
    const map = {
        blue: {
            quoteBackground: (0, $kbpa7.wacToken)("color.extended.blue800"),
            imageBackground: (0, $kbpa7.wacToken)("color.extended.blue200"),
            textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
        },
        lime: {
            quoteBackground: (0, $kbpa7.wacToken)("color.extended.lime800"),
            imageBackground: (0, $kbpa7.wacToken)("color.extended.lime200"),
            textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
        },
        purple: {
            quoteBackground: (0, $kbpa7.wacToken)("color.extended.purple800"),
            imageBackground: (0, $kbpa7.wacToken)("color.extended.purple200"),
            textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
        },
        orange: {
            quoteBackground: (0, $kbpa7.wacToken)("color.extended.orange700"),
            imageBackground: (0, $kbpa7.wacToken)("color.extended.saffron200"),
            textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
        }
    };
    return map[color];
};
const $a9e6bc4742132548$var$customerQuoteStyles = null;
const $a9e6bc4742132548$var$linkImageContainerStyles = null;
const $a9e6bc4742132548$var$customerImageStyles = null;
const $a9e6bc4742132548$var$customerQuoteContentStyles = null;
const $a9e6bc4742132548$var$linkQuoteContainerStyles = null;
const $a9e6bc4742132548$var$logoStyles = null;
const $a9e6bc4742132548$var$logoColoringStyles = null;
const $a9e6bc4742132548$var$quoteIconStyles = null;
const $a9e6bc4742132548$var$logoQuoteStackStyles = null;
const $a9e6bc4742132548$export$615b20b92b568a40 = ({ logoSrc: logoSrc, logoAlt: logoAlt, name: name, title: title, quote: quote, ctaLinkText: ctaLinkText, ctaLinkUrl: ctaLinkUrl, ctaLinkDataEventProps: ctaLinkDataEventProps, imageSrc: imageSrc, imageAlt: imageAlt, color: color, motionConfig: motionConfig })=>{
    const isValidLink = ctaLinkUrl && ctaLinkText;
    const uniqueId = (0, $1oC0p.useId)();
    const attributionId = `customer-quote-attribution-${uniqueId}`;
    const linkId = `customer-quote-link-${uniqueId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("article", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21sbv _4cvresu3 _p12fq7f4 _19pkidpf _2hwx1wug _otyridpf _18u01wug _ceho1kau _j6qu1ogm _1rkb1178 _m6k41e03 _t9ecy7a9 _dk9v15m1",
            isValidLink && "_vms7ab0i _71ml1784 _7b4d1784 _1o5w120f _1es6120f",
            motionConfig?.transformForward && "_t9ecg30n _dk9vwey4"
        ]),
        style: {
            "--customer-quote-bg": $a9e6bc4742132548$export$3855eab3480168d5(color).quoteBackground,
            "--customer-quote-img-bg": $a9e6bc4742132548$export$3855eab3480168d5(color).imageBackground,
            "--customer-quote-text": $a9e6bc4742132548$export$3855eab3480168d5(color).textColor,
            "--_1oyjq9z": (0, $6ZVlx.default)(motionConfig?.transformForward),
            "--_1vdjstz": (0, $6ZVlx.default)(motionConfig?.transformBackward)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rkovwyg _p12f1kvu _1e0c1txw _16jlkb7n _2lx21bp4 _zulputpp _1yt41uzm _bfhk1os4 _syaz1oll _flz01ejb _cehoufrr _1acz1uzm _1lzopxbi _j6qu1kdj _13znps30 _1cqsu2gc _1rfm1osq _1rkb1178 _15txxy5q",
                    isValidLink && "_kqswh2mm _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _17qt1kw7 _w6hs1kw7 _biez1kw7 _9yql1kw7 _65a7kb7n _1tmikb7n _1rpbkb7n _j8p3kb7n _1k67kb7n _cv5ikb7n _7awzkb7n _vxx0kb7n _g2lz4jg8 _msyw4jg8 _17ed4jg8 _1o3r4jg8 _4zvn4jg8 _1vl64jg8 _x7ym4jg8 _14414jg8 _1kt9b3bt _1cs8stnw _1g0v1mrw _iajmidpf _1812idpf _1jx8vwyg _1u5svwyg _kfgtckbl _1rus1kw7 _pdykxgvd _ecfcs44g _1r9es44g _fg6xc38t _15g7c38t"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1p571jfw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                src: logoSrc,
                                alt: logoAlt,
                                height: "40",
                                className: (0, $2jatx.default)([
                                    "_1bsbmlf1 _4t3i1tcg _5ral1f51 _rsuf1048 _165tzwfg",
                                    "_kdamj8h6 _16buj8h6"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                width: "63",
                                height: "54",
                                viewBox: "0 0 63 54",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                className: (0, $2jatx.default)([
                                    "_1bsb1h39 _4t3i1l27 _1hr2fhn8 _15951ylp _1rfm1qjk _tnruzwfg"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                    d: "M58.2 41.4C58.2 49.2 53.2 54 46 54C38.2 54 32 48.8 32 34C32 14.4 43.2 0.999999 63 0V12.2C54.4 12.8 47 18.2 45 29H46.4C53.6 29 58.2 33.8 58.2 41.4ZM26.2 41.4C26.2 49.2 21.2 54 14 54C6.2 54 0 48.8 0 34C0 14.4 11.2 0.999999 31 0V12.2C22.4 12.8 15 18.2 13 29H14.4C21.6 29 26.2 33.8 26.2 41.4Z",
                                    fill: "var(--customer-quote-text)"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        className: (0, $2jatx.default)([
                            "_1pfhidpf _6rthu2gc _syaztohn",
                            "callout-sm"
                        ]),
                        children: [
                            quote,
                            "\u201D"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        id: attributionId,
                        className: (0, $2jatx.default)([
                            "_syaztohn",
                            "body-md"
                        ]),
                        children: [
                            name.toUpperCase(),
                            ", ",
                            title
                        ]
                    }),
                    isValidLink && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaztohn",
                            "body-md"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            id: linkId,
                            href: ctaLinkUrl,
                            text: ctaLinkText,
                            ariaLabelledby: `${linkId} ${attributionId}`,
                            "aria-label": ctaLinkText,
                            bgColor: "bgBlackBlue",
                            type: "primary",
                            className: "full-card",
                            dataEventProps: ctaLinkDataEventProps
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_bfhk3jub _1o2w1n0t _1bsb1gwv _1o9zidpf _vwz4idpf _19pk1wug _2hwxdzxt _otyridpf _18u0idpf _kqswh2mm _2rkovwyg _1reo15vq _18m915vq _mezj1osq _bna71wug _v4pn1ule _1jpx1f51 _1j3s1fw2 _1hr21mjv _12rrp3fh _sugaglyw _t9ec5igf",
                    "card-image"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: imageSrc,
                    alt: imageAlt ?? "",
                    width: "360"
                })
            })
        ]
    });
};

});

parcelRegister("6XpQD", function(module, exports) {
$parcel$export(module.exports, "CustomerStat", function () { return $eef05c7db30f41b6$export$e6dcb98258d692b5; });
/* customer-stat.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $eef05c7db30f41b6$var$colorMap = {
    blue: {
        bg: (0, $kbpa7.wacToken)("color.extended.blue700"),
        text: (0, $kbpa7.wacToken)("color.neutral.light0"),
        linkBg: "bgBlackBlue"
    },
    blueLight: {
        bg: (0, $kbpa7.wacToken)("color.extended.blue200"),
        text: (0, $kbpa7.wacToken)("color.primary.black"),
        linkBg: "bgColored"
    },
    lime: {
        bg: (0, $kbpa7.wacToken)("color.extended.lime800"),
        text: (0, $kbpa7.wacToken)("color.neutral.light0"),
        linkBg: "bgBlackBlue"
    },
    limeLight: {
        bg: (0, $kbpa7.wacToken)("color.extended.lime200"),
        text: (0, $kbpa7.wacToken)("color.primary.black"),
        linkBg: "bgColored"
    },
    purple: {
        bg: (0, $kbpa7.wacToken)("color.extended.purple800"),
        text: (0, $kbpa7.wacToken)("color.neutral.light0"),
        linkBg: "bgBlackBlue"
    },
    purpleLight: {
        bg: (0, $kbpa7.wacToken)("color.extended.purple200"),
        text: (0, $kbpa7.wacToken)("color.primary.black"),
        linkBg: "bgColored"
    },
    orange: {
        bg: (0, $kbpa7.wacToken)("color.extended.orange700"),
        text: (0, $kbpa7.wacToken)("color.neutral.light0"),
        linkBg: "bgBlackBlue"
    },
    orangeLight: {
        bg: (0, $kbpa7.wacToken)("color.extended.saffron200"),
        text: (0, $kbpa7.wacToken)("color.primary.black"),
        linkBg: "bgColored"
    },
    black: {
        bg: (0, $kbpa7.wacToken)("color.primary.black"),
        text: (0, $kbpa7.wacToken)("color.neutral.light0"),
        linkBg: "bgBlackBlue"
    }
};
const $eef05c7db30f41b6$var$containerCss = null;
const $eef05c7db30f41b6$var$logoImageCss = null;
/** Dark stat surfaces use light body text; invert a dark logo asset so it reads as light (same idea as `CustomerQuote`). */ const $eef05c7db30f41b6$var$logoOnDarkSurfaceCss = null;
const $eef05c7db30f41b6$var$fullStatCss = null;
const $eef05c7db30f41b6$var$statRowCss = null;
/** Atlassian Mono — matches Desktop XL spec at `above.lg`; scales down on smaller breakpoints. */ const $eef05c7db30f41b6$var$statValueCss = null;
const $eef05c7db30f41b6$var$statModifierCss = null;
const $eef05c7db30f41b6$var$linkWrapCss = null;
const $eef05c7db30f41b6$export$e6dcb98258d692b5 = ({ logoSrc: logoSrc, logoAlt: logoAlt, statValue: statValue, statModifier: statModifier, description: description, linkText: linkText, linkHref: linkHref, linkDataEventProps: linkDataEventProps, color: color = "blue", motionConfig: motionConfig })=>{
    const { bg: surfaceBg, text: surfaceText, linkBg: linkBg } = $eef05c7db30f41b6$var$colorMap[color];
    const logoOnDarkSurface = surfaceText === (0, $kbpa7.wacToken)("color.neutral.light0");
    const uniqueId = (0, $1oC0p.useId)();
    const statDescriptionId = `customer-stat-description-${uniqueId}`;
    const linkId = `customer-stat-link-${uniqueId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "data-testid": "customer-stat",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _2rkovwyg _1yt4xy5q _1bsb1178 _12rrnklw _1hr21gwv _6ru5xilx _m6k41e03 _t9ecy7a9 _dk9v15m1 _kqswh2mm _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _17qt1kw7 _w6hs1kw7 _biez1kw7 _9yql1kw7 _65a7kb7n _1tmikb7n _1rpbkb7n _j8p3kb7n _1k67kb7n _cv5ikb7n _7awzkb7n _vxx0kb7n _g2lz4jg8 _msyw4jg8 _17ed4jg8 _1o3r4jg8 _4zvn4jg8 _1vl64jg8 _x7ym4jg8 _14414jg8 _1kt9b3bt _1cs8stnw _1g0v1mrw _iajmidpf _1812idpf _1jx8vwyg _1u5svwyg _kfgtckbl _1rus1kw7 _pdykxgvd _ecfcs44g _1r9es44g _fg6xc38t _15g7c38t",
            motionConfig?.transformForward && "_t9ecg30n _dk9vwey4"
        ]),
        style: {
            backgroundColor: surfaceBg,
            color: surfaceText,
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_1oyjq9z": (0, $6ZVlx.default)(motionConfig?.transformForward),
            "--_1vdjstz": (0, $6ZVlx.default)(motionConfig?.transformBackward)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: logoSrc,
                alt: logoAlt,
                height: "40",
                className: (0, $2jatx.default)([
                    "_5ral1f51 _rsuf2bpp _1bsbmlf1 _4t3i1tcg _165tzwfg",
                    logoOnDarkSurface && "_kdamj8h6 _16buj8h6"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp7vkz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx2vrvc _4cvr1q9y _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_ect41tx7 _zg8l4jg8 _k48p1fw0 _1dyzj39m _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1iqs1jhh _1wyb1wqb _vwz4ys9h _1lzoymf6 _119zys9h _flz0ys9h _280zys9h _fz8916xz _1ol916xz _1ken24x1 _zu7r1yfw"
                                ]),
                                children: statValue
                            }),
                            statModifier && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_ect41tx7 _zg8l4jg8 _k48p1fw0 _1dyzj39m _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1iqs1jhh _1wybzwfg _vwz41wqb _1lzo1ylp _119z1wqb _flz01ylp _280z1wqb _fz89vbgk _1ol9tudo _1ken24x1 _zu7r1yfw"
                                ]),
                                children: statModifier
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        id: statDescriptionId,
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1ken24x1 _zu7r1yfw",
                            "callout-sm"
                        ]),
                        style: {
                            color: surfaceText
                        },
                        children: description
                    })
                ]
            }),
            linkText && linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wyb1j6v _3p1c1cby"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    id: linkId,
                    text: linkText,
                    href: linkHref,
                    type: "primary",
                    bgColor: linkBg,
                    ariaLabelledby: `${linkId} ${statDescriptionId}`,
                    "aria-label": linkText,
                    className: "full-card",
                    dataEventProps: linkDataEventProps
                })
            })
        ]
    });
};

});


parcelRegister("cDjwJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b49d11c3d700c7d0$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $4MQZO = parcelRequire("4MQZO");
const $b49d11c3d700c7d0$export$760d8d36b06866af = (props)=>{
    const statProps = {
        ...props
    };
    statProps.stats = (0, $f2QWG.flattenValues)(props.stats);
    return statProps;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b49d11c3d700c7d0$var$UniformCustomerStat = (props)=>{
    const statProps = $b49d11c3d700c7d0$export$760d8d36b06866af(props);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4MQZO.CustomerDetailsStats), {
        ...statProps
    });
};
var $b49d11c3d700c7d0$export$2e2bcd8739ae039 = $b49d11c3d700c7d0$var$UniformCustomerStat;

});
parcelRegister("4MQZO", function(module, exports) {
$parcel$export(module.exports, "CustomerDetailsStats", function () { return $f63b6970ed36f5a7$export$60ec57d65c4d2d2b; });
/* customer-details-stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");
// Stats become vertical when the viewport is tablet or smaller
const $f63b6970ed36f5a7$var$containerStyle = null;
const $f63b6970ed36f5a7$var$horizontalContainerWithThreeStatsStyle = null;
const $f63b6970ed36f5a7$var$statsContainerStyle = null;
const $f63b6970ed36f5a7$var$statStyle = null;
const $f63b6970ed36f5a7$var$statTextStyle = null;
const $f63b6970ed36f5a7$var$horizontalStatStyle = null;
const $f63b6970ed36f5a7$var$horizontalStatTextStyle = null;
const $f63b6970ed36f5a7$var$layoutStyle = null;
const $f63b6970ed36f5a7$var$oneStatDesktopStyle = null;
// Stat number color to be changed in the future to be dynamic based on the page-level accent color
const $f63b6970ed36f5a7$var$isEmptyStats = (currentObject)=>JSON.stringify(currentObject) === "{}";
const $f63b6970ed36f5a7$export$60ec57d65c4d2d2b = ({ title: title, stats: stats })=>{
    if (!stats || stats?.every($f63b6970ed36f5a7$var$isEmptyStats)) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_2rkovwyg _1wpz1h6o _11q71rga _18zrxy5q _1e0c1txw _2lx21bp4 _zulp1ejb _1rjcxy5q _1bhl1ejb _2osnpxbi",
                stats?.length === 1 && "_glte12it _xtn71wug",
                stats?.length === 3 && "_glteqciz _u5ggze3t _xtn7ukr8"
            ]),
            style: {
                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "eyebrow-md",
                    role: "heading",
                    "aria-level": 2,
                    children: title
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("dl", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _zulpxy5q _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2osn1ejb _1gde1bp4 _8164pxbi"
                    ]),
                    children: stats?.map((stat, idx)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1wpz1fhb _16jlkb7n _i0dlidpf _2lx21bp4",
                                    stats?.length < 3 && "_1inivrvc _pdlmxy5q"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("dt", {
                                        className: (0, $2jatx.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            stats?.length < 3 && "_cdjm1h6o",
                                            "stat-sm"
                                        ]),
                                        children: stat?.stat
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("dd", {
                                        className: (0, $2jatx.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            stats?.length < 3 && "_cdjm1h6o",
                                            "body-md"
                                        ]),
                                        children: stat?.statDescription
                                    })
                                ]
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
};

});


parcelRegister("gl1tq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2fb2f2d214994b84$export$2e2bcd8739ae039; });
/* customer-stories-details-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $je135 = parcelRequire("je135");

var $b9OTp = parcelRequire("b9OTp");

var $avaxs = parcelRequire("avaxs");
const $2fb2f2d214994b84$var$heroContainerCss = null;
const $2fb2f2d214994b84$export$74f30557f8a70c45 = ({ title: title, subtitle: subtitle, imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition?.data?._id;
    const tracker = (0, $je135.useScrollTracking)("UniformCustomerStoriesDetailsHero", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7603UniformPageDwellTime) ? tracker?.ref : null,
        className: (0, $2jatx.default)([
            "_1e0c11p5 _1bah1yb4 _1pfhxy5q _p12f1osq _vchhusvi _zulp1tcg _1bsb1osq _yv0ei47z _pdlmzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b9OTp.default), {
                title: title,
                subtitle: subtitle,
                alignment: imgSrc ? "left" : "center"
            }),
            quote && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $avaxs.default), {
                imgSrc: imgSrc,
                imgAlt: imgAlt,
                quote: quote,
                author: author,
                role: role,
                company: company
            })
        ]
    });
};
var $2fb2f2d214994b84$export$2e2bcd8739ae039 = $2fb2f2d214994b84$export$74f30557f8a70c45;

});
parcelRegister("b9OTp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $134c9de5826b2c34$export$2e2bcd8739ae039; });
/* hero-intro.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
const $134c9de5826b2c34$var$UniformHeroIntro = ({ title: title, subtitle: subtitle, alignment: alignment })=>{
    const heroContainer = null;
    const textCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_y3gnoues _yv0ecx6w _1e0c11p5 _gy1p1tcg _1rqtaigu _ikjdzwfg"
        ]),
        style: {
            "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $6ZVlx.default)(alignment == "center" ? "2" : "1")
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg",
                    "body-lg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $6ZVlx.default)(alignment == "center" ? "2" : "1")
                },
                children: subtitle
            })
        ]
    });
};
var $134c9de5826b2c34$export$2e2bcd8739ae039 = $134c9de5826b2c34$var$UniformHeroIntro;

});

parcelRegister("avaxs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d76d7b05240d3961$export$2e2bcd8739ae039; });
/* customer-stories-details-hero-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $ftgEA = parcelRequire("ftgEA");

var $ksvEJ = parcelRequire("ksvEJ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $je135 = parcelRequire("je135");
const $d76d7b05240d3961$var$quoteBodyCss = null;
const $d76d7b05240d3961$var$quoteStylingWithImage = null;
const $d76d7b05240d3961$var$quoteStylingNoImage = null;
const $d76d7b05240d3961$var$imageCss = null;
const $d76d7b05240d3961$var$quoteContainerStyles = null;
const $d76d7b05240d3961$export$d35b0bc1e0617ca6 = ({ imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition?.data?._id;
    const tracker = (0, $je135.useScrollTracking)("UniformCustomerStoriesDetailsHeroQuote", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    const authorDetails = [
        role,
        company
    ].filter(Boolean).join(", ");
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7603UniformPageDwellTime) ? tracker?.ref : null,
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0ecx6w _zulp1tcg _4cvr1h6o _6a6zv2br _1rqtaigu _pdlmzwfg"
        ]),
        children: [
            imgSrc && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1461kb7n _f0zu1ohn _nw6ekb7n _1jpu1mrw _uhi5kb7n _eao7qfx8"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                    contentType: /* Since we do not pass in the direct Contentful image via Uniform,
      this uses a rough assumption to trigger a webp transformation */ imgSrc.endsWith(".png") ? "image/png" : undefined,
                    src: imgSrc,
                    alt: imgAlt ?? "",
                    style: {
                        maxWidth: "100%"
                    },
                    baseWidth: 440
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1461kb7n _f0zu1mrw _1vb6grf3",
                    imgSrc ? "_1e3c1gti" : "_1e3ceqnf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ksvEJ.PullQuote), {
                    quote: quote ?? "",
                    authorName: author ?? "",
                    authorDetails: authorDetails,
                    alignment: imgSrc ? "start" : "center",
                    size: "large",
                    variant: "basic"
                })
            })
        ]
    });
};
var $d76d7b05240d3961$export$2e2bcd8739ae039 = $d76d7b05240d3961$export$d35b0bc1e0617ca6;

});


parcelRegister("hvVOW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $34f3707412098f34$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $i1SI4 = parcelRequire("i1SI4");
const $34f3707412098f34$var$transformContentfulImage = (image, alt = "")=>{
    if (!image?.file?.url) return undefined;
    return {
        contentType: image.file.contentType || "image",
        src: image.file.url,
        alt: alt,
        baseWidth: 500,
        width: image.file.details?.image?.width,
        height: image.file.details?.image?.height
    };
};
const $34f3707412098f34$var$transformUniformCompanyLogo = (logos, alt = "")=>{
    const logo = logos?.[0];
    if (!logo?.src) return undefined;
    return {
        contentType: "image",
        src: logo.src,
        alt: logo.alt ?? alt,
        baseWidth: 500,
        width: logo.width,
        height: undefined
    };
};
const $34f3707412098f34$var$transformUniformHeadshot = (headshots)=>{
    const headshot = headshots?.[0];
    if (!headshot?.src) return undefined;
    return {
        contentType: "image",
        src: headshot.src,
        alt: headshot.alt ?? "",
        baseWidth: 500,
        width: undefined,
        height: undefined
    };
};
const $34f3707412098f34$var$transformCta = (url, text)=>{
    if (!url || !text) return undefined;
    return {
        url: url,
        text: text
    };
};
const $34f3707412098f34$var$isContentfulQuote = (quote)=>{
    return "fields" in quote && quote.fields !== undefined;
};
const $34f3707412098f34$var$transformContentfulQuote = (quote)=>{
    const { fields: fields } = quote;
    const cta = fields.advocateCta?.[0]?.fields;
    const companyName = fields.organization?.fields?.organizationNameExternal ?? "";
    return {
        logo: $34f3707412098f34$var$transformContentfulImage(fields.organization?.fields?.logo?.[0]?.fields, companyName),
        name: fields.advocateName,
        title: fields.advocateJobTitle,
        image: $34f3707412098f34$var$transformContentfulImage(fields.advocateHeadshot?.fields),
        quote: fields.advocateQuote,
        link: $34f3707412098f34$var$transformCta(cta?.ctaUrl, cta?.ctaButtonText),
        label: companyName
    };
};
const $34f3707412098f34$var$transformUniformQuote = (quote)=>{
    return {
        logo: $34f3707412098f34$var$transformUniformCompanyLogo(quote.companyLogo, quote.companyName),
        name: quote.advocateName,
        title: quote.advocateJobTitle,
        image: $34f3707412098f34$var$transformUniformHeadshot(quote.advocateHeadshot),
        quote: quote.quote,
        link: $34f3707412098f34$var$transformCta(quote.ctaUrl, quote.ctaLinkText),
        label: quote.companyName
    };
};
const $34f3707412098f34$var$isValidTestimonial = (quote)=>{
    return !!quote.logo && !!quote.name && !!quote.title && !!quote.image && !!quote.quote;
};
const $34f3707412098f34$var$flattenUniformQuote = (quote)=>{
    if (!quote || typeof quote !== "object") return null;
    try {
        return (0, $f2QWG.flattenValues)(quote);
    } catch  {
        return null;
    }
};
const $34f3707412098f34$var$transformProps = (props)=>{
    let testimonials;
    if (props.uniformQuotes) {
        // Uniform CMS: flatten each raw quote entry, then transform
        const flattenedQuotes = (props.uniformQuotes ?? []).map($34f3707412098f34$var$flattenUniformQuote).filter((quote)=>quote !== null);
        testimonials = flattenedQuotes.map($34f3707412098f34$var$transformUniformQuote);
    } else {
        // Contentful fallback
        const contentfulQuotes = props.quotes ?? [];
        testimonials = contentfulQuotes.filter((quote)=>quote !== null && quote !== undefined).map((quote)=>{
            if ($34f3707412098f34$var$isContentfulQuote(quote)) return $34f3707412098f34$var$transformContentfulQuote(quote);
            return $34f3707412098f34$var$transformUniformQuote(quote);
        });
    }
    return {
        bgColor: props.theme ?? "white",
        testimonials: testimonials.filter($34f3707412098f34$var$isValidTestimonial)
    };
};
const $34f3707412098f34$var$UniformCustomerTestimonials = (props)=>{
    //TODO GWP-6632: add CTA links, and ensure they are localized in each panel
    const { bgColor: bgColor, testimonials: testimonials } = $34f3707412098f34$var$transformProps(props);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i1SI4.CustomerTestimonials), {
        bgColor: bgColor,
        testimonials: testimonials
    });
};
var $34f3707412098f34$export$2e2bcd8739ae039 = $34f3707412098f34$var$UniformCustomerTestimonials;

});

parcelRegister("2m9G1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $672275a99d24ea5f$export$2e2bcd8739ae039; });
/* design-refresh-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $3uttc = parcelRequire("3uttc");
const $672275a99d24ea5f$var$UniformDesignRefreshBar = ({ backgroundDesign: backgroundDesign = "blueShapes" })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _4t3i7vkz _1reo15vq _18m915vq _1vymcqtm _1wlt1q3m",
            backgroundDesign
        ]),
        style: {
            "--_r4erkq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue400")),
            "--_ee0w4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.saffron200"))
        },
        children: backgroundDesign === "orangePurpleShapes" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3uttc.OrangePurpleShapes), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3uttc.BlueShapes), {})
    });
};
const $672275a99d24ea5f$var$containerCss = null;
var $672275a99d24ea5f$export$2e2bcd8739ae039 = $672275a99d24ea5f$var$UniformDesignRefreshBar;

});
parcelRegister("3uttc", function(module, exports) {
$parcel$export(module.exports, "BlueShapes", function () { return $460ff537c7911762$export$5a5238b19420ab54; });
$parcel$export(module.exports, "OrangePurpleShapes", function () { return $460ff537c7911762$export$20a09cdb7c5c22c2; });

var $7VQPk = parcelRequire("7VQPk");
const $460ff537c7911762$export$5a5238b19420ab54 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            width: "100%"
        },
        xmlns: "http://www.w3.org/2000/svg",
        width: "1440",
        height: "16",
        viewBox: "0 0 1440 16",
        fill: "none",
        preserveAspectRatio: "xMidYMid slice",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M522.691 -149.313L621.485 -121.386L580.24 -97.898L561.353 -54.3125L522.772 -149.313H522.691ZM678.227 -60.6081C720.037 -62.8681 755.713 -30.8247 758.054 10.9852L769.354 219.631C771.614 261.441 739.57 297.117 697.76 299.457C655.95 301.798 620.275 269.674 617.934 227.864L606.634 19.2181C604.374 -22.5918 636.417 -58.2674 678.227 -60.6081Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M333.17 -168.762L304.112 -70.291L281.028 -111.859L237.685 -131.23L333.17 -168.762ZM242.689 -14.1947C244.465 27.6152 212.018 62.9679 170.208 64.7436L-38.5995 73.7029C-80.4094 75.4786 -115.762 43.0316 -117.538 1.22166C-119.314 -40.5882 -86.8664 -75.941 -45.0565 -77.7167L163.751 -86.676C205.561 -88.4517 240.913 -56.0047 242.689 -14.1947Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M542.063 168.623L481.447 85.8102L528.422 92.671L570.151 69.9902L542.063 168.623ZM474.102 2.99762C439.798 -20.9745 431.323 -68.1922 455.295 -102.576L574.833 -273.933C598.805 -308.236 646.023 -316.711 680.407 -292.739C714.791 -268.767 723.185 -221.549 699.213 -187.165L579.676 -15.8088C555.704 18.4947 508.486 26.9697 474.102 2.99762Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1065.58 213.497L1095.52 115.268L1118.2 156.997L1161.39 176.772L1065.58 213.416V213.497ZM1157.43 59.7368C1155.98 17.9269 1188.75 -17.1838 1230.64 -18.6366L1439.45 -25.7395C1481.26 -27.1924 1516.37 5.57762 1517.82 47.4682C1519.27 89.3589 1486.5 124.389 1444.61 125.842L1235.8 132.944C1193.99 134.397 1158.88 101.627 1157.43 59.7368Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M72.0586 -332.128L170.853 -304.201L129.608 -280.713L110.721 -237.128L72.1394 -332.128H72.0586ZM227.675 -243.423C269.485 -245.683 305.161 -213.64 307.502 -171.83L318.802 36.8161C321.062 78.626 289.018 114.302 247.208 116.642C205.398 118.983 169.723 86.8589 167.382 45.049L156.082 -163.597C153.822 -205.407 185.865 -241.082 227.675 -243.423Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-17.1288 192.192L-66.6873 102.276L-20.9223 115.11L23.3896 97.9176L-17.1288 192.192ZM-63.378 19.1407C-94.3722 -9.02853 -96.7128 -56.9727 -68.5436 -87.9669L71.9797 -242.696C100.149 -273.69 148.093 -276.031 179.087 -247.862C210.081 -219.692 212.422 -171.748 184.253 -140.754L43.7297 13.975C15.5605 44.9692 -32.3838 47.3099 -63.378 19.1407Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M736.746 141.664L638.597 171.77L660.552 129.637L652.803 82.7424L736.746 141.664ZM557.883 151.511C523.983 176.129 476.604 168.542 451.987 134.642L329.301 -34.5352C304.683 -68.4351 312.27 -115.814 346.17 -140.432C380.07 -165.05 427.45 -157.463 452.067 -123.563L574.753 45.614C599.37 79.5139 591.783 126.893 557.883 151.511Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M96.5958 58.8487L89.6543 -43.5775L125.653 -12.5833L173.032 -9.43549L96.515 58.8487H96.5958ZM127.751 -117.512C111.528 -156.093 129.688 -200.566 168.351 -216.709L361.015 -297.585C399.597 -313.808 444.07 -295.648 460.213 -256.986C476.356 -218.324 458.276 -173.931 419.614 -157.788L226.949 -76.9125C188.368 -60.6889 143.894 -78.8496 127.751 -117.512Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M58.4199 -174.657L154.873 -209.768L135.179 -166.505L145.349 -120.095L58.4199 -174.577V-174.657ZM236.475 -193.787C269.084 -220.099 316.786 -215.014 343.099 -182.406L474.34 -19.8477C500.652 12.7608 495.567 60.4627 462.959 86.7755C430.35 113.088 382.648 108.003 356.336 75.3949L225.094 -87.1634C198.782 -119.772 203.867 -167.474 236.475 -193.787Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-234.572 -1.28267L-146.029 -53.1819L-157.652 -7.09409L-139.33 36.7336L-234.572 -1.28267ZM-62.8935 -52.0519C-35.6121 -83.7725 12.2515 -87.324 43.9721 -60.0426L202.333 76.2834C234.054 103.565 237.605 151.428 210.324 183.149C183.042 214.87 135.179 218.421 103.458 191.14L-54.9026 54.8136C-86.6233 27.5322 -90.1749 -20.3313 -62.8935 -52.0519Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M79.082 -205.732L181.75 -207.185L148.9 -172.882L143.169 -125.745L79.082 -205.813V-205.732ZM253.505 -165.133C292.894 -179.258 336.318 -158.676 350.443 -119.287L420.826 77.4936C434.95 116.882 414.368 160.306 374.98 174.431C335.591 188.556 292.167 167.974 278.042 128.586L207.66 -68.1954C193.535 -107.584 214.117 -151.008 253.505 -165.133Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M232.761 284.202L206.287 185.005L247.613 208.492L294.75 202.439L232.842 284.202H232.761ZM229.533 105.178C206.206 70.3905 215.489 23.3342 250.276 0.00784302L423.812 -116.382C458.599 -139.708 505.656 -130.426 528.982 -95.6383C552.309 -60.8505 543.026 -13.7942 508.239 9.53218L334.703 125.922C299.915 149.248 252.859 139.966 229.533 105.178Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M702.764 6.86975L772.178 82.4988L724.718 80.8846L685.733 108.085L702.764 6.95042V6.86975ZM788.644 163.939C825.45 183.956 839.01 229.964 818.993 266.769L719.149 450.313C699.132 487.119 653.125 500.679 616.319 480.661C579.514 460.644 565.954 414.637 585.971 377.832L685.814 194.288C705.831 157.482 751.838 143.922 788.644 163.939Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M25.7318 280.489L-76.9366 279.117L-43.1982 245.702L-36.2566 198.726L25.651 280.489H25.7318ZM-147.481 235.128C-187.273 248.123 -230.051 226.492 -243.127 186.7L-308.183 -11.857C-321.178 -51.6491 -299.546 -94.4275 -259.754 -107.503C-219.962 -120.579 -177.184 -98.8668 -164.108 -59.0747L-99.0522 139.482C-86.0572 179.274 -107.689 222.052 -147.481 235.128Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M542.144 -134.379L600.419 -49.8712L553.605 -58.1041L511.23 -36.6341L542.144 -134.46V-134.379ZM605.343 33.1835C639.001 58.1242 646.023 105.584 621.082 139.242L496.621 307.127C471.68 340.785 424.22 347.807 390.563 322.866C356.905 297.926 349.883 250.466 374.823 216.808L499.284 48.9228C524.225 15.265 571.685 8.24289 605.343 33.1835Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1128.93 -45.8364L1059.6 29.8734L1057.18 -17.5864L1026.75 -54.0692L1129.02 -45.8364H1128.93ZM979.856 53.2805C963.067 91.6197 918.432 109.135 880.012 92.3461L688.558 8.64565C650.219 -8.14288 632.704 -52.7779 649.493 -91.1978C666.281 -129.618 710.916 -147.052 749.336 -130.263L940.79 -46.5628C979.129 -29.7742 996.644 14.8606 979.856 53.2805Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M93.043 -421.964L191.837 -394.036L150.592 -370.549L131.705 -326.963L93.1238 -421.964H93.043ZM248.66 -333.34C290.47 -335.6 326.145 -303.556 328.486 -261.746L339.786 -53.1003C342.046 -11.2903 310.003 24.3853 268.193 26.726C226.383 29.0667 190.707 -3.05746 188.366 -44.8674L177.066 -253.513C174.806 -295.323 206.85 -330.999 248.66 -333.34Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M12.4946 102.275L86.8325 31.4883L86.0253 79.0289L113.871 117.529L12.4141 102.355L12.4946 102.275ZM168.031 13.5698C187.402 -23.5587 233.167 -38.0066 270.295 -18.6352L455.615 77.8989C492.744 97.2703 507.191 143.035 487.82 180.164C468.449 217.292 422.684 231.74 385.555 212.369L200.236 115.835C163.107 96.4632 148.659 50.6983 168.031 13.5698Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M9.66917 58.3648L-50.9472 -24.4479L-3.97153 -17.5872L37.7575 -40.2678L9.66917 58.3648ZM-58.373 -107.261C-92.6765 -131.233 -101.151 -178.45 -77.1793 -212.835L42.3583 -384.191C66.3304 -418.494 113.548 -426.969 147.932 -402.997C182.316 -379.025 190.711 -331.807 166.739 -297.423L47.2012 -126.067C23.2291 -91.7635 -23.9888 -83.2885 -58.373 -107.261Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M872.022 203.165L837.315 106.55L880.416 126.487L926.907 116.559L872.022 203.246V203.165ZM853.7 25.029C827.548 -7.66019 832.875 -55.3622 865.565 -81.5136L1028.77 -212.028C1061.46 -238.18 1109.16 -232.853 1135.31 -200.163C1161.46 -167.474 1156.14 -119.772 1123.45 -93.6207L960.242 36.894C927.553 63.0454 879.851 57.7182 853.7 25.029Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M47.5254 -29.9348L138.087 -78.2019L124.608 -32.6792L141.154 11.875L47.5254 -29.9348ZM221.142 -73.7626C249.714 -104.353 297.659 -105.968 328.249 -77.3948L480.96 65.2271C511.551 93.7998 513.165 141.744 484.592 172.335C456.02 202.925 408.075 204.54 377.485 175.967L224.774 33.345C194.183 4.77221 192.569 -43.172 221.142 -73.7626Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-242.238 -69.8073L-143.444 -41.8803L-184.689 -18.3925L-203.576 25.1932L-242.158 -69.8073H-242.238ZM-86.6216 18.8975C-44.8117 16.6375 -9.13597 48.681 -6.79526 90.4909L4.50467 299.137C6.76466 340.947 -25.2788 376.622 -67.0887 378.963C-108.899 381.304 -144.574 349.18 -146.915 307.37L-158.215 98.7238C-160.475 56.9139 -128.432 21.2383 -86.6216 18.8975Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M987.206 -78.118L1056.62 -2.48898L1009.16 -4.10323L970.175 23.0974L987.206 -78.0374V-78.118ZM1073.09 79.0323C1109.89 99.0494 1123.45 145.056 1103.43 181.862L1003.59 365.406C983.573 402.211 937.566 415.771 900.761 395.754C863.955 375.737 850.395 329.73 870.412 292.925L970.256 109.381C990.273 72.5751 1036.28 59.0152 1073.09 79.0323Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M347.458 28.4211L249.31 58.5275L271.264 16.3947L263.515 -30.5002L347.458 28.4211ZM168.676 38.2683C134.776 62.8861 87.3972 55.299 62.7794 21.3991L-59.9061 -147.778C-84.5239 -181.678 -76.9366 -229.057 -43.0367 -253.675C-9.13676 -278.292 38.2424 -270.705 62.8602 -236.805L185.545 -67.6286C210.163 -33.7286 202.576 13.6505 168.676 38.2683Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M358.197 14.78L261.098 48.1956L281.599 5.33649L272.236 -41.2356L358.116 14.78H358.197ZM179.819 30.7614C146.807 56.5092 99.1854 50.5363 73.4376 17.5243L-54.8977 -147.375C-80.6455 -180.387 -74.6728 -228.008 -41.6607 -253.756C-8.64867 -279.504 38.9726 -273.531 64.7204 -240.519L193.056 -75.6197C218.804 -42.6077 212.831 5.01358 179.819 30.7614Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-275.492 -25.2512L-179.039 -60.3619L-198.733 -17.0992L-188.563 29.3114L-275.492 -25.1706V-25.2512ZM-97.4369 -44.3806C-64.8284 -70.6934 -17.1265 -65.6083 9.18634 -32.9998L140.428 129.558C166.74 162.167 161.655 209.869 129.047 236.182C96.4383 262.494 48.7364 257.409 22.4236 224.801L-108.818 62.2428C-135.13 29.6343 -130.045 -18.0678 -97.4369 -44.3806Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-200.834 -55.6016L-98.1656 -57.0544L-131.016 -22.7509L-136.747 24.3861L-200.834 -55.6823V-55.6016ZM-26.4915 -15.0024C12.897 -29.1274 56.3212 -8.54521 70.4462 30.8433L140.829 227.624C154.954 267.013 134.372 310.437 94.9831 324.562C55.5946 338.687 12.1706 318.105 -1.95435 278.716L-72.337 81.9353C-86.462 42.5468 -65.88 -0.877438 -26.4915 -15.0024Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-23.6664 286.223L-50.1406 187.025L-8.81504 210.513L38.322 204.459L-23.5859 286.223H-23.6664ZM-26.9757 107.118C-50.3021 72.3303 -41.0199 25.274 -6.23214 1.94759L167.303 -114.442C202.091 -137.769 249.147 -128.486 272.474 -93.6987C295.8 -58.9109 286.518 -11.8546 251.73 11.4718L78.1947 127.862C43.407 151.188 -3.64934 141.906 -26.9757 107.118Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M420.508 -427.13L489.923 -351.501L442.463 -353.115L403.478 -325.915L420.508 -427.049V-427.13ZM506.388 -270.06C543.194 -250.043 556.754 -204.036 536.737 -167.231L436.893 16.3132C416.876 53.1188 370.869 66.6787 334.063 46.6616C297.258 26.6445 283.698 -19.3624 303.715 -56.1681L403.558 -239.712C423.575 -276.518 469.582 -290.078 506.388 -270.06Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M270.537 366.611L168.596 354.666L205.644 324.882L217.428 278.875L270.618 366.611H270.537ZM102.814 303.735C61.8915 312.614 21.5346 286.624 12.6561 245.702L-31.5753 41.495C-40.4539 0.572971 -14.4639 -39.7841 26.4581 -48.6626C67.3802 -57.5412 107.737 -31.5512 116.616 9.37084L160.847 213.578C169.726 254.5 143.736 294.857 102.814 303.735Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M37.8359 9.6945L135.016 42.7067L92.5601 64.0152L71.413 106.551L37.8359 9.61383V9.6945ZM188.61 106.309C230.5 106.229 264.481 140.048 264.562 181.938L265.046 390.907C265.127 432.798 231.308 466.779 189.417 466.859C147.526 466.94 113.546 433.121 113.465 391.23L112.981 182.261C112.9 140.371 146.719 106.39 188.61 106.309Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-222.382 255.471L-236.83 153.851L-198.652 182.101L-151.112 181.779L-222.382 255.551V255.471ZM-204.222 77.2538C-223.189 39.9638 -208.338 -5.72038 -171.048 -24.6882L15.1594 -119.447C52.4493 -138.414 98.1335 -123.563 117.101 -86.2731C136.069 -48.9832 121.218 -3.29896 83.9277 15.6689L-102.28 110.427C-139.57 129.395 -185.254 114.544 -204.222 77.2538Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M278.045 383.725L176.103 371.779L213.151 341.996L224.935 295.989L278.125 383.725H278.045ZM110.402 320.849C69.4795 329.727 29.1225 303.737 20.244 262.815L-23.9874 58.6088C-32.866 17.6867 -6.87603 -22.6703 34.046 -31.5488C74.9681 -40.4274 115.325 -14.4375 124.204 26.4845L168.435 230.691C177.314 271.613 151.324 311.97 110.402 320.849Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-78.1484 -116.458L20.6455 -88.5315L-20.5992 -65.0436L-39.4866 -21.458L-78.0679 -116.458H-78.1484ZM77.4683 -27.7538C119.278 -30.0138 154.954 2.02982 157.294 43.8397L168.594 252.486C170.854 294.296 138.811 329.971 97.001 332.312C55.1911 334.653 19.5156 302.528 17.1749 260.719L5.87497 52.0725C3.61497 10.2626 35.6584 -25.4131 77.4683 -27.7538Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-348.379 298.329L-342.89 195.822L-310.847 230.932L-264.194 239.811L-348.379 298.329ZM-296.076 127.053C-307.457 86.7769 -284.05 44.8864 -243.773 33.5057L-42.7146 -23.3978C-2.43829 -34.7785 39.4523 -11.3714 50.833 28.9049C62.2137 69.1812 38.8067 111.072 -1.4696 122.453L-202.528 179.356C-242.805 190.737 -284.696 167.33 -296.076 127.053Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M875.171 -15.4877L790.26 42.223L798.816 -4.51054L777.588 -47.0469L875.171 -15.4877ZM707.205 46.5815C682.022 80.0779 634.563 86.7771 601.066 61.675L433.988 -63.8353C400.492 -89.0181 393.792 -136.478 418.894 -169.974C443.997 -203.471 491.537 -210.17 525.033 -185.068L692.112 -59.5575C725.608 -34.3747 732.307 13.0851 707.205 46.5815Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M475.314 98.7224L563.858 46.8232L552.235 92.911L570.557 136.739L475.314 98.7224ZM646.993 47.9532C674.275 16.2325 722.138 12.6811 753.859 39.9624L912.22 176.289C943.941 203.57 947.492 251.433 920.211 283.154C892.929 314.875 845.066 318.426 813.345 291.145L654.984 154.819C623.263 127.537 619.712 79.6738 646.993 47.9532Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M366.107 -277.164L466.92 -257.793L427.773 -230.834L412.68 -185.796L366.107 -277.164ZM528.666 -202.1C570.153 -207.912 608.492 -179.097 614.303 -137.61L643.441 69.3412C649.253 110.828 620.438 149.167 578.951 154.979C537.464 160.79 499.124 131.975 493.313 90.4883L464.175 -116.463C458.364 -157.95 487.179 -196.289 528.666 -202.1Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1295.13 -155.608L1266.07 -57.1369L1242.99 -98.7046L1199.65 -118.076L1295.13 -155.608ZM1204.65 -1.04045C1206.43 40.7695 1173.98 76.1222 1132.17 77.8979L923.361 86.8572C881.552 88.6329 846.199 56.1857 844.423 14.3758C842.647 -27.4341 875.094 -62.7868 916.904 -64.5625L1125.71 -73.5218C1167.52 -75.2975 1202.87 -42.8504 1204.65 -1.04045Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1505.47 209.866L1444.86 127.053L1491.83 133.914L1533.56 111.233L1505.47 209.866ZM1437.43 44.1595C1403.13 20.1875 1394.65 -27.0303 1418.62 -61.4145L1538.16 -232.771C1562.13 -267.074 1609.35 -275.549 1643.73 -251.577C1678.12 -227.605 1686.51 -180.387 1662.54 -146.003L1543 25.3531C1519.03 59.6566 1471.81 68.1316 1437.43 44.1595Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M265.532 479.129L171.419 438.127L215.489 420.37L240.107 379.77L265.532 479.129ZM123.314 370.246C81.5845 366.856 50.5095 330.293 53.8995 288.563L70.7687 80.321C74.1587 38.5918 110.722 7.51693 152.451 10.9069C194.181 14.2969 225.255 50.8604 221.865 92.5895L204.996 300.832C201.606 342.561 165.043 373.636 123.314 370.246Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1037.65 -313.566L1136.44 -285.639L1095.2 -262.151L1076.31 -218.565L1037.73 -313.566H1037.65ZM1193.27 -224.861C1235.08 -227.121 1270.75 -195.078 1273.09 -153.268L1284.39 55.3782C1286.65 97.1881 1254.61 132.864 1212.8 135.204C1170.99 137.545 1135.31 105.421 1132.97 63.6111L1121.67 -145.035C1119.41 -186.845 1151.46 -222.52 1193.27 -224.861Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M484.195 -43.2518L576.371 1.94818L531.574 17.6874L505.181 57.1566L484.276 -43.2518H484.195ZM621.329 71.9273C662.897 77.1737 692.276 115.109 686.949 156.677L660.636 363.951C655.39 405.519 617.454 434.899 575.887 429.571C534.319 424.244 504.939 386.389 510.266 344.822L536.579 137.548C541.825 95.9801 579.761 66.6002 621.329 71.9273Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M945.393 202.037L895.834 112.121L941.599 124.955L985.911 107.763L945.393 202.037ZM899.143 29.0665C868.149 0.897278 865.809 -47.0469 893.978 -78.0411L1034.5 -232.77C1062.67 -263.764 1110.61 -266.105 1141.61 -237.936C1172.6 -209.767 1174.94 -161.822 1146.77 -130.828L1006.25 23.9008C978.082 54.895 930.138 57.2357 899.143 29.0665Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1693.85 178.55L1595.7 208.656L1617.66 166.523L1609.91 119.628L1693.85 178.55ZM1515.07 188.477C1481.17 213.095 1433.79 205.508 1409.17 171.608L1286.49 2.43135C1261.87 -31.4686 1269.46 -78.8477 1303.36 -103.465C1337.26 -128.083 1384.64 -120.496 1409.25 -86.5963L1531.94 82.5805C1556.56 116.48 1548.97 163.86 1515.07 188.477Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M563.128 429.488L483.786 364.352L531.004 359.348L565.791 326.982L563.128 429.488ZM456.02 285.979C416.793 271.37 396.857 227.703 411.547 188.476L484.593 -7.25551C499.202 -46.4826 542.869 -66.4189 582.096 -51.7289C621.323 -37.039 641.259 6.54653 626.569 45.7736L553.523 241.505C538.914 280.732 495.247 300.669 456.02 285.979Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1426.29 -288.786L1443.07 -187.49L1404.25 -214.852L1356.79 -213.399L1426.37 -288.786H1426.29ZM1412.32 -110.327C1432.18 -73.4409 1418.38 -27.5146 1381.57 -7.65891L1197.62 91.458C1160.74 111.314 1114.81 97.5116 1094.95 60.706C1075.1 23.9003 1088.9 -22.1067 1125.71 -41.9624L1309.65 -141.079C1346.54 -160.935 1392.47 -147.133 1412.32 -110.327Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1021.34 -150.683L1117.79 -185.793L1098.1 -142.531L1108.27 -96.12L1021.34 -150.602V-150.683ZM1199.4 -169.812C1232.01 -196.125 1279.71 -191.04 1306.02 -158.431L1437.26 4.12689C1463.57 36.7354 1458.49 84.4373 1425.88 110.75C1393.27 137.063 1345.57 131.978 1319.26 99.3694L1188.02 -63.1888C1161.7 -95.7973 1166.79 -143.499 1199.4 -169.812Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M721.086 5.9808L809.629 -45.9184L798.006 0.16938L816.328 43.9971L721.086 5.9808ZM892.765 -44.7884C920.046 -76.5091 967.91 -80.0604 999.63 -52.779L1157.99 83.5471C1189.71 110.828 1193.26 158.692 1165.98 190.413C1138.7 222.133 1090.84 225.685 1059.12 198.403L900.756 62.0771C869.035 34.7957 865.483 -13.0678 892.765 -44.7884Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M390.238 314.391L332.043 229.803L378.857 238.116L421.232 216.646L390.238 314.391ZM327.2 146.829C293.623 121.888 286.601 74.4282 311.542 40.7704L436.083 -127.034C461.024 -160.611 508.484 -167.633 542.142 -142.693C575.8 -117.752 582.741 -70.2922 557.8 -36.6344L433.258 131.17C408.318 164.747 360.858 171.769 327.2 146.829Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M715.514 12.7603L613.411 2.18683L650.055 -28.081L661.194 -74.2494L715.514 12.7603ZM546.983 -47.9367C506.223 -38.4931 465.462 -63.9987 456.099 -104.759L409.124 -308.401C399.68 -349.162 425.186 -389.922 465.946 -399.285C506.707 -408.648 547.467 -383.223 556.83 -342.462L603.806 -138.821C613.249 -98.0601 587.744 -57.2995 546.983 -47.9367Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1039.66 -183.456L1142.33 -184.908L1109.48 -150.605L1103.75 -103.468L1039.66 -183.536V-183.456ZM1214.09 -142.856C1253.47 -156.981 1296.9 -136.399 1311.02 -97.0108L1381.41 99.7701C1395.53 139.159 1374.95 182.583 1335.56 196.708C1296.17 210.833 1252.75 190.251 1238.62 150.862L1168.24 -45.9189C1154.11 -85.3074 1174.7 -128.732 1214.09 -142.856Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1187.85 312.13L1161.38 212.933L1202.7 236.421L1249.84 230.367L1187.93 312.13H1187.85ZM1184.54 133.026C1161.22 98.2382 1170.5 51.1818 1205.29 27.8554L1378.82 -88.5343C1413.61 -111.861 1460.66 -102.579 1483.99 -67.7908C1507.32 -33.003 1498.04 14.0533 1463.25 37.3797L1289.71 153.769C1254.92 177.096 1207.87 167.814 1184.54 133.026Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M979.615 277.827L876.947 276.455L910.685 243.039L917.627 196.064L979.534 277.827H979.615ZM806.322 232.546C766.53 245.541 723.751 223.91 710.676 184.118L645.62 -14.4388C632.625 -54.2309 654.257 -97.0094 694.049 -110.085C733.841 -123.161 776.619 -101.449 789.695 -61.6566L854.75 136.9C867.745 176.692 846.114 219.471 806.322 232.546Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M152.776 102.679L138.328 1.05984L176.506 29.3098L224.047 28.987L152.776 102.76V102.679ZM170.937 -75.4571C151.969 -112.747 166.82 -158.431 204.11 -177.399L390.318 -272.157C427.607 -291.125 473.292 -276.274 492.259 -238.984C511.227 -201.694 496.376 -156.01 459.086 -137.042L272.879 -42.2836C235.589 -23.3158 189.904 -38.1672 170.937 -75.4571Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1063.96 -402.027L1162.75 -374.1L1121.51 -350.612L1102.62 -307.026L1064.04 -402.027H1063.96ZM1219.57 -313.322C1261.38 -315.582 1297.06 -283.539 1299.4 -241.729L1310.7 -33.0826C1312.96 8.72726 1280.92 44.4029 1239.11 46.7436C1197.3 49.0843 1161.62 16.96 1159.28 -24.8499L1147.98 -233.496C1145.72 -275.306 1177.76 -310.981 1219.57 -313.322Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M965.083 124.632L1039.42 53.8452L1038.61 101.386L1066.46 139.886L965.002 124.712L965.083 124.632ZM1120.62 35.9267C1139.99 -1.2018 1185.76 -15.6495 1222.88 3.72184L1408.2 100.256C1445.33 119.627 1459.78 165.392 1440.41 202.521C1421.04 239.649 1375.27 254.097 1338.14 234.726L1152.82 138.192C1115.7 118.82 1101.25 73.0552 1120.62 35.9267Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M980.499 68.2108L919.882 -14.6018L966.858 -7.74109L1008.59 -30.4217L980.499 68.2108ZM912.537 -97.4952C878.234 -121.467 869.759 -168.685 893.731 -203.069L1013.27 -374.425C1037.24 -408.729 1084.46 -417.204 1118.84 -393.232C1153.23 -369.26 1161.62 -322.042 1137.65 -287.658L1018.11 -116.302C994.139 -81.998 946.921 -73.5232 912.537 -97.4952Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M987.924 9.21087L1076.23 -43.1725L1064.84 2.91518L1083.41 46.6622L987.924 9.21087ZM1159.36 -42.5268C1186.48 -74.4089 1234.34 -78.2025 1266.23 -51.0826L1425.31 84.4365C1457.2 111.556 1460.99 159.42 1433.87 191.302C1406.75 223.184 1358.89 226.978 1327 199.858L1167.92 64.3386C1136.03 37.2187 1132.24 -10.6447 1159.36 -42.5268Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M708.33 -70.3748L807.124 -42.4476L765.879 -18.9598L746.992 24.6258L708.411 -70.3748H708.33ZM863.947 18.3301C905.757 16.0701 941.432 48.1135 943.773 89.9235L955.073 298.569C957.333 340.379 925.289 376.055 883.48 378.396C841.67 380.736 805.994 348.612 803.653 306.802L792.353 98.1563C790.093 56.3464 822.137 20.6708 863.947 18.3301Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1311.99 42.3828L1213.84 72.4892L1235.8 30.3564L1228.05 -16.5385L1311.99 42.3828ZM1133.21 52.3107C1099.31 76.9285 1051.93 69.3413 1027.31 35.4413L904.627 -133.735C880.009 -167.635 887.597 -215.014 921.497 -239.632C955.396 -264.25 1002.78 -256.663 1027.39 -222.763L1150.08 -53.5863C1174.7 -19.6864 1167.11 27.6929 1133.21 52.3107Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M647.477 260.072L653.046 157.565L685.089 192.675L731.742 201.554L647.557 260.072H647.477ZM699.779 88.7963C688.399 48.5199 711.806 6.62935 752.082 -4.75134L953.141 -61.6548C993.417 -73.0355 1035.31 -49.6283 1046.69 -9.35198C1058.07 30.9244 1034.66 72.8149 994.386 84.1956L793.327 141.099C753.051 152.48 711.16 129.073 699.779 88.7963Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M324.782 -125.743L399.12 -196.529L398.312 -148.988L426.159 -110.488L324.701 -125.662L324.782 -125.743ZM480.399 -214.528C499.77 -251.657 545.535 -266.105 582.663 -246.733L767.983 -150.199C805.111 -130.828 819.559 -85.0629 800.188 -47.9344C780.816 -10.8059 735.052 3.64194 697.923 -15.7294L512.604 -112.263C475.475 -131.635 461.027 -177.4 480.399 -214.528Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M679.201 -21.3796L775.655 -56.4902L755.96 -13.2275L766.13 33.1831L679.201 -21.2989V-21.3796ZM857.176 -40.5088C889.784 -66.8215 937.486 -61.7367 963.799 -29.1282L1095.04 133.43C1121.35 166.039 1116.27 213.741 1083.66 240.053C1051.05 266.366 1003.35 261.281 977.036 228.673L845.795 66.1145C819.482 33.506 824.567 -14.196 857.176 -40.5088Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M751.354 -50.1961L854.022 -51.6489L821.171 -17.3454L815.441 29.7916L751.354 -50.2767V-50.1961ZM925.777 -9.59689C965.165 -23.7219 1008.59 -3.13969 1022.71 36.2488L1093.1 233.03C1107.22 272.418 1086.64 315.842 1047.25 329.967C1007.86 344.092 964.439 323.51 950.314 284.122L879.931 87.3408C865.806 47.9523 886.388 4.52808 925.777 -9.59689Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M931.668 298.813L905.193 199.615L946.519 223.103L993.656 217.049L931.748 298.813H931.668ZM928.358 119.789C905.032 85.0013 914.314 37.9448 949.102 14.6184L1122.64 -101.771C1157.42 -125.098 1204.48 -115.815 1227.81 -81.0277C1251.13 -46.2399 1241.85 0.816399 1207.06 24.1428L1033.53 140.532C998.741 163.859 951.685 154.577 928.358 119.789Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M603.732 -291.286L635.13 -193.541L592.674 -214.93L545.941 -206.536L603.732 -291.286ZM615.92 -112.585C640.941 -79.0079 634 -31.548 600.423 -6.52667L432.861 118.338C399.283 143.359 351.823 136.418 326.802 102.841C301.781 69.2639 308.722 21.804 342.299 -3.21738L509.862 -128.082C543.439 -153.103 590.899 -146.162 615.92 -112.585Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M691.543 66.923L714.789 -33.0818L740.214 7.03313L784.606 23.9023L691.543 66.923ZM772.741 -92.6488C768.464 -134.297 798.812 -171.506 840.461 -175.704L1048.38 -196.851C1090.03 -201.129 1127.24 -170.78 1131.43 -129.132C1135.63 -87.4832 1105.36 -50.2739 1063.72 -46.0768L855.796 -24.9297C814.148 -20.6519 776.938 -51.0004 772.741 -92.6488Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M940.148 -179.177L1038.94 -151.249L997.697 -127.762L978.81 -84.176L940.229 -179.177H940.148ZM1095.68 -90.4717C1137.49 -92.7317 1173.17 -60.6882 1175.51 -18.8783L1186.81 189.768C1189.07 231.578 1157.03 267.253 1115.22 269.594C1073.41 271.935 1037.73 239.81 1035.39 198L1024.09 -10.6454C1021.83 -52.4553 1053.87 -88.131 1095.68 -90.4717Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M413.892 297.845L387.418 198.647L428.744 222.135L475.881 216.082L413.973 297.845H413.892ZM410.583 118.821C387.257 84.0333 396.539 36.977 431.326 13.6506L604.862 -102.739C639.65 -126.065 686.706 -116.783 710.032 -81.9955C733.359 -47.2077 724.076 -0.151436 689.289 23.1749L515.753 139.565C480.966 162.891 433.909 153.609 410.583 118.821Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1347.43 -140.512L1355.5 -38.1668L1319.1 -68.7574L1271.64 -71.421L1347.43 -140.593V-140.512ZM1318.21 36.0901C1334.84 74.5101 1317.16 119.145 1278.74 135.772L1086.96 218.746C1048.54 235.373 1003.91 217.697 987.28 179.277C970.653 140.857 988.329 96.2222 1026.75 79.595L1218.53 -3.37904C1256.95 -20.0061 1301.58 -2.32977 1318.21 36.0901Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M642.223 -419.219L711.637 -343.59L664.177 -345.204L625.192 -318.003L642.223 -419.138V-419.219ZM728.103 -262.149C764.909 -242.132 778.469 -196.125 758.451 -159.32L658.608 24.2242C638.591 61.0299 592.584 74.5899 555.778 54.5728C518.973 34.5557 505.413 -11.4514 525.43 -48.257L625.273 -231.801C645.29 -268.606 691.297 -282.166 728.103 -262.149Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1270.26 -198.707L1339.68 -123.078L1292.22 -124.692L1253.23 -97.4912L1270.26 -198.626V-198.707ZM1356.14 -41.5563C1392.95 -21.5392 1406.51 24.4679 1386.49 61.2735L1286.65 244.817C1266.63 281.623 1220.62 295.183 1183.82 275.166C1147.01 255.149 1133.45 209.142 1153.47 172.336L1253.31 -11.2078C1273.33 -48.0135 1319.34 -61.5734 1356.14 -41.5563Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M819.961 -423.578L889.376 -347.949L841.916 -349.563L802.931 -322.363L819.961 -423.497V-423.578ZM905.841 -266.508C942.647 -246.491 956.207 -200.484 936.19 -163.679L836.346 19.8652C816.329 56.6708 770.322 70.2307 733.517 50.2136C696.711 30.1965 683.151 -15.8104 703.168 -52.6161L803.011 -236.16C823.029 -272.966 869.036 -286.526 905.841 -266.508Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-139.759 284.393L-158.727 183.5L-119.338 209.974L-71.8782 207.553L-139.839 284.393H-139.759ZM-129.589 105.611C-150.252 69.2088 -137.418 22.9595 -101.016 2.29665L80.8329 -100.694C117.235 -121.357 163.484 -108.524 184.147 -72.1217C204.81 -35.7197 191.976 10.5296 155.574 31.1924L-26.2747 134.184C-62.6767 154.846 -108.926 142.013 -129.589 105.611Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M987.739 145.08L927.123 62.2674L974.098 69.1279L1015.83 46.4473L987.739 145.08ZM919.778 -20.5453C885.474 -44.5174 876.999 -91.735 900.971 -126.119L1020.51 -297.475C1044.48 -331.779 1091.7 -340.254 1126.08 -316.282C1160.47 -292.31 1168.86 -245.092 1144.89 -210.708L1025.35 -39.3516C1001.38 -5.0481 954.162 3.42676 919.778 -20.5453Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1028.52 99.1669L930.368 129.273L952.323 87.1406L944.574 40.2457L1028.52 99.1669ZM849.735 109.014C815.835 133.632 768.456 126.045 743.838 92.1448L621.152 -77.0319C596.535 -110.932 604.122 -158.311 638.022 -182.929C671.922 -207.547 719.301 -199.959 743.919 -166.06L866.604 3.11716C891.222 37.0171 883.635 84.3962 849.735 109.014Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M1072.99 -81.7939L1149.34 -150.401L1147.16 -102.941L1173.88 -63.714L1072.91 -81.7939H1072.99ZM1231.03 -166.059C1251.45 -202.623 1297.61 -215.699 1334.18 -195.359L1516.67 -93.5781C1553.24 -73.1574 1566.31 -26.989 1545.97 9.57452C1525.55 46.138 1479.38 59.2135 1442.82 38.8735L1260.32 -62.9068C1223.76 -83.3275 1210.69 -129.496 1231.03 -166.059Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M237.112 65.8336L137.753 91.7428L161.403 50.5786L155.672 3.44154L237.032 65.8336H237.112ZM58.0887 68.1742C23.2202 91.2584 -23.8362 81.7343 -47.0011 46.8658L-162.422 -127.315C-185.507 -162.184 -175.982 -209.24 -141.114 -232.405C-106.245 -255.57 -59.1889 -245.965 -36.024 -211.096L79.3972 -36.9155C102.481 -2.04701 92.9572 45.0092 58.0887 68.1742Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M377.556 -218.359L402.82 -118.839L361.817 -142.811L314.6 -137.403L377.556 -218.359ZM378.606 -39.3351C401.448 -4.30518 391.601 42.6704 356.571 65.5932L181.583 179.804C146.553 202.646 99.5771 192.798 76.6543 157.769C53.7315 122.739 63.6594 75.7631 98.6894 52.8403L273.677 -61.3701C308.707 -84.2122 355.683 -74.365 378.606 -39.3351Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M103.526 -236.604L181.899 -170.338L134.601 -165.979L99.3287 -134.097L103.445 -236.604H103.526ZM208.535 -91.5605C247.52 -76.3863 266.81 -32.3973 251.636 6.5876L175.684 201.27C160.51 240.255 116.521 259.546 77.5358 244.371C38.5509 229.197 19.2603 185.208 34.4345 146.223L110.387 -48.4592C125.561 -87.4441 169.55 -106.735 208.535 -91.5605Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-114.965 -112.141L-17.7851 -79.0483L-60.2407 -57.7396L-81.3877 -15.2034L-114.965 -112.141ZM35.7284 -15.3647C77.619 -15.3647 111.6 18.4543 111.68 60.3449L112.003 269.314C112.003 311.204 78.1839 345.185 36.2933 345.266C-5.59731 345.346 -39.5779 311.447 -39.6586 269.556L-39.9815 60.587C-39.9815 18.6964 -6.16225 -15.284 35.7284 -15.3647Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M437.12 132.989L344.622 177.463L359.958 132.505L345.268 87.3049L437.12 132.909V132.989ZM261.809 169.633C232.026 199.013 184.001 198.69 154.621 168.826L7.96342 19.9894C-21.4165 -9.79412 -21.0936 -57.819 8.77061 -87.1989C38.6348 -116.579 86.579 -116.256 115.959 -86.3917L262.616 62.4451C291.996 92.2286 291.673 140.253 261.809 169.633Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-28.8398 -166.139L59.7035 -218.038L48.0807 -171.95L66.4028 -128.122L-28.8398 -166.139ZM142.92 -216.908C170.201 -248.628 218.065 -252.18 249.785 -224.899L408.146 -88.5724C439.867 -61.2911 443.418 -13.4277 416.137 18.2929C388.856 50.0136 340.992 53.5649 309.271 26.2835L150.91 -110.042C119.19 -137.324 115.638 -185.187 142.92 -216.908Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M499.761 168.742L441.566 84.1533L488.381 92.4668L530.755 70.9968L499.761 168.742ZM436.723 1.1792C403.146 -23.7614 396.124 -71.2215 421.065 -104.879L545.607 -272.684C570.548 -306.261 618.008 -313.283 651.665 -288.342C685.323 -263.402 692.264 -215.942 667.324 -182.284L542.782 -14.4793C517.841 19.0977 470.381 26.1198 436.723 1.1792Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-57.5799 71.2422L-107.138 -18.6732L-61.3734 -5.83972L-17.0615 -23.0319L-57.5799 71.2422ZM-103.829 -101.728C-134.823 -129.897 -137.164 -177.841 -108.995 -208.836L31.5284 -363.565C59.6977 -394.559 107.642 -396.9 138.636 -368.73C169.63 -340.561 171.971 -292.617 143.802 -261.623L3.2785 -106.894C-24.8907 -75.8997 -72.8349 -73.5589 -103.829 -101.728Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M643.35 123.868L719.706 55.2615L717.526 102.721L744.243 141.948L643.27 123.868H643.35ZM801.388 39.6835C821.809 3.12002 867.978 -9.9557 904.541 10.3842L1087.04 112.165C1123.6 132.586 1136.67 178.754 1116.33 215.317C1095.91 251.881 1049.75 264.956 1013.18 244.616L830.688 142.836C794.124 122.415 781.048 76.247 801.388 39.6835Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M727.775 290.538L708.807 189.646L748.195 216.12L795.655 213.698L727.694 290.538H727.775ZM737.944 111.837C717.282 75.4352 730.115 29.1861 766.517 8.52329L948.366 -94.468C984.768 -115.131 1031.02 -102.297 1051.68 -65.8951C1072.34 -29.4931 1059.51 16.756 1023.11 37.4188L841.258 140.41C804.856 161.073 758.607 148.239 737.944 111.837Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M249.059 -194.79L346.723 -226.43L325.495 -183.974L333.97 -137.24L249.059 -194.79ZM427.679 -207.462C461.175 -232.564 508.716 -225.784 533.818 -192.287L659.167 -25.0478C684.269 8.44856 677.489 55.9891 643.993 81.0912C610.496 106.193 562.956 99.4133 537.854 65.9169L412.505 -101.323C387.403 -134.819 394.183 -182.36 427.679 -207.462Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M309.271 -51.4433L340.669 46.3014L298.214 24.9122L251.48 33.2257L309.271 -51.524V-51.4433ZM321.459 127.177C346.48 160.754 339.539 208.214 305.962 233.235L138.4 358.1C104.822 383.121 57.3626 376.18 32.3412 342.603C7.31985 309.026 14.2612 261.566 47.8383 236.544L215.401 111.68C248.978 86.6585 296.438 93.5998 321.459 127.177Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M356.805 70.1137L281.741 0.0537109L329.201 -1.96414L366.007 -32.0703L356.805 70.1137ZM259.061 -79.9337C220.883 -97.0451 203.772 -141.922 220.883 -180.1L306.359 -370.747C323.471 -408.925 368.348 -426.036 406.525 -408.924C444.703 -391.813 461.814 -346.936 444.703 -308.758L359.227 -118.112C342.115 -79.9338 297.238 -62.8224 259.061 -79.9337Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M307.572 68.9796L205.63 57.0338L242.678 27.2505L254.462 -18.7566L307.653 68.9796H307.572ZM139.929 6.10324C99.0069 14.9818 58.6499 -11.0081 49.7713 -51.9302L5.5399 -256.137C-3.33865 -297.059 22.6513 -337.416 63.5734 -346.294C104.495 -355.173 144.852 -329.183 153.731 -288.261L197.962 -84.0543C206.841 -43.1322 180.851 -2.7753 139.929 6.10324Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M358.262 373.516L256.158 362.943L292.803 332.675L303.941 286.506L358.262 373.516ZM189.811 312.9C149.051 322.343 108.29 296.838 98.9274 256.077L51.9517 52.4356C42.5081 11.675 68.0139 -29.0857 108.774 -38.4485C149.535 -47.8921 190.296 -22.3863 199.659 18.3743L246.634 222.016C256.078 262.776 230.572 303.537 189.811 312.9Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-3.98438 -196.245L98.684 -197.698L65.8333 -163.395L60.1026 -116.257L-3.98438 -196.326V-196.245ZM170.439 -155.646C209.827 -169.771 253.251 -149.189 267.376 -109.8L337.759 86.9808C351.884 126.369 331.302 169.793 291.914 183.918C252.525 198.043 209.101 177.461 194.976 138.073L124.593 -58.7083C110.468 -98.0968 131.05 -141.521 170.439 -155.646Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M422.92 140.894L373.362 50.978L419.127 63.8117L463.439 46.6196L422.92 140.894ZM376.671 -32.1574C345.677 -60.3267 343.336 -108.271 371.505 -139.265L512.028 -293.994C540.198 -324.988 588.142 -327.329 619.136 -299.16C650.13 -270.99 652.471 -223.046 624.302 -192.052L483.778 -37.323C455.609 -6.3288 407.665 -3.98822 376.671 -32.1574Z",
                    fill: "#669DF1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M704.935 157.767L650.776 70.5956L697.106 81.0076L740.45 61.5557L704.935 157.767ZM649.727 -12.6206C617.28 -39.0948 612.518 -86.8777 638.992 -119.244L771.282 -280.995C797.756 -313.442 845.539 -318.204 877.906 -291.73C910.272 -265.256 915.115 -217.473 888.641 -185.107L756.35 -23.3557C729.876 9.09137 682.093 13.8536 649.727 -12.6206Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M402.25 71.9668L320.083 10.4627L367.059 3.27933L400.313 -30.6207L402.25 71.8863V71.9668ZM288.766 -66.6191C248.893 -79.4527 227.101 -122.231 239.934 -162.023L304.183 -360.903C317.016 -400.776 359.795 -422.568 399.587 -409.735C439.379 -396.901 461.252 -354.123 448.419 -314.331L384.17 -115.451C371.337 -75.5785 328.558 -53.7856 288.766 -66.6191Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M335.34 -222.639L431.309 -259.122L412.18 -215.617L422.995 -169.368L335.34 -222.639ZM513.072 -244.27C545.277 -271.067 593.06 -266.628 619.776 -234.423L753.358 -73.7214C780.155 -41.5165 775.716 6.2663 743.511 32.9827C711.306 59.699 663.523 55.3405 636.807 23.1355L503.225 -137.566C476.428 -169.771 480.867 -217.554 513.072 -244.27Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M-232.324 74.8731L-143.781 22.974L-155.404 69.0617L-137.082 112.889L-232.324 74.8731ZM-60.6453 24.1039C-33.364 -7.61673 14.4996 -11.1681 46.2202 16.1133L204.581 152.439C236.302 179.721 239.853 227.584 212.572 259.305C185.291 291.025 137.427 294.577 105.706 267.295L-52.6546 130.969C-84.3752 103.688 -87.9267 55.8245 -60.6453 24.1039Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M465.453 -136.193L459.318 -33.6865L427.517 -68.9585L380.864 -78.0793L465.453 -136.113V-136.193ZM412.101 34.7591C423.239 75.1162 399.59 116.845 359.313 128.065L157.932 183.838C117.575 194.977 75.8456 171.327 64.6263 131.051C53.407 90.7747 77.1369 48.9648 117.413 37.7455L318.795 -18.028C359.152 -29.1665 400.881 -5.51721 412.101 34.7591Z",
                    fill: "#1558BC"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "724",
                            height: "1448",
                            transform: "translate(1440 -80.9999) rotate(90)",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M1848.69 -161.878L1757.55 -237.61C1620.1 -351.828 1451.52 -349.573 1349.08 -226.288L1839.15 180.925C1864.55 202.031 1895.97 197.646 1917.21 172.087L2326.98 -321.054C2204.46 -422.857 2039.83 -391.91 1924.9 -253.59L1848.69 -161.878ZM1887.1 284.312L1795.96 208.58C1658.51 94.3619 1491.18 95.114 1388.74 218.399L1878.81 625.612C1904.21 646.717 1935.88 645.077 1957.12 619.518L2366.88 126.378C2244.37 24.5745 2078.24 54.2799 1963.31 192.6L1887.1 284.312ZM1928.26 730.24L1837.12 654.508C1699.66 540.29 1531.09 542.546 1428.65 665.831L1918.71 1073.04C1944.11 1094.15 1975.54 1089.76 1995.53 1065.71L2405.29 572.568C2282.78 470.765 2118.15 501.711 2003.21 640.031L1928.26 730.24Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M37.1931 -209.403L-81.2826 -211.715C-259.967 -215.202 -390.29 -108.256 -393.417 52.0055L243.632 64.4372C276.65 65.0816 298.472 42.0455 299.121 8.82061L311.63 -632.226C152.368 -635.334 43.0284 -508.427 39.5196 -328.622L37.1931 -209.403ZM345.617 115.306L227.141 112.994C48.4564 109.507 -81.8281 214.498 -84.9555 374.76L552.094 387.192C585.112 387.836 608.838 366.792 609.486 333.567L621.996 -307.479C462.734 -310.587 351.452 -183.718 347.943 -3.91272L345.617 115.306ZM656.021 438.099L537.545 435.787C358.86 432.3 228.538 539.245 225.41 699.507L862.46 711.939C895.478 712.583 917.3 689.547 917.91 658.276L930.42 17.2298C771.157 14.1218 661.818 141.028 658.309 320.834L656.021 438.099Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M296.845 -300.694L219.958 -390.863C103.998 -526.854 -62.4873 -553.385 -184.457 -449.381L228.966 35.457C250.393 60.5858 282.107 61.6255 307.394 40.0637L795.274 -375.953C691.918 -497.163 524.423 -494.751 387.579 -378.063L296.845 -300.694ZM258.583 145.508L181.696 55.3403C65.7361 -80.6508 -99.2618 -108.451 -221.232 -4.44649L192.191 480.392C213.619 505.52 245.106 509.307 270.392 487.745L758.272 71.7276C654.916 -49.4819 486.161 -48.5483 349.317 68.1394L258.583 145.508ZM223.069 591.921L146.182 501.753C30.2221 365.762 -136.263 339.23 -258.233 443.235L155.19 928.073C176.617 953.201 208.331 954.241 232.13 933.948L720.01 517.93C616.655 396.721 449.16 399.133 312.315 515.82L223.069 591.921Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M329.199 698.785L313.025 816.174C288.631 993.22 379.574 1135.17 538.366 1157.05L625.336 525.845C629.843 493.13 609.522 468.759 576.602 464.223L-58.5657 376.708C-80.3081 534.51 32.9168 657.962 211.074 682.509L329.199 698.785ZM687.801 430.521L671.627 547.91C647.233 724.956 736.24 866.642 895.032 888.521L982.001 257.314C986.509 224.599 968.389 198.571 935.469 194.035L300.301 106.52C278.559 264.321 391.519 389.698 569.675 414.245L687.801 430.521ZM1044.73 160.066L1028.56 277.455C1004.16 454.501 1095.11 596.454 1253.9 618.333L1340.87 -12.8748C1345.38 -45.5899 1325.05 -69.9602 1294.07 -74.2292L658.903 -161.745C637.161 -3.94262 750.386 119.51 928.542 144.057L1044.73 160.066Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M879.229 169.576L840.243 57.6752C781.444 -111.094 635.889 -196.152 484.52 -143.416L694.151 458.283C705.016 489.469 734.198 501.93 765.579 490.997L1371.05 280.051C1318.65 129.626 1161.66 71.178 991.832 130.346L879.229 169.576ZM681.875 571.587L642.889 459.685C584.09 290.916 440.381 205.215 289.012 257.951L498.643 859.65C509.508 890.836 537.483 905.775 568.864 894.842L1174.34 683.896C1121.93 533.471 964.307 473.188 794.478 532.356L681.875 571.587ZM487.006 974.788L448.02 862.887C389.221 694.118 243.666 609.06 92.2971 661.796L301.928 1263.49C312.793 1294.68 341.974 1307.14 371.51 1296.85L976.984 1085.91C924.576 935.481 767.592 877.033 597.763 936.201L487.006 974.788Z",
                            fill: "#8FB8F6"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M538.365 1157.05C379.573 1135.17 288.63 993.22 313.024 816.174L329.198 698.786L211.073 682.509C174.933 677.53 141.465 668.48 111.253 655.899C255.689 616.322 391.679 701.177 448.019 862.887L487.005 974.789L567.335 946.801L538.365 1157.05ZM569.675 414.246C450.012 397.758 359.763 335.781 319.988 249.045C448.144 219.964 566.839 289.223 627.856 422.261L569.675 414.246ZM576.602 464.223C609.522 468.759 629.842 493.13 625.335 525.844L574.778 892.78L568.862 894.841C537.481 905.775 509.507 890.836 498.642 859.65L349.998 433.001L576.602 464.223ZM935.469 194.035C968.389 198.571 986.509 224.599 982.001 257.314L959.094 423.576L765.577 490.997C734.196 501.93 705.014 489.468 694.149 458.283L686.859 437.356L687.801 430.521L684.311 430.04L585.276 145.784L935.469 194.035ZM865.633 130.555C730.414 90.2587 647.067 -14.1394 657.046 -144.432C737.818 -115.384 804.794 -44.0668 840.241 57.6754L865.633 130.555ZM910.563 775.794L759.495 828.425C688.988 766.703 655.487 665.046 671.626 547.911L672.193 543.798L681.874 571.587L794.478 532.356C847.465 513.895 899.265 507.062 947.052 510.968L910.563 775.794ZM1296.95 305.868L1030.46 398.713C1023.51 361.157 1022.65 320.335 1028.56 277.455L1044.73 160.066L945.694 146.42L991.831 130.346C1119.23 85.9618 1239.4 107.761 1313.62 184.923L1296.95 305.868Z",
                            fill: "#1558BC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M1503.9 -221.47L1464.91 -333.371C1406.11 -502.141 1260.56 -587.199 1109.19 -534.463L1318.82 67.2363C1329.69 98.422 1358.87 110.883 1390.25 99.9502L1995.72 -110.996C1943.32 -261.42 1786.33 -319.869 1616.5 -260.701L1503.9 -221.47ZM1306.54 180.54L1267.56 68.6389C1208.76 -100.13 1065.05 -185.832 913.682 -133.095L1123.31 468.604C1134.18 499.789 1162.15 514.728 1193.53 503.795L1799.01 292.849C1746.6 142.424 1588.98 82.1418 1419.15 141.309L1306.54 180.54ZM1111.68 583.742L1072.69 471.841C1013.89 303.071 868.336 218.013 716.967 270.749L926.598 872.448C937.463 903.634 966.644 916.095 996.18 905.805L1601.65 694.859C1549.25 544.435 1392.26 485.987 1222.43 545.154L1111.68 583.742Z",
                            fill: "#8FB8F6"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M198.886 -2.53919L99.1717 -66.5612C-51.2176 -163.119 -218.249 -140.273 -304.851 -5.38923L231.32 338.86C259.109 356.702 289.764 348.508 307.718 320.545L654.127 -218.99C520.084 -305.053 360.474 -254.212 263.31 -102.879L198.886 -2.53919ZM291.554 435.609L191.839 371.587C41.4499 275.029 -124.525 296.23 -211.127 431.114L325.043 775.363C352.833 793.205 384.066 787.706 402.02 759.742L748.429 220.207C614.387 134.145 453.141 183.936 355.977 335.269L291.554 435.609ZM386.912 873.161L287.198 809.14C136.808 712.582 -30.2228 735.428 -116.825 870.311L419.346 1214.56C447.135 1232.4 477.79 1224.21 494.688 1197.89L841.097 658.355C707.054 572.293 547.443 623.133 450.28 774.466L386.912 873.161Z",
                            fill: "#8FB8F6"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M307.719 320.545C289.765 348.509 259.11 356.703 231.32 338.861L-121.837 112.115L-221.23 -4.44694C-99.2605 -108.451 65.7372 -80.6509 181.697 55.3402L258.584 145.508L349.317 68.139C404.443 21.1333 464.747 -7.08895 523.868 -16.109L307.719 320.545ZM402.02 759.743C384.066 787.706 352.833 793.206 325.044 775.364L-211.127 431.115C-203.74 419.61 -195.776 408.932 -187.293 399.084C-76.9525 352.626 51.4693 390.677 146.184 501.752L223.07 591.92L312.316 515.82C406.382 435.609 514.931 409.395 607.175 440.213L402.02 759.743ZM232.131 933.947C208.332 954.24 176.618 953.2 155.19 928.072L15.3603 764.086C97.4661 735.761 195.43 750.22 287.198 809.14L339.281 842.579L232.131 933.947ZM270.394 487.744C245.107 509.306 213.62 505.52 192.192 480.391L51.9111 315.876C98.1955 323.465 145.75 341.995 191.84 371.587L291.555 435.61L355.978 335.269C426.12 226.023 529.657 169.693 632.248 179.189L270.394 487.744ZM307.395 40.0629C282.108 61.6247 250.394 60.5852 228.967 35.4564L193.764 -5.82875L198.887 -2.53872L263.311 -102.879C354.332 -244.645 500.155 -298.223 628.423 -233.679L307.395 40.0629Z",
                            fill: "#1558BC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M510.199 866.513L494.025 983.902C469.631 1160.95 560.574 1302.9 719.366 1324.78L806.336 693.572C810.843 660.857 790.522 636.487 757.602 631.951L122.434 544.436C100.692 702.238 213.917 825.69 392.074 850.237L510.199 866.513ZM868.801 598.249L852.627 715.638C828.233 892.684 917.24 1034.37 1076.03 1056.25L1163 425.041C1167.51 392.326 1149.39 366.299 1116.47 361.763L481.301 274.247C459.559 432.049 572.519 557.426 750.675 581.973L868.801 598.249ZM1225.73 327.794L1209.56 445.183C1185.16 622.229 1276.11 764.182 1434.9 786.06L1521.87 154.853C1526.38 122.138 1506.05 97.7676 1475.07 93.4985L839.903 5.98327C818.161 163.785 931.386 287.238 1109.54 311.785L1225.73 327.794Z",
                            fill: "#1868DB"
                        })
                    ]
                })
            ]
        })
    });
const $460ff537c7911762$export$20a09cdb7c5c22c2 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        style: {
            width: "100%"
        },
        xmlns: "http://www.w3.org/2000/svg",
        width: "1440",
        height: "16",
        viewBox: "0 0 1440 16",
        fill: "none",
        preserveAspectRatio: "xMidYMid slice",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1440 -595.542H0.640625V611.939H1440V-595.542Z",
                fill: "#CB7FF5"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M972.322 -144.352L1011.06 -99.1573L983.597 -101.075L960.485 -86.1041L972.369 -144.352H972.322ZM1018.97 -51.6234C1039.88 -39.3189 1046.8 -12.3706 1034.5 8.54243L972.977 112.873C960.673 133.786 933.724 140.711 912.811 128.406C891.898 116.102 884.974 89.1533 897.279 68.2403L958.801 -36.0907C971.106 -57.0037 998.054 -63.928 1018.97 -51.6234Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1198.48 287.663L1146.55 258.609L1172.98 250.937L1189.55 228.901L1198.48 287.663ZM1122.74 216.643C1098.88 212.292 1083.06 189.414 1087.41 165.507L1109.17 46.3447C1113.52 22.4842 1136.4 6.67088 1160.3 11.0219C1184.21 15.3729 1199.98 38.2509 1195.63 62.1581L1173.87 181.32C1169.52 205.181 1146.64 220.994 1122.74 216.643Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M515.791 -125.778L556.026 -81.9403L528.517 -82.8761L505.919 -67.1095L515.791 -125.731V-125.778ZM565.57 -34.6874C586.904 -23.0846 594.764 3.58305 583.162 24.9171L525.288 131.307C513.686 152.641 487.018 160.501 465.684 148.898C444.35 137.295 436.49 110.628 448.093 89.2935L505.966 -17.0961C517.569 -38.4301 544.236 -46.2901 565.57 -34.6874Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M952.953 142.629L932.835 86.6268L957.818 98.1828L984.766 92.4281L952.953 142.675V142.629ZM942.332 39.3737C927.174 20.4257 930.262 -7.22443 949.21 -22.3828L1043.81 -98.0345C1062.76 -113.193 1090.41 -110.105 1105.57 -91.157C1120.72 -72.209 1117.64 -44.559 1098.69 -29.4006L1004.09 46.2511C985.141 61.4095 957.491 58.3217 942.332 39.3737Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M235.22 -127.088L281.678 -89.8938L254.309 -86.6656L234.378 -67.6708L235.22 -127.135V-127.088ZM298.24 -44.6057C321.071 -36.3715 332.908 -11.201 324.673 11.6302L283.596 125.599C275.362 148.43 250.191 160.267 227.36 152.033C204.529 143.798 192.692 118.628 200.927 95.7968L242.004 -18.1721C250.238 -41.0033 275.409 -52.8399 298.24 -44.6057Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M366.781 -101.824L418.105 -131.907L411.368 -105.192L421.988 -79.7881L366.781 -101.824ZM466.293 -131.252C482.107 -149.638 509.85 -151.697 528.237 -135.884L620.03 -56.8634C638.416 -41.05 640.475 -13.3064 624.661 5.08018C608.848 23.4668 581.104 25.5254 562.718 9.71201L470.925 -69.3083C452.539 -85.1217 450.48 -112.865 466.293 -131.252Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M175.336 95.282L141.604 46.2512L168.74 51.0701L193.302 38.6252L175.336 95.282ZM138.797 -1.84402C119.335 -16.3007 115.264 -43.8104 129.721 -63.3199L201.91 -160.586C216.367 -180.049 243.877 -184.119 263.386 -169.663C282.896 -155.206 286.919 -127.696 272.463 -108.187L200.273 -10.9204C185.816 8.54228 158.307 12.6126 138.797 -1.84402Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M548.588 -220.331L608.099 -221.173L589.057 -201.289L585.735 -173.967L548.588 -220.378V-220.331ZM649.691 -196.798C672.522 -204.985 697.693 -193.055 705.88 -170.224L746.677 -56.1615C754.864 -33.3303 742.934 -8.15982 720.103 0.0275879C697.271 8.21501 672.101 -3.71519 663.914 -26.5464L623.117 -140.609C614.929 -163.44 626.86 -188.61 649.691 -196.798Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M637.715 63.6557L622.369 6.15657L646.323 19.7711L673.646 16.2622L637.762 63.6557H637.715ZM635.796 -40.1141C622.276 -60.2785 627.656 -87.5543 647.82 -101.075L748.409 -168.539C768.573 -182.06 795.849 -176.68 809.37 -156.516C822.891 -136.351 817.51 -109.075 797.346 -95.5545L696.758 -28.0903C676.593 -14.5693 649.317 -19.9497 635.796 -40.1141Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M910.145 -97.0986L950.38 -53.2609L922.87 -54.1965L900.273 -38.4299L910.145 -97.0518V-97.0986ZM959.924 -6.05448C981.258 5.54826 989.118 32.2158 977.515 53.5499L919.642 159.939C908.039 181.273 881.372 189.133 860.037 177.531C838.703 165.928 830.844 139.26 842.446 117.926L900.32 11.5367C911.922 -9.79739 938.59 -17.6572 959.924 -6.05448Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M449.262 -53.4015L472.187 1.52447L446.642 -8.76834L420.021 -1.65704L449.262 -53.4015ZM465.029 49.1986C481.123 67.3513 479.439 95.1416 461.286 111.236L370.616 191.519C352.464 207.613 324.673 205.929 308.579 187.776C292.485 169.624 294.169 141.833 312.322 125.739L402.992 45.4557C421.144 29.3616 448.935 31.046 465.029 49.1986Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M181.465 68.7549L203.36 13.4079L214.495 38.5784L238.496 52.0526L181.418 68.7081L181.465 68.7549ZM241.724 -15.786C242.847 -40.0208 263.432 -58.7349 287.667 -57.612L408.654 -51.9042C432.889 -50.7814 451.603 -30.1959 450.48 -5.96111C449.357 18.2736 428.771 36.9878 404.537 35.8649L283.55 30.1571C259.315 29.0343 240.601 8.44872 241.724 -15.786Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M296.415 -144.726L342.873 -107.532L315.504 -104.304L295.573 -85.3088L296.415 -144.773V-144.726ZM359.435 -62.2906C382.266 -54.0564 394.103 -28.8858 385.869 -6.05464L344.791 107.914C336.557 130.745 311.387 142.582 288.555 134.348C265.724 126.114 253.888 100.943 262.122 78.1119L303.199 -35.8569C311.433 -58.6881 336.604 -70.5248 359.435 -62.2906Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M230.776 82.0888L197.044 33.0578L224.179 37.8767L248.742 25.4318L230.776 82.0888ZM194.237 -15.0374C174.774 -29.494 170.704 -57.0038 185.16 -76.5133L257.35 -173.78C271.807 -193.242 299.316 -197.313 318.826 -182.856C338.335 -168.399 342.359 -140.89 327.902 -121.38L255.712 -24.1137C241.256 -4.65109 213.746 -0.580765 194.237 -15.0374Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M690.113 7.6535L674.768 -49.8456L698.722 -36.2311L726.044 -39.74L690.16 7.6535H690.113ZM688.242 -96.1161C674.721 -116.281 680.101 -143.556 700.266 -157.077L800.854 -224.542C821.018 -238.063 848.294 -232.682 861.815 -212.518C875.336 -192.353 869.956 -165.078 849.791 -151.557L749.203 -84.0924C729.038 -70.5715 701.763 -75.9517 688.242 -96.1161Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M971.572 -169.756L1011.81 -125.918L984.298 -126.854L961.701 -111.087L971.572 -169.709V-169.756ZM1021.35 -78.7121C1042.69 -67.1094 1050.55 -40.4417 1038.94 -19.1076L981.07 87.282C969.467 108.616 942.799 116.476 921.465 104.873C900.131 93.2705 892.271 66.6028 903.874 45.2688L961.747 -61.1208C973.35 -82.4549 1000.02 -90.3148 1021.35 -78.7121Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M315.504 -150.387L373.939 -139.159L351.248 -123.532L342.499 -97.4263L315.504 -150.387ZM409.729 -106.877C433.777 -110.245 456 -93.5431 459.368 -69.4955L476.258 50.4619C479.626 74.5095 462.924 96.7324 438.877 100.101C414.829 103.469 392.606 86.7672 389.237 62.7196L372.348 -57.2377C368.979 -81.2853 385.682 -103.508 409.729 -106.877Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-158.195 74.4159L-153.891 15.0454L-135.692 35.7246L-108.743 41.3387L-158.149 74.369L-158.195 74.4159ZM-126.054 -24.301C-132.229 -47.7871 -118.241 -71.788 -94.7546 -77.9636L22.3489 -108.842C45.8351 -115.017 69.8359 -101.029 76.0116 -77.5426C82.1872 -54.0564 68.1984 -30.0556 44.7122 -23.8799L-72.3912 6.99836C-95.8774 13.174 -119.878 -0.814781 -126.054 -24.301Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M316.347 -22.6166L311.014 36.6602L293.189 15.6537L266.334 9.52485L316.347 -22.6166ZM282.428 75.4921C288.183 99.0718 273.726 122.839 250.193 128.593L132.528 157.319C108.949 163.074 85.1817 148.617 79.4271 125.084C73.6725 101.551 88.1291 77.7377 111.662 71.9832L229.327 43.257C252.907 37.5024 276.674 51.9591 282.428 75.4921Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M407.625 45.4557L434.573 -7.5987L443.322 18.5075L466.013 34.1338L407.672 45.4557H407.625ZM475.464 -33.0967C478.832 -57.1443 501.055 -73.8466 525.103 -70.4781L645.06 -53.5885C669.108 -50.22 685.81 -27.9971 682.441 -3.94946C679.073 20.0981 656.85 36.8004 632.802 33.4319L512.845 16.5425C488.797 13.174 472.095 -9.0491 475.464 -33.0967Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1353.01 52.4736L1298.04 75.258L1308.38 49.7133L1301.32 23.0925L1353.01 52.427V52.4736ZM1250.41 68.0532C1232.21 84.1005 1204.47 82.3694 1188.38 64.17L1108.23 -26.6402C1092.19 -44.8396 1093.92 -72.5832 1112.12 -88.6773C1130.32 -104.771 1158.06 -102.994 1174.15 -84.7942L1254.3 6.01595C1270.34 24.2154 1268.61 51.9591 1250.41 68.0532Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M741.578 -90.6892L792.902 -120.772L786.165 -94.0578L796.785 -68.6533L741.578 -90.6892ZM841.09 -120.117C856.904 -138.504 884.647 -140.562 903.034 -124.749L994.827 -45.7286C1013.21 -29.9152 1015.27 -2.17159 999.458 16.215C983.645 34.6016 955.901 36.6603 937.515 20.8468L845.722 -58.1735C827.335 -73.9869 825.277 -101.73 841.09 -120.117Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M316.205 154.84L257.116 147.915L278.59 130.652L285.421 103.984L316.252 154.84H316.205ZM219.032 118.394C195.312 123.54 171.92 108.475 166.773 84.7552L141.135 -33.6113C135.989 -57.3314 151.053 -80.7241 174.774 -85.8705C198.494 -91.0168 221.886 -75.952 227.033 -52.2319L252.671 66.1348C257.817 89.8549 242.753 113.247 219.032 118.394Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M763.847 243.17L704.664 237.041L725.904 219.497L732.361 192.736L763.847 243.17ZM666.16 207.988C642.533 213.461 618.907 198.677 613.48 175.051L586.251 57.0116C580.777 33.385 595.561 9.75843 619.187 4.33134C642.814 -1.14253 666.44 13.6416 671.867 37.2682L699.096 155.307C704.57 178.934 689.786 202.56 666.16 207.988Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1036.14 -27.9502L1059.06 26.9758L1033.52 16.683L1006.9 23.7943L1036.14 -27.9502ZM1051.9 74.6031C1068 92.7558 1066.31 120.546 1048.16 136.64L957.491 216.924C939.339 233.018 911.548 231.334 895.454 213.181C879.36 195.028 881.044 167.238 899.197 151.144L989.867 70.8602C1008.02 54.7661 1035.81 56.4504 1051.9 74.6031Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M506.574 -152.165L560.003 -125.965L534.037 -116.842L518.738 -93.9642L506.621 -152.165H506.574ZM586.062 -85.4026C610.157 -82.3615 627.187 -60.3725 624.099 -36.2781L608.847 83.8663C605.806 107.961 583.817 124.991 559.722 121.903C535.628 118.815 518.598 96.8727 521.686 72.7783L536.938 -47.3662C539.979 -71.4606 561.968 -88.4904 586.062 -85.4026Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M509.896 -134.387L556.354 -97.1923L528.984 -93.9642L509.054 -74.9694L509.896 -134.433V-134.387ZM572.916 -51.9511C595.747 -43.7169 607.583 -18.5464 599.349 4.28482L558.272 118.254C550.038 141.085 524.867 152.921 502.036 144.687C479.205 136.453 467.368 111.283 475.602 88.4514L516.68 -25.5173C524.914 -48.3485 550.084 -60.1853 572.916 -51.9511Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M430.643 181.648L396.911 132.617L424.046 137.436L448.609 124.991L430.643 181.648ZM394.057 84.4748C374.594 70.0182 370.524 42.5085 384.981 22.9991L457.17 -74.2675C471.627 -93.7301 499.137 -97.8004 518.646 -83.3438C538.156 -68.8872 542.179 -41.3774 527.722 -21.8679L455.533 75.3985C441.076 94.8611 413.566 98.9314 394.057 84.4748Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M435.322 40.8238L376.139 34.695L397.379 17.1505L403.835 -9.61064L435.322 40.8238ZM337.681 5.68806C314.055 11.1619 290.428 -3.62222 285.001 -27.2488L257.772 -145.288C252.298 -168.914 267.082 -192.541 290.709 -197.968C314.335 -203.395 337.962 -188.658 343.389 -165.031L370.618 -46.992C376.092 -23.3655 361.308 0.260986 337.681 5.68806Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M415.531 -35.5293L412.49 23.888L393.87 3.58323L366.781 -1.46965L415.484 -35.5293H415.531ZM385.495 63.8425C392.185 87.1883 378.664 111.517 355.365 118.16L238.917 151.471C215.571 158.162 191.243 144.641 184.599 121.342C177.956 98.0425 191.43 73.6675 214.729 67.024L331.177 33.7129C354.523 27.0226 378.852 40.5434 385.495 63.8425Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M251.689 35.1633L278.638 -17.8913L287.387 8.21491L310.077 23.8412L251.736 35.1633H251.689ZM319.528 -43.3892C322.897 -67.4368 345.12 -84.1391 369.167 -80.7705L489.124 -63.8811C513.172 -60.5126 529.874 -38.2896 526.506 -14.2419C523.137 9.80566 500.914 26.5079 476.867 23.1394L356.909 6.24987C332.862 2.88133 316.16 -19.3416 319.528 -43.3892Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-54.2402 -15.2245L3.02487 0.963305L-20.8824 14.5777L-31.8301 39.8418L-54.1935 -15.2245H-54.2402ZM35.9149 36.1926C60.1496 34.8826 80.8287 53.4563 82.1855 77.6911L88.7354 198.631C90.0454 222.866 71.4716 243.545 47.2369 244.901C23.0022 246.258 2.32308 227.638 0.966312 203.403L-5.58359 82.4631C-6.89358 58.2283 11.6801 37.5494 35.9149 36.1926Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-112.721 -69.0276L-69.6316 -110.058L-70.0994 -82.5018L-53.9585 -60.1851L-112.768 -68.9808L-112.721 -69.0276ZM-22.5657 -120.445C-11.3372 -141.966 15.19 -150.34 36.7112 -139.112L144.13 -83.1567C165.651 -71.9282 174.026 -45.4011 162.797 -23.8799C151.569 -2.35866 125.042 6.01599 103.521 -5.21246L-3.89834 -61.1677C-25.4195 -72.3962 -33.7941 -98.9233 -22.5657 -120.445Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M448.983 21.3147L437.988 -37.1668L460.819 -21.8213L488.329 -23.2248L448.936 21.3147H448.983ZM454.878 -82.3146C442.901 -103.415 450.34 -130.223 471.44 -142.2L576.847 -201.898C597.947 -213.875 624.755 -206.436 636.732 -185.336C648.709 -164.235 641.27 -137.428 620.17 -125.451L514.763 -65.7525C493.663 -53.7755 466.855 -61.2144 454.878 -82.3146Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M666.768 24.6364L615.818 -6.10152L642.486 -12.9321L659.75 -34.4067L666.768 24.6364ZM593.361 -48.7696C569.641 -53.916 554.577 -77.3086 559.723 -100.982L585.361 -219.349C590.508 -243.069 613.9 -258.134 637.574 -252.987C661.247 -247.841 676.359 -224.448 671.212 -200.775L645.574 -82.4082C640.427 -58.6881 617.035 -43.6232 593.361 -48.7696Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M92.9937 281.394L57.858 233.392L85.0869 237.369L109.275 224.222L92.9937 281.394ZM53.6005 185.39C33.7168 171.495 28.8043 144.126 42.6995 124.195L111.988 24.8704C125.884 4.98663 153.253 0.0742445 173.184 13.9695C193.114 27.8647 197.98 55.234 184.085 75.1645L114.796 174.49C100.9 194.373 73.531 199.286 53.6005 185.39Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-185.846 -42.1263L-139.762 -79.7883L-142.289 -52.3722L-127.879 -28.9328L-185.846 -42.1263ZM-92.0413 -86.6189C-79.2221 -107.251 -52.1335 -113.567 -31.548 -100.748L71.3328 -36.8395C91.965 -24.0204 98.281 3.06825 85.4619 23.6538C72.6427 44.2393 45.5541 50.6021 24.9686 37.783L-77.9122 -26.1257C-98.5445 -38.9448 -104.86 -66.0334 -92.0413 -86.6189Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M184.834 -164.469L242.099 -148.282L218.192 -134.667L207.244 -109.403L184.881 -164.469H184.834ZM275.036 -113.053C299.271 -114.363 319.95 -95.7887 321.306 -71.5539L327.856 49.3858C329.166 73.6205 310.593 94.2997 286.358 95.6564C262.123 97.0132 241.444 78.3927 240.087 54.158L233.537 -66.7819C232.227 -91.0166 250.801 -111.696 275.036 -113.053Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M239.572 19.5836L210.846 -32.535L237.374 -25.0962L263.059 -35.0615L239.572 19.5836ZM212.811 -80.6771C194.846 -97.0051 193.489 -124.796 209.817 -142.761L291.27 -232.448C307.598 -250.414 335.389 -251.771 353.354 -235.443C371.32 -219.115 372.676 -191.324 356.348 -173.359L274.895 -83.6714C258.567 -65.7059 230.777 -64.349 212.811 -80.6771Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M219.595 135.096L162.704 152.547L175.43 128.125L170.939 100.943L219.595 135.096ZM115.966 140.851C96.3161 155.12 68.8532 150.723 54.5837 131.073L-16.5298 33.0108C-30.7993 13.361 -26.4015 -14.1019 -6.75174 -28.3714C12.8981 -42.6409 40.361 -38.2431 54.6305 -18.5933L125.744 79.4687C140.013 99.1185 135.616 126.581 115.966 140.851Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1038.01 118.488L1042.31 59.1172L1060.51 79.7962L1087.46 85.4105L1038.05 118.441L1038.01 118.488ZM1070.15 19.7708C1063.97 -3.71536 1077.96 -27.7162 1101.45 -33.8918L1218.55 -64.7701C1242.04 -70.9458 1266.04 -56.957 1272.21 -33.4708C1278.39 -9.98461 1264.4 14.0162 1240.92 20.1919L1123.81 51.0702C1100.33 57.2458 1076.32 43.257 1070.15 19.7708Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M375.857 -108.281L373.378 -48.8167L354.57 -68.9342L327.481 -73.7531L375.904 -108.281H375.857ZM346.757 -8.67499C353.634 14.5773 340.347 39.046 317.095 45.9234L200.927 80.3106C177.675 87.188 153.206 73.901 146.329 50.6488C139.452 27.3965 152.739 2.9278 175.991 -3.94963L292.159 -38.3368C315.411 -45.2142 339.88 -31.9272 346.757 -8.67499Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M71.9395 -68.3727L127.848 -88.7243L116.432 -63.6475L122.327 -36.746L71.9395 -68.326V-68.3727ZM175.101 -79.4141C194.002 -94.6661 221.652 -91.7186 236.904 -72.8174L312.977 21.4081C328.229 40.3094 325.281 67.9594 306.38 83.2114C287.479 98.4634 259.829 95.5159 244.577 76.6146L168.504 -17.6107C153.252 -36.512 156.2 -64.1621 175.101 -79.4141Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M995.059 9.47792L935.969 2.5538L957.444 -14.71L964.274 -41.3776L995.106 9.47792H995.059ZM897.839 -26.9677C874.119 -21.8213 850.726 -36.8861 845.58 -60.6063L819.942 -178.973C814.795 -202.693 829.86 -226.086 853.58 -231.232C877.3 -236.378 900.693 -221.313 905.839 -197.593L931.478 -79.2268C936.624 -55.5067 921.559 -32.114 897.839 -26.9677Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M90.748 -135.416L150.259 -136.258L131.217 -116.374L127.896 -89.0518L90.748 -135.463V-135.416ZM191.851 -111.883C214.682 -120.07 239.853 -108.14 248.04 -85.3089L288.837 28.7534C297.024 51.5846 285.094 76.7551 262.263 84.9425C239.432 93.1299 214.261 81.1997 206.074 58.3685L165.277 -55.6939C157.089 -78.5251 169.02 -103.696 191.851 -111.883Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M47.7049 110.16L32.3594 52.6607L56.3134 66.2752L83.6359 62.7663L47.7517 110.16H47.7049ZM45.7867 6.39006C32.2658 -13.7744 37.6461 -41.0502 57.8105 -54.5711L158.399 -122.035C178.563 -135.556 205.839 -130.176 219.36 -110.011C232.881 -89.847 227.501 -62.5713 207.336 -49.0503L106.748 18.4139C86.5834 31.9348 59.3076 26.5545 45.7867 6.39006Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M633.878 42.368L576.286 27.4435L599.912 13.2675L610.299 -12.2303L633.878 42.3213V42.368ZM542.601 -7.03725C518.413 -5.21262 497.312 -23.3185 495.441 -47.5064L486.224 -168.259C484.4 -192.447 502.506 -213.547 526.693 -215.419C550.881 -217.29 571.982 -199.137 573.853 -174.949L583.07 -54.1967C584.894 -30.0087 566.788 -8.90865 542.601 -7.03725Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-149.119 23.1861L-103.036 -14.4761L-105.562 12.9401L-91.1522 36.3794L-149.119 23.1861ZM-55.3148 -21.3067C-42.4956 -41.939 -15.407 -48.2551 5.17854 -35.4359L108.059 28.4727C128.691 41.2919 135.008 68.3806 122.188 88.9661C109.369 109.552 82.2805 115.914 61.695 103.095L-41.1856 39.1866C-61.8179 26.3674 -68.1339 -0.721172 -55.3148 -21.3067Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M219.875 -124L277.14 -107.812L253.233 -94.1981L242.285 -68.9339L219.922 -124H219.875ZM310.03 -72.63C334.265 -73.94 354.944 -55.3663 356.301 -31.1315L362.851 89.8083C364.161 114.043 345.587 134.722 321.352 136.079C297.117 137.436 276.438 118.815 275.082 94.5804L268.532 -26.3595C267.222 -50.5942 285.795 -71.2732 310.03 -72.63Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M325.89 69.0357L290.754 21.034L317.983 25.0108L342.171 11.8642L325.89 69.0357ZM286.497 -26.9675C266.613 -40.8627 261.701 -68.2322 275.596 -88.1627L344.885 -187.488C358.78 -207.372 386.15 -212.284 406.08 -198.389C426.011 -184.493 430.876 -157.124 416.981 -137.194L347.692 -37.8686C333.797 -17.9848 306.427 -13.0723 286.497 -26.9675Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-7.31445 -8.25356L38.769 -45.9157L36.2427 -18.4995L50.6524 4.93977L-7.31445 -8.25356ZM86.4899 -52.7464C99.3091 -73.3786 126.398 -79.6946 146.983 -66.8754L249.864 -2.96694C270.496 9.85221 276.812 36.941 263.993 57.5265C251.174 78.112 224.085 84.4747 203.5 71.6555L100.619 7.74691C79.9868 -5.07224 73.6708 -32.1609 86.4899 -52.7464Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-241.193 -128.726L-185.285 -149.077L-196.701 -124L-190.806 -97.0988L-241.193 -128.679V-128.726ZM-138.032 -139.814C-119.131 -155.066 -91.4807 -152.118 -76.2287 -133.217L-0.155853 -38.9915C15.0961 -20.0903 12.1486 7.55974 -6.75259 22.8117C-25.6538 38.0637 -53.3039 35.1162 -68.5559 16.215L-144.629 -78.0104C-159.881 -96.9116 -156.933 -124.562 -138.032 -139.814Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M405.191 -9.04877L348.3 8.40218L361.026 -16.0197L356.534 -43.2019L405.191 -9.04877ZM301.562 -3.34096C281.912 10.9285 254.449 6.53075 240.179 -13.119L169.066 -111.181C154.796 -130.831 159.194 -158.294 178.844 -172.563C198.494 -186.833 225.957 -182.435 240.226 -162.785L311.34 -64.7232C325.609 -45.0734 321.211 -17.6105 301.562 -3.34096Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M374.781 33.6661L419.04 -6.10133L417.777 21.4084L433.263 44.146L374.734 33.6661H374.781ZM466.387 -15.1777C478.223 -36.3714 504.984 -43.9506 526.178 -32.1607L631.96 26.8355C653.153 38.6722 660.732 65.4333 648.943 86.627C637.106 107.821 610.345 115.4 589.151 103.61L483.37 44.6138C462.176 32.7772 454.597 6.01603 466.387 -15.1777Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1.38846 -14.2888L-53.5842 8.49554L-43.2446 -17.0492L-50.3092 -43.67L1.38846 -14.3357V-14.2888ZM-101.258 1.29057C-119.458 17.3379 -147.201 15.6069 -163.296 -2.59253L-243.439 -93.4027C-259.486 -111.602 -257.755 -139.346 -239.555 -155.44C-221.356 -171.534 -193.612 -169.756 -177.518 -151.557L-97.3751 -60.7466C-81.3278 -42.5471 -83.0589 -14.8035 -101.258 1.29057Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M671.867 -129.568L710.605 -84.3732L683.142 -86.2914L660.03 -71.3201L671.914 -129.568H671.867ZM718.465 -36.8394C739.378 -24.5349 746.302 2.4135 733.998 23.3265L672.475 127.658C660.171 148.57 633.222 155.495 612.309 143.19C591.396 130.886 584.472 103.937 596.777 83.0244L658.299 -21.3067C670.604 -42.2197 697.552 -49.1439 718.465 -36.8394Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M912.249 280.318L860.318 251.264L886.751 243.591L903.313 221.556L912.249 280.318ZM836.551 209.298C812.69 204.947 796.877 182.069 801.228 158.161L822.983 38.9995C827.334 15.139 850.212 -0.674333 874.119 3.67669C898.027 8.02772 913.793 30.9057 909.442 54.8129L887.687 173.975C883.336 197.835 860.458 213.649 836.551 209.298Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M220.016 -62.1969L260.251 -18.3592L232.741 -19.2949L210.144 -3.52833L220.016 -62.1502V-62.1969ZM269.795 28.8471C291.129 40.4498 298.989 67.1174 287.386 88.4514L229.513 194.841C217.91 216.175 191.243 224.035 169.909 212.432C148.575 200.83 140.715 174.162 152.317 152.828L210.191 46.4383C221.793 25.1042 248.461 17.2444 269.795 28.8471Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M740.454 -172.189L791.403 -141.404L764.736 -134.574L747.472 -113.099L740.501 -172.142L740.454 -172.189ZM813.813 -98.7362C837.534 -93.5899 852.598 -70.1972 847.452 -46.4771L821.767 71.8895C816.621 95.6096 793.228 110.674 769.508 105.528C745.788 100.382 730.723 76.9892 735.869 53.269L761.554 -65.0977C766.701 -88.8178 790.093 -103.883 813.813 -98.7362Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1498.98 -118.152L1537.72 -72.9576L1510.26 -74.8758L1487.15 -59.9044L1499.03 -118.152H1498.98ZM1545.63 -25.4237C1566.54 -13.1192 1573.47 13.829 1561.16 34.742L1499.64 139.073C1487.33 159.986 1460.39 166.91 1439.47 154.606C1418.56 142.301 1411.64 115.353 1423.94 94.44L1485.46 -9.89101C1497.77 -30.804 1524.72 -37.7283 1545.63 -25.4237Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1042.12 -126.433L1082.36 -82.5954L1054.85 -83.5311L1032.25 -67.7644L1042.12 -126.386V-126.433ZM1091.9 -35.3423C1113.24 -23.7395 1121.1 2.92801 1109.5 24.2621L1051.62 130.652C1040.02 151.986 1013.35 159.846 992.018 148.243C970.684 136.64 962.824 109.973 974.427 88.6386L1032.3 -17.751C1043.9 -39.085 1070.57 -46.945 1091.9 -35.3423Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M762.162 -143.042L808.619 -105.847L781.25 -102.619L761.319 -83.6245L762.162 -143.089V-143.042ZM825.181 -60.5594C848.013 -52.3252 859.849 -27.1547 851.615 -4.3235L810.538 109.645C802.303 132.476 777.133 144.313 754.302 136.079C731.47 127.845 719.634 102.674 727.868 79.8431L768.945 -34.1257C777.18 -56.9569 802.35 -68.7936 825.181 -60.5594Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M898.309 -102.339L949.632 -132.421L942.895 -105.707L953.515 -80.3028L898.309 -102.339ZM997.821 -131.767C1013.63 -150.153 1041.38 -152.212 1059.76 -136.398L1151.56 -57.3779C1169.94 -41.5645 1172 -13.8209 1156.19 4.56567C1140.38 22.9523 1112.63 25.0108 1094.25 9.19736L1002.45 -69.8228C984.066 -85.6362 982.007 -113.38 997.821 -131.767Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M706.536 76.4742L672.804 27.4433L699.939 32.2621L724.501 19.8174L706.536 76.4742ZM669.95 -20.6986C650.487 -35.1553 646.417 -62.665 660.873 -82.1745L733.063 -179.441C747.52 -198.904 775.029 -202.974 794.539 -188.517C814.048 -174.061 818.072 -146.551 803.615 -127.041L731.425 -29.775C716.969 -10.3123 689.459 -6.242 669.95 -20.6986Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1082.97 -212.143L1142.48 -212.986L1123.44 -193.102L1120.12 -165.779L1082.97 -212.19V-212.143ZM1184.07 -188.611C1206.9 -196.798 1232.07 -184.868 1240.26 -162.037L1281.06 -47.9741C1289.24 -25.1429 1277.31 0.0275574 1254.48 8.21497C1231.65 16.4024 1206.48 4.47218 1198.29 -18.359L1157.5 -132.421C1149.31 -155.253 1161.24 -180.423 1184.07 -188.611Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1168.82 75.1178L1153.47 17.6189L1177.43 31.2332L1204.75 27.7243L1168.87 75.1178H1168.82ZM1166.95 -28.6518C1153.43 -48.8162 1158.81 -76.092 1178.97 -89.6129L1279.56 -157.077C1299.73 -170.598 1327 -165.218 1340.52 -145.053C1354.04 -124.889 1348.66 -97.6133 1328.5 -84.0923L1227.91 -16.628C1207.75 -3.10703 1180.47 -8.48737 1166.95 -28.6518Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1434.09 -74.4077L1474.33 -30.57L1446.82 -31.5056L1424.22 -15.739L1434.09 -74.3609V-74.4077ZM1483.87 16.6831C1505.21 28.2859 1513.07 54.9534 1501.46 76.2875L1443.59 182.677C1431.99 204.011 1405.32 211.871 1383.98 200.268C1362.65 188.666 1354.79 161.998 1366.39 140.664L1424.27 34.2744C1435.87 12.9404 1462.54 5.08039 1483.87 16.6831Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M972.182 -61.0741L995.107 -6.14829L969.562 -16.441L942.941 -9.32965L972.182 -61.0741ZM987.949 41.5259C1004.04 59.6785 1002.36 87.469 984.206 103.563L893.536 183.847C875.384 199.941 847.593 198.256 831.499 180.104C815.405 161.951 817.089 134.161 835.242 118.067L925.912 37.7831C944.064 21.689 971.855 23.3732 987.949 41.5259Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M708.875 56.6375L730.77 1.29051L741.905 26.461L765.906 39.9352L708.828 56.5907L708.875 56.6375ZM769.181 -27.8566C770.304 -52.0913 790.889 -70.8054 815.124 -69.6826L936.111 -63.9748C960.346 -62.8519 979.06 -42.2666 977.937 -18.0318C976.814 6.20293 956.228 24.917 931.994 23.7942L811.007 18.0864C786.772 16.9635 768.058 -3.62185 769.181 -27.8566Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M824.294 -157.031L870.752 -119.836L843.383 -116.608L823.452 -97.6134L824.294 -157.078V-157.031ZM887.314 -74.5951C910.145 -66.3609 921.982 -41.1904 913.748 -18.3592L872.67 95.6095C864.436 118.441 839.266 130.277 816.434 122.043C793.603 113.809 781.767 88.6386 790.001 65.8074L831.078 -48.1614C839.312 -70.9926 864.483 -82.8293 887.314 -74.5951Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M762.678 66.6029L728.946 17.5719L756.082 22.3908L780.644 9.94592L762.678 66.6029ZM726.139 -30.5701C706.676 -45.0267 702.606 -72.5364 717.063 -92.0458L789.252 -189.312C803.709 -208.775 831.219 -212.845 850.728 -198.389C870.238 -183.932 874.261 -156.422 859.804 -136.913L787.615 -39.6465C773.158 -20.1838 745.648 -16.1135 726.139 -30.5701Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1224.5 22.3438L1209.15 -35.1551L1233.1 -21.5407L1260.43 -25.0496L1224.54 22.3438H1224.5ZM1222.62 -81.4258C1209.1 -101.59 1214.48 -128.866 1234.65 -142.387L1335.24 -209.851C1355.4 -223.372 1382.68 -217.992 1396.2 -197.827C1409.72 -177.663 1404.34 -150.387 1384.17 -136.866L1283.59 -69.4019C1263.42 -55.881 1236.15 -61.2613 1222.62 -81.4258Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1499.73 -143.276L1539.97 -99.4381L1512.46 -100.374L1489.86 -84.6072L1499.73 -143.229V-143.276ZM1549.51 -52.185C1570.85 -40.5823 1578.71 -13.9148 1567.1 7.4193L1509.23 113.809C1497.63 135.143 1470.96 143.003 1449.63 131.4C1428.29 119.797 1420.43 93.1299 1432.03 71.7958L1489.91 -34.5938C1501.51 -55.9278 1528.18 -63.7878 1549.51 -52.185Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M845.02 -157.545L903.454 -146.317L880.763 -130.69L872.015 -104.584L845.02 -157.545ZM939.292 -114.035C963.339 -117.403 985.562 -100.701 988.931 -76.6536L1005.82 43.3038C1009.19 67.3514 992.487 89.5743 968.439 92.9429C944.391 96.3114 922.168 79.6091 918.8 55.5615L901.91 -64.3958C898.542 -88.4434 915.244 -110.666 939.292 -114.035Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M371.787 40.7773L376.091 -18.5931L394.291 2.086L421.239 7.70015L371.834 40.7306L371.787 40.7773ZM403.929 -57.9395C397.753 -81.4257 411.742 -105.427 435.228 -111.602L552.331 -142.48C575.817 -148.656 599.818 -134.667 605.994 -111.181C612.17 -87.6948 598.181 -63.694 574.695 -57.5183L457.591 -26.6402C434.105 -20.4645 410.104 -34.4533 403.929 -57.9395Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M840.248 -41.6115L834.914 17.6654L817.089 -3.34117L790.235 -9.47002L840.248 -41.6115ZM806.329 56.4972C812.083 80.0769 797.627 103.844 774.094 109.598L656.429 138.325C632.849 144.079 609.082 129.622 603.327 106.089C597.573 82.5564 612.03 58.7429 635.563 52.9883L753.227 24.2621C776.807 18.5075 800.574 32.9642 806.329 56.4972Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M935.268 47.1401L962.216 -5.9143L970.965 20.1918L993.655 35.818L935.314 47.1401H935.268ZM1003.11 -31.4591C1006.47 -55.5067 1028.7 -72.209 1052.75 -68.8405L1172.7 -51.9511C1196.75 -48.5826 1213.45 -26.3595 1210.08 -2.31189C1206.72 21.7357 1184.49 38.438 1160.44 35.0695L1040.49 18.1801C1016.44 14.8115 999.738 -7.41153 1003.11 -31.4591Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1271.75 -68.9339L1323.07 -99.0169L1316.33 -72.3025L1326.95 -46.8981L1271.75 -68.9339ZM1371.31 -98.3619C1387.12 -116.748 1414.86 -118.807 1433.25 -102.994L1525.04 -23.9734C1543.43 -8.16 1545.49 19.5836 1529.68 37.9702C1513.86 56.3568 1486.12 58.4154 1467.73 42.602L1375.94 -36.4183C1357.55 -52.2317 1355.49 -79.9753 1371.31 -98.3619Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M842.026 137.202L782.936 130.278L804.41 113.014L811.241 86.3463L842.072 137.202H842.026ZM744.853 100.756C721.133 105.903 697.74 90.8377 692.594 67.1176L666.955 -51.249C661.809 -74.9691 676.874 -98.3618 700.594 -103.508C724.314 -108.655 747.707 -93.5897 752.853 -69.8696L778.491 48.497C783.638 72.2171 768.573 95.6098 744.853 100.756Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1283.58 251.826L1224.4 245.697L1245.64 228.152L1252.1 201.391L1283.58 251.826ZM1185.9 216.69C1162.27 222.164 1138.64 207.379 1133.22 183.753L1105.99 65.7139C1100.51 42.0874 1115.3 18.4608 1138.92 13.0337C1162.55 7.60662 1186.18 22.344 1191.6 45.9705L1218.83 164.01C1224.31 187.636 1209.52 211.263 1185.9 216.69Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1556.53 -0.814697L1579.45 54.1111L1553.91 43.8183L1527.29 50.9298L1556.53 -0.814697ZM1572.3 101.738C1588.39 119.891 1586.71 147.682 1568.55 163.776L1477.88 244.059C1459.73 260.153 1431.94 258.469 1415.85 240.316C1399.75 222.164 1401.44 194.373 1419.59 178.279L1510.26 97.9957C1528.41 81.9016 1556.2 83.5858 1572.3 101.738Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1034.87 -150.06L1088.3 -123.86L1062.34 -114.737L1047.04 -91.8589L1034.92 -150.06H1034.87ZM1114.36 -83.2971C1138.46 -80.256 1155.49 -58.267 1152.4 -34.1726L1137.15 85.9718C1134.1 110.066 1112.12 127.096 1088.02 124.008C1063.93 120.92 1046.9 98.9782 1049.98 74.8838L1065.24 -45.2607C1068.28 -69.3551 1090.27 -86.3849 1114.36 -83.2971Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1036.79 -134.059L1083.25 -96.8648L1055.88 -93.6366L1035.95 -74.6418L1036.79 -134.106V-134.059ZM1099.81 -51.5767C1122.64 -43.3425 1134.48 -18.1721 1126.25 4.65906L1085.17 118.628C1076.93 141.459 1051.76 153.296 1028.93 145.062C1006.1 136.827 994.265 111.657 1002.5 88.8258L1043.58 -25.1431C1051.81 -47.9743 1076.98 -59.8109 1099.81 -51.5767Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M956.229 177.811L922.497 128.78L949.632 133.599L974.195 121.154L956.229 177.811ZM919.69 80.6851C900.227 66.2285 896.157 38.7189 910.613 19.2094L982.803 -78.0571C997.26 -97.5198 1024.77 -101.59 1044.28 -87.1335C1063.79 -72.6768 1067.81 -45.167 1053.36 -25.6576L981.166 71.6088C966.709 91.0714 939.199 95.1418 919.69 80.6851Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M967.691 30.344L908.508 24.215L929.748 6.6705L936.204 -20.0905L967.691 30.344ZM870.003 -4.79179C846.377 0.682083 822.75 -14.1021 817.323 -37.7286L790.094 -155.768C784.62 -179.394 799.404 -203.021 823.031 -208.448C846.658 -213.875 870.284 -199.138 875.711 -175.511L902.94 -57.472C908.414 -33.8455 893.63 -10.2189 870.003 -4.79179Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1037.49 -142.247L1092.42 -165.124L1082.13 -139.58L1089.24 -112.959L1037.49 -142.247ZM1140.09 -157.966C1158.25 -174.06 1186.04 -172.376 1202.13 -154.177L1282.41 -63.4602C1298.51 -45.3076 1296.82 -17.5171 1278.63 -1.42299C1260.43 14.6711 1232.68 12.9869 1216.59 -5.21257L1136.3 -95.9292C1120.21 -114.082 1121.89 -141.872 1140.09 -157.966Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M940.555 -115.719L927.829 -57.6121L912.811 -80.6772L886.939 -90.1278L940.601 -115.766L940.555 -115.719ZM894.612 -22.6635C897.372 1.43086 880.061 23.2328 855.967 25.9931L735.635 39.7479C711.541 42.5083 689.739 25.1978 686.979 1.10345C684.218 -22.991 701.529 -44.793 725.623 -47.5533L845.955 -61.3082C870.049 -64.0685 891.851 -46.7579 894.612 -22.6635Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M888.998 211.356L840.154 177.39L867.196 172.291L885.769 151.986L888.951 211.356H888.998ZM820.457 133.365C797.111 126.722 783.591 102.393 790.234 79.0476L823.451 -37.4476C830.095 -60.7934 854.423 -74.3143 877.769 -67.6708C901.115 -61.0273 914.636 -36.699 907.992 -13.3532L874.775 103.142C868.131 126.488 843.803 140.009 820.457 133.365Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1106.55 191.987L1110.85 132.617L1129.05 153.296L1156 158.91L1106.6 191.94L1106.55 191.987ZM1138.69 93.2705C1132.51 69.7843 1146.5 45.7834 1169.99 39.6078L1287.09 8.72952C1310.58 2.55387 1334.58 16.5427 1340.76 40.0288C1346.93 63.515 1332.94 87.5159 1309.46 93.6915L1192.35 124.57C1168.87 130.745 1144.87 116.757 1138.69 93.2705Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M985.656 -207.98L1024.39 -162.785L996.931 -164.703L973.819 -149.732L985.703 -207.98H985.656ZM1032.25 -115.252C1053.17 -102.947 1060.09 -75.9987 1047.79 -55.0857L986.264 49.2453C973.96 70.1583 947.011 77.0826 926.098 64.778C905.185 52.4735 898.261 25.5253 910.566 4.61229L972.088 -99.7188C984.393 -120.632 1011.34 -127.556 1032.25 -115.252Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M849.418 -107.017L906.683 -90.8294L882.776 -77.2149L871.828 -51.9509L849.465 -107.017H849.418ZM939.573 -55.6002C963.808 -56.9102 984.487 -38.3363 985.844 -14.1015L992.394 106.838C993.704 131.073 975.13 151.752 950.895 153.109C926.66 154.466 905.981 135.845 904.624 111.61L898.075 -9.32951C896.765 -33.5643 915.338 -54.2434 939.573 -55.6002Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M440.187 96.1244L483.277 55.0937L482.809 82.6502L498.95 104.967L440.141 96.1711L440.187 96.1244ZM530.343 44.7073C541.571 23.1861 568.098 14.8116 589.619 26.0401L697.038 81.9952C718.56 93.2236 726.934 119.751 715.706 141.272C704.477 162.793 677.95 171.168 656.429 159.939L549.01 103.984C527.489 92.7558 519.114 66.2285 530.343 44.7073Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M543.816 151.424L528.471 93.9253L552.425 107.54L579.747 104.031L543.863 151.424H543.816ZM541.898 47.6546C528.377 27.4902 533.757 0.214424 553.922 -13.3065L654.51 -80.7707C674.675 -94.2917 701.95 -88.9115 715.471 -68.747C728.992 -48.5826 723.612 -21.3068 703.447 -7.78589L602.859 59.6785C582.695 73.1994 555.419 67.8191 541.898 47.6546Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M294.076 -16.8153L334.311 27.0224L306.802 26.0868L284.204 41.8534L294.076 -16.7685V-16.8153ZM343.856 74.2755C365.19 85.8783 373.05 112.546 361.447 133.88L303.574 240.27C291.971 261.604 265.303 269.463 243.969 257.861C222.635 246.258 214.775 219.59 226.378 198.256L284.251 91.8668C295.854 70.5328 322.522 62.6728 343.856 74.2755Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1085.03 -80.5837L1089.71 -21.2599L1068.61 -38.9916L1041.1 -40.5355L1085.03 -80.6304V-80.5837ZM1068.05 21.7824C1077.68 44.0522 1067.44 69.9244 1045.17 79.5622L934.006 127.657C911.736 137.295 885.864 127.049 876.226 104.779C866.588 82.5096 876.834 56.6375 899.104 46.9997L1010.27 -1.09549C1032.54 -10.7332 1058.41 -0.487358 1068.05 21.7824Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M684.359 -260.847L724.595 -217.009L697.085 -217.945L674.488 -202.178L684.359 -260.8V-260.847ZM734.139 -169.756C755.473 -158.153 763.333 -131.486 751.73 -110.152L693.857 -3.76218C682.254 17.5719 655.586 25.4319 634.252 13.8291C612.918 2.22638 605.058 -24.4413 616.661 -45.7754L674.534 -152.165C686.137 -173.499 712.805 -181.359 734.139 -169.756Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1040.11 -111.649L1080.35 -67.8111L1052.84 -68.7468L1030.24 -52.9802L1040.11 -111.602V-111.649ZM1089.89 -20.558C1111.23 -8.95523 1119.09 17.7123 1107.48 39.0464L1049.61 145.436C1038.01 166.77 1011.34 174.63 990.006 163.027C968.672 151.424 960.812 124.757 972.415 103.423L1030.29 -2.96681C1041.89 -24.3009 1068.56 -32.1607 1089.89 -20.558Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M787.334 -257.291L827.569 -213.454L800.059 -214.389L777.462 -198.623L787.334 -257.245V-257.291ZM837.113 -166.2C858.447 -154.598 866.307 -127.93 854.705 -106.596L796.831 -0.20639C785.229 21.1277 758.561 28.9875 737.227 17.3848C715.893 5.78201 708.033 -20.8855 719.636 -42.2196L777.509 -148.609C789.112 -169.943 815.779 -177.803 837.113 -166.2Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M424.42 -106.035L475.743 -136.118L469.006 -109.403L479.626 -83.999L424.42 -106.035ZM523.932 -135.463C539.745 -153.849 567.489 -155.908 585.876 -140.095L677.668 -61.0743C696.055 -45.2609 698.113 -17.5173 682.3 0.869308C666.487 19.2559 638.743 21.3144 620.356 5.50101L528.564 -73.5192C510.177 -89.3326 508.119 -117.076 523.932 -135.463Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M360.7 17.7591L326.968 -31.2719L354.103 -26.453L378.665 -38.8979L360.7 17.7591ZM324.161 -79.3671C304.698 -93.8237 300.628 -121.334 315.084 -140.843L387.274 -238.109C401.73 -257.572 429.24 -261.642 448.75 -247.186C468.259 -232.729 472.283 -205.219 457.826 -185.71L385.636 -88.4434C371.18 -68.9808 343.67 -64.9104 324.161 -79.3671Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M256.742 13.0335L278.638 -42.3133L289.772 -17.143L313.773 -3.66885L256.695 12.9867L256.742 13.0335ZM317.001 -71.4606C318.124 -95.6953 338.71 -114.409 362.945 -113.287L483.931 -107.579C508.166 -106.456 526.88 -85.8704 525.757 -61.6357C524.634 -37.4009 504.049 -18.6868 479.814 -19.8097L358.827 -25.5175C334.593 -26.6403 315.879 -47.2259 317.001 -71.4606Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M16.2656 -169.429L69.6943 -143.229L43.7285 -134.106L28.4297 -111.228L16.3124 -169.429H16.2656ZM95.7537 -102.666C119.848 -99.6253 136.878 -77.6363 133.79 -53.5419L118.538 66.6027C115.497 90.6971 93.508 107.727 69.4136 104.639C45.3193 101.551 28.2894 79.6089 31.3772 55.5145L46.6293 -64.6299C49.6703 -88.7243 71.6594 -105.754 95.7537 -102.666Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M763.94 90.6035L705.786 103.282L720.476 79.9833L718.231 52.5204L763.893 90.5568L763.94 90.6035ZM660.17 87.7028C639.398 100.288 612.402 93.6446 599.817 72.872L537.078 -30.7106C524.493 -51.4832 531.137 -78.4783 551.909 -91.0635C572.682 -103.649 599.677 -97.0052 612.262 -76.2325L675.001 27.3499C687.586 48.1225 680.943 75.1176 660.17 87.7028Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M-128.908 -6.66284L-71.6431 9.52481L-95.5503 23.1393L-106.498 48.4033L-128.861 -6.66284H-128.908ZM-38.7063 44.7541C-14.4715 43.4441 6.20753 62.0178 7.5643 86.2526L14.1142 207.192C15.4242 231.427 -3.14952 252.106 -27.3843 253.463C-51.619 254.82 -72.2981 236.199 -73.6549 211.964L-80.2048 91.0247C-81.5148 66.79 -62.941 46.1109 -38.7063 44.7541Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M186.424 62.9537L194.939 4.05095L211.594 25.9932L238.075 33.5257L186.424 62.9537ZM225.443 -33.1901C220.951 -57.0505 236.624 -80.0221 260.485 -84.5135L379.507 -106.97C403.367 -111.462 426.339 -95.7887 430.83 -71.9282C435.321 -48.0678 419.648 -25.0962 395.788 -20.6048L276.766 1.85204C252.906 6.34341 229.934 -9.32959 225.443 -33.1901Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M144.785 -56.8634L109.462 -9.00204L105.158 -36.1842L85.3677 -55.3662L144.785 -56.8634ZM64.9225 9.38452C57.624 32.5432 32.9214 45.3623 9.76273 38.0171L-105.703 1.47781C-128.862 -5.82069 -141.681 -30.5233 -134.336 -53.682C-127.037 -76.8407 -102.335 -89.6598 -79.176 -82.3146L36.2899 -45.7753C59.4486 -38.4768 72.2678 -13.7742 64.9225 9.38452Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M758.28 87.4222L706.349 58.3686L732.783 50.6957L749.344 28.6599L758.28 87.4222ZM682.535 16.4491C658.675 12.098 642.861 -10.78 647.212 -34.6873L668.967 -153.849C673.318 -177.71 696.196 -193.523 720.104 -189.172C744.011 -184.821 759.778 -161.943 755.427 -138.036L733.671 -18.8739C729.32 4.9866 706.442 20.8001 682.535 16.4491Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M806.236 -123.72L857.185 -92.9348L830.517 -86.1042L813.253 -64.6298L806.282 -123.673L806.236 -123.72ZM879.595 -50.2667C903.315 -45.1204 918.38 -21.7278 913.233 1.99229L887.548 120.359C882.402 144.079 859.009 159.144 835.289 153.998C811.569 148.851 796.504 125.459 801.651 101.738L827.336 -16.6281C832.482 -40.3483 855.875 -55.4131 879.595 -50.2667Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M964.931 -187.347L1011.39 -150.153L984.019 -146.925L964.089 -127.93L964.931 -187.394V-187.347ZM1027.95 -104.912C1050.78 -96.6776 1062.62 -71.5072 1054.38 -48.676L1013.31 65.2929C1005.07 88.1241 979.902 99.9607 957.071 91.7265C934.24 83.4923 922.403 58.3218 930.637 35.4906L971.715 -78.4782C979.949 -101.309 1005.12 -113.146 1027.95 -104.912Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1035.25 4.84641L980.275 27.6308L990.615 2.08611L983.55 -24.5347L1035.25 4.79958V4.84641ZM932.648 20.3791C914.449 36.4265 886.705 34.6953 870.611 16.4959L790.468 -74.3143C774.42 -92.5137 776.151 -120.257 794.351 -136.351C812.55 -152.446 840.294 -150.668 856.388 -132.468L936.531 -41.6581C952.578 -23.4587 950.847 4.28502 932.648 20.3791Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1092.47 -90.8296L1089.99 -31.3655L1071.18 -51.4832L1044.09 -56.3021L1092.51 -90.8296H1092.47ZM1063.37 8.82304C1070.24 32.0753 1056.96 56.5439 1033.7 63.4213L917.537 97.8085C894.285 104.686 869.816 91.3989 862.938 68.1467C856.061 44.8944 869.348 20.4257 892.6 13.5482L1008.77 -20.8388C1032.02 -27.7162 1056.49 -14.4292 1063.37 8.82304Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M703.729 -87.648L759.637 -108L748.221 -82.9228L754.116 -56.0213L703.729 -87.6013V-87.648ZM806.89 -98.7363C825.791 -113.988 853.441 -111.041 868.693 -92.1395L944.766 2.08599C960.018 20.9872 957.071 48.6373 938.169 63.8892C919.268 79.1412 891.618 76.1937 876.366 57.2925L800.293 -36.9329C785.041 -55.8341 787.989 -83.4843 806.89 -98.7363Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1292.94 115.119L1233.76 108.99L1255 91.4458L1261.45 64.6846L1292.94 115.119ZM1195.25 79.9365C1171.63 85.4104 1148 70.6263 1142.57 46.9998L1115.34 -71.0394C1109.87 -94.6659 1124.65 -118.293 1148.28 -123.72C1171.91 -129.147 1195.53 -114.409 1200.96 -90.7828L1228.19 27.2564C1233.66 50.8829 1218.88 74.5094 1195.25 79.9365Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1064.21 -211.909L1123.72 -212.752L1104.68 -192.868L1101.36 -165.545L1064.21 -211.956V-211.909ZM1165.31 -188.376C1188.14 -196.564 1213.31 -184.634 1221.5 -161.802L1262.3 -47.7401C1270.49 -24.9089 1258.55 0.261475 1235.72 8.44888C1212.89 16.6363 1187.72 4.7061 1179.53 -18.1251L1138.74 -132.187C1130.55 -155.019 1142.48 -180.189 1165.31 -188.376Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M866.259 -214.155L912.717 -176.961L885.348 -173.733L865.417 -154.738L866.259 -214.202V-214.155ZM929.279 -131.673C952.11 -123.439 963.947 -98.2685 955.713 -75.4373L914.635 38.5316C906.401 61.3628 881.23 73.1995 858.399 64.9653C835.568 56.731 823.731 31.5605 831.966 8.72932L873.043 -105.239C881.277 -128.071 906.448 -139.907 929.279 -131.673Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M946.918 -156.937L944.438 -97.473L925.631 -117.591L898.542 -122.41L946.965 -156.937H946.918ZM917.771 -57.3314C924.648 -34.0791 911.361 -9.61037 888.109 -2.73293L771.941 31.6542C748.689 38.5317 724.22 25.2445 717.343 1.99228C710.465 -21.26 723.752 -45.7286 747.005 -52.606L863.172 -86.9932C886.425 -93.8706 910.893 -80.5836 917.771 -57.3314Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M993.047 -1.28261L1039.13 -38.9448L1036.6 -11.5286L1051.01 11.9109L993.047 -1.28261ZM1086.85 -45.7754C1099.67 -66.4077 1126.76 -72.7236 1147.34 -59.9045L1250.23 4.00415C1270.86 16.8233 1277.17 43.9119 1264.35 64.4974C1251.54 85.0829 1224.45 91.4456 1203.86 78.6265L1100.98 14.7179C1080.35 1.8987 1074.03 -25.1899 1086.85 -45.7754Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1454.68 -222.483L1493.42 -177.289L1465.95 -179.207L1442.84 -164.236L1454.72 -222.483H1454.68ZM1501.32 -129.755C1522.24 -117.45 1529.16 -90.502 1516.86 -69.5891L1455.33 34.7419C1443.03 55.6549 1416.08 62.5792 1395.17 50.2747C1374.25 37.9702 1367.33 11.0219 1379.63 -9.89105L1441.16 -114.222C1453.46 -135.135 1480.41 -142.059 1501.32 -129.755Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1273.57 -208.775L1330.84 -192.587L1306.93 -178.973L1295.98 -153.709L1273.62 -208.775H1273.57ZM1363.73 -157.358C1387.96 -158.668 1408.64 -140.094 1410 -115.86L1416.55 5.08011C1417.86 29.3148 1399.28 49.994 1375.05 51.3508C1350.81 52.7076 1330.14 34.087 1328.78 9.85229L1322.23 -111.088C1320.92 -135.322 1339.49 -156.001 1363.73 -157.358Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M395.6 205.555L361.868 156.524L389.003 161.343L413.566 148.898L395.6 205.555ZM359.061 108.428C339.598 93.9718 335.528 66.4621 349.985 46.9527L422.174 -50.3138C436.631 -69.7765 464.14 -73.8468 483.65 -59.3902C503.159 -44.9335 507.183 -17.4238 492.726 2.08568L420.537 99.3522C406.08 118.815 378.57 122.885 359.061 108.428Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1161.71 121.248L1102.62 114.324L1124.09 97.0599L1130.92 70.3924L1161.76 121.248H1161.71ZM1064.54 84.7554C1040.82 89.9018 1017.42 74.8369 1012.28 51.1168L986.639 -67.2498C981.493 -90.9699 996.557 -114.362 1020.28 -119.509C1044 -124.655 1067.39 -109.59 1072.54 -85.8703L1098.17 32.4964C1103.32 56.2165 1088.26 79.609 1064.54 84.7554Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1035.72 246.913L976.533 240.784L997.774 223.24L1004.23 196.478L1035.72 246.913ZM938.076 211.777C914.449 217.251 890.823 202.467 885.396 178.84L858.167 60.8013C852.693 37.1748 867.477 13.5483 891.103 8.12123C914.73 2.69415 938.356 17.4314 943.783 41.0579L971.012 159.097C976.486 182.724 961.702 206.35 938.076 211.777Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M921.279 -44.6055L980.79 -45.4476L961.749 -25.5639L958.427 1.75865L921.279 -44.6522V-44.6055ZM1022.38 -21.0726C1045.21 -29.26 1070.38 -17.3298 1078.57 5.50141L1119.37 119.564C1127.56 142.395 1115.63 167.566 1092.79 175.753C1069.96 183.94 1044.79 172.01 1036.61 149.179L995.808 35.1165C987.621 12.2853 999.551 -12.8852 1022.38 -21.0726Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M365.611 139.682L387.507 84.3345L398.642 109.505L422.642 122.979L365.564 139.635L365.611 139.682ZM425.871 55.1406C426.993 30.9059 447.579 12.1918 471.814 13.3146L592.8 19.0224C617.035 20.1452 635.749 40.7308 634.626 64.9655C633.503 89.2003 612.918 107.914 588.683 106.792L467.697 101.084C443.462 99.9609 424.748 79.3754 425.871 55.1406Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1593.96 131.541L1537.07 148.992L1549.79 124.57L1545.3 97.3875L1593.96 131.541ZM1490.33 137.248C1470.68 151.518 1443.22 147.12 1428.95 127.47L1357.83 29.4085C1343.56 9.75872 1347.96 -17.7042 1367.61 -31.9737C1387.26 -46.2432 1414.72 -41.8454 1428.99 -22.1956L1500.11 75.8662C1514.38 95.516 1509.98 122.979 1490.33 137.248Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1230.25 -86.2916L1276.71 -49.0973L1249.34 -45.8691L1229.41 -26.8743L1230.25 -86.3383V-86.2916ZM1293.27 -3.85603C1316.1 4.37817 1327.94 29.5487 1319.7 52.3799L1278.63 166.349C1270.39 189.18 1245.22 201.017 1222.39 192.782C1199.56 184.548 1187.72 159.378 1195.96 136.546L1237.03 22.5777C1245.27 -0.253448 1270.44 -12.0902 1293.27 -3.85603Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1355.96 23.7007L1300.99 46.485L1311.33 20.9403L1304.26 -5.68047L1355.96 23.6538V23.7007ZM1253.31 39.2801C1235.11 55.3274 1207.37 53.5964 1191.28 35.397L1111.13 -55.4132C1095.09 -73.6126 1096.82 -101.356 1115.02 -117.45C1133.22 -133.545 1160.96 -131.767 1177.05 -113.567L1257.2 -22.757C1273.24 -4.55759 1271.51 23.186 1253.31 39.2801Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1310.91 -29.12L1308.43 30.3441L1289.62 10.2264L1262.53 5.40753L1310.95 -29.12H1310.91ZM1281.76 70.4858C1288.64 93.7381 1275.35 118.207 1252.1 125.084L1135.93 159.471C1112.68 166.349 1088.21 153.062 1081.33 129.809C1074.46 106.557 1087.74 82.0886 1110.99 75.2112L1227.16 40.824C1250.41 33.9466 1274.88 47.2335 1281.76 70.4858Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1035.06 -137.053L1090.97 -157.405L1079.55 -132.328L1085.45 -105.427L1035.06 -137.007V-137.053ZM1138.22 -148.095C1157.12 -163.347 1184.77 -160.399 1200.03 -141.498L1276.1 -47.2726C1291.35 -28.3713 1288.4 -0.721146 1269.5 14.5308C1250.6 29.7828 1222.95 26.8353 1207.7 7.9341L1131.63 -86.2914C1116.37 -105.193 1119.32 -132.843 1138.22 -148.095Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M754.537 -2.45212L805.861 -32.535L799.123 -5.82066L809.744 19.5837L754.537 -2.45212ZM854.049 -31.8801C869.863 -50.2667 897.606 -52.3252 915.993 -36.5118L1007.79 42.5084C1026.17 58.3218 1028.23 86.0656 1012.42 104.452C996.604 122.839 968.86 124.897 950.474 109.084L858.681 30.0635C840.294 14.2501 838.236 -13.4935 854.049 -31.8801Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1525.7 249.065L1466.61 242.141L1488.08 224.877L1494.91 198.21L1525.74 249.065H1525.7ZM1428.52 212.62C1404.8 217.766 1381.41 202.701 1376.27 178.981L1350.63 60.6144C1345.48 36.8943 1360.55 13.5016 1384.27 8.35524C1407.99 3.20886 1431.38 18.2737 1436.52 41.9938L1462.16 160.36C1467.31 184.08 1452.24 207.473 1428.52 212.62Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M926.66 -223.045L973.117 -185.85L945.748 -182.622L925.817 -163.627L926.66 -223.091V-223.045ZM989.679 -140.562C1012.51 -132.328 1024.35 -107.158 1016.11 -84.3263L975.036 29.6424C966.801 52.4736 941.631 64.3104 918.8 56.0762C895.968 47.842 884.132 22.6714 892.366 -0.159729L933.443 -114.128C941.678 -136.96 966.848 -148.796 989.679 -140.562Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1006.57 -169.616L1004.09 -110.152L985.281 -130.27L958.192 -135.088L1006.62 -169.616H1006.57ZM977.421 -70.0102C984.298 -46.7579 971.011 -22.2892 947.759 -15.4117L831.592 18.9753C808.339 25.8527 783.871 12.5657 776.993 -10.6865C770.116 -33.9388 783.403 -58.4074 806.655 -65.2848L922.823 -99.672C946.075 -106.549 970.544 -93.2624 977.421 -70.0102Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1045.82 11.1621L1091.9 -26.5001L1089.38 0.916145L1103.79 24.3556L1045.82 11.1621ZM1139.58 -33.2838C1152.4 -53.9161 1179.49 -60.2322 1200.07 -47.4131L1302.95 16.4956C1323.58 29.3147 1329.9 56.4035 1317.08 76.989C1304.26 97.5745 1277.17 103.937 1256.59 91.1181L1153.71 27.2094C1133.07 14.3903 1126.76 -12.6983 1139.58 -33.2838Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1513.77 -184.166L1552.51 -138.972L1525.04 -140.89L1501.93 -125.919L1513.81 -184.166H1513.77ZM1560.37 -91.4378C1581.28 -79.1333 1588.2 -52.185 1575.9 -31.272L1514.38 73.059C1502.07 93.972 1475.12 100.896 1454.21 88.5917C1433.3 76.2872 1426.37 49.339 1438.68 28.426L1500.2 -75.9052C1512.5 -96.8182 1539.45 -103.742 1560.37 -91.4378Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1215.32 127.751L1156.23 120.827L1177.71 103.563L1184.54 76.8955L1215.37 127.751H1215.32ZM1118.15 91.3055C1094.43 96.4518 1071.04 81.387 1065.89 57.6669L1040.25 -60.6998C1035.11 -84.4199 1050.17 -107.812 1073.89 -112.959C1097.61 -118.105 1121.01 -103.04 1126.15 -79.3203L1151.79 39.0463C1156.94 62.7664 1141.87 86.1591 1118.15 91.3055Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1079.13 242.281L1019.95 236.152L1041.19 218.608L1047.65 191.847L1079.13 242.281ZM981.445 207.145C957.818 212.619 934.192 197.835 928.765 174.209L901.536 56.1695C896.062 32.5429 910.846 8.91636 934.473 3.48927C958.099 -1.93782 981.726 12.7996 987.153 36.4261L1014.38 154.465C1019.86 178.092 1005.07 201.718 981.445 207.145Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M970.637 -41.7519L1030.15 -42.5941L1011.11 -22.7104L1007.78 4.61231L970.637 -41.7987V-41.7519ZM1071.74 -18.2189C1094.57 -26.4063 1119.74 -14.4761 1127.93 8.35507L1168.73 122.417C1176.91 145.249 1164.98 170.419 1142.15 178.606C1119.32 186.794 1094.15 174.864 1085.96 152.032L1045.17 37.9701C1036.98 15.1389 1048.91 -10.0315 1071.74 -18.2189Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M443.555 -71.4137L501.989 -60.1853L479.299 -44.559L470.55 -18.4529L443.555 -71.4137ZM537.827 -27.9503C561.875 -31.3189 584.098 -14.6164 587.466 9.43118L604.355 129.388C607.724 153.436 591.022 175.659 566.974 179.028C542.927 182.396 520.703 165.694 517.335 141.646L500.446 21.6889C497.077 -2.35873 513.779 -24.5818 537.827 -27.9503Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1520.64 -97.2391L1525.32 -37.9154L1504.22 -55.6469L1476.71 -57.1909L1520.64 -97.2858V-97.2391ZM1503.71 5.17385C1513.35 27.4436 1503.1 53.3159 1480.83 62.9536L1369.67 111.049C1347.4 120.687 1321.53 110.441 1311.89 88.1708C1302.25 65.901 1312.5 40.0288 1334.77 30.391L1445.93 -17.7042C1468.2 -27.3419 1494.07 -17.0959 1503.71 5.17385Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M438.783 -72.9576L485.24 -35.7633L457.871 -32.5351L437.941 -13.5403L438.783 -73.0044V-72.9576ZM501.802 9.47798C524.634 17.7122 536.47 42.8827 528.236 65.7139L487.159 179.683C478.924 202.514 453.754 214.35 430.923 206.116C408.092 197.882 396.255 172.712 404.489 149.88L445.566 35.9116C453.801 13.0804 478.971 1.24378 501.802 9.47798Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M669.013 70.439L614.041 93.2234L624.38 67.6787L617.316 41.0579L669.013 70.3923V70.439ZM566.367 86.0185C548.167 102.066 520.424 100.335 504.329 82.1353L424.186 -8.67486C408.139 -26.8743 409.87 -54.6179 428.07 -70.712C446.269 -86.8061 474.013 -85.0283 490.107 -66.8289L570.25 23.9813C586.297 42.1807 584.566 69.9244 566.367 86.0185Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M536.471 -63.1796L533.991 -3.71544L515.183 -23.8332L488.095 -28.652L536.517 -63.1796H536.471ZM507.37 36.4262C514.248 59.6785 500.961 84.1472 477.708 91.0247L361.541 125.412C338.288 132.289 313.82 119.002 306.942 95.7499C300.065 72.4976 313.352 48.029 336.604 41.1516L452.772 6.76441C476.024 -0.113018 500.493 13.174 507.37 36.4262Z",
                        fill: "#FDB72E"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M371.039 249.58L311.855 243.451L333.096 225.906L339.552 199.145L371.039 249.58ZM273.398 214.397C249.771 219.871 226.145 205.087 220.718 181.46L193.489 63.4213C188.015 39.7948 202.799 16.1683 226.426 10.7412C250.052 5.31414 273.679 20.0514 279.106 43.6779L306.335 161.717C311.809 185.344 297.024 208.97 273.398 214.397Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M940.461 -277.035L980.696 -233.197L953.187 -234.133L930.589 -218.366L940.461 -276.988V-277.035ZM990.24 -185.944C1011.57 -174.341 1019.43 -147.674 1007.83 -126.34L949.958 -19.95C938.356 1.38403 911.688 9.24384 890.354 -2.35889C869.02 -13.9616 861.16 -40.6292 872.763 -61.9632L930.636 -168.353C942.239 -189.687 968.906 -197.547 990.24 -185.944Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M324.814 10.3668L380.723 -9.98477L369.307 15.0922L375.202 41.9937L324.814 10.4137V10.3668ZM428.023 -0.72124C446.924 -15.9732 474.574 -13.0257 489.826 5.87549L565.899 100.101C581.151 119.002 578.203 146.652 559.302 161.904C540.401 177.156 512.751 174.209 497.499 155.308L421.426 61.082C406.174 42.1808 409.121 14.5307 428.023 -0.72124Z",
                        fill: "#CB7FF5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1450.42 -89.7534L1490.66 -45.9157L1463.15 -46.8513L1440.55 -31.0847L1450.42 -89.7066V-89.7534ZM1500.2 1.33743C1521.53 12.9402 1529.39 39.6077 1517.79 60.9418L1459.92 167.331C1448.31 188.666 1421.65 196.525 1400.31 184.923C1378.98 173.32 1371.12 146.652 1382.72 125.318L1440.59 18.9287C1452.2 -2.40535 1478.87 -10.2653 1500.2 1.33743Z",
                        fill: "#CB7FF5"
                    })
                ]
            })
        ]
    });

});


parcelRegister("6nTac", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $489bc9d32a5c9852$export$2e2bcd8739ae039; });
/* design-refresh-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $dZNgt = parcelRequire("dZNgt");

var $jehLw = parcelRequire("jehLw");

var $kbpa7 = parcelRequire("kbpa7");

var $hMmnm = parcelRequire("hMmnm");
const $489bc9d32a5c9852$var$UniformDesignRefreshHeading = ({ heading: heading, subheading: subheading, emphasisStyle: emphasisStyle = "blueShapes", textColor: textColor = "dark" })=>{
    const textColorClass = textColor === "light" ? "textColor-light" : "";
    const getNode = (value)=>{
        if (!value) return undefined;
        return value.root || value;
    };
    const headingNode = getNode(heading);
    const subheadingNode = getNode(subheading);
    const hasHeading = heading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(heading);
    const hasSubheading = subheading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(subheading);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            hasHeading && headingNode && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1yoqidpf _rojhidpf _f0a5idpf _823zidpf _1n3widpf _gkzjidpf _pb27idpf _1x9pidpf _d09g1gnr _1bpp1gnr _ihkewebb _1rfewebb _io87pxbi _1ticpxbi _1ppph2mm _1uh8h2mm _bsml4jg8 _1kix4jg8 _uy2yb3bt _jmz4b3bt _4ql2stnw _3ebnstnw _1shtpm4n _1l3mpm4n _137116r0 _1egr16r0 _1i9t1et3 _6vws1et3 _1l9v8vuz _1lf68vuz _12eq1f51 _q8d91f51 _hhnzmgnk _uu55mgnk _1u2lglyw _15rkglyw _1quaov9v _1fzcov9v _7rsb1wug _jzo61wug _1tcg10j7 _15oh10j7 _zk071kdv _1rnv1kdv _d5961j28 _jmh61j28 _r0xv1kdv _32hl1kdv _eycy1x5a _33xt1x5a _jxar4pt2 _1haa4pt2 _1wsv8pqr _1paf8pqr _9x3msxyd _dftg1mtn _qoyoecb6 _744p1w2a _ydm7izje _lyva145n _ck5gcd5j _dgcscd5j",
                    `design-refresh-heading ${emphasisStyle} ${textColorClass}`
                ]),
                style: {
                    "--_o8nmkh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue500")),
                    "--_1lttd86": (0, $6ZVlx.default)($489bc9d32a5c9852$var$cssifySVG((0, $hMmnm.blueShapesSVG)())),
                    "--_1yno7nz": (0, $6ZVlx.default)($489bc9d32a5c9852$var$cssifySVG((0, $hMmnm.eyelashes)((0, $kbpa7.wacToken)("color.extended.blue500")))),
                    "--_e0fbx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple500")),
                    "--_3zd0ej": (0, $6ZVlx.default)($489bc9d32a5c9852$var$cssifySVG((0, $hMmnm.orangePurpleShapesSVG)())),
                    "--_ak9xfd": (0, $6ZVlx.default)($489bc9d32a5c9852$var$cssifySVG((0, $hMmnm.eyelashes)((0, $kbpa7.wacToken)("color.extended.purple500")))),
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                    node: headingNode,
                    resolveRichTextRenderer: $489bc9d32a5c9852$var$resolveHeadingRenderer
                })
            }),
            hasSubheading && subheadingNode && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _q7gq1k92 _zcqxbs82 _1jzwcd5j _vakocd5j",
                    textColorClass
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                    node: subheadingNode,
                    resolveRichTextRenderer: $489bc9d32a5c9852$var$resolveSubheadingRenderer
                })
            })
        ]
    });
};
const $489bc9d32a5c9852$var$cssifySVG = (svgElement)=>{
    const svgString = (0, $jehLw.renderToStaticMarkup)(svgElement);
    return 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString) + '")';
};
const $489bc9d32a5c9852$var$containerCss = null;
const $489bc9d32a5c9852$var$headingCss = null;
const $489bc9d32a5c9852$var$subheadingCss = null;
function $489bc9d32a5c9852$var$resolveHeadingRenderer(node) {
    if (node.type === "heading" || node.type === "paragraph") return ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
            children: children
        });
    return undefined;
}
function $489bc9d32a5c9852$var$resolveSubheadingRenderer(node) {
    if (node.type === "paragraph") return ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: children
        });
    return undefined;
}
var $489bc9d32a5c9852$export$2e2bcd8739ae039 = $489bc9d32a5c9852$var$UniformDesignRefreshHeading;

});
parcelRegister("jehLw", function(module, exports) {
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $dffd1af9bc104dd9$export$eb3a06aef9e6ee51; }, function (v) { return $dffd1af9bc104dd9$export$eb3a06aef9e6ee51 = v; });
var $dffd1af9bc104dd9$export$83d89fbfd8236492;
var $dffd1af9bc104dd9$export$80e7718417253a51;
var $dffd1af9bc104dd9$export$eb3a06aef9e6ee51;
var $dffd1af9bc104dd9$export$307591e98609eddd;
var $dffd1af9bc104dd9$export$b23711c915539651;
var $dffd1af9bc104dd9$export$7020a3240b287705;
'use strict';
var $dffd1af9bc104dd9$var$l, $dffd1af9bc104dd9$var$s;

$dffd1af9bc104dd9$var$l = (parcelRequire("8hHXc"));

$dffd1af9bc104dd9$var$s = (parcelRequire("dRPp5"));
$dffd1af9bc104dd9$export$83d89fbfd8236492 = $dffd1af9bc104dd9$var$l.version;
$dffd1af9bc104dd9$export$80e7718417253a51 = $dffd1af9bc104dd9$var$l.renderToString;
$dffd1af9bc104dd9$export$eb3a06aef9e6ee51 = $dffd1af9bc104dd9$var$l.renderToStaticMarkup;
$dffd1af9bc104dd9$export$307591e98609eddd = $dffd1af9bc104dd9$var$l.renderToNodeStream;
$dffd1af9bc104dd9$export$b23711c915539651 = $dffd1af9bc104dd9$var$l.renderToStaticNodeStream;
$dffd1af9bc104dd9$export$7020a3240b287705 = $dffd1af9bc104dd9$var$s.renderToReadableStream;

});
parcelRegister("8hHXc", function(module, exports) {
$parcel$export(module.exports, "renderToNodeStream", function () { return $60820199b182faf3$export$307591e98609eddd; }, function (v) { return $60820199b182faf3$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $60820199b182faf3$export$eb3a06aef9e6ee51; }, function (v) { return $60820199b182faf3$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $60820199b182faf3$export$b23711c915539651; }, function (v) { return $60820199b182faf3$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToString", function () { return $60820199b182faf3$export$80e7718417253a51; }, function (v) { return $60820199b182faf3$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "version", function () { return $60820199b182faf3$export$83d89fbfd8236492; }, function (v) { return $60820199b182faf3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60820199b182faf3$export$307591e98609eddd;
var $60820199b182faf3$export$eb3a06aef9e6ee51;
var $60820199b182faf3$export$b23711c915539651;
var $60820199b182faf3$export$80e7718417253a51;
var $60820199b182faf3$export$83d89fbfd8236492;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $60820199b182faf3$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $60820199b182faf3$var$p = Object.prototype.hasOwnProperty, $60820199b182faf3$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $60820199b182faf3$var$ha = {}, $60820199b182faf3$var$ia = {};
function $60820199b182faf3$var$ja(a) {
    if ($60820199b182faf3$var$p.call($60820199b182faf3$var$ia, a)) return !0;
    if ($60820199b182faf3$var$p.call($60820199b182faf3$var$ha, a)) return !1;
    if ($60820199b182faf3$var$fa.test(a)) return $60820199b182faf3$var$ia[a] = !0;
    $60820199b182faf3$var$ha[a] = !0;
    return !1;
}
function $60820199b182faf3$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $60820199b182faf3$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $60820199b182faf3$var$t[b] = new $60820199b182faf3$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $60820199b182faf3$var$ka = /[\-:]([a-z])/g;
function $60820199b182faf3$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($60820199b182faf3$var$ka, $60820199b182faf3$var$la);
    $60820199b182faf3$var$t[b] = new $60820199b182faf3$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($60820199b182faf3$var$ka, $60820199b182faf3$var$la);
    $60820199b182faf3$var$t[b] = new $60820199b182faf3$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($60820199b182faf3$var$ka, $60820199b182faf3$var$la);
    $60820199b182faf3$var$t[b] = new $60820199b182faf3$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$60820199b182faf3$var$t.xlinkHref = new $60820199b182faf3$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $60820199b182faf3$var$t[a] = new $60820199b182faf3$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $60820199b182faf3$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $60820199b182faf3$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($60820199b182faf3$var$u).forEach(function(a) {
    $60820199b182faf3$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $60820199b182faf3$var$u[b] = $60820199b182faf3$var$u[a];
    });
});
var $60820199b182faf3$var$na = /["'&<>]/;
function $60820199b182faf3$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $60820199b182faf3$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $60820199b182faf3$var$oa = /([A-Z])/g, $60820199b182faf3$var$pa = /^ms-/, $60820199b182faf3$var$qa = Array.isArray;
function $60820199b182faf3$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $60820199b182faf3$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $60820199b182faf3$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $60820199b182faf3$var$w(2, null);
        case "math":
            return $60820199b182faf3$var$w(3, null);
        case "foreignObject":
            return $60820199b182faf3$var$w(1, null);
        case "table":
            return $60820199b182faf3$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $60820199b182faf3$var$w(5, null);
        case "colgroup":
            return $60820199b182faf3$var$w(7, null);
        case "tr":
            return $60820199b182faf3$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $60820199b182faf3$var$w(1, null) : a;
}
var $60820199b182faf3$var$sa = new Map;
function $60820199b182faf3$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($60820199b182faf3$var$l(62));
    b = !0;
    for(var d in c)if ($60820199b182faf3$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $60820199b182faf3$var$v(d);
                f = $60820199b182faf3$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $60820199b182faf3$var$sa.get(e);
                void 0 !== g ? e = g : (g = $60820199b182faf3$var$v(e.replace($60820199b182faf3$var$oa, "-$1").toLowerCase().replace($60820199b182faf3$var$pa, "-ms-")), $60820199b182faf3$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $60820199b182faf3$var$p.call($60820199b182faf3$var$u, d) ? "" + f : f + "px" : $60820199b182faf3$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $60820199b182faf3$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $60820199b182faf3$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $60820199b182faf3$var$t.hasOwnProperty(c) ? $60820199b182faf3$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
            }
        } else if ($60820199b182faf3$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $60820199b182faf3$var$v(d), '"');
        }
    }
}
function $60820199b182faf3$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($60820199b182faf3$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($60820199b182faf3$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $60820199b182faf3$var$ua(a) {
    var b = "";
    $1oC0p.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $60820199b182faf3$var$va(a, b, c, d) {
    a.push($60820199b182faf3$var$A(c));
    var f = c = null, e;
    for(e in b)if ($60820199b182faf3$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $60820199b182faf3$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $60820199b182faf3$var$y(a, f, c);
    return "string" === typeof c ? (a.push($60820199b182faf3$var$v(c)), null) : c;
}
var $60820199b182faf3$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $60820199b182faf3$var$xa = new Map;
function $60820199b182faf3$var$A(a) {
    var b = $60820199b182faf3$var$xa.get(a);
    if (void 0 === b) {
        if (!$60820199b182faf3$var$wa.test(a)) throw Error($60820199b182faf3$var$l(65, a));
        b = "<" + a;
        $60820199b182faf3$var$xa.set(a, b);
    }
    return b;
}
function $60820199b182faf3$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($60820199b182faf3$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($60820199b182faf3$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $60820199b182faf3$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $60820199b182faf3$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($60820199b182faf3$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($60820199b182faf3$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $60820199b182faf3$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $60820199b182faf3$var$ua(h), $60820199b182faf3$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $60820199b182faf3$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($60820199b182faf3$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($60820199b182faf3$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(91));
                default:
                    $60820199b182faf3$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($60820199b182faf3$var$l(92));
                if ($60820199b182faf3$var$qa(n) && 1 < n.length) throw Error($60820199b182faf3$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($60820199b182faf3$var$v("" + e));
            return null;
        case "input":
            a.push($60820199b182faf3$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($60820199b182faf3$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $60820199b182faf3$var$x(a, d, g, m);
            }
            null !== n ? $60820199b182faf3$var$x(a, d, "checked", n) : null !== k && $60820199b182faf3$var$x(a, d, "checked", k);
            null !== e ? $60820199b182faf3$var$x(a, d, "value", e) : null !== h && $60820199b182faf3$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($60820199b182faf3$var$A("menuitem"));
            for(var C in c)if ($60820199b182faf3$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(400));
                default:
                    $60820199b182faf3$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($60820199b182faf3$var$A("title"));
            e = null;
            for(q in c)if ($60820199b182faf3$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(434));
                default:
                    $60820199b182faf3$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($60820199b182faf3$var$A(b));
            g = e = null;
            for(k in c)if ($60820199b182faf3$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $60820199b182faf3$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($60820199b182faf3$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($60820199b182faf3$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($60820199b182faf3$var$A(b));
            for(var D in c)if ($60820199b182faf3$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($60820199b182faf3$var$l(399, b));
                default:
                    $60820199b182faf3$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $60820199b182faf3$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $60820199b182faf3$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $60820199b182faf3$var$va(a, c, b, d);
            a.push($60820199b182faf3$var$A(b));
            g = e = null;
            for(m in c)if ($60820199b182faf3$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $60820199b182faf3$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $60820199b182faf3$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $60820199b182faf3$var$v(h), '"');
            }
            a.push(">");
            $60820199b182faf3$var$y(a, g, e);
            return e;
    }
}
function $60820199b182faf3$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($60820199b182faf3$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $60820199b182faf3$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($60820199b182faf3$var$l(397));
    }
}
function $60820199b182faf3$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($60820199b182faf3$var$l(397));
    }
}
var $60820199b182faf3$var$Ca = /[<\u2028\u2029]/g;
function $60820199b182faf3$var$Da(a) {
    return JSON.stringify(a).replace($60820199b182faf3$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $60820199b182faf3$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $60820199b182faf3$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($60820199b182faf3$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($60820199b182faf3$var$v(b)), a = !0);
    return a;
}
var $60820199b182faf3$var$B = Object.assign, $60820199b182faf3$var$Ga = Symbol.for("react.element"), $60820199b182faf3$var$Ha = Symbol.for("react.portal"), $60820199b182faf3$var$Ia = Symbol.for("react.fragment"), $60820199b182faf3$var$Ja = Symbol.for("react.strict_mode"), $60820199b182faf3$var$Ka = Symbol.for("react.profiler"), $60820199b182faf3$var$La = Symbol.for("react.provider"), $60820199b182faf3$var$Ma = Symbol.for("react.context"), $60820199b182faf3$var$Na = Symbol.for("react.forward_ref"), $60820199b182faf3$var$Oa = Symbol.for("react.suspense"), $60820199b182faf3$var$Pa = Symbol.for("react.suspense_list"), $60820199b182faf3$var$Qa = Symbol.for("react.memo"), $60820199b182faf3$var$Ra = Symbol.for("react.lazy"), $60820199b182faf3$var$Sa = Symbol.for("react.scope"), $60820199b182faf3$var$Ta = Symbol.for("react.debug_trace_mode"), $60820199b182faf3$var$Ua = Symbol.for("react.legacy_hidden"), $60820199b182faf3$var$Va = Symbol.for("react.default_value"), $60820199b182faf3$var$Wa = Symbol.iterator;
function $60820199b182faf3$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $60820199b182faf3$var$Ia:
            return "Fragment";
        case $60820199b182faf3$var$Ha:
            return "Portal";
        case $60820199b182faf3$var$Ka:
            return "Profiler";
        case $60820199b182faf3$var$Ja:
            return "StrictMode";
        case $60820199b182faf3$var$Oa:
            return "Suspense";
        case $60820199b182faf3$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $60820199b182faf3$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $60820199b182faf3$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $60820199b182faf3$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $60820199b182faf3$var$Qa:
            return b = a.displayName || null, null !== b ? b : $60820199b182faf3$var$Xa(a.type) || "Memo";
        case $60820199b182faf3$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $60820199b182faf3$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $60820199b182faf3$var$Ya = {};
function $60820199b182faf3$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $60820199b182faf3$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $60820199b182faf3$var$E = null;
function $60820199b182faf3$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($60820199b182faf3$var$l(401));
        } else {
            if (null === c) throw Error($60820199b182faf3$var$l(401));
            $60820199b182faf3$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $60820199b182faf3$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $60820199b182faf3$var$$a(a);
}
function $60820199b182faf3$var$ab(a) {
    var b = a.parent;
    null !== b && $60820199b182faf3$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $60820199b182faf3$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($60820199b182faf3$var$l(402));
    a.depth === b.depth ? $60820199b182faf3$var$F(a, b) : $60820199b182faf3$var$bb(a, b);
}
function $60820199b182faf3$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($60820199b182faf3$var$l(402));
    a.depth === c.depth ? $60820199b182faf3$var$F(a, c) : $60820199b182faf3$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $60820199b182faf3$var$G(a) {
    var b = $60820199b182faf3$var$E;
    b !== a && (null === b ? $60820199b182faf3$var$ab(a) : null === a ? $60820199b182faf3$var$$a(b) : b.depth === a.depth ? $60820199b182faf3$var$F(b, a) : b.depth > a.depth ? $60820199b182faf3$var$bb(b, a) : $60820199b182faf3$var$cb(b, a), $60820199b182faf3$var$E = a);
}
var $60820199b182faf3$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $60820199b182faf3$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $60820199b182faf3$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $60820199b182faf3$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $60820199b182faf3$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $60820199b182faf3$var$B({}, e, h)) : $60820199b182faf3$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $60820199b182faf3$var$fb = {
    id: 1,
    overflow: ""
};
function $60820199b182faf3$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $60820199b182faf3$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $60820199b182faf3$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $60820199b182faf3$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $60820199b182faf3$var$H = Math.clz32 ? Math.clz32 : $60820199b182faf3$var$hb, $60820199b182faf3$var$ib = Math.log, $60820199b182faf3$var$jb = Math.LN2;
function $60820199b182faf3$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($60820199b182faf3$var$ib(a) / $60820199b182faf3$var$jb | 0) | 0;
}
function $60820199b182faf3$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $60820199b182faf3$var$lb = "function" === typeof Object.is ? Object.is : $60820199b182faf3$var$kb, $60820199b182faf3$var$I = null, $60820199b182faf3$var$ob = null, $60820199b182faf3$var$J = null, $60820199b182faf3$var$K = null, $60820199b182faf3$var$L = !1, $60820199b182faf3$var$M = !1, $60820199b182faf3$var$N = 0, $60820199b182faf3$var$O = null, $60820199b182faf3$var$P = 0;
function $60820199b182faf3$var$Q() {
    if (null === $60820199b182faf3$var$I) throw Error($60820199b182faf3$var$l(321));
    return $60820199b182faf3$var$I;
}
function $60820199b182faf3$var$pb() {
    if (0 < $60820199b182faf3$var$P) throw Error($60820199b182faf3$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $60820199b182faf3$var$qb() {
    null === $60820199b182faf3$var$K ? null === $60820199b182faf3$var$J ? ($60820199b182faf3$var$L = !1, $60820199b182faf3$var$J = $60820199b182faf3$var$K = $60820199b182faf3$var$pb()) : ($60820199b182faf3$var$L = !0, $60820199b182faf3$var$K = $60820199b182faf3$var$J) : null === $60820199b182faf3$var$K.next ? ($60820199b182faf3$var$L = !1, $60820199b182faf3$var$K = $60820199b182faf3$var$K.next = $60820199b182faf3$var$pb()) : ($60820199b182faf3$var$L = !0, $60820199b182faf3$var$K = $60820199b182faf3$var$K.next);
    return $60820199b182faf3$var$K;
}
function $60820199b182faf3$var$rb() {
    $60820199b182faf3$var$ob = $60820199b182faf3$var$I = null;
    $60820199b182faf3$var$M = !1;
    $60820199b182faf3$var$J = null;
    $60820199b182faf3$var$P = 0;
    $60820199b182faf3$var$K = $60820199b182faf3$var$O = null;
}
function $60820199b182faf3$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $60820199b182faf3$var$tb(a, b, c) {
    $60820199b182faf3$var$I = $60820199b182faf3$var$Q();
    $60820199b182faf3$var$K = $60820199b182faf3$var$qb();
    if ($60820199b182faf3$var$L) {
        var d = $60820199b182faf3$var$K.queue;
        b = d.dispatch;
        if (null !== $60820199b182faf3$var$O && (c = $60820199b182faf3$var$O.get(d), void 0 !== c)) {
            $60820199b182faf3$var$O.delete(d);
            d = $60820199b182faf3$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $60820199b182faf3$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $60820199b182faf3$var$K.memoizedState,
            b
        ];
    }
    a = a === $60820199b182faf3$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $60820199b182faf3$var$K.memoizedState = a;
    a = $60820199b182faf3$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $60820199b182faf3$var$ub.bind(null, $60820199b182faf3$var$I, a);
    return [
        $60820199b182faf3$var$K.memoizedState,
        a
    ];
}
function $60820199b182faf3$var$vb(a, b) {
    $60820199b182faf3$var$I = $60820199b182faf3$var$Q();
    $60820199b182faf3$var$K = $60820199b182faf3$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $60820199b182faf3$var$K) {
        var c = $60820199b182faf3$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$60820199b182faf3$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $60820199b182faf3$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $60820199b182faf3$var$ub(a, b, c) {
    if (25 <= $60820199b182faf3$var$P) throw Error($60820199b182faf3$var$l(301));
    if (a === $60820199b182faf3$var$I) {
        if ($60820199b182faf3$var$M = !0, a = {
            action: c,
            next: null
        }, null === $60820199b182faf3$var$O && ($60820199b182faf3$var$O = new Map), c = $60820199b182faf3$var$O.get(b), void 0 === c) $60820199b182faf3$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $60820199b182faf3$var$wb() {
    throw Error($60820199b182faf3$var$l(394));
}
function $60820199b182faf3$var$R() {}
var $60820199b182faf3$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $60820199b182faf3$var$Q();
        return a._currentValue2;
    },
    useMemo: $60820199b182faf3$var$vb,
    useReducer: $60820199b182faf3$var$tb,
    useRef: function(a) {
        $60820199b182faf3$var$I = $60820199b182faf3$var$Q();
        $60820199b182faf3$var$K = $60820199b182faf3$var$qb();
        var b = $60820199b182faf3$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $60820199b182faf3$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $60820199b182faf3$var$tb($60820199b182faf3$var$sb, a);
    },
    useInsertionEffect: $60820199b182faf3$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $60820199b182faf3$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $60820199b182faf3$var$R,
    useEffect: $60820199b182faf3$var$R,
    useDebugValue: $60820199b182faf3$var$R,
    useDeferredValue: function(a) {
        $60820199b182faf3$var$Q();
        return a;
    },
    useTransition: function() {
        $60820199b182faf3$var$Q();
        return [
            !1,
            $60820199b182faf3$var$wb
        ];
    },
    useId: function() {
        var a = $60820199b182faf3$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $60820199b182faf3$var$H(a) - 1)).toString(32) + b;
        var c = $60820199b182faf3$var$S;
        if (null === c) throw Error($60820199b182faf3$var$l(404));
        b = $60820199b182faf3$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $60820199b182faf3$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($60820199b182faf3$var$l(407));
        return c();
    }
}, $60820199b182faf3$var$S = null, $60820199b182faf3$var$yb = $1oC0p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $60820199b182faf3$var$zb(a) {
    console.error(a);
    return null;
}
function $60820199b182faf3$var$T() {}
function $60820199b182faf3$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $60820199b182faf3$var$zb : f,
        onAllReady: void 0 === e ? $60820199b182faf3$var$T : e,
        onShellReady: void 0 === g ? $60820199b182faf3$var$T : g,
        onShellError: void 0 === h ? $60820199b182faf3$var$T : h,
        onFatalError: void 0 === k ? $60820199b182faf3$var$T : k
    };
    c = $60820199b182faf3$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $60820199b182faf3$var$Bb(b, a, null, c, n, $60820199b182faf3$var$Ya, null, $60820199b182faf3$var$fb);
    m.push(a);
    return b;
}
function $60820199b182faf3$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $60820199b182faf3$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $60820199b182faf3$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $60820199b182faf3$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $60820199b182faf3$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $60820199b182faf3$var$Db(a, b, c, d, f) {
    $60820199b182faf3$var$I = {};
    $60820199b182faf3$var$ob = b;
    $60820199b182faf3$var$N = 0;
    for(a = c(d, f); $60820199b182faf3$var$M;)$60820199b182faf3$var$M = !1, $60820199b182faf3$var$N = 0, $60820199b182faf3$var$P += 1, $60820199b182faf3$var$K = null, a = c(d, f);
    $60820199b182faf3$var$rb();
    return a;
}
function $60820199b182faf3$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($60820199b182faf3$var$l(108, $60820199b182faf3$var$Xa(d) || "Unknown", h));
            d = $60820199b182faf3$var$B({}, g, c);
        }
        b.legacyContext = d;
        $60820199b182faf3$var$X(a, b, f);
        b.legacyContext = g;
    } else $60820199b182faf3$var$X(a, b, f);
}
function $60820199b182faf3$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $60820199b182faf3$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $60820199b182faf3$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $60820199b182faf3$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $60820199b182faf3$var$eb(e, c, d, f);
            $60820199b182faf3$var$Eb(a, b, e, c);
        } else {
            e = $60820199b182faf3$var$Za(c, b.legacyContext);
            f = $60820199b182faf3$var$Db(a, b, c, d, e);
            var g = 0 !== $60820199b182faf3$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $60820199b182faf3$var$eb(f, c, d, e), $60820199b182faf3$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $60820199b182faf3$var$gb(d, 1, 0);
                try {
                    $60820199b182faf3$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $60820199b182faf3$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $60820199b182faf3$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $60820199b182faf3$var$ra(g, c, d);
        $60820199b182faf3$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $60820199b182faf3$var$Ua:
            case $60820199b182faf3$var$Ta:
            case $60820199b182faf3$var$Ja:
            case $60820199b182faf3$var$Ka:
            case $60820199b182faf3$var$Ia:
                $60820199b182faf3$var$X(a, b, d.children);
                return;
            case $60820199b182faf3$var$Pa:
                $60820199b182faf3$var$X(a, b, d.children);
                return;
            case $60820199b182faf3$var$Sa:
                throw Error($60820199b182faf3$var$l(343));
            case $60820199b182faf3$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $60820199b182faf3$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $60820199b182faf3$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($60820199b182faf3$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $60820199b182faf3$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $60820199b182faf3$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $60820199b182faf3$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $60820199b182faf3$var$Na:
                d = $60820199b182faf3$var$Db(a, b, c.render, d, f);
                if (0 !== $60820199b182faf3$var$N) {
                    c = b.treeContext;
                    b.treeContext = $60820199b182faf3$var$gb(c, 1, 0);
                    try {
                        $60820199b182faf3$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $60820199b182faf3$var$X(a, b, d);
                return;
            case $60820199b182faf3$var$Qa:
                c = c.type;
                d = $60820199b182faf3$var$Fb(c, d);
                $60820199b182faf3$var$Gb(a, b, c, d, f);
                return;
            case $60820199b182faf3$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $60820199b182faf3$var$E;
                $60820199b182faf3$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $60820199b182faf3$var$X(a, b, f);
                a = $60820199b182faf3$var$E;
                if (null === a) throw Error($60820199b182faf3$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $60820199b182faf3$var$Va ? a.context._defaultValue : d;
                a = $60820199b182faf3$var$E = a.parent;
                b.context = a;
                return;
            case $60820199b182faf3$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $60820199b182faf3$var$X(a, b, d);
                return;
            case $60820199b182faf3$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $60820199b182faf3$var$Fb(c, d);
                $60820199b182faf3$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($60820199b182faf3$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $60820199b182faf3$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $60820199b182faf3$var$Ga:
                $60820199b182faf3$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $60820199b182faf3$var$Ha:
                throw Error($60820199b182faf3$var$l(257));
            case $60820199b182faf3$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $60820199b182faf3$var$X(a, b, c);
                return;
        }
        if ($60820199b182faf3$var$qa(c)) {
            $60820199b182faf3$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $60820199b182faf3$var$Wa && c[$60820199b182faf3$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $60820199b182faf3$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($60820199b182faf3$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $60820199b182faf3$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $60820199b182faf3$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $60820199b182faf3$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $60820199b182faf3$var$gb(e, d, f);
        try {
            $60820199b182faf3$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $60820199b182faf3$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $60820199b182faf3$var$X(a, b, c);
    } catch (k) {
        if ($60820199b182faf3$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $60820199b182faf3$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $60820199b182faf3$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $60820199b182faf3$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $60820199b182faf3$var$G(e), k;
    }
}
function $60820199b182faf3$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $60820199b182faf3$var$Kb(this, b, a);
}
function $60820199b182faf3$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($60820199b182faf3$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $60820199b182faf3$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $60820199b182faf3$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $60820199b182faf3$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $60820199b182faf3$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($60820199b182faf3$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $60820199b182faf3$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $60820199b182faf3$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($60820199b182faf3$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($60820199b182faf3$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $60820199b182faf3$var$Cb(a) {
    if (2 !== a.status) {
        var b = $60820199b182faf3$var$E, c = $60820199b182faf3$var$yb.current;
        $60820199b182faf3$var$yb.current = $60820199b182faf3$var$xb;
        var d = $60820199b182faf3$var$S;
        $60820199b182faf3$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $60820199b182faf3$var$G(g.context);
                    try {
                        $60820199b182faf3$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $60820199b182faf3$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($60820199b182faf3$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $60820199b182faf3$var$V(h, q);
                            null === n ? $60820199b182faf3$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $60820199b182faf3$var$Mb(a, a.destination);
        } catch (z) {
            $60820199b182faf3$var$V(a, z), $60820199b182faf3$var$W(a, z);
        } finally{
            $60820199b182faf3$var$S = d, $60820199b182faf3$var$yb.current = c, c === $60820199b182faf3$var$xb && $60820199b182faf3$var$G(b);
        }
    }
}
function $60820199b182faf3$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $60820199b182faf3$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($60820199b182faf3$var$l(390));
    }
}
function $60820199b182faf3$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $60820199b182faf3$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $60820199b182faf3$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $60820199b182faf3$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $60820199b182faf3$var$za(b, a.responseState, d);
        $60820199b182faf3$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $60820199b182faf3$var$za(b, a.responseState, d.id), $60820199b182faf3$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($60820199b182faf3$var$l(391));
    $60820199b182faf3$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $60820199b182faf3$var$Ob(a, b, c) {
    $60820199b182faf3$var$Aa(b, a.responseState, c.formatContext, c.id);
    $60820199b182faf3$var$Nb(a, b, c);
    return $60820199b182faf3$var$Ba(b, c.formatContext);
}
function $60820199b182faf3$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$60820199b182faf3$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($60820199b182faf3$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $60820199b182faf3$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($60820199b182faf3$var$l(392));
        return $60820199b182faf3$var$Ob(a, b, d);
    }
    $60820199b182faf3$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $60820199b182faf3$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $60820199b182faf3$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($60820199b182faf3$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $60820199b182faf3$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $60820199b182faf3$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $60820199b182faf3$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$60820199b182faf3$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$60820199b182faf3$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$60820199b182faf3$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $60820199b182faf3$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $60820199b182faf3$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $60820199b182faf3$var$Mb(a, a.destination);
    } catch (d) {
        $60820199b182faf3$var$V(a, d), $60820199b182faf3$var$W(a, d);
    }
}
function $60820199b182faf3$var$Sb() {}
function $60820199b182faf3$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $60820199b182faf3$var$Ab(a, $60820199b182faf3$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $60820199b182faf3$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $60820199b182faf3$var$Cb(a);
    $60820199b182faf3$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $60820199b182faf3$var$Mb(a, h);
        } catch (m) {
            $60820199b182faf3$var$V(a, m), $60820199b182faf3$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($60820199b182faf3$var$l(426));
    return g;
}
$60820199b182faf3$export$307591e98609eddd = function() {
    throw Error($60820199b182faf3$var$l(207));
};
$60820199b182faf3$export$eb3a06aef9e6ee51 = function(a, b) {
    return $60820199b182faf3$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$60820199b182faf3$export$b23711c915539651 = function() {
    throw Error($60820199b182faf3$var$l(208));
};
$60820199b182faf3$export$80e7718417253a51 = function(a, b) {
    return $60820199b182faf3$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$60820199b182faf3$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("dRPp5", function(module, exports) {
$parcel$export(module.exports, "renderToReadableStream", function () { return $a1881948aaca9e76$export$7020a3240b287705; }, function (v) { return $a1881948aaca9e76$export$7020a3240b287705 = v; });
$parcel$export(module.exports, "version", function () { return $a1881948aaca9e76$export$83d89fbfd8236492; }, function (v) { return $a1881948aaca9e76$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a1881948aaca9e76$export$7020a3240b287705;
var $a1881948aaca9e76$export$83d89fbfd8236492;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $a1881948aaca9e76$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a1881948aaca9e76$var$l = null, $a1881948aaca9e76$var$n = 0;
function $a1881948aaca9e76$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $a1881948aaca9e76$var$n && (a.enqueue(new Uint8Array($a1881948aaca9e76$var$l.buffer, 0, $a1881948aaca9e76$var$n)), $a1881948aaca9e76$var$l = new Uint8Array(512), $a1881948aaca9e76$var$n = 0), a.enqueue(b);
        else {
            var c = $a1881948aaca9e76$var$l.length - $a1881948aaca9e76$var$n;
            c < b.length && (0 === c ? a.enqueue($a1881948aaca9e76$var$l) : ($a1881948aaca9e76$var$l.set(b.subarray(0, c), $a1881948aaca9e76$var$n), a.enqueue($a1881948aaca9e76$var$l), b = b.subarray(c)), $a1881948aaca9e76$var$l = new Uint8Array(512), $a1881948aaca9e76$var$n = 0);
            $a1881948aaca9e76$var$l.set(b, $a1881948aaca9e76$var$n);
            $a1881948aaca9e76$var$n += b.length;
        }
    }
}
function $a1881948aaca9e76$var$t(a, b) {
    $a1881948aaca9e76$var$p(a, b);
    return !0;
}
function $a1881948aaca9e76$var$ba(a) {
    $a1881948aaca9e76$var$l && 0 < $a1881948aaca9e76$var$n && (a.enqueue(new Uint8Array($a1881948aaca9e76$var$l.buffer, 0, $a1881948aaca9e76$var$n)), $a1881948aaca9e76$var$l = null, $a1881948aaca9e76$var$n = 0);
}
var $a1881948aaca9e76$var$ca = new TextEncoder;
function $a1881948aaca9e76$var$u(a) {
    return $a1881948aaca9e76$var$ca.encode(a);
}
function $a1881948aaca9e76$var$w(a) {
    return $a1881948aaca9e76$var$ca.encode(a);
}
function $a1881948aaca9e76$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $a1881948aaca9e76$var$x = Object.prototype.hasOwnProperty, $a1881948aaca9e76$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a1881948aaca9e76$var$fa = {}, $a1881948aaca9e76$var$ha = {};
function $a1881948aaca9e76$var$ia(a) {
    if ($a1881948aaca9e76$var$x.call($a1881948aaca9e76$var$ha, a)) return !0;
    if ($a1881948aaca9e76$var$x.call($a1881948aaca9e76$var$fa, a)) return !1;
    if ($a1881948aaca9e76$var$ea.test(a)) return $a1881948aaca9e76$var$ha[a] = !0;
    $a1881948aaca9e76$var$fa[a] = !0;
    return !1;
}
function $a1881948aaca9e76$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $a1881948aaca9e76$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a1881948aaca9e76$var$z[b] = new $a1881948aaca9e76$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a1881948aaca9e76$var$ja = /[\-:]([a-z])/g;
function $a1881948aaca9e76$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a1881948aaca9e76$var$ja, $a1881948aaca9e76$var$ka);
    $a1881948aaca9e76$var$z[b] = new $a1881948aaca9e76$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a1881948aaca9e76$var$ja, $a1881948aaca9e76$var$ka);
    $a1881948aaca9e76$var$z[b] = new $a1881948aaca9e76$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a1881948aaca9e76$var$ja, $a1881948aaca9e76$var$ka);
    $a1881948aaca9e76$var$z[b] = new $a1881948aaca9e76$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a1881948aaca9e76$var$z.xlinkHref = new $a1881948aaca9e76$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a1881948aaca9e76$var$z[a] = new $a1881948aaca9e76$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $a1881948aaca9e76$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a1881948aaca9e76$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a1881948aaca9e76$var$B).forEach(function(a) {
    $a1881948aaca9e76$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a1881948aaca9e76$var$B[b] = $a1881948aaca9e76$var$B[a];
    });
});
var $a1881948aaca9e76$var$oa = /["'&<>]/;
function $a1881948aaca9e76$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $a1881948aaca9e76$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $a1881948aaca9e76$var$pa = /([A-Z])/g, $a1881948aaca9e76$var$qa = /^ms-/, $a1881948aaca9e76$var$ra = Array.isArray, $a1881948aaca9e76$var$sa = $a1881948aaca9e76$var$w("<script>"), $a1881948aaca9e76$var$ta = $a1881948aaca9e76$var$w("\x3c/script>"), $a1881948aaca9e76$var$ua = $a1881948aaca9e76$var$w('<script src="'), $a1881948aaca9e76$var$va = $a1881948aaca9e76$var$w('<script type="module" src="'), $a1881948aaca9e76$var$wa = $a1881948aaca9e76$var$w('" async="">\x3c/script>'), $a1881948aaca9e76$var$xa = /(<\/|<)(s)(cript)/gi;
function $a1881948aaca9e76$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $a1881948aaca9e76$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $a1881948aaca9e76$var$sa : $a1881948aaca9e76$var$w('<script nonce="' + $a1881948aaca9e76$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $a1881948aaca9e76$var$u(("" + c).replace($a1881948aaca9e76$var$xa, $a1881948aaca9e76$var$ya)), $a1881948aaca9e76$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($a1881948aaca9e76$var$ua, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d[c])), $a1881948aaca9e76$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($a1881948aaca9e76$var$va, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(f[d])), $a1881948aaca9e76$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $a1881948aaca9e76$var$w(a + "P:"),
        segmentPrefix: $a1881948aaca9e76$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $a1881948aaca9e76$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $a1881948aaca9e76$var$Aa(a) {
    return $a1881948aaca9e76$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $a1881948aaca9e76$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $a1881948aaca9e76$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $a1881948aaca9e76$var$D(2, null);
        case "math":
            return $a1881948aaca9e76$var$D(3, null);
        case "foreignObject":
            return $a1881948aaca9e76$var$D(1, null);
        case "table":
            return $a1881948aaca9e76$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $a1881948aaca9e76$var$D(5, null);
        case "colgroup":
            return $a1881948aaca9e76$var$D(7, null);
        case "tr":
            return $a1881948aaca9e76$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $a1881948aaca9e76$var$D(1, null) : a;
}
var $a1881948aaca9e76$var$Ca = $a1881948aaca9e76$var$w("\x3c!-- --\x3e");
function $a1881948aaca9e76$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($a1881948aaca9e76$var$Ca);
    a.push($a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(b)));
    return !0;
}
var $a1881948aaca9e76$var$Ea = new Map, $a1881948aaca9e76$var$Fa = $a1881948aaca9e76$var$w(' style="'), $a1881948aaca9e76$var$Ga = $a1881948aaca9e76$var$w(":"), $a1881948aaca9e76$var$Ha = $a1881948aaca9e76$var$w(";");
function $a1881948aaca9e76$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($a1881948aaca9e76$var$k(62));
    b = !0;
    for(var d in c)if ($a1881948aaca9e76$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d));
                f = $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $a1881948aaca9e76$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $a1881948aaca9e76$var$w($a1881948aaca9e76$var$C(e.replace($a1881948aaca9e76$var$pa, "-$1").toLowerCase().replace($a1881948aaca9e76$var$qa, "-ms-"))), $a1881948aaca9e76$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $a1881948aaca9e76$var$x.call($a1881948aaca9e76$var$B, d) ? $a1881948aaca9e76$var$u("" + f) : $a1881948aaca9e76$var$u(f + "px") : $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($a1881948aaca9e76$var$Fa, e, $a1881948aaca9e76$var$Ga, f)) : a.push($a1881948aaca9e76$var$Ha, e, $a1881948aaca9e76$var$Ga, f);
        }
    }
    b || a.push($a1881948aaca9e76$var$E);
}
var $a1881948aaca9e76$var$H = $a1881948aaca9e76$var$w(" "), $a1881948aaca9e76$var$I = $a1881948aaca9e76$var$w('="'), $a1881948aaca9e76$var$E = $a1881948aaca9e76$var$w('"'), $a1881948aaca9e76$var$Ja = $a1881948aaca9e76$var$w('=""');
function $a1881948aaca9e76$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $a1881948aaca9e76$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $a1881948aaca9e76$var$z.hasOwnProperty(c) ? $a1881948aaca9e76$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $a1881948aaca9e76$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$Ja) : !1 !== d && a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($a1881948aaca9e76$var$H, c, $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
            }
        } else if ($a1881948aaca9e76$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($a1881948aaca9e76$var$H, $a1881948aaca9e76$var$u(c), $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d)), $a1881948aaca9e76$var$E);
        }
    }
}
var $a1881948aaca9e76$var$K = $a1881948aaca9e76$var$w(">"), $a1881948aaca9e76$var$Ka = $a1881948aaca9e76$var$w("/>");
function $a1881948aaca9e76$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($a1881948aaca9e76$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($a1881948aaca9e76$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($a1881948aaca9e76$var$u("" + b));
    }
}
function $a1881948aaca9e76$var$La(a) {
    var b = "";
    $1oC0p.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $a1881948aaca9e76$var$Ma = $a1881948aaca9e76$var$w(' selected=""');
function $a1881948aaca9e76$var$Na(a, b, c, d) {
    a.push($a1881948aaca9e76$var$M(c));
    var f = c = null, e;
    for(e in b)if ($a1881948aaca9e76$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $a1881948aaca9e76$var$J(a, d, e, g);
        }
    }
    a.push($a1881948aaca9e76$var$K);
    $a1881948aaca9e76$var$L(a, f, c);
    return "string" === typeof c ? (a.push($a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(c))), null) : c;
}
var $a1881948aaca9e76$var$Oa = $a1881948aaca9e76$var$w("\n"), $a1881948aaca9e76$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $a1881948aaca9e76$var$Qa = new Map;
function $a1881948aaca9e76$var$M(a) {
    var b = $a1881948aaca9e76$var$Qa.get(a);
    if (void 0 === b) {
        if (!$a1881948aaca9e76$var$Pa.test(a)) throw Error($a1881948aaca9e76$var$k(65, a));
        b = $a1881948aaca9e76$var$w("<" + a);
        $a1881948aaca9e76$var$Qa.set(a, b);
    }
    return b;
}
var $a1881948aaca9e76$var$Ra = $a1881948aaca9e76$var$w("<!DOCTYPE html>");
function $a1881948aaca9e76$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($a1881948aaca9e76$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($a1881948aaca9e76$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $a1881948aaca9e76$var$J(a, d, r, h);
                }
            }
            a.push($a1881948aaca9e76$var$K);
            $a1881948aaca9e76$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($a1881948aaca9e76$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($a1881948aaca9e76$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $a1881948aaca9e76$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $a1881948aaca9e76$var$La(h), $a1881948aaca9e76$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($a1881948aaca9e76$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($a1881948aaca9e76$var$Ma);
            } else q && a.push($a1881948aaca9e76$var$Ma);
            a.push($a1881948aaca9e76$var$K);
            $a1881948aaca9e76$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($a1881948aaca9e76$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($a1881948aaca9e76$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(91));
                default:
                    $a1881948aaca9e76$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($a1881948aaca9e76$var$K);
            if (null != r) {
                if (null != e) throw Error($a1881948aaca9e76$var$k(92));
                if ($a1881948aaca9e76$var$ra(r) && 1 < r.length) throw Error($a1881948aaca9e76$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($a1881948aaca9e76$var$Oa);
            null !== e && a.push($a1881948aaca9e76$var$u($a1881948aaca9e76$var$C("" + e)));
            return null;
        case "input":
            a.push($a1881948aaca9e76$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($a1881948aaca9e76$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $a1881948aaca9e76$var$J(a, d, g, q);
            }
            null !== r ? $a1881948aaca9e76$var$J(a, d, "checked", r) : null !== m && $a1881948aaca9e76$var$J(a, d, "checked", m);
            null !== e ? $a1881948aaca9e76$var$J(a, d, "value", e) : null !== h && $a1881948aaca9e76$var$J(a, d, "value", h);
            a.push($a1881948aaca9e76$var$Ka);
            return null;
        case "menuitem":
            a.push($a1881948aaca9e76$var$M("menuitem"));
            for(var A in c)if ($a1881948aaca9e76$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(400));
                default:
                    $a1881948aaca9e76$var$J(a, d, A, e);
            }
            a.push($a1881948aaca9e76$var$K);
            return null;
        case "title":
            a.push($a1881948aaca9e76$var$M("title"));
            e = null;
            for(v in c)if ($a1881948aaca9e76$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(434));
                default:
                    $a1881948aaca9e76$var$J(a, d, v, g);
            }
            a.push($a1881948aaca9e76$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($a1881948aaca9e76$var$M(b));
            g = e = null;
            for(m in c)if ($a1881948aaca9e76$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $a1881948aaca9e76$var$J(a, d, m, h);
            }
            a.push($a1881948aaca9e76$var$K);
            if (null != g) {
                if (null != e) throw Error($a1881948aaca9e76$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($a1881948aaca9e76$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($a1881948aaca9e76$var$Oa, $a1881948aaca9e76$var$u(c)) : a.push($a1881948aaca9e76$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($a1881948aaca9e76$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($a1881948aaca9e76$var$M(b));
            for(var F in c)if ($a1881948aaca9e76$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a1881948aaca9e76$var$k(399, b));
                default:
                    $a1881948aaca9e76$var$J(a, d, F, e);
            }
            a.push($a1881948aaca9e76$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $a1881948aaca9e76$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($a1881948aaca9e76$var$Ra), $a1881948aaca9e76$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $a1881948aaca9e76$var$Na(a, c, b, d);
            a.push($a1881948aaca9e76$var$M(b));
            g = e = null;
            for(q in c)if ($a1881948aaca9e76$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $a1881948aaca9e76$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $a1881948aaca9e76$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($a1881948aaca9e76$var$H, $a1881948aaca9e76$var$u(q), $a1881948aaca9e76$var$I, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(h)), $a1881948aaca9e76$var$E);
            }
            a.push($a1881948aaca9e76$var$K);
            $a1881948aaca9e76$var$L(a, g, e);
            return e;
    }
}
var $a1881948aaca9e76$var$Ta = $a1881948aaca9e76$var$w("</"), $a1881948aaca9e76$var$Ua = $a1881948aaca9e76$var$w(">"), $a1881948aaca9e76$var$Va = $a1881948aaca9e76$var$w('<template id="'), $a1881948aaca9e76$var$Wa = $a1881948aaca9e76$var$w('"></template>'), $a1881948aaca9e76$var$Xa = $a1881948aaca9e76$var$w("\x3c!--$--\x3e"), $a1881948aaca9e76$var$Ya = $a1881948aaca9e76$var$w('\x3c!--$?--\x3e<template id="'), $a1881948aaca9e76$var$Za = $a1881948aaca9e76$var$w('"></template>'), $a1881948aaca9e76$var$$a = $a1881948aaca9e76$var$w("\x3c!--$!--\x3e"), $a1881948aaca9e76$var$ab = $a1881948aaca9e76$var$w("\x3c!--/$--\x3e"), $a1881948aaca9e76$var$bb = $a1881948aaca9e76$var$w("<template"), $a1881948aaca9e76$var$cb = $a1881948aaca9e76$var$w('"'), $a1881948aaca9e76$var$db = $a1881948aaca9e76$var$w(' data-dgst="');
$a1881948aaca9e76$var$w(' data-msg="');
$a1881948aaca9e76$var$w(' data-stck="');
var $a1881948aaca9e76$var$eb = $a1881948aaca9e76$var$w("></template>");
function $a1881948aaca9e76$var$fb(a, b, c) {
    $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$Ya);
    if (null === c) throw Error($a1881948aaca9e76$var$k(395));
    $a1881948aaca9e76$var$p(a, c);
    return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$Za);
}
var $a1881948aaca9e76$var$gb = $a1881948aaca9e76$var$w('<div hidden id="'), $a1881948aaca9e76$var$hb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$ib = $a1881948aaca9e76$var$w("</div>"), $a1881948aaca9e76$var$jb = $a1881948aaca9e76$var$w('<svg aria-hidden="true" style="display:none" id="'), $a1881948aaca9e76$var$kb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$lb = $a1881948aaca9e76$var$w("</svg>"), $a1881948aaca9e76$var$mb = $a1881948aaca9e76$var$w('<math aria-hidden="true" style="display:none" id="'), $a1881948aaca9e76$var$nb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$ob = $a1881948aaca9e76$var$w("</math>"), $a1881948aaca9e76$var$pb = $a1881948aaca9e76$var$w('<table hidden id="'), $a1881948aaca9e76$var$qb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$rb = $a1881948aaca9e76$var$w("</table>"), $a1881948aaca9e76$var$sb = $a1881948aaca9e76$var$w('<table hidden><tbody id="'), $a1881948aaca9e76$var$tb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$ub = $a1881948aaca9e76$var$w("</tbody></table>"), $a1881948aaca9e76$var$vb = $a1881948aaca9e76$var$w('<table hidden><tr id="'), $a1881948aaca9e76$var$wb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$xb = $a1881948aaca9e76$var$w("</tr></table>"), $a1881948aaca9e76$var$yb = $a1881948aaca9e76$var$w('<table hidden><colgroup id="'), $a1881948aaca9e76$var$zb = $a1881948aaca9e76$var$w('">'), $a1881948aaca9e76$var$Ab = $a1881948aaca9e76$var$w("</colgroup></table>");
function $a1881948aaca9e76$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$gb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$hb);
        case 2:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$jb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$kb);
        case 3:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$mb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$nb);
        case 4:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$pb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$qb);
        case 5:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$sb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$tb);
        case 6:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$vb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$wb);
        case 7:
            return $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$yb), $a1881948aaca9e76$var$p(a, b.segmentPrefix), $a1881948aaca9e76$var$p(a, $a1881948aaca9e76$var$u(d.toString(16))), $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$zb);
        default:
            throw Error($a1881948aaca9e76$var$k(397));
    }
}
function $a1881948aaca9e76$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$ib);
        case 2:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$lb);
        case 3:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$ob);
        case 4:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$rb);
        case 5:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$ub);
        case 6:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$xb);
        case 7:
            return $a1881948aaca9e76$var$t(a, $a1881948aaca9e76$var$Ab);
        default:
            throw Error($a1881948aaca9e76$var$k(397));
    }
}
var $a1881948aaca9e76$var$Db = $a1881948aaca9e76$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $a1881948aaca9e76$var$Eb = $a1881948aaca9e76$var$w('$RS("'), $a1881948aaca9e76$var$Gb = $a1881948aaca9e76$var$w('","'), $a1881948aaca9e76$var$Hb = $a1881948aaca9e76$var$w('")\x3c/script>'), $a1881948aaca9e76$var$Ib = $a1881948aaca9e76$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $a1881948aaca9e76$var$Jb = $a1881948aaca9e76$var$w('$RC("'), $a1881948aaca9e76$var$Kb = $a1881948aaca9e76$var$w('","'), $a1881948aaca9e76$var$Lb = $a1881948aaca9e76$var$w('")\x3c/script>'), $a1881948aaca9e76$var$Mb = $a1881948aaca9e76$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $a1881948aaca9e76$var$Nb = $a1881948aaca9e76$var$w('$RX("'), $a1881948aaca9e76$var$Ob = $a1881948aaca9e76$var$w('"'), $a1881948aaca9e76$var$Pb = $a1881948aaca9e76$var$w(")\x3c/script>"), $a1881948aaca9e76$var$Qb = $a1881948aaca9e76$var$w(","), $a1881948aaca9e76$var$Rb = /[<\u2028\u2029]/g;
function $a1881948aaca9e76$var$Sb(a) {
    return JSON.stringify(a).replace($a1881948aaca9e76$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $a1881948aaca9e76$var$N = Object.assign, $a1881948aaca9e76$var$Tb = Symbol.for("react.element"), $a1881948aaca9e76$var$Ub = Symbol.for("react.portal"), $a1881948aaca9e76$var$Vb = Symbol.for("react.fragment"), $a1881948aaca9e76$var$Wb = Symbol.for("react.strict_mode"), $a1881948aaca9e76$var$Xb = Symbol.for("react.profiler"), $a1881948aaca9e76$var$Yb = Symbol.for("react.provider"), $a1881948aaca9e76$var$Zb = Symbol.for("react.context"), $a1881948aaca9e76$var$$b = Symbol.for("react.forward_ref"), $a1881948aaca9e76$var$ac = Symbol.for("react.suspense"), $a1881948aaca9e76$var$bc = Symbol.for("react.suspense_list"), $a1881948aaca9e76$var$cc = Symbol.for("react.memo"), $a1881948aaca9e76$var$dc = Symbol.for("react.lazy"), $a1881948aaca9e76$var$ec = Symbol.for("react.scope"), $a1881948aaca9e76$var$fc = Symbol.for("react.debug_trace_mode"), $a1881948aaca9e76$var$gc = Symbol.for("react.legacy_hidden"), $a1881948aaca9e76$var$hc = Symbol.for("react.default_value"), $a1881948aaca9e76$var$ic = Symbol.iterator;
function $a1881948aaca9e76$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a1881948aaca9e76$var$Vb:
            return "Fragment";
        case $a1881948aaca9e76$var$Ub:
            return "Portal";
        case $a1881948aaca9e76$var$Xb:
            return "Profiler";
        case $a1881948aaca9e76$var$Wb:
            return "StrictMode";
        case $a1881948aaca9e76$var$ac:
            return "Suspense";
        case $a1881948aaca9e76$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a1881948aaca9e76$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $a1881948aaca9e76$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $a1881948aaca9e76$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a1881948aaca9e76$var$cc:
            return b = a.displayName || null, null !== b ? b : $a1881948aaca9e76$var$jc(a.type) || "Memo";
        case $a1881948aaca9e76$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $a1881948aaca9e76$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $a1881948aaca9e76$var$kc = {};
function $a1881948aaca9e76$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $a1881948aaca9e76$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $a1881948aaca9e76$var$O = null;
function $a1881948aaca9e76$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($a1881948aaca9e76$var$k(401));
        } else {
            if (null === c) throw Error($a1881948aaca9e76$var$k(401));
            $a1881948aaca9e76$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $a1881948aaca9e76$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $a1881948aaca9e76$var$mc(a);
}
function $a1881948aaca9e76$var$nc(a) {
    var b = a.parent;
    null !== b && $a1881948aaca9e76$var$nc(b);
    a.context._currentValue = a.value;
}
function $a1881948aaca9e76$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($a1881948aaca9e76$var$k(402));
    a.depth === b.depth ? $a1881948aaca9e76$var$P(a, b) : $a1881948aaca9e76$var$oc(a, b);
}
function $a1881948aaca9e76$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($a1881948aaca9e76$var$k(402));
    a.depth === c.depth ? $a1881948aaca9e76$var$P(a, c) : $a1881948aaca9e76$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $a1881948aaca9e76$var$Q(a) {
    var b = $a1881948aaca9e76$var$O;
    b !== a && (null === b ? $a1881948aaca9e76$var$nc(a) : null === a ? $a1881948aaca9e76$var$mc(b) : b.depth === a.depth ? $a1881948aaca9e76$var$P(b, a) : b.depth > a.depth ? $a1881948aaca9e76$var$oc(b, a) : $a1881948aaca9e76$var$pc(b, a), $a1881948aaca9e76$var$O = a);
}
var $a1881948aaca9e76$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $a1881948aaca9e76$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $a1881948aaca9e76$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $a1881948aaca9e76$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $a1881948aaca9e76$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $a1881948aaca9e76$var$N({}, e, h)) : $a1881948aaca9e76$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $a1881948aaca9e76$var$sc = {
    id: 1,
    overflow: ""
};
function $a1881948aaca9e76$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $a1881948aaca9e76$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $a1881948aaca9e76$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $a1881948aaca9e76$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $a1881948aaca9e76$var$uc = Math.clz32 ? Math.clz32 : $a1881948aaca9e76$var$vc, $a1881948aaca9e76$var$wc = Math.log, $a1881948aaca9e76$var$xc = Math.LN2;
function $a1881948aaca9e76$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a1881948aaca9e76$var$wc(a) / $a1881948aaca9e76$var$xc | 0) | 0;
}
function $a1881948aaca9e76$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a1881948aaca9e76$var$zc = "function" === typeof Object.is ? Object.is : $a1881948aaca9e76$var$yc, $a1881948aaca9e76$var$R = null, $a1881948aaca9e76$var$Ac = null, $a1881948aaca9e76$var$Bc = null, $a1881948aaca9e76$var$S = null, $a1881948aaca9e76$var$T = !1, $a1881948aaca9e76$var$Cc = !1, $a1881948aaca9e76$var$U = 0, $a1881948aaca9e76$var$V = null, $a1881948aaca9e76$var$Dc = 0;
function $a1881948aaca9e76$var$W() {
    if (null === $a1881948aaca9e76$var$R) throw Error($a1881948aaca9e76$var$k(321));
    return $a1881948aaca9e76$var$R;
}
function $a1881948aaca9e76$var$Ec() {
    if (0 < $a1881948aaca9e76$var$Dc) throw Error($a1881948aaca9e76$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $a1881948aaca9e76$var$Fc() {
    null === $a1881948aaca9e76$var$S ? null === $a1881948aaca9e76$var$Bc ? ($a1881948aaca9e76$var$T = !1, $a1881948aaca9e76$var$Bc = $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Ec()) : ($a1881948aaca9e76$var$T = !0, $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Bc) : null === $a1881948aaca9e76$var$S.next ? ($a1881948aaca9e76$var$T = !1, $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$S.next = $a1881948aaca9e76$var$Ec()) : ($a1881948aaca9e76$var$T = !0, $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$S.next);
    return $a1881948aaca9e76$var$S;
}
function $a1881948aaca9e76$var$Gc() {
    $a1881948aaca9e76$var$Ac = $a1881948aaca9e76$var$R = null;
    $a1881948aaca9e76$var$Cc = !1;
    $a1881948aaca9e76$var$Bc = null;
    $a1881948aaca9e76$var$Dc = 0;
    $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$V = null;
}
function $a1881948aaca9e76$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a1881948aaca9e76$var$Ic(a, b, c) {
    $a1881948aaca9e76$var$R = $a1881948aaca9e76$var$W();
    $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Fc();
    if ($a1881948aaca9e76$var$T) {
        var d = $a1881948aaca9e76$var$S.queue;
        b = d.dispatch;
        if (null !== $a1881948aaca9e76$var$V && (c = $a1881948aaca9e76$var$V.get(d), void 0 !== c)) {
            $a1881948aaca9e76$var$V.delete(d);
            d = $a1881948aaca9e76$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $a1881948aaca9e76$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $a1881948aaca9e76$var$S.memoizedState,
            b
        ];
    }
    a = a === $a1881948aaca9e76$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $a1881948aaca9e76$var$S.memoizedState = a;
    a = $a1881948aaca9e76$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $a1881948aaca9e76$var$Jc.bind(null, $a1881948aaca9e76$var$R, a);
    return [
        $a1881948aaca9e76$var$S.memoizedState,
        a
    ];
}
function $a1881948aaca9e76$var$Kc(a, b) {
    $a1881948aaca9e76$var$R = $a1881948aaca9e76$var$W();
    $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $a1881948aaca9e76$var$S) {
        var c = $a1881948aaca9e76$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$a1881948aaca9e76$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $a1881948aaca9e76$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a1881948aaca9e76$var$Jc(a, b, c) {
    if (25 <= $a1881948aaca9e76$var$Dc) throw Error($a1881948aaca9e76$var$k(301));
    if (a === $a1881948aaca9e76$var$R) {
        if ($a1881948aaca9e76$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $a1881948aaca9e76$var$V && ($a1881948aaca9e76$var$V = new Map), c = $a1881948aaca9e76$var$V.get(b), void 0 === c) $a1881948aaca9e76$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $a1881948aaca9e76$var$Lc() {
    throw Error($a1881948aaca9e76$var$k(394));
}
function $a1881948aaca9e76$var$Mc() {}
var $a1881948aaca9e76$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $a1881948aaca9e76$var$W();
        return a._currentValue;
    },
    useMemo: $a1881948aaca9e76$var$Kc,
    useReducer: $a1881948aaca9e76$var$Ic,
    useRef: function(a) {
        $a1881948aaca9e76$var$R = $a1881948aaca9e76$var$W();
        $a1881948aaca9e76$var$S = $a1881948aaca9e76$var$Fc();
        var b = $a1881948aaca9e76$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $a1881948aaca9e76$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $a1881948aaca9e76$var$Ic($a1881948aaca9e76$var$Hc, a);
    },
    useInsertionEffect: $a1881948aaca9e76$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $a1881948aaca9e76$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $a1881948aaca9e76$var$Mc,
    useEffect: $a1881948aaca9e76$var$Mc,
    useDebugValue: $a1881948aaca9e76$var$Mc,
    useDeferredValue: function(a) {
        $a1881948aaca9e76$var$W();
        return a;
    },
    useTransition: function() {
        $a1881948aaca9e76$var$W();
        return [
            !1,
            $a1881948aaca9e76$var$Lc
        ];
    },
    useId: function() {
        var a = $a1881948aaca9e76$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $a1881948aaca9e76$var$uc(a) - 1)).toString(32) + b;
        var c = $a1881948aaca9e76$var$Nc;
        if (null === c) throw Error($a1881948aaca9e76$var$k(404));
        b = $a1881948aaca9e76$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $a1881948aaca9e76$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($a1881948aaca9e76$var$k(407));
        return c();
    }
}, $a1881948aaca9e76$var$Nc = null, $a1881948aaca9e76$var$Pc = $1oC0p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $a1881948aaca9e76$var$Qc(a) {
    console.error(a);
    return null;
}
function $a1881948aaca9e76$var$X() {}
function $a1881948aaca9e76$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $a1881948aaca9e76$var$Qc : f,
        onAllReady: void 0 === e ? $a1881948aaca9e76$var$X : e,
        onShellReady: void 0 === g ? $a1881948aaca9e76$var$X : g,
        onShellError: void 0 === h ? $a1881948aaca9e76$var$X : h,
        onFatalError: void 0 === m ? $a1881948aaca9e76$var$X : m
    };
    c = $a1881948aaca9e76$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $a1881948aaca9e76$var$Tc(b, a, null, c, r, $a1881948aaca9e76$var$kc, null, $a1881948aaca9e76$var$sc);
    q.push(a);
    return b;
}
function $a1881948aaca9e76$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $a1881948aaca9e76$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $a1881948aaca9e76$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $a1881948aaca9e76$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $a1881948aaca9e76$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $a1881948aaca9e76$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $a1881948aaca9e76$var$Wc(a, b, c, d, f) {
    $a1881948aaca9e76$var$R = {};
    $a1881948aaca9e76$var$Ac = b;
    $a1881948aaca9e76$var$U = 0;
    for(a = c(d, f); $a1881948aaca9e76$var$Cc;)$a1881948aaca9e76$var$Cc = !1, $a1881948aaca9e76$var$U = 0, $a1881948aaca9e76$var$Dc += 1, $a1881948aaca9e76$var$S = null, a = c(d, f);
    $a1881948aaca9e76$var$Gc();
    return a;
}
function $a1881948aaca9e76$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($a1881948aaca9e76$var$k(108, $a1881948aaca9e76$var$jc(d) || "Unknown", h));
            d = $a1881948aaca9e76$var$N({}, g, c);
        }
        b.legacyContext = d;
        $a1881948aaca9e76$var$Z(a, b, f);
        b.legacyContext = g;
    } else $a1881948aaca9e76$var$Z(a, b, f);
}
function $a1881948aaca9e76$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $a1881948aaca9e76$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $a1881948aaca9e76$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $a1881948aaca9e76$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $a1881948aaca9e76$var$rc(e, c, d, f);
            $a1881948aaca9e76$var$Xc(a, b, e, c);
        } else {
            e = $a1881948aaca9e76$var$lc(c, b.legacyContext);
            f = $a1881948aaca9e76$var$Wc(a, b, c, d, e);
            var g = 0 !== $a1881948aaca9e76$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $a1881948aaca9e76$var$rc(f, c, d, e), $a1881948aaca9e76$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $a1881948aaca9e76$var$tc(d, 1, 0);
                try {
                    $a1881948aaca9e76$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $a1881948aaca9e76$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $a1881948aaca9e76$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $a1881948aaca9e76$var$Ba(g, c, d);
        $a1881948aaca9e76$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($a1881948aaca9e76$var$Ta, $a1881948aaca9e76$var$u(c), $a1881948aaca9e76$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $a1881948aaca9e76$var$gc:
            case $a1881948aaca9e76$var$fc:
            case $a1881948aaca9e76$var$Wb:
            case $a1881948aaca9e76$var$Xb:
            case $a1881948aaca9e76$var$Vb:
                $a1881948aaca9e76$var$Z(a, b, d.children);
                return;
            case $a1881948aaca9e76$var$bc:
                $a1881948aaca9e76$var$Z(a, b, d.children);
                return;
            case $a1881948aaca9e76$var$ec:
                throw Error($a1881948aaca9e76$var$k(343));
            case $a1881948aaca9e76$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $a1881948aaca9e76$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $a1881948aaca9e76$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($a1881948aaca9e76$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($a1881948aaca9e76$var$Ca), q.status = 1, $a1881948aaca9e76$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $a1881948aaca9e76$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $a1881948aaca9e76$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $a1881948aaca9e76$var$$b:
                d = $a1881948aaca9e76$var$Wc(a, b, c.render, d, f);
                if (0 !== $a1881948aaca9e76$var$U) {
                    c = b.treeContext;
                    b.treeContext = $a1881948aaca9e76$var$tc(c, 1, 0);
                    try {
                        $a1881948aaca9e76$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $a1881948aaca9e76$var$Z(a, b, d);
                return;
            case $a1881948aaca9e76$var$cc:
                c = c.type;
                d = $a1881948aaca9e76$var$Yc(c, d);
                $a1881948aaca9e76$var$Zc(a, b, c, d, f);
                return;
            case $a1881948aaca9e76$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $a1881948aaca9e76$var$O;
                $a1881948aaca9e76$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $a1881948aaca9e76$var$Z(a, b, f);
                a = $a1881948aaca9e76$var$O;
                if (null === a) throw Error($a1881948aaca9e76$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $a1881948aaca9e76$var$hc ? a.context._defaultValue : d;
                a = $a1881948aaca9e76$var$O = a.parent;
                b.context = a;
                return;
            case $a1881948aaca9e76$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $a1881948aaca9e76$var$Z(a, b, d);
                return;
            case $a1881948aaca9e76$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $a1881948aaca9e76$var$Yc(c, d);
                $a1881948aaca9e76$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($a1881948aaca9e76$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $a1881948aaca9e76$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $a1881948aaca9e76$var$Tb:
                $a1881948aaca9e76$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $a1881948aaca9e76$var$Ub:
                throw Error($a1881948aaca9e76$var$k(257));
            case $a1881948aaca9e76$var$dc:
                var d = c._init;
                c = d(c._payload);
                $a1881948aaca9e76$var$Z(a, b, c);
                return;
        }
        if ($a1881948aaca9e76$var$ra(c)) {
            $a1881948aaca9e76$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $a1881948aaca9e76$var$ic && c[$a1881948aaca9e76$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $a1881948aaca9e76$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($a1881948aaca9e76$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $a1881948aaca9e76$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $a1881948aaca9e76$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $a1881948aaca9e76$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $a1881948aaca9e76$var$tc(e, d, f);
        try {
            $a1881948aaca9e76$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $a1881948aaca9e76$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $a1881948aaca9e76$var$Z(a, b, c);
    } catch (m) {
        if ($a1881948aaca9e76$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $a1881948aaca9e76$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $a1881948aaca9e76$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $a1881948aaca9e76$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $a1881948aaca9e76$var$Q(e), m;
    }
}
function $a1881948aaca9e76$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $a1881948aaca9e76$var$dd(this, b, a);
}
function $a1881948aaca9e76$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($a1881948aaca9e76$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $a1881948aaca9e76$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $a1881948aaca9e76$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $a1881948aaca9e76$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $a1881948aaca9e76$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($a1881948aaca9e76$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $a1881948aaca9e76$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $a1881948aaca9e76$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($a1881948aaca9e76$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($a1881948aaca9e76$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $a1881948aaca9e76$var$Uc(a) {
    if (2 !== a.status) {
        var b = $a1881948aaca9e76$var$O, c = $a1881948aaca9e76$var$Pc.current;
        $a1881948aaca9e76$var$Pc.current = $a1881948aaca9e76$var$Oc;
        var d = $a1881948aaca9e76$var$Nc;
        $a1881948aaca9e76$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $a1881948aaca9e76$var$Q(g.context);
                    try {
                        $a1881948aaca9e76$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($a1881948aaca9e76$var$Ca), g.abortSet.delete(g), m.status = 1, $a1881948aaca9e76$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($a1881948aaca9e76$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $a1881948aaca9e76$var$Y(h, v);
                            null === r ? $a1881948aaca9e76$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $a1881948aaca9e76$var$fd(a, a.destination);
        } catch (G) {
            $a1881948aaca9e76$var$Y(a, G), $a1881948aaca9e76$var$Vc(a, G);
        } finally{
            $a1881948aaca9e76$var$Nc = d, $a1881948aaca9e76$var$Pc.current = c, c === $a1881948aaca9e76$var$Oc && $a1881948aaca9e76$var$Q(b);
        }
    }
}
function $a1881948aaca9e76$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Va);
            $a1881948aaca9e76$var$p(b, a.placeholderPrefix);
            a = $a1881948aaca9e76$var$u(d.toString(16));
            $a1881948aaca9e76$var$p(b, a);
            return $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$a1881948aaca9e76$var$p(b, d[e]);
                f = $a1881948aaca9e76$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$a1881948aaca9e76$var$p(b, d[e]);
            e < d.length && (f = $a1881948aaca9e76$var$t(b, d[e]));
            return f;
        default:
            throw Error($a1881948aaca9e76$var$k(390));
    }
}
function $a1881948aaca9e76$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $a1881948aaca9e76$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$$a), $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$bb), d && ($a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$db), $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$C(d))), $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$cb)), $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$eb), $a1881948aaca9e76$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $a1881948aaca9e76$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $a1881948aaca9e76$var$fb(b, a.responseState, d);
        $a1881948aaca9e76$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $a1881948aaca9e76$var$fb(b, a.responseState, d.id), $a1881948aaca9e76$var$gd(a, b, c);
    else {
        $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($a1881948aaca9e76$var$k(391));
        $a1881948aaca9e76$var$hd(a, b, c[0]);
    }
    return $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$ab);
}
function $a1881948aaca9e76$var$id(a, b, c) {
    $a1881948aaca9e76$var$Bb(b, a.responseState, c.formatContext, c.id);
    $a1881948aaca9e76$var$hd(a, b, c);
    return $a1881948aaca9e76$var$Cb(b, c.formatContext);
}
function $a1881948aaca9e76$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$a1881948aaca9e76$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $a1881948aaca9e76$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Ib));
    if (null === d) throw Error($a1881948aaca9e76$var$k(395));
    c = $a1881948aaca9e76$var$u(c.toString(16));
    $a1881948aaca9e76$var$p(b, d);
    $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Kb);
    $a1881948aaca9e76$var$p(b, a.segmentPrefix);
    $a1881948aaca9e76$var$p(b, c);
    return $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$Lb);
}
function $a1881948aaca9e76$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($a1881948aaca9e76$var$k(392));
        return $a1881948aaca9e76$var$id(a, b, d);
    }
    $a1881948aaca9e76$var$id(a, b, d);
    a = a.responseState;
    $a1881948aaca9e76$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Eb) : (a.sentCompleteSegmentFunction = !0, $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Db));
    $a1881948aaca9e76$var$p(b, a.segmentPrefix);
    f = $a1881948aaca9e76$var$u(f.toString(16));
    $a1881948aaca9e76$var$p(b, f);
    $a1881948aaca9e76$var$p(b, $a1881948aaca9e76$var$Gb);
    $a1881948aaca9e76$var$p(b, a.placeholderPrefix);
    $a1881948aaca9e76$var$p(b, f);
    return $a1881948aaca9e76$var$t(b, $a1881948aaca9e76$var$Hb);
}
function $a1881948aaca9e76$var$fd(a, b) {
    $a1881948aaca9e76$var$l = new Uint8Array(512);
    $a1881948aaca9e76$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $a1881948aaca9e76$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$a1881948aaca9e76$var$p(b, d[c]);
            c < d.length && $a1881948aaca9e76$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $a1881948aaca9e76$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Nb) : (h.sentClientRenderFunction = !0, $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Mb));
            if (null === m) throw Error($a1881948aaca9e76$var$k(395));
            $a1881948aaca9e76$var$p(d, m);
            $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Ob);
            if (q || r || v) $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Qb), $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$Sb(q || "")));
            if (r || v) $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Qb), $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$Sb(r || "")));
            v && ($a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$Qb), $a1881948aaca9e76$var$p(d, $a1881948aaca9e76$var$u($a1881948aaca9e76$var$Sb(v))));
            if (!$a1881948aaca9e76$var$t(d, $a1881948aaca9e76$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$a1881948aaca9e76$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $a1881948aaca9e76$var$ba(b);
        $a1881948aaca9e76$var$l = new Uint8Array(512);
        $a1881948aaca9e76$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$a1881948aaca9e76$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$a1881948aaca9e76$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $a1881948aaca9e76$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $a1881948aaca9e76$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $a1881948aaca9e76$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $a1881948aaca9e76$var$fd(a, a.destination);
    } catch (d) {
        $a1881948aaca9e76$var$Y(a, d), $a1881948aaca9e76$var$Vc(a, d);
    }
}
$a1881948aaca9e76$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $a1881948aaca9e76$var$Rc(a, $a1881948aaca9e76$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $a1881948aaca9e76$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $a1881948aaca9e76$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $a1881948aaca9e76$var$fd(h, a);
                        } catch (A) {
                            $a1881948aaca9e76$var$Y(h, A), $a1881948aaca9e76$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $a1881948aaca9e76$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $a1881948aaca9e76$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $a1881948aaca9e76$var$Uc(h);
    });
};
$a1881948aaca9e76$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("hMmnm", function(module, exports) {
$parcel$export(module.exports, "eyelashes", function () { return $5234614371b266d4$export$e2a321401c0e05f3; });
$parcel$export(module.exports, "blueShapesSVG", function () { return $5234614371b266d4$export$4b78ca8dd9f1ebf5; });
$parcel$export(module.exports, "orangePurpleShapesSVG", function () { return $5234614371b266d4$export$4f43b91428c248ba; });

var $7VQPk = parcelRequire("7VQPk");
const $5234614371b266d4$export$e2a321401c0e05f3 = (fill = "#669DF1")=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "56",
        height: "84",
        viewBox: "0 0 56 84",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            fill: fill,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M26.4864 16.718C26.5405 16.0726 20.795 9.2477 20.8952 12.0688C20.7985 13.0952 21.2446 13.738 22.1426 13.5149C20.7856 14.6078 23.6044 14.8934 23.5211 15.8699C22.3421 16.2318 25.7092 17.0448 24.3987 17.2763C28.0425 26.1539 47.6897 36.8107 29.9444 20.1653C30.6415 22.4448 29.1343 20.7925 28.8411 19.7567C30.9149 20.2708 27.582 17.178 26.7213 16.7512C27.4235 17.9025 25.3303 16.5509 26.485 16.7235L26.4864 16.718Z"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M22.523 38.9197C21.8369 37.8857 11.9397 37.6356 10.9185 37.475C8.67196 37.5389 9.9636 40.0847 11.6524 39.6395C12.0179 39.6958 14.4962 39.1886 13.8968 40.2052C15.5696 42.0387 19.4456 40.176 20.701 41.8144C21.0254 41.2473 21.9705 41.5362 22.2143 41.2032C22.4626 41.7632 23.3379 41.6469 23.3281 41.4838C26.4577 42.6731 27.0008 38.6273 23.676 38.9433C23.7357 38.7869 22.9182 38.443 22.53 38.9156L22.523 38.9197Z"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M24.6199 74.1834C26.3875 74.443 25.0709 75.1187 24.2095 74.983C24.7947 73.487 22.2597 74.96 21.7776 75.6274C22.0718 75.5279 22.378 75.9607 21.7847 76.2001C21.6576 74.8105 14.1945 77.9237 18.7689 78.8462C18.8925 78.7842 18.5301 77.8072 18.8076 78.0361C19.1938 79.5902 19.9078 78.0574 20.1851 77.7988C20.5068 78.5509 20.5111 77.7138 20.7294 77.9863C20.7735 79.1752 21.9126 76.6327 21.8993 77.836C24.2573 78.5987 26.7045 75.057 28.6049 75.8635C28.7542 73.7751 35.2544 73.8343 31.7599 71.5663C29.1146 71.8979 27.0299 72.3559 24.6199 74.1834Z"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M3.05391 63.3631C3.48696 65.9405 8.33035 63.1301 10.1233 63.45C12.3839 64.0438 32.344 60.5753 25.6944 58.1455C19.6623 59.2462 14.5246 59.0943 7.37953 61.3534C6.19213 61.6357 2.19682 61.8136 3.05391 63.3631Z"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M48.0023 18.2733C50.4643 18.7368 48.974 21.7025 51.0738 22.2533C54.8718 22.7894 48.2743 5.2548 45.4835 7.19426C43.309 9.18589 48.5718 16.5473 48.0023 18.2733Z"
                })
            ]
        })
    });
const $5234614371b266d4$export$4b78ca8dd9f1ebf5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "389",
        height: "207",
        viewBox: "0 0 389 207",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-250.535 100.922L-184.874 90.4661L-202.753 115.507L-202.021 146.247L-250.535 100.869V100.922ZM-134.949 110.698C-111.006 97.9941 -81.2595 107.09 -68.556 131.086L-5.14313 250.645C7.56036 274.589 -1.53593 304.335 -25.5314 317.038C-49.527 329.742 -79.2207 320.645 -91.9242 296.65L-155.337 177.09C-168.041 153.147 -158.944 123.401 -134.949 110.698Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M278.777 83.8796L287.299 149.802L262.78 131.191L231.989 131.034L278.725 83.8273L278.777 83.8796ZM265.603 199.1C277.575 223.409 267.59 252.842 243.281 264.865L121.892 324.776C97.5826 336.747 68.1501 326.762 56.1262 302.453C44.1023 278.144 54.1398 248.712 78.449 236.688L199.838 176.777C224.147 164.806 253.58 174.791 265.603 199.1Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-43.4141 -263.297L20.5739 -245.209L-6.14012 -229.996L-18.3731 -201.766L-43.3619 -263.297H-43.4141ZM57.3252 -205.844C84.4051 -207.308 107.512 -186.554 109.028 -159.474L116.347 -24.3354C117.811 2.74448 97.0564 25.8513 69.9765 27.3673C42.8966 28.8834 19.7897 8.07681 18.2737 -19.0031L10.9548 -154.141C9.49105 -181.221 30.2453 -204.328 57.3252 -205.844Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-300.983 -20.1016L-252.835 -65.9492L-253.358 -35.1576L-235.322 -10.2211L-301.035 -20.0493L-300.983 -20.1016ZM-200.244 -77.5549C-187.697 -101.603 -158.055 -110.96 -134.008 -98.4137L-13.9778 -35.8895C10.07 -23.3428 19.4278 6.29868 6.88113 30.3465C-5.66556 54.3943 -35.3071 63.752 -59.3549 51.2054L-179.385 -11.3189C-203.433 -23.8656 -212.79 -53.5071 -200.244 -77.5549Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M265.653 -107.927L270.881 -41.6388L247.303 -61.4521L216.564 -63.1773L265.653 -107.979V-107.927ZM246.676 6.50901C257.445 31.3932 245.996 60.3029 221.112 71.0721L96.9002 124.814C72.0159 135.583 43.1063 124.134 32.337 99.2499C21.5678 74.3656 33.0166 45.456 57.9008 34.6868L182.113 -19.0548C206.997 -29.8241 235.907 -18.3752 246.676 6.50901Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.7984 -116.866L34.6887 -50.7343L15.189 -74.5207L-14.7139 -81.8919L41.7984 -116.813V-116.866ZM2.01508 -7.91878C7.97473 18.5338 -8.59747 44.8295 -35.05 50.7892L-167.051 80.6398C-193.504 86.5995 -219.8 70.0274 -225.759 43.5748C-231.719 17.1222 -215.147 -9.17347 -188.694 -15.1331L-56.693 -44.9837C-30.2404 -50.9434 -3.9446 -34.3714 2.01508 -7.91878Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M242.811 189.743L188.389 151.528L218.658 145.986L239.569 123.402L242.811 189.743ZM166.694 102.23C140.66 94.6493 125.656 67.4126 133.236 41.3782L170.981 -88.5844C178.561 -114.619 205.798 -129.622 231.832 -122.042C257.867 -114.462 272.87 -87.2252 265.29 -61.1908L227.545 68.7718C219.965 94.8062 192.728 109.81 166.694 102.23Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.2233 -162.139L118.182 -113.155L87.4429 -114.2L62.1926 -96.5829L73.2233 -162.087V-162.139ZM128.847 -60.4066C152.686 -47.4417 161.468 -17.6434 148.503 6.19533L83.8357 125.075C70.8708 148.914 41.0724 157.696 17.2337 144.732C-6.60499 131.767 -15.3876 101.968 -2.42266 78.1296L62.245 -40.7501C75.2099 -64.5888 105.008 -73.3715 128.847 -60.4066Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-236.893 152.47L-180.589 117.078L-187.176 147.138L-174.421 175.159L-236.84 152.47H-236.893ZM-126.743 116.137C-109.701 95.069 -78.8045 91.7755 -57.6842 108.818L47.551 193.874C68.619 210.917 71.9124 241.813 54.8699 262.933C37.8273 284.053 6.93117 287.295 -14.1891 270.252L-119.424 185.196C-140.492 168.153 -143.786 137.257 -126.743 116.137Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.8142 -253.625L6.93022 -198.89L-23.3908 -204.222L-50.8367 -190.316L-30.8142 -253.677V-253.625ZM10.1192 -145.096C31.9191 -128.942 36.4673 -98.2026 20.3135 -76.4028L-60.299 32.3351C-76.4528 54.1349 -107.192 58.6831 -128.992 42.5292C-150.792 26.3754 -155.34 -4.36395 -139.186 -26.1638L-58.5739 -134.902C-42.42 -156.701 -11.6806 -161.25 10.1192 -145.096Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M66.1666 181.013L111.126 229.997L80.3862 228.952L55.1359 246.569L66.1666 181.065V181.013ZM121.79 282.798C145.629 295.763 154.412 325.561 141.447 349.4L76.779 468.28C63.8141 492.118 34.0158 500.901 10.1772 487.936C-13.6615 474.971 -22.4442 445.173 -9.47934 421.334L55.1883 302.454C68.1532 278.616 97.9515 269.833 121.79 282.798Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M320.289 163.447L353.643 220.953L323.844 213.268L295.405 225.03L320.289 163.447ZM352.702 274.799C373.142 292.573 375.338 323.574 357.563 344.067L268.743 446.218C250.969 466.658 219.968 468.854 199.475 451.08C179.035 433.305 176.839 402.304 194.614 381.811L283.434 279.661C301.208 259.22 332.209 257.024 352.702 274.799Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-185.816 166.688L-169.349 102.282L-153.456 128.63L-124.913 140.183L-185.816 166.74V166.688ZM-130.925 64.485C-133.068 37.4574 -112.941 13.7756 -85.9134 11.6323L49.0156 0.862955C76.0432 -1.28043 99.725 18.8465 101.868 45.8742C104.012 72.9018 83.8849 96.5836 56.8573 98.727L-78.0718 109.496C-105.099 111.64 -128.781 91.5127 -130.925 64.485Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-193.342 43.1568L-130.87 20.4159L-143.626 48.4369L-137.038 78.4966L-193.342 43.2091V43.1568ZM-78.017 30.7669C-56.8967 13.7244 -26.0004 17.0179 -8.95786 38.1381L76.0458 143.426C93.0883 164.546 89.795 195.442 68.6747 212.485C47.5545 229.527 16.6582 226.234 -0.384369 205.113L-85.388 99.826C-102.431 78.7057 -99.1372 47.8095 -78.017 30.7669Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-144.988 23.4496L-78.4909 22.5086L-99.7678 44.7267L-103.48 75.257L-144.988 23.3974V23.4496ZM-32.0158 49.7976C-6.50427 40.649 21.6212 53.9799 30.7699 79.4915L76.3561 206.945C85.5047 232.456 72.1738 260.582 46.6622 269.73C21.1506 278.879 -6.97473 265.548 -16.1234 240.037L-61.7096 112.583C-70.8582 87.0718 -57.5274 58.9463 -32.0158 49.7976Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.2357 244.846L-47.3828 180.596L-20.6166 195.809L9.91363 191.888L-30.1834 244.846H-30.2357ZM-32.3791 128.893C-47.4874 106.362 -41.4754 75.8838 -18.9437 60.7755L93.4536 -14.6091C115.985 -29.7174 146.463 -23.7055 161.572 -1.17375C176.68 21.358 170.668 51.836 148.136 66.9442L35.7389 142.329C13.2071 157.437 -17.2708 151.425 -32.3791 128.893Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M257.45 -217.185L302.409 -168.201L271.669 -169.246L246.419 -151.629L257.45 -217.133V-217.185ZM313.074 -115.4C336.912 -102.435 345.695 -72.6371 332.73 -48.7984L268.062 70.0814C255.097 93.9201 225.299 102.703 201.46 89.7378C177.622 76.7729 168.839 46.9746 181.804 23.1359L246.471 -95.7438C259.436 -119.583 289.235 -128.365 313.074 -115.4Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M122.314 73.3206L97.8999 135.165L85.4578 107.04L58.5869 91.9838L122.314 73.3206ZM55.032 167.787C53.7774 194.867 30.7751 215.778 3.69519 214.523L-131.495 208.197C-158.575 206.943 -179.486 183.94 -178.232 156.861C-176.977 129.781 -153.975 108.87 -126.895 110.124L8.29567 116.45C35.3756 117.704 56.2867 140.707 55.032 167.787Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M14.8776 151.684L-15.8095 210.653L-25.2718 181.378L-50.4174 163.656L14.9299 151.684H14.8776ZM-61.8662 238.674C-65.9439 265.493 -90.9327 283.947 -117.751 279.869L-251.582 259.585C-278.401 255.508 -296.855 230.519 -292.777 203.7C-288.7 176.882 -263.711 158.428 -236.892 162.505L-103.061 182.789C-76.2426 186.867 -57.7885 211.856 -61.8662 238.674Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.3516 381.288L26.3247 373.551L50.3202 354.26L57.9527 324.462L92.4038 381.288H92.3516ZM-16.2295 340.564C-42.7343 346.314 -68.8732 329.481 -74.6237 302.976L-103.272 170.713C-109.023 144.208 -92.1891 118.069 -65.6843 112.319C-39.1794 106.568 -13.0404 123.402 -7.28987 149.906L21.3583 282.169C27.1088 308.674 10.2754 334.813 -16.2295 340.564Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-193.711 76.5084L-144.204 32.0723L-145.615 62.8117L-128.312 88.2709L-193.711 76.5084ZM-91.2987 22.0349C-78.0724 -1.6469 -48.1695 -10.1159 -24.4877 3.11041L93.6602 69.1373C117.342 82.3636 125.811 112.266 112.585 135.948C99.3584 159.63 69.4555 168.099 45.7737 154.873L-72.3742 88.846C-96.056 75.6197 -104.525 45.7168 -91.2987 22.0349Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M101.921 58.525L140.45 4.36524L145.783 34.6864L168.262 55.7021L101.869 58.5774L101.921 58.525ZM189.853 -17.0686C197.59 -43.0507 224.879 -57.8976 250.913 -50.1605L380.667 -11.6318C406.649 -3.89465 421.496 23.3944 413.759 49.4288C406.021 75.4631 378.732 90.2577 352.698 82.5206L222.945 43.9918C196.963 36.2547 182.116 8.96573 189.853 -17.0686Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M568.915 177.667L566.667 244.112L545.495 221.79L515.174 216.667L568.915 177.667ZM537.34 289.228C545.234 315.158 530.648 342.604 504.718 350.498L375.278 390.02C349.349 397.914 321.903 383.328 314.009 357.398C306.115 331.469 320.7 304.023 346.63 296.129L476.07 256.607C502 248.713 529.446 263.298 537.34 289.228Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M311.086 -1.43771L359.233 -47.2854L358.711 -16.4937L376.746 8.4428L311.033 -1.38545L311.086 -1.43771ZM411.825 -58.9433C424.371 -82.9911 454.013 -92.3488 478.061 -79.8022L598.091 -17.2779C622.138 -4.73127 631.496 24.9103 618.949 48.9581C606.403 73.0059 576.761 82.3636 552.714 69.8169L432.684 7.29269C408.636 -5.25399 399.278 -34.8955 411.825 -58.9433Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M83.4648 2.01385L145.937 -20.7269L133.181 7.29396L139.768 37.3537L83.4648 2.06618V2.01385ZM198.79 -10.3237C219.91 -27.3663 250.806 -24.0728 267.849 -2.95252L352.852 102.335C369.895 123.455 366.601 154.351 345.481 171.394C324.361 188.437 293.465 185.143 276.422 164.023L191.418 58.7353C174.376 37.6151 177.669 6.71885 198.79 -10.3237Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-74.0977 -102.647L-16.7489 -136.262L-24.2768 -106.411L-12.4097 -78.0242L-74.0977 -102.647ZM37.0973 -135.53C54.7672 -156.075 85.7679 -158.375 106.313 -140.705L208.882 -52.408C229.427 -34.7381 231.728 -3.7374 214.058 16.8078C196.388 37.353 165.387 39.6532 144.842 21.9833L42.2728 -66.3139C21.7276 -83.9838 19.4274 -114.985 37.0973 -135.53Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M84.3086 -50.0568L150.806 -50.9978L129.529 -28.7797L125.817 1.75049L84.3086 -50.1091V-50.0568ZM197.229 -23.761C222.74 -32.9096 250.866 -19.5788 260.014 5.93273L305.601 133.386C314.749 158.898 301.418 187.023 275.907 196.172C250.395 205.32 222.27 191.989 213.121 166.478L167.535 39.0246C158.386 13.513 171.717 -14.6124 197.229 -23.761Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M90.9928 289.122L73.8457 224.872L100.612 240.085L131.142 236.164L91.0452 289.122H90.9928ZM88.8494 173.169C73.7411 150.638 79.7531 120.16 102.285 105.051L214.682 29.6668C237.214 14.5585 267.692 20.5705 282.8 43.1022C297.908 65.6339 291.896 96.1119 269.365 111.22L156.967 186.605C134.436 201.713 103.958 195.701 88.8494 173.169Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M74.5253 426.615L14.1966 398.647L43.0018 387.825L59.5737 361.895L74.5253 426.615ZM-15.9154 354.001C-42.8908 351.178 -62.4426 327.026 -59.6196 300.05L-45.5569 165.435C-42.7339 138.46 -18.5815 118.908 8.39387 121.731C35.3692 124.554 54.921 148.706 52.098 175.682L38.0353 310.297C35.2123 337.272 11.0599 356.824 -15.9154 354.001Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M209.14 -27.5756L257.288 -73.4232L256.765 -42.6316L274.801 -17.6951L209.088 -27.5233L209.14 -27.5756ZM309.88 -85.0289C322.426 -109.077 352.068 -118.434 376.116 -105.888L496.145 -43.3635C520.193 -30.8168 529.551 -1.17531 517.004 22.8725C504.457 46.9203 474.816 56.278 450.768 43.7314L330.738 -18.7929C306.691 -31.3396 297.333 -60.9811 309.88 -85.0289Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M178.717 154.926L241.189 132.185L228.433 160.206L235.02 190.266L178.717 154.978V154.926ZM294.042 142.536C315.162 125.494 346.058 128.787 363.101 149.908L448.104 255.195C465.147 276.315 461.853 307.211 440.733 324.254C419.613 341.297 388.717 338.003 371.674 316.883L286.67 211.595C269.628 190.475 272.921 159.579 294.042 142.536Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-15.7559 256.396L41.5929 222.781L34.0649 252.632L45.932 281.019L-15.7559 256.396ZM95.4391 223.513C113.109 202.968 144.11 200.668 164.655 218.337L267.224 306.635C287.769 324.305 290.069 355.305 272.4 375.851C254.73 396.396 223.729 398.696 203.184 381.026L100.615 292.729C80.0694 275.059 77.7692 244.058 95.4391 223.513Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.582 133.701L257.079 132.76L235.802 154.978L232.091 185.509L190.582 133.649V133.701ZM303.554 159.997C329.066 150.849 357.191 164.179 366.34 189.691L411.926 317.144C421.075 342.656 407.744 370.781 382.233 379.93C356.721 389.078 328.596 375.748 319.447 350.236L273.861 222.783C264.712 197.271 278.043 169.146 303.554 159.997Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M286.565 454.688L269.418 390.438L296.184 405.651L326.714 401.73L286.617 454.688H286.565ZM284.422 338.736C269.313 316.204 275.325 285.726 297.857 270.617L410.254 195.233C432.786 180.125 463.264 186.137 478.372 208.668C493.481 231.2 487.469 261.678 464.937 276.786L352.54 352.171C330.008 367.279 299.53 361.267 284.422 338.736Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-68.3457 -194.602L-8.64436 -165.327L-37.6586 -155.133L-54.7534 -129.569L-68.2934 -194.602H-68.3457ZM20.4744 -120.002C47.3975 -116.604 66.4265 -92.0334 62.9762 -65.1103L45.9337 69.1392C42.5356 96.0622 17.9651 115.091 -8.95802 111.641C-35.8811 108.191 -54.9102 83.6723 -51.4599 56.7493L-34.4173 -77.5001C-31.0192 -104.423 -6.44865 -123.452 20.4744 -120.002Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.668 -13.7203L96.0676 -25.8488L78.8158 -0.337156L80.3319 30.4022L30.668 -13.7203ZM146.463 -6.81963C170.093 -20.1505 200.048 -11.7337 213.327 11.8436L279.72 129.782C293.05 153.412 284.634 183.367 261.056 196.646C237.479 209.924 207.472 201.56 194.193 177.983L127.8 60.0437C114.469 36.4142 122.886 6.45893 146.463 -6.81963Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-17.2201 111.587L-68.6091 69.399L-38.0265 66.1578L-15.4948 45.1945L-17.2201 111.587ZM-86.5927 18.6373C-112 9.17503 -124.912 -19.1073 -115.398 -44.5143L-68.0863 -171.288C-58.624 -196.695 -30.3418 -209.608 -4.93475 -200.093C20.4723 -190.578 33.3849 -162.349 23.8704 -136.942L-23.4411 -10.1678C-32.9034 15.2392 -61.1856 28.1519 -86.5927 18.6373Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M485.852 106.204L459.661 167.317L448.003 138.825L421.603 123.037L485.852 106.204ZM415.957 198.735C413.918 225.763 390.341 246.047 363.313 244.008L228.332 233.866C201.304 231.827 181.02 208.25 183.059 181.223C185.098 154.195 208.675 133.911 235.703 135.95L370.684 146.092C397.712 148.131 417.996 171.708 415.957 198.735Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M387.405 35.5757L370.258 -28.6737L397.024 -13.4608L427.554 -17.3817L387.457 35.5757H387.405ZM385.262 -80.4287C370.153 -102.96 376.165 -133.438 398.697 -148.547L511.094 -223.931C533.626 -239.04 564.104 -233.028 579.212 -210.496C594.321 -187.964 588.309 -157.486 565.777 -142.378L453.38 -66.9933C430.848 -51.8851 400.37 -57.897 385.262 -80.4287Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M205.268 -146.978L204.066 -80.4811L182.528 -102.438L152.102 -107.09L205.268 -146.926V-146.978ZM175.418 -34.8948C183.73 -9.06956 169.563 18.5854 143.737 26.8976L14.9249 68.4061C-10.9003 76.7183 -38.5553 62.551 -46.8675 36.7258C-55.1797 10.9005 -41.0124 -16.7544 -15.1872 -25.0666L113.625 -66.5751C139.451 -74.8873 167.106 -60.72 175.418 -34.8948Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M252.528 13.3573L186.031 12.4686L207.883 -9.17445L212.379 -39.6001L252.476 13.3573H252.528ZM140.288 -15.9706C114.515 -7.55386 86.8074 -21.5643 78.3384 -47.3373L36.2025 -175.941C27.7858 -201.714 41.7962 -229.421 67.5692 -237.89C93.3422 -246.359 121.049 -232.296 129.518 -206.523L171.654 -77.9197C180.071 -52.1468 166.061 -24.4396 140.288 -15.9706Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M158.479 177.248L150.062 243.223L131.033 219.018L101.287 211.072L158.427 177.196L158.479 177.248ZM116.605 285.464C122.094 312.021 104.999 338.003 78.442 343.44L-54.1346 370.729C-80.6917 376.218 -106.674 359.123 -112.111 332.566C-117.548 306.009 -100.505 280.027 -73.9478 274.59L58.6287 247.301C85.1858 241.812 111.168 258.907 116.605 285.464Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M262.355 103.119L321.848 73.4249L312.333 102.7L322.266 131.819L262.355 103.171V103.119ZM375.537 77.7117C394.566 58.3689 425.671 58.1598 444.962 77.1889L541.362 172.178C560.705 191.207 560.914 222.312 541.885 241.603C522.856 260.893 491.751 261.155 472.46 242.125L376.06 147.137C356.717 128.107 356.508 97.0022 375.537 77.7117Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M233.762 99.6157L296.234 76.8749L283.478 104.896L290.065 134.956L233.762 99.668V99.6157ZM349.087 87.2258C370.207 70.1833 401.103 73.4768 418.145 94.597L503.149 199.884C520.192 221.005 516.898 251.901 495.778 268.944C474.658 285.986 443.762 282.693 426.719 261.572L341.715 156.285C324.673 135.165 327.966 104.268 349.087 87.2258Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M46.084 216.354L103.433 182.739L95.9047 212.59L107.772 240.976L46.084 216.354ZM157.331 183.471C175.001 162.926 206.002 160.625 226.547 178.295L329.116 266.592C349.661 284.262 351.961 315.263 334.292 335.808C316.622 356.353 285.621 358.654 265.076 340.984L162.507 252.687C141.961 235.017 139.661 204.016 157.331 183.471Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.5613 243.903L-36.5701 237.055L-12.8361 217.45L-5.62175 187.548L29.5613 243.903ZM-79.5948 204.59C-105.995 210.707 -132.395 194.187 -138.46 167.787L-168.885 35.8896C-175.002 9.48935 -158.482 -16.911 -132.082 -22.9752C-105.681 -29.0917 -79.2812 -12.5719 -73.2169 13.8284L-42.7912 145.725C-36.6747 172.126 -53.1945 198.526 -79.5948 204.59Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M247.721 79.9076L314.218 78.9666L292.941 101.185L289.229 131.715L247.721 79.8553V79.9076ZM360.693 106.203C386.205 97.0547 414.33 110.386 423.479 135.897L469.065 263.35C478.214 288.862 464.883 316.988 439.371 326.136C413.859 335.285 385.734 321.954 376.585 296.442L330.999 168.989C321.851 143.477 335.181 115.352 360.693 106.203Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M348.774 395.718L331.627 331.468L358.393 346.681L388.923 342.76L348.826 395.718H348.774ZM346.631 279.713C331.522 257.181 337.534 226.703 360.066 211.595L472.463 136.211C494.995 121.102 525.473 127.114 540.581 149.646C555.69 172.178 549.678 202.656 527.146 217.764L414.749 293.149C392.217 308.257 361.739 302.245 346.631 279.713Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-75.3027 194.709L-10.0078 207.256L-35.3626 224.717L-45.1385 253.888L-75.3027 194.709ZM30.037 243.275C56.9078 239.511 81.7399 258.175 85.5039 285.045L104.376 419.086C108.14 445.957 89.4769 470.788 62.6062 474.552C35.7354 478.316 10.9033 459.653 7.13931 432.783L-11.7329 298.742C-15.4969 271.871 3.16622 247.039 30.037 243.275Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-221.785 199.153L-234.07 133.805L-208.559 150.953L-177.819 149.384L-221.837 199.153H-221.785ZM-215.198 83.4097C-228.581 59.8324 -220.269 29.8772 -196.692 16.4941L-78.9098 -50.2124C-55.3325 -63.5955 -25.3774 -55.2834 -11.9943 -31.7061C1.38885 -8.1288 -6.9232 21.8264 -30.5005 35.2095L-148.282 101.916C-171.86 115.299 -201.815 106.987 -215.198 83.4097Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M316.466 -78.5991L297.646 -14.8202L282.695 -41.7432L254.622 -54.2899L316.466 -78.5991ZM257.863 21.4606C259.013 48.5405 237.997 71.4382 210.917 72.5883L75.6747 78.3911C48.5948 79.5413 25.6971 58.5256 24.547 31.4457C23.3969 4.36578 44.4125 -18.5319 71.4924 -19.682L206.735 -25.4848C233.815 -26.635 256.713 -5.61929 257.863 21.4606Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.8262 -212.17L140.814 -194.082L114.1 -178.869L101.867 -150.639L76.8783 -212.17H76.8262ZM177.618 -154.716C204.698 -156.18 227.804 -135.426 229.32 -108.346L236.639 26.7922C238.103 53.8721 217.349 76.9789 190.269 78.4949C163.189 80.011 140.082 59.2044 138.566 32.1245L131.247 -103.014C129.784 -130.094 150.538 -153.2 177.618 -154.716Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M181.38 -0.548485L229.528 -46.3961L229.005 -15.6045L247.041 9.33202L181.328 -0.496231L181.38 -0.548485ZM282.172 -58.0541C294.719 -82.1019 324.36 -91.4596 348.408 -78.9129L468.438 -16.3886C492.486 -3.84197 501.843 25.7995 489.297 49.8473C476.75 73.8951 447.108 83.2528 423.061 70.7061L303.031 8.18191C278.983 -4.36477 269.625 -34.0063 282.172 -58.0541Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M136.887 203.072L196.588 232.348L167.574 242.542L150.479 268.106L136.939 203.072H136.887ZM225.707 277.621C252.63 281.019 271.659 305.589 268.209 332.512L251.166 466.762C247.768 493.685 223.197 512.714 196.274 509.264C169.351 505.813 150.322 481.295 153.773 454.372L170.815 320.122C174.213 293.199 198.784 274.17 225.707 277.621Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M230.521 140.443L295.921 128.315L278.669 153.826L280.185 184.566L230.521 140.443ZM346.317 147.292C369.946 133.961 399.902 142.378 413.18 165.955L479.573 283.894C492.904 307.523 484.487 337.479 460.91 350.757C437.333 364.036 407.325 355.671 394.046 332.094L327.654 214.155C314.323 190.526 322.74 160.57 346.317 147.292Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M106.466 191.154L74.3673 132.917L104.009 141.229L132.709 130.093L106.466 191.154ZM76.5107 79.0703C56.4361 60.8254 54.9199 29.7723 73.1649 9.69766L164.181 -90.5189C182.426 -110.594 213.478 -112.11 233.553 -93.8647C253.628 -75.6197 255.144 -44.5667 236.899 -24.492L145.883 75.7246C127.638 95.7993 96.5854 97.3153 76.5107 79.0703Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M677.133 166.531L618.686 198.212L627.208 168.623L616.282 139.87L677.133 166.531ZM564.84 195.65C546.491 215.568 515.385 216.875 495.467 198.473L395.93 106.778C376.013 88.4284 374.706 57.3231 393.108 37.4052C411.509 17.4874 442.562 16.1804 462.48 34.5822L562.017 126.277C581.935 144.627 583.242 175.732 564.84 195.65Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.4082 1.85736L41.0154 -64.5354L61.7697 -41.7946L91.9863 -36.0441L37.4605 1.85736H37.4082ZM71.2843 -109.076C63.9131 -135.163 79.0736 -162.295 105.16 -169.666L235.384 -206.522C261.471 -213.893 288.603 -198.733 295.974 -172.646C303.345 -146.559 288.185 -119.427 262.098 -112.056L131.874 -75.2001C105.788 -67.8289 78.6555 -82.9895 71.2843 -109.076Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.957 -180.436L120.429 -203.177L107.673 -175.156L114.26 -145.096L57.957 -180.384V-180.436ZM173.23 -192.826C194.35 -209.868 225.246 -206.575 242.289 -185.455L327.292 -80.1672C344.335 -59.047 341.041 -28.1507 319.921 -11.1082C298.801 5.9344 267.905 2.64088 250.862 -18.4794L165.859 -123.767C148.816 -144.887 152.109 -175.783 173.23 -192.826Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5957 46.1868L105.944 12.5722L98.4164 42.4229L110.284 70.8097L48.5957 46.1868ZM159.791 13.3041C177.461 -7.24108 208.461 -9.54133 229.006 8.12857L331.576 96.4258C352.121 114.096 354.421 145.096 336.751 165.642C319.081 186.187 288.08 188.487 267.535 170.817L164.966 82.5199C144.421 64.85 142.121 33.8493 159.791 13.3041Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M61.7767 404.656L-4.35474 397.808L19.3793 378.204L26.5936 348.301L61.7767 404.656ZM-47.3271 365.396C-73.7274 371.512 -100.128 354.993 -106.192 328.592L-136.618 196.695C-142.734 170.295 -126.214 143.895 -99.8141 137.831C-73.4138 131.766 -47.0134 148.234 -40.9492 174.634L-10.5236 306.531C-4.40714 332.931 -20.9268 359.332 -47.3271 365.396Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M104.693 -199.1L171.191 -200.041L149.914 -177.823L146.202 -147.293L104.693 -199.153V-199.1ZM217.666 -172.805C243.177 -181.953 271.303 -168.622 280.451 -143.111L326.038 -15.6574C335.186 9.85416 321.855 37.9796 296.344 47.1282C270.832 56.2768 242.707 42.9459 233.558 17.4344L187.972 -110.019C178.823 -135.53 192.154 -163.656 217.666 -172.805Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M221.485 26.95L204.338 -37.2995L231.104 -22.0867L261.634 -26.0075L221.537 26.95H221.485ZM219.342 -89.0022C204.233 -111.534 210.245 -142.012 232.777 -157.12L345.174 -232.505C367.706 -247.613 398.184 -241.601 413.292 -219.069C428.401 -196.538 422.389 -166.06 399.857 -150.951L287.46 -75.5669C264.928 -60.4586 234.45 -66.4705 219.342 -89.0022Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M139.775 211.805L201.15 186.241L189.648 214.785L197.595 244.531L139.775 211.805ZM254.421 194.187C274.705 176.204 305.757 178.086 323.741 198.422L413.45 299.789C431.433 320.072 429.551 351.125 409.215 369.109C388.879 387.093 357.878 385.211 339.895 364.874L250.186 263.508C232.203 243.224 234.085 212.171 254.421 194.187Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M326.983 140.028L311.979 204.8L295.512 178.818L266.759 167.945L327.035 140.028H326.983ZM274.392 243.434C277.162 270.409 257.506 294.509 230.531 297.28L95.9152 311.029C68.9399 313.8 44.8397 294.143 42.069 267.168C39.2983 240.193 58.9548 216.092 85.9301 213.322L220.546 199.573C247.521 196.802 271.621 216.458 274.392 243.434Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M217.458 -18.8969L167.794 25.3302L169.362 -5.40919L152.163 -30.9208L217.51 -18.8969H217.458ZM114.837 35.1584C101.506 58.788 71.5505 67.1002 47.9732 53.7693L-69.9132 -12.7281C-93.5428 -26.0589 -101.855 -56.0141 -88.5241 -79.5914C-75.1932 -103.221 -45.238 -111.533 -21.6607 -98.2023L96.2257 -31.7049C119.855 -18.3741 128.167 11.5812 114.837 35.1584Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M97.4268 178.398L74.9473 115.822L102.864 128.735L132.976 122.304L97.4268 178.451V178.398ZM85.5596 63.0213C68.6216 41.8488 72.072 10.9527 93.2445 -5.98534L198.95 -90.5185C220.123 -107.457 251.019 -104.006 267.957 -82.8337C284.895 -61.6612 281.445 -30.765 260.272 -13.827L154.566 70.7062C133.394 87.6442 102.498 84.1938 85.5596 63.0213Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M345.591 261.625L377.847 203.492L386.525 233.03L411.2 251.431L345.539 261.678L345.591 261.625ZM424.635 176.674C429.393 149.96 454.904 132.238 481.618 136.995L614.822 160.834C641.536 165.591 659.258 191.103 654.501 217.817C649.744 244.531 624.232 262.253 597.518 257.495L464.314 233.657C437.6 228.9 419.878 203.388 424.635 176.674Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M319.19 269.677L261.527 236.585L291.169 228.325L309.937 203.912L319.242 269.677H319.19ZM235.441 189.483C208.831 184.307 191.423 158.587 196.598 131.925L222.319 -0.96516C227.494 -27.5746 253.215 -44.9831 279.877 -39.8076C306.538 -34.6321 323.895 -8.91137 318.719 17.7503L292.998 150.64C287.823 177.25 262.102 194.658 235.441 189.483Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M226.977 -282.64L290.965 -264.551L264.251 -249.339L252.018 -221.109L227.029 -282.64H226.977ZM327.716 -225.186C354.796 -226.65 377.902 -205.896 379.419 -178.816L386.738 -43.6776C388.201 -16.5977 367.447 6.50909 340.367 8.02515C313.287 9.5412 290.18 -11.2654 288.664 -38.3453L281.345 -173.483C279.882 -200.563 300.636 -223.67 327.716 -225.186Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-224.549 -33.6411L-176.401 -79.4888L-176.924 -48.6972L-158.888 -23.7606L-224.602 -33.5889L-224.549 -33.6411ZM-123.81 -91.1467C-111.263 -115.195 -81.6218 -124.552 -57.5741 -112.006L62.4559 -49.4813C86.5037 -36.9346 95.8614 -7.29312 83.3147 16.7547C70.768 40.8025 41.1265 50.1601 17.0787 37.6135L-102.951 -24.9107C-126.999 -37.4574 -136.357 -67.0989 -123.81 -91.1467Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M359.605 310.087L293.578 302.35L317.574 283.059L325.206 253.261L359.657 310.087H359.605ZM250.972 269.363C224.467 275.113 198.328 258.28 192.577 231.775L163.929 99.5121C158.179 73.0072 175.012 46.8683 201.517 41.1178C228.022 35.3672 254.161 52.2006 259.911 78.7054L288.559 210.968C294.31 237.473 277.477 263.612 250.972 269.363Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M169.623 133.963L236.12 133.022L214.843 155.24L211.132 185.77L169.623 133.911V133.963ZM282.595 160.259C308.107 151.11 336.232 164.441 345.381 189.953L390.967 317.406C400.116 342.918 386.785 371.043 361.274 380.192C335.762 389.34 307.636 376.009 298.488 350.498L252.902 223.045C243.753 197.533 257.084 169.407 282.595 160.259Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-113.878 26.3229L-131.025 -37.9266L-104.259 -22.7137L-73.7289 -26.6346L-113.826 26.3229H-113.878ZM-116.022 -89.6294C-131.13 -112.161 -125.118 -142.639 -102.586 -157.747L9.81107 -233.132C32.3428 -248.24 62.8208 -242.228 77.929 -219.697C93.0373 -197.165 87.0254 -166.687 64.4936 -151.579L-47.9037 -76.1939C-70.4354 -61.0856 -100.913 -67.0976 -116.022 -89.6294Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.203 333.403L370.942 279.766L401.368 284.21L428.396 269.52L410.203 333.403ZM366.185 226.077C343.967 210.551 338.478 179.968 354.005 157.698L431.428 46.712C446.954 24.4939 477.537 19.0047 499.807 34.5312C522.078 50.0577 527.515 80.6403 511.988 102.911L434.565 213.896C419.038 236.115 388.456 241.604 366.185 226.077Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M328.909 136.159L327.707 202.656L306.168 180.699L275.742 176.047L328.909 136.211V136.159ZM299.058 248.242C307.37 274.067 293.203 301.722 267.378 310.035L138.566 351.543C112.74 359.855 85.0853 345.688 76.7731 319.863C68.4609 294.038 82.6282 266.383 108.453 258.07L237.266 216.562C263.091 208.25 290.746 222.417 299.058 248.242Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.3668 -3.21293L107.515 -49.0605L106.992 -18.2689L125.028 6.66757L59.3145 -3.16061L59.3668 -3.21293ZM160.106 -60.6662C172.653 -84.714 202.294 -94.0717 226.342 -81.5251L346.372 -19.0008C370.42 -6.45409 379.777 23.1874 367.231 47.2352C354.684 71.283 325.042 80.6407 300.995 68.094L180.965 5.56979C156.917 -6.97689 147.559 -36.6184 160.106 -60.6662Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-269.668 74.7848L-207.196 52.044L-219.952 80.0649L-213.365 110.125L-269.668 74.8371V74.7848ZM-154.395 62.395C-133.275 45.3524 -102.379 48.6459 -85.3365 69.7662L-0.332703 175.054C16.7099 196.174 13.4164 227.07 -7.70389 244.113C-28.8241 261.155 -59.7203 257.862 -76.7628 236.742L-161.767 131.454C-178.809 110.334 -175.516 79.4375 -154.395 62.395Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M232.454 129.886L215.307 65.6363L242.073 80.8492L272.603 76.9283L232.506 129.886H232.454ZM230.31 13.9335C215.202 -8.59819 221.214 -39.0761 243.746 -54.1844L356.143 -129.569C378.675 -144.677 409.153 -138.665 424.261 -116.134C439.369 -93.6019 433.357 -63.1239 410.826 -48.0156L298.428 27.369C275.897 42.4773 245.419 36.4653 230.31 13.9335Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M311.505 494.263L268.428 443.658L299.115 445.854L324.993 429.229L311.505 494.263ZM259.75 390.491C236.434 376.638 228.749 346.526 242.603 323.21L311.714 206.839C325.568 183.523 355.68 175.839 378.996 189.692C402.311 203.546 409.996 233.658 396.143 256.974L327.031 373.344C313.178 396.66 283.066 404.345 259.75 390.491Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M137.059 217.607L199.531 194.866L186.775 222.887L193.362 252.946L137.059 217.659V217.607ZM252.383 205.269C273.504 188.226 304.4 191.52 321.442 212.64L406.446 317.928C423.489 339.048 420.195 369.944 399.075 386.987C377.955 404.029 347.059 400.736 330.016 379.615L245.012 274.328C227.97 253.208 231.263 222.311 252.383 205.269Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M440.786 -295.289L485.745 -246.305L455.005 -247.35L429.755 -229.733L440.786 -295.237V-295.289ZM496.409 -193.504C520.248 -180.539 529.031 -150.741 516.066 -126.902L451.398 -8.02261C438.433 15.8161 408.635 24.5988 384.796 11.6339C360.958 -1.33099 352.175 -31.1294 365.14 -54.9681L429.807 -173.848C442.772 -197.687 472.571 -206.469 496.409 -193.504Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-101.131 270.093L-52.6171 224.611L-53.349 255.351L-35.4699 280.392L-101.079 270.041L-101.131 270.093ZM0.0789108 213.424C12.7824 189.481 42.5286 180.384 66.4718 193.088L186.031 256.553C209.974 269.257 219.071 299.003 206.367 322.946C193.664 346.889 163.918 355.986 139.974 343.282L20.4151 279.817C-3.52818 267.113 -12.6246 237.367 0.0789108 213.424Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M324.729 150.325L307.582 86.0759L334.348 101.289L364.878 97.3679L324.781 150.325H324.729ZM322.586 34.3209C307.477 11.7891 313.489 -18.6888 336.021 -33.7971L448.418 -109.182C470.95 -124.29 501.428 -118.278 516.536 -95.7464C531.645 -73.2146 525.633 -42.7367 503.101 -27.6284L390.704 47.7562C368.172 62.8645 337.694 56.8526 322.586 34.3209Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M163.644 -42.6136L144.824 21.1653L129.873 -5.75779L101.799 -18.3044L163.644 -42.6136ZM105.041 57.4984C106.191 84.5783 85.1752 107.476 58.0953 108.626L-77.1476 114.429C-104.227 115.579 -127.125 94.5634 -128.275 67.4835C-129.425 40.4036 -108.41 17.5059 -81.3297 16.3558L53.9129 10.5529C80.9929 9.40275 103.891 30.4185 105.041 57.4984Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.538 70.9435L213.368 128.763L183.622 120.817L155.078 132.318L180.485 70.9435H180.538ZM211.904 182.609C232.188 200.593 234.122 231.593 216.139 251.929L126.43 353.296C108.447 373.58 77.446 375.514 57.1099 357.53C36.7738 339.547 34.8917 308.546 52.8752 288.21L142.584 186.844C160.568 166.56 191.568 164.626 211.904 182.609Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M506.49 201.062L527.088 264.266L499.537 250.517L469.268 256.059L506.49 201.062ZM514.855 316.753C531.165 338.448 526.774 369.188 505.079 385.499L396.864 466.791C375.168 483.101 344.429 478.71 328.118 457.015C311.808 435.319 316.199 404.58 337.894 388.269L446.109 306.977C467.805 290.667 498.544 295.058 514.855 316.753Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-302.297 145.544L-244.948 111.93L-252.476 141.781L-240.609 170.167L-302.297 145.544ZM-191.05 112.662C-173.38 92.1166 -142.379 89.8161 -121.834 107.486L-19.2648 195.783C1.28036 213.453 3.58054 244.454 -14.0894 264.999C-31.7593 285.544 -62.76 287.845 -83.3051 270.175L-185.874 181.878C-206.419 164.208 -208.72 133.207 -191.05 112.662Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.1197 362.444L2.42732 307.657L32.7485 313.042L60.1944 299.136L40.1197 362.444ZM-0.761553 253.863C-22.5091 237.709 -27.0573 206.97 -10.9035 185.17L69.7612 76.4844C85.915 54.7369 116.654 50.1887 138.454 66.3425C160.254 82.4964 164.75 113.236 148.596 135.036L67.9314 243.721C51.7776 265.469 21.0383 270.017 -0.761553 253.863Z",
                fill: "#1558BC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-110.231 179.156L-85.7649 117.311L-73.3228 145.437L-46.5042 160.493L-110.283 179.104L-110.231 179.156ZM-42.897 84.7423C-41.6424 57.6624 -18.6403 36.7512 8.43965 38.0059L143.63 44.384C170.71 45.6386 191.621 68.6406 190.367 95.7205C189.112 122.8 166.11 143.712 139.03 142.457L3.83934 136.079C-23.2406 134.824 -44.1517 111.822 -42.897 84.7423Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M337.111 -152.494L396.813 -123.219L367.798 -113.024L350.703 -87.4605L337.163 -152.494H337.111ZM425.931 -77.9459C452.854 -74.5479 471.884 -49.9773 468.433 -23.0542L451.391 111.195C447.993 138.118 423.422 157.147 396.499 153.697C369.576 150.247 350.547 125.728 353.997 98.8053L371.04 -35.444C374.438 -62.3671 399.008 -81.3963 425.931 -77.9459Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.44043 51.0242L-55.1293 70.524L-40.9097 43.2348L-45.9285 12.8614L8.44043 51.0242ZM-107.407 57.4546C-129.364 73.3993 -160.051 68.485 -175.996 46.5284L-255.458 -63.0459C-271.403 -85.0026 -266.489 -115.69 -244.532 -131.634C-222.575 -147.579 -191.888 -142.665 -175.943 -120.708L-96.4811 -11.1339C-80.5364 10.8228 -85.4505 41.5098 -107.407 57.4546Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.7377 -86.3604L84.1926 -130.797L82.781 -100.057L100.085 -74.6502L34.6855 -86.3604H34.7377ZM137.098 -140.886C150.324 -164.568 180.227 -173.037 203.909 -159.863L322.109 -93.9407C345.791 -80.7144 354.26 -50.8115 341.086 -27.1297C327.859 -3.44785 297.957 5.02101 274.275 -8.15298L156.075 -74.0752C132.393 -87.3015 123.924 -117.204 137.098 -140.886Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-95.543 -30.0601L-30.248 -17.5134L-55.6028 -0.0524883L-65.3787 29.1183L-95.543 -30.0601ZM9.79678 18.5061C36.6676 14.7421 61.4996 33.4052 65.2636 60.276L84.1358 194.316C87.8998 221.187 69.2367 246.019 42.3659 249.783C15.4951 253.547 -9.33692 234.884 -13.1009 208.013L-31.9731 73.9727C-35.7371 47.102 -17.074 22.2701 9.79678 18.5061Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M89.4162 21.5903L77.1309 -43.7568L102.642 -26.6097L133.382 -28.1781L89.3638 21.5903H89.4162ZM96.0031 -94.1527C82.62 -117.73 90.9322 -147.685 114.509 -161.068L232.291 -227.775C255.869 -241.158 285.824 -232.846 299.207 -209.268C312.59 -185.691 304.278 -155.736 280.701 -142.353L162.919 -75.6463C139.341 -62.2632 109.386 -70.5754 96.0031 -94.1527Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-67.5723 233.419L-20.5746 186.369L-20.3132 217.16L-1.65002 241.626L-67.5723 233.419ZM31.7033 173.508C43.6226 149.147 73.055 139.109 97.3642 151.029L218.91 210.573C243.272 222.493 253.309 251.925 241.39 276.234C229.47 300.543 200.038 310.633 175.729 298.714L54.1827 239.169C29.8212 227.25 19.7839 197.817 31.7033 173.508Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-75.0957 54.0554L-9.69627 41.9269L-26.9479 67.4385L-25.4318 98.1779L-75.0957 54.0554ZM40.6996 60.9561C64.3292 47.6252 94.2844 56.042 107.563 79.6193L173.956 197.558C187.287 221.188 178.87 251.143 155.293 264.421C131.715 277.7 101.708 269.335 88.4293 245.758L22.0364 127.819C8.70555 104.19 17.1223 74.2346 40.6996 60.9561Z",
                fill: "#669DF1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M198.004 44.7518L147.661 88.1426L149.699 57.4555L132.918 31.6823L198.056 44.7518H198.004ZM94.5463 97.1342C80.8495 120.555 50.7899 128.396 27.3694 114.699L-89.4193 46.3203C-112.84 32.6236 -120.681 2.56362 -106.985 -20.8568C-93.2878 -44.2773 -63.2281 -52.1189 -39.8076 -38.4221L76.981 29.9574C100.401 43.6542 108.243 73.7138 94.5463 97.1342Z",
                fill: "#4D8CED"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M454.216 327.574L392.894 301.854L421.281 289.986L436.86 263.482L454.216 327.626V327.574ZM361.162 258.306C334.134 256.476 313.641 233.056 315.471 206.028L324.62 70.9945C326.449 43.9669 349.87 23.4741 376.897 25.3038C403.925 27.1335 424.418 50.554 422.588 77.5816L413.44 212.615C411.61 239.643 388.189 260.136 361.162 258.306Z",
                fill: "#4D8CED"
            })
        ]
    });
const $5234614371b266d4$export$4f43b91428c248ba = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "471",
        height: "220",
        viewBox: "0 0 471 220",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M162.119 -197.709L202.354 -153.871L174.845 -154.807L152.247 -139.04L162.119 -197.662V-197.709ZM211.899 -106.618C233.233 -95.0155 241.093 -68.3479 229.49 -47.0138L171.617 59.3758C160.014 80.7098 133.346 88.5698 112.012 76.9671C90.6781 65.3643 82.8182 38.6966 94.4209 17.3626L152.294 -89.027C163.897 -110.361 190.564 -118.221 211.899 -106.618Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M368.769 245.955L313.797 268.74L324.136 243.195L317.072 216.574L368.769 245.908V245.955ZM266.122 261.535C247.923 277.582 220.179 275.851 204.085 257.652L123.942 166.841C107.895 148.642 109.626 120.898 127.825 104.804C146.025 88.7101 173.768 90.488 189.863 108.687L270.006 199.498C286.053 217.697 284.322 245.441 266.122 261.535Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M95.5904 -125.332L118.515 -70.4064L92.9704 -80.6992L66.3496 -73.5879L95.5904 -125.332ZM111.357 -22.7323C127.451 -4.57961 125.767 23.2107 107.614 39.3048L16.9444 119.588C-1.20826 135.682 -28.9987 133.998 -45.0929 115.846C-61.187 97.6929 -59.5027 69.9024 -41.35 53.8083L49.3198 -26.4752C67.4725 -42.5693 95.2628 -40.8849 111.357 -22.7323Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-57.2564 -216.657L-10.7987 -179.463L-38.1681 -176.235L-58.0986 -157.24L-57.2564 -216.704V-216.657ZM5.76321 -134.221C28.5944 -125.987 40.4311 -100.817 32.1969 -77.9855L-8.88051 35.9832C-17.1147 58.8144 -42.2852 70.651 -65.1164 62.4168C-87.9476 54.1826 -99.7842 29.0122 -91.55 6.18103L-50.4726 -107.788C-42.2384 -130.619 -17.068 -142.456 5.76321 -134.221Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M449.099 199.404L394.127 222.188L404.466 196.644L397.402 170.023L449.099 199.357V199.404ZM346.5 214.984C328.3 231.031 300.556 229.3 284.462 211.1L204.319 120.29C188.272 102.091 190.003 74.3471 208.202 58.253C226.402 42.1589 254.145 43.9366 270.24 62.1361L350.383 152.946C366.43 171.146 364.699 198.889 346.5 214.984Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M288.066 34.8604L257.469 85.9031L250.591 59.2354L229.07 42.0652L288.066 34.8604ZM214.894 108.453C209.841 132.174 186.495 147.332 162.729 142.232L44.2684 116.922C20.5483 111.869 5.38986 88.523 10.4894 64.7561C15.589 40.9892 38.888 25.8775 62.6549 30.9771L181.115 56.288C204.835 61.3408 219.994 84.6866 214.894 108.453Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-38.168 -222.318L20.2668 -211.09L-2.42406 -195.463L-11.1729 -169.357L-38.168 -222.318ZM56.0575 -178.808C80.1051 -182.176 102.328 -165.474 105.697 -141.426L122.586 -21.469C125.955 2.57858 109.252 24.8015 85.2047 28.17C61.1571 31.5386 38.9341 14.8363 35.5656 -9.21132L18.6761 -129.169C15.3076 -153.216 32.0099 -175.439 56.0575 -178.808Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M484.704 -4.01823L531.162 33.1759L503.793 36.4041L483.862 55.3989L484.704 -4.06506V-4.01823ZM547.724 78.464C570.555 86.6982 582.392 111.869 574.158 134.7L533.08 248.669C524.846 271.5 499.676 283.336 476.845 275.102C454.013 266.868 442.177 241.698 450.411 218.867L491.488 104.898C499.723 82.0666 524.893 70.2298 547.724 78.464Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M405.45 312.016L371.718 262.985L398.853 267.804L423.415 255.359L405.45 312.016ZM368.911 214.89C349.448 200.433 345.378 172.924 359.834 153.414L432.024 56.1478C446.481 36.6852 473.99 32.6149 493.5 47.0715C513.009 61.5281 517.033 89.0379 502.576 108.547L430.386 205.814C415.93 225.276 388.42 229.347 368.911 214.89Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.175 171.239L350.992 165.11L372.233 147.566L378.689 120.805L410.175 171.239ZM312.488 136.057C288.861 141.531 265.235 126.746 259.808 103.12L232.579 -14.9194C227.105 -38.5459 241.889 -62.1725 265.515 -67.5996C289.142 -73.0734 312.768 -58.2893 318.196 -34.6627L345.425 83.3764C350.898 107.003 336.114 130.63 312.488 136.057Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M394.127 140.361L416.022 85.0142L427.157 110.185L451.158 123.659L394.08 140.314L394.127 140.361ZM454.386 55.8669C455.509 31.6322 476.095 12.9181 500.329 14.0409L621.316 19.7487C645.551 20.8716 664.265 41.4571 663.142 65.6918C662.019 89.9266 641.434 108.641 617.199 107.518L496.212 101.81C471.978 100.687 453.263 80.1017 454.386 55.8669Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M152.902 -224.096L206.331 -197.896L180.365 -188.773L165.066 -165.895L152.949 -224.096H152.902ZM232.39 -157.333C256.485 -154.292 273.515 -132.303 270.427 -108.209L255.175 11.9354C252.134 36.0298 230.145 53.0597 206.05 49.9718C181.956 46.884 164.926 24.9417 168.014 0.847351L183.266 -119.297C186.307 -143.391 208.296 -160.421 232.39 -157.333Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M177.418 212.27L219.478 170.163L219.712 197.72L236.414 219.615L177.418 212.27ZM266.31 158.654C276.977 136.852 303.317 127.869 325.072 138.536L433.848 191.825C455.65 202.492 464.633 228.832 453.966 250.587C443.299 272.342 416.958 281.372 395.203 270.705L286.428 217.416C264.626 206.749 255.643 180.409 266.31 158.654Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M156.224 -206.318L202.682 -169.123L175.312 -165.895L155.382 -146.9L156.224 -206.364V-206.318ZM219.244 -123.882C242.075 -115.648 253.912 -90.4773 245.677 -67.6461L204.6 46.3226C196.366 69.1538 171.195 80.9905 148.364 72.7563C125.533 64.5221 113.696 39.3517 121.93 16.5205L163.008 -97.4483C171.242 -120.279 196.413 -132.116 219.244 -123.882Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.9711 109.717L43.239 60.6859L70.3745 65.5048L94.9367 53.0599L76.9711 109.717ZM40.3851 12.5439C20.9225 -1.91273 16.8522 -29.4224 31.3088 -48.9318L103.498 -146.198C117.955 -165.661 145.465 -169.731 164.974 -155.275C184.484 -140.818 188.507 -113.308 174.05 -93.7988L101.861 3.46756C87.4043 22.9302 59.8946 27.0005 40.3851 12.5439Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M61.8593 -107.46L58.8183 -48.0429L40.1977 -68.3477L13.1091 -73.4006L61.8125 -107.46H61.8593ZM31.8232 -8.08842C38.5134 15.2574 24.9925 39.5858 1.69345 46.2293L-114.755 79.5404C-138.101 86.2307 -162.429 72.7097 -169.073 49.4107C-175.716 26.1116 -162.242 1.73659 -138.943 -4.90691L-22.4945 -38.218C0.851334 -44.9083 25.1797 -31.3875 31.8232 -8.08842Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M294.803 144.01L289.469 203.287L271.644 182.281L244.789 176.152L294.803 144.01ZM260.93 242.119C266.685 265.699 252.228 289.466 228.695 295.22L111.03 323.946C87.4505 329.701 63.6836 315.244 57.929 291.711C52.1745 268.178 66.6311 244.365 90.1641 238.61L207.829 209.884C231.409 204.129 255.176 218.586 260.93 242.119Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M236.742 341.35L177.653 334.426L199.127 317.163L205.958 290.495L236.789 341.35H236.742ZM139.57 304.858C115.849 310.004 92.4568 294.94 87.3104 271.219L61.6721 152.853C56.5258 129.133 71.5906 105.74 95.3107 100.594C119.031 95.4474 142.423 110.512 147.57 134.232L173.208 252.599C178.354 276.319 163.29 299.712 139.57 304.858Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.1855 -180.212L19.7059 -120.748L0.898178 -140.865L-26.1904 -145.684L22.2322 -180.212H22.1855ZM-6.91495 -80.6059C-0.0375214 -57.3536 -13.3245 -32.8849 -36.5768 -26.0075L-152.744 8.3797C-175.997 15.2571 -200.465 1.97014 -207.343 -21.2821C-214.22 -44.5344 -200.933 -69.0031 -177.681 -75.8805L-61.5133 -110.268C-38.261 -117.145 -13.7924 -103.858 -6.91495 -80.6059Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-271.812 163.754L-225.729 126.092L-228.255 153.508L-213.846 176.947L-271.812 163.754ZM-178.055 119.308C-165.236 98.6753 -138.147 92.3594 -117.562 105.179L-14.6809 169.087C5.95139 181.906 12.2674 208.995 -0.551758 229.58C-13.3709 250.166 -40.4596 256.529 -61.0451 243.71L-163.926 179.801C-184.558 166.982 -190.874 139.893 -178.055 119.308Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M98.8672 41.4573L156.132 57.6449L132.225 71.2594L121.277 96.5234L98.9139 41.4573H98.8672ZM189.022 92.8742C213.257 91.5642 233.936 110.138 235.293 134.373L241.843 255.313C243.153 279.547 224.579 300.226 200.344 301.583C176.11 302.94 155.431 284.319 154.074 260.085L147.524 139.145C146.214 114.91 164.788 94.231 189.022 92.8742Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-129.914 72.5226L-86.8249 31.492L-87.2928 59.0484L-71.1519 81.3651L-129.961 72.5694L-129.914 72.5226ZM-39.759 21.1056C-28.5306 -0.415558 -2.00335 -8.79021 19.5179 2.43824L126.937 58.3935C148.458 69.6219 156.833 96.1491 145.604 117.67C134.376 139.191 107.848 147.566 86.3272 136.338L-21.0917 80.3825C-42.6129 69.154 -50.9875 42.6269 -39.759 21.1056Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-83.082 132.127L-74.5672 73.2242L-57.9116 95.1665L-31.4312 102.699L-83.082 132.127ZM-44.0164 35.9364C-48.5078 12.0759 -32.8347 -10.8956 -8.97424 -15.387L110.047 -37.8438C133.908 -42.3352 156.879 -26.6622 161.371 -2.80175C165.862 21.0587 150.189 44.0303 126.329 48.5216L7.307 70.9786C-16.5535 75.47 -39.525 59.7969 -44.0164 35.9364Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-133.797 -195.931L-76.5318 -179.743L-100.439 -166.129L-111.387 -140.865L-133.75 -195.931H-133.797ZM-43.6418 -144.561C-19.4071 -145.871 1.27202 -127.297 2.62878 -103.062L9.17876 17.8774C10.4888 42.1122 -8.08504 62.7912 -32.3198 64.1479C-56.5545 65.5047 -77.2336 46.8842 -78.5904 22.6494L-85.1403 -98.2904C-86.4503 -122.525 -67.8765 -143.204 -43.6418 -144.561Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-38.4493 -54.3121L0.288826 -9.11773L-27.1741 -11.0358L-50.286 3.93539L-38.4025 -54.3121H-38.4493ZM8.19554 38.4161C29.1085 50.7206 36.0328 77.669 23.7283 98.582L-37.7943 202.913C-50.0989 223.826 -77.0472 230.75 -97.9602 218.446C-118.873 206.141 -125.797 179.193 -113.493 158.28L-51.9703 53.9488C-39.6657 33.0358 -12.7175 26.1116 8.19554 38.4161Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M201.982 355.573L150.05 326.519L176.484 318.847L193.046 296.811L201.982 355.573ZM126.236 284.553C102.376 280.202 86.5625 257.324 90.9135 233.417L112.669 114.255C117.02 90.3944 139.898 74.5809 163.805 78.9319C187.712 83.283 203.479 106.161 199.128 130.068L177.373 249.23C173.022 273.091 150.144 288.904 126.236 284.553Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M21.1093 -38.2648L65.3681 -78.0322L64.1049 -50.5225L79.5909 -27.785L21.0625 -38.2648H21.1093ZM112.715 -87.1086C124.551 -108.302 151.313 -115.882 172.506 -104.092L278.288 -45.0954C299.481 -33.2587 307.061 -6.4976 295.271 14.6961C283.434 35.8898 256.673 43.4689 235.479 31.679L129.698 -27.3171C108.504 -39.1537 100.925 -65.9149 112.715 -87.1086Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M318.195 -201.499L356.933 -156.304L329.47 -158.222L306.358 -143.251L318.242 -201.499H318.195ZM364.793 -108.77C385.706 -96.4658 392.63 -69.5174 380.326 -48.6044L318.803 55.7266C306.499 76.6396 279.551 83.5638 258.638 71.2593C237.725 58.9548 230.8 32.0064 243.105 11.0934L304.627 -93.2376C316.932 -114.151 343.88 -121.075 364.793 -108.77Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M558.577 208.387L506.646 179.333L533.08 171.66L549.641 149.625L558.577 208.387ZM482.879 137.367C459.019 133.016 443.205 110.138 447.556 86.2306L469.311 -32.9314C473.662 -56.7919 496.54 -72.6052 520.448 -68.2542C544.355 -63.9032 560.121 -41.0252 555.77 -17.118L534.015 102.044C529.664 125.904 506.786 141.718 482.879 137.367Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M386.782 -244.12L437.732 -213.335L411.064 -206.505L393.8 -185.03L386.829 -244.073L386.782 -244.12ZM460.142 -170.667C483.862 -165.521 498.927 -142.128 493.78 -118.408L468.095 -0.0414276C462.949 23.6787 439.556 38.7435 415.836 33.5972C392.116 28.4508 377.051 5.05826 382.198 -18.6619L407.883 -137.029C413.029 -160.749 436.421 -175.814 460.142 -170.667Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M408.49 -214.973L454.947 -177.778L427.578 -174.55L407.647 -155.555L408.49 -215.019V-214.973ZM471.509 -132.49C494.341 -124.256 506.177 -99.0856 497.943 -76.2544L456.866 37.7143C448.631 60.5455 423.461 72.3821 400.63 64.1479C377.799 55.9138 365.962 30.7433 374.196 7.91217L415.274 -106.057C423.508 -128.888 448.678 -140.725 471.509 -132.49Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M352.864 4.54333L319.132 -44.4876L346.267 -39.6688L370.829 -52.1135L352.864 4.54333ZM316.278 -92.6295C296.815 -107.086 292.745 -134.596 307.201 -154.105L379.391 -251.372C393.848 -270.835 421.357 -274.905 440.867 -260.448C460.376 -245.991 464.4 -218.482 449.943 -198.972L377.754 -101.706C363.297 -82.2432 335.787 -78.1729 316.278 -92.6295Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M618.51 -133.005L641.435 -78.0792L615.89 -88.3719L589.269 -81.2606L618.51 -133.005ZM634.277 -30.405C650.371 -12.2524 648.687 15.5381 630.534 31.6322L539.864 111.916C521.712 128.01 493.921 126.325 477.827 108.173C461.733 90.0201 463.417 62.2298 481.57 46.1357L572.24 -34.1478C590.392 -50.2419 618.183 -48.5577 634.277 -30.405Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M470.623 -228.962L517.08 -191.767L489.711 -188.539L469.78 -169.544L470.623 -229.008V-228.962ZM533.642 -146.526C556.473 -138.292 568.31 -113.121 560.076 -90.2901L518.998 23.6786C510.764 46.5098 485.594 58.3465 462.763 50.1122C439.931 41.8781 428.095 16.7077 436.329 -6.12354L477.406 -120.092C485.641 -142.923 510.811 -154.76 533.642 -146.526Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M486.576 -113.542L481.242 -54.2656L463.417 -75.2721L436.563 -81.4009L486.576 -113.542ZM452.657 -15.4337C458.411 8.14603 443.955 31.9128 420.422 37.6674L302.757 66.3936C279.177 72.1482 255.41 57.6915 249.656 34.1585C243.901 10.6255 258.358 -13.188 281.891 -18.9426L399.556 -47.6688C423.135 -53.4234 446.902 -38.9667 452.657 -15.4337Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M488.354 65.271L429.264 58.3467L450.738 41.0829L457.569 14.4154L488.401 65.271H488.354ZM391.181 28.8252C367.461 33.9716 344.068 18.9068 338.922 -4.81335L313.283 -123.18C308.137 -146.9 323.202 -170.293 346.922 -175.439C370.642 -180.585 394.035 -165.521 399.181 -141.8L424.819 -23.4339C429.966 0.286179 414.901 23.6788 391.181 28.8252Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M535.326 139.425L486.482 105.459L513.524 100.36L532.097 80.055L535.279 139.425H535.326ZM466.785 61.4344C443.44 54.7909 429.919 30.4625 436.562 7.11671L469.78 -109.378C476.423 -132.724 500.751 -146.245 524.097 -139.602C547.443 -132.958 560.964 -108.63 554.32 -85.2841L521.103 31.2112C514.459 54.557 490.131 68.0779 466.785 61.4344Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M320.863 205.439L367.32 242.634L339.951 245.862L320.021 264.857L320.863 205.393V205.439ZM383.882 287.922C406.714 296.156 418.55 321.326 410.316 344.158L369.239 458.126C361.004 480.958 335.834 492.794 313.003 484.56C290.172 476.326 278.335 451.155 286.569 428.324L327.647 314.355C335.881 291.524 361.051 279.688 383.882 287.922Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M399.602 160.526L445.685 122.863L443.159 150.28L457.569 173.719L399.602 160.526ZM493.406 116.08C506.225 95.4473 533.314 89.1313 553.899 101.95L656.78 165.859C677.412 178.678 683.728 205.767 670.909 226.352C658.09 246.938 631.001 253.301 610.416 240.481L507.535 176.573C486.903 163.754 480.587 136.665 493.406 116.08Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M86.5156 24.1935L129.605 -16.8372L129.137 10.7193L145.278 33.0358L86.4688 24.2402L86.5156 24.1935ZM176.671 -27.2236C187.899 -48.7448 214.426 -57.1193 235.948 -45.8908L343.366 10.0643C364.888 21.2927 373.262 47.82 362.034 69.3412C350.805 90.8624 324.278 99.2369 302.757 88.0085L195.338 32.0534C173.817 20.8249 165.442 -5.70237 176.671 -27.2236Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M597.551 348.275L538.461 341.35L559.936 324.086L566.766 297.419L597.598 348.275H597.551ZM500.331 311.829C476.611 316.975 453.219 301.91 448.072 278.19L422.434 159.824C417.287 136.104 432.352 112.711 456.072 107.564C479.793 102.418 503.185 117.483 508.332 141.203L533.97 259.57C539.116 283.29 524.051 306.682 500.331 311.829Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M423.883 192.199L483.394 191.357L464.352 211.241L461.03 238.563L423.883 192.152V192.199ZM524.986 215.779C547.817 207.591 572.987 219.521 581.175 242.353L621.972 356.415C630.159 379.246 618.229 404.417 595.397 412.604C572.566 420.792 547.396 408.861 539.209 386.03L498.412 271.968C490.224 249.137 502.155 223.966 524.986 215.779Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.144 79.4933L174.799 21.9944L198.753 35.6089L226.075 32.1L190.191 79.4933H190.144ZM188.226 -24.2763C174.705 -44.4407 180.086 -71.7165 200.25 -85.2374L300.838 -152.702C321.003 -166.223 348.278 -160.842 361.799 -140.678C375.32 -120.514 369.94 -93.2377 349.776 -79.7168L249.187 -12.2524C229.023 1.26851 201.747 -4.11183 188.226 -24.2763Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-59.5957 -88.7462L-19.3605 -44.9085L-46.8702 -45.8441L-69.4674 -30.0775L-59.5957 -88.6994V-88.7462ZM-9.81622 2.34463C11.5178 13.9474 19.3777 40.6149 7.77499 61.949L-50.0983 168.339C-61.701 189.673 -88.3687 197.533 -109.703 185.93C-131.037 174.327 -138.897 147.66 -127.294 126.325L-69.4206 19.9359C-57.8179 -1.39815 -31.1503 -9.25811 -9.81622 2.34463Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M223.923 172.83L270.381 210.024L243.012 213.253L223.081 232.247L223.923 172.783V172.83ZM286.99 255.312C309.821 263.547 321.658 288.717 313.423 311.548L272.346 425.517C264.112 448.348 238.941 460.185 216.11 451.951C193.279 443.717 181.442 418.546 189.677 395.715L230.754 281.746C238.988 258.915 264.159 247.078 286.99 255.312Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M355.203 281.372L300.23 304.156L310.57 278.611L303.505 251.991L355.203 281.325V281.372ZM252.603 296.904C234.404 312.952 206.66 311.221 190.566 293.021L110.423 202.211C94.3754 184.012 96.1064 156.268 114.306 140.174C132.505 124.08 160.249 125.858 176.343 144.057L256.486 234.867C272.533 253.067 270.802 280.81 252.603 296.904Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M338.5 66.4872L381.589 25.4566L381.121 53.0131L397.262 75.3297L338.453 66.534L338.5 66.4872ZM428.655 15.0703C439.883 -6.45095 466.411 -14.8255 487.932 -3.597L595.351 52.3581C616.872 63.5865 625.247 90.1138 614.018 111.635C602.79 133.156 576.262 141.531 554.741 130.302L447.322 74.3472C425.801 63.1187 417.427 36.5915 428.655 15.0703Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.9219 117.764L92.8302 97.4121L81.4147 122.489L87.3096 149.39L36.9219 117.81V117.764ZM140.13 106.675C159.031 91.4235 186.681 94.371 201.933 113.272L278.006 207.498C293.258 226.399 290.311 254.049 271.409 269.301C252.508 284.553 224.858 281.605 209.606 262.704L133.533 168.479C118.281 149.578 121.229 121.927 140.13 106.675Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-249.59 235.99L-198.266 205.907L-205.004 232.621L-194.383 258.026L-249.59 235.99ZM-150.078 206.562C-134.264 188.175 -106.521 186.117 -88.134 201.93L3.65855 280.951C22.0452 296.764 24.1037 324.508 8.29031 342.894C-7.52309 361.281 -35.2668 363.339 -53.6534 347.526L-145.446 268.506C-163.833 252.692 -165.891 224.949 -150.078 206.562Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M111.78 146.63L110.704 206.141L91.4282 186.491L64.1991 182.327L111.78 146.677V146.63ZM85.0654 246.938C92.5042 270.05 79.8254 294.799 56.7135 302.238L-58.5654 339.385C-81.6773 346.824 -106.427 334.146 -113.865 311.034C-121.304 287.922 -108.626 263.172 -85.5136 255.733L29.7652 218.586C52.8771 211.147 77.6265 223.826 85.0654 246.938Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M284.744 167.543L331.201 204.738L303.832 207.966L283.902 226.961L284.744 167.496V167.543ZM347.81 250.026C370.641 258.26 382.478 283.43 374.244 306.261L333.166 420.23C324.932 443.062 299.762 454.898 276.931 446.664C254.099 438.43 242.263 413.259 250.497 390.428L291.574 276.459C299.808 253.628 324.979 241.791 347.81 250.026Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M424.07 274.541L369.097 297.325L379.437 271.781L372.373 245.16L424.07 274.494V274.541ZM321.423 290.074C303.224 306.121 275.48 304.39 259.386 286.191L179.243 195.381C163.196 177.181 164.927 149.437 183.126 133.343C201.326 117.249 229.069 119.027 245.163 137.227L325.307 228.037C341.354 246.236 339.623 273.98 321.423 290.074Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M364.371 218.258L361.891 277.723L343.084 257.605L315.995 252.786L364.418 218.258H364.371ZM335.224 317.864C342.101 341.116 328.814 365.585 305.562 372.463L189.394 406.85C166.142 413.727 141.673 400.44 134.796 377.188C127.918 353.936 141.205 329.467 164.458 322.59L280.625 288.202C303.878 281.325 328.346 294.612 335.224 317.864Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M419.486 82.7684L462.575 41.7378L462.108 69.2943L478.249 91.6109L419.439 82.8153L419.486 82.7684ZM509.641 31.3515C520.87 9.83029 547.397 1.45564 568.918 12.6841L676.337 68.6393C697.858 79.8678 706.233 106.395 695.004 127.916C683.776 149.437 657.249 157.812 635.727 146.584L528.309 90.6283C506.787 79.3999 498.413 52.8727 509.641 31.3515Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M109.768 107.097L165.676 86.7452L154.26 111.822L160.155 138.723L109.768 107.143V107.097ZM212.976 96.0554C231.877 80.8034 259.527 83.7509 274.779 102.652L350.852 196.878C366.104 215.779 363.156 243.429 344.255 258.681C325.354 273.933 297.704 270.985 282.452 252.084L206.379 157.859C191.127 138.957 194.075 111.307 212.976 96.0554Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-183.623 201.697L-132.3 171.614L-139.037 198.328L-128.416 223.732L-183.623 201.697ZM-84.0641 172.269C-68.2507 153.882 -40.507 151.824 -22.1204 167.637L69.6722 246.657C88.0588 262.471 90.1174 290.214 74.304 308.601C58.4905 326.987 30.7469 329.046 12.3603 313.233L-79.4323 234.212C-97.8189 218.399 -99.8775 190.655 -84.0641 172.269Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-117.797 310.098L-90.8486 257.043L-82.0998 283.15L-59.4089 298.776L-117.75 310.098H-117.797ZM-49.9583 231.499C-46.5898 207.451 -24.3668 190.749 -0.319168 194.117L119.638 211.007C143.686 214.375 160.388 236.598 157.02 260.646C153.651 284.693 131.428 301.396 107.38 298.027L-12.577 281.138C-36.6245 277.769 -53.3268 255.546 -49.9583 231.499Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M281.376 51.3757L327.834 88.5699L300.465 91.798L280.534 110.793L281.376 51.3289V51.3757ZM344.396 133.858C367.227 142.092 379.064 167.263 370.83 190.094L329.752 304.063C321.518 326.894 296.348 338.731 273.516 330.496C250.685 322.262 238.849 297.092 247.083 274.26L288.16 160.292C296.394 137.46 321.565 125.624 344.396 133.858Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M515.021 199.451L460.049 222.235L470.388 196.691L463.324 170.07L515.021 199.404V199.451ZM412.374 215.03C394.175 231.078 366.431 229.347 350.337 211.147L270.194 120.337C254.147 102.138 255.878 74.3939 274.077 58.2998C292.277 42.2057 320.02 43.9836 336.115 62.1831L416.258 152.993C432.305 171.193 430.574 198.936 412.374 215.03Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M381.309 59.5631L378.829 119.027L360.021 98.9095L332.932 94.0906L381.355 59.5631H381.309ZM352.161 159.216C359.039 182.468 345.752 206.937 322.499 213.814L206.332 248.201C183.079 255.078 158.611 241.791 151.733 218.539C144.856 195.287 158.143 170.818 181.395 163.941L297.563 129.554C320.815 122.676 345.284 135.963 352.161 159.216Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M268.088 21.0119L323.996 0.660396L312.581 25.7372L318.476 52.6387L268.088 21.0587V21.0119ZM371.296 9.92378C390.197 -5.3282 417.847 -2.38072 433.099 16.5205L509.172 110.746C524.424 129.647 521.477 157.297 502.575 172.549C483.674 187.801 456.024 184.854 440.772 165.953L364.699 71.7272C349.447 52.8259 352.395 25.1758 371.296 9.92378Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M219.806 431.506L160.623 425.377L181.864 407.832L188.32 381.071L219.806 431.506ZM122.166 396.323C98.539 401.797 74.9125 387.013 69.4854 363.386L42.2564 245.347C36.7825 221.721 51.5667 198.094 75.1932 192.667C98.8198 187.24 122.446 201.977 127.873 225.604L155.102 343.643C160.576 367.269 145.792 390.896 122.166 396.323Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M62.3281 207.732L113.652 177.649L106.914 204.363L117.535 229.768L62.3281 207.732ZM161.84 178.304C177.654 159.917 205.397 157.859 223.784 173.672L315.577 252.692C333.963 268.506 336.022 296.249 320.208 314.636C304.395 333.023 276.651 335.081 258.265 319.268L166.472 240.247C148.085 224.434 146.027 196.69 161.84 178.304Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-1.39397 331.526L-35.1261 282.495L-7.99063 287.314L16.5716 274.869L-1.39397 331.526ZM-37.9332 234.399C-57.3959 219.943 -61.4662 192.433 -47.0096 172.924L25.1801 75.6572C39.6367 56.1946 67.1464 52.1243 86.6559 66.5809C106.165 81.0375 110.189 108.547 95.7322 128.057L23.5426 225.323C9.08592 244.786 -18.4238 248.856 -37.9332 234.399Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M410.268 18.6726L352.114 31.3515L366.805 8.05238L364.559 -19.4105L410.221 18.6259L410.268 18.6726ZM306.498 15.7719C285.726 28.3571 258.731 21.7137 246.145 0.941086L183.406 -102.641C170.821 -123.414 177.465 -150.409 198.237 -162.994C219.01 -175.58 246.005 -168.936 258.59 -148.163L321.329 -44.581C333.914 -23.8084 327.271 3.18669 306.498 15.7719Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.43071 216.761L-57.7701 229.206L-42.986 205.954L-45.0913 178.491L0.43071 216.714V216.761ZM-103.339 213.439C-124.158 225.931 -151.153 219.194 -163.598 198.375L-225.916 94.5114C-238.408 73.692 -231.671 46.6969 -210.851 34.252C-190.032 21.8071 -163.037 28.4974 -150.592 49.3169L-88.274 153.18C-75.7824 173.999 -82.5195 200.995 -103.339 213.439Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M82.725 390.615L71.7305 332.134L94.5617 347.479L122.071 346.076L82.6782 390.615H82.725ZM88.6199 286.986C76.6429 265.886 84.0817 239.078 105.182 227.101L210.589 167.403C231.689 155.426 258.497 162.865 270.474 183.965C282.451 205.065 275.012 231.873 253.912 243.85L148.505 303.548C127.405 315.525 100.597 308.086 88.6199 286.986Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-212.77 294.659L-208.465 235.288L-190.266 255.967L-163.318 261.582L-212.723 294.612L-212.77 294.659ZM-180.675 195.942C-186.851 172.456 -172.862 148.455 -149.376 142.279L-32.2721 111.401C-8.78592 105.225 15.2149 119.214 21.3906 142.7C27.5662 166.187 13.5774 190.187 -9.90877 196.363L-127.012 227.241C-150.498 233.417 -174.499 219.428 -180.675 195.942Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M80.2926 391.317L21.1094 385.188L42.3498 367.644L48.8062 340.882L80.2926 391.317ZM-17.3481 356.134C-40.9746 361.608 -64.6012 346.824 -70.0283 323.198L-97.2573 205.158C-102.731 181.532 -87.947 157.905 -64.3205 152.478C-40.694 147.051 -17.0674 161.789 -11.6403 185.415L15.5887 303.454C21.0625 327.081 6.27844 350.707 -17.3481 356.134Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M251.714 204.317L243.34 145.414L265.469 161.789L293.026 161.602L251.714 204.363V204.317ZM262.241 101.015C251.247 79.4 259.855 52.9195 281.47 41.925L389.403 -13.0008C411.018 -23.9954 437.499 -15.3868 448.493 6.22797C459.488 27.8428 450.879 54.3231 429.264 65.3176L321.331 120.244C299.716 131.238 273.236 122.63 262.241 101.015Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M220.414 330.824L162.821 315.899L186.448 301.723L196.834 276.225L220.414 330.777V330.824ZM129.136 281.418C104.948 283.243 83.8476 265.137 81.9762 240.949L72.7595 120.196C70.9348 96.0085 89.0407 74.9085 113.229 73.0371C137.417 71.1656 158.517 89.3183 160.388 113.506L169.605 234.259C171.429 258.447 153.324 279.547 129.136 281.418Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-138.006 205.673L-133.702 146.303L-115.502 166.982L-88.5538 172.596L-137.959 205.627L-138.006 205.673ZM-105.911 106.956C-112.087 83.4703 -98.098 59.4695 -74.6119 53.2938L42.4916 22.4156C65.9778 16.2399 89.9786 30.2287 96.1542 53.7149C102.33 77.2011 88.3411 101.202 64.8549 107.378L-52.2485 138.256C-75.7347 144.431 -99.7355 130.443 -105.911 106.956Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.4035 235.101L35.4719 206.048L61.9055 198.375L78.4675 176.339L87.4035 235.101ZM11.6582 164.128C-12.2022 159.777 -28.0156 136.899 -23.6646 112.992L-1.90952 -6.1702C2.44151 -30.0307 25.3195 -45.844 49.2268 -41.493C73.134 -37.142 88.9007 -14.264 84.5496 9.64323L62.7945 128.805C58.4434 152.666 35.5655 168.479 11.6582 164.128Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-97.3048 204.317L-53.0459 164.549L-54.3092 192.059L-38.8233 214.796L-97.3516 204.317H-97.3048ZM-5.69933 155.473C6.13734 134.279 32.8985 126.7 54.0922 138.49L159.874 197.486C181.067 209.323 188.647 236.084 176.857 257.277C165.02 278.471 138.259 286.05 117.065 274.26L11.2837 215.264C-9.90997 203.428 -17.4892 176.667 -5.69933 155.473Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M457.85 8.84778L496.588 54.0422L469.125 52.1241L446.013 67.0953L457.896 8.84778H457.85ZM504.494 101.576C525.407 113.881 532.332 140.829 520.027 161.742L458.505 266.073C446.2 286.986 419.252 293.91 398.339 281.606C377.426 269.301 370.501 242.353 382.806 221.44L444.329 117.109C456.633 96.1957 483.581 89.2715 504.494 101.576Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M404.609 15.4913L352.677 -13.5623L379.111 -21.2352L395.673 -43.271L404.609 15.4913ZM328.863 -55.4818C305.003 -59.8329 289.189 -82.711 293.54 -106.618L315.296 -225.78C319.647 -249.641 342.525 -265.454 366.432 -261.103C390.339 -256.752 406.106 -233.874 401.755 -209.967L380 -90.8048C375.649 -66.9443 352.771 -51.1308 328.863 -55.4818Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M313.049 103.635L370.314 119.822L346.407 133.437L335.459 158.701L313.096 103.635H313.049ZM403.204 155.005C427.439 153.695 448.118 172.268 449.475 196.503L456.025 317.443C457.335 341.678 438.761 362.357 414.526 363.714C390.291 365.07 369.612 346.45 368.255 322.215L361.706 201.275C360.396 177.041 378.969 156.362 403.204 155.005Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-102.637 270.097L-59.5476 229.066L-60.0155 256.622L-43.8745 278.939L-102.684 270.143L-102.637 270.097ZM-12.4817 218.68C-1.25323 197.158 25.274 188.784 46.7952 200.012L154.214 255.967C175.735 267.196 184.11 293.723 172.881 315.244C161.653 336.765 135.126 345.14 113.604 333.912L6.18565 277.956C-15.3356 266.728 -23.7101 240.201 -12.4817 218.68Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.2147 327.596L-0.130859 270.097L23.8232 283.711L51.1458 280.202L15.2615 327.596H15.2147ZM13.2965 223.779C-0.224453 203.615 5.15588 176.339 25.3203 162.818L125.909 95.3537C146.073 81.8328 173.349 87.2131 186.87 107.378C200.391 127.542 195.01 154.818 174.846 168.339L74.2577 235.803C54.0933 249.324 26.8174 243.944 13.2965 223.779Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M452.564 -195.651L503.513 -164.866L476.845 -158.035L459.581 -136.561L452.61 -195.604L452.564 -195.651ZM525.923 -122.198C549.643 -117.051 564.708 -93.6587 559.561 -69.9386L533.876 48.4281C528.73 72.1482 505.337 87.2131 481.617 82.0667C457.897 76.9203 442.832 53.5276 447.979 29.8075L473.664 -88.5591C478.81 -112.279 502.203 -127.344 525.923 -122.198Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M350.057 -159.579L405.965 -179.931L394.549 -154.854L400.444 -127.952L350.057 -159.532V-159.579ZM453.218 -170.667C472.119 -185.919 499.769 -182.972 515.021 -164.07L591.094 -69.8449C606.346 -50.9437 603.399 -23.2937 584.497 -8.04167C565.596 7.21031 537.946 4.26282 522.694 -14.6384L446.621 -108.864C431.369 -127.765 434.317 -155.415 453.218 -170.667Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M318.711 157.485L370.034 127.402L363.297 154.116L373.917 179.52L318.711 157.485ZM418.27 128.057C434.083 109.67 461.827 107.612 480.214 123.425L572.006 202.445C590.393 218.259 592.451 246.002 576.638 264.389C560.825 282.776 533.081 284.834 514.694 269.021L422.902 190C404.515 174.187 402.456 146.443 418.27 128.057Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M365.588 189.298L392.536 136.244L401.285 162.35L423.976 177.976L365.635 189.298H365.588ZM433.426 110.699C436.795 86.6516 459.018 69.9493 483.066 73.3178L603.023 90.2072C627.071 93.5758 643.773 115.799 640.404 139.846C637.036 163.894 614.813 180.596 590.765 177.228L470.808 160.338C446.76 156.97 430.058 134.747 433.426 110.699Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.9283 133.624L8.19611 84.5929L35.3316 89.4117L59.8938 76.9669L41.9283 133.624ZM5.38904 36.4975C-14.0736 22.0409 -18.1439 -5.46877 -3.6873 -24.9782L68.5023 -122.245C82.9589 -141.707 110.469 -145.778 129.978 -131.321C149.487 -116.864 153.511 -89.3547 139.054 -69.8452L66.8648 27.4213C52.4082 46.884 24.8985 50.9541 5.38904 36.4975Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.9393 67.7506L33.8348 12.4036L44.9697 37.5741L68.9705 51.0483L11.8926 67.7038L11.9393 67.7506ZM72.1987 -16.7903C73.3216 -41.0251 93.9071 -59.7392 118.142 -58.6163L239.128 -52.9085C263.363 -51.7857 282.077 -31.2001 280.954 -6.96538C279.832 17.2694 259.246 35.9835 235.011 34.8606L114.025 29.1528C89.79 28.03 71.0759 7.44444 72.1987 -16.7903Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.1094 185.275L66.5381 211.475L40.5723 220.598L25.2736 243.476L13.1561 185.275H13.1094ZM92.5975 251.991C116.692 255.032 133.722 277.021 130.634 301.115L115.382 421.26C112.341 445.354 90.3518 462.384 66.2574 459.296C42.163 456.208 25.1332 434.266 28.221 410.172L43.473 290.027C46.5141 265.933 68.5031 248.903 92.5975 251.991Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M400.865 -74.383L452.189 -104.466L445.452 -77.7516L456.072 -52.3472L400.865 -74.383ZM500.377 -103.811C516.191 -122.198 543.934 -124.256 562.321 -108.443L654.114 -29.4225C672.5 -13.6091 674.559 14.1346 658.745 32.5212C642.932 50.9078 615.188 52.9663 596.802 37.1529L505.009 -41.8674C486.623 -57.6808 484.564 -85.4244 500.377 -103.811Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M405.965 261.488L372.233 212.457L399.369 217.276L423.931 204.831L405.965 261.488ZM369.426 164.315C349.963 149.859 345.893 122.349 360.35 102.839L432.539 5.57288C446.996 -13.8898 474.506 -17.9601 494.015 -3.50346C513.525 10.9532 517.548 38.463 503.092 57.9724L430.902 155.239C416.445 174.701 388.936 178.772 369.426 164.315Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M520.682 300.039L461.171 299.244L480.727 279.875L484.751 252.646L520.635 300.039H520.682ZM420.234 273.793C397.169 281.325 372.373 268.786 364.793 245.721L327.084 130.63C319.552 107.565 332.09 82.7685 355.155 75.1893C378.221 67.6101 403.017 80.1953 410.596 103.26L448.305 218.352C455.837 241.417 443.299 266.213 420.234 273.793Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M402.361 177.462L429.31 124.407L438.058 150.513L460.749 166.14L402.408 177.462H402.361ZM470.2 98.8624C473.568 74.8148 495.791 58.1125 519.839 61.481L639.796 78.3704C663.844 81.739 680.546 103.962 677.178 128.01C673.809 152.057 651.586 168.76 627.538 165.391L507.581 148.501C483.534 145.133 466.831 122.91 470.2 98.8624Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M89.8828 -143.345L148.318 -132.116L125.627 -116.49L116.878 -90.3838L89.8828 -143.345ZM184.155 -99.8812C208.203 -103.25 230.426 -86.5473 233.794 -62.4997L250.684 57.4575C254.052 81.5051 237.35 103.728 213.302 107.097C189.255 110.465 167.032 93.7628 163.663 69.7152L146.774 -50.242C143.405 -74.2896 160.107 -96.5127 184.155 -99.8812Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M168.67 347.105L157.676 288.623L180.507 303.969L208.017 302.566L168.624 347.105H168.67ZM174.612 243.476C162.635 222.376 170.074 195.568 191.174 183.591L296.581 123.893C317.681 111.916 344.489 119.354 356.466 140.455C368.443 161.555 361.004 188.363 339.904 200.34L234.497 260.038C213.397 272.015 186.589 264.576 174.612 243.476Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.1108 -144.888L131.569 -107.694L104.199 -104.466L84.2687 -85.4712L85.1108 -144.935V-144.888ZM148.13 -62.4529C170.962 -54.2187 182.798 -29.0482 174.564 -6.217L133.487 107.752C125.252 130.583 100.082 142.42 77.2509 134.185C54.4197 125.951 42.583 100.781 50.8172 77.9496L91.8946 -36.0193C100.129 -58.8505 125.299 -70.6871 148.13 -62.4529Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M315.342 -1.49193L260.369 21.2924L270.708 -4.25223L263.644 -30.873L315.342 -1.53862V-1.49193ZM212.695 14.0876C194.495 30.135 166.752 28.4038 150.658 10.2044L70.5145 -80.6058C54.4672 -98.8052 56.1982 -126.549 74.3977 -142.643C92.5971 -158.737 120.341 -156.959 136.435 -138.76L216.578 -47.9496C232.625 -29.7502 230.894 -2.00648 212.695 14.0876Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M182.799 -135.11L180.319 -75.6463L161.511 -95.7641L134.423 -100.583L182.846 -135.11H182.799ZM153.698 -35.5047C160.576 -12.2524 147.289 12.2163 124.037 19.0938L7.8688 53.4808C-15.3835 60.3582 -39.8521 47.0712 -46.7295 23.819C-53.607 0.566696 -40.32 -23.9019 -17.0677 -30.7793L99.1 -65.1665C122.352 -72.0439 146.821 -58.7569 153.698 -35.5047Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-30.6348 261.488L15.4487 223.826L12.9223 251.242L27.3321 274.681L-30.6348 261.488ZM63.1229 217.042C75.942 196.41 103.031 190.094 123.616 202.913L226.497 266.821C247.129 279.641 253.445 306.729 240.626 327.315C227.807 347.9 200.718 354.263 180.133 341.444L77.252 277.535C56.6197 264.716 50.3037 237.627 63.1229 217.042Z",
                fill: "#FA8700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M180.694 251.008L121.604 244.084L143.078 226.82L149.909 200.153L180.74 251.008H180.694ZM83.5207 214.563C59.8006 219.709 36.408 204.644 31.2617 180.924L5.6233 62.5572C0.476927 38.8371 15.5418 15.4446 39.2619 10.2982C62.982 5.15185 86.3746 20.2167 91.521 43.9368L117.159 162.303C122.306 186.023 107.241 209.416 83.5207 214.563Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.3669 177.649L-41.8165 171.52L-20.576 153.976L-14.1196 127.214L17.3669 177.649ZM-80.2739 142.466C-103.9 147.94 -127.527 133.156 -132.954 109.53L-160.183 -8.50961C-165.657 -32.1361 -150.873 -55.7626 -127.246 -61.1897C-103.62 -66.6168 -79.9932 -51.8795 -74.5661 -28.253L-47.3371 89.7862C-41.8632 113.413 -56.6474 137.039 -80.2739 142.466Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-82.1914 12.9181L-22.6806 12.076L-41.7222 31.9598L-45.0439 59.2823L-82.1914 12.8713V12.9181ZM18.8646 36.4978C41.6958 28.3104 66.8663 40.2407 75.0538 63.0719L115.85 177.134C124.038 199.966 112.108 225.136 89.2764 233.323C66.4452 241.511 41.2748 229.581 33.0874 206.749L-7.70933 92.6869C-15.8967 69.8557 -3.96655 44.6852 18.8646 36.4978Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M385.613 251.382L370.268 193.883L394.222 207.498L421.544 203.989L385.66 251.382H385.613ZM383.695 147.613C370.174 127.448 375.554 100.172 395.719 86.6514L496.307 19.1872C516.471 5.6663 543.747 11.0466 557.268 31.2111C570.789 51.3755 565.409 78.6513 545.244 92.1722L444.656 159.636C424.492 173.157 397.216 167.777 383.695 147.613Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M190.238 236.739L233.327 195.708L232.86 223.264L249 245.581L190.191 236.785L190.238 236.739ZM280.393 185.322C291.622 163.801 318.149 155.426 339.67 166.654L447.089 222.61C468.61 233.838 476.985 260.365 465.756 281.886C454.528 303.408 428.001 311.782 406.479 300.554L299.061 244.599C277.539 233.37 269.165 206.843 280.393 185.322Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M-28.8574 -61.5641L27.0509 -81.9157L15.6353 -56.8387L21.5303 -29.9372L-28.8574 -61.5172V-61.5641ZM74.3508 -72.6521C93.252 -87.9041 120.902 -84.9566 136.154 -66.0554L212.227 28.17C227.479 47.0712 224.531 74.7214 205.63 89.9733C186.729 105.225 159.079 102.278 143.827 83.3766L67.7541 -10.8489C52.5021 -29.7501 55.4496 -57.4002 74.3508 -72.6521Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M527.326 364.93L468.143 358.801L489.383 341.257L495.839 314.496L527.326 364.93ZM429.685 329.748C406.059 335.222 382.432 320.437 377.005 296.811L349.776 178.772C344.302 155.145 359.086 131.519 382.713 126.092C406.339 120.664 429.966 135.402 435.393 159.028L462.622 277.067C468.096 300.694 453.312 324.321 429.685 329.748Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M427.768 200.199L487.278 199.357L468.237 219.241L464.915 246.564L427.768 200.153V200.199ZM528.824 223.732C551.655 215.545 576.825 227.475 585.013 250.306L625.809 364.369C633.997 387.2 622.067 412.37 599.235 420.558C576.404 428.745 551.234 416.815 543.046 393.984L502.25 279.921C494.062 257.09 505.993 231.92 528.824 223.732Z",
                fill: "#AF59E0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M244.883 228.224L296.206 198.141L289.469 224.855L300.089 250.259L244.883 228.224ZM344.442 198.796C360.255 180.409 387.999 178.351 406.385 194.164L498.178 273.184C516.565 288.998 518.623 316.741 502.81 335.128C486.996 353.515 459.253 355.573 440.866 339.76L349.073 260.739C330.687 244.926 328.628 217.182 344.442 198.796Z",
                fill: "#AF59E0"
            })
        ]
    });

});


parcelRegister("2540f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b007b6ae3baf0cb1$export$2e2bcd8739ae039; });
/* download-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");
const $b007b6ae3baf0cb1$var$rowStyle = null;
const $b007b6ae3baf0cb1$var$versionContainerStyle = null;
const $b007b6ae3baf0cb1$var$releaseNotesStyle = null;
const $b007b6ae3baf0cb1$var$cellStyle = null;
const $b007b6ae3baf0cb1$var$firstCellStyle = null;
const $b007b6ae3baf0cb1$var$UniformDownloadRow = ({ size: size, date: date })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
        className: (0, $2jatx.default)([
            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _179r87ef"
        ]),
        style: {
            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "_y3gn1e5h",
                    "p"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                            name: "version"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("small", {
                            className: (0, $2jatx.default)([
                                "_1wyb1wqq _1pfhi2wt"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                name: "releaseNotes"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: size
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: date
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "format"
                })
            })
        ]
    });
};
var $b007b6ae3baf0cb1$export$2e2bcd8739ae039 = $b007b6ae3baf0cb1$var$UniformDownloadRow;

});

parcelRegister("j6nXt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $368a77dca296ff8b$export$2e2bcd8739ae039; });
/* download-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $kbpa7 = parcelRequire("kbpa7");
const $368a77dca296ff8b$var$containerStyle = null;
const $368a77dca296ff8b$var$titleStyle = null;
const $368a77dca296ff8b$var$tableStyle = null;
const $368a77dca296ff8b$var$headStyle = null;
const $368a77dca296ff8b$var$bodyStyle = null;
const $368a77dca296ff8b$var$UniformDownloadTable = ({ title: title })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyr7vkz _18u0idpf _k48p8n31 _1wyb1q5e"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
                className: (0, $2jatx.default)([
                    "_vwz4kb7n _ect4q6fz _syazvejh _1bsb1osq _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _yq5hcfaq _btyzidpf _6rth1tcg"
                ]),
                style: {
                    "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _n7zl87ef _1fr819bv _1160ftgi _lxpr19bv _il49ftgi _xhev1h6o _7dd61e5h"
                        ]),
                        style: {
                            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: "Version"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: "Size"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: "Build Date"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                        children: "Format"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1a0z87ef _1czs19bv _ayjoftgi _7zpg19bv _3m4tftgi _1omd150w _ue36cd5j"
                        ]),
                        style: {
                            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000")),
                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                            name: "downloadrow"
                        })
                    })
                ]
            })
        ]
    });
};
var $368a77dca296ff8b$export$2e2bcd8739ae039 = $368a77dca296ff8b$var$UniformDownloadTable;

});

parcelRegister("8JW63", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6316a05e55dc2e95$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $6iX8D = parcelRequire("6iX8D");
const $6316a05e55dc2e95$var$UniformEmbeddedVideo = ({ url: url, title: title, thumbnailSrc: thumbnailSrc, thumbnailAlt: thumbnailAlt = "", videoType: videoType })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
        embedUrl: url,
        title: title,
        thumbnail: {
            src: thumbnailSrc ? thumbnailSrc : "",
            alt: thumbnailAlt
        },
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "embeddedVideo",
            "data-event-container": "video",
            "data-event": "clicked",
            "data-track-event": "videoPlayed"
        },
        videoType: videoType || undefined
    });
};
var $6316a05e55dc2e95$export$2e2bcd8739ae039 = $6316a05e55dc2e95$var$UniformEmbeddedVideo;

});

parcelRegister("jK7xK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dd4891ef82d7897a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $9NH4m = parcelRequire("9NH4m");
const $dd4891ef82d7897a$var$UniformEnhancedBanner = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9NH4m.EnhancedBanner), {
        ...props
    });
};
var $dd4891ef82d7897a$export$2e2bcd8739ae039 = $dd4891ef82d7897a$var$UniformEnhancedBanner;

});

parcelRegister("856b3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b78c67bf5af211c6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $g3AHF = parcelRequire("g3AHF");

var $lTkkF = parcelRequire("lTkkF");
const $b78c67bf5af211c6$var$UniformExpand = (props)=>{
    const expandProps = {
        eventDataName: props.eventDataName ?? undefined,
        chevronColor: props.chevronColor,
        boldLabel: props.richText ? false : props.boldLabel,
        label: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.label,
        expandedLabelText: props.expandedLabelText ?? null
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3AHF.Expand), {
        ...expandProps,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "contents"
        })
    });
};
var $b78c67bf5af211c6$export$2e2bcd8739ae039 = $b78c67bf5af211c6$var$UniformExpand;

});

parcelRegister("2bofd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6173395c20c30f5b$export$2e2bcd8739ae039; });
/* experiment.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $Fp3mL = parcelRequire("Fp3mL");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $izdHQ = parcelRequire("izdHQ");

var $eRzlV = parcelRequire("eRzlV");

var $e61Ln = parcelRequire("e61Ln");
const $6173395c20c30f5b$var$WRAPPER_STYLES = null;
const $6173395c20c30f5b$var$renderSlot = (variant)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: variant
    });
const $6173395c20c30f5b$var$getSelectedVariantFromExperimentStatus = (experimentStatus)=>experimentStatus.type === "enrolled" && experimentStatus.value ? "treatment" : "control";
const $6173395c20c30f5b$var$getActiveVariant = ({ manualOverride: manualOverride, propOverride: propOverride, experimentStatus: experimentStatus })=>{
    if (manualOverride) return manualOverride;
    if (propOverride) return propOverride;
    if (experimentStatus) return $6173395c20c30f5b$var$getSelectedVariantFromExperimentStatus(experimentStatus);
    return "control";
};
const $6173395c20c30f5b$var$UniformExperiment = (props)=>{
    const { experimentId: experimentId, override: override, postExperimentationMode: postExperimentationMode } = props;
    const isProd = (0, $eRzlV.isProduction)();
    const experiment = Object.entries((0, $4X0dO.experiments)).find(// @ts-ignore
    ([, value])=>value.experimentName === experimentId)?.[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks -- intentional: experiment is stable per render, this is safe
    const experimentStatus = experiment ? (0, $gIKKj.useExperiment)(// oxlint-disable-line react-hooks/rules-of-hooks
    experiment) : undefined;
    const [manualOverride, setManualOverride] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        setManualOverride(null);
    }, [
        experimentId
    ]);
    if (postExperimentationMode) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
        experimentKey: experimentId,
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "treatment"
        })
    });
    if (!isProd) {
        const activeVariant = $6173395c20c30f5b$var$getActiveVariant({
            manualOverride: manualOverride,
            propOverride: override,
            experimentStatus: experimentStatus
        });
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e61Ln.default), {
                    experimentId: experimentId,
                    selectedVariant: manualOverride,
                    setSelectedVariant: setManualOverride
                }),
                !experiment && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Fp3mL.ManifestErrorMessage), {
                    id: experimentId
                }),
                $6173395c20c30f5b$var$renderSlot(activeVariant)
            ]
        });
    }
    if (!experiment || !experimentStatus) return $6173395c20c30f5b$var$renderSlot("control");
    return $6173395c20c30f5b$var$renderSlot($6173395c20c30f5b$var$getSelectedVariantFromExperimentStatus(experimentStatus));
};
var $6173395c20c30f5b$export$2e2bcd8739ae039 = $6173395c20c30f5b$var$UniformExperiment;

});
parcelRegister("Fp3mL", function(module, exports) {
$parcel$export(module.exports, "ManifestErrorMessage", function () { return $080833fa2bf97116$export$702dc26c1a322512; });

var $7VQPk = parcelRequire("7VQPk");

var $8S1MN = parcelRequire("8S1MN");
const $080833fa2bf97116$export$702dc26c1a322512 = ({ id: id })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: id.length === 0 ? null : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8S1MN.default), {
            appearance: "error",
            isDismissible: true,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                        children: "Manifest entry not found for:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7VQPk.jsx)("code", {
                        children: id
                    }),
                    ". Rendering control slot."
                ]
            })
        })
    });
};

});

parcelRegister("e61Ln", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6a2f274f0a5e2609$export$2e2bcd8739ae039; });
/* experiment-override-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $6a2f274f0a5e2609$var$PANEL_STYLES = null;
const $6a2f274f0a5e2609$var$PANEL_EXPANDED_STYLES = null;
const $6a2f274f0a5e2609$var$META_STYLES = null;
const $6a2f274f0a5e2609$var$EXPERIMENT_ID_STYLES = null;
const $6a2f274f0a5e2609$var$BUTTON_CLUSTER_STYLES = null;
const $6a2f274f0a5e2609$var$BUTTON_CLUSTER_COLLAPSED_STYLES = null;
const $6a2f274f0a5e2609$var$BUTTON_CLUSTER_EXPANDED_STYLES = null;
const $6a2f274f0a5e2609$var$VARIANT_BUTTON_STYLES = null;
const $6a2f274f0a5e2609$var$SELECTED_VARIANT_BUTTON_STYLES = null;
const $6a2f274f0a5e2609$var$UNSELECTED_VARIANT_BUTTON_STYLES = null;
const $6a2f274f0a5e2609$var$getDisplayedExperimentLabel = (experimentId, isExpanded)=>{
    if (isExpanded) return experimentId;
    return experimentId.length > 14 ? `${experimentId.slice(0, 14)}\u{2026}` : experimentId;
};
const $6a2f274f0a5e2609$var$getVariantButtonText = (variant)=>variant === "control" ? "Control" : "Treatment";
const $6a2f274f0a5e2609$var$getVariantButtonAriaLabel = (variant)=>variant === "control" ? "Show control (Original experience)" : "Show treatment (Experiment experience)";
const $6a2f274f0a5e2609$var$getVariantDescription = (variant)=>variant === "control" ? "Original experience" : "Experiment experience";
const $6a2f274f0a5e2609$var$VARIANTS = [
    "control",
    "treatment"
];
const $6a2f274f0a5e2609$var$renderVariantButton = (variant, selectedVariant, setSelectedVariant)=>{
    const isSelected = selectedVariant === variant;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        "aria-pressed": isSelected,
        "aria-label": $6a2f274f0a5e2609$var$getVariantButtonAriaLabel(variant),
        title: $6a2f274f0a5e2609$var$getVariantDescription(variant),
        onClick: ()=>setSelectedVariant(isSelected ? null : variant),
        className: (0, $2jatx.default)([
            "_19itidpf _2rkow7q6 _1ul91oqx _1yt41ppf _1wyb19bv _vwz4cjiy _80omtlke _k48p1fw0 _v564t6js _1llw1qs1 _1ygb7g83 _1ah3yh40",
            isSelected ? "_syazi7uo _bfhkvuon" : "_syaz15cr _bfhk1j28 _tzy4q80t"
        ]),
        children: $6a2f274f0a5e2609$var$getVariantButtonText(variant)
    }, variant);
};
const $6a2f274f0a5e2609$var$ExperimentOverrideControls = ({ experimentId: experimentId, selectedVariant: selectedVariant, setSelectedVariant: setSelectedVariant })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const handleActivate = ()=>{
        setIsExpanded(true);
    };
    const handleDeactivate = ()=>{
        setIsExpanded(false);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "experiment-controls",
        onMouseEnter: handleActivate,
        onMouseLeave: handleDeactivate,
        onFocus: handleActivate,
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) handleDeactivate();
        },
        className: (0, $2jatx.default)([
            "_kqswstnw _152t1b66 _rjxp1b66 _1pbyrpof _1e0c116y _4cvr1h6o _1bahesu3 _gy1p1b66 _syaz15cr _19itidpf _16qs130s _8hrz11aj _2rko7vkz _p12f163w _1yt4u49m _bfhk1tj6 _18k91p0y _tzy4x7ai _1reo15vq _18m915vq _v5641pcj",
            isExpanded && "_1pby14ny _p12fsb0t _1yt412x7 _bfhk1tj6 _18k91m5u _tzy4kb7n"
        ]),
        style: {
            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _ae4v1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    title: `Experiment ID: ${experimentId}`,
                    "aria-label": `Experiment override for ${experimentId}`,
                    className: (0, $2jatx.default)([
                        "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wyb1skh _vwz4cjiy _k48p1fw0 _1ul9idpf _p12f1osq"
                    ]),
                    children: $6a2f274f0a5e2609$var$getDisplayedExperimentLabel(experimentId, isExpanded)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "group",
                "aria-label": "Experiment variant override",
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _gy1pv77o _1yt4v77o _2rkow7q6 _1o9zidpf _v564ke4q",
                    isExpanded ? "_bfhk1s03" : "_bfhk1s03"
                ]),
                style: {
                    "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800"))
                },
                children: $6a2f274f0a5e2609$var$VARIANTS.map((variant)=>$6a2f274f0a5e2609$var$renderVariantButton(variant, selectedVariant, setSelectedVariant))
            })
        ]
    });
};
var $6a2f274f0a5e2609$export$2e2bcd8739ae039 = $6a2f274f0a5e2609$var$ExperimentOverrideControls;

});


parcelRegister("3VYCw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b2cb92c2df40e8d$export$2e2bcd8739ae039; });
/* feature-gate.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $Fp3mL = parcelRequire("Fp3mL");

var $9rnwe = parcelRequire("9rnwe");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5oDng = parcelRequire("5oDng");
const $9b2cb92c2df40e8d$var$WRAPPER_STYLES = null;
const $9b2cb92c2df40e8d$var$UniformFeatureGate = (props)=>{
    const { featureGateId: featureGateId, override: override } = props;
    const context = (0, $9rnwe.useWAEContextSafe)();
    const isProduction = context?.wacEnvironment === "production";
    const featureGate = Object.entries((0, $ai3ZP.featureFlags)).find(([, value])=>value.featureFlagName === featureGateId)?.[1];
    const [manualOverride, setManualOverride] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        setManualOverride(null);
    }, [
        featureGateId
    ]);
    if (!isProduction) {
        const activeVariant = (()=>{
            if (manualOverride) return manualOverride;
            if (override) return override;
            if (featureGate) return (0, $cN0Nw.checkFeatureFlagGate)(featureGate) ? "treatment" : "control";
            return "control";
        })();
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5oDng.default), {
                    featureGateId: featureGateId,
                    selectedVariant: manualOverride,
                    setSelectedVariant: setManualOverride
                }),
                !featureGate && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Fp3mL.ManifestErrorMessage), {
                    id: featureGateId
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: activeVariant
                })
            ]
        });
    }
    if (!featureGate) return null;
    const showTreatment = (0, $cN0Nw.checkFeatureFlagGate)(featureGate);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $9b2cb92c2df40e8d$export$2e2bcd8739ae039 = $9b2cb92c2df40e8d$var$UniformFeatureGate;

});
parcelRegister("5oDng", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d53e3d0b3ec2075e$export$2e2bcd8739ae039; });
/* feature-gate-override-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $d53e3d0b3ec2075e$var$PANEL_STYLES = null;
const $d53e3d0b3ec2075e$var$PANEL_EXPANDED_STYLES = null;
const $d53e3d0b3ec2075e$var$META_STYLES = null;
const $d53e3d0b3ec2075e$var$FEATURE_GATE_ID_STYLES = null;
const $d53e3d0b3ec2075e$var$BUTTON_CLUSTER_STYLES = null;
const $d53e3d0b3ec2075e$var$BUTTON_CLUSTER_COLLAPSED_STYLES = null;
const $d53e3d0b3ec2075e$var$BUTTON_CLUSTER_EXPANDED_STYLES = null;
const $d53e3d0b3ec2075e$var$VARIANT_BUTTON_STYLES = null;
const $d53e3d0b3ec2075e$var$SELECTED_VARIANT_BUTTON_STYLES = null;
const $d53e3d0b3ec2075e$var$UNSELECTED_VARIANT_BUTTON_STYLES = null;
const $d53e3d0b3ec2075e$var$getDisplayedFeatureGateLabel = (featureGateId, isExpanded)=>{
    if (!featureGateId) return "";
    if (isExpanded) return featureGateId;
    return featureGateId.length > 14 ? `${featureGateId.slice(0, 14)}\u{2026}` : featureGateId;
};
const $d53e3d0b3ec2075e$var$getVariantButtonText = (variant)=>variant === "control" ? "Control" : "Treatment";
const $d53e3d0b3ec2075e$var$getVariantButtonAriaLabel = (variant)=>variant === "control" ? "Show control (Gate off)" : "Show treatment (Gate on)";
const $d53e3d0b3ec2075e$var$getVariantDescription = (variant)=>variant === "control" ? "Gate off" : "Gate on";
const $d53e3d0b3ec2075e$var$VARIANTS = [
    "control",
    "treatment"
];
const $d53e3d0b3ec2075e$var$renderVariantButton = (variant, selectedVariant, setSelectedVariant)=>{
    const isSelected = selectedVariant === variant;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        "aria-pressed": isSelected,
        "aria-label": $d53e3d0b3ec2075e$var$getVariantButtonAriaLabel(variant),
        title: $d53e3d0b3ec2075e$var$getVariantDescription(variant),
        onClick: ()=>setSelectedVariant(isSelected ? null : variant),
        className: (0, $2jatx.default)([
            "_19itidpf _2rkow7q6 _1ul91oqx _1yt41ppf _1wyb19bv _vwz4cjiy _80omtlke _k48p1fw0 _v564t6js _1llw1qs1 _1ygb7g83 _1ah3yh40",
            isSelected ? "_syazi7uo _bfhkvuon" : "_syaz15cr _bfhk1j28 _tzy4q80t"
        ]),
        children: $d53e3d0b3ec2075e$var$getVariantButtonText(variant)
    }, variant);
};
const $d53e3d0b3ec2075e$var$FeatureGateOverrideControls = ({ featureGateId: featureGateId, selectedVariant: selectedVariant, setSelectedVariant: setSelectedVariant })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const handleActivate = ()=>{
        setIsExpanded(true);
    };
    const handleDeactivate = ()=>{
        setIsExpanded(false);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "feature-gate-controls",
        onMouseEnter: handleActivate,
        onMouseLeave: handleDeactivate,
        onFocus: handleActivate,
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) handleDeactivate();
        },
        className: (0, $2jatx.default)([
            "_kqswstnw _152t1b66 _rjxp1b66 _1pbyrpof _1e0c116y _4cvr1h6o _1bahesu3 _gy1p1b66 _syaz15cr _19itidpf _16qs130s _8hrz11aj _2rko7vkz _p12f163w _1yt4u49m _bfhk1tj6 _18k91p0y _tzy4x7ai _1reo15vq _18m915vq _v5641pcj",
            isExpanded && "_1pby14ny _p12fsb0t _1yt412x7 _bfhk1tj6 _18k91m5u _tzy4kb7n"
        ]),
        style: {
            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _1ul9idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _ae4v1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    title: `Feature Gate ID: ${featureGateId}`,
                    className: (0, $2jatx.default)([
                        "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wyb1skh _vwz4cjiy _k48p1fw0 _1ul9idpf _p12f1osq"
                    ]),
                    children: $d53e3d0b3ec2075e$var$getDisplayedFeatureGateLabel(featureGateId, isExpanded)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "group",
                "aria-label": "Feature gate override",
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _gy1pv77o _1yt4v77o _2rkow7q6 _1o9zidpf _v564ke4q",
                    isExpanded ? "_bfhk1s03" : "_bfhk1s03"
                ]),
                style: {
                    "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800"))
                },
                children: $d53e3d0b3ec2075e$var$VARIANTS.map((variant)=>$d53e3d0b3ec2075e$var$renderVariantButton(variant, selectedVariant, setSelectedVariant))
            })
        ]
    });
};
var $d53e3d0b3ec2075e$export$2e2bcd8739ae039 = $d53e3d0b3ec2075e$var$FeatureGateOverrideControls;

});


parcelRegister("g0xMT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ff1fa21ab21004e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $anFhN = parcelRequire("anFhN");

var $lTkkF = parcelRequire("lTkkF");
const $3ff1fa21ab21004e$var$UniformFeaturesHighlight = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $anFhN.FeaturesHighlight), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkText: props.linkText,
        linkHref: props.linkHref,
        feature1Eyebrow: props.feature1Eyebrow,
        feature1Title: props.feature1Title,
        feature1Body: props.feature1RichText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature1RichText
        }) : props.feature1Body,
        feature1ImageSrc: props.feature1ImageSrc,
        feature1ImageAltText: props.feature1ImageAltText,
        feature2Eyebrow: props.feature2Eyebrow,
        feature2Title: props.feature2Title,
        feature2Body: props.feature2RichText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature2RichText
        }) : props.feature2Body,
        feature2ImageSrc: props.feature2ImageSrc,
        feature2ImageAltText: props.feature2ImageAltText,
        feature3Eyebrow: props.feature3Eyebrow,
        feature3Title: props.feature3Title,
        feature3Body: props.feature3RichText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.feature3RichText
        }) : props.feature3Body,
        feature3ImageSrc: props.feature3ImageSrc,
        feature3ImageAltText: props.feature3ImageAltText
    });
};
var $3ff1fa21ab21004e$export$2e2bcd8739ae039 = $3ff1fa21ab21004e$var$UniformFeaturesHighlight;

});
parcelRegister("anFhN", function(module, exports) {
$parcel$export(module.exports, "FeaturesHighlight", function () { return $00c15acb18b151d4$export$bf20c48d528647dd; });
/* features-highlight.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $ggSCt = parcelRequire("ggSCt");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $2axoc = parcelRequire("2axoc");

var $iPPTB = parcelRequire("iPPTB");

var $lE15B = parcelRequire("lE15B");

var $kbpa7 = parcelRequire("kbpa7");
const $00c15acb18b151d4$export$bf20c48d528647dd = (props)=>{
    const [activeFeature, setActiveFeature] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const onFeatureSelect = (0, $1oC0p.useCallback)((featureKey)=>{
        setActiveFeature(featureKey);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "tab",
            actionSubjectId: "featuresHighlightTab",
            source: "featuresHighlight",
            attributes: {
                label: `feature ${featureKey + 1}`,
                tabIndex: featureKey
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const singleFeature = (content, featureKey)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            onClick: ()=>onFeatureSelect(featureKey),
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onFeatureSelect(featureKey);
                }
            },
            className: (0, $2jatx.default)([
                "_80omtlke _kqswh2mm _u5ggpxbi _11xx17la _uoz5x71z _suga1ule _1ah31y44",
                `feature ${activeFeature === featureKey ? "selected" : ""}`
            ]),
            role: "tab",
            tabIndex: 0,
            style: {
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
            },
            children: [
                activeFeature === featureKey && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1pbykb7n _bfhk17la _2rko1y44 _1bsb1osq _4t3iftgi _165t1osq _glteftgi"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_owpupxbi _6ssjpxbi"
                    ]),
                    children: content
                })
            ]
        });
    const feature1Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: props.feature1Title,
        titleAs: "h3",
        text: props.feature1Body,
        eyebrow: props.feature1Eyebrow,
        alignment: "start"
    });
    const feature1Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: props.feature1ImageSrc,
            alt: props.feature1ImageAltText ?? "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature1Video = props.feature1VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature1VideoSrc,
        poster: props.feature1VideoPoster,
        alt: props.feature1VideoAltText ?? ""
    }, "feature1-video") : null;
    const feature2Video = props.feature2VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature2VideoSrc,
        poster: props.feature2VideoPoster,
        alt: props.feature2VideoAltText ?? ""
    }, "feature2-video") : null;
    const feature3Video = props.feature3VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature3VideoSrc,
        poster: props.feature3VideoPoster,
        alt: props.feature3VideoAltText ?? ""
    }, "feature3-video") : null;
    const feature2Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: props.feature2Title,
        titleAs: "h3",
        text: props.feature2Body,
        eyebrow: props.feature2Eyebrow,
        alignment: "start"
    });
    const feature2Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: props.feature2ImageSrc,
            alt: props.feature2ImageAltText ?? "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature3Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
        title: props.feature3Title,
        titleAs: "h3",
        text: props.feature3Body,
        eyebrow: props.feature3Eyebrow,
        alignment: "start"
    });
    const feature3Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: props.feature3ImageSrc,
            alt: props.feature3ImageAltText ?? "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const featureTexts = [
        feature1Text,
        feature2Text,
        props.feature3Title && feature3Text
    ];
    const content = [
        props.feature1ImageSrc ? feature1Image : feature1Video,
        props.feature2ImageSrc ? feature2Image : feature2Video,
        props.feature3Title && props.feature3ImageSrc ? feature3Image : feature3Video
    ];
    const sectionContainerStyles = null;
    const topContentContainerStyles = null;
    const featuresContainerStyles = null;
    const imageContainerStyles = null;
    const navDotsContainerStyles = null;
    const navDot = (featureNum)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsbftgi _4t3iftgi _2rko1y44 _bfhk1cls"
            ]),
            style: {
                "--_1lhuu6n": (0, $6ZVlx.default)(featureNum === activeFeature ? (0, $kbpa7.wacToken)("color.primary.black") : (0, $kbpa7.wacToken)("color.neutral.light500"))
            }
        });
    };
    const navDotsContainer = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulppxbi _1bah1h6o _1q51pxbi"
            ]),
            children: featureTexts.map((_, index)=>navDot(index))
        });
    const mobileCarouselContainerStyles = null;
    const sliderSettings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current)=>setActiveFeature(current),
        appendDots: navDotsContainer
    };
    const featureSlideStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_15fl1wug _1d2w1wug _1svy1wug _seov1wug _16imoahv _b8yq1osq _14b51osq _su071wqb _1j8bcx6w _181n11p5 _dwk3usvi _19wg14hz _11mz1tcg _owpu1wqb _10jxzqdx _1vsw1vi7 _suga1txw _1gde1bp4 _1rfm1osq _tnru1osq _8164pxbi _133i1jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1rfm1osq _xlt11ejb _s51szwfg _uoz5179g _1e3ceqnf _1e0c1txw _2lx21bp4 _zulpu2gc _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                        title: props.title,
                        titleAs: "h2",
                        text: props.description,
                        alignment: "center"
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: props.linkText,
                        href: props.linkHref,
                        "aria-label": props.linkText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tablist",
                className: (0, $2jatx.default)([
                    "_1e3cx71z _dm251txw _1ini1bp4 _kzvi1bgi _1e0cglyw"
                ]),
                children: featureTexts.map((feature, index)=>singleFeature(feature, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tabpanel",
                className: (0, $2jatx.default)([
                    "_1e3cthi2 _165t1osq _uoz5uufb _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: content[activeFeature]
                }, activeFeature)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule",
                    "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw",
                    "slider-container"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), {
                    ...sliderSettings,
                    children: featureTexts.map((feature, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_18zrzwfg _1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                singleFeature(feature, index),
                                content[index]
                            ]
                        }, index))
                })
            })
        ]
    });
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $00c15acb18b151d4$var$slickStyle = null;

});


parcelRegister("76Hra", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9017bbe137d60f3e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $7sd2h = parcelRequire("7sd2h");

var $17RBn = parcelRequire("17RBn");

var $9rnwe = parcelRequire("9rnwe");

var $k1kqo = parcelRequire("k1kqo");
const $9017bbe137d60f3e$var$PATH_PREFIX = "$:";
const $9017bbe137d60f3e$var$resolveValue = (raw, itemData)=>{
    if (typeof raw !== "string") return raw;
    if (!raw.startsWith($9017bbe137d60f3e$var$PATH_PREFIX)) return raw;
    const path = raw.slice($9017bbe137d60f3e$var$PATH_PREFIX.length);
    return $9017bbe137d60f3e$var$getByPath(itemData, path);
};
const $9017bbe137d60f3e$var$DEFAULT_LOCALE = "en";
const $9017bbe137d60f3e$var$isAbsoluteUrl = (value)=>/^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(value);
const $9017bbe137d60f3e$var$isAlreadyLocalized = (value, locale)=>value === `/${locale}` || value.startsWith(`/${locale}/`);
const $9017bbe137d60f3e$var$withLocalePrefix = (value, locale)=>{
    if (typeof value !== "string" || value.length === 0) return value;
    if (!locale || locale === $9017bbe137d60f3e$var$DEFAULT_LOCALE) return value;
    if ($9017bbe137d60f3e$var$isAbsoluteUrl(value)) return value;
    if ($9017bbe137d60f3e$var$isAlreadyLocalized(value, locale)) return value;
    const path = value.startsWith("/") ? value : `/${value}`;
    return `/${locale}${path}`;
};
const $9017bbe137d60f3e$var$getByPath = (obj, path)=>{
    if (obj === null || obj === undefined) return undefined;
    return path.split(".").reduce((acc, key)=>acc !== null && acc !== undefined && typeof acc === "object" ? acc[key] : undefined, obj);
};
const $9017bbe137d60f3e$var$FilterableCard = (rawProps)=>{
    const itemData = (0, $1oC0p.useContext)((0, $7sd2h.FilterableCardItemDataContext));
    const intlLocale = (0, $17RBn.useLocale)();
    const { locale: contextLocale } = (0, $9rnwe.useWAEContext)();
    const activeLocale = contextLocale ?? intlLocale;
    const resolvedTitle = $9017bbe137d60f3e$var$resolveValue(rawProps.title, itemData);
    const resolved = {
        alignment: $9017bbe137d60f3e$var$resolveValue(rawProps.alignment, itemData),
        orientation: $9017bbe137d60f3e$var$resolveValue(rawProps.orientation, itemData),
        columns: $9017bbe137d60f3e$var$resolveValue(rawProps.columns, itemData),
        background: $9017bbe137d60f3e$var$resolveValue(rawProps.background, itemData),
        eyebrow: $9017bbe137d60f3e$var$resolveValue(rawProps.eyebrow, itemData),
        logo: $9017bbe137d60f3e$var$resolveValue(rawProps.logo, itemData),
        title: resolvedTitle,
        titleAs: $9017bbe137d60f3e$var$resolveValue(rawProps.titleAs, itemData),
        // Per-template attribution for the gallery card CTA click event.
        // An explicit dataLabel (incl. a "$:" binding) wins; otherwise fall
        // back to the resolved template title.
        dataLabel: $9017bbe137d60f3e$var$resolveValue(rawProps.dataLabel, itemData) ?? resolvedTitle,
        dataLabelEnglish: $9017bbe137d60f3e$var$resolveValue(rawProps.dataLabelEnglish, itemData),
        body: $9017bbe137d60f3e$var$resolveValue(rawProps.body, itemData),
        richText: $9017bbe137d60f3e$var$resolveValue(rawProps.richText, itemData),
        linkText: $9017bbe137d60f3e$var$resolveValue(rawProps.linkText, itemData),
        linkUrl: $9017bbe137d60f3e$var$withLocalePrefix($9017bbe137d60f3e$var$resolveValue(rawProps.linkUrl, itemData), activeLocale),
        imageUrl: $9017bbe137d60f3e$var$resolveValue(rawProps.imageUrl, itemData),
        imageAlt: $9017bbe137d60f3e$var$resolveValue(rawProps.imageAlt, itemData),
        iconUrl: $9017bbe137d60f3e$var$resolveValue(rawProps.iconUrl, itemData),
        iconSize: $9017bbe137d60f3e$var$resolveValue(rawProps.iconSize, itemData),
        iconPaddingIncluded: $9017bbe137d60f3e$var$resolveValue(rawProps.iconPaddingIncluded, itemData),
        spotIllustrationUrl: $9017bbe137d60f3e$var$resolveValue(rawProps.spotIllustrationUrl, itemData),
        spotIllustrationAlt: $9017bbe137d60f3e$var$resolveValue(rawProps.spotIllustrationAlt, itemData),
        spotIllustrationWidth: $9017bbe137d60f3e$var$resolveValue(rawProps.spotIllustrationWidth, itemData)
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k1kqo.default), {
        ...resolved
    });
};
var $9017bbe137d60f3e$export$2e2bcd8739ae039 = $9017bbe137d60f3e$var$FilterableCard;

});
parcelRegister("7sd2h", function(module, exports) {
$parcel$export(module.exports, "FilterableCardItemDataContext", function () { return $718a58a0cf5379a0$export$b57146c2dbbd8dd6; });

var $1oC0p = parcelRequire("1oC0p");
const $718a58a0cf5379a0$export$b57146c2dbbd8dd6 = (0, $1oC0p.createContext)(undefined);

});


parcelRegister("89oar", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3fddb102737e1f1a$export$2e2bcd8739ae039; });
/* filterable-gallery.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $01zo5 = parcelRequire("01zo5");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $7sd2h = parcelRequire("7sd2h");

var $6f8Au = parcelRequire("6f8Au");

var $foNCS = parcelRequire("foNCS");

var $lG1Of = parcelRequire("lG1Of");

var $9BG80 = parcelRequire("9BG80");

var $bQjAr = parcelRequire("bQjAr");

var $eUwCn = parcelRequire("eUwCn");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $f4mYE = parcelRequire("f4mYE");

var $jh5WI = parcelRequire("jh5WI");

var $eAngy = parcelRequire("eAngy");

var $iPbWG = parcelRequire("iPbWG");

var $ddUw7 = parcelRequire("ddUw7");

var $H7SCD = parcelRequire("H7SCD");
const $3fddb102737e1f1a$var$messages = (0, $fnHPc.defineMessages)({
    emptyState: {
        id: "filterable-gallery.empty-state",
        defaultMessage: "No results found."
    },
    loadMore: {
        id: "filterable-gallery.load-more",
        defaultMessage: "Load more"
    }
});
const $3fddb102737e1f1a$var$FilterableGallerySlot = ({ items: items, itemDataArrayRef: itemDataArrayRef, searchConfiguration: searchConfiguration, showSearchInput: showSearchInput = true, displayLimit: rawDisplayLimit, rawFilters: rawFilters, rawSorts: rawSorts, urlSync: urlSync, layout: layout, rawFacetDataSources: rawFacetDataSources, pageSize: pageSize, dataItems: dataItems, featuredItemSlugs: featuredItemSlugs, loadMoreLabel: loadMoreLabel, emptyStateLabel: emptyStateLabel })=>{
    const intl = (0, $8e22h.default)();
    const [displayLimitOverrideQuery, setDisplayLimitOverrideQuery] = (0, $1oC0p.useState)();
    const { extraItems: extraItems, isAwaitingBackfill: isAwaitingBackfill } = $3fddb102737e1f1a$var$useFilterableBackfillState();
    const [visibleCount, setVisibleCount] = (0, $1oC0p.useState)(()=>$3fddb102737e1f1a$var$resolveInitialVisibleCount(pageSize, dataItems?.length));
    const registeredItems = itemDataArrayRef.current;
    const itemDataArray = (0, $1oC0p.useMemo)(()=>{
        if (dataItems && dataItems.length > 0) {
            const seenIds = new Set();
            return [
                ...dataItems,
                ...extraItems
            ].filter((item)=>{
                const id = $3fddb102737e1f1a$var$getSysId(item);
                if (!id) return true;
                if (seenIds.has(id)) return false;
                seenIds.add(id);
                return true;
            });
        }
        if (extraItems.length === 0) return registeredItems;
        const seenIds = new Set();
        for (const item of registeredItems){
            const id = $3fddb102737e1f1a$var$getSysId(item);
            if (id) seenIds.add(id);
        }
        const newExtras = extraItems.filter((item)=>{
            const id = $3fddb102737e1f1a$var$getSysId(item);
            return id ? !seenIds.has(id) : true;
        });
        return [
            ...registeredItems,
            ...newExtras
        ];
    }, [
        registeredItems,
        extraItems,
        dataItems
    ]);
    // Publish to the search bar so it searches the identical items + config.
    $3fddb102737e1f1a$var$usePublishGalleryConfig(itemDataArray, searchConfiguration, featuredItemSlugs);
    const canSearch = $3fddb102737e1f1a$var$hasSearchKeys(searchConfiguration);
    const shouldShowSearchInput = $3fddb102737e1f1a$var$resolveBooleanParameter(showSearchInput, true);
    const displayLimit = $3fddb102737e1f1a$var$resolvePositiveIntegerParameter(rawDisplayLimit);
    const skeletonCardCount = $3fddb102737e1f1a$var$resolveSkeletonCardCount(displayLimit, dataItems?.length ?? items.length);
    const filterDefs = (0, $1oC0p.useMemo)(()=>{
        if (!rawFilters) return [];
        const flat = (0, $f2QWG.flattenValues)(rawFilters);
        return Array.isArray(flat) ? flat : [];
    }, [
        rawFilters
    ]);
    const sortDefs = (0, $1oC0p.useMemo)(()=>{
        if (!rawSorts) return [];
        const flat = (0, $f2QWG.flattenValues)(rawSorts);
        return Array.isArray(flat) ? flat : [];
    }, [
        rawSorts
    ]);
    const optionsDataSources = (0, $1oC0p.useMemo)(()=>{
        if (!rawFacetDataSources) return {};
        const rawEntries = $3fddb102737e1f1a$var$getUniformBlockEntries(rawFacetDataSources);
        if (rawEntries.length === 0) return {};
        return Object.fromEntries(rawEntries.flatMap((entry)=>{
            const sourceId = entry.fields?.sourceId?.value;
            const data = entry.fields?.data?.value;
            if (typeof sourceId !== "string" || !Array.isArray(data)) return [];
            return [
                [
                    sourceId,
                    data
                ]
            ];
        }));
    }, [
        rawFacetDataSources
    ]);
    const { filterObject: filterObject, searchQuery: searchQuery, selectedSortId: selectedSortId, dropdownVisibility: dropdownVisibility, isAnyDropdownOpen: isAnyDropdownOpen, setSearchQuery: setSearchQuery, handleFilterButtonClick: handleFilterButtonClick, toggleFilterOption: toggleFilterOption, clearAllFilters: clearAllFilters, handleSearchSubmit: handleSearchSubmit, handleSearchClear: handleSearchClear, handleSortChange: handleSortChange, closeAllDropdownsAndCommit: closeAllDropdownsAndCommit } = (0, $iPbWG.useFilterState)({
        items: itemDataArray,
        filterDefs: filterDefs,
        urlSync: urlSync,
        optionsDataSources: optionsDataSources
    });
    const showAllSearchResults = (0, $1oC0p.useCallback)((query)=>{
        const trimmedQuery = query.trim();
        setDisplayLimitOverrideQuery(trimmedQuery);
        setVisibleCount(Infinity);
    }, []);
    const handleSearchSubmitAndShowAll = (0, $1oC0p.useCallback)(()=>{
        handleSearchSubmit();
        showAllSearchResults(searchQuery);
    }, [
        handleSearchSubmit,
        searchQuery,
        showAllSearchResults
    ]);
    (0, $1oC0p.useEffect)(()=>(0, $f4mYE.subscribeToShowAllFilterableGalleryItems)(({ query: query })=>{
            setSearchQuery(query);
            showAllSearchResults(query);
        }), [
        setSearchQuery,
        showAllSearchResults
    ]);
    const trimmedSearchQuery = searchQuery.trim();
    const shouldShowAllSearchResults = trimmedSearchQuery.length > 0 && displayLimitOverrideQuery === trimmedSearchQuery;
    (0, $1oC0p.useEffect)(()=>{
        if (shouldShowAllSearchResults) {
            setVisibleCount(Infinity);
            return;
        }
        if (pageSize !== undefined) {
            setVisibleCount(pageSize);
            return;
        }
        if (dataItems !== undefined) setVisibleCount(dataItems.length);
    }, [
        filterObject,
        searchQuery,
        pageSize,
        dataItems,
        shouldShowAllSearchResults
    ]);
    const sortedMatchingDataItems = (0, $1oC0p.useMemo)(()=>{
        const filtered = (0, $H7SCD.applyFilters)(itemDataArray, filterDefs, filterObject);
        const selectedSort = sortDefs.find((sort)=>sort.id === selectedSortId);
        // An explicit sort wins; otherwise relevance + featured boost.
        return selectedSort ? (0, $H7SCD.applySort)((0, $H7SCD.applySearch)(filtered, searchQuery, searchConfiguration), selectedSort) : (0, $H7SCD.searchWithFeaturedBoost)(filtered, searchQuery, searchConfiguration, featuredItemSlugs);
    }, [
        itemDataArray,
        filterDefs,
        filterObject,
        searchConfiguration,
        searchQuery,
        sortDefs,
        selectedSortId,
        featuredItemSlugs
    ]);
    const shouldApplyDisplayLimit = $3fddb102737e1f1a$var$getShouldApplyDisplayLimit(displayLimit, shouldShowAllSearchResults);
    const usesVisibleCount = $3fddb102737e1f1a$var$getUsesVisibleCount(pageSize, dataItems);
    const effectiveVisibleCount = usesVisibleCount ? visibleCount : undefined;
    const visibleDataItems = (0, $1oC0p.useMemo)(()=>effectiveVisibleCount !== undefined ? sortedMatchingDataItems.slice(0, effectiveVisibleCount) : shouldApplyDisplayLimit ? sortedMatchingDataItems.slice(0, displayLimit) : sortedMatchingDataItems, [
        effectiveVisibleCount,
        displayLimit,
        shouldApplyDisplayLimit,
        sortedMatchingDataItems
    ]);
    const hasMoreToShow = effectiveVisibleCount !== undefined && visibleCount < sortedMatchingDataItems.length;
    const visibleIndices = (0, $1oC0p.useMemo)(()=>$3fddb102737e1f1a$var$getOrderedIndicesForDataItems(itemDataArray, visibleDataItems), [
        itemDataArray,
        visibleDataItems
    ]);
    const visibleIndexSet = (0, $1oC0p.useMemo)(()=>new Set(visibleIndices), [
        visibleIndices
    ]);
    const labelMaps = (0, $1oC0p.useMemo)(()=>(0, $H7SCD.buildLabelMaps)(itemDataArray, filterDefs, optionsDataSources), [
        itemDataArray,
        filterDefs,
        optionsDataSources
    ]);
    (0, $ddUw7.useOutsideClick)({
        isActive: isAnyDropdownOpen,
        insideMarkerAttribute: (0, $jh5WI.FILTER_DROPDOWN_DATA_ATTR),
        onOutsideClick: closeAllDropdownsAndCommit
    });
    const isRegistered = itemDataArray.length > 0;
    const allSlotItems = (0, $1oC0p.useMemo)(()=>{
        const slotChildren = items;
        const cardTemplate = slotChildren.find((0, $1oC0p.isValidElement));
        if (!cardTemplate) return slotChildren;
        if (dataItems && dataItems.length > 0) return itemDataArray.map((itemData, offset)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7sd2h.FilterableCardItemDataContext).Provider, {
                value: itemData,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1e0c11p5"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(cardTemplate, {
                        key: `data-card-${offset}`
                    })
                })
            }, `data-item-${offset}`));
        const backfilledItems = itemDataArray.slice(registeredItems.length);
        if (backfilledItems.length === 0) return slotChildren;
        const backfillItems = backfilledItems.map((data, offset)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7sd2h.FilterableCardItemDataContext).Provider, {
                value: data,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1e0c11p5"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(cardTemplate, {
                        key: `backfill-card-${offset}`
                    })
                })
            }, `backfill-${offset}`));
        return [
            ...slotChildren,
            ...backfillItems
        ];
    }, [
        items,
        dataItems,
        itemDataArray
    ]);
    const isDataDrivenMode = dataItems !== undefined;
    const orderedItems = (0, $1oC0p.useMemo)(()=>{
        const slotItems = allSlotItems;
        if (!isRegistered) {
            if (isDataDrivenMode) return [];
            return slotItems.map((item, index)=>({
                    index: index,
                    item: item,
                    visible: true
                }));
        }
        const visible = visibleIndices.map((index)=>({
                index: index,
                item: slotItems[index],
                visible: true
            }));
        const hidden = slotItems.map((item, index)=>({
                index: index,
                item: item,
                visible: false
            })).filter(({ index: index })=>!visibleIndexSet.has(index));
        return [
            ...visible,
            ...hidden
        ];
    }, [
        isRegistered,
        isDataDrivenMode,
        allSlotItems,
        visibleIndices,
        visibleIndexSet
    ]);
    const shouldRenderCards = !isAwaitingBackfill;
    const renderedItems = (0, $1oC0p.useMemo)(()=>shouldRenderCards ? orderedItems : [], [
        orderedItems,
        shouldRenderCards
    ]);
    const measurementItems = (0, $1oC0p.useMemo)(()=>orderedItems.filter(({ visible: visible })=>visible), [
        orderedItems
    ]);
    const { measuredSkeletonHeight: measuredSkeletonHeight, isSkeletonMeasurementReady: isSkeletonMeasurementReady, measurementItemRefs: measurementItemRefs } = $3fddb102737e1f1a$var$useMeasuredSkeletonHeight({
        shouldRenderCards: shouldRenderCards,
        measurementItems: measurementItems
    });
    const animatedVisibleIndices = $3fddb102737e1f1a$var$useAnimatedVisibleIndices(shouldRenderCards, visibleIndices);
    const filteredItems = (0, $1oC0p.useMemo)(()=>renderedItems.filter(({ visible: visible })=>visible).map(({ item: item })=>item), [
        renderedItems
    ]);
    const handleLoadMoreClick = (0, $1oC0p.useCallback)(()=>{
        setVisibleCount((previousVisibleCount)=>$3fddb102737e1f1a$var$getNextVisibleCount(previousVisibleCount, pageSize));
    }, [
        pageSize
    ]);
    const loadMoreText = loadMoreLabel ?? intl.formatMessage($3fddb102737e1f1a$var$messages.loadMore);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eAngy.Toolbar), {
                    filterDefs: filterDefs,
                    sortDefs: sortDefs,
                    canSearch: canSearch,
                    showSearchInput: shouldShowSearchInput,
                    filterObject: filterObject,
                    searchQuery: searchQuery,
                    selectedSortId: selectedSortId,
                    dropdownVisibility: dropdownVisibility,
                    labelMaps: labelMaps,
                    onSearchChange: setSearchQuery,
                    onSearchSubmit: handleSearchSubmitAndShowAll,
                    onSearchClear: handleSearchClear,
                    onFilterButtonClick: handleFilterButtonClick,
                    onOptionToggle: toggleFilterOption,
                    onClearAllFilters: clearAllFilters,
                    onSortChange: handleSortChange
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6f8Au.FilterableGalleryProvider), {
                items: items,
                filteredItems: filteredItems,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhxy5q _1wbphkll"
                    ]),
                    children: [
                        isRegistered && sortedMatchingDataItems.length === 0 && itemDataArray.length > 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            "data-testid": "filterable-gallery-empty",
                            className: (0, $2jatx.default)([
                                "_1yt4pxbi _syaz1rpy _zg8l1m30 _y3gn1h6o"
                            ]),
                            children: emptyStateLabel
                        }) : null,
                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                            layout: layout,
                            renderAsList: "ul",
                            children: [
                                !shouldRenderCards && isSkeletonMeasurementReady ? /*#__PURE__*/ (0, $7VQPk.jsx)($3fddb102737e1f1a$var$FilterableGallerySkeletonCards, {
                                    count: skeletonCardCount,
                                    height: measuredSkeletonHeight
                                }) : null,
                                renderedItems.map(({ index: index, item: item, visible: visible }, renderIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lG1Of.FilterableItemIndexContext).Provider, {
                                        value: index,
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                            hidden: visible ? undefined : true,
                                            style: visible ? $3fddb102737e1f1a$var$getCardEntranceStyle($3fddb102737e1f1a$var$getCardEntranceDelayIndex(renderIndex)) : undefined,
                                            "data-testid": visible ? "filterable-gallery-item" : undefined,
                                            className: (0, $2jatx.default)([
                                                "_q32d11p5 _8wqw1osq _xqg4glyw",
                                                visible && "_tzy4idpf _t9ec13hh _v564p5ws _m602kb7n _qp04161g _sedtglyw",
                                                visible && animatedVisibleIndices.has(index) && "_tzy4kb7n _t9ec161g"
                                            ]),
                                            children: item
                                        })
                                    }, index))
                            ]
                        }),
                        !shouldRenderCards ? /*#__PURE__*/ (0, $7VQPk.jsx)($3fddb102737e1f1a$var$MeasuredGalleryItems, {
                            items: measurementItems,
                            refs: measurementItemRefs,
                            layout: layout
                        }) : null,
                        hasMoreToShow && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o _1rjcxy5q"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                type: "button",
                                "data-testid": "load-more-button",
                                onClick: handleLoadMoreClick,
                                "data-event": "clicked",
                                "data-event-component": "button",
                                "data-event-container": "searchWithFilters",
                                "data-label": loadMoreText,
                                "data-label-english": "Load more",
                                className: (0, $2jatx.default)([
                                    "_r06hglyw _11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _4cvr1h6o _zulp1b66"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_4t3i1tcg _1bsb1tcg _1e0c116y _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                            label: "",
                                            spacing: "spacious"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfht94y _y3gn1e5h",
                                                "body-sm"
                                            ]),
                                            children: loadMoreText
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $3fddb102737e1f1a$var$UniformFilterableGallery = ({ searchConfiguration: searchConfiguration, showSearchInput: showSearchInput = true, displayLimit: displayLimit, filters: rawFilters, sorts: rawSorts, urlSync: urlSync = true, layout: layout = "4-4-4", facetDataSources: rawFacetDataSources, pageSize: rawPageSize, data: data, featuredItemSlugs: rawFeaturedItemSlugs, loadMoreLabel: loadMoreLabel, emptyStateLabel: emptyStateLabel })=>{
    const intl = (0, $8e22h.default)();
    // CMS-provided label wins (localized on the Uniform side); otherwise fall
    // back to the localized default for the active page locale.
    const resolvedEmptyStateLabel = emptyStateLabel ?? intl.formatMessage($3fddb102737e1f1a$var$messages.emptyState);
    const resolvedLoadMoreLabel = loadMoreLabel ?? intl.formatMessage($3fddb102737e1f1a$var$messages.loadMore);
    const itemDataArrayRef = (0, $1oC0p.useRef)([]);
    const [, setDataVersion] = (0, $1oC0p.useState)(0);
    const insideContainer = (0, $foNCS.useIsInsideLoaderProvider)();
    const pageSize = $3fddb102737e1f1a$var$resolvePositiveIntegerParameter(rawPageSize);
    const featuredItemSlugs = (0, $1oC0p.useMemo)(()=>$3fddb102737e1f1a$var$resolveFeaturedSlugs(rawFeaturedItemSlugs), [
        rawFeaturedItemSlugs
    ]);
    const handleRegistryChange = (0, $1oC0p.useCallback)((data)=>{
        const previousData = itemDataArrayRef.current;
        if (data.length !== previousData.length || data.some((item, index)=>item !== previousData[index])) {
            itemDataArrayRef.current = data;
            setDataVersion((v)=>v + 1);
        }
    }, []);
    const wrapperComponent = (0, $1oC0p.useCallback)((slotProps)=>/*#__PURE__*/ (0, $7VQPk.jsx)($3fddb102737e1f1a$var$FilterableGallerySlot, {
            ...slotProps,
            itemDataArrayRef: itemDataArrayRef,
            searchConfiguration: searchConfiguration,
            showSearchInput: showSearchInput,
            displayLimit: displayLimit,
            rawFilters: rawFilters,
            rawSorts: rawSorts,
            urlSync: urlSync,
            layout: layout,
            rawFacetDataSources: rawFacetDataSources,
            pageSize: pageSize,
            dataItems: $3fddb102737e1f1a$var$toDataItems(data),
            featuredItemSlugs: featuredItemSlugs,
            loadMoreLabel: resolvedLoadMoreLabel,
            emptyStateLabel: resolvedEmptyStateLabel
        }), [
        searchConfiguration,
        showSearchInput,
        displayLimit,
        rawFilters,
        rawSorts,
        urlSync,
        layout,
        rawFacetDataSources,
        pageSize,
        data,
        featuredItemSlugs,
        resolvedLoadMoreLabel,
        resolvedEmptyStateLabel
    ]);
    const galleryContent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lG1Of.FilterableItemRegistryProvider), {
        onRegistryChange: handleRegistryChange,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "filterableItems",
            wrapperComponent: wrapperComponent
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "uniform-filters",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: insideContainer ? galleryContent : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $foNCS.FilterableGalleryLoaderProvider), {
                children: galleryContent
            })
        })
    });
};
const $3fddb102737e1f1a$var$hasSearchKeys = (searchConfiguration)=>(searchConfiguration?.keys.length ?? 0) > 0;
const $3fddb102737e1f1a$var$resolveBooleanParameter = (parameter, defaultValue)=>{
    if (typeof parameter === "boolean") return parameter;
    if (typeof parameter?.value === "boolean") return parameter.value;
    return defaultValue;
};
const $3fddb102737e1f1a$var$resolvePositiveIntegerParameter = (parameter)=>{
    const rawValue = typeof parameter === "object" && parameter !== null ? parameter.value : parameter;
    const value = typeof rawValue === "string" ? Number(rawValue) : rawValue;
    if (typeof value !== "number" || !Number.isFinite(value)) return undefined;
    const integerValue = Math.floor(value);
    return integerValue > 0 ? integerValue : undefined;
};
const $3fddb102737e1f1a$var$resolveFeaturedSlugs = (parameter)=>{
    const rawValue = $3fddb102737e1f1a$var$unwrapParameterValue(parameter);
    if (!Array.isArray(rawValue)) return [];
    return rawValue.map((0, $H7SCD.normalizeUrlSlug)).filter((slug)=>slug !== undefined);
};
const $3fddb102737e1f1a$var$getOrderedIndicesForDataItems = (sourceDataItems, orderedDataItems)=>{
    const indexMap = new Map();
    sourceDataItems.forEach((dataItem, index)=>{
        const indices = indexMap.get(dataItem) ?? [];
        indices.push(index);
        indexMap.set(dataItem, indices);
    });
    return orderedDataItems.flatMap((dataItem)=>{
        const indices = indexMap.get(dataItem);
        const index = indices?.shift();
        return index === undefined ? [] : [
            index
        ];
    });
};
const $3fddb102737e1f1a$var$SKELETON_CARD_MIN_HEIGHT = 360;
const $3fddb102737e1f1a$var$CARD_ENTRANCE_START_DELAY_MS = 100;
const $3fddb102737e1f1a$var$CARD_ENTRANCE_DELAY_SECONDS = 0.2;
const $3fddb102737e1f1a$var$MAX_CARD_ENTRANCE_DELAY_SECONDS = 1.2;
const $3fddb102737e1f1a$var$MAX_STAGGERED_CARD_COUNT = $3fddb102737e1f1a$var$MAX_CARD_ENTRANCE_DELAY_SECONDS / $3fddb102737e1f1a$var$CARD_ENTRANCE_DELAY_SECONDS + 1;
const $3fddb102737e1f1a$var$MeasuredGalleryItems = ({ items: items, refs: refs, layout: layout })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_4t3iidpf _1reo15vq _18m915vq _3um015vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: layout,
            renderAsList: "ul",
            children: items.map(({ index: index, item: item }, offset)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    ref: (element)=>{
                        refs.current[offset] = element;
                    },
                    className: (0, $2jatx.default)([
                        "_q32d11p5 _8wqw1osq _xqg4glyw"
                    ]),
                    children: item
                }, index))
        })
    });
const $3fddb102737e1f1a$var$FilterableGallerySkeletonCards = ({ count: count, height: height })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: Array.from({
            length: count
        }, (_, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                "data-testid": "filterable-gallery-skeleton-item",
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_q32d11p5 _8wqw1osq _xqg4glyw",
                    "_2mzuglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1e0c11p5"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4t3i1osq _1tke1gwv _1reo15vq _18m915vq _bfhkvuon _2rkovwyg _16qst7xp"
                        ]),
                        style: {
                            ...height ? {
                                minHeight: height
                            } : undefined,
                            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4t3i93m8 _1reo15vq _18m915vq"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                    width: "100%",
                                    height: "100%"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _zulppxbi _1yt41ejb"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                        width: "40%",
                                        height: "16px"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulpu2gc"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                                width: $3fddb102737e1f1a$var$getSkeletonLineWidth(index, 0),
                                                height: "24px"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                                width: $3fddb102737e1f1a$var$getSkeletonLineWidth(index, 1),
                                                height: "24px"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulp12x7 _6rth1wug"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                                width: "100%",
                                                height: "16px"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                                width: $3fddb102737e1f1a$var$getSkeletonLineWidth(index, 2),
                                                height: "16px"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                        width: "32%",
                                        height: "20px"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, index))
    });
const $3fddb102737e1f1a$var$useMeasuredSkeletonHeight = ({ shouldRenderCards: shouldRenderCards, measurementItems: measurementItems })=>{
    const [measuredSkeletonHeight, setMeasuredSkeletonHeight] = (0, $1oC0p.useState)();
    const [hasMeasuredSkeletonHeight, setHasMeasuredSkeletonHeight] = (0, $1oC0p.useState)(false);
    const measurementItemRefs = (0, $1oC0p.useRef)([]);
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (shouldRenderCards) {
            setMeasuredSkeletonHeight(undefined);
            setHasMeasuredSkeletonHeight(false);
            return;
        }
        const maxHeight = $3fddb102737e1f1a$var$getMaxElementHeight(measurementItemRefs.current);
        setMeasuredSkeletonHeight(maxHeight > $3fddb102737e1f1a$var$SKELETON_CARD_MIN_HEIGHT ? maxHeight : undefined);
        setHasMeasuredSkeletonHeight(true);
    }, [
        shouldRenderCards,
        measurementItems
    ]);
    return {
        measuredSkeletonHeight: measuredSkeletonHeight,
        isSkeletonMeasurementReady: shouldRenderCards || measurementItems.length === 0 || hasMeasuredSkeletonHeight,
        measurementItemRefs: measurementItemRefs
    };
};
const $3fddb102737e1f1a$var$useAnimatedVisibleIndices = (shouldRenderCards, visibleIndices)=>{
    const [animatedVisibleIndices, setAnimatedVisibleIndices] = (0, $1oC0p.useState)(()=>new Set());
    (0, $1oC0p.useEffect)(()=>{
        if (!shouldRenderCards) {
            setAnimatedVisibleIndices(new Set());
            return;
        }
        const timeoutId = window.setTimeout(()=>{
            setAnimatedVisibleIndices((previousIndices)=>{
                const nextIndices = new Set(previousIndices);
                visibleIndices.forEach((index)=>nextIndices.add(index));
                return nextIndices;
            });
        }, $3fddb102737e1f1a$var$CARD_ENTRANCE_START_DELAY_MS);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        shouldRenderCards,
        visibleIndices
    ]);
    return animatedVisibleIndices;
};
const $3fddb102737e1f1a$var$getSkeletonLineWidth = (index, offset)=>{
    const widths = [
        "82%",
        "64%",
        "92%",
        "56%",
        "74%"
    ];
    return widths[(index + offset) % widths.length] ?? "72%";
};
const $3fddb102737e1f1a$var$getCardEntranceStyle = (index)=>({
        transitionDelay: `${$3fddb102737e1f1a$var$getCardEntranceDelay(index)}s`
    });
const $3fddb102737e1f1a$var$getCardEntranceDelayIndex = (renderIndex)=>renderIndex % $3fddb102737e1f1a$var$MAX_STAGGERED_CARD_COUNT;
const $3fddb102737e1f1a$var$getCardEntranceDelay = (index)=>Math.min($3fddb102737e1f1a$var$CARD_ENTRANCE_DELAY_SECONDS * index, $3fddb102737e1f1a$var$MAX_CARD_ENTRANCE_DELAY_SECONDS);
const $3fddb102737e1f1a$var$resolveSkeletonCardCount = (displayLimit, ssrItemCount)=>displayLimit ?? ssrItemCount;
const $3fddb102737e1f1a$var$getShouldApplyDisplayLimit = (displayLimit, shouldShowAllSearchResults)=>typeof displayLimit === "number" && !shouldShowAllSearchResults;
const $3fddb102737e1f1a$var$getUsesVisibleCount = (pageSize, dataItems)=>pageSize !== undefined || dataItems !== undefined;
const $3fddb102737e1f1a$var$getNextVisibleCount = (previousVisibleCount, pageSize)=>pageSize !== undefined ? previousVisibleCount + pageSize : Infinity;
const $3fddb102737e1f1a$var$getMaxElementHeight = (elements)=>elements.reduce((maxHeight, element)=>Math.max(maxHeight, element?.getBoundingClientRect().height ?? 0), 0);
const $3fddb102737e1f1a$var$measurementLayerStyle = null;
const $3fddb102737e1f1a$var$gallerySlotStyle = null;
const $3fddb102737e1f1a$var$emptyStateStyle = null;
const $3fddb102737e1f1a$var$galleryItemStyle = null;
const $3fddb102737e1f1a$var$galleryItemEntranceStyle = null;
const $3fddb102737e1f1a$var$galleryItemVisibleStyle = null;
const $3fddb102737e1f1a$var$fullHeightCardStyle = null;
const $3fddb102737e1f1a$var$skeletonCardItemStyle = null;
const $3fddb102737e1f1a$var$skeletonCardStyle = null;
const $3fddb102737e1f1a$var$skeletonMediaStyle = null;
const $3fddb102737e1f1a$var$skeletonContentStyle = null;
const $3fddb102737e1f1a$var$skeletonTitleGroupStyle = null;
const $3fddb102737e1f1a$var$skeletonBodyGroupStyle = null;
const $3fddb102737e1f1a$var$loadMoreStyle = null;
const $3fddb102737e1f1a$var$loadMoreButtonStyle = null;
const $3fddb102737e1f1a$var$loadMoreChevronStyle = null;
const $3fddb102737e1f1a$var$loadMoreLabelStyle = null;
function $3fddb102737e1f1a$var$resolveInitialVisibleCount(pageSize, dataItemsLength) {
    if (pageSize !== undefined) return pageSize;
    if (dataItemsLength !== undefined) return dataItemsLength;
    return Infinity;
}
function $3fddb102737e1f1a$var$toDataItems(data) {
    return Array.isArray(data) && data.length > 0 ? data : undefined;
}
function $3fddb102737e1f1a$var$getUniformBlockEntries(data) {
    const entries = Array.isArray(data) ? data : $3fddb102737e1f1a$var$isRecord(data) && Array.isArray(data["value"]) ? data["value"] : [];
    return entries.filter($3fddb102737e1f1a$var$isFacetDataSourceEntry);
}
function $3fddb102737e1f1a$var$isFacetDataSourceEntry(entry) {
    return $3fddb102737e1f1a$var$isRecord(entry);
}
function $3fddb102737e1f1a$var$getSysId(item) {
    if (!$3fddb102737e1f1a$var$isRecord(item)) return undefined;
    const sys = item["sys"];
    if (!$3fddb102737e1f1a$var$isRecord(sys)) return undefined;
    return typeof sys["id"] === "string" ? sys["id"] : undefined;
}
function $3fddb102737e1f1a$var$unwrapParameterValue(parameter) {
    if (parameter === undefined) return undefined;
    if (typeof parameter !== "object" || parameter === null) return parameter;
    if (Array.isArray(parameter)) return parameter;
    return parameter.value;
}
function $3fddb102737e1f1a$var$isRecord(value) {
    return typeof value === "object" && value !== null;
}
/**
 * Publishes the gallery's items + config to the loader context for the search
 * bar. Depends on the stable `registerGalleryConfig` setter, not the context
 * object, so publishing doesn't re-trigger the effect (avoids a render loop).
 */ function $3fddb102737e1f1a$var$usePublishGalleryConfig(items, searchConfiguration, featuredItemSlugs) {
    const register = (0, $foNCS.useFilterableGalleryLoader)()?.registerGalleryConfig;
    (0, $1oC0p.useEffect)(()=>{
        register?.({
            items: items,
            searchConfiguration: searchConfiguration,
            featuredItemSlugs: featuredItemSlugs
        });
    }, [
        register,
        items,
        searchConfiguration,
        featuredItemSlugs
    ]);
}
function $3fddb102737e1f1a$var$useFilterableBackfillState() {
    const loaderContext = (0, $foNCS.useFilterableGalleryLoader)();
    const extraItems = loaderContext?.extraItems ?? [];
    const hasLoaderRegistered = loaderContext?.currentRegistration !== null && loaderContext?.currentRegistration !== undefined;
    const isAwaitingBackfill = hasLoaderRegistered && extraItems.length === 0;
    return {
        extraItems: extraItems,
        isAwaitingBackfill: isAwaitingBackfill
    };
}
var $3fddb102737e1f1a$export$2e2bcd8739ae039 = $3fddb102737e1f1a$var$UniformFilterableGallery;

});
parcelRegister("6f8Au", function(module, exports) {
$parcel$export(module.exports, "FilterableGalleryProvider", function () { return $25ed86a2ba13fe14$export$b4e7927da72f0442; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $25ed86a2ba13fe14$var$FilterableGalleryContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $25ed86a2ba13fe14$export$b4e7927da72f0442 = ({ items: items, filteredItems: filteredItems, children: children })=>{
    const value = (0, $1oC0p.useMemo)(()=>({
            items: items,
            filteredItems: filteredItems
        }), [
        items,
        filteredItems
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($25ed86a2ba13fe14$var$FilterableGalleryContext.Provider, {
        value: value,
        children: children
    });
};
const $25ed86a2ba13fe14$export$a305c0376773bb0a = ()=>(0, $1oC0p.useContext)($25ed86a2ba13fe14$var$FilterableGalleryContext);

});

parcelRegister("lG1Of", function(module, exports) {
$parcel$export(module.exports, "FilterableItemIndexContext", function () { return $f4dd86ccea1056a6$export$2284b5017b55f87e; });
$parcel$export(module.exports, "FilterableItemRegistryProvider", function () { return $f4dd86ccea1056a6$export$408e600f5b338e55; });
$parcel$export(module.exports, "useFilterableItemRegistry", function () { return $f4dd86ccea1056a6$export$c3fea36cd05b76e9; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $f4dd86ccea1056a6$export$2284b5017b55f87e = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
const $f4dd86ccea1056a6$var$FilterableItemRegistryContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $f4dd86ccea1056a6$export$408e600f5b338e55 = ({ children: children, onRegistryChange: onRegistryChange })=>{
    const registryRef = (0, $1oC0p.useRef)(new Map());
    const prevDataRef = (0, $1oC0p.useRef)([]);
    const notify = (0, $1oC0p.useCallback)(()=>{
        const sorted = [
            ...registryRef.current.entries()
        ].sort(([a], [b])=>a - b).map(([, data])=>data);
        // Only notify if the data actually changed to prevent infinite re-render loops.
        const prev = prevDataRef.current;
        if (sorted.length === prev.length && sorted.every((d, i)=>d === prev[i])) return;
        prevDataRef.current = sorted;
        onRegistryChange(sorted);
    }, [
        onRegistryChange
    ]);
    const registerItem = (0, $1oC0p.useCallback)((index, data)=>{
        registryRef.current.set(index, data);
        notify();
    }, [
        notify
    ]);
    const unregisterItem = (0, $1oC0p.useCallback)((index)=>{
        registryRef.current.delete(index);
    // Don't notify synchronously on unregister — this runs during React's
    // commit/cleanup phase and calling setState here causes infinite loops.
    // The subsequent registerItem call (when the component remounts or data
    // changes) will notify with the correct up-to-date array.
    }, []);
    const contextValue = (0, $1oC0p.useMemo)(()=>({
            registerItem: registerItem,
            unregisterItem: unregisterItem
        }), [
        registerItem,
        unregisterItem
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f4dd86ccea1056a6$var$FilterableItemRegistryContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $f4dd86ccea1056a6$export$c3fea36cd05b76e9 = ()=>(0, $1oC0p.useContext)($f4dd86ccea1056a6$var$FilterableItemRegistryContext);

});

parcelRegister("f4mYE", function(module, exports) {
$parcel$export(module.exports, "dispatchShowAllFilterableGalleryItems", function () { return $407123e77a052455$export$d81b1c3ad32cc0e3; });
$parcel$export(module.exports, "subscribeToShowAllFilterableGalleryItems", function () { return $407123e77a052455$export$d570aeec1ed41f70; });
const $407123e77a052455$export$4bc61210cf504a16 = "wac:filterable-gallery:show-all-items";
const $407123e77a052455$export$d81b1c3ad32cc0e3 = (query)=>{
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent($407123e77a052455$export$4bc61210cf504a16, {
        detail: {
            query: query.trim()
        }
    }));
};
const $407123e77a052455$export$d570aeec1ed41f70 = (onShowAllItems)=>{
    if (typeof window === "undefined") return ()=>undefined;
    const handleShowAllItems = (event)=>{
        onShowAllItems(event.detail);
    };
    window.addEventListener($407123e77a052455$export$4bc61210cf504a16, handleShowAllItems);
    return ()=>window.removeEventListener($407123e77a052455$export$4bc61210cf504a16, handleShowAllItems);
};

});

parcelRegister("jh5WI", function(module, exports) {
$parcel$export(module.exports, "FILTER_DROPDOWN_DATA_ATTR", function () { return $4187681c2fe2739d$export$e0eb4323da102d75; });
$parcel$export(module.exports, "FilterControl", function () { return $4187681c2fe2739d$export$de444dcd5d6300ee; });
/* filter-control.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $OKl9V = parcelRequire("OKl9V");
const $4187681c2fe2739d$export$e0eb4323da102d75 = "data-filter-dropdown";
const $4187681c2fe2739d$export$de444dcd5d6300ee = ({ filter: filter, activeCount: activeCount, isOpen: isOpen, subFilter: subFilter, labelMap: labelMap, onButtonClick: onButtonClick, onOptionToggle: onOptionToggle })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lqyi6.Button), {
                variant: "secondary",
                size: "small",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _zulp1b66",
                    activeCount && "_1h6d17la _syaz17la",
                    "body-md"
                ]),
                onClick: (event)=>{
                    event.preventDefault();
                    onButtonClick();
                },
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event": "clicked",
                    "data-event-component": "button",
                    "data-event-container": "searchWithFilters",
                    "data-label": filter.label ?? filter.id
                },
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                },
                children: [
                    filter.label ?? filter.id,
                    " ",
                    /*#__PURE__*/ (0, $7VQPk.jsx)($4187681c2fe2739d$var$DropdownArrow, {
                        isOpen: isOpen
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c116y _4cvr1h6o _1bah1h6o _1ul9f6fq _4t3if6fq _2rko1ssb _bfhk17la _syazcd5j _1wyb1skh _vwz4kb7n _ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _3um015vq _uiisewfl",
                            "fine-print"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: activeCount || ""
                    })
                ]
            }),
            isOpen && subFilter && /*#__PURE__*/ (0, $7VQPk.jsx)($4187681c2fe2739d$var$OptionsPanel, {
                filterId: filter.id,
                options: subFilter,
                onToggle: onOptionToggle,
                labelMap: labelMap
            })
        ]
    });
// ---------------------------------------------------------------------------
// Internal sub-components (private to this file)
// ---------------------------------------------------------------------------
const $4187681c2fe2739d$var$DropdownArrow = ({ isOpen: isOpen })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            transform: isOpen ? "rotate(180deg)" : undefined
        },
        className: (0, $2jatx.default)([
            "_v564kete"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M9 1.18164L5 4.818L1 1.18164",
            stroke: (0, $kbpa7.wacToken)("color.primary.black"),
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const $4187681c2fe2739d$var$OptionsPanel = ({ filterId: filterId, options: options, onToggle: onToggle, labelMap: labelMap })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _bfhkcd5j _2rko7vkz _1pbycs5v _152t4bvh _1yt4pxbi _16qs130s",
            filterId
        ]),
        [$4187681c2fe2739d$export$e0eb4323da102d75]: "",
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: Object.keys(options).map((optionId, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($4187681c2fe2739d$var$OptionCheckbox, {
                    optionId: optionId,
                    label: labelMap?.[optionId] ?? optionId,
                    checked: options[optionId]?.stagedActive ?? false,
                    inputId: $4187681c2fe2739d$var$buildOptionInputId(filterId, index),
                    onToggle: onToggle
                }, optionId))
        })
    });
const $4187681c2fe2739d$var$buildOptionInputId = (filterId, index)=>`option-${filterId.replace(/\s/g, "")}-${index}`;
const $4187681c2fe2739d$var$OptionCheckbox = ({ optionId: optionId, label: label, checked: checked, inputId: inputId, onToggle: onToggle })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
        htmlFor: inputId,
        className: (0, $2jatx.default)([
            "_80omtlke _1e0c1txw _4cvr1h6o _1pfhu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                id: inputId,
                type: "checkbox",
                onClick: ()=>onToggle(optionId),
                className: (0, $2jatx.default)([
                    "_kqswstnw _tzy4idpf _lcxvglyw"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1bsbgktf _4t3igktf _2rko1l7b _19it1n5q _i0dlgktf _12l2u2gc _11q7cd5j _1e0c1txw _1bah1h6o _4cvr1h6o _bfw78djs _1c3917la _uq4u8djs",
                    checked ? "checked" : ""
                ]),
                style: {
                    "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4idpf",
                        checked && "_tzy4kb7n"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                        name: "featurecheckmark",
                        size: "xs",
                        color: (0, $kbpa7.wacToken)("color.neutral.light0")
                    })
                })
            }),
            label
        ]
    });
// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const $4187681c2fe2739d$var$triggerButtonStyle = null;
const $4187681c2fe2739d$var$triggerButtonActiveStyle = null;
const $4187681c2fe2739d$var$activeCountBadgeStyle = null;
const $4187681c2fe2739d$var$dropdownArrowStyle = null;
const $4187681c2fe2739d$var$panelStyle = null;
const $4187681c2fe2739d$var$optionListStyle = null;
const $4187681c2fe2739d$var$optionLabelStyle = null;
const $4187681c2fe2739d$var$checkboxStyle = null;
const $4187681c2fe2739d$var$checkmarkStyle = null;
const $4187681c2fe2739d$var$checkmarkVisibleStyle = null;
const $4187681c2fe2739d$var$hiddenCheckboxStyle = null;

});

parcelRegister("eAngy", function(module, exports) {
$parcel$export(module.exports, "Toolbar", function () { return $6dde010468313e76$export$4c260019440d418f; });
/* toolbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $iiNB7 = parcelRequire("iiNB7");

var $jh5WI = parcelRequire("jh5WI");

var $7HjDW = parcelRequire("7HjDW");

var $7EuEV = parcelRequire("7EuEV");
const $6dde010468313e76$export$4c260019440d418f = ({ filterDefs: filterDefs, sortDefs: sortDefs, canSearch: canSearch, showSearchInput: showSearchInput, filterObject: filterObject, searchQuery: searchQuery, selectedSortId: selectedSortId, dropdownVisibility: dropdownVisibility, labelMaps: labelMaps, onSearchChange: onSearchChange, onSearchSubmit: onSearchSubmit, onSearchClear: onSearchClear, onFilterButtonClick: onFilterButtonClick, onOptionToggle: onOptionToggle, onClearAllFilters: onClearAllFilters, onSortChange: onSortChange })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc _1lp7vrvc _q8t51h6o"
            ]),
            children: [
                showSearchInput && canSearch && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9uuw1"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7HjDW.SearchField), {
                        value: searchQuery,
                        onChange: onSearchChange,
                        onSubmit: onSearchSubmit,
                        onClear: onSearchClear
                    })
                }),
                filterDefs.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _1n261g80 _zulpu2gc _kqswh2mm"
                    ]),
                    children: [
                        filterDefs.map((filter)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                [(0, $jh5WI.FILTER_DROPDOWN_DATA_ATTR)]: "",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jh5WI.FilterControl), {
                                    filter: filter,
                                    activeCount: (0, $iiNB7.countActiveFilterOptions)(filter.id, filterObject),
                                    isOpen: !!dropdownVisibility[filter.id],
                                    subFilter: filterObject[filter.id],
                                    labelMap: labelMaps[filter.id],
                                    onButtonClick: ()=>onFilterButtonClick(filter.id),
                                    onOptionToggle: (optionId)=>onOptionToggle(filter.id, optionId)
                                })
                            }, filter.id)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                            variant: "primary_alt",
                            size: "small",
                            onClick: onClearAllFilters,
                            className: (0, $2jatx.default)([
                                "_o5721q9c",
                                "body-md"
                            ]),
                            dataEventProps: {
                                "data-product-key": "uniform",
                                "data-event": "clicked",
                                "data-event-component": "button",
                                "data-event-container": "searchWithFilters",
                                "data-label": "Clear Filters",
                                "data-label-english": "Clear Filters"
                            },
                            children: intl.formatMessage({
                                id: "uniformFilterableGallery.clearFilters",
                                defaultMessage: "Clear Filters"
                            })
                        })
                    ]
                }),
                sortDefs.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhutpp _1e0c1txw _1bahesu3"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7EuEV.SortControl), {
                        sorts: sortDefs,
                        selectedSortId: selectedSortId,
                        onChange: onSortChange
                    })
                })
            ]
        })
    });
};
const $6dde010468313e76$var$toolbarSectionStyle = null;
const $6dde010468313e76$var$toolbarRowStyle = null;
const $6dde010468313e76$var$searchContainerStyle = null;
const $6dde010468313e76$var$filterButtonRowStyle = null;
const $6dde010468313e76$var$clearFiltersButtonStyle = null;
const $6dde010468313e76$var$sortRowStyle = null;

});
parcelRegister("iiNB7", function(module, exports) {
$parcel$export(module.exports, "countActiveFilterOptions", function () { return $e9f05f3c168a82a3$export$c7d87b41bc3ef441; });
const $e9f05f3c168a82a3$export$c7d87b41bc3ef441 = (filterId, state)=>Object.values(state[filterId] ?? {}).reduce((count, option)=>option.committedActive ? count + 1 : count, 0);
const $e9f05f3c168a82a3$export$2de238e100787a91 = (state)=>Object.keys(state).reduce((count, filterId)=>count + $e9f05f3c168a82a3$export$c7d87b41bc3ef441(filterId, state), 0);

});

parcelRegister("7HjDW", function(module, exports) {
$parcel$export(module.exports, "SearchField", function () { return $e6c01637ddd40d01$export$b94867ecbd698f21; });
/* search-field.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bZmYH = parcelRequire("bZmYH");

var $kbpa7 = parcelRequire("kbpa7");

var $dE0sS = parcelRequire("dE0sS");
const $e6c01637ddd40d01$export$b94867ecbd698f21 = ({ value: value, onChange: onChange, onSubmit: onSubmit, onClear: onClear })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const inputRef = (0, $1oC0p.useRef)(null);
    const [isFocused, setIsFocused] = (0, $1oC0p.useState)(false);
    const placeholder = intl.formatMessage({
        id: "SearchBar.searchPlaceholder",
        defaultMessage: "Search"
    });
    const fireFocusAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "searchInput",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                url: location.href,
                page_path: location.pathname,
                eventComponent: "searchInput"
            }
        }).fire();
    };
    const handleFocus = ()=>{
        setIsFocused(true);
        fireFocusAnalyticsEvent();
    };
    const handleBlur = ()=>{
        if (value === "") setIsFocused(false);
    };
    const submitAndFocusInput = ()=>{
        inputRef.current?.focus();
        onSubmit();
    };
    const clearAndFocusInput = ()=>{
        onClear();
        inputRef.current?.focus();
    };
    const focusedClass = isFocused ? "search-active" : "";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            submitAndFocusInput();
        },
        className: (0, $2jatx.default)([
            "_4t3i1jfw _6rthidpf _1bsb1osq _12l2pxbi _11q7150w _2rko1jfw _1e0c1txw _1n261q9c _1bah1yb4 _1yt4119w _scffglyw _1rwq1j28 _xmji1r31 _gxxuglyw _34ir1o36 _5hv91osq _17ea1vuk _psgk1hlo _1owa1w8u _4u6k1j28 _10709by0 _1f021txw _oki51h6o _1vh3esu3 _dier1q9c _qe2zh8dc _12nmbz2e _1d2m1ejb _11vy1wtv _p2rgx19p"
        ]),
        style: {
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                ref: inputRef,
                className: focusedClass,
                type: "text",
                "aria-label": placeholder,
                placeholder: placeholder,
                value: value,
                onChange: (event)=>onChange(event.target.value),
                onFocus: handleFocus,
                onBlur: handleBlur
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: `search-buttons-container ${focusedClass}`,
                children: [
                    isFocused && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($e6c01637ddd40d01$var$SearchClearButton, {
                                onClick: clearAndFocusInput
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: "search-buttons-divider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($e6c01637ddd40d01$var$SearchSubmitButton, {})
                ]
            })
        ]
    });
};
// ---------------------------------------------------------------------------
// Internal sub-components (private to this file; used only by SearchField)
// ---------------------------------------------------------------------------
const $e6c01637ddd40d01$var$SearchSubmitButton = ()=>{
    const intl = (0, $8e22h.default)();
    const label = intl.formatMessage({
        id: "SearchButton.label",
        defaultMessage: "Search"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "submit",
        "aria-label": label,
        "data-testid": "search-submit-button",
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "searchButton",
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _syaz1nc2"
        ]),
        style: {
            "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_syaz1hlo _2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _irr31rga"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                label: label,
                size: "medium"
            })
        })
    });
};
const $e6c01637ddd40d01$var$SearchClearButton = ({ onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const label = intl.formatMessage({
        id: "SearchCloseButton.label",
        defaultMessage: "Clear search"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: onClick,
        "aria-label": label,
        "data-testid": "search-close-button",
        "data-event": "clicked",
        "data-event-component": "button",
        "data-event-container": "searchCloseButton",
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _syaz1nc2 _30l31nc2"
        ]),
        style: {
            "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
            size: "16",
            className: (0, $2jatx.default)([
                "_syaz1hlo _2rko1ssb _4t3i1wug"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            }
        })
    });
};
// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const $e6c01637ddd40d01$var$searchFieldStyle = null;
const $e6c01637ddd40d01$var$submitButtonStyle = null;
const $e6c01637ddd40d01$var$submitIconWrapperStyle = null;
const $e6c01637ddd40d01$var$clearButtonStyle = null;
const $e6c01637ddd40d01$var$clearIconStyle = null;

});

parcelRegister("7EuEV", function(module, exports) {
$parcel$export(module.exports, "SortControl", function () { return $7853d66fe8b17701$export$b0d8abc8911a4de9; });
/* sort-control.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $7853d66fe8b17701$export$b0d8abc8911a4de9 = ({ sorts: sorts, selectedSortId: selectedSortId, onChange: onChange })=>{
    if (sorts.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulpu2gc _1wyboxwj"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: "Sort by"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                value: selectedSortId ?? "",
                onChange: (event)=>onChange(event.target.value),
                className: (0, $2jatx.default)([
                    "_19itj0fz _2rko1y44 _1yt418iy _11q7vuon _80omtlke"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                        value: "",
                        children: "None"
                    }),
                    sorts.map((sort)=>/*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                            value: sort.id,
                            children: sort.label
                        }, sort.id))
                ]
            })
        ]
    });
};
const $7853d66fe8b17701$var$sortControlStyle = null;
const $7853d66fe8b17701$var$sortSelectStyle = null;

});


parcelRegister("iPbWG", function(module, exports) {
$parcel$export(module.exports, "useFilterState", function () { return $31df0a65d93a9831$export$486dfeb2d6bb2b9b; });

var $1oC0p = parcelRequire("1oC0p");

var $cP432 = parcelRequire("cP432");

var $H7SCD = parcelRequire("H7SCD");

var $iSHOM = parcelRequire("iSHOM");

var $7Ofoh = parcelRequire("7Ofoh");
const $31df0a65d93a9831$export$486dfeb2d6bb2b9b = ({ items: items, filterDefs: filterDefs, urlSync: urlSync, optionsDataSources: optionsDataSources })=>{
    const fireFilterClickAnalytics = (0, $7Ofoh.useFireFilterClickAnalytics)();
    const [filterObject, setFilterObject] = (0, $1oC0p.useState)(()=>(0, $H7SCD.buildUniformFilterObject)(items, filterDefs, optionsDataSources));
    const [searchQuery, setSearchQuery] = (0, $1oC0p.useState)("");
    const [selectedSortId, setSelectedSortId] = (0, $1oC0p.useState)();
    const [dropdownVisibility, setDropdownVisibility] = (0, $1oC0p.useState)({});
    const closedDropdownState = (0, $1oC0p.useMemo)(()=>Object.fromEntries(filterDefs.map((def)=>[
                def.id,
                false
            ])), [
        filterDefs
    ]);
    // Rebuild filter options when the filter schema or data shape changes,
    // preserving any existing user selections for options that still exist.
    // We use item count as a proxy for "items actually changed" to avoid
    // resetting selections when Uniform recreates data object references
    // on re-renders without changing the actual item set.
    const itemCount = items.length;
    (0, $1oC0p.useEffect)(()=>{
        const fresh = (0, $H7SCD.buildUniformFilterObject)(items, filterDefs, optionsDataSources);
        setFilterObject((prev)=>{
            // Merge: carry over existing selections for options that still exist.
            return Object.fromEntries(Object.entries(fresh).map(([filterId, subFilter])=>[
                    filterId,
                    Object.fromEntries(Object.entries(subFilter).map(([optionId, option])=>[
                            optionId,
                            prev[filterId]?.[optionId] ?? option
                        ]))
                ]));
        });
        setDropdownVisibility(Object.fromEntries(filterDefs.map((def)=>[
                def.id,
                false
            ])));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        itemCount,
        filterDefs,
        optionsDataSources
    ]);
    // Disable URL sync in Uniform preview — writing query params breaks the preview iframe.
    // Computed once on mount via useRef since the preview state never changes mid-session.
    const isUniformPreviewRef = (0, $1oC0p.useRef)(typeof window !== "undefined" && window.location.pathname.includes("/uniform-preview"));
    const effectiveUrlSync = urlSync && !isUniformPreviewRef.current;
    // Hydrate from URL on mount + on browser back/forward.
    (0, $1oC0p.useEffect)(()=>{
        if (!effectiveUrlSync || typeof window === "undefined") return;
        const hydrate = ()=>{
            const urlState = (0, $iSHOM.readStateFromUrl)(window.location.search, filterDefs);
            setFilterObject((prev)=>(0, $iSHOM.filtersToUniformFilterObject)(urlState.filters, prev));
            setSearchQuery(urlState.query);
            setSelectedSortId(urlState.sortId);
        };
        hydrate();
        window.addEventListener("popstate", hydrate);
        return ()=>window.removeEventListener("popstate", hydrate);
    }, [
        urlSync,
        filterDefs
    ]);
    const isAnyDropdownOpen = Object.values(dropdownVisibility).some(Boolean);
    const pushUrl = (nextFilterObject, nextQuery, nextSortId)=>{
        if (!effectiveUrlSync) return;
        (0, $iSHOM.writeStateToUrl)({
            filters: (0, $iSHOM.uniformFilterObjectToFlat)(nextFilterObject),
            query: nextQuery,
            sortId: nextSortId
        });
    };
    // The GALLERY_SEARCH_EVENT listener subscribes once on mount, so route the
    // event through a ref that always holds the latest handler. This keeps
    // `filterObject`/`selectedSortId`/`pushUrl` fresh without re-subscribing.
    const handleGallerySearchRef = (0, $1oC0p.useRef)(()=>{});
    handleGallerySearchRef.current = (query)=>{
        const nextQuery = query ?? "";
        setSearchQuery(nextQuery);
        // A non-empty search clears filters (like the gallery's own submit),
        // so it ranks the full set — matching the search bar's suggestions.
        const nextFilterObject = nextQuery.trim() ? $31df0a65d93a9831$var$mapAllOptionsToInactive(filterObject) : filterObject;
        if (nextFilterObject !== filterObject) setFilterObject(nextFilterObject);
        // Mirror the new search state into the URL so a refresh or shared link
        // doesn't re-hydrate the now-cleared filters or the previous query.
        pushUrl(nextFilterObject, nextQuery, selectedSortId);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window === "undefined") return;
        const listener = (e)=>handleGallerySearchRef.current(e.detail.query);
        window.addEventListener((0, $cP432.GALLERY_SEARCH_EVENT), listener);
        return ()=>window.removeEventListener((0, $cP432.GALLERY_SEARCH_EVENT), listener);
    }, []);
    const handleFilterButtonClick = (filterId)=>{
        fireFilterClickAnalytics(filterId);
        setDropdownVisibility((prev)=>({
                ...closedDropdownState,
                [filterId]: !prev[filterId]
            }));
    };
    const toggleFilterOption = (filterId, optionId)=>{
        setFilterObject((prev)=>{
            const subFilter = prev[filterId] ?? {};
            const current = subFilter[optionId];
            const nextActive = !current?.stagedActive;
            const next = {
                ...prev,
                [filterId]: {
                    ...subFilter,
                    [optionId]: {
                        committedActive: nextActive,
                        stagedActive: nextActive
                    }
                }
            };
            // Commit and push URL immediately so filters apply on selection,
            // not on dropdown close.
            pushUrl(next, searchQuery, selectedSortId);
            return next;
        });
    };
    const clearAllFilters = ()=>{
        const cleared = $31df0a65d93a9831$var$mapAllOptionsToInactive(filterObject);
        setFilterObject(cleared);
        pushUrl(cleared, searchQuery, selectedSortId);
    };
    const handleSearchSubmit = ()=>{
        const nextFilterObject = searchQuery ? $31df0a65d93a9831$var$mapAllOptionsToInactive(filterObject) : filterObject;
        setFilterObject(nextFilterObject);
        pushUrl(nextFilterObject, searchQuery, selectedSortId);
    };
    const handleSearchClear = ()=>{
        setSearchQuery("");
        pushUrl(filterObject, "", selectedSortId);
    };
    const handleSortChange = (nextSortId)=>{
        setSelectedSortId(nextSortId);
        pushUrl(filterObject, searchQuery, nextSortId);
    };
    const closeAllDropdownsAndCommit = ()=>{
        setDropdownVisibility(closedDropdownState);
    };
    return {
        filterObject: filterObject,
        searchQuery: searchQuery,
        selectedSortId: selectedSortId,
        dropdownVisibility: dropdownVisibility,
        isAnyDropdownOpen: isAnyDropdownOpen,
        setSearchQuery: setSearchQuery,
        handleFilterButtonClick: handleFilterButtonClick,
        toggleFilterOption: toggleFilterOption,
        clearAllFilters: clearAllFilters,
        handleSearchSubmit: handleSearchSubmit,
        handleSearchClear: handleSearchClear,
        handleSortChange: handleSortChange,
        closeAllDropdownsAndCommit: closeAllDropdownsAndCommit
    };
};
const $31df0a65d93a9831$var$mapAllOptionsToInactive = (state)=>Object.fromEntries(Object.entries(state).map(([filterId, subFilter])=>[
            filterId,
            Object.fromEntries(Object.keys(subFilter ?? {}).map((optionId)=>[
                    optionId,
                    {
                        committedActive: false,
                        stagedActive: false
                    }
                ]))
        ]));

});
parcelRegister("cP432", function(module, exports) {
$parcel$export(module.exports, "GALLERY_SEARCH_EVENT", function () { return $d46df9a41fa8d9aa$export$5f4885e91e9f6714; });
const $d46df9a41fa8d9aa$export$5f4885e91e9f6714 = "filterable-gallery-search";

});

parcelRegister("H7SCD", function(module, exports) {
$parcel$export(module.exports, "normalizeUrlSlug", function () { return $ca127b9d3597e36e$export$884dc6c52e5ca88e; });
$parcel$export(module.exports, "coerceToPrimitiveArray", function () { return $ca127b9d3597e36e$export$7ee9ceeb236f8344; });
$parcel$export(module.exports, "resolveFieldPath", function () { return $ca127b9d3597e36e$export$329d3c8bdb587c75; });
$parcel$export(module.exports, "buildUniformFilterObject", function () { return $ca127b9d3597e36e$export$5ff5ecbcecad50cc; });
$parcel$export(module.exports, "buildLabelMaps", function () { return $ca127b9d3597e36e$export$a76d208414bdf304; });
$parcel$export(module.exports, "applyFilters", function () { return $ca127b9d3597e36e$export$47150c42ed89d097; });
$parcel$export(module.exports, "applySearch", function () { return $ca127b9d3597e36e$export$7fd91c352a58fa31; });
$parcel$export(module.exports, "searchWithFeaturedBoost", function () { return $ca127b9d3597e36e$export$57b3b77c1845381d; });
$parcel$export(module.exports, "applySort", function () { return $ca127b9d3597e36e$export$6dbc556d5545b9b1; });

var $djfBw = parcelRequire("djfBw");
const $ca127b9d3597e36e$var$UNRANKED_PRIORITY = Number.MAX_SAFE_INTEGER;
function $ca127b9d3597e36e$export$576ccdef7afa907a(items, featuredItemSlugs) {
    if (featuredItemSlugs.length === 0) return items;
    const priorityBySlug = new Map(featuredItemSlugs.map((slug, index)=>[
            slug,
            index
        ]));
    return [
        ...items
    ].sort((a, b)=>$ca127b9d3597e36e$var$getSlugPriority(a, priorityBySlug) - $ca127b9d3597e36e$var$getSlugPriority(b, priorityBySlug));
}
function $ca127b9d3597e36e$var$getSlugPriority(item, priorityBySlug) {
    const slug = $ca127b9d3597e36e$var$getItemFullUrlSlug(item);
    if (slug === undefined) return $ca127b9d3597e36e$var$UNRANKED_PRIORITY;
    return priorityBySlug.get(slug) ?? $ca127b9d3597e36e$var$UNRANKED_PRIORITY;
}
function $ca127b9d3597e36e$var$getItemFullUrlSlug(item) {
    if (!$ca127b9d3597e36e$var$isRecord(item)) return undefined;
    const fields = item["fields"];
    if (!$ca127b9d3597e36e$var$isRecord(fields)) return undefined;
    return $ca127b9d3597e36e$export$884dc6c52e5ca88e(fields["fullUrlSlug"]);
}
function $ca127b9d3597e36e$export$884dc6c52e5ca88e(value) {
    if (typeof value !== "string") return undefined;
    const trimmedValue = value.trim();
    if (trimmedValue.length === 0) return undefined;
    const pathname = $ca127b9d3597e36e$var$extractPathname(trimmedValue);
    return $ca127b9d3597e36e$var$stripTrailingSlash($ca127b9d3597e36e$var$stripQueryAndFragment(pathname));
}
function $ca127b9d3597e36e$var$extractPathname(value) {
    const valueWithProtocol = value.startsWith("//") ? `https:${value}` : value;
    try {
        return new URL(valueWithProtocol).pathname;
    } catch  {
        return value.startsWith("/") ? value : `/${value}`;
    }
}
function $ca127b9d3597e36e$var$stripQueryAndFragment(path) {
    return path.split(/[?#]/, 1)[0] ?? path;
}
function $ca127b9d3597e36e$var$stripTrailingSlash(path) {
    if (path === "/") return path;
    return path.endsWith("/") ? path.slice(0, -1) : path;
}
function $ca127b9d3597e36e$var$isRecord(value) {
    return typeof value === "object" && value !== null;
}
const $ca127b9d3597e36e$var$DEFAULT_SEARCH_THRESHOLD = 0.4;
const $ca127b9d3597e36e$var$DEFAULT_FEATURED_BOOST = 0.15;
// ---------------------------------------------------------------------------
// Internal helpers
// ---------------------------------------------------------------------------
function $ca127b9d3597e36e$var$isPrimitive(v) {
    return v !== null && v !== undefined && typeof v !== "object";
}
function $ca127b9d3597e36e$var$isUnresolvedLink(value) {
    if (typeof value !== "object" || value === null) return false;
    const sys = value["sys"];
    return typeof sys === "object" && sys !== null && sys["type"] === "Link";
}
function $ca127b9d3597e36e$export$7ee9ceeb236f8344(value) {
    const values = Array.isArray(value) ? value : [
        value
    ];
    return values.filter($ca127b9d3597e36e$var$isPrimitive).map(String);
}
function $ca127b9d3597e36e$var$normaliseOptionItems(options) {
    if (!options) return [];
    if (Array.isArray(options)) return options;
    try {
        const parsed = JSON.parse(options);
        return Array.isArray(parsed) ? parsed : [];
    } catch  {
        return [];
    }
}
function $ca127b9d3597e36e$var$optionItemToPair(o) {
    return typeof o === "string" ? {
        value: o,
        label: o
    } : {
        value: String(o.value),
        label: o.label ?? String(o.value)
    };
}
function $ca127b9d3597e36e$export$329d3c8bdb587c75(item, path) {
    const segments = path.split(/\[\]\.?/);
    function walk(value, segs) {
        if (segs.length === 0) return value;
        const [head, ...tail] = segs;
        if (head === undefined) return value;
        let current = value;
        for (const key of head.split(".").filter(Boolean)){
            if (current === null || current === undefined) return undefined;
            if (typeof current !== "object") return undefined;
            // Block navigation into `fields` of an unresolved Link (the linked entry hasn't
            // been resolved so its `fields` is empty/missing). But allow navigating into `sys`
            // (e.g. sys.id) — that data is always present on Link stubs and is intentional.
            if ($ca127b9d3597e36e$var$isUnresolvedLink(current) && key !== "sys") return undefined;
            current = current[key];
        }
        if (tail.length === 0) return current;
        if (!Array.isArray(current)) return undefined;
        const results = current.flatMap((el)=>{
            const resolved = walk(el, tail);
            return Array.isArray(resolved) ? resolved : [
                resolved
            ];
        });
        return results.filter((v)=>v !== undefined);
    }
    return walk(item, segments);
}
function $ca127b9d3597e36e$export$49fe41a914eb071d(options) {
    return $ca127b9d3597e36e$var$normaliseOptionItems(options).map((o)=>typeof o === "string" ? o : String(o.value));
}
function $ca127b9d3597e36e$export$c1270495306335d8(options) {
    return $ca127b9d3597e36e$var$normaliseOptionItems(options).map($ca127b9d3597e36e$var$optionItemToPair);
}
function $ca127b9d3597e36e$export$cb7a25b3ee8582a2(items, fieldPath) {
    const seen = new Set();
    for (const item of items)for (const v of $ca127b9d3597e36e$export$7ee9ceeb236f8344($ca127b9d3597e36e$export$329d3c8bdb587c75(item, fieldPath)))seen.add(v);
    return Array.from(seen).sort((a, b)=>a.localeCompare(b));
}
function $ca127b9d3597e36e$export$ea41b75b01c9ad42(items, fieldPath, labelFieldPath) {
    // Map<label, Set<value>> — groups multiple IDs under the same display label.
    // This handles cases where distinct entries share a label (e.g. "Design" for
    // both Jira and Confluence categories). The combined IDs are pipe-separated so
    // matchValue can split and OR-match all of them.
    const labelToIds = new Map();
    for (const item of items){
        const valueArr = $ca127b9d3597e36e$export$7ee9ceeb236f8344($ca127b9d3597e36e$export$329d3c8bdb587c75(item, fieldPath));
        const labelArr = $ca127b9d3597e36e$export$7ee9ceeb236f8344($ca127b9d3597e36e$export$329d3c8bdb587c75(item, labelFieldPath));
        valueArr.forEach((valueStr, i)=>{
            const label = labelArr[i] ?? valueStr;
            if (!labelToIds.has(label)) labelToIds.set(label, new Set());
            labelToIds.get(label)?.add(valueStr);
        });
    }
    return Array.from(labelToIds.entries()).map(([label, ids])=>({
            value: Array.from(ids).join("|"),
            label: label
        })).sort((a, b)=>a.label.localeCompare(b.label));
}
// ---------------------------------------------------------------------------
// Shared resolution (used by both buildUniformFilterObject and buildLabelMaps)
// ---------------------------------------------------------------------------
function $ca127b9d3597e36e$var$resolveOptionPairs(items, filter, optionsDataSources) {
    // 1. Explicit static options — highest priority.
    if (filter.options) {
        const pairs = $ca127b9d3597e36e$export$c1270495306335d8(filter.options);
        if (pairs.length > 0) return pairs;
    }
    // 2. Data-bound options from a gallery-level data resource — resolves the
    //    limitation of data bindings inside $block children not being resolved
    //    by Uniform before flattenValues runs. The gallery component receives
    //    the resolved array as a top-level prop and passes it here keyed by
    //    filter ID.
    const externalData = optionsDataSources?.[filter.id];
    if (Array.isArray(externalData) && externalData.length > 0) {
        if (!filter.optionsValuePath) // eslint-disable-next-line no-console
        console.warn(`[FilterableGallery] FacetDataSource found for filter "${filter.id}" but optionsValuePath is not set. ` + `Set Options Value Path on the FilterDefinition (e.g. "sys.id"). Falling back to auto-derive.`);
        else return $ca127b9d3597e36e$export$ea41b75b01c9ad42(externalData, filter.optionsValuePath, filter.optionsLabelPath ?? filter.optionsValuePath);
    }
    // 3. Auto-derive from gallery items — fallback.
    if (filter.labelFieldPath) return $ca127b9d3597e36e$export$ea41b75b01c9ad42(items, filter.fieldPath, filter.labelFieldPath);
    return $ca127b9d3597e36e$export$cb7a25b3ee8582a2(items, filter.fieldPath).map((v)=>({
            value: v,
            label: v
        }));
}
function $ca127b9d3597e36e$export$5ff5ecbcecad50cc(items, filters, optionsDataSources) {
    return Object.fromEntries(filters.map((filter)=>{
        const subFilter = Object.fromEntries($ca127b9d3597e36e$var$resolveOptionPairs(items, filter, optionsDataSources).map(({ value: value })=>[
                value,
                {
                    committedActive: false,
                    stagedActive: false
                }
            ]));
        return [
            filter.id,
            subFilter
        ];
    }));
}
function $ca127b9d3597e36e$export$a76d208414bdf304(items, filters, optionsDataSources) {
    return Object.fromEntries(filters.map((filter)=>[
            filter.id,
            Object.fromEntries($ca127b9d3597e36e$var$resolveOptionPairs(items, filter, optionsDataSources).map(({ value: value, label: label })=>[
                    value,
                    label
                ]))
        ]));
}
// ---------------------------------------------------------------------------
// Filter pipeline
// ---------------------------------------------------------------------------
function $ca127b9d3597e36e$var$matchValue(itemValue, matchType, selected) {
    const itemValues = $ca127b9d3597e36e$export$7ee9ceeb236f8344(itemValue);
    // Selected values may be pipe-separated IDs (e.g. "id1|id2") when multiple
    // entries share the same display label (see deriveOptionsWithLabels).
    // Each pipe-joined token represents OR semantics — the item matches if it
    // contains ANY of the IDs in the token.
    if (matchType === "equals") // Item matches if it satisfies at least one selected token (OR across tokens,
    // OR across pipe-joined IDs within each token).
    return selected.some((token)=>token.split("|").some((id)=>itemValues.includes(id)));
    if (matchType === "includes") // Item matches if it satisfies every selected token. Within each token,
    // pipe-joined IDs are OR'd (same label = different product variants).
    return selected.every((token)=>token.split("|").some((id)=>itemValues.includes(id)));
    if (matchType === "contains") return selected.some((token)=>token.split("|").some((id)=>itemValues.some((v)=>v.toLowerCase().includes(id.toLowerCase()))));
    return false;
}
function $ca127b9d3597e36e$export$47150c42ed89d097(items, filters, filterState) {
    const activeFilters = filters.filter((filter)=>{
        const subFilter = filterState[filter.id];
        return subFilter && Object.values(subFilter).some((opt)=>opt.committedActive);
    });
    if (activeFilters.length === 0) return items;
    return items.filter((item)=>activeFilters.every((filter)=>{
            const subFilter = filterState[filter.id];
            if (!subFilter) return true;
            const selected = Object.entries(subFilter).filter(([, opt])=>opt.committedActive).map(([key])=>key);
            return $ca127b9d3597e36e$var$matchValue($ca127b9d3597e36e$export$329d3c8bdb587c75(item, filter.fieldPath), filter.matchType, selected);
        }));
}
function $ca127b9d3597e36e$export$7fd91c352a58fa31(items, query, searchConfiguration) {
    const trimmedQuery = query.trim();
    if (!trimmedQuery || !$ca127b9d3597e36e$var$hasSearchCriteria(searchConfiguration)) return items;
    return $ca127b9d3597e36e$var$scoredSearch(items, trimmedQuery, searchConfiguration).map((scored)=>scored.item);
}
function $ca127b9d3597e36e$export$57b3b77c1845381d(items, query, searchConfiguration, featuredItemSlugs) {
    const trimmedQuery = query.trim();
    if (!trimmedQuery || !$ca127b9d3597e36e$var$hasSearchCriteria(searchConfiguration)) return $ca127b9d3597e36e$export$576ccdef7afa907a(items, featuredItemSlugs);
    const scored = $ca127b9d3597e36e$var$scoredSearch(items, trimmedQuery, searchConfiguration);
    return $ca127b9d3597e36e$export$a1cf0b2ee0663507(scored, featuredItemSlugs, searchConfiguration.featuredBoost ?? $ca127b9d3597e36e$var$DEFAULT_FEATURED_BOOST);
}
function $ca127b9d3597e36e$export$a1cf0b2ee0663507(scored, featuredItemSlugs, boost) {
    if (featuredItemSlugs.length === 0) return scored.map((s)=>s.item);
    const priorityBySlug = new Map(featuredItemSlugs.map((slug, index)=>[
            slug,
            index
        ]));
    const ranked = scored.map((s, index)=>{
        const slugPriority = $ca127b9d3597e36e$var$getSlugPriority(s.item, priorityBySlug);
        const isFeatured = slugPriority !== $ca127b9d3597e36e$var$UNRANKED_PRIORITY;
        return {
            item: s.item,
            index: index,
            slugPriority: // stable tiebreak: keep relevance order for equal scores
            slugPriority,
            // featured order matches browse mode (prioritizeItemsBySlug)
            adjustedScore: s.score - (isFeatured ? boost : 0)
        };
    }).sort((a, b)=>a.adjustedScore - b.adjustedScore || a.slugPriority - b.slugPriority || a.index - b.index);
    return ranked.map((r)=>r.item);
}
function $ca127b9d3597e36e$var$hasSearchCriteria(searchConfiguration) {
    return searchConfiguration !== undefined && searchConfiguration.keys.length > 0;
}
/**
 * Weighted Fuse search. Each config key is indexed under a positional alias
 * (`key_0`, `key_1`, …) rather than its dot-path name. Fuse treats dot-paths as
 * nested lookups, and naively replacing dots with underscores would let two
 * distinct paths collide (e.g. `fields.name` and `fields_name`), silently
 * overwriting one key's data. Positional aliases sidestep both problems.
 */ function $ca127b9d3597e36e$var$scoredSearch(items, query, config) {
    const aliasFor = (index)=>`key_${index}`;
    const fuseKeys = config.keys.map((key, index)=>({
            name: aliasFor(index),
            weight: key.weight
        }));
    const indexedItems = items.map((item)=>{
        const indexed = {};
        config.keys.forEach((key, index)=>{
            indexed[aliasFor(index)] = $ca127b9d3597e36e$export$7ee9ceeb236f8344($ca127b9d3597e36e$export$329d3c8bdb587c75(item, key.name));
        });
        return {
            ...indexed,
            __fuseOriginalItem__: item
        };
    });
    return new (0, $djfBw.default)(indexedItems, {
        keys: fuseKeys,
        threshold: config.threshold ?? $ca127b9d3597e36e$var$DEFAULT_SEARCH_THRESHOLD,
        ignoreLocation: config.ignoreLocation ?? true,
        includeScore: true
    }).search(query).map((result)=>({
            item: result.item.__fuseOriginalItem__,
            score: result.score ?? 0
        }));
}
function $ca127b9d3597e36e$export$6dbc556d5545b9b1(items, sort) {
    if (!sort) return items;
    const direction = sort.direction === "desc" ? -1 : 1;
    const valueType = sort.valueType ?? "string";
    return [
        ...items
    ].sort((a, b)=>{
        const av = $ca127b9d3597e36e$var$coerceForSort($ca127b9d3597e36e$export$329d3c8bdb587c75(a, sort.fieldPath), valueType);
        const bv = $ca127b9d3597e36e$var$coerceForSort($ca127b9d3597e36e$export$329d3c8bdb587c75(b, sort.fieldPath), valueType);
        if (av === undefined && bv === undefined) return 0;
        if (av === undefined) return 1;
        if (bv === undefined) return -1;
        if (av < bv) return -1 * direction;
        if (av > bv) return 1 * direction;
        return 0;
    });
}
function $ca127b9d3597e36e$var$coerceForSort(value, valueType) {
    const first = Array.isArray(value) ? value[0] : value;
    if (first === null || first === undefined) return undefined;
    if (valueType === "number") {
        const n = typeof first === "number" ? first : Number(first);
        return Number.isNaN(n) ? undefined : n;
    }
    if (valueType === "date") {
        const ms = new Date(String(first)).getTime();
        return Number.isNaN(ms) ? undefined : ms;
    }
    return String(first).toLowerCase();
}

});

parcelRegister("iSHOM", function(module, exports) {
$parcel$export(module.exports, "readStateFromUrl", function () { return $958e0f67d19dcee0$export$5ae5c11fea1e305c; });
$parcel$export(module.exports, "writeStateToUrl", function () { return $958e0f67d19dcee0$export$99ca66643841f01b; });
$parcel$export(module.exports, "filtersToUniformFilterObject", function () { return $958e0f67d19dcee0$export$d33e743aeb9f3bca; });
$parcel$export(module.exports, "uniformFilterObjectToFlat", function () { return $958e0f67d19dcee0$export$dc58eee439d7a466; });

var $9hXFt = parcelRequire("9hXFt");
const $958e0f67d19dcee0$var$SEARCH_KEY = "term";
const $958e0f67d19dcee0$var$SORT_KEY = "sort";
function $958e0f67d19dcee0$var$readSearchParams(search) {
    return new URLSearchParams(search);
}
function $958e0f67d19dcee0$var$getMulti(params, key) {
    const raw = params.get(key);
    return raw ? raw.split(";").filter(Boolean) : [];
}
function $958e0f67d19dcee0$export$5ae5c11fea1e305c(search, filterDefs) {
    const params = $958e0f67d19dcee0$var$readSearchParams(search);
    const query = params.get($958e0f67d19dcee0$var$SEARCH_KEY) ?? "";
    const filters = {};
    if (!query) for (const def of filterDefs){
        if ((0, $9hXFt.warnIfReservedKey)(def.id, "filter id")) continue;
        const values = $958e0f67d19dcee0$var$getMulti(params, def.id);
        if (values.length > 0) filters[def.id] = values;
    }
    return {
        filters: filters,
        query: query,
        sortId: params.get($958e0f67d19dcee0$var$SORT_KEY) ?? undefined
    };
}
function $958e0f67d19dcee0$export$6b17a39e52c8ee53(state) {
    const params = new URLSearchParams();
    if (state.query) params.set($958e0f67d19dcee0$var$SEARCH_KEY, state.query);
    if (state.sortId) params.set($958e0f67d19dcee0$var$SORT_KEY, state.sortId);
    if (!state.query) for (const [key, values] of Object.entries(state.filters)){
        if ((0, $9hXFt.isReservedUrlKey)(key)) continue;
        if (!values || values.length === 0) continue;
        params.set(key, values.join(";"));
    }
    return $958e0f67d19dcee0$var$paramsToUnencodedString(params);
}
/**
 * Serialises params with semicolons left unencoded inside values
 * (mirrors roadmap-features/src/context/url.ts).
 */ function $958e0f67d19dcee0$var$paramsToUnencodedString(params) {
    return Array.from(params.entries()).map(([k, v])=>{
        const encodedKey = encodeURIComponent(k);
        const encodedValue = v.split(";").map(encodeURIComponent).join(";");
        return `${encodedKey}=${encodedValue}`;
    }).join("&");
}
function $958e0f67d19dcee0$export$99ca66643841f01b(state) {
    if (typeof window === "undefined") return;
    const queryString = $958e0f67d19dcee0$export$6b17a39e52c8ee53(state);
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""}${window.location.hash}`;
    if (newUrl !== `${window.location.pathname}${window.location.search}${window.location.hash}`) window.history.pushState({}, "", newUrl);
}
function $958e0f67d19dcee0$export$d33e743aeb9f3bca(flat, seedFilterObject) {
    const result = {};
    for (const [filterId, subFilter] of Object.entries(seedFilterObject)){
        const activeValues = new Set(flat[filterId] ?? []);
        const next = {};
        for (const optionKey of Object.keys(subFilter ?? {})){
            const isActive = activeValues.has(optionKey);
            next[optionKey] = {
                committedActive: isActive,
                stagedActive: isActive
            };
        }
        result[filterId] = next;
    }
    return result;
}
function $958e0f67d19dcee0$export$dc58eee439d7a466(state) {
    const flat = {};
    for (const [filterId, subFilter] of Object.entries(state)){
        const active = Object.entries(subFilter ?? {}).filter(([, opt])=>opt.committedActive).map(([key])=>key);
        if (active.length > 0) flat[filterId] = active;
    }
    return flat;
}

});
parcelRegister("9hXFt", function(module, exports) {
$parcel$export(module.exports, "isReservedUrlKey", function () { return $9b5db1cb5cc0ca12$export$a5c43a85198b9978; });
$parcel$export(module.exports, "warnIfReservedKey", function () { return $9b5db1cb5cc0ca12$export$954ab33cf89a3d04; });
const $9b5db1cb5cc0ca12$export$e5e16582af6ef4ec = [
    "term",
    "sort"
];
function $9b5db1cb5cc0ca12$export$a5c43a85198b9978(key) {
    return $9b5db1cb5cc0ca12$export$e5e16582af6ef4ec.includes(key);
}
function $9b5db1cb5cc0ca12$export$954ab33cf89a3d04(key, context) {
    if (!$9b5db1cb5cc0ca12$export$a5c43a85198b9978(key)) return false;
    // eslint-disable-next-line no-console
    console.warn(`[filterableGallery] FilterDefinition.id "${key}" collides with a reserved URL key (${context}). URL sync skipped for this filter.`);
    return true;
}

});


parcelRegister("7Ofoh", function(module, exports) {
$parcel$export(module.exports, "useFireFilterClickAnalytics", function () { return $aa7e817244a8a5ef$export$95bea3ee3a9a8e3b; });

var $eY3N6 = parcelRequire("eY3N6");
const $aa7e817244a8a5ef$export$95bea3ee3a9a8e3b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (filterId)=>{
        createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "uniformFilterButton",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                labelEnglish: filterId,
                url: location.href,
                page_path: location.pathname,
                eventComponent: "uniformFilterButton"
            }
        }).fire();
    };
};

});


parcelRegister("ddUw7", function(module, exports) {
$parcel$export(module.exports, "useOutsideClick", function () { return $366b8f49f7729ef5$export$71b2224f1ce5e08e; });

var $1oC0p = parcelRequire("1oC0p");
const $366b8f49f7729ef5$export$71b2224f1ce5e08e = ({ isActive: isActive, insideMarkerAttribute: insideMarkerAttribute, onOutsideClick: onOutsideClick })=>{
    const onOutsideClickRef = (0, $1oC0p.useRef)(onOutsideClick);
    onOutsideClickRef.current = onOutsideClick;
    (0, $1oC0p.useEffect)(()=>{
        if (!isActive) return;
        const handleClick = (event)=>{
            const clickedInside = $366b8f49f7729ef5$var$isElementInsideMarkedAncestor(event.target, insideMarkerAttribute);
            if (!clickedInside) onOutsideClickRef.current();
        };
        document.addEventListener("click", handleClick);
        return ()=>document.removeEventListener("click", handleClick);
    }, [
        isActive,
        insideMarkerAttribute
    ]);
};
/**
 * Walks up from `target` until it finds an ancestor carrying
 * `markerAttribute`, or hits the document body. Returns true if the marker
 * was found along the way.
 */ const $366b8f49f7729ef5$var$isElementInsideMarkedAncestor = (target, markerAttribute)=>{
    let currentNode = target;
    while(currentNode && currentNode.nodeName !== "BODY"){
        if (currentNode.hasAttribute(markerAttribute)) return true;
        currentNode = currentNode.parentElement;
    }
    return false;
};

});


parcelRegister("ccVGG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("hTiWM")).default; });

var $hTiWM = parcelRequire("hTiWM");

});
parcelRegister("hTiWM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $08b31e9a84ad8ff1$export$2e2bcd8739ae039; });
/* filterable-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");

var $7sd2h = parcelRequire("7sd2h");

var $lG1Of = parcelRequire("lG1Of");
const $08b31e9a84ad8ff1$var$FilterableItem = ({ data: data, fullHeight: fullHeight = false })=>{
    const registry = (0, $lG1Of.useFilterableItemRegistry)();
    const index = (0, $1oC0p.useContext)((0, $lG1Of.FilterableItemIndexContext));
    const isFullHeight = $08b31e9a84ad8ff1$var$resolveBooleanParameter(fullHeight, false);
    (0, $1oC0p.useEffect)(()=>{
        if (!registry) return;
        registry.registerItem(index, data);
        return ()=>registry.unregisterItem(index);
    }, [
        registry,
        index,
        data
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7sd2h.FilterableCardItemDataContext).Provider, {
        value: data,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                isFullHeight && "_4t3i1osq _1e0c11p5"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "content"
            })
        })
    });
};
const $08b31e9a84ad8ff1$var$resolveBooleanParameter = (parameter, defaultValue)=>{
    if (typeof parameter === "boolean") return parameter;
    if (typeof parameter?.value === "boolean") return parameter.value;
    return defaultValue;
};
const $08b31e9a84ad8ff1$var$fullHeightStyle = null;
var $08b31e9a84ad8ff1$export$2e2bcd8739ae039 = $08b31e9a84ad8ff1$var$FilterableItem;

});


parcelRegister("7d42O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c0a87c7a69a87c04$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $hcVGp = parcelRequire("hcVGp");
const $c0a87c7a69a87c04$var$UniformGlobalNav = ({ productKey: // This productKey is used for UFO instrumentation
// This prop is standardized to the value `uniform`
// See ldr/0018-set-standard-uniform-globalnav-productkey.md for more details
productKey = "uniform", showCta: showCta = true })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: productKey,
        isShowTryNowLink: showCta
    });
var $c0a87c7a69a87c04$export$2e2bcd8739ae039 = $c0a87c7a69a87c04$var$UniformGlobalNav;

});

parcelRegister("wwZ1W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35f2008f0829ec0d$export$2e2bcd8739ae039; });
/* graph-paper-reveal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $35f2008f0829ec0d$var$containerStyles = null;
const $35f2008f0829ec0d$var$UniformGraphPaperReveal = ()=>{
    const ref = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const spotlight = ref.current;
        const parent = spotlight?.parentElement;
        function move(e) {
            if (!parent) return;
            const rect = parent.getBoundingClientRect();
            spotlight?.style.setProperty("--graph-grid-x", e.clientX - rect.left + "px");
            spotlight?.style.setProperty("--graph-grid-y", e.clientY - rect.top + "px");
        }
        if (window.PointerEvent) parent?.addEventListener("pointermove", move, {
            passive: true
        });
        return ()=>{
            parent?.removeEventListener("pointermove", move);
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: ref,
        className: (0, $2jatx.default)([
            "_kqswstnw _1r04idpf _1reo15vq _18m915vq _lcxvglyw _1kt9b3bt _1cs8stnw _1g0v1m4m _1tesidpf _1s6kxmqp _1ankwpg9 _wkf1atrn _aetrb3bt _18postnw _1bqq1mrw _9v7aidpf _16r21z0y"
        ])
    });
};
var $35f2008f0829ec0d$export$2e2bcd8739ae039 = $35f2008f0829ec0d$var$UniformGraphPaperReveal;

});

parcelRegister("f7IMH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0c2ad3f3cc2c800b$export$2e2bcd8739ae039; });
/* heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $dZNgt = parcelRequire("dZNgt");

var $kbpa7 = parcelRequire("kbpa7");

var $faxYF = parcelRequire("faxYF");
const $0c2ad3f3cc2c800b$var$EMPHASIS_COLOR_TO_HEX = {
    purple: (0, $kbpa7.wacToken)("color.primary.purple"),
    blue: (0, $kbpa7.wacToken)("color.primary.blue"),
    orange: (0, $kbpa7.wacToken)("color.extended.orange300")
};
/**
 * Recolors any `<em>` (italic) inside the heading to whatever value the
 * `--wac-heading-emphasis-color` CSS variable holds. The variable itself
 * is set as an inline style on the heading based on the `emphasisColor`
 * prop, which keeps this rule fully static so Compiled can extract it
 * cleanly at build time.
 */ const $0c2ad3f3cc2c800b$var$emphasisColorStyles = null;
var $0c2ad3f3cc2c800b$var$GestureLineType = /*#__PURE__*/ function(GestureLineType) {
    GestureLineType["UNDERLINE_SQUIGGLE"] = "underline-squiggle";
    GestureLineType["EYELASH"] = "eyelash";
    return GestureLineType;
}($0c2ad3f3cc2c800b$var$GestureLineType || {});
const $0c2ad3f3cc2c800b$var$UniformHeading = ({ text: text, uniformRichText: uniformRichText, customRichText: customRichText, styleType: styleType = "h1", alignment: alignment = "start", wordWrap: wordWrap, emphasisColor: emphasisColor })=>{
    const [headingRef, textColor] = (0, $faxYF.useStylePropertyVariableValueFromParent)("--dxp-container-text-color");
    const baseHeadingCss = null;
    const headingCss = [
        baseHeadingCss,
        // Only recolor `<em>` when the author explicitly picked a color.
        // Otherwise let italics render with the browser default font-style
        // and inherited color.
        emphasisColor && $0c2ad3f3cc2c800b$var$emphasisColorStyles,
        wordWrap && null
    ];
    // Inline-style overrides applied to the heading element. Sets the CSS
    // variable consumed by `emphasisColorStyles` (only when an emphasis
    // color is selected) and merges with the parent text color (if any)
    // so the heading itself still inherits container styling.
    const headingStyle = {
        ...emphasisColor ? {
            ["--wac-heading-emphasis-color"]: $0c2ad3f3cc2c800b$var$EMPHASIS_COLOR_TO_HEX[emphasisColor]
        } : null,
        ...textColor ? {
            color: textColor
        } : null
    };
    function resolveUniformRichText({ node: node, children: children }) {
        const nodeIsBold = (node)=>{
            return node.type === "text" && (0, $dZNgt.getRichTextTagsFromTextFormat)(node.format).includes("strong");
        };
        const richTextValueHasBold = (value)=>{
            let hasBold = false;
            (0, $dZNgt.walkRichTextTree)(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = richTextValueHasBold(node);
        return /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
            ref: headingRef,
            className: (0, $2jatx.default)([
                "_1mouidpf _y3gnoues _p12f1osq",
                emphasisColor && "_r7o3wj02 _cq6tn7od",
                wordWrap && "_1i4q1hna _3fcw150s",
                `${styleType} ${hasBoldText ? "h1-contrast" : ""}`
            ]),
            style: {
                ...headingStyle,
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            },
            children: children
        });
    }
    function resolveUniformRichTextRenderer(node) {
        if (node.type === "paragraph") return resolveUniformRichText;
        return undefined;
    }
    const customRichTextIsConsideredEmpty = (customRichTextPropValue)=>{
        return !customRichTextPropValue || customRichTextPropValue.plainText === "";
    };
    const renderCustomRichText = ()=>{
        const nodeIsBold = (node)=>{
            return node.type === "bold";
        };
        const walkCustomRichTextTree = (node, callBack)=>{
            callBack(node);
            if (node.children) node.children.forEach((child)=>{
                walkCustomRichTextTree(child, callBack);
            });
        };
        const customRichTextValueHasBold = (value)=>{
            let hasBold = false;
            walkCustomRichTextTree(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = ()=>{
            let hasBold = false;
            customRichText?.content.forEach((node)=>{
                if (customRichTextValueHasBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const renderCustomRichTextNode = (node, index)=>{
            switch(node.type){
                case "bold":
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                        children: node.children?.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                    }, index);
                case "underline-squiggle":
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm"
                        ]),
                        children: [
                            $0c2ad3f3cc2c800b$var$getGestureLine(node.type, node.color),
                            node.children?.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                        ]
                    }, index);
                case "eyelash":
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm"
                                ]),
                                children: [
                                    $0c2ad3f3cc2c800b$var$getGestureLine(node.type, node.color),
                                    node.children?.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                                ]
                            }, index)
                        ]
                    });
                case "text":
                default:
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: node.text || ""
                    }, index);
            }
        };
        return /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
            ref: headingRef,
            className: (0, $2jatx.default)([
                "_1mouidpf _y3gnoues _p12f1osq",
                emphasisColor && "_r7o3wj02 _cq6tn7od",
                wordWrap && "_1i4q1hna _3fcw150s",
                `${styleType} ${hasBoldText() ? "h1-contrast" : ""}`
            ]),
            style: {
                ...headingStyle,
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            },
            children: customRichText?.content.map((node, index)=>renderCustomRichTextNode(node, index))
        });
    };
    return !(0, $dZNgt.isRichTextValueConsideredEmpty)(uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichText), {
        parameterId: "uniformRichText",
        resolveRichTextRenderer: resolveUniformRichTextRenderer
    }) : !customRichTextIsConsideredEmpty(customRichText) ? renderCustomRichText() : /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
        ref: headingRef,
        className: (0, $2jatx.default)([
            "_1mouidpf _y3gnoues _p12f1osq",
            emphasisColor && "_r7o3wj02 _cq6tn7od",
            wordWrap && "_1i4q1hna _3fcw150s",
            styleType
        ]),
        style: {
            ...headingStyle,
            "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
        },
        children: text
    });
};
const $0c2ad3f3cc2c800b$var$getGestureLine = (gestureLine, gestureColor)=>{
    switch(gestureLine){
        case "underline-squiggle":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "168",
                height: "16",
                viewBox: "0 0 168 16",
                fill: "none",
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_kqswstnw _u7comgjw _1e021ssb _t9eczr6s"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M2.28772 11.6604C3.27772 12.0304 4.34772 11.9903 5.35772 11.8503C7.39772 11.5403 9.37772 10.8704 11.5877 10.1904C12.1377 9.84043 12.2377 9.88052 12.0577 9.53052C12.1777 9.40052 12.3777 9.17054 12.2377 9.05054C11.7477 8.23054 13.1677 7.92036 13.7077 7.62036C13.8777 8.38036 14.7577 8.34047 15.9677 7.98047C16.3177 7.88047 16.4477 7.83054 16.7777 7.80054C17.1377 7.75054 17.5177 7.69037 17.9177 7.63037C18.6977 7.55037 19.5677 7.43051 20.3677 7.52051C21.1777 7.59051 21.9477 7.82033 22.5477 8.34033C23.1577 8.85033 23.5977 9.61033 23.9377 10.3403C24.2777 11.0803 24.5277 11.7703 24.7977 12.3303C25.0477 12.8903 25.3077 13.2605 25.4377 13.4805C25.2677 13.7805 25.3077 14.2403 25.6877 14.5603C25.8477 14.7603 26.1177 14.8404 26.3877 14.9504C26.6777 15.0204 26.9977 15.0505 27.3177 15.0405C27.9777 14.9905 28.6077 14.7703 29.1477 14.6003C29.6277 14.4003 30.0777 14.2805 30.4177 14.2905C30.3777 14.3905 29.9477 14.8704 29.8977 14.9504C30.2677 15.0804 31.5877 14.5504 33.0877 13.6204C34.5877 12.6804 36.3277 11.3904 37.8377 10.1504C40.8877 7.70039 43.2477 5.65034 41.7577 7.85034C42.9077 7.23034 44.1177 6.56054 45.3277 5.80054C45.6277 5.61054 45.9377 5.42047 46.2477 5.23047L46.4577 5.10034L46.5577 5.05054C46.6177 5.02054 46.6877 4.98046 46.7477 4.97046H46.9577C46.9577 4.97046 47.0077 4.99048 47.0677 4.99048L47.3177 4.97046C47.6477 4.93046 47.9577 4.97046 48.2877 4.97046C49.5577 5.03046 50.7077 5.27036 51.5177 5.87036C52.3577 6.43036 53.0377 7.39032 53.8677 8.83032C54.2877 9.54032 54.7477 10.3605 55.4377 11.2405C56.1177 12.1105 57.1877 13.1003 58.5577 13.5903C58.8977 13.6903 59.2377 13.8104 59.5777 13.8804C59.9077 13.9304 60.2477 13.9705 60.5877 14.0005C61.2077 14.0005 61.8677 14.0004 62.4177 13.8804C62.6977 13.8304 62.9977 13.7905 63.2677 13.7205L64.0477 13.5005C64.5877 13.3605 65.0377 13.1605 65.5277 12.9805C69.2577 11.4205 72.3477 9.28033 75.4077 7.09033L77.3177 5.68042L78.2877 5.3103C78.6577 5.1603 78.9877 5.13052 79.3377 5.03052C79.5177 4.97052 79.6677 4.96045 79.8177 4.96045L80.2677 4.92041C80.4177 4.90041 80.5077 4.95044 80.6377 4.95044C80.7577 4.96044 80.8877 4.9505 80.9677 5.0105C81.3577 5.0805 81.7077 5.38037 82.1877 5.88037C83.1277 6.87037 84.1977 8.90048 86.2677 10.2405C86.7977 10.5505 87.3177 10.8705 87.8977 11.0505C88.1777 11.1505 88.4677 11.2603 88.7477 11.3403L89.6277 11.5005L90.1877 11.5903C90.3777 11.6103 90.5577 11.6904 90.7377 11.6204L91.7777 11.4004L93.0077 11.1504C99.5477 9.79039 105.978 9.92039 111.408 10.6504L111.248 10.4805C111.418 10.5405 111.958 10.4604 112.088 10.6704C113.168 10.3804 115.148 10.2204 116.858 10.1104C118.568 9.99035 120.008 9.98047 120.008 9.98047L126.178 9.68042C126.178 9.68042 128.828 10.0004 132.038 10.1804C135.248 10.3504 139.018 10.3505 141.168 9.75049C146.538 9.91049 151.978 9.90038 157.378 9.14038C157.378 9.14038 157.798 9.06042 158.458 8.93042C159.108 8.76042 159.998 8.50045 160.938 8.21045C161.878 7.90045 162.878 7.63048 163.728 7.24048C164.578 6.84048 165.308 6.46038 165.738 6.14038C166.818 5.34038 167.398 4.60032 167.398 4.08032C167.398 3.56032 166.798 3.26034 165.488 3.35034C164.838 3.40034 164.008 3.5403 162.978 3.8103C161.958 4.0903 160.678 4.30047 159.188 4.73047C159.108 4.69047 158.848 4.68034 158.798 4.60034C155.658 5.58034 152.388 5.81031 149.118 5.82031C147.488 5.85031 145.828 5.71044 144.178 5.70044C142.518 5.66044 140.838 5.55033 139.138 5.59033C139.218 5.88033 138.988 6.11045 138.788 5.96045L138.868 5.60034C134.278 6.20034 131.478 4.87037 127.188 5.88037C127.188 5.88037 127.698 5.43041 127.708 5.42041C124.088 5.28041 120.148 5.02035 115.968 4.86035C111.798 4.67035 107.398 4.61033 102.918 4.84033C101.798 4.92033 100.678 5.00032 99.5477 5.08032C98.4277 5.18032 97.2977 5.37051 96.1777 5.52051L94.4977 5.7605L92.8277 6.12036L91.1677 6.49048L90.4477 6.65039C90.5277 6.65039 90.4077 6.67039 90.3977 6.65039C90.3677 6.65039 90.3977 6.65037 90.3277 6.63037L90.0777 6.60034C89.8977 6.60034 89.7877 6.50046 89.6377 6.47046C89.3377 6.41046 89.1177 6.22034 88.8477 6.10034C88.3577 5.76034 87.8377 5.20043 87.2377 4.44043C86.6277 3.70043 85.9777 2.69047 84.7877 1.73047C84.5377 1.49047 84.1477 1.29032 83.8277 1.08032C83.4977 0.860322 83.1177 0.720332 82.7377 0.590332C81.9677 0.270332 81.2177 0.260439 80.4877 0.200439C80.5177 0.210439 80.5577 0.240498 80.5977 0.260498L80.5477 0.310303C80.8177 0.380303 81.2077 0.480342 81.6777 0.600342C82.1377 0.700342 82.7077 1.02054 83.2677 1.30054C84.3877 2.00054 85.2177 3.07043 85.7777 3.94043C86.3577 4.84043 86.7577 5.54052 87.1077 6.03052C87.4577 6.48052 87.6877 6.76048 87.6877 6.74048C86.5777 6.38048 85.6577 5.36052 84.6977 4.28052C84.1877 3.75052 83.6877 3.17048 82.9877 2.74048C82.3277 2.26048 81.5077 2.01037 80.6977 1.88037C79.8977 1.79037 79.0677 1.79041 78.3077 1.92041C77.4877 1.99041 76.8377 2.21041 76.0077 2.42041L75.6577 2.52051C75.5477 2.57051 75.4477 2.64045 75.3377 2.71045L74.8077 3.03052L73.9177 3.58032C73.3277 3.96032 72.7577 4.34047 72.1877 4.73047L71.9477 4.32031C72.9277 3.67031 73.7977 2.95035 74.5077 2.36035L74.6377 2.25049L74.8677 2.07031C75.0177 1.96031 75.1377 1.82049 75.2977 1.75049C75.5977 1.62049 75.8977 1.48039 76.0577 1.40039C76.4177 1.22039 76.7177 1.06042 76.9377 0.93042C76.6377 1.02042 76.3377 1.10043 76.0177 1.19043C75.8277 1.25043 75.6377 1.31036 75.4477 1.37036L75.0877 1.49048C74.9677 1.55048 74.8677 1.63044 74.7577 1.70044C74.2077 2.06044 73.6377 2.43031 73.0377 2.82031C71.9577 3.52031 70.7877 4.26048 69.5577 4.99048C68.3377 5.72048 67.0477 6.48035 65.7477 7.11035C64.4677 7.75035 63.1077 8.35031 61.9777 8.57031C61.4477 8.66031 60.9377 8.7304 60.6677 8.6604C60.3877 8.6004 60.2477 8.55031 59.9677 8.32031C59.6977 8.10031 59.3477 7.66033 58.9677 7.09033C58.5877 6.53033 58.1977 5.88043 57.7177 5.19043C56.8077 3.83043 55.4277 2.36054 53.8077 1.55054C52.1877 0.720537 50.5777 0.550342 49.3377 0.600342C49.3977 0.690342 49.6377 0.730479 49.9777 0.740479C50.3177 0.770479 50.7777 0.8304 51.2477 0.9104C51.7177 1.0204 52.2077 1.20043 52.5777 1.44043C52.9477 1.71043 53.2077 2.02036 53.2477 2.37036C52.0777 1.73036 50.7777 1.51044 49.5877 1.45044L48.6977 1.43042L47.8477 1.50049C47.5677 1.52049 47.2777 1.53032 47.0177 1.58032C46.6977 1.63032 46.3777 1.67046 46.0677 1.72046C46.0177 1.53046 46.0977 1.40053 46.2577 1.29053C46.3377 1.24053 46.4377 1.19039 46.5477 1.15039C46.6377 1.11039 46.7077 1.0903 46.7977 1.0603C47.1377 0.950303 47.5377 0.960381 47.6577 0.890381C47.5377 0.880381 47.3277 0.840352 47.0677 0.860352C46.9377 0.860352 46.7877 0.870371 46.6277 0.880371C46.3877 0.900371 46.1277 0.930439 45.8477 0.950439C45.6977 0.960439 45.5477 0.980488 45.3777 1.00049L45.1277 1.02051C45.0477 1.05051 44.9877 1.11039 44.9177 1.15039C44.6377 1.35039 44.3377 1.56053 44.0177 1.79053C43.6377 2.05053 43.2077 2.3404 42.7477 2.6604C40.9377 3.9104 38.5277 5.5904 35.7377 7.4104C34.3477 8.3304 32.8477 9.23033 31.3077 10.0903C30.9277 10.2903 30.5377 10.4804 30.1477 10.6804C29.7677 10.8504 29.3877 11.0204 28.9977 11.1904L28.4577 11.3704L28.1877 11.4705L28.0877 11.4905C27.9377 11.5305 27.8877 11.5305 27.8177 11.5205C27.6677 11.5205 27.5777 11.3805 27.5377 11.2505L27.2377 10.2505C27.0977 9.76049 26.9177 9.1703 26.6777 8.5603C26.4377 7.9403 26.0877 7.27035 25.6277 6.61035C25.3577 6.29035 25.0977 5.96041 24.7877 5.67041C24.4577 5.40041 24.1377 5.09038 23.7677 4.89038C22.2977 3.98038 20.7377 3.74048 19.4877 3.74048C18.1677 3.71048 17.0877 3.89035 15.9277 4.11035C15.7477 4.16035 15.5177 4.15049 15.3077 4.25049L14.7377 4.49048L13.9977 4.83032C13.5277 5.06032 13.0777 5.2805 12.6577 5.5105C10.9577 6.4105 9.43772 7.26043 8.02772 7.94043C6.62772 8.62043 5.32772 9.14035 4.32772 9.36035C3.83772 9.47035 3.42772 9.49046 3.18772 9.47046C2.95772 9.46046 2.81772 9.42033 2.64772 9.34033C2.36772 9.20033 2.02772 8.68046 1.82772 8.22046C1.59772 7.77046 1.46772 7.39051 1.29772 7.27051C1.13772 7.14051 0.99772 7.24036 0.86772 7.62036C0.73772 8.01036 0.61772 8.68038 0.80772 9.64038C0.63772 9.58038 0.44772 9.51041 0.28772 9.42041C0.58772 10.4404 1.30772 11.3504 2.30772 11.7004L2.28772 11.6604Z",
                    fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                })
            });
        case "eyelash":
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "117",
                height: "117",
                viewBox: "0 0 117 117",
                fill: "none",
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_kqswstnw _rjxp120u _152txmi2 _1bsb1wug _4t3i1vuk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.93 74.8872C25.1564 75.4245 12.3829 73.151 16.0089 71.2258C17.2313 70.3577 18.3652 70.4522 18.7372 71.7455C19.127 69.2416 21.5364 72.5841 22.7056 71.7691C22.3041 70.0211 25.7765 73.6706 25.115 71.8518C38.9455 69.9857 66.6537 86.9815 32.7862 76.7356C36.1641 75.956 32.987 75.2593 31.4693 75.6431C33.6248 77.8813 27.306 75.9325 26.1426 75.1589C28.1032 75.2061 24.8788 73.5526 25.9359 74.8813L25.93 74.8872Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M51.0103 53.7517C49.2092 53.6395 41.6974 41.3562 40.7526 40.187C39.1994 37.311 43.345 37.0866 44.0123 39.5374C44.3489 39.9566 45.5123 43.4468 46.3568 41.9527C49.8823 42.7263 50.3548 48.9624 53.3311 49.3522C52.8528 50.173 53.9039 51.1533 53.6618 51.7025C54.5476 51.608 55.0377 52.795 54.8251 52.9013C58.5987 55.978 53.898 59.604 51.8784 55.1867C51.7248 55.3757 50.6973 54.5961 51.0102 53.7635L51.0103 53.7517Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M96.948 30.7506C98.5602 32.788 98.4539 30.6385 97.6566 29.6523C96.198 31.477 96.2098 27.2133 96.6999 26.1208C96.7885 26.5637 97.5562 26.6346 97.4263 25.7133C95.5838 26.5637 94.0779 14.9005 98.5661 19.991C98.5779 20.1918 97.0838 20.4457 97.5739 20.6287C99.8121 19.9851 98.4007 21.9989 98.2767 22.5363C99.4578 22.3945 98.4066 23.0087 98.9086 23.0855C100.438 22.2764 98.0641 25.5598 99.57 24.6681C102.245 27.0834 99.564 32.7408 101.962 34.5478C99.44 36.2545 104.241 44.3981 98.8437 41.6462C97.3378 38.0734 96.3988 35.1147 96.948 30.7506Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M67.6391 11.4579C71.2001 10.1291 71.1824 18.2727 72.8891 20.2983C75.2808 22.7136 85.4263 50.3746 77.5308 43.7665C74.5308 35.3689 70.6037 29.0087 68.2533 18.3672C67.7454 16.6664 65.0643 11.5051 67.6391 11.4579Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M43.5337 100.854C45.9077 103.617 48.5592 99.584 50.7796 101.828C54.2166 106.222 27.3351 110.663 27.7485 105.737C28.6757 101.551 41.7739 102.826 43.5337 100.854Z",
                        fill: (0, $kbpa7.wacToken)(`color.${gestureColor}`)
                    })
                ]
            });
        default:
            return null;
    }
};
var $0c2ad3f3cc2c800b$export$2e2bcd8739ae039 = $0c2ad3f3cc2c800b$var$UniformHeading;

});
parcelRegister("faxYF", function(module, exports) {
$parcel$export(module.exports, "useStylePropertyVariableValueFromParent", function () { return $21111e3490530253$export$a43348ac9682b5fa; });

var $1oC0p = parcelRequire("1oC0p");
const $21111e3490530253$export$a43348ac9682b5fa = (cssVariableName)=>{
    const ref = (0, $1oC0p.useRef)(null);
    const [propertyValue, setPropertyValue] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        if (!ref.current) return;
        let element = ref.current;
        let depth = 0;
        const maxDepth = 20; // prevent infinite loops
        while(element && depth < maxDepth){
            const computedStyle = getComputedStyle(element);
            const value = computedStyle.getPropertyValue(cssVariableName).trim();
            if (value && value !== "") {
                setPropertyValue(value);
                return;
            }
            element = element.parentElement;
            depth++;
        }
        setPropertyValue(undefined);
    }, [
        cssVariableName
    ]);
    return [
        ref,
        propertyValue
    ];
};

});


parcelRegister("jGtmE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0cf533147eaa151$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $us1N6 = parcelRequire("us1N6");
const $b0cf533147eaa151$var$renderHeroCarousel = ({ items: items })=>{
    // First pass to work through Uniform setting empty to "" vs undefined that underlying component expects
    // eslint-disable-next-line complexity
    const transformed = items.map((heroSlide)=>{
        const params = heroSlide.props?.children?.props?.data?.parameters;
        return {
            id: params.id?.value || undefined,
            eyebrow: params.tabEyebrow?.value || undefined,
            title: params?.tabLabel?.value || undefined,
            panel: {
                title: params.title?.value || undefined,
                body: params.body?.value || undefined,
                primaryCallToAction: params.buttonText?.value && params.buttonHref?.value ? {
                    "text": params.buttonText?.value,
                    "href": params.buttonHref?.value,
                    "aria-label": params.buttonAriaLabel?.value || undefined
                } : undefined,
                secondaryCallToAction: params.linkText?.value && params.linkHref?.value ? {
                    text: params.linkText?.value,
                    href: params.linkHref?.value,
                    type: params.linkType?.value || undefined,
                    ariaLabel: params.linkAriaLabel?.value || undefined
                } : undefined,
                bgColor: params.bgColor?.value || undefined,
                bgImage: {
                    lg: params.imageLarge?.value || undefined
                },
                layout: params.alignment?.value || undefined
            }
        };
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $us1N6.HeroCarousel), {
        tabsData: transformed
    });
};
const $b0cf533147eaa151$var$UniformHeroCarousel = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "tabdata",
            wrapperComponent: $b0cf533147eaa151$var$renderHeroCarousel
        })
    });
};
var $b0cf533147eaa151$export$2e2bcd8739ae039 = $b0cf533147eaa151$var$UniformHeroCarousel;

});
parcelRegister("us1N6", function(module, exports) {
$parcel$export(module.exports, "HeroCarousel", function () { return $13e2b0d7d2657b7f$export$b92905002f03c113; });
/* hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $hBYvx = parcelRequire("hBYvx");

var $660KI = parcelRequire("660KI");

var $kbpa7 = parcelRequire("kbpa7");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");
const $13e2b0d7d2657b7f$export$b92905002f03c113 = ({ tabsData: tabsData })=>{
    const [selectedTab, setSelectedTab] = (0, $1oC0p.useState)(0);
    const listRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { ref: lastTabRef, inView: isTabListEndVisible } = (0, $jKShK.useInView)({
        root: listRef?.current,
        threshold: 1
    });
    const { ref: firstTabRef, inView: isTabListStartVisible } = (0, $jKShK.useInView)({
        root: listRef?.current,
        threshold: 1
    });
    (0, $1oC0p.useEffect)(()=>{
        const listElement = listRef?.current;
        if (listElement) {
            const tabElement = listElement.children?.[selectedTab + 1];
            if (tabElement && typeof tabElement.scrollIntoView === "function") {
                tabElement.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "end"
                });
                tabElement.focus();
            }
        }
    }, [
        selectedTab
    ]);
    const onKeyDown = (e)=>{
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            let newFocusIndex = 0;
            if (e.key === "ArrowRight") {
                newFocusIndex = selectedTab + 1;
                if (newFocusIndex >= tabsData.length) newFocusIndex = 0;
            } else if (e.key === "ArrowLeft") {
                newFocusIndex = selectedTab - 1;
                // If we're at the start, move to the end
                if (newFocusIndex < 0) newFocusIndex = tabsData.length - 1;
            }
            setSelectedTab(newFocusIndex);
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "hero-carousel",
        "data-testid": "hero-carousel",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21sxn _1bsb1osq _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)($13e2b0d7d2657b7f$var$TabList, {
                    listRef: listRef,
                    isTabListViewable: isTabListStartVisible && isTabListEndVisible,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            ref: firstTabRef
                        }),
                        tabsData.map((tab, i)=>/*#__PURE__*/ (0, $7VQPk.jsxs)($13e2b0d7d2657b7f$var$Tab, {
                                isSelected: i === selectedTab,
                                id: tab.id,
                                onClick: ()=>{
                                    setSelectedTab(i);
                                    createAnalyticsEvent({
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "tab",
                                        actionSubjectId: "heroCarouselTab",
                                        source: "heroSection",
                                        attributes: {
                                            label: tab.title,
                                            tabIndex: i
                                        }
                                    }).fire();
                                },
                                onKeyDown: onKeyDown,
                                children: [
                                    tab.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazcd5j _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "eyebrow-sm"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazcd5j _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "_syazcd5j _1wyb1j6v _k48pni7l _vwz410nf"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.title
                                    })
                                ]
                            }, tab.id)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            ref: lastTabRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelContainer, {
                    children: tabsData.map((tab, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$Panel, {
                            isSelected: i === selectedTab,
                            id: tab.id,
                            panel: tab.panel,
                            titleAs: i === 0 ? "h1" : "h2"
                        }, tab.id))
                })
            ]
        })
    });
};
var $13e2b0d7d2657b7f$export$2e2bcd8739ae039 = $13e2b0d7d2657b7f$export$b92905002f03c113;
const $13e2b0d7d2657b7f$var$TabList = ({ children: children, listRef: listRef, isTabListViewable: isTabListViewable })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q71hlo _1bsb1osq _syazcd5j _1reo15vq _18m915vq _18zrzwfg _su071wqb"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-expect-error - type mismatch
            ref: listRef,
            tabIndex: -1,
            role: "tablist",
            className: (0, $2jatx.default)([
                "_1tkegad4 _1e0c1txw _qtt8glyw _1mouidpf _195g1wug _18zridpf _1rjcie5z _1reo15zi _rjfvx6dd _b8yqzqdx _zcekze3t _kpfhglyw",
                isTabListViewable && "_1bah1h6o"
            ]),
            children: children
        })
    });
};
const $13e2b0d7d2657b7f$var$Tab = ({ children: children, isSelected: isSelected, id: id, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        tabIndex: isSelected ? 0 : -1,
        role: "tab",
        "aria-selected": isSelected ? "true" : "false",
        "aria-controls": `hero-panel-${id}`,
        id: `hero-tab-${id}`,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "data-label": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_mqm21kma _v564ucvz _179rglyw _h7alglyw _r06hglyw _bfhk1j28 _ect41kw7 _1wyb1j6v _1bsb1ltq _1ul91ltq _80omtlke _1hu1v2br _1rjcu2gc _18zr1ejb _4cvrv2br _1e0c1txw _2lx21bp4 _zulp12x7 _oxutkb7n _svxhkb7n _1ah3j39m",
            isSelected && "_mqm25cav _1wk5kb7n"
        ]),
        style: {
            "--_jxcf9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.saffron"))
        },
        children: children
    });
};
const $13e2b0d7d2657b7f$var$PanelContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};
const $13e2b0d7d2657b7f$var$Panel = ({ isSelected: isSelected, id: id, panel: panel, ...props })=>{
    const [isModalOpen, setIsModalOpen] = (0, $1oC0p.useState)(false);
    const baseStyle = null;
    const isVideoLink = panel.secondaryCallToAction?.type === "video";
    const isForegroundLight = [
        "blue",
        "black"
    ].includes(panel.bgColor);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "tabpanel",
        id: `hero-panel-${id}`,
        "data-testid": `hero-panel-${id}`,
        "aria-hidden": !isSelected,
        // @ts-expect-error -- inert is a valid HTML attribute but missing from @compiled/react types
        inert: !isSelected ? "" : undefined,
        "aria-labelledby": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_v564twcc _yyhy183o _1ii7183o _1e0c11p5 _tzy4idpf _1pby1mrw _kqswh2mm",
            isSelected && "_tzy4kb7n _1pbykb7n",
            "_1kt9b3bt _1g0v1mrw _1cs8stnw _1tesidpf _1rusu6yl _aetrb3bt _1bqq1mrw _18postnw _16gxidpf _z0ai1osq _wbcj14i6 _1kje1h6o _1hfku6yl _1a1fdirt _19h91dfr _z0bc12wd"
        ]),
        style: {
            "--bg-color": panel.bgColor === "neutral" ? (0, $kbpa7.wacToken)(`color.neutral.light200`) : (0, $kbpa7.wacToken)(`color.primary.${panel.bgColor}`),
            "--_1gk99st": (0, $6ZVlx.default)(panel.bgImage?.lg ? `url(${panel.bgImage.lg})` : undefined),
            "--_xe4ghn": (0, $6ZVlx.default)(panel.layout === "end" ? "0% 50%" : "center center")
        },
        children: [
            isVideoLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $660KI.Modal), {
                isOpen: isModalOpen,
                closeModal: ()=>{
                    setIsModalOpen(false);
                },
                closeLabel: "Close video",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBYvx.Video), {
                    muted: false,
                    videoType: "mp4",
                    videoLink: panel.secondaryCallToAction?.href
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_yyhy183o _1ii7183o _18zrzwfg _1rjcxncg _1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1ejb _1qon1h6o _1lb81h6o _5qqy1h6o _su071wqb _1rqtcx6w _pdlmxy5q _10jxzqdx",
                    isForegroundLight && "_cg41121t _125x121t",
                    panel.layout === "end" ? "_1uyy1d44 _1cxzv2br _10wbv2br _s0n3v2br" : panel.layout === "start" ? "_1uyy1vi5 _1cxzv2br _10wbv2br _s0n3v2br" : "_1uyyeqnf"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelContent, {
                        panel: panel,
                        titleAs: props.titleAs
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelActions, {
                        ...panel,
                        onVideoClick: isVideoLink ? (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsModalOpen(true);
                        } : undefined
                    })
                ]
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelContent = ({ panel: panel, ...props })=>{
    const { titleAs: Title = "h2" } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)(Title, {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "h1"
                ]),
                children: panel.title
            }),
            panel.body && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "body-lg"
                ]),
                children: panel.body
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelActions = (panel)=>{
    return panel && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1n261g80 _zulp1ejb",
            (panel.layout === "start" || panel.layout === "end") && "_msupv2br"
        ]),
        children: [
            panel.primaryCallToAction && /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PrimaryCallToAction, {
                bgColor: panel.bgColor,
                ...panel.primaryCallToAction
            }),
            panel.secondaryCallToAction && /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$SecondaryCallToAction, {
                ...panel
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PrimaryCallToAction = (props)=>{
    const { bgColor: bgColor, ...rest } = props;
    let variant = "primary";
    if (bgColor === "blue") variant = "primary_alt";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        ...rest,
        variant: variant,
        "data-testid": "primary-cta",
        children: props.text
    });
};
const $13e2b0d7d2657b7f$var$SecondaryCallToAction = (panel)=>{
    const { secondaryCallToAction: secondaryCallToAction } = panel;
    const bgColor = [
        "blue",
        "black"
    ].includes(panel.bgColor) ? "bgBlackBlue" : "bgWhite";
    return(// @ts-expect-error - link doesn't have children
    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        ...secondaryCallToAction,
        bgColor: bgColor,
        anchorProps: {
            "data-testid": "secondary-cta"
        },
        onClick: panel.onVideoClick,
        onKeyDown: panel.onVideoClick,
        role: "button",
        tabIndex: 0,
        children: secondaryCallToAction?.text
    }));
};
const $13e2b0d7d2657b7f$var$sectionStyles = null;
const $13e2b0d7d2657b7f$var$tabListStyle = null;
const $13e2b0d7d2657b7f$var$scrollableStyle = null;
const $13e2b0d7d2657b7f$var$fittableStyle = null;
const $13e2b0d7d2657b7f$var$tabStyle = null;
const $13e2b0d7d2657b7f$var$tabTextStyle = null;
const $13e2b0d7d2657b7f$var$tabTitleStyle = null;
const $13e2b0d7d2657b7f$var$tabSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelContainerStyle = null;
const $13e2b0d7d2657b7f$var$panelStyle = null;
const $13e2b0d7d2657b7f$var$panelSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelDetailsStyle = null;
const $13e2b0d7d2657b7f$var$panelEndStyle = null;
const $13e2b0d7d2657b7f$var$panelStartStyle = null;
const $13e2b0d7d2657b7f$var$panelCenteredStyle = null;
const $13e2b0d7d2657b7f$var$detailsTextStyle = null;
const $13e2b0d7d2657b7f$var$panelColorStyle = null;
const $13e2b0d7d2657b7f$var$actionContainerStyle = null;
const $13e2b0d7d2657b7f$var$actionStartStyle = null;

});
parcelRegister("660KI", function(module, exports) {
$parcel$export(module.exports, "Modal", function () { return $d050fad9e00c5863$export$2b77a92f1a5ad772; });
/* modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $ddxTX = parcelRequire("ddxTX");

var $h6Fsc = parcelRequire("h6Fsc");

var $4kArV = parcelRequire("4kArV");
var $izxiU = parcelRequire("izxiU");
var $9GQ1i = parcelRequire("9GQ1i");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");
const $d050fad9e00c5863$export$2b77a92f1a5ad772 = ({ title: title, closeLabel: closeLabel, isOpen: isOpen, closeModal: closeModal, width: width, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izxiU.default), {
        children: isOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4kArV.default), {
            onClose: closeModal,
            shouldScrollInViewport: true,
            width: width,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($d050fad9e00c5863$var$CustomHeader, {
                        title: title,
                        closeLabel: closeLabel
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt4xy5q"
                        ]),
                        children: children
                    })
                ]
            })
        })
    });
};
const $d050fad9e00c5863$var$CustomHeader = ({ title: title, closeLabel: closeLabel })=>{
    const intl = (0, $8e22h.default)();
    const { onClose: onClose, titleId: titleId } = (0, $9GQ1i.useModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClose = (e)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "closeModal",
            source: "modal",
            attributes: {
                label: "close modal"
            }
        }).fire();
        onClose?.(e, {});
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0e1o6p _ae4v1h6o _1yt4xy5q _179r11b3"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "card-title"
                ]),
                id: titleId,
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                appearance: "subtle-link",
                onClick: handleClose,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
                    label: closeLabel ?? intl.formatMessage({
                        id: "Modal.closeIconLabel",
                        defaultMessage: "close modal"
                    })
                })
            })
        ]
    });
};
const $d050fad9e00c5863$var$mainContentStyle = null;
const $d050fad9e00c5863$var$titleStyle = null;

});



parcelRegister("dr4ha", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d40bb110636103fe$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $eizE0 = parcelRequire("eizE0");
const $d40bb110636103fe$var$UniformHeroScrollToEnlargeContainer = ({ isTransform: isTransform })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eizE0.ScrollToEnlarge), {
        isTransform: isTransform,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "content"
        })
    });
};
var $d40bb110636103fe$export$2e2bcd8739ae039 = $d40bb110636103fe$var$UniformHeroScrollToEnlargeContainer;

});
parcelRegister("eizE0", function(module, exports) {
$parcel$export(module.exports, "ScrollToEnlarge", function () { return $3b02598d110ef439$export$d38db68c757989ac; });
/* scroll-to-enlarge.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $3b02598d110ef439$var$scaleUpSm = null;
const $3b02598d110ef439$var$scaleUpMd = null;
const $3b02598d110ef439$var$transformContainerStyles = null;
const $3b02598d110ef439$var$dimensionsUpSm = null;
const $3b02598d110ef439$var$dimensionsUpMd = null;
const $3b02598d110ef439$var$dimensionsContainerStyles = null;
const $3b02598d110ef439$export$d38db68c757989ac = ({ isTransform: isTransform = false, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            isTransform && "",
            isTransform && "",
            isTransform && "_8hrz1nut _p0azweqd _1tntp1rm _poph1jeq _9dw31mjz _ugw21g55 _1k2qeoah _1hcndy1v _1gq61pf3",
            !isTransform && "",
            !isTransform && "",
            !isTransform && "_195g1wug _glte1v4r _poph1jeq _9dw31mjz _ugw21g55 _1k2qeoah _1hcn6d3o _1gq61sn3"
        ]),
        style: {
            "--_1ptu23k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease-both"))
        },
        children: children
    });
};

});


parcelRegister("2XwEb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3bc05aa7eb0605f5$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8J2ZV = parcelRequire("8J2ZV");

var $jQ0cd = parcelRequire("jQ0cd");
const $3bc05aa7eb0605f5$var$UniformHeroSection = (props)=>{
    const localizedButtonHref = (0, $jQ0cd.useLocalizedHref)(props.buttonHref?.path ?? "");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8J2ZV.default), {
        heading: props.heading,
        size: props.size,
        subheading: props.subheading,
        layout: props.layout ?? "image-right",
        backgroundColor: props.backgroundColor,
        callToActionProps: props.buttonHref && props.buttonLabel ? {
            text: props.buttonLabel,
            href: localizedButtonHref,
            variant: props.buttonVariant ?? "primary",
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection"
            }
        } : undefined,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: props.imageAlt ?? ""
        } : undefined,
        secondaryImageProps: props.secondaryImageUrl ? {
            src: props.secondaryImageUrl,
            alt: ""
        } : undefined
    });
};
var $3bc05aa7eb0605f5$export$2e2bcd8739ae039 = $3bc05aa7eb0605f5$var$UniformHeroSection;

});
parcelRegister("8J2ZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3798516d873ca4cc$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $3798516d873ca4cc$export$887967f05dc521ae = ({ layout: layout = "image-right", ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        style: {
            "--background-color": `${props.backgroundColor ? (0, $kbpa7.wacToken)(props.backgroundColor) : "transparent"}`
        },
        className: (0, $2jatx.default)([
            "_11q76ulk"
        ]),
        children: layout === "image-both" ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroBothImages, {
            ...props
        }) : layout === "no-image" ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroNoImage, {
            ...props
        }) : layout === "image-below" ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroImageBelow, {
            ...props
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroOneImage, {
            layout: layout,
            ...props
        })
    });
};
var $3798516d873ca4cc$export$2e2bcd8739ae039 = $3798516d873ca4cc$export$887967f05dc521ae;
const $3798516d873ca4cc$var$DARK_BKGD_COLORS = [
    "color.primary.black"
];
const $3798516d873ca4cc$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, size: size = "regular", backgroundColor: backgroundColor })=>{
    const { text: buttonText, ...buttonProps } = callToActionProps ?? {};
    const isLarge = size === "large";
    const useLightText = backgroundColor ? $3798516d873ca4cc$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    const uniqueId = (0, $1oC0p.useId)();
    const headingId = `hero-heading-${uniqueId}`;
    const buttonId = `hero-cta-${uniqueId}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                id: headingId,
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)("color.neutral.light0") : "inherit"
                },
                className: (0, $2jatx.default)([
                    "_18s8ze3t",
                    isLarge ? "superhero" : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1pfhu2gc _6rthze3t",
                    isLarge ? "body-lg" : "body-md"
                ]),
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)("color.neutral.light0") : "inherit"
                },
                children: subheading
            }),
            buttonText && buttonProps && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1q51xy5q"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                    ...buttonProps,
                    id: buttonId,
                    size: "large",
                    ariaLabelledby: `${buttonId} ${headingId}`,
                    children: buttonText
                })
            })
        ]
    });
};
const $3798516d873ca4cc$var$HeroOneImage = ({ layout: layout = "image-right", imageProps: imageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        layout === "image-left" && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                        ...props
                    })
                }),
                imageProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: imageProps.alt ?? "",
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $3798516d873ca4cc$var$gridStyle = null;
const $3798516d873ca4cc$var$headingStyle = null;
const $3798516d873ca4cc$var$imageStartStyle = null;
const $3798516d873ca4cc$var$bodyStyle = null;
const $3798516d873ca4cc$var$buttonWrapperStyle = null;
/*
This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
Initial support is seen on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine

TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
  Currently it is very tailored to the aforementioned enterprise experience. 
  We may need to ensure we use Image so that we can add an alt text if needed.
*/ const $3798516d873ca4cc$var$HeroBothImages = ({ imageProps: imageProps, secondaryImageProps: secondaryImageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_uaqo1x3a _13j917im",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1thiznr": (0, $6ZVlx.default)(imageProps ? `url(${imageProps.src})` : "none"),
                    "--_c31b9r": (0, $6ZVlx.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : "none")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                    ...props,
                    size: "regular"
                })
            })
        })
    });
};
const $3798516d873ca4cc$var$gridTwoImagesStyle = null;
const $3798516d873ca4cc$var$HeroNoImage = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "10",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _1rjc1jfw _1ooboahv _1s0lxncg",
                "_85i5xncg"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                ...props
            })
        })
    });
};
const $3798516d873ca4cc$var$centerTextWrapperStyle = null;
const $3798516d873ca4cc$var$noImageBottomPaddingStyle = null;
const $3798516d873ca4cc$var$HeroImageBelow = ({ imageProps: imageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "10",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _85i5xncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _1rjc1jfw _1ooboahv _1s0lxncg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                        ...props
                    })
                }),
                imageProps && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1pfhxy5q _1nlx1osq _mezj1osq _v4pn1ule"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: imageProps.src,
                        alt: imageProps.alt ?? "",
                        loading: "eager",
                        width: imageProps.width,
                        height: imageProps.height
                    })
                })
            ]
        })
    });
};
const $3798516d873ca4cc$var$imageBelowContainerStyle = null;
const $3798516d873ca4cc$var$imageBelowImageWrapperStyle = null;

});


parcelRegister("2oS3p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e060563c171063cc$export$2e2bcd8739ae039; });
/* horizontal-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $4OgEb = parcelRequire("4OgEb");

var $kbpa7 = parcelRequire("kbpa7");
const $e060563c171063cc$var$dividerStyle = null;
const $e060563c171063cc$var$UniformHorizontalDivider = ({ lineStyle: lineStyle = "solid" })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
        role: "presentation",
        style: {
            borderBlockStart: `1px ${lineStyle} ${(0, $kbpa7.wacToken)("color.neutral.light400")}`
        },
        className: (0, $2jatx.default)([
            "_1bsb1osq _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    });
};
$e060563c171063cc$var$UniformHorizontalDivider.propTypes = {
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string
};
var $e060563c171063cc$export$2e2bcd8739ae039 = $e060563c171063cc$var$UniformHorizontalDivider;

});

parcelRegister("6JkkA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c1fa0ef514a5e9e$export$2e2bcd8739ae039; });
/* image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");
const $5c1fa0ef514a5e9e$var$UniformImage = ({ source: source, altText: altText = "", width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null;
    // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: source,
            alt: altText
        },
        className: (0, $2jatx.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            makeCircle && "_2rko1ssb"
        ]),
        style: {
            ...imageStyle,
            "--_m5r7t4": (0, $6ZVlx.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $6ZVlx.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $6ZVlx.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $6ZVlx.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : "auto")
        }
    });
};
var $5c1fa0ef514a5e9e$export$2e2bcd8739ae039 = $5c1fa0ef514a5e9e$var$UniformImage;

});

parcelRegister("1ij5s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $00ee4cee431699a0$export$2e2bcd8739ae039; });
/* image-v2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $00ee4cee431699a0$var$UniformImageV2 = ({ source: source, altText: altText = "", caption: caption, width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false, roundedCorners: roundedCorners = false, mobileSrc: mobileSrc, tabletSrc: tabletSrc })=>{
    if (!source) return null;
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null;
    // @ts-expect-error types
    const responsiveStyles = null;
    const makeCircleStyle = null;
    const roundedCornersStyle = null;
    const pictureStyle = null;
    const { maxWidth: maxWidthStyle, ...restImageStyle } = imageStyle;
    const hasResponsiveSources = mobileSrc || tabletSrc;
    if (hasResponsiveSources) {
        const sources = [];
        // The <source> media attribute requires a plain CSS media query string —
        // the @atlaskit/primitives media tokens (e.g. media.below.sm) are
        // Compiled-JS values and cannot be used here. The pixel values below
        // correspond to media.below.sm (< 768px = mobile) and
        // media.below.md (< 1024px = tablet), consistent with breakpoints used
        // elsewhere in this codebase.
        // Note: these use max-width (desktop-first) because <source> elements
        // are evaluated top-to-bottom by the browser — the most specific
        // (smallest) breakpoint must come first. This is separate from the
        // mobile-first min-width approach used for CSS sizing props above.
        if (mobileSrc) sources.push({
            srcSet: mobileSrc,
            media: "(max-width: 767px)"
        });
        if (tabletSrc) sources.push({
            srcSet: tabletSrc,
            media: "(max-width: 1023px)"
        });
        const pictureElement = /*#__PURE__*/ (0, $7VQPk.jsxs)("picture", {
            className: (0, $2jatx.default)([
                width && "_1bsbzdsf",
                height && "_4t3i1rot",
                tabletWidth && "_14b51mzn",
                desktopWidth && "_glte1k6c",
                tabletHeight && "_1xloa7f3",
                desktopHeight && "_165tbekw",
                roundedCorners && "_2rkovwyg",
                makeCircle && "_2rko1ssb",
                "_1e0c1ule"
            ]),
            style: {
                "--_m5r7t4": (0, $6ZVlx.default)(width ? width : "auto"),
                "--_mzs5ed": (0, $6ZVlx.default)(height ? height : "auto"),
                "--_dwkr3u": (0, $6ZVlx.default)(tabletWidth ? tabletWidth : "auto"),
                "--_1mc860w": (0, $6ZVlx.default)(desktopWidth ? desktopWidth : "auto"),
                "--_1cta8t7": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : "auto"),
                "--_1frmj6s": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : "auto"),
                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
            },
            children: [
                sources.map((src, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                        ...src
                    }, index)),
                /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: source,
                    alt: altText,
                    style: {
                        maxWidth: maxWidthStyle ?? "100%",
                        display: "block",
                        ...restImageStyle
                    }
                })
            ]
        });
        if (caption) return /*#__PURE__*/ (0, $7VQPk.jsxs)("figure", {
            className: (0, $2jatx.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
            ]),
            children: [
                pictureElement,
                /*#__PURE__*/ (0, $7VQPk.jsx)("figcaption", {
                    className: (0, $2jatx.default)([
                        "_1pfhu2gc",
                        "body-sm"
                    ]),
                    children: caption
                })
            ]
        });
        return pictureElement;
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        src: source,
        alt: altText,
        caption: caption,
        className: (0, $2jatx.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            roundedCorners && "_2rkovwyg",
            makeCircle && "_2rko1ssb"
        ]),
        style: {
            ...imageStyle,
            "--_m5r7t4": (0, $6ZVlx.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $6ZVlx.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $6ZVlx.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $6ZVlx.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $6ZVlx.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $6ZVlx.default)(desktopHeight ? desktopHeight : "auto"),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
        }
    });
};
var $00ee4cee431699a0$export$2e2bcd8739ae039 = $00ee4cee431699a0$var$UniformImageV2;

});

parcelRegister("3jkl6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26110392bbc93120$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $lAAJP = parcelRequire("lAAJP");

var $ifNiy = parcelRequire("ifNiy");

var $3OVYv = parcelRequire("3OVYv");

var $lTkkF = parcelRequire("lTkkF");

var $i4BST = parcelRequire("i4BST");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26110392bbc93120$var$UniformIntegration = (props)=>{
    const { eyebrow: eyebrow, title: title, titleAs: titleAs, titleAppearsAs: titleAppearsAs, body: body, richText: richText, linkLabel: linkLabel, linkHref: linkHref, logos: logos, clickableLogos: clickableLogos, background: background, backgroundColor: backgroundColor, flipLayout: flipLayout } = (0, $lAAJP.flattenLogoProps)(props);
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    if (isWacRefresh) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3OVYv.Integration), {
        title: title,
        titleAs: titleAs,
        titleAppearsAs: titleAppearsAs,
        body: richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: richText
        }) : body,
        linkLabel: linkLabel,
        linkHref: linkHref,
        linkDataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "integrationsSection"
        },
        logoLinkDataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "linkLogo",
            "data-event-container": "integrationsSection"
        },
        clickableLogos: clickableLogos,
        logos: logos
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ifNiy.Integration), {
        eyebrow: eyebrow,
        title: title,
        titleAs: titleAs,
        titleAppearsAs: titleAppearsAs,
        body: richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: richText
        }) : body,
        linkLabel: linkLabel,
        linkHref: linkHref,
        linkDataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "integrationsSection"
        },
        logoLinkDataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "linkLogo",
            "data-event-container": "integrationsSection"
        },
        logos: logos,
        background: background,
        backgroundColor: backgroundColor,
        flipLayout: flipLayout
    });
};
var $26110392bbc93120$export$2e2bcd8739ae039 = $26110392bbc93120$var$UniformIntegration;

});
parcelRegister("lAAJP", function(module, exports) {
$parcel$export(module.exports, "flattenLogoProps", function () { return $a69aeb5889de0c02$export$ffc5469ebe0e6998; });

var $f2QWG = parcelRequire("f2QWG");
const $a69aeb5889de0c02$export$ffc5469ebe0e6998 = (props)=>{
    return {
        ...props,
        logos: (0, $f2QWG.flattenValues)(props.logos)
    };
};

});

parcelRegister("ifNiy", function(module, exports) {
$parcel$export(module.exports, "Integration", function () { return $945afc5e0498e2e0$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2axoc = parcelRequire("2axoc");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $945afc5e0498e2e0$var$logoSizes = {
    regular: {
        size: "78px",
        cornerRadius: "18.7px"
    },
    large: {
        size: "100px",
        cornerRadius: "24px"
    }
};
const $945afc5e0498e2e0$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImageContainerStyles = null;
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1bsbcae7 _4t3icae7 _bfhkcd5j _19it1k0a _2rko13r7 _gltef22m _165tf22m _2oz41w8s _1dbz130s"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_1jpuyj7": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].size),
            "--_1k7rxgg": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].cornerRadius)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: props.href,
            ...props.dataEventProps ?? {},
            className: (0, $2jatx.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq _4cvr1h6o _1bah1h6o _1yt4u2gc"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbsq37 _4t3isbdl"
                ]),
                style: {
                    "--_1hn5070": (0, $6ZVlx.default)(props.width ? `${props.width}px` : "100%"),
                    "--_1jk4xy3": (0, $6ZVlx.default)(props.width ? "auto" : "100%")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: props.src,
                    alt: props.alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $945afc5e0498e2e0$export$8912007324034abd = ({ eyebrow: eyebrow, title: title, titleAs: titleAs = "h3", titleAppearsAs: titleAppearsAs, body: body, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, logoLinkDataEventProps: logoLinkDataEventProps, logos: logos, background: background = "polygon", backgroundColor: backgroundColor = "neutral.light100", flipLayout: flipLayout = false })=>{
    const numLogos = logos.filter((logo)=>logo.href ?? false).length;
    const logoSize = numLogos <= 6 ? "large" : "regular";
    const responsiveSectionDividerHeightsStyles = null;
    const sectionStyles = null;
    const polygonStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _kqswh2mm _1moul8wr _11q7fulm _1rjcq9zu",
            "_9luy1wqb _ce5au29b _wfa7llbu"
        ]),
        style: {
            "--_pxzrua": (0, $6ZVlx.default)(background === "full" ? 0 : "var(--ds-space-800, 64px)"),
            "--_1sgx88i": (0, $6ZVlx.default)(background === "full" ? (0, $kbpa7.wacToken)(`color.${backgroundColor}`) : "transparent")
        },
        children: [
            background === "polygon" && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q71xvm _kqswstnw _1bsb1osq _4t3imhst _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _1kt9b3bt _1cs8stnw _iajm14o7 _kfgtq9zu _1mp41osq _1s6k1xvm _tgsmcdv4 _aetrb3bt _18postnw _1qdgq9zu _19nq1osq _z0ai1osq _16r21xvm _1oj41mhh"
                ]),
                style: {
                    "--_vp2za": (0, $6ZVlx.default)((0, $kbpa7.wacToken)(`color.${backgroundColor}`))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_195g1wug _p12f1osq _1bsb1osq _kqswh2mm _1pbykb7n _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _p12f1to9 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q _8fz6nklw _688gkb7n",
                            flipLayout && "_1f49kb7n",
                            numLogos === 7 && "_w9am12am _1bhm12am"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($945afc5e0498e2e0$var$IntegrationLogo, {
                                ...logo,
                                logoSize: logoSize,
                                dataEventProps: logo.dataEventProps ?? logoLinkDataEventProps
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                        eyebrow: eyebrow,
                        title: title,
                        titleAs: titleAs,
                        titleAppearsAs: titleAppearsAs,
                        text: body,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref,
                                ...linkDataEventProps && {
                                    dataEventProps: linkDataEventProps
                                }
                            }
                        } : undefined,
                        alignment: {
                            mobile: "center",
                            tablet: "start",
                            desktop: "start"
                        }
                    })
                ]
            })
        ]
    });
};
const $945afc5e0498e2e0$var$contentContainerStyles = null;
const $945afc5e0498e2e0$var$logosContainerStyles = null;
const $945afc5e0498e2e0$var$sevenLogosGridStyles = null;

});

parcelRegister("3OVYv", function(module, exports) {
$parcel$export(module.exports, "Integration", function () { return $a9c45609cd9ba3bf$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2axoc = parcelRequire("2axoc");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $a9c45609cd9ba3bf$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        src: props.src,
        alt: props.alt,
        style: {
            width: "100%",
            height: "100%",
            objectFit: "contain"
        }
    });
    if (!props.clickable) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsbys9h _4t3iys9h _glte53f4 _165t53f4"
        ]),
        children: logoImage
    });
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsbys9h _4t3iys9h _glte53f4 _165t53f4"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: props.href,
            ...props.dataEventProps ?? {},
            className: (0, $2jatx.default)([
                "_4t3i1osq _1bsb1osq _1hbx1doa _skp01k4l"
            ]),
            children: logoImage
        })
    });
};
const $a9c45609cd9ba3bf$export$8912007324034abd = ({ title: title, titleAs: titleAs = "h3", titleAppearsAs: titleAppearsAs, body: body, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, logoLinkDataEventProps: logoLinkDataEventProps, clickableLogos: clickableLogos = true, logos: logos })=>{
    const sectionStyles = null;
    const responsiveButtonSize = {
        mobile: "small",
        tablet: "small",
        desktop: "large",
        xl_desktop: "large"
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _11q71rga _1e0c1txw _2lx21bp4 _zulpxncg _1rjcxncg _19wg1epz _16im1epz _pdlm16xz _1s0l16xz"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "8",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                    title: title,
                    titleAs: titleAs,
                    titleAppearsAs: titleAppearsAs,
                    text: body,
                    callToActionProps: linkLabel && linkHref ? {
                        button: {
                            href: linkHref
                        },
                        buttonText: linkLabel,
                        buttonVariant: "secondary",
                        responsiveSize: responsiveButtonSize,
                        ...linkDataEventProps && {
                            dataEventProps: linkDataEventProps
                        }
                    } : undefined,
                    alignment: {
                        mobile: "center",
                        tablet: "center",
                        desktop: "center"
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q"
                    ]),
                    children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a9c45609cd9ba3bf$var$IntegrationLogo, {
                            ...logo,
                            dataEventProps: logo.dataEventProps ?? logoLinkDataEventProps,
                            clickable: clickableLogos
                        }, index))
                })
            })
        ]
    });
};
const $a9c45609cd9ba3bf$var$logosContainerStyles = null;

});


parcelRegister("bkhKq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b9780893fe5c6ce3$export$2e2bcd8739ae039; });
/* invisible-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $b9780893fe5c6ce3$var$UniformInvisibleContent = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-content": props.content,
        className: (0, $2jatx.default)([
            "_1e0cglyw"
        ])
    });
};
var $b9780893fe5c6ce3$export$2e2bcd8739ae039 = $b9780893fe5c6ce3$var$UniformInvisibleContent;

});

parcelRegister("6jbRM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3255cbe80369d8fd$export$2e2bcd8739ae039; });
/* jira-templates-tab-content-subgrid-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $01zo5 = parcelRequire("01zo5");
const $3255cbe80369d8fd$export$2f2a2862921598f6 = ()=>{
    const renderJiraTemplatesTabContent = ({ items: items })=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulpv47k _dm2511p5 _dbjgidpf _1hvkidpf _isu4idpf _15qmidpf _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf _pdlm14hz _glte1osq _1vsw13cz _18jf188f _azss12kr _1rqt1we7"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "jiraTemplatesTabContent",
        wrapperComponent: renderJiraTemplatesTabContent
    });
};
var $3255cbe80369d8fd$export$2e2bcd8739ae039 = $3255cbe80369d8fd$export$2f2a2862921598f6;

});

parcelRegister("g9CPg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db671c237f518514$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $eY3N6 = parcelRequire("eY3N6");

var $hLJF4 = parcelRequire("hLJF4");

var $2WL8B = parcelRequire("2WL8B");

var $7GVWk = parcelRequire("7GVWk");

var $hnmMQ = parcelRequire("hnmMQ");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $lDqnU = parcelRequire("lDqnU");

var $bUqvj = parcelRequire("bUqvj");

var $fSk0D = parcelRequire("fSk0D");

var $3riD8 = parcelRequire("3riD8");
const $db671c237f518514$var$TRACKING_EVENT_NAMES = {
    loggedInHeroProductCtaClicked: "loggedInHeroProductCtaClicked",
    loggedInHeroAnotherSiteCtaClicked: "loggedInHeroAnotherSiteCtaClicked",
    loggedInHeroExploreFeaturesClicked: "loggedInHeroExploreFeaturesClicked",
    loggedInHeroCreateNewSiteClicked: "loggedInHeroCreateNewSiteClicked"
};
const $db671c237f518514$var$EXISTING_SITES_URL = "/try/cloud/signup?bundle=service-collection&primaryCollectionProduct=jira-servicedesk.ondemand";
const $db671c237f518514$export$cbc42fadf8b93ea3 = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "jsmLoggedInHero",
    source: "/software/jira-service-management"
};
const $db671c237f518514$var$jsmLoggedInCss = null;
const $db671c237f518514$var$heroSectionCss = null;
const $db671c237f518514$var$anchorContainer = null;
const $db671c237f518514$var$jsmSiteBoxCss = null;
const $db671c237f518514$var$headingCss = null;
const $db671c237f518514$var$starCss = null;
const $db671c237f518514$var$differentSiteCss = null;
const $db671c237f518514$var$subHeadingContainerCss = null;
const $db671c237f518514$var$createNewSiteAnchorCss = null;
const $db671c237f518514$var$subHeadingCss = null;
const $db671c237f518514$var$nameUnderlineCss = null;
const $db671c237f518514$var$inlineJSMLogoCss = null;
const $db671c237f518514$var$siteInfoContainerCss = null;
const $db671c237f518514$var$sitenameIconCss = null;
const $db671c237f518514$var$sitenameIconTextCss = null;
const $db671c237f518514$var$sitenameAndAvatarContainerCss = null;
const $db671c237f518514$var$siteNameSpanCss = null;
const $db671c237f518514$var$tooltipWrapperCss = null;
const $db671c237f518514$var$avatarContainerCss = null;
const $db671c237f518514$var$linkPlaceholderCss = null;
/**
 * JSM Logged-In Hero Section
 *
 * This component only renders for users who are logged in and have at least one JSM site.
 * For all other users (logged-out or logged-in without JSM), it returns null.
 *
 * Mimics the LoggedInHeroSection from the Jira Software page with JSM-specific messaging.
 */ const $db671c237f518514$var$JsmLoggedInHeroSection = ()=>{
    const loggedInHasJsm = (0, $2WL8B.useLoggedInHasJSM)();
    // Don't render while profile is loading or if user doesn't have JSM
    if (!loggedInHasJsm) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($db671c237f518514$var$JsmLoggedInHeroContent, {});
};
const $db671c237f518514$var$JsmLoggedInHeroContent = ()=>{
    const loggedInUserProfile = (0, $3riD8.useLoggedInUser)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    const intl = (0, $8e22h.default)();
    // Try to get name from props, and fallback to hook if needed
    const userFirstName = user.name?.split(" ")[0] ?? loggedInUserProfile.name?.split(" ")[0];
    // Try to get picture from props, and fallback to hook if needed
    const userPicture = user?.picture ?? loggedInUserProfile.picture;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const localizedTryLink = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=service-collection&createNew=true&primaryCollectionProduct=jira-servicedesk.ondemand");
    const [hasMultipleJsms, setHasMultipleJsms] = (0, $1oC0p.useState)(false);
    const [siteName, setSiteName] = (0, $1oC0p.useState)("");
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)("");
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)("");
    const { hasMultipleSites: mostRecentHasMultipleJsms, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials } = (0, $fSk0D.useRecentProductSite)({
        productKeyFilter: "jira-servicedesk.ondemand",
        activityClientProduct: "jira"
    });
    (0, $1oC0p.useEffect)(()=>{
        setHasMultipleJsms(mostRecentHasMultipleJsms);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        mostRecentHasMultipleJsms,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            ...$db671c237f518514$export$cbc42fadf8b93ea3,
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: "ATLAS-117392"
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _11q71ybm _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5112am _85i553f4 _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _syaz1hlo _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7conh1r _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp",
                            alt: ""
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41pz4 _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraServiceManagementPageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnltki _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_u1whbc": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.saffron400"))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraServiceManagementPageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraServiceManagementPageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: "Jira Service Management",
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _ahbq14id _12l21lpd"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lDqnU.JiraServiceManagementMarkBrandV3), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler($db671c237f518514$var$TRACKING_EVENT_NAMES.loggedInHeroCreateNewSiteClicked),
                            className: (0, $2jatx.default)([
                                "_ect4bzd7 _1wyb7vkz _k48pni7l _vwz41f4h _syazjk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new workspace"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhkcd5j _2rko1y44 _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1wcj _1rjc7vkz _18zr7vkz _1mougktf _kqswh2mm"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_11q7ihgv _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                        ]),
                                        style: {
                                            "--_1efrnav": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime300"))
                                        },
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                            className: (0, $2jatx.default)([
                                                "_syaz5wis _ect41pz4 _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o",
                                                "h4"
                                            ]),
                                            style: {
                                                "--_1yoj5ey": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime800")),
                                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                            },
                                            children: siteInitials
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3igktf"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                                    content: siteName,
                                                    position: "top-end",
                                                    mousePosition: "top",
                                                    tag: "span",
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_ect4bzd7 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                        ]),
                                                        style: {
                                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                                        },
                                                        children: siteName
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                ]),
                                                children: userPicture && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bUqvj.AvatarFacepile), {
                                                    max: 4,
                                                    iconSize: 24,
                                                    icons: [
                                                        userPicture
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                "data-testid": "goToJsmButton",
                                variant: "primary_alt",
                                href: siteUrl,
                                size: "large",
                                onClick: ()=>clickHandler($db671c237f518514$var$TRACKING_EVENT_NAMES.loggedInHeroProductCtaClicked),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "JiraServiceManagementPageTemplate.loggedInHero.goToJsm",
                                    defaultMessage: "Go to Jira Service Management"
                                })
                            })
                        ]
                    })
                }),
                hasMultipleJsms ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ect4bzd7 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: intl.formatMessage({
                            id: "JiraServiceManagementPageTemplate.loggedInHero.lookingForDifferentSite",
                            defaultMessage: "Looking for a different workspace?"
                        }),
                        href: $db671c237f518514$var$EXISTING_SITES_URL,
                        type: "primary",
                        onClick: ()=>clickHandler($db671c237f518514$var$TRACKING_EVENT_NAMES.loggedInHeroAnotherSiteCtaClicked)
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3iqslr"
                    ])
                })
            ]
        })
    });
};
var $db671c237f518514$export$2e2bcd8739ae039 = $db671c237f518514$var$JsmLoggedInHeroSection;

});
parcelRegister("fSk0D", function(module, exports) {
$parcel$export(module.exports, "useRecentProductSite", function () { return $780bc3687a084d28$export$86e5df7c422dcc77; });

var $1oC0p = parcelRequire("1oC0p");

var $gV7D4 = parcelRequire("gV7D4");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");
const $780bc3687a084d28$var$GRAPHQL_GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
const $780bc3687a084d28$var$START_URL = "https://start.atlassian.com";
const $780bc3687a084d28$var$constructLoginUrl = (url)=>{
    const loginUrl = new URL(url);
    loginUrl.pathname = "/login.jsp";
    const searchParam = new URLSearchParams();
    const browseUrl = new URL(loginUrl);
    browseUrl.pathname = "/browse";
    searchParam.append("os_destination", browseUrl.href);
    loginUrl.search = searchParam.toString();
    return loginUrl;
};
// @ts-ignore
const $780bc3687a084d28$var$getSitenameFromUrl = (url)=>{
    try {
        const tempUrl = new URL(url);
        return tempUrl.hostname.split(".")[0] || "";
    } catch  {
        return "";
    }
};
const $780bc3687a084d28$var$filterSitesByProductKey = (sites, productKeyFilter)=>{
    if (sites) {
        const filteredSites = sites.filter((site)=>{
            return site.products.some((product)=>{
                return product.productKey.includes(productKeyFilter);
            });
        }) || [];
        return filteredSites;
    } else return [];
};
const $780bc3687a084d28$export$86e5df7c422dcc77 = ({ productKeyFilter: productKeyFilter, activityClientProduct: activityClientProduct = "jira" })=>{
    const { profile: profile, user: user } = (0, $7GVWk.useUserContext)();
    const splitName = user.name?.split(" ");
    // @ts-ignore
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const activityClient = (0, $gV7D4.useActivityClient)("v3", "www.atlassian.com", undefined, $780bc3687a084d28$var$GRAPHQL_GATEWAY_URL);
    const availableProductSites = $780bc3687a084d28$var$filterSitesByProductKey(profile.attributes?.existingSites, productKeyFilter);
    const hasMultipleSites = availableProductSites.length > 1;
    const [siteName, setSiteName] = (0, $1oC0p.useState)("");
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)("");
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)("");
    const [cloudSiteId, setCloudSiteId] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        const promises = [];
        let mostRecentActivity;
        const fetchActivitiesPromise = activityClient.fetchActivities([
            50,
            125,
            250
        ], {
            limit: 5,
            products: [
                activityClientProduct
            ]
        }, [
            "workedOn",
            "viewed"
        ]).then((data)=>{
            // Filter activities to only include those from available product sites
            const filteredViewed = data.viewed.filter((activity)=>availableProductSites.some((site)=>site.cloudId === activity.object.rootContainerIdentifier.id));
            const filteredWorkedOn = data.workedOn.filter((activity)=>availableProductSites.some((site)=>site.cloudId === activity.object.rootContainerIdentifier.id));
            const mostRecentlyViewed = filteredViewed[0];
            const mostRecentlyWorkedOn = filteredWorkedOn[0];
            if (mostRecentlyViewed && mostRecentlyWorkedOn) mostRecentActivity = new Date(mostRecentlyViewed.timestamp) > new Date(mostRecentlyWorkedOn.timestamp) ? mostRecentlyViewed : mostRecentlyWorkedOn;
            else if (mostRecentlyWorkedOn) mostRecentActivity = mostRecentlyWorkedOn;
            else if (mostRecentlyViewed) mostRecentActivity = mostRecentlyViewed;
        }).catch((error)=>console.log(error));
        promises.push(fetchActivitiesPromise);
        Promise.allSettled(promises).then(()=>{
            if (mostRecentActivity) {
                const loginUrl = $780bc3687a084d28$var$constructLoginUrl(mostRecentActivity.object.url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split(".")[0] || "");
                setSiteInitials(loginUrl.hostname.slice(0, 1).toUpperCase() + loginUrl.hostname.slice(1, 2));
                setCloudSiteId(mostRecentActivity.object.rootContainerIdentifier.id);
            } else if (availableProductSites[0]) {
                const loginUrl = $780bc3687a084d28$var$constructLoginUrl(availableProductSites[0].url);
                setSiteUrl(loginUrl.href);
                setSiteName(loginUrl.hostname.split(".")[0] || "");
                setSiteInitials(loginUrl.hostname.slice(0, 1).toUpperCase() + loginUrl.hostname.slice(1, 2));
                setCloudSiteId(availableProductSites[0].cloudId);
            } else {
                setSiteUrl($780bc3687a084d28$var$START_URL);
                setSiteName("");
            }
        });
    }, []);
    return {
        splitName: splitName,
        hasMultipleSites: hasMultipleSites,
        siteName: siteName,
        siteUrl: siteUrl,
        siteInitials: siteInitials,
        cloudSiteId: cloudSiteId
    };
};

});


parcelRegister("ks0ka", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6351c758da902f43$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $jQ0cd = parcelRequire("jQ0cd");

var $aIIww = parcelRequire("aIIww");

var $iPPTB = parcelRequire("iPPTB");
const $6351c758da902f43$export$64bc9cd96d3d9a80 = (props)=>{
    let localizedHref = (0, $jQ0cd.useLocalizedHref)(props.href);
    const localizedPartnerDirectoryUrl = (0, $aIIww.useLocalizedPartnerDirectoryHref)(props.href);
    if (props.href !== localizedPartnerDirectoryUrl) localizedHref = localizedPartnerDirectoryUrl;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        ...props,
        "aria-label": props.text,
        href: localizedHref,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "link",
            "data-event": "clicked"
        }
    });
};
var $6351c758da902f43$export$2e2bcd8739ae039 = $6351c758da902f43$export$64bc9cd96d3d9a80;

});

parcelRegister("71BPb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $abc24fa26164e237$export$2e2bcd8739ae039; });
/* list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $lTkkF = parcelRequire("lTkkF");
const $abc24fa26164e237$var$UniformList = ({ gap: gap = "space.100", maxHeight: maxHeight, isHorizontal: isHorizontal = false })=>{
    const spaceTokenValue = (0, $lTkkF.spaceTokenValues)[gap];
    const listStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21q43 _zulpfogq _c71l1nve _1reo15vq _18m915vq"
        ]),
        style: {
            "--_edet6m": (0, $6ZVlx.default)(isHorizontal ? "row" : "column"),
            "--_e9ez6f": (0, $6ZVlx.default)("var(--ds-space-" + spaceTokenValue + ")"),
            "--_6stjzx": (0, $6ZVlx.default)(maxHeight ? maxHeight + "px" : "none")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "listItems"
        })
    });
};
var $abc24fa26164e237$export$2e2bcd8739ae039 = $abc24fa26164e237$var$UniformList;

});

parcelRegister("bmNwd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $68ad224476b69534$export$2e2bcd8739ae039; });
/* listv2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $4yv6j = parcelRequire("4yv6j");
// Helper functions to reduce complexity
const $68ad224476b69534$var$createResponsiveGapObject = (gapv2)=>({
        mobile: gapv2.mobile ?? "0",
        tablet: gapv2?.tablet ?? gapv2.mobile ?? "0",
        desktop: gapv2?.desktop ?? gapv2?.tablet ?? gapv2.mobile ?? "0"
    });
const $68ad224476b69534$var$createResponsiveOrientationObject = (orientation)=>({
        mobile: orientation.mobile || "vertical",
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: orientation.desktop || orientation.tablet || orientation.mobile || "vertical"
    });
const $68ad224476b69534$var$createResponsiveWrappedChildContentObject = (wrappedChildContent)=>({
        mobile: wrappedChildContent?.mobile || "nowrap",
        tablet: wrappedChildContent?.tablet || wrappedChildContent?.mobile || "nowrap",
        desktop: wrappedChildContent?.desktop || wrappedChildContent?.tablet || wrappedChildContent?.mobile || "nowrap"
    });
const $68ad224476b69534$var$createResponsiveJustifyContentObject = (justifyContent)=>({
        mobile: justifyContent.mobile || "flex-start",
        tablet: justifyContent?.tablet || justifyContent?.mobile || "flex-start",
        desktop: justifyContent?.desktop || justifyContent?.tablet || justifyContent.mobile || "flex-start"
    });
const $68ad224476b69534$var$getFlexWrapValue = (value)=>{
    if (value === "wrap") return "wrap";
    if (value === "wrap-reverse") return "wrap-reverse";
    return "nowrap";
};
const $68ad224476b69534$var$zeroMarginPadding = null;
const $68ad224476b69534$var$resetListStyles = null;
const $68ad224476b69534$var$createRenderListItems = (listType)=>{
    return ({ items: items })=>{
        // Only works for paired dt/dd items. Would need different solution for different structure
        if (listType === "dl") return items.map((item, index)=>{
            if (index % 2 === 0) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("dt", {
                        children: item
                    }),
                    items[index + 1] && /*#__PURE__*/ (0, $7VQPk.jsx)("dd", {
                        children: items[index + 1]
                    })
                ]
            }, index);
            return null;
        });
        if (listType === "ol") return items.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                    "_qtt8glyw _1e0c1txw _2lx21bp4 _zulp1crf _1lp7vrvc _q8t51q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4yv6j.ListItemNumber), {
                        value: index + 1
                    }),
                    item
                ]
            }, index));
        return items.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                className: (0, $2jatx.default)([
                    "_kkk2n7od _1e0c1txw",
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: item
            }, index));
    };
};
const $68ad224476b69534$var$UniformListV2 = ({ listType: listType, gapv2: gapv2 = {
    mobile: "0"
}, orientation: orientation = {
    mobile: "vertical"
}, wrappedChildContent: wrappedChildContent = {
    mobile: "nowrap"
}, justifyContent: justifyContent = {
    mobile: "flex-start"
} })=>{
    const gapObject = $68ad224476b69534$var$createResponsiveGapObject(gapv2);
    const orientationObject = $68ad224476b69534$var$createResponsiveOrientationObject(orientation);
    const wrappedChildContentObject = $68ad224476b69534$var$createResponsiveWrappedChildContentObject(wrappedChildContent);
    const justifyContentObject = $68ad224476b69534$var$createResponsiveJustifyContentObject(justifyContent);
    // css() calls must be inline for Compiled CSS static analysis
    const listStyle = null;
    const orientationStyle = null;
    const wrappedChildContentStyle = null;
    const justifyContentStyle = null;
    const renderListItems = $68ad224476b69534$var$createRenderListItems(listType);
    const ListTypeComponent = listType || "ul";
    return /*#__PURE__*/ (0, $7VQPk.jsx)(ListTypeComponent, {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            "_1hmt1wth _16wj1p3b _1q2jw4vn",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6",
            "_1e0c1txw _1n261g80 _zkhy1g80 _45zz1g80",
            "_1bahown3 _e8gh2fwo _msup1t9b"
        ]),
        style: {
            "--_rkv8x9": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $6ZVlx.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $6ZVlx.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $6ZVlx.default)(orientationObject.desktop === "horizontal" ? "row" : "column"),
            "--_vie9y1": (0, $6ZVlx.default)(justifyContentObject.mobile),
            "--_1rrey82": (0, $6ZVlx.default)(justifyContentObject.tablet),
            "--_pc7561": (0, $6ZVlx.default)(justifyContentObject.desktop)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "listItems",
            wrapperComponent: renderListItems
        })
    });
};
var $68ad224476b69534$export$2e2bcd8739ae039 = $68ad224476b69534$var$UniformListV2;

});
parcelRegister("4yv6j", function(module, exports) {
$parcel$export(module.exports, "ListItemNumber", function () { return $5cbfb5c1496470c1$export$448080ad20b09ab8; });
/* list-item-number.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");
const $5cbfb5c1496470c1$export$448080ad20b09ab8 = (props)=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3ickbl _1bsbckbl _2rko1osq _11q76kkz _1e0c1txw _1bah1h6o _4cvr1h6o _syaz1tj6 _y3gn1h6o _ect41pz4 _1wybgktf _zg8l4jg8 _k48p1fw0 _vwz4183y"
        ]),
        style: {
            "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200")),
            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900")),
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
        },
        children: value
    });
};

});


parcelRegister("5c1uT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd7e060da4850d2d$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $behZZ = parcelRequire("behZZ");

var $lAAJP = parcelRequire("lAAJP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fd7e060da4850d2d$var$UniformLogos = (intakeProps)=>{
    const { title: title, logos: logos } = (0, $lAAJP.flattenLogoProps)(intakeProps);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $behZZ.Logos), {
        title: title,
        logos: logos
    });
};
var $fd7e060da4850d2d$export$2e2bcd8739ae039 = $fd7e060da4850d2d$var$UniformLogos;

});
parcelRegister("behZZ", function(module, exports) {
$parcel$export(module.exports, "Logos", function () { return $511c14fce74817fd$export$c847549a613b9060; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");

var $i4BST = parcelRequire("i4BST");
// Per GWP-11501 design spec:
// - All logos render in a 32px-tall container at every breakpoint.
// - Default max width is 140px; logos that need more horizontal room (e.g.
//   HarperCollins) can opt into the wider 240px slot via `wider: true`.
//
// Note (per Dan's dev notes on GWP-11501):
// - Items #6 (remove play/pause for reduced motion) and #7 (padding rules
//   when the button is removed) are deferred — there is an ongoing Slack
//   discussion about the right reduced-motion treatment, so we keep the
//   existing PlayPauseControls behavior.
// - Item #8 (N100 background option) is handled at the Uniform
//   `blockContainer` level (which already exposes Neutral Light 100), not
//   on the Logos pattern itself.
const $511c14fce74817fd$var$LOGO_HEIGHT_PX = 32;
const $511c14fce74817fd$var$LOGO_MAX_WIDTH_PX = 140;
const $511c14fce74817fd$var$LOGO_WIDER_MAX_WIDTH_PX = 240;
/**
 * Measures the logos list and computes:
 * - `maxWidth`: a pixel budget to apply to the <ul> so flex-wrap distributes
 *   logos into evenly-sized rows (same row count, balanced widths).
 * - `overflowsViewport`: true when all logos can't fit on one row, meaning the
 *   marquee should be shown instead.
 */ function $511c14fce74817fd$var$useBalancedMaxWidth(logoCount) {
    const wrapperRef = (0, $1oC0p.useRef)(null);
    const listRef = (0, $1oC0p.useRef)(null);
    const [containerWidth, setContainerWidth] = (0, $1oC0p.useState)(0);
    const [measured, setMeasured] = (0, $1oC0p.useState)({
        widths: [],
        gap: 0
    });
    // Mirrors the last overflowsViewport result. Used to add a buffer when
    // switching back from marquee to logos — see the useMemo below.
    const overflowsViewportRef = (0, $1oC0p.useRef)(false);
    // Watch the wrapper div width. We observe the wrapper (not the <ul>) so
    // that applying maxWidth to the <ul> doesn't trigger the observer again.
    (0, $1oC0p.useEffect)(()=>{
        const el = wrapperRef.current;
        if (!el) return;
        const observer = new ResizeObserver(([entry])=>{
            // Ignore zero-width reports — the wrapper can briefly report zero
            // when hidden. Keep the last real width so overflowsViewport stays stable.
            if (entry && entry.contentRect.width > 0) setContainerWidth(entry.contentRect.width);
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    // Measure each logo's natural width and the gap between them.
    // Temporarily removes maxWidth and forces nowrap so all items are on one
    // row, giving accurate individual widths and a correct gap reading.
    (0, $1oC0p.useEffect)(()=>{
        const ul = listRef.current;
        if (!ul) return;
        const measure = ()=>{
            const prevMaxWidth = ul.style.maxWidth;
            const prevMargin = ul.style.margin;
            const prevFlexWrap = ul.style.flexWrap;
            ul.style.maxWidth = "none";
            ul.style.margin = "0";
            // Force all items onto one row so the gap between adjacent items
            // can be measured. The CSS class sets width:100% which overrides
            // width:max-content, so we use flexWrap:nowrap instead.
            ul.style.flexWrap = "nowrap";
            try {
                const items = Array.from(ul.querySelectorAll(":scope > li"));
                const widths = items.map((el)=>el.getBoundingClientRect().width);
                // Skip if all widths are zero — the list is hidden and not giving real values.
                if (widths.length > 0 && widths.every((w)=>w === 0)) return;
                // Detect same-row items by vertical overlap rather than exact
                // top equality — alignItems:center means different-height logos
                // have different top values even when on the same row.
                let gap = 0;
                const r0 = items[0]?.getBoundingClientRect();
                const r1 = items[1]?.getBoundingClientRect();
                if (r0 && r1 && r1.top < r0.bottom && r0.top < r1.bottom) gap = r1.left - r0.right;
                setMeasured({
                    widths: widths,
                    gap: gap
                });
            } finally{
                ul.style.maxWidth = prevMaxWidth;
                ul.style.margin = prevMargin;
                ul.style.flexWrap = prevFlexWrap;
            }
        };
        // Don't re-measure while the marquee is showing — we already know logos
        // overflow, and hidden items can return unreliable widths.
        if (overflowsViewportRef.current) return;
        // Wait for images to load before measuring (they affect logo widths).
        let cancelled = false;
        const images = Array.from(ul.querySelectorAll("img"));
        const unloaded = images.filter((img)=>!img.complete);
        if (unloaded.length === 0) measure();
        else Promise.all(unloaded.map((img)=>new Promise((res)=>img.addEventListener("load", ()=>res(), {
                    once: true
                })))).then(()=>{
            if (!cancelled) measure();
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        logoCount,
        containerWidth
    ]);
    const { maxWidth: maxWidth, overflowsViewport: overflowsViewport } = (0, $1oC0p.useMemo)(()=>{
        const result = (maxWidth, overflowsViewport)=>{
            overflowsViewportRef.current = overflowsViewport;
            return {
                maxWidth: maxWidth,
                overflowsViewport: overflowsViewport
            };
        };
        const { widths: widths, gap: gap } = measured;
        if (!containerWidth || widths.length === 0) return result(undefined, false);
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0) + gap * (widths.length - 1);
        // Everything fits on one row — no constraint needed.
        // Add a one-gap buffer when switching back from marquee to logos to
        // prevent flickering when resizing near the transition point.
        const clearanceNeeded = overflowsViewportRef.current ? gap : 0;
        if (totalWidth <= containerWidth - clearanceNeeded) return result(undefined, false);
        // Greedily split logos into rows given a max row pixel width budget.
        // Returns the pixel width of each row.
        const splitIntoRowWidths = (budget)=>{
            const rowWidths = [];
            let rowWidth = 0;
            for (const w of widths){
                const needed = rowWidth === 0 ? w : gap + w;
                if (rowWidth > 0 && rowWidth + needed > budget) {
                    rowWidths.push(rowWidth);
                    rowWidth = w;
                } else rowWidth += needed;
            }
            rowWidths.push(rowWidth);
            return rowWidths;
        };
        const currentRowWidths = splitIntoRowWidths(containerWidth);
        const numRows = currentRowWidths.length;
        if (numRows <= 1) return result(undefined, true);
        // Score by the minimum row width — maximising it ensures no row is
        // disproportionately short.
        const score = (rowWidths)=>Math.min(...rowWidths);
        // Candidate budgets: pixel width of every possible contiguous subsequence
        // of logos. These are the only meaningful flex-wrap split points.
        const candidateBudgets = new Set();
        for(let start = 0; start < widths.length; start++){
            let rowW = 0;
            for(let end = start; end < widths.length; end++){
                rowW += (widths[end] ?? 0) + (end > start ? gap : 0);
                candidateBudgets.add(rowW);
            }
        }
        let best;
        let bestScore = score(currentRowWidths);
        for (const budget of candidateBudgets){
            if (budget >= containerWidth) continue;
            const rowWidths = splitIntoRowWidths(budget);
            if (rowWidths.length !== numRows) continue;
            const s = score(rowWidths);
            if (s > bestScore) {
                bestScore = s;
                best = `${budget}px`;
            }
        }
        return result(best, true);
    }, [
        measured,
        containerWidth
    ]);
    return {
        maxWidth: maxWidth,
        overflowsViewport: overflowsViewport,
        wrapperRef: wrapperRef,
        listRef: listRef
    };
}
const $511c14fce74817fd$export$c847549a613b9060 = ({ title: title, logos: logos })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    // Declared here (not inside the isWacRefresh block) so hooks are never called conditionally.
    // Default to true (running); correct to false after mount if the user prefers reduced motion.
    // We do this in useEffect (not useState initializer) to avoid SSR/hydration mismatches,
    // since window.matchMedia is not available on the server.
    const [marqueeRunning, setMarqueeRunning] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) setMarqueeRunning(false);
    }, []);
    const logoColoringStyles = null;
    const { maxWidth: maxWidth, overflowsViewport: overflowsViewport, wrapperRef: wrapperRef, listRef: listRef } = $511c14fce74817fd$var$useBalancedMaxWidth(logos.length);
    const showMarquee = isWacRefresh && overflowsViewport;
    const logosComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: wrapperRef,
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            ref: listRef,
            style: maxWidth ? {
                maxWidth: maxWidth,
                margin: "0 auto"
            } : undefined,
            className: (0, $2jatx.default)([
                "_1e0c1txw _1n261g80 _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o",
                isWacRefresh && "_gy1p1epz _4t3izwfg _99s61epz _ikjd1epz _1plridpf"
            ]),
            children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        isWacRefresh && "_4t3i1osq _1e0c1txw _4cvr1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: logo.src,
                        alt: logo.alt,
                        className: (0, $2jatx.default)([
                            "_4t3izwfg _1bsb1wug",
                            "_kdam2v9e _16bu1vqo",
                            isWacRefresh ? "_4t3izwfg _1bsb1wug _p12f4dhv _5ral1f51 _rsuf1h6o" : logo.heightPercentage ? "_4t3in8c9" : logo.width && "_1bsb1y7t _4t3i1wug"
                        ]),
                        style: {
                            "--_y177ig": (0, $6ZVlx.default)(isWacRefresh // css color filter generator for color.neutral.light900
                             ? "brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)" : "grayscale(100%) brightness(66%)"),
                            "--_1v9vtiy": (0, $6ZVlx.default)(isWacRefresh ? "brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)" : "grayscale(100%) brightness(66%)"),
                            "--_120hwu8": (0, $6ZVlx.default)(logo.wider ? `${$511c14fce74817fd$var$LOGO_WIDER_MAX_WIDTH_PX}px` : `${$511c14fce74817fd$var$LOGO_MAX_WIDTH_PX}px`),
                            "--_mpa0nt": (0, $6ZVlx.default)(logo.heightPercentage, "%"),
                            "--_daj5q9": (0, $6ZVlx.default)(logo.width, "px")
                        }
                    })
                }, index))
        })
    });
    if (isWacRefresh) {
        const marqueeLogos = [
            ...logos,
            ...logos,
            ...logos,
            ...logos
        ];
        const originalCount = logos.length;
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1rjcxncg"
            ]),
            children: [
                showMarquee ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _2lx21bp4 _zulp1ejb"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _o5721q9c",
                                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1bsb1ns9",
                                    "_gy1p1epz _4t3izwfg _99s61epz _ikjd1epz _1plridpf",
                                    "_y44vhu9l _1y0c12j5"
                                ]),
                                style: {
                                    "--_1xkovpx": (0, $6ZVlx.default)(marqueeRunning ? "running" : "paused")
                                },
                                children: marqueeLogos.map((logo, index)=>{
                                    const isOriginal = index < originalCount;
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                        "aria-hidden": !isOriginal,
                                        className: (0, $2jatx.default)([
                                            "_4t3i1osq _1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                            src: logo.src,
                                            alt: logo.alt,
                                            className: (0, $2jatx.default)([
                                                "_4t3i1osq _1bsb1ns9 _5ral1f51 _rsuf1h6o",
                                                "_kdam2v9e _16bu1vqo",
                                                "_p12f4dhv"
                                            ]),
                                            style: {
                                                "--_y177ig": (0, $6ZVlx.default)(isWacRefresh ? "brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)" : "grayscale(100%) brightness(66%)"),
                                                "--_1v9vtiy": (0, $6ZVlx.default)(isWacRefresh ? "brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)" : "grayscale(100%) brightness(66%)"),
                                                "--_120hwu8": (0, $6ZVlx.default)(logo.wider ? `${$511c14fce74817fd$var$LOGO_WIDER_MAX_WIDTH_PX}px` : `${$511c14fce74817fd$var$LOGO_MAX_WIDTH_PX}px`)
                                            }
                                        })
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                            layout: "12",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _1e0c1txw _1bahh9n0"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                                    isPlaying: marqueeRunning,
                                    onToggle: ()=>setMarqueeRunning((r)=>!r)
                                })
                            })
                        })
                    ]
                }) : logosComponent,
                showMarquee && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: wrapperRef,
                    "aria-hidden": true,
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152tidpf _1e02idpf _rjxpidpf _3um015vq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        ref: listRef,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o",
                            "_gy1p1epz _4t3izwfg _99s61epz _ikjd1epz _1plridpf"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_4t3i1osq _1e0c1txw _4cvr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: logo.src,
                                    alt: logo.alt,
                                    className: (0, $2jatx.default)([
                                        "_4t3izwfg _1bsb1wug"
                                    ])
                                })
                            }, index))
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpoahv _pdlmxncg _y3gn1h6o"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: title
            }),
            logosComponent
        ]
    });
};
const $511c14fce74817fd$var$regularLogoStyles = null;
// visibility:hidden (not display:none) so ResizeObserver and
// getBoundingClientRect() still return real dimensions.
const $511c14fce74817fd$var$measurementOnlyStyles = null;
const $511c14fce74817fd$var$logosWrapperStyle = null;
const $511c14fce74817fd$var$logosContainerStyle = null;
const $511c14fce74817fd$var$marqueeLogoStyles = null;
const $511c14fce74817fd$var$marqueeListItemStyles = null;
const $511c14fce74817fd$var$listStyles = null;
// Per GWP-11501 (#1, #2, #3, #9): a single 32px-tall row with 80px between
// logos at every breakpoint.
//
// The columnGap overrides are repeated at the same breakpoints used in
// logosContainerStyle so that they win at every viewport size without
// relying on !important. CSS specificity for a media-query rule is equal
// to the same rule outside a media query, so the last declaration in source
// order wins — and since wacRefreshSizeStyles is applied after
// logosContainerStyle in the css array, these values take effect correctly.
const $511c14fce74817fd$var$wacRefreshSizeStyles = null;
const $511c14fce74817fd$var$marqueeContainerStyles = null;
const $511c14fce74817fd$var$marqueeListContainerStyles = null;
const $511c14fce74817fd$var$animationKeyframesStyles = null;
const $511c14fce74817fd$var$marqueeControlsContainerStyles = null;

});


parcelRegister("f8O2Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $684b9f8001657ce7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $jE3Ci = parcelRequire("jE3Ci");
const $684b9f8001657ce7$export$d64e2f97651f7f4d = (props)=>{
    const appearance = props.color === "red" ? "danger" : props.color || "neutral";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
        appearance: appearance,
        text: props.text
    });
};
var $684b9f8001657ce7$export$2e2bcd8739ae039 = $684b9f8001657ce7$export$d64e2f97651f7f4d;

});

parcelRegister("96bxg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c23a9551caa87274$export$2e2bcd8739ae039; });
/* migration-placeholder.tsx generated by @compiled/babel-plugin v0.28.8 */ parcelRequire("7VQPk");
parcelRequire("1oC0p");

parcelRequire("kbpa7");
/**
 * Migration Placeholder component.
 *
 * Rendered by the AI migration agent when a Magnolia section cannot be mapped
 * confidently to a Uniform component. In production (NODE_ENV === "production")
 * this renders nothing so that placeholder sections are invisible to end-users.
 * In all other environments (dev, staging, preview) it renders a clearly-visible
 * red banner showing the suggested component name and a link to the source page,
 * so that reviewers can quickly identify and replace it.
 */ const $c23a9551caa87274$var$UniformMigrationPlaceholder = ({ suggestedComponent: suggestedComponent, reviewerTag: reviewerTag, confidence: confidence, sectionName: sectionName, sectionId: sectionId, sourcePageUrl: sourcePageUrl })=>{
    return null;
};
var $c23a9551caa87274$export$2e2bcd8739ae039 = $c23a9551caa87274$var$UniformMigrationPlaceholder;

});

parcelRegister("iSxa6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d66bc09b4415831b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $euqle = parcelRequire("euqle");

var $lTkkF = parcelRequire("lTkkF");
const $d66bc09b4415831b$var$UniformMobileApp = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $euqle.MobileApp), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkLabel: props.linkLabel,
        linkHref: props.linkHref,
        linkDataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "mobileAppSection"
        },
        imageSrc: props.imageSrc,
        imageAlt: props.imageAlt,
        appleAppStoreUrl: props.appleAppStoreUrl,
        googlePlayStoreUrl: props.googlePlayStoreUrl
    });
};
var $d66bc09b4415831b$export$2e2bcd8739ae039 = $d66bc09b4415831b$var$UniformMobileApp;

});
parcelRegister("euqle", function(module, exports) {
$parcel$export(module.exports, "MobileApp", function () { return $dec4263d3b3e8269$export$f81bbe9088ca57b0; });
/* mobile-app.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $2axoc = parcelRequire("2axoc");

var $bSVv5 = parcelRequire("bSVv5");
const $dec4263d3b3e8269$export$f81bbe9088ca57b0 = ({ title: title, description: description, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, imageSrc: imageSrc, imageAlt: imageAlt = "", appleAppStoreUrl: appleAppStoreUrl, googlePlayStoreUrl: googlePlayStoreUrl })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleAppStoreClick = (0, $1oC0p.useCallback)((store)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: store === "apple" ? "appleAppStore" : "googlePlayStore",
            source: "mobileAppSection",
            attributes: {
                label: store === "apple" ? "Download on the Apple App Store" : "Get it on the Google Play Store"
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1pfhxncg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yd3xy5q _40tuxncg _1mou1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                        title: title,
                        titleAs: "h2",
                        text: description,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref,
                                ...linkDataEventProps && {
                                    dataEventProps: linkDataEventProps
                                }
                            }
                        } : undefined
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulppxbi _1pfhxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: appleAppStoreUrl,
                                onClick: ()=>handleAppStoreClick("apple"),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3g0xj4162q6vj8iis1nr5pkh2scjm13a.png",
                                    alt: intl.formatMessage({
                                        id: "mobile-app.apple-store-alt",
                                        defaultMessage: "Download on the Apple App Store"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: googlePlayStoreUrl,
                                onClick: ()=>handleAppStoreClick("google"),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/md1w60b88865q56fl84744t5u0heh751.png",
                                    alt: intl.formatMessage({
                                        id: "mobile-app.google-play-alt",
                                        defaultMessage: "Get it on the Google Play Store"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: imageSrc,
                    alt: imageAlt,
                    className: (0, $2jatx.default)([
                        "_glte1osq _165t1pna _12rrk5xz _1vkhidpf _1x6l1osq _1bsb1osq _4t3ia91z _5ral1dfr _rsufq0ho"
                    ])
                })
            })
        ]
    });
};
const $dec4263d3b3e8269$var$sectionStyles = null;
const $dec4263d3b3e8269$var$leftSideContentStyles = null;
const $dec4263d3b3e8269$var$appStoreLinksContainerStyles = null;
const $dec4263d3b3e8269$var$imageContainerStyles = null;
const $dec4263d3b3e8269$var$imageStyles = null;

});


parcelRegister("lATol", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5a6303ec758cb0a2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $60KY6 = parcelRequire("60KY6");
// Pass modalSize as the width directly to the Modal component
const $5a6303ec758cb0a2$var$UniformModal = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $60KY6.ModalLink), {
        modalTitle: props.modalTitle,
        modalCloseLabel: props.modalCloseLabel,
        ctaText: props.ctaText,
        modalWidth: props.modalSize,
        modalLinkType: props.modalLinkType,
        modalDataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "modal"
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "modalContent"
        })
    });
};
var $5a6303ec758cb0a2$export$2e2bcd8739ae039 = $5a6303ec758cb0a2$var$UniformModal;

});
parcelRegister("60KY6", function(module, exports) {
$parcel$export(module.exports, "ModalLink", function () { return $6d4cc7ee45c7a136$export$cf363aa9ce73688b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iPPTB = parcelRequire("iPPTB");

var $660KI = parcelRequire("660KI");
const $6d4cc7ee45c7a136$export$cf363aa9ce73688b = ({ modalTitle: modalTitle, modalCloseLabel: modalCloseLabel, children: children, ctaText: ctaText, modalWidth: modalWidth, modalLinkType: modalLinkType = "modal", modalDataEventProps: modalDataEventProps })=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const openModal = (e)=>{
        e.preventDefault();
        setIsOpen(true);
    };
    const closeModal = (0, $1oC0p.useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                onClick: openModal,
                "aria-label": "modal-link",
                text: ctaText,
                href: "#modal-section",
                type: modalLinkType,
                dataEventProps: modalDataEventProps
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $660KI.Modal), {
                closeModal: closeModal,
                closeLabel: modalCloseLabel,
                title: modalTitle,
                isOpen: isOpen,
                width: modalWidth,
                children: children
            })
        ]
    });
};

});


parcelRegister("3E1lH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d007356a760321ff$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $8e22h = parcelRequire("8e22h");

var $1pIeE = parcelRequire("1pIeE");

var $9D78w = parcelRequire("9D78w");

var $bTseT = parcelRequire("bTseT");

var $jsxHL = parcelRequire("jsxHL");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $lT2z5 = parcelRequire("lT2z5");

var $f2RFx = parcelRequire("f2RFx");

var $jcRhI = parcelRequire("jcRhI");

var $h1dGc = parcelRequire("h1dGc");

var $6VSBC = parcelRequire("6VSBC");

var $fbo5H = parcelRequire("fbo5H");

var $atyps = parcelRequire("atyps");

var $lgKym = parcelRequire("lgKym");

var $hCHU3 = parcelRequire("hCHU3");

var $1iUL9 = parcelRequire("1iUL9");

var $g2lQR = parcelRequire("g2lQR");

var $aYwTu = parcelRequire("aYwTu");

var $8IN8s = parcelRequire("8IN8s");

var $cimg4 = parcelRequire("cimg4");

var $aYVVm = parcelRequire("aYVVm");

var $4c8eJ = parcelRequire("4c8eJ");

var $1K6kz = parcelRequire("1K6kz");

var $3wzIU = parcelRequire("3wzIU");

var $cQSG9 = parcelRequire("cQSG9");

var $cF9FY = parcelRequire("cF9FY");

var $hfydu = parcelRequire("hfydu");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $9xKEy = parcelRequire("9xKEy");

var $17RBn = parcelRequire("17RBn");

var $lpEyw = parcelRequire("lpEyw");

var $8xC9Z = parcelRequire("8xC9Z");
const $d007356a760321ff$export$6955bcca4cd3539f = (props)=>{
    const { component: component, siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix, dwellTimeEnabled: dwellTimeEnabled } = props;
    const fullSiteSelectorProductKey = siteSelectorProductKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${siteSelectorProductKey}.ondemand`;
    const locale = (0, $17RBn.useLocale)();
    const isBootIntercom = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp5381AddIntercomWidgetToUniform);
    const intercomAppId = locale === "ja" ? "p0ww63i2" : "";
    const isSalesWidgetBxpWebPlatform = intercomAppId !== "" && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).salesWidgetBxpWebPlatform);
    const contentSlot = component.slots?.["content"] ?? [];
    const pageHasGlobalNavComponent = !!contentSlot.find((content)=>content.type === "globalNav");
    const pageHasGlobalFooterComponent = !!contentSlot.find((content)=>content.type === "globalFooter");
    const isSalesWidgetBxpWebPlatformDeveloper = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).salesWidgetBxpWebPlatformDeveloper);
    if (isSalesWidgetBxpWebPlatformDeveloper) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfydu.DwellTimeContextProvider), {
        enabled: !!dwellTimeEnabled,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9xKEy.ChatWidgetProvider), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1pIeE.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8xC9Z.OptionalSiteSelectorContextProvider), {
                        siteSelectorProductKey: fullSiteSelectorProductKey,
                        siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                    name: "enhancedBannerSlot"
                                })
                            }),
                            !pageHasGlobalNavComponent && /*#__PURE__*/ (0, $7VQPk.jsx)($d007356a760321ff$export$f24150b9675a2c65, {
                                component: component
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                                    id: "content",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                        name: "content"
                                    })
                                })
                            })
                        ]
                    })
                }),
                !pageHasGlobalFooterComponent && /*#__PURE__*/ (0, $7VQPk.jsx)($d007356a760321ff$export$1b198b648cc5b0ce, {
                    component: component
                })
            ]
        })
    });
    else if (isSalesWidgetBxpWebPlatform) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfydu.DwellTimeContextProvider), {
        enabled: !!dwellTimeEnabled,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9xKEy.ChatWidgetProvider), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1pIeE.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8xC9Z.OptionalSiteSelectorContextProvider), {
                        siteSelectorProductKey: fullSiteSelectorProductKey,
                        siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                    name: "enhancedBannerSlot"
                                })
                            }),
                            !pageHasGlobalNavComponent && /*#__PURE__*/ (0, $7VQPk.jsx)($d007356a760321ff$export$f24150b9675a2c65, {
                                component: component
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                                    id: "content",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                        name: "content"
                                    })
                                })
                            })
                        ]
                    })
                }),
                !pageHasGlobalFooterComponent && /*#__PURE__*/ (0, $7VQPk.jsx)($d007356a760321ff$export$1b198b648cc5b0ce, {
                    component: component
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfydu.DwellTimeContextProvider), {
        enabled: !!dwellTimeEnabled,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bTseT.IntercomProvider), {
            appId: intercomAppId,
            triggerBoot: isBootIntercom,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1pIeE.default), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8xC9Z.OptionalSiteSelectorContextProvider), {
                        siteSelectorProductKey: fullSiteSelectorProductKey,
                        siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                    name: "enhancedBannerSlot"
                                })
                            }),
                            !pageHasGlobalNavComponent && /*#__PURE__*/ (0, $7VQPk.jsx)($d007356a760321ff$export$f24150b9675a2c65, {
                                component: component
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                                    id: "content",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                                        name: "content"
                                    })
                                })
                            })
                        ]
                    })
                }),
                !pageHasGlobalFooterComponent && /*#__PURE__*/ (0, $7VQPk.jsx)($d007356a760321ff$export$1b198b648cc5b0ce, {
                    component: component
                })
            ]
        })
    });
};
const $d007356a760321ff$export$f24150b9675a2c65 = ({ component: component })=>{
    const intl = (0, $8e22h.default)();
    const pageNavType = component.parameters && component.parameters["nav"] && component.parameters["nav"].value;
    let pageNav;
    switch(pageNavType){
        case "confluence":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCHU3.default), {});
            break;
        case "bitbucket":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $atyps.BitbucketNav), {});
            break;
        case "confluence-template-experiment":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1iUL9.ConfluenceTemplateHeaderContainer), {});
            break;
        case "enterprise":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6VSBC.default), {});
            break;
        case "jira-software":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {});
            break;
        case "jira-service-management":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {});
            break;
        case "jira-product-discovery":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYwTu.default), {});
            break;
        case "gwp-7880-jira-software-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cimg4.default), {});
            break;
        case "gwp-7880-jira-service-management-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4c8eJ.default), {});
            break;
        case "compass":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lgKym.CompassNav), {});
            break;
        case "atlassian-access":
        case "guard":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g2lQR.GuardNav), {});
            break;
        case "rovo":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3wzIU.RovoNav), {});
            break;
        case "rovo-dev":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lpEyw.RovoDevNav), {});
            break;
        case "loom":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1K6kz.LoomNav), {});
            break;
        case "teamwork-collection":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h1dGc.TeamworkCollectionNavbar), {});
            break;
        case "strategy-collection":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f2RFx.StrategyCollectionNavbar), {});
            break;
        case "service-collection":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jcRhI.ServiceCollectionNavbar), {});
            break;
        case "sourcetree-app":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cF9FY.SourcetreeAppNav), {});
            break;
        case "jac":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fbo5H.JacNavbar), {});
            break;
        case "jsm-anchor":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9D78w.ProductNavBar), {
                productHref: "/software/jira/service-management",
                productName: "jiraservicemanagement",
                ariaLabel: intl.formatMessage({
                    id: "wacJiraServiceManagementNavigation.logo-label",
                    defaultMessage: "Jira Service Management logo"
                }),
                dataProductKey: "jiraServiceManagement",
                showFreeHrefButton: false,
                logoLinkWrapperWidth: "279px"
            });
            break;
        case "global-nav-no-try-now-cta":
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                productKey: "uniform",
                isShowTryNowLink: false
            });
            break;
        case "none":
            break;
        case "global":
        default:
            pageNav = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                productKey: "uniform",
                isShowTryNowLink: true
            });
            break;
    }
    return pageNav;
};
const $d007356a760321ff$export$1b198b648cc5b0ce = ({ component: component })=>{
    const pageFooterType = component.parameters && component.parameters["footer"] && component.parameters["footer"].value;
    let pageFooter;
    switch(pageFooterType){
        case "bitbucket":
            pageFooter = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lT2z5.BitbucketFooter), {});
            break;
        case "sourcetree-app":
            pageFooter = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cQSG9.SourcetreeAppFooter), {});
            break;
        case "none":
            break;
        case "global":
        default:
            pageFooter = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {});
            break;
    }
    return pageFooter;
};
var $d007356a760321ff$export$2e2bcd8739ae039 = $d007356a760321ff$export$6955bcca4cd3539f;

});
parcelRegister("1pIeE", function(module, exports) {
$parcel$export(module.exports, "useProductTemplateContext", function () { return $c8bd6f25249f43f7$export$9aa15cd8273c8730; });
$parcel$export(module.exports, "default", function () { return $c8bd6f25249f43f7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $c8bd6f25249f43f7$var$ProductTemplateContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    template: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTemplate: ()=>{}
});
const $c8bd6f25249f43f7$export$d254455f6d2132ac = ({ children: children })=>{
    const [template, setTemplate] = (0, $1oC0p.useState)(null);
    const value = (0, $1oC0p.useMemo)(()=>({
            template: template,
            setTemplate: setTemplate
        }), [
        template
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($c8bd6f25249f43f7$var$ProductTemplateContext.Provider, {
        value: value,
        children: children
    });
};
const $c8bd6f25249f43f7$export$9aa15cd8273c8730 = ()=>{
    const context = (0, $1oC0p.useContext)($c8bd6f25249f43f7$var$ProductTemplateContext);
    if (!context) throw new Error("useProductTemplateContext must be used within a ProductTemplateContextProvider");
    return context;
};
var $c8bd6f25249f43f7$export$2e2bcd8739ae039 = $c8bd6f25249f43f7$export$d254455f6d2132ac;

});

parcelRegister("lT2z5", function(module, exports) {
$parcel$export(module.exports, "BitbucketFooter", function () { return $d9ce239d06825d00$export$afd0363f76a301c9; });
/* bitbucket-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $6xclR = parcelRequire("6xclR");

var $efeGz = parcelRequire("efeGz");
const $d9ce239d06825d00$var$globalFooterStyle = null;
const $d9ce239d06825d00$var$globalFooterContentContainerStyle = null;
const $d9ce239d06825d00$export$afd0363f76a301c9 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _11q7cd5j _1e0c1txw _2lx2vrvc _1bah1h6o"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhkcd5j _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $efeGz.BitbucketFooterTop), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6xclR.BitbucketFooterBottom), {})
            ]
        })
    });

});
parcelRegister("6xclR", function(module, exports) {
$parcel$export(module.exports, "BitbucketFooterBottom", function () { return $b77cb42cc02018d8$export$1a0aacf81bbdc390; });
/* bitbucket-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $e3HD6 = parcelRequire("e3HD6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
// ==================================================================
// CSS styling
// ==================================================================
const $b77cb42cc02018d8$var$containerStyle = null;
const $b77cb42cc02018d8$var$linkStyle = null;
const $b77cb42cc02018d8$var$copyrightStyle = null;
const $b77cb42cc02018d8$var$linksAndLanguageStyle = null;
const $b77cb42cc02018d8$var$listStyle = null;
const $b77cb42cc02018d8$var$bottomViewAllLinkLiAnchorStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
const $b77cb42cc02018d8$var$BottomLinks = ()=>{
    const intl = (0, $8e22h.default)();
    (0, $1oC0p.useEffect)(()=>{
        const w = window;
        if (w.AtlOneTrustWrapper?.updatePolicyLinks) w.AtlOneTrustWrapper.updatePolicyLinks();
    }, []);
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: "bitbucket.globalfooter.bottom.privacy-policy",
                defaultMessage: "Privacy policy"
            }),
            href: (0, $jQ0cd.useLocalizedHref)("/legal/privacy-policy"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "bitbucket.globalfooter.bottom.notice-at-collection",
                defaultMessage: "Notice at Collection"
            }),
            href: (0, $jQ0cd.useLocalizedHref)("/legal/privacy-policy#additional-disclosures-for-ca-residents"),
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: "bitbucket.globalfooter.bottom.terms",
                defaultMessage: "Terms of use"
            }),
            href: (0, $jQ0cd.useLocalizedHref)("/legal/cloud-terms-of-service"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "bitbucket.globalfooter.bottom.trust.security",
                defaultMessage: "Trust & security"
            }),
            href: (0, $jQ0cd.useLocalizedHref)("/legal/atlassian-customer-agreement#intro"),
            isOneTrustWrapped: false
        }
    ];
    const bottomViewAllLink = {
        text: intl.formatMessage({
            id: "bitbucket.globalfooter.bottom.view-all-products",
            defaultMessage: "View all Atlassian products"
        }),
        href: (0, $jQ0cd.useLocalizedHref)("/software"),
        bgColor: "bgWhite"
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            bottomLinks.map((bottomLink)=>{
                if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: "link-wrapper atl-policy-link-container",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e3HD6.LinkWithIcon), {
                        linkText: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        isHaveIcon: false,
                        isUsePlainSpanTagForLinkText: true,
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                            "atl-policy-link"
                        ]),
                        spanLinkTextClassName: "atl-policy-link-text",
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    })
                }, bottomLink.text);
                else return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        bgColor: "bgColored",
                        "aria-label": "footer-link",
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    })
                }, bottomLink.text);
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    text: bottomViewAllLink.text,
                    href: bottomViewAllLink.href,
                    type: "primary",
                    bgColor: "bgColored",
                    "aria-label": "footer-link",
                    className: (0, $2jatx.default)([
                        "_syaz1hlo _1wyboxwj _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dyz1a1y _ect4kipj _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1 _1ygbqgpo"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                    }
                })
            }, bottomViewAllLink.text.trim().replace(" ", "-"))
        ]
    });
};
const $b77cb42cc02018d8$var$copyRightYear = new Date().getFullYear();
const $b77cb42cc02018d8$export$1a0aacf81bbdc390 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-v2-bottom",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $2jatx.default)([
                        "_syaz1yg0 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $b77cb42cc02018d8$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
                        name: "global-footer-v2-bottom-links",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($b77cb42cc02018d8$var$BottomLinks, {})
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("efeGz", function(module, exports) {
$parcel$export(module.exports, "BitbucketFooterTop", function () { return $3c80a5d60bf18c13$export$64d78c3a7aa7d045; });
/* bitbucket-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $kbpa7 = parcelRequire("kbpa7");

var $aejAB = parcelRequire("aejAB");

var $dO2Fq = parcelRequire("dO2Fq");
// ==================================================================
// CSS styling
// ==================================================================
const $3c80a5d60bf18c13$var$containerStyle = null;
const $3c80a5d60bf18c13$var$linksWrapperStyle = null;
const $3c80a5d60bf18c13$export$26b6a80e48da8316 = {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline"
};
// ==================================================================
// Rendering Functions
// ==================================================================
const $3c80a5d60bf18c13$var$headerContainerStyle = null;
const $3c80a5d60bf18c13$var$listOfLinksColumnHeaderStyle = null;
const $3c80a5d60bf18c13$var$listOfLinksUlStyle = null;
const $3c80a5d60bf18c13$var$textStyle = null;
const $3c80a5d60bf18c13$var$connectTextStyle = null;
const $3c80a5d60bf18c13$var$socialButtonStandardStyle = null;
const $3c80a5d60bf18c13$var$socialButtonsStyle = null;
const $3c80a5d60bf18c13$var$twitterLinkStyle = null;
const $3c80a5d60bf18c13$var$facebookLinkStyle = null;
const $3c80a5d60bf18c13$var$socialButtonsListStyle = null;
const $3c80a5d60bf18c13$var$socialButtonsGroupStyle = null;
const $3c80a5d60bf18c13$var$bitbucketTextStyle = null;
const $3c80a5d60bf18c13$var$ConnectColumn = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wybw1gv _o10x10nf _1p1dangw _syazr2ho _k48p53lb _ect48q0o",
                        "eyebrow-md"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: "Connect with us"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _qtt8glyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _syaz1mpp _s7n41q9y"
                    ]),
                    children: "Sign up for Git articles and resources:"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dO2Fq.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1 _1wyb1j6v _syaz1mpp _s7n41q9y"
                            ]),
                            children: "Connect with Bitbucket"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                            className: (0, $2jatx.default)([
                                "_vwz4kb7n _syazvejh _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bozgidpf _qtt8glyw _1aaxusic _ahbq19bv"
                            ]),
                            style: {
                                "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "https://www.facebook.com/Atlassian",
                                        title: "Atlassian on Facebook",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1yg0 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q71tu0 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                        },
                                        children: "Facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "https://twitter.com/bitbucket",
                                        title: "Follow us on Twitter",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1yg0 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q713k9 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                        },
                                        children: "Twitter"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $3c80a5d60bf18c13$export$64d78c3a7aa7d045 = ()=>{
    const intl = (0, $8e22h.default)();
    const resourcesLinkList = {
        headerText: intl.formatMessage({
            id: "bitbucket.top.resources",
            defaultMessage: "Resources"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.technical.support",
                    defaultMessage: "Technical support"
                }),
                href: intl.formatMessage({
                    id: "bitbucket.globalfooter.technical.support.link",
                    defaultMessage: "https://support.atlassian.com/help/#/bitbucket"
                })
            },
            {
                text: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.documentation",
                    defaultMessage: "Documentation"
                }),
                href: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.documentation.link",
                    defaultMessage: "https://confluence.atlassian.com/display/BITBUCKET"
                })
            },
            {
                text: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.plan.pricing",
                    defaultMessage: "Plans & pricing"
                }),
                href: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.plan.pricing.link",
                    defaultMessage: "https://bitbucket.org/product/pricing"
                })
            },
            {
                text: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.version.control",
                    defaultMessage: "What is Version Control?"
                }),
                href: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.version.control.link",
                    defaultMessage: "https://bitbucket.org/product/version-control-software"
                })
            }
        ]
    };
    const bitbucketLinkList = {
        headerText: intl.formatMessage({
            id: "bitbucket.top.bitbucket",
            defaultMessage: "Bitbucket"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.blog",
                    defaultMessage: "Blog"
                }),
                href: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.blog.link",
                    defaultMessage: "https://bitbucket.org/blog/"
                })
            },
            {
                text: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.bitbucket.writing.program",
                    defaultMessage: "Bitbucket writing program"
                }),
                href: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.bitbucket.writing.program.link",
                    defaultMessage: "https://bitbucket.org/product/write"
                })
            },
            {
                text: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.api",
                    defaultMessage: "API"
                }),
                href: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.api.link",
                    defaultMessage: "https://developer.atlassian.com/bitbucket"
                })
            },
            {
                text: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.site.status",
                    defaultMessage: "Site status"
                }),
                href: intl.formatMessage({
                    id: "bitbucket.globalfooter.top.site.status.link",
                    defaultMessage: "http://status.bitbucket.org/"
                })
            }
        ]
    };
    // // Adding pdf to french locale for compliance
    // if (location.pathname.startsWith("/fr")) {
    //     bitbucketLinkList.listOfLinks.push({
    //         text: `Index de l'égalité professionnelle`,
    //         href: "https://dam-cdn.atl.orangelogic.com/AssetLink/qey7mu25028ek1rp0ru28l45l8y3fm5r/2025-France-Gender-Equality-Index.pdf"
    //     });
    // }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-bitbucket-top",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1rga _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg"
            ]),
            style: {
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1raq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...bitbucketLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...resourcesLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($3c80a5d60bf18c13$var$ConnectColumn, {})
                ]
            })
        })
    });
};

});
parcelRegister("dO2Fq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4537f13a77503f08$export$2e2bcd8739ae039; });
/* bitbucket-mailing-list-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $ldrV1 = parcelRequire("ldrV1");

var $eC3qs = parcelRequire("eC3qs");

var $1ka2O = parcelRequire("1ka2O");
const $4537f13a77503f08$var$inputContainerStyle = null;
const $4537f13a77503f08$var$errorStyles = null;
const $4537f13a77503f08$var$inputStyle = null;
const $4537f13a77503f08$var$searchInputContainerStyle = null;
const $4537f13a77503f08$var$validateEmail = (email)=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const $4537f13a77503f08$export$501844742ea3c924 = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const intl = (0, $8e22h.default)();
    const emptyEmailError = intl.formatMessage({
        id: "BitbucketFooter.top.emptyEmailError",
        defaultMessage: "This field is required"
    });
    const invalidEmailError = intl.formatMessage({
        id: "BitbucketFooter.top.invalidEmailError",
        defaultMessage: "This field requires a valid email address"
    });
    const [errorMessage, setErrorMessage] = (0, $1oC0p.useState)("");
    const [isValidatingEmail] = (0, $1oC0p.useState)(false);
    const [emailInput, setEmailInput] = (0, $1oC0p.useState)("");
    const [honeypotInput, setHoneypotInput] = (0, $1oC0p.useState)("");
    const [signupSuccess, setSignupSuccess] = (0, $1oC0p.useState)(false);
    const [consentConfig, setConsentConfig] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        if (isValidatingEmail) {
            if (emailInput === "") setErrorMessage(emptyEmailError);
            else $4537f13a77503f08$var$validateEmail(emailInput) ? setErrorMessage("") : setErrorMessage(invalidEmailError);
        }
    }, [
        isValidatingEmail,
        emailInput,
        emptyEmailError,
        invalidEmailError
    ]);
    (0, $1oC0p.useEffect)(()=>{
        getConsentConfig();
    }, []);
    const getConsentConfig = async ()=>{
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const consentConfigUrl = `${stargateUrl}/preferencesV2/consent-config`;
        await fetch(consentConfigUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST"
        }).then((response)=>response.json()).then((data)=>setConsentConfig(data)).catch(()=>{
            console.error("Failed to fetch consent config");
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (emailInput === "") {
            setErrorMessage(emptyEmailError);
            return;
        }
        if (!$4537f13a77503f08$var$validateEmail(emailInput)) return;
        if (honeypotInput) return;
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const postUrl = `${stargateUrl}/preferencesV2/update`;
        // These are hardcoded values that are required by the endpoint.
        // https://bitbucket.org/atlassian/magnolia-resources/annotate/f65b7a5bf31677bcde32caa3305364c7ffb88808/resources/js/components/generic/exact-target-formV2.ts?at=qa
        await fetch(postUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST",
            body: JSON.stringify({
                consentCheckboxValue: true,
                consentLabelText: "",
                email: emailInput,
                formId: "2ed5d5c4-fe00-4259-a4e0-e82e997a371b",
                formUrl: location.href,
                locale: consentConfig?.locale || "UNKNOWN",
                privacyPolicyText: "",
                site: "atlassian"
            })
        }).then(()=>setSignupSuccess(true)).catch(()=>{
            setErrorMessage(intl.formatMessage({
                id: "Bitbucket.top.signupError",
                defaultMessage: "There was a server error submitting."
            }));
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($4537f13a77503f08$export$eac6122d3091f0d0, {
        errorMessage: errorMessage,
        emailInput: emailInput,
        setEmailInput: setEmailInput,
        setHoneypotInput: setHoneypotInput,
        signupSuccess: signupSuccess,
        handleSubmit: handleSubmit
    });
};
const $4537f13a77503f08$var$buttonStyle = null;
const $4537f13a77503f08$export$eac6122d3091f0d0 = (props)=>{
    const { errorMessage: errorMessage, emailInput: emailInput, setEmailInput: setEmailInput, setHoneypotInput: setHoneypotInput, signupSuccess: signupSuccess, handleSubmit: handleSubmit } = props;
    const intl = (0, $8e22h.default)();
    const subscribeText = intl.formatMessage({
        id: "BitbucketFooter.top.subscribe",
        defaultMessage: "Subscribe"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            !signupSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1y6m _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1o8l _y3gn1e5h _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eC3qs.TextInput), {
                                    name: "email",
                                    value: emailInput,
                                    id: "email",
                                    testId: "email",
                                    label: "",
                                    placeholder: "email@example.com",
                                    onChangeHandler: setEmailInput,
                                    validation: (value)=>{
                                        if (value === "") return [
                                            false,
                                            intl.formatMessage({
                                                id: "BitbucketFooter.top.emptyEmailError",
                                                defaultMessage: "This field is required"
                                            })
                                        ];
                                        else if (!$4537f13a77503f08$var$validateEmail(value)) return [
                                            false,
                                            intl.formatMessage({
                                                id: "BitbucketFooter.top.invalidEmailError",
                                                defaultMessage: "This field requires a valid email address"
                                            })
                                        ];
                                        return [
                                            true,
                                            ""
                                        ];
                                    },
                                    className: (0, $2jatx.default)([
                                        "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                                    ])
                                }),
                                errorMessage && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_syaz1du8 _1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfh1y44"
                                    ]),
                                    children: errorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0cglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                type: "text",
                                name: "list name",
                                "aria-label": "keep this field blank",
                                onChange: (e)=>setHoneypotInput(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                            type: "secondary",
                            text: subscribeText,
                            inputType: "submit",
                            dataEventProps: {
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-product-key": "bitbucket",
                                "data-event-container": "button"
                            },
                            size: "large",
                            color: "whiteblue",
                            "aria-label": subscribeText,
                            className: (0, $2jatx.default)([
                                "_ahbq7vkz _1pfh1y44"
                            ])
                        })
                    ]
                })
            }),
            signupSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "Bitbucket.top.signup-success",
                    defaultMessage: "Thanks for signing up!"
                })
            })
        ]
    });
};
var $4537f13a77503f08$export$2e2bcd8739ae039 = $4537f13a77503f08$export$501844742ea3c924;

});



parcelRegister("jcRhI", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionNavbar", function () { return $db358e19517c36a2$export$21a8ade06194f818; });

var $7VQPk = parcelRequire("7VQPk");

var $hcVGp = parcelRequire("hcVGp");

var $lVpxp = parcelRequire("lVpxp");

var $dahOu = parcelRequire("dahOu");
const $db358e19517c36a2$export$21a8ade06194f818 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: "home",
        compoundNav: {
            ...(0, $lVpxp.CollectionsCompoundSubNavProps)(),
            ctaUrl: (0, $dahOu.CTA_URL_PATH)
        }
    });
};

});
parcelRegister("dahOu", function(module, exports) {
$parcel$export(module.exports, "CTA_URL_PATH", function () { return $98017d3276cdfe68$export$d5587a12d9eea1dc; });
const $98017d3276cdfe68$export$d5587a12d9eea1dc = "/collections/service#contact";

});


parcelRegister("fbo5H", function(module, exports) {
$parcel$export(module.exports, "JacNavbar", function () { return $dafddddada2c1ebf$export$56b1f48c0b125acc; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $gNdrj = parcelRequire("gNdrj");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $eIRB3 = parcelRequire("eIRB3");

var $cR2Ov = parcelRequire("cR2Ov");

var $9KOR3 = parcelRequire("9KOR3");

var $iOXki = parcelRequire("iOXki");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $cB958 = parcelRequire("cB958");

var $1jBLM = parcelRequire("1jBLM");
const $dafddddada2c1ebf$var$JiraLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eIRB3.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $dafddddada2c1ebf$export$56b1f48c0b125acc = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const gwp7518NavIconUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const productNavGoToAppCta = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).productNavGoToAppCta);
    const isExperimentEnabled = productNavGoToAppCta.type === "enrolled" && productNavGoToAppCta.value === true;
    const ctaText = isExperimentEnabled ? intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.navbar.openJira",
        defaultMessage: "Open Jira"
    }) : intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.navbar.getItFree",
        defaultMessage: "Get it free"
    });
    const signupLink = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, [
        openCrossFlow,
        productNavCtaCTAClickFunction,
        isUseOpenCrossFlow
    ]);
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    // Teams Hrefs
    const marketingHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/marketing");
    const engineeringHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/engineering");
    const designHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/design");
    const operationsHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/operations");
    const itHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/it");
    // Use Cases Hrefs
    const gettingStartedHref = (0, $jQ0cd.useLocalizedHref)("https://community.atlassian.com/learning/hub/jira");
    const planningHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/planning");
    const campaignManagementHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/campaign-management");
    const agileProjectManagementHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/agile-project-management");
    const programManagementHref = (0, $jQ0cd.useLocalizedHref)("/jira/solutions/program-management");
    //Company Size Hrefs
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/enterprise");
    const solutionsDropdown = (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
            contentSections: [
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.teams.header",
                        defaultMessage: "Teams"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.marketing",
                                defaultMessage: "Marketing"
                            }),
                            href: marketingHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.engineering",
                                defaultMessage: "Engineering"
                            }),
                            href: engineeringHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.design",
                                defaultMessage: "Design"
                            }),
                            href: designHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.operations",
                                defaultMessage: "Operations"
                            }),
                            href: operationsHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.it",
                                defaultMessage: "IT"
                            }),
                            href: itHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.useCases.header",
                        defaultMessage: "Use Cases"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.getting-started",
                                defaultMessage: "Getting started"
                            }),
                            href: gettingStartedHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.planning",
                                defaultMessage: "Planning"
                            }),
                            href: planningHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.campaign-management",
                                defaultMessage: "Campaign Management"
                            }),
                            href: campaignManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.agile-project-management",
                                defaultMessage: "Agile Project Management"
                            }),
                            href: agileProjectManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.program-management",
                                defaultMessage: "Program Management"
                            }),
                            href: programManagementHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.companySize.header",
                        defaultMessage: "Company Size"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.companySize.enterprise",
                                defaultMessage: "Enterprise"
                            }),
                            href: enterpriseHref
                        }
                    ]
                }
            ]
        }), [
        intl,
        gettingStartedHref,
        marketingHref,
        engineeringHref,
        designHref,
        operationsHref,
        itHref,
        planningHref,
        campaignManagementHref,
        agileProjectManagementHref,
        programManagementHref,
        enterpriseHref
    ]);
    const featuresHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/features");
    const productGuideHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const pricingHref = (0, $jQ0cd.useLocalizedHref)("/software/jira/pricing");
    const productLogoHref = (0, $jQ0cd.useLocalizedHref)("/software/jira");
    const templatesLinkContent = (0, $1oC0p.useMemo)(()=>{
        return {
            globalLinksKey: "templates",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.templates",
                defaultMessage: "Templates"
            }),
            productKey: "jira",
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1jBLM.TemplateCategoriesDropdown), {}),
            dropdownType: "templates",
            containerPosition: "relative"
        };
    }, [
        intl
    ]);
    const featuresLinkContent = (0, $1oC0p.useMemo)(()=>({
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.features",
                defaultMessage: "Features"
            }),
            productKey: "jira",
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cB958.FeaturesDropdown), {}),
            dropdownType: "features",
            containerPosition: "relative"
        }), [
        intl
    ]);
    const newLinks = (0, $1oC0p.useMemo)(()=>[
            featuresLinkContent,
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                productKey: "jira",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                dropdownType: "solutions",
                content: solutionsDropdown
            },
            {
                globalLinksKey: "productGuide",
                linkText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "software-jira.navbar.product-guide-gwp-7518",
                    defaultMessage: "Guide"
                }) : intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            }
        ], [
        intl,
        featuresLinkContent,
        templatesLinkContent,
        gwp7518NavIconUpdates,
        solutionsDropdown,
        solutionsDropdownStyles,
        productGuideHref,
        pricingHref
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: featuresHref
            },
            {
                globalLinksKey: "productGuide",
                linkText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "software-jira.navbar.product-guide-gwp-7518",
                    defaultMessage: "Guide"
                }) : intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            },
            {
                globalLinksKey: "enterprise",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.enterprise",
                    defaultMessage: "Enterprise"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: enterpriseHref
            }
        ], [
        enterpriseHref,
        featuresHref,
        intl,
        pricingHref,
        productGuideHref,
        templatesLinkContent,
        gwp7518NavIconUpdates
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gNdrj.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
                globalNavItemKeys: globalNavItemKeys,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
                    productLogoUrl: productLogoHref,
                    productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($dafddddada2c1ebf$var$JiraLogo, {}),
                    productLogoAriaLabel: intl.formatMessage({
                        id: "wacJiraSoftwareNavigation.logo-label",
                        defaultMessage: "Jira Software logo"
                    }),
                    mobileCtaText: intl.formatMessage({
                        id: "JiraeSoftwarePageTemplate.navbar.getitfree",
                        defaultMessage: "Get it free"
                    }),
                    mobileCtaUrl: signupLink,
                    mobileCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($dafddddada2c1ebf$var$JiraLogo, {}),
                    navigationTrynowCtaText: ctaText,
                    navigationTrynowCtaUrl: signupLink,
                    navigationTrynowCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    productPageNavLinks: newLinks,
                    mobileLinksSections: [
                        {
                            mobileLinkKey: "mobile-jira",
                            mobileLinksProps: newLinks
                        }
                    ],
                    additionalMenuPageObjectsArray: [
                        {
                            menuPageKey: "solutions",
                            menuPageObjects: newLinks.find((link)=>link.globalLinksKey === "solutions")?.content
                        },
                        {
                            menuPageKey: "templates",
                            menuPageObjects: newLinks.find((link)=>link.globalLinksKey === "templates")?.content
                        }
                    ],
                    isShowAppSwitcher: false,
                    isShowUserProfile: false
                })
            })
        ]
    });
};
$dafddddada2c1ebf$export$56b1f48c0b125acc.displayName = "JiraSoftwareNav";
var $dafddddada2c1ebf$export$2e2bcd8739ae039 = $dafddddada2c1ebf$export$56b1f48c0b125acc;

});

parcelRegister("cimg4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c26c977f7fa25d25$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $1pIeE = parcelRequire("1pIeE");

var $iHYHa = parcelRequire("iHYHa");

var $8IN8s = parcelRequire("8IN8s");
const $c26c977f7fa25d25$var$JiraSoftwareNavUniform = ()=>{
    const { template: template } = (0, $1pIeE.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $1oC0p.useState)(false);
    const openModalForTemplateClickAction = (0, $1oC0p.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template?.templateId,
                templateName: template?.templateName,
                productKey: template?.productKey
            });
        };
    }, [
        openModalForTemplate,
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (template?.templateId && template?.templateName && template?.productKey) setIsUseOpenCrossFlow(true);
    }, [
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$c26c977f7fa25d25$var$JiraSoftwareNavUniform.displayName = "JiraSoftwareNavUniform";
var $c26c977f7fa25d25$export$2e2bcd8739ae039 = $c26c977f7fa25d25$var$JiraSoftwareNavUniform;

});

parcelRegister("4c8eJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1b68c0ea2ce93d4$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $1pIeE = parcelRequire("1pIeE");

var $iHYHa = parcelRequire("iHYHa");

var $aYVVm = parcelRequire("aYVVm");
const $a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform = ()=>{
    const { template: template } = (0, $1pIeE.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $1oC0p.useState)(false);
    const openModalForTemplateClickAction = (0, $1oC0p.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template?.templateId,
                templateName: template?.templateName,
                productKey: template?.productKey
            });
        };
    }, [
        openModalForTemplate,
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (template?.templateId && template?.templateName && template?.productKey) setIsUseOpenCrossFlow(true);
    }, [
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform.displayName = "JiraServiceManagementSoftwareNavV2Uniform";
var $a1b68c0ea2ce93d4$export$2e2bcd8739ae039 = $a1b68c0ea2ce93d4$var$JiraServiceManagementSoftwareNavV2Uniform;

});

parcelRegister("cQSG9", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooter", function () { return $8415a60865fc69c3$export$e1512df89103926d; });
/* sourcetree-app-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $qW9Nb = parcelRequire("qW9Nb");

var $8LmPp = parcelRequire("8LmPp");
const $8415a60865fc69c3$var$globalFooterStyle = null;
const $8415a60865fc69c3$var$globalFooterContentContainerStyle = null;
const $8415a60865fc69c3$export$e1512df89103926d = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("footer", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _11q7cd5j _1e0c1txw _2lx2vrvc _1bah1h6o"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhkcd5j _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LmPp.SourcetreeAppFooterTop), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $qW9Nb.SourcetreeAppFooterBottom), {})
            ]
        })
    });

});
parcelRegister("qW9Nb", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooterBottom", function () { return $e18ab648d292d24b$export$89b0be2f0f7ea8dd; });
/* sourcetree-app-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $e3HD6 = parcelRequire("e3HD6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
// ==================================================================
// CSS styling
// ==================================================================
const $e18ab648d292d24b$var$containerStyle = null;
const $e18ab648d292d24b$var$linkStyle = null;
const $e18ab648d292d24b$var$copyrightStyle = null;
const $e18ab648d292d24b$var$linksAndLanguageStyle = null;
const $e18ab648d292d24b$var$listStyle = null;
const $e18ab648d292d24b$var$bottomViewAllLinkLiAnchorStyle = null;
// ==================================================================
// Rendering Functions
// ==================================================================
const $e18ab648d292d24b$var$BottomLinks = ()=>{
    const intl = (0, $8e22h.default)();
    (0, $1oC0p.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (window?.AtlOneTrustWrapper?.updatePolicyLinks) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.AtlOneTrustWrapper.updatePolicyLinks();
    }, []);
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.privacy-policy",
                defaultMessage: "Privacy policy"
            }),
            href: (0, $jQ0cd.useLocalizedHref)("/legal/privacy-policy"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.notice-at-collection",
                defaultMessage: "Notice at Collection"
            }),
            href: (0, $jQ0cd.useLocalizedHref)("/legal/privacy-policy#additional-disclosures-for-ca-residents"),
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.terms",
                defaultMessage: "Terms of use"
            }),
            href: (0, $jQ0cd.useLocalizedHref)("/legal/cloud-terms-of-service"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.trust.security",
                defaultMessage: "Trust & security"
            }),
            href: (0, $jQ0cd.useLocalizedHref)("/legal/atlassian-customer-agreement#intro"),
            isOneTrustWrapped: false
        }
    ];
    const bottomViewAllLink = {
        text: intl.formatMessage({
            id: "sourcetreeapp.globalfooter.bottom.view-all-products",
            defaultMessage: "View all Atlassian products"
        }),
        href: (0, $jQ0cd.useLocalizedHref)("/software"),
        bgColor: "bgWhite"
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            bottomLinks.map((bottomLink)=>{
                if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: "link-wrapper atl-policy-link-container",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e3HD6.LinkWithIcon), {
                        linkText: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        isHaveIcon: false,
                        isUsePlainSpanTagForLinkText: true,
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                            "atl-policy-link"
                        ]),
                        spanLinkTextClassName: "atl-policy-link-text",
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    })
                }, bottomLink.text);
                else return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        bgColor: "bgColored",
                        "aria-label": "footer-link",
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    })
                }, bottomLink.text);
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                    text: bottomViewAllLink.text,
                    href: bottomViewAllLink.href,
                    type: "primary",
                    bgColor: "bgColored",
                    "aria-label": "footer-link",
                    className: (0, $2jatx.default)([
                        "_syaz1hlo _1wyboxwj _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dyz1a1y _ect4kipj _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1 _1ygbqgpo"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                    }
                })
            }, bottomViewAllLink.text.trim().replace(" ", "-"))
        ]
    });
};
const $e18ab648d292d24b$var$copyRightYear = new Date().getFullYear();
const $e18ab648d292d24b$export$89b0be2f0f7ea8dd = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-v2-bottom",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $2jatx.default)([
                        "_syaz1yg0 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $e18ab648d292d24b$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
                        name: "global-footer-v2-bottom-links",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($e18ab648d292d24b$var$BottomLinks, {})
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("8LmPp", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppFooterTop", function () { return $f9eec892615b5033$export$e7a002b3133bbe21; });
/* sourcetree-app-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $aejAB = parcelRequire("aejAB");

var $1ka2O = parcelRequire("1ka2O");

var $huLm0 = parcelRequire("huLm0");
// ==================================================================
// CSS styling
// ==================================================================
const $f9eec892615b5033$var$containerStyle = null;
const $f9eec892615b5033$var$linksWrapperStyle = null;
const $f9eec892615b5033$export$26b6a80e48da8316 = {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline"
};
// ==================================================================
// Rendering Functions
// ==================================================================
const $f9eec892615b5033$var$headerContainerStyle = null;
const $f9eec892615b5033$var$listOfLinksColumnHeaderStyle = null;
const $f9eec892615b5033$var$listOfLinksUlStyle = null;
const $f9eec892615b5033$var$textStyle = null;
const $f9eec892615b5033$var$connectTextStyle = null;
const $f9eec892615b5033$var$socialButtonStandardStyle = null;
const $f9eec892615b5033$var$socialButtonsStyle = null;
const $f9eec892615b5033$var$twitterLinkStyle = null;
const $f9eec892615b5033$var$facebookLinkStyle = null;
const $f9eec892615b5033$var$socialButtonsListStyle = null;
const $f9eec892615b5033$var$socialButtonsGroupStyle = null;
const $f9eec892615b5033$var$sourcetreeTextStyle = null;
const $f9eec892615b5033$var$ConnectColumn = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wybw1gv _o10x10nf _1p1dangw _syazr2ho _k48p53lb _ect48q0o",
                        "eyebrow-md"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: "Connect with us"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthidpf _qtt8glyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _syaz1mpp _s7n41q9y"
                    ]),
                    children: "Sign up for Git articles and resources:"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $huLm0.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1 _1wyb1j6v _syaz1mpp _s7n41q9y"
                            ]),
                            children: "Connect with Sourcetree"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                            className: (0, $2jatx.default)([
                                "_vwz4kb7n _syazvejh _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bozgidpf _qtt8glyw _1aaxusic _ahbq19bv"
                            ]),
                            style: {
                                "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "https://www.facebook.com/Atlassian",
                                        title: "Atlassian on Facebook",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1yg0 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q71tu0 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                        },
                                        children: "Facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    className: (0, $2jatx.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "https://twitter.com/sourcetree",
                                        title: "Follow us on Twitter",
                                        className: (0, $2jatx.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1yg0 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q713k9 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                        },
                                        children: "Twitter"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $f9eec892615b5033$export$e7a002b3133bbe21 = ()=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const resourcesLinkList = {
        headerText: intl.formatMessage({
            id: "sourcetreeapp.top.resources",
            defaultMessage: "Resources"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.support",
                    defaultMessage: "Support"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.support.link",
                    defaultMessage: "https://support.atlassian.com/sourcetree"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.documentation",
                    defaultMessage: "Documentation"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.documentation.link",
                    defaultMessage: "https://confluence.atlassian.com/get-started-with-sourcetree"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.about.atlassian",
                    defaultMessage: "About Atlassian"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.about.atlassian.link",
                    defaultMessage: "https://www.atlassian.com/company"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.download.archive",
                    defaultMessage: "Download archive"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.download.archive.link",
                    defaultMessage: "https://sourcetreeapp.com/download-archives"
                })
            }
        ]
    };
    const sourcetreeAppLinkList = {
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.top.blog",
                    defaultMessage: "Blog"
                }),
                href: (0, $jQ0cd.useLocalizedHref)("/blog/sourcetree")
            }
        ]
    };
    // Adding pdf to french locale for compliance
    if (location.pathname.startsWith("/fr")) sourcetreeAppLinkList.listOfLinks.push({
        text: `Index de l'\xe9galit\xe9 professionnelle`,
        href: "https://dam-cdn.atl.orangelogic.com/AssetLink/qey7mu25028ek1rp0ru28l45l8y3fm5r/2025-France-Gender-Equality-Index.pdf"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "global-footer-sourcetreeapp-top",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1rga _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg"
            ]),
            style: {
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1raq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...sourcetreeAppLinkList,
                        logoType: "sourcetreeapp"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aejAB.LinkListContainer), {
                        ...resourcesLinkList
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($f9eec892615b5033$var$ConnectColumn, {})
                ]
            })
        })
    });
};

});
parcelRegister("huLm0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $97b566dc024060a4$export$2e2bcd8739ae039; });
/* sourcetree-app-mailing-list-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $ldrV1 = parcelRequire("ldrV1");

var $eC3qs = parcelRequire("eC3qs");

var $1ka2O = parcelRequire("1ka2O");
const $97b566dc024060a4$var$inputContainerStyle = null;
const $97b566dc024060a4$var$errorStyles = null;
const $97b566dc024060a4$var$inputStyle = null;
const $97b566dc024060a4$var$searchInputContainerStyle = null;
const $97b566dc024060a4$var$validateEmail = (email)=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const $97b566dc024060a4$export$d8d3a333528c91a5 = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const intl = (0, $8e22h.default)();
    const emptyEmailError = intl.formatMessage({
        id: "SourcetreeAppFooter.top.emptyEmailError",
        defaultMessage: "This field is required"
    });
    const invalidEmailError = intl.formatMessage({
        id: "SourcetreeAppFooter.top.invalidEmailError",
        defaultMessage: "This field requires a valid email address"
    });
    const [errorMessage, setErrorMessage] = (0, $1oC0p.useState)("");
    const [isValidatingEmail] = (0, $1oC0p.useState)(false);
    const [emailInput, setEmailInput] = (0, $1oC0p.useState)("");
    const [honeypotInput, setHoneypotInput] = (0, $1oC0p.useState)("");
    const [signupSuccess, setSignupSuccess] = (0, $1oC0p.useState)(false);
    const [consentConfig, setConsentConfig] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        if (isValidatingEmail) {
            if (emailInput === "") setErrorMessage(emptyEmailError);
            else $97b566dc024060a4$var$validateEmail(emailInput) ? setErrorMessage("") : setErrorMessage(invalidEmailError);
        }
    }, [
        isValidatingEmail,
        emailInput,
        emptyEmailError,
        invalidEmailError
    ]);
    (0, $1oC0p.useEffect)(()=>{
        getConsentConfig();
    }, []);
    const getConsentConfig = async ()=>{
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const consentConfigUrl = `${stargateUrl}/preferencesV2/consent-config`;
        await fetch(consentConfigUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST"
        }).then((response)=>response.json()).then((data)=>setConsentConfig(data)).catch(()=>{
            console.error("Failed to fetch consent config");
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (emailInput === "") {
            setErrorMessage(emptyEmailError);
            return;
        }
        if (!$97b566dc024060a4$var$validateEmail(emailInput)) return;
        if (honeypotInput) return;
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const postUrl = `${stargateUrl}/preferencesV2/update`;
        // These are hardcoded values that are required by the endpoint.
        // https://bitbucket.org/atlassian/magnolia-resources/annotate/f65b7a5bf31677bcde32caa3305364c7ffb88808/resources/js/components/generic/exact-target-formV2.ts?at=qa
        await fetch(postUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST",
            body: JSON.stringify({
                consentCheckboxValue: true,
                consentLabelText: "",
                email: emailInput,
                formId: "2ed5d5c4-fe00-4259-a4e0-e82e997a371b",
                formUrl: location.href,
                locale: consentConfig?.locale || "UNKNOWN",
                privacyPolicyText: "",
                site: "atlassian"
            })
        }).then(()=>setSignupSuccess(true)).catch(()=>{
            setErrorMessage(intl.formatMessage({
                id: "SourcetreeApp.top.signupError",
                defaultMessage: "There was a server error submitting."
            }));
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($97b566dc024060a4$export$b59b70495d14eb0, {
        errorMessage: errorMessage,
        emailInput: emailInput,
        setEmailInput: setEmailInput,
        setHoneypotInput: setHoneypotInput,
        signupSuccess: signupSuccess,
        handleSubmit: handleSubmit
    });
};
const $97b566dc024060a4$var$buttonStyle = null;
const $97b566dc024060a4$export$b59b70495d14eb0 = (props)=>{
    const { errorMessage: errorMessage, emailInput: emailInput, setEmailInput: setEmailInput, setHoneypotInput: setHoneypotInput, signupSuccess: signupSuccess, handleSubmit: handleSubmit } = props;
    const intl = (0, $8e22h.default)();
    const subscribeText = intl.formatMessage({
        id: "SourcetreeAppFooter.top.subscribe",
        defaultMessage: "Subscribe"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            !signupSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("form", {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1y6m _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1o8l _y3gn1e5h _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eC3qs.TextInput), {
                                    name: "email",
                                    value: emailInput,
                                    id: "email",
                                    testId: "email",
                                    label: "",
                                    placeholder: "email@example.com",
                                    onChangeHandler: setEmailInput,
                                    validation: (value)=>{
                                        if (value === "") return [
                                            false,
                                            intl.formatMessage({
                                                id: "SourcetreeAppFooter.top.emptyEmailError",
                                                defaultMessage: "This field is required"
                                            })
                                        ];
                                        else if (!$97b566dc024060a4$var$validateEmail(value)) return [
                                            false,
                                            intl.formatMessage({
                                                id: "SourcetreeAppFooter.top.invalidEmailError",
                                                defaultMessage: "This field requires a valid email address"
                                            })
                                        ];
                                        return [
                                            true,
                                            ""
                                        ];
                                    },
                                    className: (0, $2jatx.default)([
                                        "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                                    ])
                                }),
                                errorMessage && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_syaz1du8 _1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfh1y44"
                                    ]),
                                    children: errorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0cglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                type: "text",
                                name: "list name",
                                "aria-label": "keep this field blank",
                                onChange: (e)=>setHoneypotInput(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                            type: "secondary",
                            text: subscribeText,
                            inputType: "submit",
                            dataEventProps: {
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-product-key": "sourcetreeapp",
                                "data-event-container": "button"
                            },
                            size: "large",
                            color: "whiteblue",
                            "aria-label": subscribeText,
                            className: (0, $2jatx.default)([
                                "_ahbq7vkz _1pfh1y44"
                            ])
                        })
                    ]
                })
            }),
            signupSuccess && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "SourcetreeApp.top.signup-success",
                    defaultMessage: "Thanks for signing up!"
                })
            })
        ]
    });
};
var $97b566dc024060a4$export$2e2bcd8739ae039 = $97b566dc024060a4$export$d8d3a333528c91a5;

});



parcelRegister("cF9FY", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppNav", function () { return $f790ae6eedb0a62d$export$5ba9b99d6060872; });
/* sourcetree-app-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $hnmMQ = parcelRequire("hnmMQ");

var $lGmrg = parcelRequire("lGmrg");
const $f790ae6eedb0a62d$var$stickyWrapperStyle = null;
const $f790ae6eedb0a62d$var$imktNavbarStyle = null;
const $f790ae6eedb0a62d$var$containerFluidStyle = null;
const $f790ae6eedb0a62d$export$d6a07a1754b0e052 = "68px";
const $f790ae6eedb0a62d$var$navigationBarWrapperCss = null;
const $f790ae6eedb0a62d$var$navWrapper = null;
const $f790ae6eedb0a62d$var$navbarStyle = null;
const $f790ae6eedb0a62d$var$navigationBarLogoCss = null;
const $f790ae6eedb0a62d$var$navigationBarLogoLink = null;
const $f790ae6eedb0a62d$var$logoStyle = null;
const $f790ae6eedb0a62d$var$buttonWrapperCss = null;
const $f790ae6eedb0a62d$var$DOWNLOAD_URL = "https://product-downloads.atlassian.com/software/sourcetree/ga/Sourcetree_4.2.18_313.zip";
const $f790ae6eedb0a62d$export$5ba9b99d6060872 = ()=>{
    const intl = (0, $8e22h.default)();
    const [isDisclaimerOpen, setIsDisclaimerOpen] = (0, $1oC0p.useState)(false);
    const buttonText = intl.formatMessage({
        id: "sourcetreeapp.globalnav.button.download.free",
        defaultMessage: "Download free"
    });
    const handleDownloadButtonClick = (event)=>{
        // prevent immediate navigation to the zip
        event.preventDefault();
        // open the disclaimer modal
        setIsDisclaimerOpen(true);
    };
    const handleDisclaimerClose = ()=>{
        setIsDisclaimerOpen(false);
    };
    const handleDisclaimerConfirm = ()=>{
        // user accepted: close modal
        setIsDisclaimerOpen(false);
        // then trigger the real download
        window.location.href = $f790ae6eedb0a62d$var$DOWNLOAD_URL;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_vwz4kb7n _vchhusvi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1f491mrw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
                    className: (0, $2jatx.default)([
                        "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1e0c1ule _1f491mrw _1bsb1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_vwz4kb7n _vchhusvi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bfhkcd5j _16qs130s _1ul91osq _11rm1hrf _kqswh2mm _c71l11ux _1reo15vq _18m915vq _1pby1406 _1tket9kd"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _bfhku67f _1e0c1txw _2lx2vrvc _1bah1h6o _1pbyqfx8 _4t3i88uy"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _2lx2vrvc _1pbyouyt _195g1tcg _hy3utfvk _fy4xidpf _1h1i1wqb"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq _4t3i1osq"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _4cvr1h6o _1o3j1wug"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                href: "/",
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                    image: {
                                                        src: "https://wac-cdn.atlassian.com/dam/jcr:f32681c1-355d-4806-b29c-319b0c6ecb06/Sourcetree-blue.svg?cdnVersion=3108",
                                                        alt: "Sourcetree logo"
                                                    },
                                                    className: (0, $2jatx.default)([
                                                        "_vwz4kb7n _vchhusvi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _syaz17la _4t3i1ul9 _p12f1osq _lcxvglyw _1gwz1ou6 _1d1fqslr"
                                                    ]),
                                                    style: {
                                                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _j2s1glyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                                variant: "primary",
                                                size: "small",
                                                color: "blue",
                                                href: $f790ae6eedb0a62d$var$DOWNLOAD_URL,
                                                onClick: handleDownloadButtonClick,
                                                dataEventProps: {
                                                    "data-event": "clicked",
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "navbar",
                                                    "data-product-key": "sourcetreeapp",
                                                    "data-label-english": "Download free"
                                                },
                                                children: buttonText
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lGmrg.SourcetreeAppDisclaimer), {
                isOpen: isDisclaimerOpen,
                onClose: handleDisclaimerClose,
                onConfirm: handleDisclaimerConfirm
            })
        ]
    });
};

});
parcelRegister("lGmrg", function(module, exports) {
$parcel$export(module.exports, "SourcetreeAppDisclaimer", function () { return $3b97da82052263e7$export$5eb017b420702dcb; });
/* sourcetree-app-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $g1rTV = parcelRequire("g1rTV");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $3b97da82052263e7$var$overlayStyle = null;
const $3b97da82052263e7$var$modalStyle = null;
const $3b97da82052263e7$var$closeButtonStyle = null;
const $3b97da82052263e7$var$headingStyle = null;
const $3b97da82052263e7$var$descriptionContainerStyle = null;
const $3b97da82052263e7$var$bodyTextStyle = null;
const $3b97da82052263e7$var$checkboxRowStyle = null;
const $3b97da82052263e7$var$checkboxInputStyle = null;
const $3b97da82052263e7$var$checkboxTextWrapperStyle = null;
const $3b97da82052263e7$var$checkboxTextStyle = null;
const $3b97da82052263e7$var$linkStyle = null;
const $3b97da82052263e7$var$actionsStyle = null;
const $3b97da82052263e7$var$cancelButtonStyle = null;
const $3b97da82052263e7$var$DOWNLOAD_URL = "https://product-downloads.atlassian.com/software/sourcetree/ga/Sourcetree_4.2.16_307.zip";
const $3b97da82052263e7$var$POST_DOWNLOAD_URL = "https://sourcetreeapp.com/post-download-content";
const $3b97da82052263e7$export$5eb017b420702dcb = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm })=>{
    const intl = (0, $8e22h.default)();
    const [isChecked, setIsChecked] = (0, $1oC0p.useState)(false);
    if (!isOpen) return null;
    const title = intl.formatMessage({
        id: "sourcetreeapp.disclaimer.title",
        defaultMessage: "Important information"
    });
    const description = intl.formatMessage({
        id: "sourcetreeapp.disclaimer.description",
        defaultMessage: "To continue downloading this product you must read and agree to the Atlassian Software License Agreement and Privacy Policy."
    });
    const downloadLabel = intl.formatMessage({
        id: "sourcetreeapp.disclaimer.download",
        defaultMessage: "Download"
    });
    const cancelLabel = intl.formatMessage({
        id: "sourcetreeapp.disclaimer.cancel",
        defaultMessage: "Cancel"
    });
    const licenseText = intl.formatMessage({
        id: "sourcetreeapp.disclaimer.software-license",
        defaultMessage: "Atlassian Software License Agreement"
    });
    const privacyText = intl.formatMessage({
        id: "sourcetreeapp.disclaimer.privacy-policy",
        defaultMessage: "Privacy Policy"
    });
    const handleDownloadClick = (event)=>{
        event.preventDefault();
        if (!isChecked) return;
        onConfirm();
        // Open download in new tab
        window.open($3b97da82052263e7$var$DOWNLOAD_URL, "_blank");
        // Redirect current tab
        window.location.assign($3b97da82052263e7$var$POST_DOWNLOAD_URL);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g1rTV.default), {
        name: "sourcetreeapp-disclaimer-modal",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "sourcetreeapp-disclaimer-heading",
            className: (0, $2jatx.default)([
                "_kqsw1n9t _1r04idpf _bfhk16p9 _1reo15vq _18m915vq _y3gn1h6o _1pbyjwwv _1e0c1txw _4cvr1h6o _1bah1h6o _v56412fe _3um0ewfl _tzy4kb7n"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bfhkcd5j _vchhusvi _1bsb1wug _p12fkbql _19pkidpf _2hwx1wug _otyridpf _18u01wug _2rko1l7b _16qs130s _kqswh2mm _y3gn1e5h _ect412pn _syazvejh"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        "aria-label": intl.formatMessage({
                            id: "sourcetreeapp.disclaimer.close",
                            defaultMessage: "Close overlay"
                        }),
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tpxbi _rjxppxbi _19itglyw _bfhk1j28 _80omtlke _1wybgktf _vwz4kb7n _k48p1fw0 _syaz9c0g"
                        ]),
                        style: {
                            "--_sse8eq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark900"))
                        },
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        id: "sourcetreeapp-disclaimer-heading",
                        className: (0, $2jatx.default)([
                            "_1wyb1k92 _vwz4kb7n _k48p1nn1 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y4tior1b _19pkidpf _2hwxidpf _otyridpf _18u0idpf _179rf3nh _y3gn1e5h _syazvejh"
                        ]),
                        style: {
                            "--_w9vrer": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1100")),
                            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y3gn1e5h"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_1wyb1j6v _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazvejh"
                            ]),
                            style: {
                                "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                            },
                            children: description
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _yv0e1p7m _727qftgi _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1q51idpf _y3gn1e5h _4cvr1y6m"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                            htmlFor: "download-eula-checkbox",
                            style: {
                                display: "contents"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    type: "checkbox",
                                    id: "download-eula-checkbox",
                                    name: "download-eula-checkbox",
                                    checked: isChecked,
                                    onChange: (e)=>setIsChecked(e.target.checked),
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pfhi2wt _1wpz1y6m"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1pfh12gs _1wpz1y6m"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1tcg _syaz1kw7"
                                        ]),
                                        children: [
                                            "I agree to the",
                                            " ",
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                href: "https://www.atlassian.com/legal/software-license-agreement",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: (0, $2jatx.default)([
                                                    "_syaz17la _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
                                                ]),
                                                style: {
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                },
                                                children: licenseText
                                            }),
                                            " ",
                                            "and",
                                            " ",
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: (0, $2jatx.default)([
                                                    "_syaz17la _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
                                                ]),
                                                style: {
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                },
                                                children: privacyText
                                            }),
                                            "."
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_mqm2f3nh _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y3gnusic"
                        ]),
                        style: {
                            "--_w9vrer": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1100"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                variant: "primary",
                                size: "small",
                                type: "button",
                                onClick: handleDownloadClick,
                                isDisabled: !isChecked,
                                children: downloadLabel
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                type: "button",
                                onClick: onClose,
                                className: (0, $2jatx.default)([
                                    "_1wyb1j6v _vwz4bs82 _k48p1nn1 _syaz17la _11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ahbqftgi _80omtlke _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
                                ]),
                                style: {
                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                },
                                children: cancelLabel
                            })
                        ]
                    })
                ]
            })
        })
    });
};

});


parcelRegister("lpEyw", function(module, exports) {
$parcel$export(module.exports, "RovoDevNav", function () { return $ce46063e2c74000e$export$446da800ffd5a425; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $jQ0cd = parcelRequire("jQ0cd");

var $iOXki = parcelRequire("iOXki");
const $ce46063e2c74000e$export$446da800ffd5a425 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup?bundle=devai");
    const pricingHref = (0, $jQ0cd.useLocalizedHref)("/software/rovo-dev/pricing");
    const documentationHref = (0, $jQ0cd.useLocalizedHref)("https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents");
    const logo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg",
            alt: "Rovo Dev"
        },
        style: {
            height: "26px"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
        productLogoUrl: "/software/rovo-dev",
        productLogo: logo,
        productLogoAriaLabel: intl.formatMessage({
            id: "RovoDevNav.productLogoAriaLabel",
            defaultMessage: "Rovo Dev logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: logo,
        productPageNavLinks: [
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: pricingHref
            },
            {
                globalLinksKey: "documentation",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.documentation",
                    defaultMessage: "Documentation"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: documentationHref
            }
        ],
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-rovo-dev",
                mobileLinksProps: [
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.pricing",
                            defaultMessage: "Pricing"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: pricingHref
                    },
                    {
                        globalLinksKey: "documentation",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.documentation",
                            defaultMessage: "Documentation"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: documentationHref
                    }
                ]
            }
        ]
    });
};

});

parcelRegister("8xC9Z", function(module, exports) {
$parcel$export(module.exports, "OptionalSiteSelectorContextProvider", function () { return $770969627e2933b5$export$ef73016e54e00d81; });

var $7VQPk = parcelRequire("7VQPk");

var $iHYHa = parcelRequire("iHYHa");
const $770969627e2933b5$export$ef73016e54e00d81 = (props)=>{
    const { siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix, children: children } = props;
    if (!siteSelectorProductKey) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHYHa.SiteSelectorContextProvider), {
        productKey: siteSelectorProductKey,
        analyticsPrefix: siteSelectorAnalyticsPrefix ?? siteSelectorProductKey,
        internalLinkAfterIdentity: siteSelectorProductKey === "confluence.ondemand" ? "/team-playbook/plays/choose-your-site" : undefined,
        children: children
    });
};

});


parcelRegister("7xYdG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8abc8eb98b0d0a1c$export$2e2bcd8739ae039; });
/* pagination.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $sGleB = parcelRequire("sGleB");
const $8abc8eb98b0d0a1c$var$centerStyles = null;
const $8abc8eb98b0d0a1c$var$UniformPagination = (props)=>{
    // Generate pages array from total pages
    const pagesArray = Array.from({
        length: props.pages
    }, (_, i)=>i + 1);
    // For now, using defaults until page logic is implemented
    const selectedIndex = 0;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $sGleB.Pagination), {
            pages: pagesArray,
            selectedIndex: selectedIndex
        })
    });
};
var $8abc8eb98b0d0a1c$export$2e2bcd8739ae039 = $8abc8eb98b0d0a1c$var$UniformPagination;

});
parcelRegister("sGleB", function(module, exports) {
$parcel$export(module.exports, "Pagination", function () { return $d54cd1250a40cc23$export$68f5e1453c188a82; });
/* pagination.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7IesZ = parcelRequire("7IesZ");

var $9BG80 = parcelRequire("9BG80");

var $kbpa7 = parcelRequire("kbpa7");
const $d54cd1250a40cc23$var$baseStyles = null;
const $d54cd1250a40cc23$var$innerContainerStyles = null;
const $d54cd1250a40cc23$var$pagesContainerStyles = null;
// @ts-ignore
const $d54cd1250a40cc23$var$_navigatorContainerStyles = null;
const $d54cd1250a40cc23$var$pageButtonStyles = null;
const $d54cd1250a40cc23$var$navigatorStyles = null;
const $d54cd1250a40cc23$var$ellipsisStyles = null;
const $d54cd1250a40cc23$var$createPageRange = (pages, selectedIndex)=>{
    const result = [];
    const totalPages = pages.length;
    const current = selectedIndex;
    if (totalPages <= 5) // Show all pages if 5 or fewer
    return pages.map((page, index)=>({
            type: "page",
            page: page,
            index: index,
            key: `page-${index}`
        }));
    // Always show first page
    result.push({
        type: "page",
        page: pages[0],
        index: 0,
        key: "page-0"
    });
    if (current <= 2) {
        // Show pages 1, 2, 3, 4, ..., last
        for(let i = 1; i <= 3; i++)if (i < totalPages - 1) result.push({
            type: "page",
            page: pages[i],
            index: i,
            key: `page-${i}`
        });
        if (totalPages > 5) result.push({
            type: "ellipsis",
            key: "ellipsis-end"
        });
    } else if (current >= totalPages - 3) {
        if (totalPages > 5) result.push({
            type: "ellipsis",
            key: "ellipsis-start"
        });
        for(let i = Math.max(1, totalPages - 4); i < totalPages - 1; i++)result.push({
            type: "page",
            page: pages[i],
            index: i,
            key: `page-${i}`
        });
    } else {
        result.push({
            type: "ellipsis",
            key: "ellipsis-start"
        });
        for(let i = current - 1; i <= current + 1; i++)result.push({
            type: "page",
            page: pages[i],
            index: i,
            key: `page-${i}`
        });
        result.push({
            type: "ellipsis",
            key: "ellipsis-end"
        });
    }
    if (totalPages > 1) result.push({
        type: "page",
        page: pages[totalPages - 1],
        index: totalPages - 1,
        key: `page-${totalPages - 1}`
    });
    return result;
};
const $d54cd1250a40cc23$export$68f5e1453c188a82 = ({ pages: pages = [], selectedIndex: selectedIndex = 0, label: label, pageLabel: pageLabel, previousLabel: previousLabel, nextLabel: nextLabel, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    // Use provided props or fall back to localized defaults
    const ariaLabels = {
        navigation: label || formatMessage({
            id: "wac.design.pagination.navigation.label",
            defaultMessage: "Pagination navigation"
        }),
        page: pageLabel || formatMessage({
            id: "wac.design.pagination.page.label",
            defaultMessage: "Page"
        }),
        previous: previousLabel || formatMessage({
            id: "wac.design.pagination.previous.label",
            defaultMessage: "Previous page"
        }),
        next: nextLabel || formatMessage({
            id: "wac.design.pagination.next.label",
            defaultMessage: "Next page"
        })
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    if (pages.length === 0) return null;
    const fireAnalytics = (label)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "pagination",
            source: "pagination",
            attributes: {
                label: label
            }
        }).fire();
    };
    const handlePageClick = (event, pageIndex)=>{
        if (pageIndex === selectedIndex) return;
        const page = pages[pageIndex];
        if (page !== undefined) {
            fireAnalytics(`page ${page}`);
            onChange?.(event, page);
        }
    };
    const handlePreviousClick = (event)=>{
        if (selectedIndex === 0) return;
        const page = pages[selectedIndex - 1];
        if (page !== undefined) {
            fireAnalytics("previous");
            onChange?.(event, page);
        }
    };
    const handleNextClick = (event)=>{
        if (selectedIndex === pages.length - 1) return;
        const page = pages[selectedIndex + 1];
        if (page !== undefined) {
            fireAnalytics("next");
            onChange?.(event, page);
        }
    };
    const pageRange = $d54cd1250a40cc23$var$createPageRange(pages, selectedIndex);
    const isPreviousDisabled = selectedIndex === 0;
    const isNextDisabled = selectedIndex === pages.length - 1;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
        "aria-label": ariaLabels.navigation,
        className: (0, $2jatx.default)([
            "_1e0c116y _1yt4xy5q _4cvr1h6o _1bah1h6o _ect4bzd7 _11q7cd5j _vchhusvi"
        ]),
        style: {
            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1h6o _zulp1ejb _vchhusvi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    onClick: handlePreviousClick,
                    disabled: isPreviousDisabled,
                    "aria-label": ariaLabels.previous,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _19itglyw _bfhk1j28 _80omtlke _2rko1b66 _1wybdlk8 _vwz4gktf _k48p1nn1 _1bsbxy5q _4t3ixy5q _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1yg0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1ygb8djs _1ah3yh40 _j5dh13gf _vbqbxv17"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800")),
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                        "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                        label: ""
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _zulppxbi"
                    ]),
                    children: pageRange.map((item)=>{
                        if (item.type === "ellipsis") return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            "aria-hidden": "true",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbxy5q _4t3ixy5q _syaz1yg0 _1wybdlk8 _vwz4gktf _k48p1nn1 _uiztglyw"
                            ]),
                            style: {
                                "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                            },
                            children: "..."
                        }, item.key);
                        const isSelected = item.index === selectedIndex;
                        const pageNumber = item.page;
                        const pageIndex = item.index;
                        if (pageNumber === undefined || pageIndex === undefined) return null;
                        return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            onClick: (event)=>handlePageClick(event, pageIndex),
                            "aria-current": isSelected ? "page" : undefined,
                            "aria-label": `${ariaLabels.page} ${pageNumber}${isSelected ? ", current page" : ""}`,
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1bah1h6o _19itglyw _bfhk1j28 _80omtlke _2rko1ssb _1wybdlk8 _vwz4gktf _k48p1nn1 _1bsbxy5q _4t3ixy5q _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1yg0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1fbp17la _1ygbwfk4 _1ah3v77o _qn4zbfng _1lg61hlo _434tcd5j"
                            ]),
                            style: {
                                "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800")),
                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            },
                            children: pageNumber
                        }, item.key);
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    onClick: handleNextClick,
                    disabled: isNextDisabled,
                    "aria-label": ariaLabels.next,
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o _19itglyw _bfhk1j28 _80omtlke _2rko1b66 _1wybdlk8 _vwz4gktf _k48p1nn1 _1bsbxy5q _4t3ixy5q _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1yg0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1ygb8djs _1ah3yh40 _j5dh13gf _vbqbxv17"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800")),
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                        "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                        label: ""
                    })
                })
            ]
        })
    });
};

});


parcelRegister("gebIf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $88f904a45e3c98a2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $2smMv = parcelRequire("2smMv");

var $lTkkF = parcelRequire("lTkkF");
const $88f904a45e3c98a2$var$UniformPanel = (props)=>{
    const panelProps = {
        panelType: props.panelType,
        label: props.label,
        description: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : props.description ?? null
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2smMv.Panel), {
        ...panelProps
    });
};
var $88f904a45e3c98a2$export$2e2bcd8739ae039 = $88f904a45e3c98a2$var$UniformPanel;

});

parcelRegister("9tius", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc353b3611f7f2c4$export$2e2bcd8739ae039; });
/* personalization-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $gIKKj = parcelRequire("gIKKj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $eRzlV = parcelRequire("eRzlV");

var $iSeHD = parcelRequire("iSeHD");

var $9rnwe = parcelRequire("9rnwe");

var $4L5aK = parcelRequire("4L5aK");

var $3o1l4 = parcelRequire("3o1l4");
const $bc353b3611f7f2c4$var$VariantsStatus = {
    NO_VARIANT_MATCH: "no_variant_match",
    VARIANTS_AVAILABLE: "variants_available",
    FETCHING_SEGMENTS: "fetching_segments",
    SEGMENT_FETCH_ERROR: "segment_fetch_error",
    MISSING_USER_SEGMENTS: "missing_user_segments",
    PERSONALIZATION_DISABLED: "personalization_disabled",
    NOT_ENROLLED_IN_EXPERIMENT: "not_enrolled_in_experiment"
};
const $bc353b3611f7f2c4$var$renderMessages = {
    [$bc353b3611f7f2c4$var$VariantsStatus.NO_VARIANT_MATCH]: "No variants match. Rendering Default",
    [$bc353b3611f7f2c4$var$VariantsStatus.MISSING_USER_SEGMENTS]: "No User Segments acquired. Rendering Default",
    [$bc353b3611f7f2c4$var$VariantsStatus.PERSONALIZATION_DISABLED]: "Personalization is disabled. Rendering Default",
    [$bc353b3611f7f2c4$var$VariantsStatus.SEGMENT_FETCH_ERROR]: "Error fetching User Segments. Rendering Default",
    [$bc353b3611f7f2c4$var$VariantsStatus.NOT_ENROLLED_IN_EXPERIMENT]: "User not enrolled in experiment. Rendering Default",
    [$bc353b3611f7f2c4$var$VariantsStatus.FETCHING_SEGMENTS]: "Fetching User Segments. Temporarily rendering Default",
    [$bc353b3611f7f2c4$var$VariantsStatus.VARIANTS_AVAILABLE]: ""
};
const $bc353b3611f7f2c4$var$VariantSelector = (props)=>{
    return(// this should only be one item, but the SlotWrapper expects an array
    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
        children: props.items.map((item, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                children: item
            }, `variant-${index}`))
    }));
};
// Helper function to render default slot
const $bc353b3611f7f2c4$var$renderDefaultSlot = (variantStatus, setRenderMessage)=>{
    setRenderMessage($bc353b3611f7f2c4$var$renderMessages[variantStatus]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "default",
        wrapperComponent: $bc353b3611f7f2c4$var$VariantSelector
    });
};
const $bc353b3611f7f2c4$var$isSegmentGroup = (entry)=>"matchMode" in entry && "segments" in entry;
/**
 * Normalize the user's value for a given segment type to a string array.
 * All segment types are normalized to string[] for uniform comparison.
 */ const $bc353b3611f7f2c4$var$getUserValues = (segmentType, personalizationSegmentValues)=>{
    const raw = personalizationSegmentValues[segmentType];
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    return [
        raw
    ];
};
/**
 * Evaluate a single SegmentRule against the user's profile values.
 * Applies the rule's operator (defaults to "is" for legacy data with no operator).
 */ const $bc353b3611f7f2c4$var$evaluateSegmentRule = (rule, personalizationSegmentValues)=>{
    const op = rule.operator ?? "is";
    const userValues = $bc353b3611f7f2c4$var$getUserValues(rule.segmentType, personalizationSegmentValues);
    // Helper: does any rule target match any user value, given a comparator?
    const positiveMatch = (comparator)=>rule.value.some((v)=>userValues.some((u)=>comparator(u, v)));
    switch(op){
        case "is":
        // "matches" is an alias for "is" (exact equality on discrete values)
        case "matches":
            return positiveMatch((u, v)=>u === v);
        case "is_not":
        // "not_matches" is an alias for "is_not"
        case "not_matches":
            return !positiveMatch((u, v)=>u === v);
        case "includes":
            return positiveMatch((u, v)=>u.includes(v));
        case "not_includes":
            return !positiveMatch((u, v)=>u.includes(v));
        case "matches_regex":
            // Compile each regex once per target value (not inside the inner loop)
            return rule.value.some((v)=>{
                const re = new RegExp(v);
                return userValues.some((u)=>re.test(u));
            });
        case "not_matches_regex":
            return !rule.value.some((v)=>{
                const re = new RegExp(v);
                return userValues.some((u)=>re.test(u));
            });
        default:
            return false;
    }
};
/**
 * Evaluate a SegmentGroup against the user's profile values.
 * matchMode "any" = OR across rules, "all" = AND across rules.
 */ const $bc353b3611f7f2c4$var$evaluateSegmentGroup = (group, personalizationSegmentValues)=>{
    const check = group.matchMode === "any" ? "some" : "every";
    return group.segments[check]((rule)=>$bc353b3611f7f2c4$var$evaluateSegmentRule(rule, personalizationSegmentValues));
};
// Helper function to find matching variant index
const $bc353b3611f7f2c4$var$findMatchingVariant = (variantCandidates, personalizationSegmentValues)=>{
    if (!personalizationSegmentValues) return -1;
    return variantCandidates.findIndex((variantCandidate)=>{
        const rawValue = variantCandidate.parameters?.["personalizationSegment"]?.value;
        if (!rawValue || rawValue.length === 0) return false;
        const firstEntry = rawValue[0];
        if (!firstEntry) return false;
        // Detect format by checking whether the first item is a SegmentGroup
        if ($bc353b3611f7f2c4$var$isSegmentGroup(firstEntry)) {
            const groups = rawValue;
            // ALL groups must pass (AND between groups)
            return groups.every((group)=>$bc353b3611f7f2c4$var$evaluateSegmentGroup(group, personalizationSegmentValues));
        }
        // Legacy flat format: all rules are AND-ed together ("is" operator implied when absent)
        const segments = rawValue;
        return segments.every((rule)=>$bc353b3611f7f2c4$var$evaluateSegmentRule(rule, personalizationSegmentValues));
    });
};
// Helper function to get final personalization values
const $bc353b3611f7f2c4$var$getFinalPersonalizationValues = (userSegments, overrides)=>{
    const finalValues = {
        ...userSegments,
        ...overrides?.useOverrides ? overrides : {},
        useOverrides: overrides?.useOverrides || false,
        enrollInExperiment: overrides?.enrollInExperiment || false
    };
    return finalValues;
};
const $bc353b3611f7f2c4$var$ExperimentallyPersonalizedSection = ({ experimentId: experimentId, setVariantStatus: setVariantStatus, overrides: overrides, setRenderMessage: setRenderMessage, variantComponent: variantComponent })=>{
    const experimentStatus = (0, $gIKKj.useExperiment)({
        experimentName: experimentId,
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>typeof value === "boolean"
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Personalization Experiment - configured in Uniform",
            expectedReleaseDate: "unknown - configured in Uniform",
            expectedRuntime: "unknown - configured in Uniform",
            context: {
                urls: []
            }
        }
    });
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    (0, $1oC0p.useEffect)(()=>{
        if (!showTreatment && !overrides?.enrollInExperiment) {
            if (setVariantStatus) setVariantStatus($bc353b3611f7f2c4$var$VariantsStatus.NOT_ENROLLED_IN_EXPERIMENT);
        }
    }, [
        showTreatment,
        overrides?.enrollInExperiment,
        setVariantStatus
    ]);
    if (!showTreatment && !overrides?.enrollInExperiment) return $bc353b3611f7f2c4$var$renderDefaultSlot($bc353b3611f7f2c4$var$VariantsStatus.NOT_ENROLLED_IN_EXPERIMENT, setRenderMessage);
    return variantComponent;
};
const $bc353b3611f7f2c4$var$getRequiredSegmentTypes = (variantCandidates)=>{
    const requiredSegments = new Set();
    variantCandidates.forEach((variantCandidate)=>{
        const rawValue = variantCandidate.parameters?.["personalizationSegment"]?.value;
        if (!rawValue || rawValue.length === 0) return;
        const firstEntry = rawValue[0];
        if (!firstEntry) return;
        if ($bc353b3611f7f2c4$var$isSegmentGroup(firstEntry)) // New group format: extract segment types from nested segments
        rawValue.forEach((group)=>{
            group.segments.forEach(({ segmentType: segmentType })=>requiredSegments.add(segmentType));
        });
        else // Legacy flat format
        rawValue.forEach(({ segmentType: segmentType })=>requiredSegments.add(segmentType));
    });
    return [
        ...requiredSegments
    ];
};
const $bc353b3611f7f2c4$var$STATIC_PERSONALIZATION_HYDRATION_RULES = [
    {
        field: (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
            "clusterTag",
            "anchor"
        ],
        hasIncomingValue: (value)=>typeof value === "string" && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ""
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).SUB_ANCHOR,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).SUB_ANCHOR,
            "subAnchor"
        ],
        hasIncomingValue: (value)=>typeof value === "string" && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ""
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).CHANNEL,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).CHANNEL
        ],
        hasIncomingValue: (value)=>typeof value === "string" && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ""
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).UTM_CONTENT,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).UTM_CONTENT,
            "utmContent"
        ],
        hasIncomingValue: (value)=>typeof value === "string" && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ""
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION
        ],
        hasIncomingValue: (value)=>typeof value === "string" && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ""
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).GEOLOCATION,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).GEOLOCATION
        ],
        hasIncomingValue: (value)=>typeof value === "string" && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ""
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE
        ],
        hasIncomingValue: (value)=>typeof value === "string" && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ""
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).LOGIN_STATUS,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).LOGIN_STATUS
        ],
        hasIncomingValue: (value)=>typeof value === "string" && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || value === ""
    },
    {
        field: (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS,
        sourceKeys: [
            (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS
        ],
        hasIncomingValue: (value)=>Array.isArray(value) && value.length > 0,
        isMissingOverrideValue: (value)=>value === undefined || Array.isArray(value) && value.length === 0
    }
];
const $bc353b3611f7f2c4$var$hydrateStaticPersonalizationValues = (previousOverrides, personalizationValues)=>{
    let didChange = false;
    const nextOverrides = {
        ...previousOverrides
    };
    $bc353b3611f7f2c4$var$STATIC_PERSONALIZATION_HYDRATION_RULES.forEach(({ field: field, hasIncomingValue: hasIncomingValue, isMissingOverrideValue: isMissingOverrideValue })=>{
        const incomingValue = personalizationValues[field];
        if (hasIncomingValue(incomingValue) && isMissingOverrideValue(nextOverrides[field])) {
            nextOverrides[field] = incomingValue;
            didChange = true;
        }
    });
    return didChange ? nextOverrides : previousOverrides;
};
const $bc353b3611f7f2c4$var$readStaticPersonalizationValuesFromQuirks = (uniformContext)=>{
    const contextWithStorage = uniformContext;
    const directQuirks = contextWithStorage?.quirks ?? {};
    const storageQuirks = contextWithStorage?.storage?.data?.quirks ?? {};
    const quirks = {
        ...storageQuirks,
        ...directQuirks
    };
    return $bc353b3611f7f2c4$var$STATIC_PERSONALIZATION_HYDRATION_RULES.reduce((acc, { field: field, sourceKeys: sourceKeys, hasIncomingValue: hasIncomingValue })=>{
        const candidateValue = sourceKeys.map((sourceKey)=>quirks[sourceKey]).find((value)=>hasIncomingValue(value));
        if (hasIncomingValue(candidateValue)) acc[field] = candidateValue;
        return acc;
    }, {});
};
// Helper function to validate personalization prerequisites
const $bc353b3611f7f2c4$var$validatePersonalizationPrerequisites = (shouldPersonalize, isProd, userSegments, statuses, error, segmentFetchErrors, requiredSegmentTypes, overrides)=>{
    // Check if any required segments are still fetching
    const areRequiredSegmentsFetching = requiredSegmentTypes.some((segmentType)=>!statuses[segmentType] || statuses[segmentType] === "fetching" || statuses[segmentType] === "idle");
    if (areRequiredSegmentsFetching) return {
        isValid: false,
        status: $bc353b3611f7f2c4$var$VariantsStatus.FETCHING_SEGMENTS
    };
    if (!shouldPersonalize && isProd) return {
        isValid: false,
        status: $bc353b3611f7f2c4$var$VariantsStatus.PERSONALIZATION_DISABLED
    };
    if (!userSegments) return {
        isValid: false,
        status: $bc353b3611f7f2c4$var$VariantsStatus.MISSING_USER_SEGMENTS
    };
    const hasRequiredSegmentFetchErrors = requiredSegmentTypes.length > 0 && (segmentFetchErrors || []).some((segmentType)=>requiredSegmentTypes.includes(segmentType));
    if (error && !overrides?.useOverrides && hasRequiredSegmentFetchErrors) return {
        isValid: false,
        status: $bc353b3611f7f2c4$var$VariantsStatus.SEGMENT_FETCH_ERROR
    };
    return {
        isValid: true
    };
};
// Helper function to create variant component
const $bc353b3611f7f2c4$var$createVariantComponent = (chosenVariantIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "variants",
        wrapperComponent: (slotProps)=>$bc353b3611f7f2c4$var$VariantSelector({
                ...slotProps,
                items: [
                    slotProps.items[chosenVariantIndex]
                ]
            })
    });
// Helper function to set render message for variant
const $bc353b3611f7f2c4$var$setVariantRenderMessage = (variantCandidates, chosenVariantIndex, overrides, setRenderMessage)=>{
    const variantName = $bc353b3611f7f2c4$var$getCurrentVariantName(variantCandidates, chosenVariantIndex);
    const sourceType = overrides?.useOverrides ? "Overrides" : "User Segments";
    setRenderMessage(`Rendering "${variantName}" Variant based on ${sourceType}`);
};
const $bc353b3611f7f2c4$var$getCurrentVariantName = (variantCandidates, chosenVariantIndex)=>{
    return variantCandidates[chosenVariantIndex]?.parameters?.["variantName"]?.value || "unknown";
};
const $bc353b3611f7f2c4$var$toKebabCase = (value)=>value.trim().replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "").toLowerCase();
const $bc353b3611f7f2c4$var$getVariantPersonalizationIdentifier = (variantCandidate)=>{
    const rawValue = variantCandidate.parameters?.["personalizationSegment"]?.value;
    const entries = rawValue ?? [];
    const segmentRules = entries.flatMap((entry)=>$bc353b3611f7f2c4$var$isSegmentGroup(entry) ? entry.segments : [
            entry
        ]);
    const anchorRule = segmentRules.find((rule)=>rule.segmentType === (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG || rule.segmentType === (0, $3o1l4.UserSegmentTypes).SUB_ANCHOR);
    const anchorValue = anchorRule?.value.find((value)=>value.length > 0);
    if (anchorValue) return $bc353b3611f7f2c4$var$toKebabCase(anchorValue);
    const variantName = variantCandidate.parameters?.["variantName"]?.value;
    return typeof variantName === "string" && variantName.length > 0 ? $bc353b3611f7f2c4$var$toKebabCase(variantName) : undefined;
};
// eslint-disable-next-line complexity
const $bc353b3611f7f2c4$var$PersonalizedSection = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const [variantStatus, setVariantStatus] = (0, $1oC0p.useState)(null);
    const { data: userSegments, error: error, segmentFetchErrors: segmentFetchErrors, statuses: statuses } = (0, $3o1l4.useUserSegments)();
    const shouldPersonalize = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).uniformPersonalizationEnabled);
    const isProd = (0, $eRzlV.isProduction)();
    const composition = (0, $01zo5.useUniformCurrentComposition)();
    const compositionId = composition?.data?._id;
    // Memoize slots to prevent infinite loops
    const variantSlots = (0, $1oC0p.useMemo)(()=>props.component.slots?.["variants"] ?? [], [
        props.component.slots
    ]);
    // Compute variant selection synchronously during render (SSR + Client)
    const { selectedVariantKey: selectedVariantKey, computedStatus: computedStatus, renderedExperience: renderedExperience } = (0, $1oC0p.useMemo)(()=>{
        const validation = $bc353b3611f7f2c4$var$validatePersonalizationPrerequisites(shouldPersonalize, isProd, userSegments, statuses, error, segmentFetchErrors, props.requiredSegmentTypes, props.overrides);
        if (!validation.isValid) return {
            selectedVariantKey: "default_experience",
            computedStatus: validation.status,
            renderedExperience: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "default",
                wrapperComponent: $bc353b3611f7f2c4$var$VariantSelector
            })
        };
        // Process personalization logic
        const personalizationValues = $bc353b3611f7f2c4$var$getFinalPersonalizationValues(userSegments, props.overrides);
        const chosenVariantIndex = $bc353b3611f7f2c4$var$findMatchingVariant(variantSlots, personalizationValues);
        // Check if variant was found
        if (chosenVariantIndex < 0) return {
            selectedVariantKey: "default_experience",
            computedStatus: $bc353b3611f7f2c4$var$VariantsStatus.NO_VARIANT_MATCH,
            renderedExperience: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "default",
                wrapperComponent: $bc353b3611f7f2c4$var$VariantSelector
            })
        };
        const variantName = $bc353b3611f7f2c4$var$getCurrentVariantName(variantSlots, chosenVariantIndex);
        const selectedVariant = variantSlots[chosenVariantIndex];
        const variantIdentifier = selectedVariant ? $bc353b3611f7f2c4$var$getVariantPersonalizationIdentifier(selectedVariant) : undefined;
        const variantComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-personalization-variant",
            "data-personalization-identifier": variantIdentifier,
            "data-variant-name": variantName,
            children: $bc353b3611f7f2c4$var$createVariantComponent(chosenVariantIndex)
        });
        // Handle experimental personalization
        if (props.experimentId) return {
            selectedVariantKey: variantName,
            computedStatus: $bc353b3611f7f2c4$var$VariantsStatus.VARIANTS_AVAILABLE,
            renderedExperience: /*#__PURE__*/ (0, $7VQPk.jsx)($bc353b3611f7f2c4$var$ExperimentallyPersonalizedSection, {
                containerName: props.containerName,
                setRenderMessage: props.setRenderMessage,
                setVariantStatus: setVariantStatus,
                experimentId: props.experimentId,
                variantComponent: variantComponent,
                overrides: props.overrides,
                component: props.component
            })
        };
        return {
            selectedVariantKey: variantName,
            computedStatus: $bc353b3611f7f2c4$var$VariantsStatus.VARIANTS_AVAILABLE,
            renderedExperience: variantComponent
        };
    }, [
        error,
        segmentFetchErrors,
        props.overrides,
        props.setRenderMessage,
        props.experimentId,
        props.containerName,
        props.component,
        props.requiredSegmentTypes,
        shouldPersonalize,
        isProd,
        statuses,
        userSegments,
        variantSlots
    ]);
    // Update render message as a side effect (client-only)
    (0, $1oC0p.useEffect)(()=>{
        if (computedStatus === $bc353b3611f7f2c4$var$VariantsStatus.VARIANTS_AVAILABLE) {
            const chosenVariantIndex = variantSlots.findIndex((v)=>$bc353b3611f7f2c4$var$getCurrentVariantName(variantSlots, variantSlots.indexOf(v)) === selectedVariantKey);
            if (chosenVariantIndex >= 0) $bc353b3611f7f2c4$var$setVariantRenderMessage(variantSlots, chosenVariantIndex, props.overrides, props.setRenderMessage);
        } else props.setRenderMessage($bc353b3611f7f2c4$var$renderMessages[computedStatus]);
        setVariantStatus(computedStatus);
    }, [
        computedStatus,
        selectedVariantKey,
        variantSlots,
        props.overrides,
        props.setRenderMessage
    ]);
    // Send analytics metrics (client-only)
    (0, $1oC0p.useEffect)(()=>{
        if (!selectedVariantKey || !variantStatus) return;
        if (analyticsClient && typeof window !== "undefined") createAnalyticsEvent({
            name: "waePersonalizationVariantRender",
            action: "personalizationVariantRender",
            actionSubject: "uniformPage",
            eventType: "screen",
            source: window.location.pathname,
            attributes: {
                containerName: props.containerName,
                path: window.location.pathname,
                compositionId: compositionId,
                variantName: selectedVariantKey,
                status: variantStatus
            }
        }).fire();
    }, [
        compositionId,
        createAnalyticsEvent,
        selectedVariantKey,
        props.containerName,
        variantStatus,
        analyticsClient
    ]);
    return renderedExperience;
};
const $bc353b3611f7f2c4$var$UniformPersonalizationContainer = (props)=>{
    const isProd = (0, $eRzlV.isProduction)();
    const isUniformEditMode = typeof window !== "undefined" && window.location.pathname.includes("/uniform-preview");
    const { personalizationValues: personalizationValues, uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    const currentComposition = (0, $01zo5.useUniformCurrentComposition)();
    const requiredSegmentTypes = (0, $1oC0p.useMemo)(()=>$bc353b3611f7f2c4$var$getRequiredSegmentTypes(props.component.slots?.["variants"] ?? []), [
        props.component.slots
    ]);
    const [overrides, setOverrides] = (0, $1oC0p.useState)(()=>{
        const initialOverrides = {
            useOverrides: false,
            enrollInExperiment: false,
            ...personalizationValues
        };
        return initialOverrides;
    });
    const [renderMessage, setRenderMessage] = (0, $1oC0p.useState)("");
    const [isContainerHovered, setIsContainerHovered] = (0, $1oC0p.useState)(false);
    const [isControlsPinned, setIsControlsPinned] = (0, $1oC0p.useState)(false);
    const [isControlsActive, setIsControlsActive] = (0, $1oC0p.useState)(false);
    const isActiveLayer = isContainerHovered || isControlsPinned || isControlsActive || isUniformEditMode;
    (0, $1oC0p.useEffect)(()=>{
        if (!personalizationValues) return;
        // `personalizationValues` are seeded in page-wrapper-streaming and mirrored to Uniform quirks.
        // Treat these as static bootstrap values and only fill missing override fields.
        setOverrides((previousOverrides)=>$bc353b3611f7f2c4$var$hydrateStaticPersonalizationValues(previousOverrides, personalizationValues));
    }, [
        personalizationValues
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!isUniformEditMode) return;
        const syncQuirkValues = ()=>{
            const nextQuirkValues = $bc353b3611f7f2c4$var$readStaticPersonalizationValuesFromQuirks(uniformContext);
            setOverrides((previousOverrides)=>$bc353b3611f7f2c4$var$hydrateStaticPersonalizationValues(previousOverrides, nextQuirkValues));
        };
        syncQuirkValues();
        const intervalId = window.setInterval(syncQuirkValues, 250);
        return ()=>{
            window.clearInterval(intervalId);
        };
    }, [
        isUniformEditMode,
        uniformContext
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        onMouseEnter: !isProd ? ()=>setIsContainerHovered(true) : undefined,
        onMouseLeave: !isProd ? ()=>setIsContainerHovered(false) : undefined,
        className: (0, $2jatx.default)([
            !isProd && "_kqswh2mm _12ji1j28 _1qu2nqa1 _12y3yh40 _2rkovwyg _v564lu1q _1ubt1t8k"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_9qtbdu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue300"))
        },
        children: [
            !isProd && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    zIndex: isActiveLayer ? 2147483000 : 1
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4L5aK.PersonalizationOverrideControls), {
                    values: overrides,
                    setValues: setOverrides,
                    renderMessage: renderMessage,
                    isContainerHovered: isContainerHovered,
                    requiredSegmentTypes: requiredSegmentTypes,
                    isPinned: isControlsPinned,
                    setIsPinned: setIsControlsPinned,
                    setIsActive: setIsControlsActive,
                    compositionSlug: currentComposition?.data?.projectMapNodes?.[0]?.path ?? currentComposition?.data?._slug
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($bc353b3611f7f2c4$var$PersonalizedSection, {
                ...props,
                overrides: overrides,
                setRenderMessage: setRenderMessage,
                experimentId: props.experimentId,
                requiredSegmentTypes: requiredSegmentTypes
            })
        ]
    });
};
var $bc353b3611f7f2c4$export$2e2bcd8739ae039 = $bc353b3611f7f2c4$var$UniformPersonalizationContainer;

});
parcelRegister("4L5aK", function(module, exports) {
$parcel$export(module.exports, "PersonalizationOverrideControls", function () { return $0a7d65259cee0cad$export$3509149ef9c5f46; });
/* personalization-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $LDFpB = parcelRequire("LDFpB");

var $grkXZ = parcelRequire("grkXZ");

var $eC3qs = parcelRequire("eC3qs");

var $kbpa7 = parcelRequire("kbpa7");

var $aL9gN = parcelRequire("aL9gN");

var $8c0sT = parcelRequire("8c0sT");

var $3o1l4 = parcelRequire("3o1l4");
const $0a7d65259cee0cad$var$LABEL_STYLES = null;
const $0a7d65259cee0cad$var$isUniformPersonalizationEditMode = ()=>typeof window !== "undefined" && window.location.pathname.includes("/uniform-preview");
const $0a7d65259cee0cad$var$PersonalizationControlPanel = ({ values: values, handleSelectChange: handleSelectChange, requiredSegmentTypes: requiredSegmentTypes })=>{
    const isSegmentControlVisible = (segmentType)=>requiredSegmentTypes.includes(segmentType);
    const getMultiSelectValues = (segmentType)=>{
        const segmentValues = values[segmentType];
        if (Array.isArray(segmentValues)) return segmentValues;
        if (typeof segmentValues === "string" && segmentValues.length > 0) return [
            segmentValues
        ];
        return [];
    };
    const renderSegmentControl = (control)=>{
        const segmentValue = values[control.segmentType];
        switch(control.ux){
            case "dropdown":
                {
                    const selectedValue = typeof segmentValue === "string" ? segmentValue : "";
                    const selectedLabel = control.getSelectedLabel?.(selectedValue, control.options) ?? control.defaultLabel;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grkXZ.DropdownSelector), {
                        name: control.segmentType,
                        id: control.segmentType,
                        label: control.label,
                        options: control.options,
                        defaultValue: {
                            value: selectedValue,
                            label: selectedLabel
                        },
                        onChangeHandler: (value)=>{
                            handleSelectChange(control.segmentType, value);
                        }
                    });
                }
            case "textbox":
                {
                    const textboxValue = typeof segmentValue === "string" ? segmentValue : "";
                    const textboxPlaceholder = control.placeholder ?? "";
                    if (control.segmentType === (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: control.segmentType,
                                className: (0, $2jatx.default)([
                                    "_1e0c1ule _syaz5k8o _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                                ]),
                                style: {
                                    "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                                },
                                children: control.label
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                id: control.segmentType,
                                "data-testid": control.segmentType,
                                type: "text",
                                value: textboxValue,
                                onChange: (event)=>{
                                    const nextValue = control.transformValue ? control.transformValue(event.target.value) : event.target.value;
                                    handleSelectChange(control.segmentType, nextValue);
                                },
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq"
                                ])
                            })
                        ]
                    });
                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eC3qs.TextInput), {
                        id: control.segmentType,
                        name: control.segmentType,
                        label: control.label,
                        placeholder: textboxPlaceholder,
                        value: textboxValue,
                        onChangeHandler: (value)=>{
                            const nextValue = control.transformValue ? control.transformValue(value) : value;
                            handleSelectChange(control.segmentType, nextValue);
                        }
                    });
                }
            case "multi-select":
                {
                    const selectedValues = getMultiSelectValues(control.segmentType);
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: control.segmentType,
                                className: (0, $2jatx.default)([
                                    "_1e0c1ule _syaz5k8o _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                                ]),
                                style: {
                                    "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                                },
                                children: control.label
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _zulp1b66 _1yt4u2gc _19it1nj5 _2rko1y44 _1tke1ylp _4cvr1h6o"
                                ]),
                                style: {
                                    "--_19aes6n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark700"))
                                },
                                children: control.options.map((option)=>{
                                    const isSelected = selectedValues.includes(option.value);
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            const updatedProducts = isSelected ? selectedValues.filter((product)=>product !== option.value) : [
                                                ...selectedValues,
                                                option.value
                                            ];
                                            handleSelectChange(control.segmentType, updatedProducts);
                                        },
                                        className: (0, $2jatx.default)([
                                            "_1yt418iy _bfhkl9kt _syaz1o9l _19itglyw _2rko1y44 _80omtlke _1wyboxwj _irr31nu1"
                                        ]),
                                        style: {
                                            "--_3kul7g": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)("color.extended.blue300") : (0, $kbpa7.wacToken)("color.neutral.light200")),
                                            "--_8buy8y": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)("color.neutral.light0") : (0, $kbpa7.wacToken)("color.neutral.dark200")),
                                            "--_1pblbmt": (0, $6ZVlx.default)(isSelected ? (0, $kbpa7.wacToken)("color.extended.blue400") : (0, $kbpa7.wacToken)("color.neutral.light300"))
                                        },
                                        children: option.label
                                    }, option.value);
                                })
                            })
                        ]
                    });
                }
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-personalization-toggle": "enrollInExperiment",
                onPointerDownCapture: (event)=>{
                    event.stopPropagation();
                },
                onMouseDown: (event)=>{
                    event.stopPropagation();
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    if ($0a7d65259cee0cad$var$isUniformPersonalizationEditMode()) return;
                    const target = event.target;
                    if (target instanceof HTMLInputElement && target.type === "checkbox") {
                        handleSelectChange("enrollInExperiment", target.checked);
                        return;
                    }
                    handleSelectChange("enrollInExperiment", !values.enrollInExperiment);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("enrollInExperiment", !values.enrollInExperiment);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $LDFpB.Checkbox), {
                    id: "enrollInExperiment",
                    name: "enrollInExperiment",
                    value: "enrollInExperiment",
                    label: "Enroll in Experiment Treatment?",
                    checked: values.enrollInExperiment
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-personalization-toggle": "useOverrides",
                onPointerDownCapture: (event)=>{
                    event.stopPropagation();
                },
                onMouseDown: (event)=>{
                    event.stopPropagation();
                },
                onClick: (event)=>{
                    event.stopPropagation();
                    if ($0a7d65259cee0cad$var$isUniformPersonalizationEditMode()) return;
                    const target = event.target;
                    if (target instanceof HTMLInputElement && target.type === "checkbox") {
                        handleSelectChange("useOverrides", target.checked);
                        return;
                    }
                    handleSelectChange("useOverrides", !values.useOverrides);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("useOverrides", !values.useOverrides);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $LDFpB.Checkbox), {
                    id: "useOverrides",
                    name: "useOverrides",
                    value: "useOverrides",
                    label: "Use Overrides?",
                    checked: values.useOverrides
                })
            }),
            (0, $aL9gN.SEGMENT_CONTROL_CONFIGS).filter(({ segmentType: segmentType })=>isSegmentControlVisible(segmentType)).map((control)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: renderSegmentControl(control)
                }, control.segmentType)),
            (0, $aL9gN.RECOMMENDATION_FIELDS).filter(({ segmentType: segmentType })=>isSegmentControlVisible(segmentType)).map(({ segmentType: segmentType, label: label, defaultValue: defaultValue, defaultLabel: defaultLabel })=>{
                const selectedValue = values[segmentType] || defaultValue;
                const selectedOption = (0, $aL9gN.PRODUCT_OPTIONS).find((opt)=>opt.value === selectedValue);
                return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grkXZ.DropdownSelector), {
                        name: segmentType,
                        id: segmentType,
                        label: label,
                        options: (0, $aL9gN.PRODUCT_OPTIONS),
                        defaultValue: {
                            value: selectedValue,
                            label: selectedOption?.label || defaultLabel
                        },
                        onChangeHandler: (value)=>{
                            handleSelectChange(segmentType, value);
                        }
                    })
                }, segmentType);
            })
        ]
    });
};
const $0a7d65259cee0cad$export$3509149ef9c5f46 = ({ values: values, setValues: setValues, renderMessage: renderMessage, isContainerHovered: isContainerHovered, isPinned: isPinned = false, setIsPinned: setIsPinned = ()=>undefined, setIsActive: setIsActive = ()=>undefined, requiredSegmentTypes: requiredSegmentTypes = Object.values((0, $3o1l4.UserSegmentTypes)), compositionSlug: compositionSlug })=>{
    const controlsRootRef = (0, $1oC0p.useRef)(null);
    const skipNextDogEarClickRef = (0, $1oC0p.useRef)(false);
    const valuesRef = (0, $1oC0p.useRef)(values);
    const togglePinnedStateRef = (0, $1oC0p.useRef)(()=>undefined);
    const [isPointerInside, setIsPointerInside] = (0, $1oC0p.useState)(false);
    const [isFocusWithin, setIsFocusWithin] = (0, $1oC0p.useState)(false);
    const isVisible = isPinned || isPointerInside || isFocusWithin;
    const isTriggerVisible = isContainerHovered || isPinned;
    const triggerTitleByPinned = {
        true: "Hide Personalization Controls",
        false: "Show Personalization Controls"
    };
    const triggerIconByPinned = {
        true: "\uD83D\uDCCC",
        false: "\uD83D\uDC65"
    };
    const togglePinnedState = ()=>{
        setIsPinned((previousState)=>{
            const nextPinnedState = !previousState;
            if (!nextPinnedState) {
                setIsPointerInside(false);
                setIsFocusWithin(false);
            }
            setIsActive(nextPinnedState);
            return nextPinnedState;
        });
    };
    const handleSelectChange = (field, value)=>{
        setValues((previousValues)=>({
                ...previousValues,
                [field]: value
            }));
    };
    valuesRef.current = values;
    togglePinnedStateRef.current = togglePinnedState;
    (0, $1oC0p.useEffect)(()=>{
        if (!$0a7d65259cee0cad$var$isUniformPersonalizationEditMode()) return;
        const handleNativeTogglePointer = (event)=>{
            const controlsRoot = controlsRootRef.current;
            const target = event.target;
            if (!controlsRoot || !(target instanceof Element)) return;
            if (!controlsRoot.contains(target)) return;
            const dogEarRow = target.closest('[data-personalization-dogear="toggle"]');
            const enrollRow = target.closest('[data-personalization-toggle="enrollInExperiment"]');
            const overridesRow = target.closest('[data-personalization-toggle="useOverrides"]');
            if (!dogEarRow && !enrollRow && !overridesRow) return;
            event.stopPropagation();
            if (event.cancelable) event.preventDefault();
            if (dogEarRow) {
                skipNextDogEarClickRef.current = true;
                togglePinnedStateRef.current();
                return;
            }
            const currentValues = valuesRef.current;
            if (enrollRow) {
                const nextValue = !currentValues.enrollInExperiment;
                handleSelectChange("enrollInExperiment", nextValue);
                return;
            }
            const nextValue = !currentValues.useOverrides;
            handleSelectChange("useOverrides", nextValue);
        };
        document.addEventListener("pointerdown", handleNativeTogglePointer, {
            capture: true
        });
        document.addEventListener("mousedown", handleNativeTogglePointer, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("pointerdown", handleNativeTogglePointer, {
                capture: true
            });
            document.removeEventListener("mousedown", handleNativeTogglePointer, {
                capture: true
            });
        };
    }, []);
    // Only show the dog-ear when container is hovered
    if (!isContainerHovered && !isPinned) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: controlsRootRef,
        "data-testid": "personalization-controls",
        className: (0, $2jatx.default)([
            "_kqswstnw _152t12gs _1e0212gs _1pbyrpof _lcxvglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "data-personalization-dogear": "toggle",
                title: triggerTitleByPinned[String(isPinned)],
                onMouseEnter: ()=>{
                    setIsPointerInside(true);
                    setIsActive(true);
                },
                onPointerDownCapture: (event)=>{
                    event.stopPropagation();
                },
                onMouseDown: (event)=>{
                    event.stopPropagation();
                },
                onMouseLeave: ()=>{
                    setIsPointerInside(false);
                    if (!isPinned && !isFocusWithin) setIsActive(false);
                },
                onFocus: ()=>{
                    setIsFocusWithin(true);
                    setIsActive(true);
                },
                onBlur: ()=>{
                    setIsFocusWithin(false);
                    if (!isPinned && !isPointerInside) setIsActive(false);
                },
                onClick: ()=>{
                    if (skipNextDogEarClickRef.current) {
                        skipNextDogEarClickRef.current = false;
                        return;
                    }
                    togglePinnedState();
                },
                onKeyDown: (event)=>{
                    if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        togglePinnedState();
                    }
                },
                role: "button",
                tabIndex: 0,
                "aria-pressed": isPinned,
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _1e02idpf _1pby14ny _1bsbckbl _4t3ickbl _80omtlke _v5641hdd _tzy4m419 _t9ecvpod _lcxv1wug"
                ]),
                style: {
                    "--_1tbzjj3": (0, $6ZVlx.default)(Number(isTriggerVisible)),
                    "--_2qtd8l": (0, $6ZVlx.default)([
                        "scale(0.8)",
                        "scale(1)"
                    ][Number(isTriggerVisible)])
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _1e02idpf _1bsbckbl _4t3ickbl _bfhk1mxb _2rko1dia _v5641hdd _16qs1s6v _irr3cqtm"
                        ]),
                        style: {
                            "--_9qtbdu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue300")),
                            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                            "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                            "--_r4erkq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue400"))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152t1ssb _1e021ssb _t9ec1ooe _syazcd5j _1wyb7vkz _vwz4kb7n _lcxvglyw _w19j12yu"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800"))
                        },
                        children: triggerIconByPinned[String(isPinned)]
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                onMouseEnter: ()=>{
                    setIsPointerInside(true);
                    setIsActive(true);
                },
                onMouseLeave: ()=>{
                    if (!isPinned) {
                        setIsPointerInside(false);
                        if (!isFocusWithin) setIsActive(false);
                    }
                },
                onFocus: ()=>{
                    setIsFocusWithin(true);
                    setIsActive(true);
                },
                onBlur: (event)=>{
                    const relatedTarget = event.relatedTarget;
                    if (relatedTarget && event.currentTarget.contains(relatedTarget)) return;
                    setIsFocusWithin(false);
                    if (!isPinned && !isPointerInside) setIsActive(false);
                },
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tckbl _1e02ftgi _1bsbgx0z _c71l1rxh _1pby1n5q _1yt4pxbi _1e0c1txw _2lx21bp4 _zulpu2gc _bfhkcd5j _2rkovwyg _16qsswb1 _19it1nj5 _lcxv1wug"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                    "--_19aes6n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark700"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1bah1yb4 _zulpu2gc"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybbzd7 _syaz5k8o"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                            },
                            children: "Personalization Controls"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt412x7 _1wyboqnp _syazgc2p _bfhko27y _2rko1y44 _19itlguc"
                        ]),
                        style: {
                            "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300")),
                            "--_4kw8dp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.saffron100")),
                            "--_19ggawa": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.saffron300"))
                        },
                        children: "These controls and the blue border are only visible in pre-production environments"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_18m91wug _c71l1auj _y4ti1b66"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($0a7d65259cee0cad$var$PersonalizationControlPanel, {
                            values: values,
                            handleSelectChange: handleSelectChange,
                            requiredSegmentTypes: requiredSegmentTypes
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt4u2gc _bfhk1ybm _syazgc2p"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
                            "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300"))
                        },
                        children: renderMessage
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8c0sT.ShareableUrlDisplay), {
                        values: values,
                        compositionSlug: compositionSlug
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("LDFpB", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return $5d7641ed610c7620$export$48513f6b9f8ce62d; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $5d7641ed610c7620$var$textStyle = null;
const $5d7641ed610c7620$var$containerStyle = null;
const $5d7641ed610c7620$var$checkboxStyle = null;
const $5d7641ed610c7620$export$48513f6b9f8ce62d = (props)=>{
    const { id: id, name: name, value: value, label: label, color: color = "light", accentColor: accentColor = "#0065ff", disabled: disabled, testId: testId, checked: checked, indeterminate: indeterminate, className: className } = props;
    const ref = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (ref.current) {
            if (indeterminate) ref.current.indeterminate = indeterminate;
            else ref.current.checked = checked || false;
        }
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _4cvr1y6m _ca0qyh40 _u5f3idpf _n3tdyh40 _19bvidpf _vwz4bs82",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                id: id,
                type: "checkbox",
                "data-testid": testId ? testId : id,
                style: {
                    accentColor: accentColor
                },
                ref: ref,
                name: name,
                value: value,
                disabled: disabled || false,
                className: (0, $2jatx.default)([
                    "_s7n4nkob _1bsb7vkz _4t3i7vkz _19pk1y44 _2hwxidpf _otyridpf _18u0idpf _1372tlke _d0altlke _jomr3739 _irr33739"
                ])
            }),
            label && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                style: {
                    color: color == "dark" ? "#172b4d" : "#5e6c84"
                },
                htmlFor: id,
                className: (0, $2jatx.default)([
                    "_80omtlke _1wyboxwj _k48p1nn1 _ahbqftgi"
                ]),
                children: label
            })
        ]
    });
};

});

parcelRegister("aL9gN", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_OPTIONS", function () { return $d46db8d2ad95ca24$export$77dfeb66b7077b0e; });
$parcel$export(module.exports, "RECOMMENDATION_FIELDS", function () { return $d46db8d2ad95ca24$export$559658cad198e966; });
$parcel$export(module.exports, "SEGMENT_CONTROL_CONFIGS", function () { return $d46db8d2ad95ca24$export$fbbf6361625054cb; });

var $3o1l4 = parcelRequire("3o1l4");
const $d46db8d2ad95ca24$var$JOB_FUNCTION_OPTIONS = [
    {
        value: "engineering",
        label: "Engineering"
    },
    {
        value: "product management",
        label: "Product Management"
    },
    {
        value: "design",
        label: "Design"
    },
    {
        value: "data science",
        label: "Data Science"
    },
    {
        value: "marketing",
        label: "Marketing"
    },
    {
        value: "sales",
        label: "Sales"
    },
    {
        value: "human resources",
        label: "Human Resources"
    },
    {
        value: "finance",
        label: "Finance"
    },
    {
        value: "operations",
        label: "Operations"
    },
    {
        value: "legal",
        label: "Legal"
    },
    {
        value: "customer success",
        label: "Customer Success"
    },
    {
        value: "executive",
        label: "Executive"
    },
    {
        value: "other",
        label: "Other"
    },
    {
        value: "information technology",
        label: "Information Technology"
    },
    {
        value: "customer service",
        label: "Customer Service"
    },
    {
        value: "program management",
        label: "Program Management"
    },
    {
        value: "c-suite",
        label: "C-Suite"
    }
];
const $d46db8d2ad95ca24$export$77dfeb66b7077b0e = [
    {
        value: "jira-software",
        label: "Jira"
    },
    {
        value: "confluence",
        label: "Confluence"
    },
    {
        value: "jira-servicedesk",
        label: "JSM"
    },
    {
        value: "loom",
        label: "Loom"
    },
    {
        value: "jira-product-discovery",
        label: "JPD"
    },
    {
        value: "rovo.ondemand",
        label: "Rovo (On Demand)"
    },
    {
        value: "rovo",
        label: "Rovo"
    }
];
const $d46db8d2ad95ca24$export$671e1872ab21a444 = [
    {
        value: "TWC",
        label: "Teamwork Collection"
    }
];
const $d46db8d2ad95ca24$var$OWNED_PRODUCT_OPTIONS = [
    {
        value: "jira-software",
        label: "Jira"
    },
    {
        value: "confluence",
        label: "Confluence"
    },
    {
        value: "bitbucket",
        label: "Bitbucket"
    },
    {
        value: "compass",
        label: "Compass"
    },
    {
        value: "jira-product-discovery",
        label: "Jira Product Discovery"
    },
    {
        value: "jira-servicedesk",
        label: "Jira Service Management"
    },
    {
        value: "statuspage",
        label: "Statuspage"
    },
    {
        value: "loom",
        label: "Loom"
    },
    {
        value: "rovo.ondemand",
        label: "Rovo (On Demand)"
    },
    {
        value: "rovo",
        label: "Rovo"
    },
    {
        value: "trello",
        label: "Trello"
    }
];
const $d46db8d2ad95ca24$var$LOGIN_STATUS_OPTIONS = [
    {
        value: "loggedIn",
        label: "Logged In"
    },
    {
        value: "loggedOut",
        label: "Logged Out"
    }
];
const $d46db8d2ad95ca24$var$DOMAIN_TYPE_OPTIONS = [
    {
        value: "BUSINESS",
        label: "Business"
    },
    {
        value: "PERSONAL",
        label: "Personal"
    }
];
const $d46db8d2ad95ca24$export$559658cad198e966 = [
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).FIRST_RECOMMENDATION,
        label: "First Recommendation",
        defaultValue: "jira",
        defaultLabel: "Jira"
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).SECOND_RECOMMENDATION,
        label: "Second Recommendation",
        defaultValue: "confluence",
        defaultLabel: "Confluence"
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).THIRD_RECOMMENDATION,
        label: "Third Recommendation",
        defaultValue: "jsm",
        defaultLabel: "JSM"
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).FOURTH_RECOMMENDATION,
        label: "Fourth Recommendation",
        defaultValue: "loom",
        defaultLabel: "Loom"
    }
];
const $d46db8d2ad95ca24$export$fbbf6361625054cb = [
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).LOGIN_STATUS,
        ux: "dropdown",
        label: "Login Status",
        options: $d46db8d2ad95ca24$var$LOGIN_STATUS_OPTIONS,
        defaultLabel: "Logged Out",
        getSelectedLabel: (value, options)=>options.find((option)=>option.value === value)?.label || "Logged Out"
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).GEOLOCATION,
        ux: "textbox",
        label: "Geolocation",
        placeholder: "e.g. US, UK, AU"
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).JOB_FUNCTION,
        ux: "dropdown",
        label: "Job Function",
        options: $d46db8d2ad95ca24$var$JOB_FUNCTION_OPTIONS,
        defaultLabel: "Select job function",
        getSelectedLabel: (value, options)=>options.find((option)=>option.value === value)?.label || "Select job function"
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).DOMAIN_TYPE,
        ux: "dropdown",
        label: "Domain Type",
        options: $d46db8d2ad95ca24$var$DOMAIN_TYPE_OPTIONS,
        defaultLabel: "Personal",
        getSelectedLabel: (value, options)=>options.find((option)=>option.value === value)?.label || "Personal"
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS,
        ux: "multi-select",
        label: "Owned Products",
        options: $d46db8d2ad95ca24$var$OWNED_PRODUCT_OPTIONS
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).CLUSTER_TAG,
        ux: "textbox",
        label: "Anchor/Cluster Tag",
        transformValue: (value)=>value.toLowerCase()
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).SUB_ANCHOR,
        ux: "textbox",
        label: "Sub-Anchor",
        transformValue: (value)=>value.toLowerCase()
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).CHANNEL,
        ux: "textbox",
        label: "Channel",
        transformValue: (value)=>value.toLowerCase()
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).UTM_CONTENT,
        ux: "textbox",
        label: "UTM Content"
    },
    {
        segmentType: (0, $3o1l4.UserSegmentTypes).COLLECTION_OPTIONS,
        ux: "multi-select",
        label: "Collection Options",
        options: $d46db8d2ad95ca24$export$671e1872ab21a444
    }
];

});

parcelRegister("8c0sT", function(module, exports) {
$parcel$export(module.exports, "ShareableUrlDisplay", function () { return $57f9bd42a5f24666$export$6ba48ce7dcbe77e2; });
/* personalization-shareable-url.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $4u4go = parcelRequire("4u4go");
const $57f9bd42a5f24666$export$6ba48ce7dcbe77e2 = ({ values: values, compositionSlug: compositionSlug })=>{
    const fullUrl = (0, $4u4go.getShareableUrl)(values, compositionSlug);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp12x7 _1yt4u2gc _bfhk1rga _2rko1y44 _19it1nj5"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_19aes6n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark700"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wyboqnp _k48pni7l _syaz5k8o"
                ]),
                style: {
                    "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                },
                children: "Shareable URL"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                type: "text",
                readOnly: true,
                value: fullUrl || "(no overrides set)",
                title: fullUrl || undefined,
                onFocus: (e)=>e.target.select(),
                className: (0, $2jatx.default)([
                    "_1wyb1l5c _ect4k7ds _1bsb1osq _1yt4u49m _19it1nj5 _2rko1y44 _bfhk1byy _syaz3l4v _80om1p3i _vchhusvi"
                ]),
                style: {
                    "--_19aes6n": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark700")),
                    "--_bam7jh": (0, $6ZVlx.default)(fullUrl ? (0, $kbpa7.wacToken)("color.neutral.light0") : (0, $kbpa7.wacToken)("color.neutral.light200")),
                    "--_111zt3d": (0, $6ZVlx.default)(fullUrl ? (0, $kbpa7.wacToken)("color.neutral.dark100") : (0, $kbpa7.wacToken)("color.neutral.dark500")),
                    "--_1wrd646": (0, $6ZVlx.default)(fullUrl ? "text" : "default")
                }
            })
        ]
    });
};

});



parcelRegister("8HKOE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $304464287c39195e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");

var $lqyi6 = parcelRequire("lqyi6");

var $5JoNJ = parcelRequire("5JoNJ");

var $jQ0cd = parcelRequire("jQ0cd");
const $304464287c39195e$export$668a169209c124af = (props)=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(props.ctaUrl ?? "");
    const button = ()=>{
        if (props.ctaText && props.ctaText !== "" && props.ctaUrl && props.ctaUrl !== "") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
            href: localizedHref,
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "ctaSection",
                "data-event": "clicked"
            },
            children: props.ctaText
        });
        return;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5JoNJ.CallToAction), {
        header: props.title,
        paragraph: props.description,
        button: button() ?? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "ctaButton"
        }),
        backgroundColor: props.backgroundColor
    });
};
var $304464287c39195e$export$2e2bcd8739ae039 = $304464287c39195e$export$668a169209c124af;

});
parcelRegister("5JoNJ", function(module, exports) {
$parcel$export(module.exports, "CallToAction", function () { return $fb865668dbde9df8$export$9438b36140854db6; });
/* call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kbpa7 = parcelRequire("kbpa7");
const $fb865668dbde9df8$var$callToActionStyles = null;
const $fb865668dbde9df8$var$typographyOverrides = null;
const $fb865668dbde9df8$var$polygonStyles = null;
const $fb865668dbde9df8$var$contentStyles = null;
const $fb865668dbde9df8$export$9438b36140854db6 = ({ header: header, paragraph: paragraph, button: button, backgroundColor: backgroundColor = "black" })=>{
    const buttonProps = backgroundColor === "blue" ? {
        variant: "primary_alt",
        colorAgainst: "other"
    } : {
        variant: "primary",
        colorAgainst: "black"
    };
    const transformedButton = /*#__PURE__*/ (0, $1oC0p.cloneElement)(button, buttonProps);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_p12f1git _195g1wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            style: {
                "--background-color": (0, $kbpa7.wacToken)(`color.primary.${backgroundColor}`)
            },
            className: (0, $2jatx.default)([
                "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulpu2gc _6rthxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    "h3"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    ".body-md"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                },
                                children: paragraph
                            })
                        ]
                    })
                }),
                transformedButton
            ]
        })
    });
};

});


parcelRegister("eNJPT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $afccc8c3590eb47f$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $aSRUp = parcelRequire("aSRUp");

var $fbPwh = parcelRequire("fbPwh");
const $afccc8c3590eb47f$var$UniformPricingTable = (props)=>{
    const { urlSlug: urlSlug, componentLocale: componentLocale } = props;
    const waePricingGqlEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).waePricingGql);
    if (urlSlug && componentLocale && waePricingGqlEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aSRUp.PricingTableWithFetch), {
        urlSlug: urlSlug,
        locale: componentLocale
    });
    const { tableData: tableData, planTitles: planTitles } = props;
    if (tableData && planTitles) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fbPwh.PricingTableWithoutFetch), {
        urlSlug: urlSlug,
        tableData: tableData,
        planTitles: planTitles
    });
    return null;
};
var $afccc8c3590eb47f$export$2e2bcd8739ae039 = $afccc8c3590eb47f$var$UniformPricingTable;

});
parcelRegister("aSRUp", function(module, exports) {
$parcel$export(module.exports, "PricingTableWithFetch", function () { return $868abf2bb378cad9$export$4bd18d0f013c2a19; });

var $7VQPk = parcelRequire("7VQPk");

var $gez9l = parcelRequire("gez9l");

var $iHcWb = parcelRequire("iHcWb");

var $fJ2o2 = parcelRequire("fJ2o2");

var $UL5H4 = parcelRequire("UL5H4");
const $868abf2bb378cad9$export$4bd18d0f013c2a19 = ({ urlSlug: urlSlug, locale: locale })=>{
    const { tableData: tableData, planTitles: planTitles, hasError: hasError } = (0, $fJ2o2.useTableData)({
        urlSlug: urlSlug,
        locale: locale
    });
    const dwellTimeAttributes = (0, $iHcWb.useDwellTimeElementAttributes)({
        id: "pricing-table"
    });
    if (!tableData.length || hasError) return null;
    const transformedSections = (0, $UL5H4.transformContentfulDataToTableData)(tableData, planTitles);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...dwellTimeAttributes,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gez9l.Table), {
            header: {
                titles: [
                    "",
                    ...planTitles
                ]
            },
            sections: transformedSections
        })
    });
};

});
parcelRegister("gez9l", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return $b9a064381be18ba2$export$54ec01a60f47d33d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $bCM0B = parcelRequire("bCM0B");

var $g48EH = parcelRequire("g48EH");

var $6JrkM = parcelRequire("6JrkM");

var $kGTi3 = parcelRequire("kGTi3");

var $4XsF0 = parcelRequire("4XsF0");
const $b9a064381be18ba2$export$54ec01a60f47d33d = (props)=>{
    const { sections: sections, header: header } = props;
    const tableId = (0, $1oC0p.useId)().replace(/:/g, "_");
    const columnCount = (0, $4XsF0.getColumnCount)(sections);
    // Build column header ids aligned with titles (index 0 is the empty row-header column)
    const columnIds = header.titles.map((title, index)=>{
        const isEmpty = !title || title.trim() === "";
        return isEmpty ? "" : `${0, $6JrkM.tableHeadCellIdPrefix}${tableId}_${index}`;
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bCM0B.Table), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6JrkM.Header), {
                ...header,
                tableId: tableId
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                children: sections.map((section, sectionIndex)=>{
                    const groupId = `tblGroup_${tableId}_${sectionIndex}`;
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kGTi3.SectionHeader), {
                                sectionTitle: section.title,
                                totalColumnCount: columnCount,
                                groupId: groupId
                            }),
                            section.rows.map((row, rowIndex)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $g48EH.ContentRow), {
                                    row: row,
                                    rowKey: `${sectionIndex}-${rowIndex}`,
                                    columnTitles: header.titles,
                                    columnIds: columnIds,
                                    groupId: groupId
                                }, `${sectionIndex}-${rowIndex}`))
                        ]
                    }, sectionIndex);
                })
            })
        ]
    });
};

});
parcelRegister("bCM0B", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return $d7db4f5719f45dfe$export$54ec01a60f47d33d; });
/* table.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");
const $d7db4f5719f45dfe$export$54ec01a60f47d33d = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("table", {
        ...props,
        className: (0, $2jatx.default)([
            "_2lx21bp4 _1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _y3gn1h6o _yq5hcfaq _btyzidpf _suga1txw _1e0c5mfb"
        ])
    });
};
const $d7db4f5719f45dfe$var$tableCss = null;

});

parcelRegister("g48EH", function(module, exports) {
$parcel$export(module.exports, "ContentRow", function () { return $ac91e2ba30ede3f0$export$47e3a1a30e4428e1; });

var $7VQPk = parcelRequire("7VQPk");

var $iHkC4 = parcelRequire("iHkC4");
parcelRequire("1oC0p");

var $8isd5 = parcelRequire("8isd5");
const $ac91e2ba30ede3f0$export$47e3a1a30e4428e1 = (props)=>{
    const { row: row, rowKey: rowKey, columnTitles: columnTitles, columnIds: columnIds, groupId: groupId } = props;
    const rowHeaderId = `tblRow_${rowKey}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHkC4.Row), {
        children: row.map((cell, cellIndex)=>cellIndex === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHkC4.RowHeaderCell), {
                id: rowHeaderId,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8isd5.ContentCell), {
                    isRowHeader: true,
                    cellData: cell
                })
            }, cellIndex) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHkC4.RowCell), {
                // @ts-expect-error -- columnTitle is a valid prop but TypeScript can't infer it through HTMLAttributes
                columnTitle: columnTitles[cellIndex],
                headers: [
                    groupId,
                    columnIds[cellIndex],
                    rowHeaderId
                ].filter(Boolean).join(" "),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8isd5.ContentCell), {
                    cellData: cell
                })
            }, cellIndex))
    }, rowKey);
};

});
parcelRegister("iHkC4", function(module, exports) {
$parcel$export(module.exports, "Row", function () { return $47273071d5195ae2$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "RowHeaderCell", function () { return $47273071d5195ae2$export$90b286dd97c43ca1; });
$parcel$export(module.exports, "RowCell", function () { return $47273071d5195ae2$export$502da2b9cfd708e5; });
/* row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $47273071d5195ae2$export$b59bdbef9ce70de2 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props,
        className: (0, $2jatx.default)([
            "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhkcd5j _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _1ckvidpf _irr31rga _1o4gu1j4 _a5ztgktf _suga1txw _1gde1bp4"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        }
    });
};
const $47273071d5195ae2$export$90b286dd97c43ca1 = (props)=>{
    const { children: children, ...thProps } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...thProps,
        scope: "row",
        className: (0, $2jatx.default)([
            "_y3gnv2br _16nmgktf _1w6hgktf _gtp7150w _1kmxdlk8 _1ggmdlk8 _1ykzdlk8 _1maedlk8",
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            fontWeight: "normal",
            ...thProps.style ?? {},
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _1reo15vq"
            ]),
            children: children
        })
    });
};
const $47273071d5195ae2$export$502da2b9cfd708e5 = (props)=>{
    const { children: children = null, columnTitle: columnTitle, headers: headers, ...tdProps } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("td", {
        ...tdProps,
        headers: headers,
        className: (0, $2jatx.default)([
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: columnTitle
            }),
            children
        ]
    });
};
const $47273071d5195ae2$var$rowCss = null;
const $47273071d5195ae2$var$rowHeaderCellCss = null;
const $47273071d5195ae2$var$rowHeaderCellSpanCss = null;
const $47273071d5195ae2$var$cellCss = null;
const $47273071d5195ae2$var$cellColumnTitleCss = null;

});

parcelRegister("8isd5", function(module, exports) {
$parcel$export(module.exports, "ContentCell", function () { return $8982ab3500f1fdb0$export$6245b75abe178459; });

var $7VQPk = parcelRequire("7VQPk");

var $eTFP3 = parcelRequire("eTFP3");
parcelRequire("1oC0p");
const $8982ab3500f1fdb0$export$6245b75abe178459 = (props)=>{
    const { cellData: cellData, isRowHeader: isRowHeader } = props;
    if (cellData === null) return null;
    switch(cellData.type){
        case "text":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eTFP3.CellTextContent), {
                data: cellData,
                isRowHeader: isRowHeader
            });
        case "check":
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eTFP3.CellCheckContent), {
                data: cellData
            });
        case "expander":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eTFP3.CellExpanderContent), {
                data: cellData
            });
        case "hyperlink":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eTFP3.CellHyperlinkContent), {
                data: cellData
            });
        case "render":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eTFP3.CellRenderContent), {
                data: cellData
            });
        default:
            return null;
    }
};

});
parcelRegister("eTFP3", function(module, exports) {
$parcel$export(module.exports, "CellTextContent", function () { return $e8d9f14b2e64d6e8$export$6336b55f7613eff7; });
$parcel$export(module.exports, "CellCheckContent", function () { return $e8d9f14b2e64d6e8$export$2ff19a9fa1e2bf3d; });
$parcel$export(module.exports, "CellExpanderContent", function () { return $e8d9f14b2e64d6e8$export$9df6260913c83267; });
$parcel$export(module.exports, "CellHyperlinkContent", function () { return $e8d9f14b2e64d6e8$export$baed7aa80eb77f27; });
$parcel$export(module.exports, "CellRenderContent", function () { return $e8d9f14b2e64d6e8$export$70b9bce915221e55; });
/* cell-variants.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $g3AHF = parcelRequire("g3AHF");

var $iPPTB = parcelRequire("iPPTB");

var $jE3Ci = parcelRequire("jE3Ci");

var $1DMmy = parcelRequire("1DMmy");

var $5qLu8 = parcelRequire("5qLu8");
const $e8d9f14b2e64d6e8$export$6336b55f7613eff7 = (props)=>{
    const { data: data, isRowHeader: isRowHeader } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _zulpu2gc",
            isRowHeader && "_bozg1ul9"
        ]),
        children: [
            data.check && !isRowHeader && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DMmy.Checkmark), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    data.check && "_1q5171o5"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qLu8.TextContent), {
                    data: data.value
                })
            }),
            data.lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                    text: data.lozenge
                })
            })
        ]
    });
};
const $e8d9f14b2e64d6e8$export$2ff19a9fa1e2bf3d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DMmy.Checkmark), {});
};
const $e8d9f14b2e64d6e8$export$9df6260913c83267 = (props)=>{
    const { data: data } = props;
    const label = data.lozenge ? /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        children: [
            data.label,
            " ",
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                text: data.lozenge
            })
        ]
    }) : data.label;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3AHF.Expand), {
        label: label,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qLu8.TextContent), {
            data: data.body
        })
    });
};
const $e8d9f14b2e64d6e8$export$baed7aa80eb77f27 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        // id={rowDescId} // todo
        text: props.data.label,
        href: props.data.href,
        type: "primary",
        "aria-label": props.data.label,
        ariaLabel: props.data.label,
        dataEventProps: props.data.dataEventProps,
        className: (0, $2jatx.default)([
            "_1wybdlk8 _ahbq1y44"
        ])
    });
};
const $e8d9f14b2e64d6e8$export$70b9bce915221e55 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        children: props.data.render()
    });
};

});
parcelRegister("1DMmy", function(module, exports) {
$parcel$export(module.exports, "Checkmark", function () { return $1003cc83ff4b093a$export$4f481e0a96cfbed6; });
/* checkmark.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $OKl9V = parcelRequire("OKl9V");
const $1003cc83ff4b093a$export$4f481e0a96cfbed6 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        "data-testid": "checkmark",
        className: (0, $2jatx.default)([
            "_bfhkl30o _2rko1ssb _syazcd5j _1e0c1o8l _1o9zidpf _k48p8n31 _vwz41tcg _y3gn1h6o _4t3i1tcg _1bsb1tcg"
        ]),
        style: {
            "--_1x006p6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime700")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
            name: "featurecheckmark",
            size: "xs",
            color: (0, $kbpa7.wacToken)("color.neutral.light0")
        })
    });
};
const $1003cc83ff4b093a$var$containerInnerCss = null;

});

parcelRegister("5qLu8", function(module, exports) {
$parcel$export(module.exports, "TextContent", function () { return $b822ff1aa8b26f77$export$1b51c6466e79404f; });
/* text-content.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");
const $b822ff1aa8b26f77$export$1b51c6466e79404f = (props)=>{
    const { data: data } = props;
    if (data.type === "plaintext") return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: data.value
    });
    if (data.type === "richtext") return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: data.value
        })
    });
    throw new Error(`unknown text-content type: ${data.type}`);
};
const $b822ff1aa8b26f77$var$textCss = null;

});




parcelRegister("6JrkM", function(module, exports) {
$parcel$export(module.exports, "tableHeadCellIdPrefix", function () { return $394fde9636baf203$export$c9c38e95a06bf3ae; });
$parcel$export(module.exports, "Header", function () { return $394fde9636baf203$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $ddllp = parcelRequire("ddllp");
const $394fde9636baf203$export$c9c38e95a06bf3ae = "tblHead_";
const $394fde9636baf203$export$8b251419efc915eb = (props)=>{
    const { titles: titles, stickyOffset: stickyOffset, tableId: tableId } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddllp.Head), {
        stickyOffset: stickyOffset,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddllp.HeadRow), {
            children: titles.map((heading, index)=>{
                const isEmpty = !heading || heading.trim() === "";
                if (isEmpty) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddllp.HeadCell), {
                    role: "presentation"
                }, index);
                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddllp.HeadCell), {
                    id: `${$394fde9636baf203$export$c9c38e95a06bf3ae}${tableId}_${index}`,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulpftgi _4cvr1y6m"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1hlo _k48p1fw0"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                            },
                            children: heading
                        })
                    })
                }, index);
            })
        })
    });
};
const $394fde9636baf203$var$headCellDivCss = null;
const $394fde9636baf203$var$headCellSpanCss = null;

});
parcelRegister("ddllp", function(module, exports) {
$parcel$export(module.exports, "Head", function () { return $7c69262acefc007f$export$e93312b7773dfcac; });
$parcel$export(module.exports, "HeadRow", function () { return $7c69262acefc007f$export$b008e842a2213343; });
$parcel$export(module.exports, "HeadCell", function () { return $7c69262acefc007f$export$4e8024263ace498b; });
/* head.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $7c69262acefc007f$export$e93312b7773dfcac = (props)=>{
    const { stickyOffset: stickyOffset } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
        ...props,
        className: (0, $2jatx.default)([
            "_179ru1j4 _sugaglyw _1pbykb7n _11q7cd5j"
        ]),
        style: {
            ...stickyOffset === undefined ? {} : {
                top: stickyOffset,
                position: "sticky"
            },
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        }
    });
};
const $7c69262acefc007f$export$b008e842a2213343 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props,
        className: (0, $2jatx.default)([
            "_17gvangw _7dd6v2br"
        ])
    });
};
const $7c69262acefc007f$export$4e8024263ace498b = (props)=>{
    const scope = props.role === "presentation" ? undefined : "col";
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...props,
        scope: scope,
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        }
    });
};
const $7c69262acefc007f$var$headCss = null;
const $7c69262acefc007f$var$headRowCss = null;
const $7c69262acefc007f$var$headCellStyles = null;

});


parcelRegister("kGTi3", function(module, exports) {
$parcel$export(module.exports, "SectionHeader", function () { return $39b6b02b7cb66183$export$8adb256d999cd5a0; });
/* section-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1Ngjn = parcelRequire("1Ngjn");

var $kbpa7 = parcelRequire("kbpa7");
const $39b6b02b7cb66183$export$8adb256d999cd5a0 = (props)=>{
    const { sectionTitle: sectionTitle, totalColumnCount: totalColumnCount, groupId: groupId } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Ngjn.SectionHeader), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1Ngjn.SectionHeaderCell), {
            id: groupId,
            colSpan: totalColumnCount,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_syaz1hlo _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: sectionTitle
            })
        })
    });
};
const $39b6b02b7cb66183$var$sectionHeaderSpanCss = null;

});
parcelRegister("1Ngjn", function(module, exports) {
$parcel$export(module.exports, "SectionHeader", function () { return $66888825eec09a68$export$8adb256d999cd5a0; });
$parcel$export(module.exports, "SectionHeaderCell", function () { return $66888825eec09a68$export$32421cd0bed4993f; });
/* section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $66888825eec09a68$export$8adb256d999cd5a0 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
        ...props,
        className: (0, $2jatx.default)([
            "_syaz1hlo _2lx21bp4 _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhk1rga _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _sugaglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        }
    });
};
const $66888825eec09a68$export$32421cd0bed4993f = (props)=>{
    const { scope: scope = "rowgroup", ...rest } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
        ...rest,
        scope: scope,
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        }
    });
};
const $66888825eec09a68$var$sectionHeaderCss = null;
const $66888825eec09a68$var$sectionHeaderCellCss = null;

});


parcelRegister("4XsF0", function(module, exports) {
$parcel$export(module.exports, "getColumnCount", function () { return $fb75f3d0bfe9ee25$export$813bef8f01765aa1; });
function $fb75f3d0bfe9ee25$export$813bef8f01765aa1(sections) {
    return $fb75f3d0bfe9ee25$var$getColumnCountOfRowsOfSections(sections);
}
function $fb75f3d0bfe9ee25$var$getColumnCountOfRowsOfSections(sections) {
    if (sections.length === 0) throw new Error("sections count should be > 0");
    let columnCount;
    sections.forEach((section, index)=>{
        try {
            const columnCountOfRows = $fb75f3d0bfe9ee25$var$getColumnCountOfRows(section.rows);
            if (columnCount === undefined) columnCount = columnCountOfRows;
            else {
                if (columnCount !== columnCountOfRows) throw new Error(`inconsistent number of columns: section at index ${index} contains ${columnCountOfRows} columns; expected ${columnCount} columns based on previous section(s)`);
            }
        } catch (error) {
            // @ts-ignore
            throw new Error(`error at table section index ${index}`, {
                cause: error
            });
        }
    });
    if (columnCount === undefined) throw new Error("column count is undefined");
    return columnCount;
}
function $fb75f3d0bfe9ee25$var$getColumnCountOfRows(rows) {
    if (rows.length === 0) throw new Error("rows count should be > 0");
    let columnCount;
    rows.forEach((row, index)=>{
        if (columnCount === undefined) columnCount = row.length;
        else {
            if (row.length !== columnCount) throw new Error(`inconsistent number of columns: row at index ${index} contains ${row.length} columns; expected ${columnCount} columns based on previous row(s)`);
        }
    });
    if (columnCount === undefined) throw new Error("column count is undefined");
    if (columnCount === 0) throw new Error("columnCount should not be 0");
    return columnCount;
}

});


parcelRegister("fJ2o2", function(module, exports) {
$parcel$export(module.exports, "useTableData", function () { return $93faad57ef417f58$export$98b14d297b92183b; });

var $1oC0p = parcelRequire("1oC0p");

var $9EINl = parcelRequire("9EINl");

var $e8CU5 = parcelRequire("e8CU5");
const $93faad57ef417f58$export$98b14d297b92183b = ({ urlSlug: urlSlug, locale: locale })=>{
    const [tableData, setTableData] = (0, $1oC0p.useState)([]);
    const [planTitles, setPlanTitles] = (0, $1oC0p.useState)([]);
    const [hasError, setHasError] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        (0, $9EINl.getPricingPageAdditionalContent)({
            urlSlug: urlSlug,
            locale: locale
        }).then((data)=>{
            if (data) {
                const { features: features, planTitles: fetched } = (0, $e8CU5.mapAdditionalContentToTableData)(data);
                setTableData(features);
                setPlanTitles(fetched);
            }
        }).catch(()=>{
            setHasError(true);
        });
    }, []);
    return {
        tableData: tableData,
        planTitles: planTitles,
        hasError: hasError
    };
};

});
parcelRegister("9EINl", function(module, exports) {
$parcel$export(module.exports, "getPricingPageAdditionalContent", function () { return $4f99ac0f0ee29bbd$export$c894316808cfd187; });

var $2iZII = parcelRequire("2iZII");

var $5TsOI = parcelRequire("5TsOI");
const $4f99ac0f0ee29bbd$export$c894316808cfd187 = async ({ urlSlug: urlSlug, locale: locale })=>{
    const result = await (0, $2iZII.getContentfulGqlClient)().query((0, $5TsOI.pricingPageAdditionalContentQuery), {
        urlSlug: urlSlug,
        locale: locale
    });
    return result.data;
};

});
parcelRegister("5TsOI", function(module, exports) {
$parcel$export(module.exports, "pricingPageAdditionalContentQuery", function () { return $1bd70f13cf074cdf$export$195f6723562f4848; });

var $1dWiR = parcelRequire("1dWiR");
const $1bd70f13cf074cdf$export$195f6723562f4848 = (0, $1dWiR.gql)`
    query pricingPageAdditionalContent($urlSlug: String!, $locale: String!) {
        pricingCollection(
            where: { urlSlug: $urlSlug }
            locale: $locale
            limit: 1
        ) {
            items {
                pricingTitleInternal
                comparePlansCollection(limit: 10) {
                    items {
                        planTitleExternal
                    }
                }
                compareFeaturesTitle
                compareFeaturesCollection(limit: 10) {
                    items {
                        featureGroupTitleExternal
                        featuresCollection(limit: 20) {
                            items {
                                callOut
                                featureNameExternal
                                description {
                                    json
                                }
                                relevantPlanCollection {
                                    items {
                                        planTitleExternal
                                    }
                                }
                                relevantUrl
                                featureAdditionalInformationCollection(
                                    limit: 15
                                ) {
                                    items {
                                        featureAdditionalInformation
                                        relevantPlanCollection(limit: 15) {
                                            items {
                                                planTitleExternal
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("e8CU5", function(module, exports) {
$parcel$export(module.exports, "mapAdditionalContentToTableData", function () { return $8e6aa8d54d0eb567$export$f18b590b4399852b; });

var $gVC4y = parcelRequire("gVC4y");
// --- Mapping ---
const $8e6aa8d54d0eb567$var$mapFeatureItem = (feature)=>({
        fields: {
            featureNameExternal: feature.featureNameExternal,
            description: typeof feature.description?.json === "object" && feature.description.json?.nodeType === "document" ? (0, $gVC4y.richTextToHTML)(feature.description.json) : undefined,
            relevantUrl: feature.relevantUrl ?? undefined,
            callOut: feature.callOut ?? undefined,
            relevantPlan: feature.relevantPlanCollection.items.map((plan)=>({
                    fields: {
                        planTitleExternal: plan.planTitleExternal
                    }
                })),
            featureAdditionalInformation: feature.featureAdditionalInformationCollection.items.map((info)=>({
                    fields: {
                        featureAdditionalInformation: info.featureAdditionalInformation,
                        relevantPlan: info.relevantPlanCollection.items.map((plan)=>({
                                fields: {
                                    planTitleExternal: plan.planTitleExternal
                                }
                            }))
                    }
                }))
        }
    });
const $8e6aa8d54d0eb567$var$mapCompareFeatureGroup = (group)=>({
        fields: {
            featureGroupTitleExternal: group.featureGroupTitleExternal,
            features: group.featuresCollection.items.map($8e6aa8d54d0eb567$var$mapFeatureItem)
        }
    });
const $8e6aa8d54d0eb567$export$f18b590b4399852b = (data)=>{
    const item = data.pricingCollection.items[0];
    if (!item) return {
        planTitles: [],
        features: []
    };
    return {
        planTitles: item.comparePlansCollection.items.map((plan)=>plan.planTitleExternal),
        features: item.compareFeaturesCollection.items.map($8e6aa8d54d0eb567$var$mapCompareFeatureGroup)
    };
};

});


parcelRegister("UL5H4", function(module, exports) {
$parcel$export(module.exports, "transformContentfulDataToTableData", function () { return $b05fdcdb944104b1$export$d095b9a7d993b440; });
const $b05fdcdb944104b1$export$e28b7b712925a1 = (featureGroup)=>{
    const { fields: fields } = featureGroup;
    return fields.featureGroupTitleExternal;
};
const $b05fdcdb944104b1$export$74a00f18b9031fa7 = (featureFields)=>{
    return featureFields.featureNameExternal || "";
};
const $b05fdcdb944104b1$export$c2c44121b33af1d6 = (featureFields, planTitles)=>{
    return planTitles.map((planTitle)=>{
        const isRelevant = featureFields.relevantPlan?.some((plan)=>plan.fields?.planTitleExternal === planTitle);
        const additionalInfo = // @ts-expect-error -- Contentful field type does not include featureAdditionalInformation
        featureFields?.featureAdditionalInformation?.find(// @ts-expect-error -- Contentful field type mismatch
        (info)=>{
            return !!info.fields?.relevantPlan?.some((plan)=>plan.fields?.planTitleExternal === planTitle);
        })?.fields.featureAdditionalInformation;
        // 1. if there is featureAdditionalInformation, use that as type rich text (links, etc.)
        if (additionalInfo) return {
            type: "text",
            check: additionalInfo && isRelevant,
            value: {
                type: "richtext",
                value: additionalInfo
            }
        };
        // 2. if isRelevant, use type check with empty value
        if (isRelevant) return {
            type: "check"
        };
        // 3. otherwise, use type text with empty value
        return {
            type: "text",
            value: {
                type: "plaintext",
                value: ""
            }
        };
    });
};
const $b05fdcdb944104b1$export$4de3ae5ff94aba4 = (featureFields, featureName, descriptionText)=>{
    if (featureFields.relevantUrl) return {
        type: "hyperlink",
        label: featureName,
        href: featureFields.relevantUrl,
        dataEventProps: {
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "priceFeaturesTable",
            "data-product-key": "uniform",
            "data-label": featureName
        }
    };
    if (descriptionText) return {
        type: "expander",
        label: featureName,
        lozenge: featureFields.callOut,
        body: {
            type: "richtext",
            value: descriptionText || featureName
        }
    };
    return {
        type: "text",
        value: {
            type: "plaintext",
            value: featureName
        },
        lozenge: featureFields.callOut,
        check: false
    };
};
const $b05fdcdb944104b1$export$6fa65ac9a366ed09 = (feature, planTitles)=>{
    const featureFields = feature.fields;
    // left side column link or label
    const featureName = $b05fdcdb944104b1$export$74a00f18b9031fa7(featureFields);
    // individual cells
    const planCells = $b05fdcdb944104b1$export$c2c44121b33af1d6(featureFields, planTitles);
    // left side column
    const featureCell = $b05fdcdb944104b1$export$4de3ae5ff94aba4(featureFields, featureName, featureFields.description);
    return [
        featureCell,
        ...planCells
    ];
};
const $b05fdcdb944104b1$export$11afdf5edf7de08e = (featureGroup, planTitles)=>{
    const sectionTitle = $b05fdcdb944104b1$export$e28b7b712925a1(featureGroup);
    const rows = featureGroup.fields.features?.map((feature)=>$b05fdcdb944104b1$export$6fa65ac9a366ed09(feature, planTitles)) || [];
    return {
        title: sectionTitle,
        rows: rows
    };
};
const $b05fdcdb944104b1$export$d095b9a7d993b440 = (contentfulData, planTitles)=>{
    return contentfulData.map((featureGroup)=>$b05fdcdb944104b1$export$11afdf5edf7de08e(featureGroup, planTitles));
};

});


parcelRegister("fbPwh", function(module, exports) {
$parcel$export(module.exports, "PricingTableWithoutFetch", function () { return $efc1a62b9eef8e52$export$59022707a1d78214; });

var $7VQPk = parcelRequire("7VQPk");

var $gez9l = parcelRequire("gez9l");

var $iHcWb = parcelRequire("iHcWb");

var $427lS = parcelRequire("427lS");

var $UL5H4 = parcelRequire("UL5H4");
const $efc1a62b9eef8e52$export$59022707a1d78214 = (props)=>{
    const { tableData: tableData = [], planTitles: planTitles, urlSlug: urlSlug } = props;
    const effectivePlanTitles = (0, $427lS.useEffectivePlanTitles)(planTitles, urlSlug);
    const transformedSections = (0, $UL5H4.transformContentfulDataToTableData)(tableData, effectivePlanTitles);
    const dwellTimeAttributes = (0, $iHcWb.useDwellTimeElementAttributes)({
        id: "pricing-table"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...dwellTimeAttributes,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gez9l.Table), {
            header: {
                titles: [
                    "",
                    ...effectivePlanTitles
                ]
            },
            sections: transformedSections
        })
    });
};

});
parcelRegister("427lS", function(module, exports) {
$parcel$export(module.exports, "useEffectivePlanTitles", function () { return $5e47849f1b30080b$export$807d4632af6d16a7; });

var $lc7EO = parcelRequire("lc7EO");
const $5e47849f1b30080b$export$807d4632af6d16a7 = (planTitles, urlSlug)=>{
    // Single source of truth for the JPD plan-title allow-list (gated
    // behind the GWP-10907 feature flag). Always invoked to satisfy the
    // Rules of Hooks; the result is only USED for `product-discovery`.
    const jpdPlanTitlesAllowList = (0, $lc7EO.useJpdPlanTitlesAllowList)();
    const allTitles = planTitles.map(({ fields: fields })=>fields.planTitleExternal);
    if (urlSlug === "product-discovery") {
        const allowSet = new Set(jpdPlanTitlesAllowList);
        return allTitles.filter((title)=>allowSet.has(title));
    }
    return allTitles;
};

});



parcelRegister("lPMtR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4e8bd012cc4b17f$export$2e2bcd8739ae039; });
/* product-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");
const $d4e8bd012cc4b17f$export$fef9b561ff2e7cb1 = ({ id: id, name: name, description: description, href: href, className: className, imgSrc: imgSrc, imgAlt: imgAlt, type: type = "secondary" })=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(href ?? "");
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleCardClick = (0, $1oC0p.useCallback)((productKey)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "productCard",
            source: "customerStories",
            attributes: {
                product: productKey
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    let normalizedId;
    if (id === "jira-software") normalizedId = "jira";
    else if (id === "atlassian-access") normalizedId = "guard";
    else if (id) // The id for some products in Contentful have "-" in between (ex. jira-service-management), so we need to remove it to match data-product-key values in the global nav
    normalizedId = id.replace(/-/g, "");
    else normalizedId = name.replace(/ /g, "").toLowerCase();
    const iconSize = type === "primary" ? 44 : 32;
    const cardContent = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1aax1e5h _12l2utpp _4cvr1h6o _1bah1h6o _4t3i1ady _1bsb1ady _1wpz1q9y"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                    image: {
                        src: imgSrc ?? "https://dam-cdn.atl.orangelogic.com/AssetLink/5sd7w3j2d7rdm7354yi413c5s1eo6s10.webp",
                        alt: imgAlt ?? "",
                        width: iconSize,
                        height: iconSize
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpv77o _1q51v77o _1tke1ady",
                    "_1b2mvd4q _gp0igktf",
                    !description && "_1bah1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "h6",
                        children: name
                    }),
                    description && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "body-sm",
                        children: description
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1mouu2gc _132517la",
            className
        ]),
        "data-testid": "wae-product-card",
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: href ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: (0, $jQ0cd.isLocalizableHref)(href) ? localizedHref : href,
            target: (0, $jQ0cd.isLocalizableHref)(href) ? undefined : "_blank",
            rel: (0, $jQ0cd.isLocalizableHref)(href) ? undefined : "noreferrer",
            onClick: ()=>handleCardClick(normalizedId),
            children: cardContent
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: cardContent
        })
    });
};
const $d4e8bd012cc4b17f$var$cardStyle = null;
const $d4e8bd012cc4b17f$var$iconStyle = null;
const $d4e8bd012cc4b17f$var$textContainerStyle = null;
const $d4e8bd012cc4b17f$var$noDescriptionStyle = null;
const $d4e8bd012cc4b17f$var$overrideTextStyling = null;
var $d4e8bd012cc4b17f$export$2e2bcd8739ae039 = $d4e8bd012cc4b17f$export$fef9b561ff2e7cb1;

});

parcelRegister("4oasi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $222f1f27398983e7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $dZNgt = parcelRequire("dZNgt");

var $klmj6 = parcelRequire("klmj6");

var $lTkkF = parcelRequire("lTkkF");

var $jQ0cd = parcelRequire("jQ0cd");
const $222f1f27398983e7$export$228b49acf1bf4a77 = (props)=>{
    const localizedLinkHref = (0, $jQ0cd.useLocalizedHref)(props.linkHref?.path ?? "");
    const localizedButtonHref = (0, $jQ0cd.useLocalizedHref)(props.buttonHref?.path ?? "");
    const callToActionProps = $222f1f27398983e7$var$transformCtaProps({
        ...props,
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $klmj6.ProductCardBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            text: props.richText
        }) : !(0, $dZNgt.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: props.imageAlt ?? ""
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: props.iconAlt ?? ""
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor
    });
};
function $222f1f27398983e7$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!buttonHref?.path && !!buttonLabel;
    const isLink = !!linkHref?.path && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "productCardBlock",
                    "data-event": "clicked",
                    "data-label": buttonLabel
                }
            } : undefined,
            buttonText: buttonLabel ?? undefined,
            buttonVariant: buttonVariant ?? undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "productCardBlock",
                    "data-event": "clicked",
                    "data-label": linkText
                }
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $222f1f27398983e7$export$2e2bcd8739ae039 = $222f1f27398983e7$export$228b49acf1bf4a77;

});
parcelRegister("klmj6", function(module, exports) {
$parcel$export(module.exports, "ProductCardBlock", function () { return $7ee1c2a1142c9873$export$c17e706797abe921; });
/* product-card-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $63bv7 = parcelRequire("63bv7");

var $kbpa7 = parcelRequire("kbpa7");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");
const $7ee1c2a1142c9873$export$9bc3333acc9b342f = {
    jira: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Jira logo",
        text: "Jira"
    },
    jiraProductDiscovery: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraProductDiscoveryIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Jira Product Discovery logo",
        text: "Jira Product Discovery"
    },
    jiraServiceManagement: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraServiceManagementIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Jira Service Management logo",
        text: "Jira Service Management"
    },
    statuspage: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.StatuspageIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Statuspage logo",
        text: "Statuspage"
    },
    confluence: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Confluence logo",
        text: "Confluence"
    },
    trello: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.TrelloIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Trello logo",
        text: "Trello"
    },
    loom: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.LoomIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Loom logo",
        text: "Loom"
    },
    bitbucket: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.BitbucketIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Bitbucket logo",
        text: "Bitbucket"
    },
    rovoDev: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/m075131gef201aeok8g484w063t363hc.svg",
        alt: "Rovo Dev logo",
        text: "Rovo Dev",
        image: true
    },
    compass: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.CompassIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Compass logo",
        text: "Compass"
    },
    guard: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.GuardIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Guard logo",
        text: "Guard"
    },
    focus: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.FocusIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Focus logo",
        text: "Focus"
    },
    talent: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.TalentIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Talent logo",
        text: "Talent"
    },
    rovo: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/qe401oio4a2o006h83v3861f5xg6gc76.svg",
        alt: "Rovo logo",
        text: "Rovo",
        image: true
    },
    jiraAlign: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraAlignIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Jira Align logo",
        text: "Jira Align"
    },
    assets: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.AssetsIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Assets logo",
        text: "Assets"
    },
    customerServiceManagement: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.CustomerServiceManagementIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Customer Service Management logo",
        text: "Customer Service Management"
    },
    bamboo: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.BambooIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Bamboo logo",
        text: "Bamboo"
    },
    pipelines: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w5y63772u3hv13stbj352ut7x2h001jf.svg",
        alt: "Pipelines logo",
        text: "Pipelines",
        image: true
    },
    dx: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1mx06b178gpdjg8u7kjg38ci80p80eln.svg",
        alt: "DX logo",
        text: "DX",
        image: true
    },
    sourcetree: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1o5et30ftpu1nt3m25bbcmg44k5apcr6.svg",
        alt: "SourceTree logo",
        text: "SourceTree",
        image: true
    },
    crowd: {
        src: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.CrowdIcon), {
            appearance: "brand",
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        alt: "Crowd logo",
        text: "Crowd"
    },
    teamworkCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/78ylq28783ef6w7c21vu5y84ngku10fx.svg",
        alt: "Teamwork Collection logo",
        height: 20
    },
    strategyCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/h5mj8675hs2i21g7687jagjoax1uy14n.svg",
        alt: "Strategy Collection logo",
        height: 20
    },
    serviceCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/f481qls2e2g883b2us2ek546yg4c44g1.svg",
        alt: "Service Collection logo",
        height: 20
    },
    softwareCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1j5jdr1kj625ayo48v421j3o05hg8nkg.svg",
        alt: "Software Collection logo",
        height: 20
    },
    productCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12NA4X.svg",
        alt: "Product Collection",
        height: 20
    }
};
const $7ee1c2a1142c9873$var$imageStyle = null;
const $7ee1c2a1142c9873$var$zeroMarginCss = null;
const $7ee1c2a1142c9873$var$iconSizes = {
    "x-small": 24,
    "small": 32,
    "medium": 48,
    "large": 64
};
const $7ee1c2a1142c9873$var$contentColumnsLayout = {
    10: {
        assetSpan: 3,
        contentStart: 2
    },
    // 10 columns content block means 3 columns for asset, 7 for text
    12: {
        assetSpan: 4,
        contentStart: 1
    }
};
const $7ee1c2a1142c9873$var$renderCta = ({ ctaProps: ctaProps, buttonSize: buttonSize, alignment: alignment, backgroundColor: backgroundColor, titleId: titleId, buttonId: buttonId, linkId: linkId })=>{
    if ("button" in ctaProps && ctaProps.button !== undefined) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bahmqo6 _e8gh6xil _msuptoro"
        ]),
        style: {
            "--_1n7hwam": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.mobile),
            "--_1szc1oo": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.tablet),
            "--_1gtp2l2": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.desktop)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                ...ctaProps.button,
                id: buttonId,
                size: buttonSize,
                variant: backgroundColor && backgroundColor === "#1868DB" && (ctaProps.buttonVariant === "primary" || !ctaProps.buttonVariant) ? "secondary" : ctaProps.buttonVariant ?? "primary",
                colorAgainst: backgroundColor === "#1868DB" ? "other" : "white",
                ariaLabelledby: `${buttonId} ${titleId}`,
                dataEventProps: ctaProps.dataEventProps,
                className: (0, $2jatx.default)([
                    "_i0dl1ris"
                ]),
                children: ctaProps.buttonText
            }),
            ctaProps.link && // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Link component renders text content via the text prop from ctaProps.link
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                id: linkId,
                ariaLabelledby: `${linkId} ${titleId}`,
                type: "primary",
                bgColor: $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) ? "bgBlackBlue" : "bgWhite",
                ...ctaProps.link
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            id: linkId,
            ariaLabelledby: `${linkId} ${titleId}`,
            type: "primary",
            bgColor: $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) ? "bgBlackBlue" : "bgWhite",
            ...ctaProps.link,
            children: ctaProps.link?.text
        })
    });
};
const $7ee1c2a1142c9873$var$renderIcon = (icon)=>{
    if (icon?.linkedIcon) {
        const linkedIconSize = icon?.linkedIcon?.size ? $7ee1c2a1142c9873$var$iconSizes[icon.linkedIcon.size] : $7ee1c2a1142c9873$var$iconSizes["medium"];
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                src: icon.linkedIcon.url,
                alt: icon.linkedIcon.alt ?? "",
                width: linkedIconSize,
                height: linkedIconSize
            })
        });
    }
    if (icon?.iconComponent) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: icon.iconComponent
    });
    return null;
};
const $7ee1c2a1142c9873$var$isDarkBackgroundColor = (color)=>{
    return color ? [
        "#1868DB",
        "#101214"
    ].includes(color) : false;
};
const $7ee1c2a1142c9873$export$c17e706797abe921 = ({ logo: logo, eyebrow: eyebrow, title: title, text: text, imageProps: imageProps, spotIllustrationUrl: spotIllustrationUrl, icon: icon, callToActionProps: callToActionProps, alignment: alignment = "start", orientation: orientation = "vertical", columns: columns = 10, backgroundColor: backgroundColor, ...props })=>{
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = "h3" } = props;
    const isSmallDetailStyling = [
        "h4"
    ].includes(TitleComponent);
    const isLargeTextStyling = TitleComponent === "h2";
    const buttonSize = isSmallDetailStyling ? "small" : "large";
    const uniqueId = (0, $1oC0p.useId)();
    const titleId = `product-card-block-title-${uniqueId}`;
    const buttonId = `product-card-block-button-${uniqueId}`;
    const linkId = `product-card-block-link-${uniqueId}`;
    const lightTextStyles = null;
    const textElement = typeof text === "string" ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) && "_125xcd5j _9wqlcd5j _1loecd5j _cg41cd5j _qliycd5j _1rhqcd5j",
            isLargeTextStyling ? "body-lg" : "body-md"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: text
    }) : text;
    const bgColorStyle = null;
    const textContent = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _1q511z08 _1bah1yb4 _1b1q1cw5 _4t3i1osq",
            $7ee1c2a1142c9873$var$isDarkBackgroundColor(backgroundColor) && "_125xcd5j _9wqlcd5j _1loecd5j _cg41cd5j _qliycd5j _1rhqcd5j"
        ]),
        style: {
            "--_jsl571": (0, $6ZVlx.default)(orientation === "horizontal" ? "var(--ds-space-100, 8px)" : undefined),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1ejb"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1y6m _zulpu2gc"
                        ]),
                        children: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo] && "text" in $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo] ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].image ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                    src: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.src,
                                    alt: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.alt,
                                    className: (0, $2jatx.default)([
                                        "_1bsbzwfg"
                                    ])
                                }) : $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].src,
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect41pz4 _1wybqslr _zg8l4jg8 _k48p1nn1 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1ule"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                    },
                                    children: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo].text
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.src,
                            alt: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.alt,
                            height: $7ee1c2a1142c9873$export$9bc3333acc9b342f[logo]?.height ?? 32,
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _5ral1f51 _rsuf2bpp"
                            ])
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulpu2gc",
                            "product-card-block-text-content"
                        ]),
                        children: [
                            eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_syazw8v6",
                                    isSmallDetailStyling ? "eyebrow-sm" : "eyebrow-md"
                                ]),
                                style: {
                                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                },
                                children: eyebrow
                            }),
                            title && /*#__PURE__*/ (0, $7VQPk.jsx)(TitleComponent, {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "card-title"
                                ]),
                                id: titleId,
                                children: title
                            }),
                            text && textElement
                        ]
                    })
                ]
            }),
            callToActionProps && $7ee1c2a1142c9873$var$renderCta({
                ctaProps: callToActionProps,
                buttonSize: buttonSize,
                alignment: alignment,
                backgroundColor: backgroundColor,
                titleId: titleId,
                buttonId: buttonId,
                linkId: linkId
            })
        ]
    });
    const assetStyles = null;
    const horizontalSpotIllustrationStyles = null;
    const assetContent = imageProps ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1b1q7d4p"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
            ...imageProps,
            alt: imageProps.alt ?? "",
            className: (0, $2jatx.default)([
                "_18zxcq2i _mezj1osq _bna71wug _1jpx1f51"
            ])
        })
    }) : spotIllustrationUrl ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1b1q7d4p",
            "_181n1txw _q8t51h6o _e8gh1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
            src: spotIllustrationUrl,
            alt: "",
            width: 236,
            height: 236
        })
    }) : icon ? $7ee1c2a1142c9873$var$renderIcon(icon) : null;
    const gapBetweenIconAndText = null;
    const productCardPadding = null;
    if (orientation === "vertical") return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e1faxbu",
            "_1yt41ejb",
            "_y3gnmqo6 _uj6k6xil _10hltoro _1e0c1txw _2lx21bp4 _zulp1ejb _11q79r5u _4cvr1fhb _1bah1fhb _4t3i1osq",
            icon && "_zulppxbi",
            "_2rkovwyg _19ityzqy"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1n7hwam": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.mobile),
            "--_1szc1oo": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.tablet),
            "--_1gtp2l2": (0, $6ZVlx.default)(typeof alignment === "string" ? alignment : alignment.desktop),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            assetContent,
            textContent
        ]
    });
    const fullWidthGridStyles = null;
    const horizontalProductCard = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1yt41ejb",
            "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _1j8bcx6w _1vsw1vi7 _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg",
            "_1e1faxbu",
            "_kqswh2mm _1pbykb7n _1v6z18hw _1oyhxrvy",
            !backgroundColor && "_2rkovwyg _19ityzqy"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_vimf9d": (0, $6ZVlx.default)(orientation === "horizontal-reverse" ? $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["contentStart"] : $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["contentStart"] + $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_1seowu7": (0, $6ZVlx.default)(numColumns - $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_tnqi0k": (0, $6ZVlx.default)(orientation === "horizontal" ? $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["contentStart"] : $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["contentStart"] + numColumns - $7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_1u7gek8": (0, $6ZVlx.default)($7ee1c2a1142c9873$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            orientation === "horizontal" ? assetContent : null,
            textContent,
            orientation === "horizontal-reverse" ? assetContent : null
        ]
    });
    switch(numColumns){
        case 10:
        case 12:
            if (backgroundColor) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e1faxbu",
                    "_2rkovwyg _19ityzqy",
                    "_1bsb1osq _kqswh2mm"
                ]),
                style: {
                    "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1bsbauwl _14b5zqdx _b8yq87gh _4t3i1osq _1e021ssb _t9eczr6s _11q79r5u _2rkovwyg"
                        ]),
                        style: {
                            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                        }
                    }),
                    horizontalProductCard
                ]
            });
            return horizontalProductCard;
    }
};
const $7ee1c2a1142c9873$var$borderRadiusStyle = null;

});


parcelRegister("exkom", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ee40bb10698e2e3$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $3Nxop = parcelRequire("3Nxop");

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");

var $ghWaY = parcelRequire("ghWaY");

var $8zfxq = parcelRequire("8zfxq");

var $fboYQ = parcelRequire("fboYQ");

var $1xzPJ = parcelRequire("1xzPJ");

var $cwkIh = parcelRequire("cwkIh");

var $l5Cys = parcelRequire("l5Cys");

var $gBTmU = parcelRequire("gBTmU");

var $7iwdN = parcelRequire("7iwdN");

var $7pPqA = parcelRequire("7pPqA");
const $5ee40bb10698e2e3$var$UniformRoadmapFeatures = (props)=>{
    const { data: ssrData, roadmapFeaturesLocale: roadmapFeaturesLocale, roadmapName: roadmapName, lastUpdated: lastUpdated } = props;
    const pageBasePath = roadmapName === "Data Center" ? (0, $7iwdN.DATACENTER_BASE_PATH) : (0, $7iwdN.CLOUD_BASE_PATH);
    const { filters: filters, sortCriteria: sortCriteria, selectedFeature: selectedFeature } = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === "undefined") return {
            filters: (0, $7iwdN.emptyFilters),
            sortCriteria: undefined,
            selectedFeature: undefined
        };
        const filters = {
            category: (0, $7pPqA.getQueryParamFromWindow)("category"),
            search: (0, $7pPqA.getQueryParamFromWindow)("search"),
            status: (0, $7pPqA.getQueryParamFromWindow)("status"),
            selectedProduct: (0, $7pPqA.getQueryParamFromWindow)("selectedProduct")
        };
        const sortCriteria = {
            key: (0, $7pPqA.getQueryParamFromWindow)("sortBy")[0],
            direction: (0, $7pPqA.getQueryParamFromWindow)("sort")[0]
        };
        let selectedFeature;
        const slug = (0, $7pPqA.getSlugFromWindow)({
            basePath: pageBasePath
        });
        if (slug) selectedFeature = {
            pid: (0, $7pPqA.getQueryParamFromWindow)("p")?.[0],
            slug: slug
        };
        return {
            filters: filters,
            sortCriteria: sortCriteria,
            selectedFeature: selectedFeature
        };
    }, []);
    const { result: csrData } = (0, $fboYQ.useQuery)({
        locale: roadmapFeaturesLocale,
        roadmapName: roadmapName
    });
    const features = csrData?.roadmapFeatureCollection?.items ?? ssrData?.roadmapFeatureCollection?.items;
    const filterOptionsByKey = {
        category: ssrData?.taxonomyRoadmapCategoryCollection.items.map((item)=>({
                value: item.queryParameter,
                label: item.roadmapCategoryNameExternal
            })) ?? [],
        selectedProduct: (()=>{
            if (!ssrData?.taxonomyRoadmapAppCollection.items) return [];
            // Group apps by filterQueryParam and keep only the shortest label for each
            const groupedByQueryParam = new Map();
            for (const item of ssrData.taxonomyRoadmapAppCollection.items){
                const queryParam = item.filterQueryParam;
                const currentName = item.roadmapAppNameExternal;
                const existing = groupedByQueryParam.get(queryParam);
                if (!existing || currentName.length < existing.length) groupedByQueryParam.set(queryParam, currentName);
            }
            return Array.from(groupedByQueryParam.entries()).map(([value, label])=>({
                    value: value,
                    label: label
                }));
        })(),
        status: ssrData?.taxonomyRoadmapStatusCollection.items.map((item)=>({
                value: item.roadmapStatusNameExternal,
                label: item.roadmapStatusNameExternal
            })) ?? []
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Ntyw.BxpWebStargateClientProvider), {
        baseUrl: "https://www.atlassian.com/gateway/api",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7iwdN.RoadmapFeaturesContextProvider), {
            pageBasePath: pageBasePath,
            locale: roadmapFeaturesLocale,
            filters: filters,
            sortCriteria: sortCriteria,
            selectedFeature: selectedFeature,
            features: features,
            filterOptionsByKey: filterOptionsByKey,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gBTmU.RoadmapSubNav), {}),
                    roadmapName === "Data Center" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8zfxq.DataCenterRoadmapSubscriptionForm), {
                        lastUpdated: lastUpdated
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ghWaY.CloudRoadmapSubscriptionForm), {
                        lastUpdated: lastUpdated
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Nxop.SearchWithFilters), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l5Cys.Layout), {
                        columnHeaders: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwkIh.ColumnHeaders), {}),
                        cards: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1xzPJ.Cards), {})
                    })
                ]
            })
        })
    });
};
var $5ee40bb10698e2e3$export$2e2bcd8739ae039 = $5ee40bb10698e2e3$var$UniformRoadmapFeatures;

});
parcelRegister("3Nxop", function(module, exports) {
$parcel$export(module.exports, "SearchWithFilters", function () { return $5701f908310c3ff2$export$164878005b1b038c; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $ihYMb = parcelRequire("ihYMb");

var $2LBZM = parcelRequire("2LBZM");
const $5701f908310c3ff2$export$164878005b1b038c = ()=>{
    const searchValueFromUrl = (0, $2LBZM.useSearch)() || "";
    const [searchStringValue, setSearchStringValue] = (0, $1oC0p.useState)(searchValueFromUrl);
    const [searchInputFieldFocused, setSearchInputFieldFocused] = (0, $1oC0p.useState)(false);
    const setFilter = (0, $2LBZM.useSetFilter)();
    const setSearch = (0, $2LBZM.useSetSearch)();
    const appValue = (0, $2LBZM.useFilter)("selectedProduct");
    const statusValue = (0, $2LBZM.useFilter)("status");
    const categoryValue = (0, $2LBZM.useFilter)("category");
    const appOptions = (0, $2LBZM.useFilterOptions)("selectedProduct");
    const statusOptions = (0, $2LBZM.useFilterOptions)("status");
    const categoryOptions = (0, $2LBZM.useFilterOptions)("category");
    const filterObject = (0, $1oC0p.useMemo)(()=>{
        // Order matches column headers: Category, Status, Apps
        return {
            category: categoryOptions.reduce((acc, opt)=>{
                const isSelected = categoryValue.includes(opt.value);
                return {
                    ...acc,
                    [opt.label]: {
                        committedActive: isSelected,
                        stagedActive: isSelected
                    }
                };
            }, {}),
            status: statusOptions.reduce((acc, opt)=>{
                const isSelected = statusValue.includes(opt.value);
                return {
                    ...acc,
                    [opt.label]: {
                        committedActive: isSelected,
                        stagedActive: isSelected
                    }
                };
            }, {}),
            app: appOptions.reduce((acc, opt)=>{
                // Check if the option's value is in the filter values from URL
                const isSelected = appValue.includes(opt.value);
                return {
                    ...acc,
                    [opt.label]: {
                        committedActive: isSelected,
                        stagedActive: isSelected
                    }
                };
            }, {})
        };
    }, [
        categoryOptions,
        categoryValue,
        statusOptions,
        statusValue,
        appOptions,
        appValue
    ]);
    const [filterObjectState, setFilterObjectState] = (0, $1oC0p.useState)(filterObject);
    // Sync search string value with URL params
    (0, $1oC0p.useEffect)(()=>{
        setSearchStringValue(searchValueFromUrl);
    }, [
        searchValueFromUrl
    ]);
    // Sync filter object state with URL params
    (0, $1oC0p.useEffect)(()=>{
        setFilterObjectState(filterObject);
    }, [
        filterObject
    ]);
    const clearSearchField = (0, $1oC0p.useCallback)(()=>{
        setSearchStringValue("");
        setSearchInputFieldFocused(false);
        setSearch("");
    }, [
        setSearch
    ]);
    const runSearchWithFilters = (0, $1oC0p.useCallback)((filterObj, searchTerm)=>{
        setFilterObjectState(filterObj);
        // search
        setSearch(searchTerm);
        // app (selectedProduct) filter
        const appFilterValue = [];
        Object.entries(filterObj.app).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = appOptions.find((opt)=>opt.label === label);
                if (option) appFilterValue.push(option.value);
            }
        });
        setFilter("selectedProduct", appFilterValue);
        // category filter
        const categoryFilterValue = [];
        Object.entries(filterObj.category).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = categoryOptions.find((opt)=>opt.label === label);
                if (option) categoryFilterValue.push(option.value);
            }
        });
        setFilter("category", categoryFilterValue);
        // status filter
        const statusFilterValue = [];
        Object.entries(filterObj.status).map(([label, { committedActive: committedActive }])=>{
            if (committedActive) {
                const option = statusOptions.find((opt)=>opt.label === label);
                if (option) statusFilterValue.push(option.value);
            }
        });
        setFilter("status", statusFilterValue);
    }, [
        appOptions,
        categoryOptions,
        statusOptions,
        setFilter,
        setSearch
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ihYMb.default), {
        filterObject: filterObjectState,
        searchStringValue: searchStringValue,
        searchInputFieldFocused: searchInputFieldFocused,
        setSearchInputFieldFocused: setSearchInputFieldFocused,
        setFilterObjectValue: setFilterObjectState,
        setSearchString: setSearchStringValue,
        clearSearchField: clearSearchField,
        runSearchWithFilters: runSearchWithFilters
    });
};

});
parcelRegister("ihYMb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $920593310c76585f$export$2e2bcd8739ae039; });
/* uniform-search-with-filters.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $jsxHL = parcelRequire("jsxHL");

var $lgRQS = parcelRequire("lgRQS");

var $hjTlF = parcelRequire("hjTlF");

var $8OrKI = parcelRequire("8OrKI");
const $920593310c76585f$var$UniformSearchWithFilters = ({ filterObject: filterObject, searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setFilterObjectValue: setFilterObjectValue, setSearchInputFieldFocused: setSearchInputFieldFocused, setSearchString: setSearchString, clearSearchField: clearSearchField, runSearchWithFilters: runSearchWithFilters })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const localizedMap = {
        app: intl.formatMessage({
            id: "uniformSearchWithFilters.filter.app",
            defaultMessage: "App"
        }),
        category: intl.formatMessage({
            id: "uniformSearchWithFilters.filter.category",
            defaultMessage: "Category"
        }),
        status: intl.formatMessage({
            id: "uniformSearchWithFilters.filter.status",
            defaultMessage: "Status"
        })
    };
    const clearFiltersText = intl.formatMessage({
        id: "uniformSearchWithFilters.clearFilters",
        defaultMessage: "Clear Filters"
    });
    const clearAllFilters = ()=>{
        setFilterObjectValue((prevState)=>{
            const cleared = {};
            Object.keys(prevState).forEach((category)=>{
                const categoryKey = category;
                cleared[categoryKey] = {};
                Object.keys(prevState[categoryKey]).forEach((optionName)=>{
                    cleared[categoryKey][optionName] = {
                        committedActive: false,
                        stagedActive: false
                    };
                });
            });
            runSearchWithFilters(cleared, searchStringValue);
            return cleared;
        });
    };
    const whichFilterModalIsOpenObjectDefaultState = {
        app: false,
        category: false,
        status: false
    };
    Object.freeze(whichFilterModalIsOpenObjectDefaultState);
    const [whichFilterModalIsOpenObject, updateWhichFilterModalIsOpenObject] = (0, $1oC0p.useState)(whichFilterModalIsOpenObjectDefaultState);
    // Updates the state of which filter modal is open
    // If a modal is closing, we commit all the stagedActive values
    const updateWhichFilterModalIsShown = (subFilter)=>{
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        updateWhichFilterModalIsOpenObject(()=>({
                ...whichFilterModalIsOpenObjectDefaultState,
                [subFilter]: !whichFilterModalIsOpenObject[subFilter]
            }));
        if (isModalClosing.length > 0) setFilterObjectValue((prevState)=>{
            filterObject = {
                ...prevState,
                ...(0, $8OrKI.commitAllStagedActiveValues)(prevState)
            };
            runSearchWithFilters(filterObject, searchStringValue);
            return filterObject;
        });
    };
    // Updates the stagedActive value of the filter
    const updateSubFilterStagedValue = (subFilterName, filterOptionName)=>{
        setFilterObjectValue((prevState)=>{
            return {
                ...prevState,
                [subFilterName]: {
                    ...prevState[subFilterName],
                    [filterOptionName]: {
                        ...prevState[subFilterName][filterOptionName],
                        stagedActive: !prevState[subFilterName][filterOptionName].stagedActive
                    }
                }
            };
        });
    };
    // Handles logic for determining which filter modal to show
    const getFilterModal = (showFilter, filterKey)=>{
        if (!showFilter || !whichFilterModalIsOpenObject[filterKey]) return null;
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hjTlF.UniformFilterModal), {
            subFilter: filterKey,
            subFilterObject: filterObject[filterKey],
            updateFilterObject: (filterOptionName)=>updateSubFilterStagedValue(filterKey, filterOptionName)
        });
    };
    const filterButtonClickWrapper = (ev, filterCategory)=>{
        ev.preventDefault();
        createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "uniformFilterButton",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                labelEnglish: filterCategory,
                url: location.href,
                page_path: location.pathname,
                eventComponent: "uniformFilterButton"
            }
        }).fire();
        updateWhichFilterModalIsShown(filterCategory);
    };
    // If any filter modal is open, show the modal
    const showModal = Object.values(whichFilterModalIsOpenObject).filter((isActiveValue)=>isActiveValue).length > 0;
    const handleDocumentClick = (0, $1oC0p.useCallback)((event)=>{
        if (showModal) {
            let parentNode = event.target;
            while(parentNode && parentNode.nodeName !== "BODY"){
                if (parentNode.id === "uniform-filter-modal-component-parent") return;
                parentNode = parentNode.parentNode;
            }
        }
        // If we are here, it means the click was outside the modal
        const isModalClosing = Object.keys(whichFilterModalIsOpenObject).filter((key)=>whichFilterModalIsOpenObject[key]);
        if (isModalClosing.length > 0) {
            updateWhichFilterModalIsOpenObject(()=>({
                    ...whichFilterModalIsOpenObjectDefaultState
                }));
            setFilterObjectValue((prevState)=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                filterObject = {
                    ...prevState,
                    ...(0, $8OrKI.commitAllStagedActiveValues)(prevState)
                };
                runSearchWithFilters(filterObject, searchStringValue);
                return filterObject;
            });
        }
    }, [
        showModal
    ]);
    // Attach and detach the event listener for the document click
    // This is used to determine if there is a click outside of the filter modals
    (0, $1oC0p.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener("click", handleDocumentClick, false);
        // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener("click", handleDocumentClick, false);
        };
    }, [
        handleDocumentClick
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "uniform-filters",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                className: (0, $2jatx.default)([
                    "_18s812pl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261q9c _1bah1yb4 _zulppxbi _8rdu1g80"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1n261q9c _i0dlmko7 _1bahesu3 _8fz61osq _1a8l1osq _o5kc1y6m"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lgRQS.SearchBar), {
                                searchStringValue: searchStringValue,
                                setSearchString: setSearchString,
                                runSearch: ()=>runSearchWithFilters(filterObject, searchStringValue),
                                searchInputFieldFocused: searchInputFieldFocused,
                                setSearchInputFieldFocused: setSearchInputFieldFocused,
                                clearSearchField: clearSearchField
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1e0c1txw _1n261q9c _i0dl1ns9 _v5646lqh _zulpu2gc _1a8l1osq _1s4p1osq _8rdu1g80"
                            ]),
                            children: [
                                [
                                    "category",
                                    "status",
                                    "app"
                                ].map((key, index)=>{
                                    const filterKey = key;
                                    // Inefficient, we should look into memoizing this
                                    const numFiltersActive = (0, $8OrKI.getActiveFiltersByFilterType)(filterKey, filterObject);
                                    const buttonClassNameBuilder = `body-md ${numFiltersActive ? "filter-active" : ""} ${whichFilterModalIsOpenObject[filterKey] ? "selected" : ""}`;
                                    const filterModal = getFilterModal(showModal, filterKey);
                                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lqyi6.Button), {
                                                variant: "secondary",
                                                size: "small",
                                                className: (0, $2jatx.default)([
                                                    "_blhd1wug _1tvskb7n _1bzwkb7n _1a8l1wug _1fqbf1gs _1p3ku2gc _128g18ms _1n7j150w _19lc150w _1w3o1dli _1og01dli _mtmv1dli _1il01txw _1qqaglyw",
                                                    buttonClassNameBuilder
                                                ]),
                                                id: "uniform-filter-modal-component-parent",
                                                onClick: (ev)=>filterButtonClickWrapper(ev, filterKey),
                                                style: {
                                                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                                                    "--_1ugh14a": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple100"))
                                                },
                                                children: [
                                                    localizedMap[filterKey],
                                                    " ",
                                                    $920593310c76585f$var$filterDropDownArrowSVG,
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_1e0cglyw _4cvr1h6o _1bah1h6o _11q71p6p _2rko1ssb _ahbqu2gc _syaz1hlo _1bsbv47k _4t3iv47k _k48pni7l _vwz4kb7n",
                                                            "fine-print"
                                                        ]),
                                                        style: {
                                                            "--_liss8u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple300")),
                                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                                        },
                                                        children: numFiltersActive
                                                    })
                                                ]
                                            }),
                                            filterModal
                                        ]
                                    }, index);
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "uniform-filter-button",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        variant: "primary_alt",
                                        size: "small",
                                        onClick: clearAllFilters,
                                        className: (0, $2jatx.default)([
                                            "_o5721q9c",
                                            "body-md"
                                        ]),
                                        children: clearFiltersText
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $920593310c76585f$var$filterDropDownArrowSVG = /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "uniform-filter-dropdown-arrow",
    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
        d: "M9 1.18164L5 4.818L1 1.18164",
        stroke: (0, $kbpa7.wacToken)("color.primary.black"),
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
const $920593310c76585f$var$uniformFiltersSectionContainerStyle = null;
const $920593310c76585f$var$uniformFiltersContainerStyle = null;
const $920593310c76585f$var$filterButtonContainerStyle = null;
const $920593310c76585f$var$filterButtonStyles = null;
const $920593310c76585f$var$filterButtonCountStyles = null;
const $920593310c76585f$var$clearFiltersButtonStyle = null;
const $920593310c76585f$var$searchButtonContainerStyle = null;
var $920593310c76585f$export$2e2bcd8739ae039 = $920593310c76585f$var$UniformSearchWithFilters;

});
parcelRegister("lgRQS", function(module, exports) {
$parcel$export(module.exports, "SearchBar", function () { return $638264a52bcdb51e$export$79d13b60110f33be; });
/* search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $3n8tj = parcelRequire("3n8tj");

var $03P38 = parcelRequire("03P38");
const $638264a52bcdb51e$export$79d13b60110f33be = ({ searchStringValue: searchStringValue, searchInputFieldFocused: searchInputFieldFocused, setSearchString: setSearchString, setSearchInputFieldFocused: setSearchInputFieldFocused, clearSearchField: clearSearchField, runSearch: runSearch })=>{
    const intl = (0, $8e22h.default)();
    let createAnalyticsEvent = null;
    try {
        const analyticsHook = (0, $eY3N6.useAnalyticsEvents)();
        createAnalyticsEvent = analyticsHook.createAnalyticsEvent;
    } catch (e) {
    // Analytics provider not available
    }
    const searchRef = (0, $1oC0p.useRef)(null);
    const onSearchInputChange = (event)=>{
        setSearchString(event.target.value);
    };
    const handleSearchBarFocus = ()=>{
        setSearchInputFieldFocused(true);
        if (createAnalyticsEvent) createAnalyticsEvent({
            origin: "web",
            platform: "web",
            product: "marketing",
            source: "none",
            userIdType: "atlassianAccount",
            eventComponent: "searchInput",
            event: "clicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "component",
            attributes: {
                url: location.href,
                page_path: location.pathname,
                eventComponent: "searchInput"
            }
        }).fire();
    };
    const handleOnBlur = ()=>{
        if (searchStringValue === "") setSearchInputFieldFocused(false);
        else setSearchInputFieldFocused(true);
    };
    const handleSearchButtonClick = (0, $1oC0p.useCallback)(()=>{
        if (searchRef.current) searchRef.current.focus();
        runSearch();
    }, [
        runSearch
    ]);
    const handleClearSearchButtonClick = ()=>{
        clearSearchField();
        if (searchRef.current) searchRef.current.focus();
    };
    const searchClassName = searchInputFieldFocused ? "search-active" : "";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        onSubmit: (evt)=>{
            evt.preventDefault();
            handleSearchButtonClick();
        },
        className: (0, $2jatx.default)([
            "_4t3i1jfw _6rthidpf _1bsb1osq _12l2pxbi _11q7150w _2rko1jfw _1e0c1txw _1n261q9c _1bah1yb4 _1yt4119w _scffglyw _1rwq1j28 _xmji1r31 _gxxuglyw _34ir1o36 _5hv91osq _17ea1vuk _psgk1hlo _1owa1w8u _4u6k1j28 _10709by0 _1f021txw _oki51h6o _1vh3esu3 _dier1q9c _qe2zh8dc _12nmbz2e _1d2m1ejb _11vy1wtv _p2rgx19p"
        ]),
        style: {
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                className: searchClassName,
                type: "text",
                "aria-label": intl?.formatMessage({
                    id: "SearchBar.searchPlaceholder",
                    defaultMessage: "Search"
                }) || "Search",
                placeholder: intl?.formatMessage({
                    id: "SearchBar.searchPlaceholder",
                    defaultMessage: "Search"
                }) || "Search",
                onFocus: handleSearchBarFocus,
                onBlur: handleOnBlur,
                onChange: onSearchInputChange,
                value: searchStringValue,
                ref: searchRef
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: `search-buttons-container ${searchClassName}`,
                children: [
                    searchInputFieldFocused && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $03P38.UniformSearchCloseButton), {
                                onClick: handleClearSearchButtonClick
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: "search-buttons-divider"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3n8tj.UniformSearchButton), {})
                ]
            })
        ]
    });
};
const $638264a52bcdb51e$var$searchBarContainerStyle = null;

});
parcelRegister("3n8tj", function(module, exports) {
$parcel$export(module.exports, "UniformSearchButton", function () { return $d01e7f55404b7a17$export$fcc9da1be4557ae1; });
/* uniform-search-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bZmYH = parcelRequire("bZmYH");

var $kbpa7 = parcelRequire("kbpa7");
const $d01e7f55404b7a17$var$searchIconStyle = null;
const $d01e7f55404b7a17$var$searchIconSvgStyle = null;
const $d01e7f55404b7a17$export$fcc9da1be4557ae1 = ()=>{
    let searchLabel = "Search";
    try {
        const intl = (0, $8e22h.default)();
        searchLabel = intl.formatMessage({
            id: "SearchButton.label",
            defaultMessage: "Search"
        });
    } catch (e) {
    // IntlProvider not available, use default
    }
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "searchSubmit",
            source: "searchWithFilters",
            attributes: {
                label: searchLabel
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "submit",
        id: "search-icon",
        "aria-label": searchLabel,
        onClick: handleClick,
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _syaz1nc2"
        ]),
        style: {
            "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_syaz1hlo _2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _irr31rga"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                label: searchLabel,
                size: "medium"
            })
        })
    });
};

});

parcelRegister("03P38", function(module, exports) {
$parcel$export(module.exports, "UniformSearchCloseButton", function () { return $cf60fc5b8402956c$export$5170f7b0a027f68a; });
/* uniform-search-close-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $dE0sS = parcelRequire("dE0sS");
const $cf60fc5b8402956c$var$searchButtonStyle = null;
const $cf60fc5b8402956c$var$searchIconStyle = null;
const $cf60fc5b8402956c$export$5170f7b0a027f68a = (props)=>{
    let searchCloseLabel = "Clear search";
    try {
        const intl = (0, $8e22h.default)();
        searchCloseLabel = intl.formatMessage({
            id: "SearchCloseButton.label",
            defaultMessage: "Clear search"
        });
    } catch (e) {
    // IntlProvider not available, use default
    }
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (e)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "clearSearch",
            source: "searchWithFilters",
            attributes: {
                label: searchCloseLabel
            }
        }).fire();
        props.onClick(e);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: handleClick,
        id: "search-close-icon",
        "aria-label": searchCloseLabel,
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _syaz1nc2 _30l31nc2"
        ]),
        style: {
            "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dE0sS.Cross), {
            size: "16",
            className: (0, $2jatx.default)([
                "_syaz1hlo _2rko1ssb _4t3i1wug"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            }
        })
    });
};

});


parcelRegister("hjTlF", function(module, exports) {
$parcel$export(module.exports, "UniformFilterModal", function () { return $f44020fab7cdce9e$export$a3fbc260ab4db874; });
/* uniform-filter-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bNzAT = parcelRequire("bNzAT");

var $OKl9V = parcelRequire("OKl9V");
const $f44020fab7cdce9e$export$a3fbc260ab4db874 = ({ subFilter: subFilter, subFilterObject: subFilterObject, updateFilterObject: updateFilterObject })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _bfhku67f _2rkogktf _1pbycs5v _152t4bvh _ca0q7vkz _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _16qs130s",
            subFilter
        ]),
        id: "uniform-filter-modal-component-parent",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4"
            ]),
            children: Object.keys(subFilterObject).map((filterOptionName, index)=>{
                const filterObject = subFilterObject[filterOptionName];
                const active = filterObject.stagedActive;
                const optionId = `option-${subFilter.replace(/\s/g, "")}-${index}`;
                return /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                    htmlFor: optionId,
                    className: (0, $2jatx.default)([
                        "_19pkftgi _2hwxidpf _otyridpf _18u0idpf _80omtlke _1e0c1txw _1n261q9c _4cvr1h6o _1bah1y6m"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                            id: optionId,
                            type: "checkbox",
                            onClick: ()=>updateFilterObject(filterOptionName),
                            className: (0, $2jatx.default)([
                                "_kqswstnw _tzy4idpf _lcxvglyw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_1bsbgktf _4t3igktf _2rko1l7b _19it1n5q _i0dlgktf _12l2ftgi _11q7cd5j _1e0c1txw _1bah1h6o _4cvr1h6o _bfw78djs _1c3917la _uq4u8djs",
                                active ? "checked" : ""
                            ]),
                            style: {
                                "--_yrk0lp": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.dark100")),
                                "--_7zbnls": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.light0")),
                                "--_1r6llbg": (0, $6ZVlx.default)((0, $bNzAT.default)("color.primary.blue"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_tzy4idpf",
                                    active && "_tzy4kb7n"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                                    name: "featurecheckmark",
                                    size: "xs",
                                    color: (0, $bNzAT.default)("color.neutral.light0")
                                })
                            })
                        }),
                        filterOptionName
                    ]
                }, filterOptionName);
            })
        })
    });
};
const $f44020fab7cdce9e$var$uniformFilterModalStyle = null;
const $f44020fab7cdce9e$var$filterRadioButtonContainerStyle = null;
const $f44020fab7cdce9e$var$checkboxSpanStyle = null;
const $f44020fab7cdce9e$var$iconSpanBaseStyle = null;
const $f44020fab7cdce9e$var$iconSpanVisibleStyle = null;
const $f44020fab7cdce9e$var$hiddenInputStyle = null;
const $f44020fab7cdce9e$var$filterListContainerStyle = null;

});

parcelRegister("8OrKI", function(module, exports) {
$parcel$export(module.exports, "commitAllStagedActiveValues", function () { return $91b56c3aa2113c4b$export$995b34954b6e3c5d; });
$parcel$export(module.exports, "getActiveFiltersByFilterType", function () { return $91b56c3aa2113c4b$export$5c95673afb2371b8; });
const $91b56c3aa2113c4b$export$995b34954b6e3c5d = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    committedActive: filterOptionValue.stagedActive
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$32ef36095a2643ff = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    stagedActive: false
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$6e8eccaa2da87c2a = (prevState)=>{
    return Object.keys(prevState).reduce((acc, filterCategory)=>{
        acc[filterCategory] = {
            ...prevState[filterCategory],
            ...Object.entries(prevState[filterCategory]).reduce((acc, [filterOptionName, filterOptionValue])=>{
                acc[filterOptionName] = {
                    ...filterOptionValue,
                    stagedActive: filterOptionValue.committedActive
                };
                return acc;
            }, {})
        };
        return acc;
    }, {});
};
const $91b56c3aa2113c4b$export$5c95673afb2371b8 = (filter, filterObject)=>{
    if (filter === "all") return Object.values(filterObject).reduce((acc, filterCategory)=>acc + Object.values(filterCategory).reduce((subacc, filterOption)=>filterOption.committedActive ? subacc + 1 : subacc, 0), 0);
    else return Object.values(filterObject[filter]).reduce((acc, subFilter)=>subFilter.committedActive ? acc + 1 : acc, 0);
};

});


parcelRegister("2LBZM", function(module, exports) {
$parcel$export(module.exports, "useFilteredAndSortedRoadmapFeatures", function () { return $ffa62b15e7d75df3$export$be6200d55ad2dcf6; });
$parcel$export(module.exports, "useSetFilter", function () { return $ffa62b15e7d75df3$export$a522d27da4074c2; });
$parcel$export(module.exports, "useFilter", function () { return $ffa62b15e7d75df3$export$3274cf84b703fff; });
$parcel$export(module.exports, "useSetSearch", function () { return $ffa62b15e7d75df3$export$a23792301e1faab8; });
$parcel$export(module.exports, "useSearch", function () { return $ffa62b15e7d75df3$export$bd221a7c56b93941; });
$parcel$export(module.exports, "useSetSelectedFeature", function () { return $ffa62b15e7d75df3$export$7e1378d2861c08e9; });
$parcel$export(module.exports, "useClearSelectedFeature", function () { return $ffa62b15e7d75df3$export$848481c86eff5af3; });
$parcel$export(module.exports, "useSelectedFeatureData", function () { return $ffa62b15e7d75df3$export$90d5ab95131b086c; });
$parcel$export(module.exports, "useSort", function () { return $ffa62b15e7d75df3$export$6292515ceca0b297; });
$parcel$export(module.exports, "useFilterOptions", function () { return $ffa62b15e7d75df3$export$e00e2ace74badd4e; });

var $7iwdN = parcelRequire("7iwdN");

var $2OD6N = parcelRequire("2OD6N");

var $7pPqA = parcelRequire("7pPqA");
const $ffa62b15e7d75df3$export$be6200d55ad2dcf6 = ()=>{
    const { features: features, filters: filters, sortCriteria: sortCriteria } = (0, $7iwdN.useRoadmapFeaturesContext)();
    if (!features) return null;
    const filteredAndSortedFeatures = (0, $2OD6N.getFilteredAndSortedRoadmapFeatures)({
        features: features,
        filters: filters,
        sortCriteria: sortCriteria
    });
    return (0, $2OD6N.getNormalizedFeatures)(filteredAndSortedFeatures);
};
const $ffa62b15e7d75df3$export$a522d27da4074c2 = ()=>{
    const { setFilters: setFilters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setFilter(filterKey, values) {
        (0, $7pPqA.setQueryParam)(filterKey, values);
        setFilters((prev)=>({
                ...prev,
                [filterKey]: values
            }));
    };
};
const $ffa62b15e7d75df3$export$7eba469e65994459 = ()=>{
    const { setFilters: setFilters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function clearFilter(filterKey) {
        (0, $7pPqA.setQueryParam)(filterKey, []);
        setFilters((prev)=>({
                ...prev,
                [filterKey]: []
            }));
    };
};
const $ffa62b15e7d75df3$export$3274cf84b703fff = (filterKey)=>{
    const { filters: filters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filters[filterKey];
};
const $ffa62b15e7d75df3$export$a23792301e1faab8 = ()=>{
    const setFilter = $ffa62b15e7d75df3$export$a522d27da4074c2();
    return function setSearch(value) {
        setFilter("search", [
            value
        ]);
    };
};
const $ffa62b15e7d75df3$export$bd221a7c56b93941 = ()=>{
    const { filters: filters } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filters.search[0];
};
const $ffa62b15e7d75df3$export$7e1378d2861c08e9 = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setSelectedFeature(feature) {
        (0, $7pPqA.setQueryParam)("p", []);
        if (feature.pid) (0, $7pPqA.setQueryParam)("p", [
            feature.pid
        ]);
        (0, $7pPqA.setSlug)(feature.slug, {
            basePath: ctx.pageBasePath
        });
        ctx.setSelectedFeature(feature);
    };
};
const $ffa62b15e7d75df3$export$60c6c640e9838831 = ()=>(0, $7iwdN.useRoadmapFeaturesContext)().selectedFeature;
const $ffa62b15e7d75df3$export$848481c86eff5af3 = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function clearSelectedFeature() {
        (0, $7pPqA.setQueryParam)("p", []);
        (0, $7pPqA.clearSlug)({
            basePath: ctx.pageBasePath
        });
        ctx.setSelectedFeature(undefined);
    };
};
const $ffa62b15e7d75df3$export$90d5ab95131b086c = ()=>{
    const { features: features } = (0, $7iwdN.useRoadmapFeaturesContext)();
    const selectedFeature = $ffa62b15e7d75df3$export$60c6c640e9838831();
    if (!features || !selectedFeature) return undefined;
    const feature = features.find((feature)=>feature.slug === selectedFeature.slug);
    if (!feature) return undefined;
    return (0, $2OD6N.getNormalizedFeature)(feature);
};
const $ffa62b15e7d75df3$export$5b8a3c885421eb7c = ()=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    return function setSortCriteria(sortCriteria) {
        if (sortCriteria === undefined) {
            ctx.setSortCriteria(undefined);
            (0, $7pPqA.setQueryParams)({
                sortBy: [],
                sort: []
            });
            return;
        }
        const { key: key, direction: direction } = sortCriteria;
        ctx.setSortCriteria({
            key: key,
            direction: direction
        });
        (0, $7pPqA.setQueryParams)({
            sortBy: [
                key
            ],
            sort: [
                direction
            ]
        });
    };
};
const $ffa62b15e7d75df3$export$6292515ceca0b297 = (key)=>{
    const ctx = (0, $7iwdN.useRoadmapFeaturesContext)();
    const setSortCriteria = $ffa62b15e7d75df3$export$5b8a3c885421eb7c();
    if (!ctx.sortCriteria || ctx.sortCriteria.key !== key) return {
        sortDirection: undefined,
        onClick: ()=>{
            setSortCriteria({
                key: key,
                direction: "asc"
            });
        }
    };
    const sortDirection = ctx.sortCriteria.direction;
    return {
        sortDirection: ctx.sortCriteria.direction,
        onClick: ()=>{
            if (sortDirection === undefined) setSortCriteria({
                key: key,
                direction: "asc"
            });
            if (sortDirection === "asc") setSortCriteria({
                key: key,
                direction: "desc"
            });
            if (sortDirection === "desc") setSortCriteria(undefined);
        }
    };
};
const $ffa62b15e7d75df3$export$e00e2ace74badd4e = (filterKey)=>{
    const { filterOptionsByKey: filterOptionsByKey } = (0, $7iwdN.useRoadmapFeaturesContext)();
    return filterOptionsByKey[filterKey].sort((a, b)=>a.label > b.label ? 1 : -1);
};
const $ffa62b15e7d75df3$export$7ae092e5866bd7d3 = ()=>{
    const setFilter = $ffa62b15e7d75df3$export$a522d27da4074c2();
    const setSortCriteria = $ffa62b15e7d75df3$export$5b8a3c885421eb7c();
    return function reset() {
        setSortCriteria(undefined);
        setFilter("search", []);
        setFilter("status", []);
        setFilter("category", []);
        setFilter("selectedProduct", []);
    };
};

});
parcelRegister("7iwdN", function(module, exports) {
$parcel$export(module.exports, "CLOUD_BASE_PATH", function () { return $3ab8d70c989cf75c$export$6d5070f150ecd91; });
$parcel$export(module.exports, "DATACENTER_BASE_PATH", function () { return $3ab8d70c989cf75c$export$c66cccefb563e9a1; });
$parcel$export(module.exports, "useRoadmapFeaturesContext", function () { return $3ab8d70c989cf75c$export$8bb3881bbfbce6f5; });
$parcel$export(module.exports, "RoadmapFeaturesContextProvider", function () { return $3ab8d70c989cf75c$export$cc9094b62665bcf1; });
$parcel$export(module.exports, "emptyFilters", function () { return $3ab8d70c989cf75c$export$68abacd3bc566b56; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $3ab8d70c989cf75c$export$6d5070f150ecd91 = "/roadmap/cloud";
const $3ab8d70c989cf75c$export$c66cccefb563e9a1 = "/roadmap/data-center";
const $3ab8d70c989cf75c$var$RoadmapFeaturesContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $3ab8d70c989cf75c$export$8bb3881bbfbce6f5 = ()=>{
    const ctx = (0, $1oC0p.useContext)($3ab8d70c989cf75c$var$RoadmapFeaturesContext);
    if (!ctx) throw new Error("missing context provider for RoadmapFeaturesContext");
    return ctx;
};
const $3ab8d70c989cf75c$export$cc9094b62665bcf1 = (props)=>{
    const { pageBasePath: pageBasePath, locale: locale, filterOptionsByKey: filterOptionsByKey } = props;
    // filters
    const initialFilters = $3ab8d70c989cf75c$var$getInitialFilters(props.filters ?? {});
    const [filters, setFilters] = (0, $1oC0p.useState)(initialFilters);
    // sort
    const [sortCriteria, setSortCriteria] = (0, $1oC0p.useState)(props.sortCriteria);
    // selected feature
    const [selectedFeature, setSelectedFeature] = (0, $1oC0p.useState)(props.selectedFeature);
    // results
    const [features, setFeatures] = (0, $1oC0p.useState)(props.features);
    (0, $1oC0p.useEffect)(()=>{
        setFeatures(props.features);
    }, [
        props.features
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($3ab8d70c989cf75c$var$RoadmapFeaturesContext.Provider, {
        value: {
            pageBasePath: pageBasePath,
            locale: locale,
            features: features,
            setFeatures: setFeatures,
            filters: filters,
            setFilters: setFilters,
            filterOptionsByKey: filterOptionsByKey,
            sortCriteria: sortCriteria,
            setSortCriteria: setSortCriteria,
            selectedFeature: selectedFeature,
            setSelectedFeature: setSelectedFeature
        },
        children: props.children
    });
};
const $3ab8d70c989cf75c$export$68abacd3bc566b56 = {
    category: [],
    status: [],
    search: [],
    selectedProduct: []
};
function $3ab8d70c989cf75c$var$getInitialFilters(filters) {
    return {
        ...$3ab8d70c989cf75c$export$68abacd3bc566b56,
        ...filters
    };
}

});

parcelRegister("2OD6N", function(module, exports) {
$parcel$export(module.exports, "getFilteredAndSortedRoadmapFeatures", function () { return $c1e231f117ad5b91$export$e45024fbc7d2fc41; });
$parcel$export(module.exports, "getNormalizedFeature", function () { return $c1e231f117ad5b91$export$6df6eeaa7a8a9e78; });
$parcel$export(module.exports, "getNormalizedFeatures", function () { return $c1e231f117ad5b91$export$a75feafd6c41cba5; });
function $c1e231f117ad5b91$export$e45024fbc7d2fc41(args) {
    const { features: features, filters: filters, sortCriteria: sortCriteria } = args;
    let filtered = features.filter((feature)=>{
        return $c1e231f117ad5b91$var$matchesCategory(feature, filters.category) && $c1e231f117ad5b91$var$matchesSelectedProduct(feature, filters.selectedProduct) && $c1e231f117ad5b91$var$matchesSearch(feature, filters.search) && $c1e231f117ad5b91$var$matchesStatus(feature, filters.status);
    });
    if (sortCriteria) filtered = [
        ...filtered
    ].sort((a, b)=>$c1e231f117ad5b91$var$compareFeatures(a, b, sortCriteria));
    return filtered;
}
function $c1e231f117ad5b91$var$extractTextFromJson(json) {
    if (typeof json === "string") return json;
    if (typeof json === "number" || typeof json === "boolean") return String(json);
    if (json === null || json === undefined) return "";
    if (Array.isArray(json)) return json.map((item)=>$c1e231f117ad5b91$var$extractTextFromJson(item)).join(" ");
    if (typeof json === "object") return Object.values(json).map((value)=>$c1e231f117ad5b91$var$extractTextFromJson(value)).join(" ");
    return "";
}
function $c1e231f117ad5b91$var$matchesSearch(feature, searchTerms) {
    if (searchTerms.length === 0) return true;
    const titleText = feature.title.toLowerCase();
    const descriptionText = $c1e231f117ad5b91$var$extractTextFromJson(feature.description.json).toLowerCase();
    const aggregateText = `${titleText} ${descriptionText}`;
    return searchTerms.every((term)=>aggregateText.includes(term.toLowerCase()));
}
function $c1e231f117ad5b91$var$matchesCategory(feature, categories) {
    if (categories.length === 0) return true;
    return categories.includes(feature.category.queryParameter);
}
function $c1e231f117ad5b91$var$matchesSelectedProduct(feature, selectedProducts) {
    if (selectedProducts.length === 0) return true;
    return feature.appsCollection.items.some((app)=>selectedProducts.includes(app.filterQueryParam));
}
function $c1e231f117ad5b91$var$matchesStatus(feature, statuses) {
    if (statuses.length === 0) return true;
    return statuses.includes(feature.status.roadmapStatusNameExternal);
}
/**
 * Extracts a sortable numeric value from a normalized timeframe string.
 * Returns a number where higher values represent later dates.
 * Single quarters sort before ranges with the same start date.
 * For non-standard formats, returns 0 (will sort to the beginning).
 */ function $c1e231f117ad5b91$var$getTimeFrameSortValue(timeFrame) {
    // Pattern: QX YYYY (e.g., "Q4 2026")
    const singleQuarterPattern = /^Q([1-4])\s+(\d{4})$/;
    const singleMatch = singleQuarterPattern.exec(timeFrame);
    if (singleMatch && singleMatch[1] && singleMatch[2]) {
        const quarter = parseInt(singleMatch[1], 10);
        const year = parseInt(singleMatch[2], 10);
        return year * 10 + quarter;
    }
    // Pattern: QX - QY YYYY (e.g., "Q3 - Q4 2024")
    // Add small offset (0.1) so ranges sort after single quarters with same start date
    const rangeSameYearPattern = /^Q([1-4])\s*-\s*Q([1-4])\s+(\d{4})$/;
    const rangeSameYearMatch = rangeSameYearPattern.exec(timeFrame);
    if (rangeSameYearMatch && rangeSameYearMatch[1] && rangeSameYearMatch[3]) {
        const quarter = parseInt(rangeSameYearMatch[1], 10);
        const year = parseInt(rangeSameYearMatch[3], 10);
        return year * 10 + quarter + 0.1;
    }
    // Pattern: QX YYYY - QY YYYY (e.g., "Q1 2024 - Q2 2025")
    // Add small offset (0.1) so ranges sort after single quarters with same start date
    const rangeDifferentYearsPattern = /^Q([1-4])\s+(\d{4})\s*-\s*Q([1-4])\s+(\d{4})$/;
    const rangeDifferentYearsMatch = rangeDifferentYearsPattern.exec(timeFrame);
    if (rangeDifferentYearsMatch && rangeDifferentYearsMatch[1] && rangeDifferentYearsMatch[2]) {
        const quarter = parseInt(rangeDifferentYearsMatch[1], 10);
        const year = parseInt(rangeDifferentYearsMatch[2], 10);
        return year * 10 + quarter + 0.1;
    }
    // Pattern: YYYY (e.g., "2026") - treat as Q1 of that year
    const yearOnlyPattern = /^(\d{4})$/;
    const yearOnlyMatch = yearOnlyPattern.exec(timeFrame);
    if (yearOnlyMatch && yearOnlyMatch[1]) {
        const year = parseInt(yearOnlyMatch[1], 10);
        return year * 10 + 1; // Treat as Q1
    }
    // Non-standard formats (e.g., "Coming Soon") - return 0 to sort to beginning
    return 0;
}
function $c1e231f117ad5b91$var$compareFeatures(a, b, sortCriteria) {
    const { key: key, direction: direction } = sortCriteria;
    const multiplier = direction === "asc" ? 1 : -1;
    let aValue;
    let bValue;
    switch(key){
        case "title":
            aValue = a.title;
            bValue = b.title;
            break;
        case "category":
            aValue = a.category.roadmapCategoryNameExternal;
            bValue = b.category.roadmapCategoryNameExternal;
            break;
        case "status":
            aValue = a.status.roadmapStatusNameExternal;
            bValue = b.status.roadmapStatusNameExternal;
            break;
        case "timeFrame":
            // Use normalized timeframe and convert to sortable numeric value
            aValue = $c1e231f117ad5b91$var$getTimeFrameSortValue($c1e231f117ad5b91$export$6df6eeaa7a8a9e78(a).timeFrame);
            bValue = $c1e231f117ad5b91$var$getTimeFrameSortValue($c1e231f117ad5b91$export$6df6eeaa7a8a9e78(b).timeFrame);
            break;
        default:
            return 0;
    }
    if (aValue < bValue) return -1 * multiplier;
    if (aValue > bValue) return 1 * multiplier;
    return 0;
}
function $c1e231f117ad5b91$var$normalizeTimeFrame(timeFrame) {
    // Pattern: YYYY QX (e.g., "2026 Q4")
    const singleYearQuarterPattern = /^(\d{4})\s+(Q[1-4])$/;
    const singleMatch = singleYearQuarterPattern.exec(timeFrame);
    if (singleMatch) return `${singleMatch[2]} ${singleMatch[1]}`;
    // Pattern: QX - YYYY QY (e.g., "Q3 - 2024 Q4")
    const rangeWithYearQuarterPattern = /^(Q[1-4])\s*-\s*(\d{4})\s+(Q[1-4])$/;
    const rangeMatch = rangeWithYearQuarterPattern.exec(timeFrame);
    if (rangeMatch) return `${rangeMatch[1]} - ${rangeMatch[3]} ${rangeMatch[2]}`;
    // Pattern: YYYY QX - YYYY QY (e.g., "2024 Q1 - 2024 Q2" or "2024 Q1 - 2025 Q2")
    const rangeWithTwoYearQuartersPattern = /^(\d{4})\s+(Q[1-4])\s*-\s*(\d{4})\s+(Q[1-4])$/;
    const twoYearRangeMatch = rangeWithTwoYearQuartersPattern.exec(timeFrame);
    if (twoYearRangeMatch) {
        const [, year1, quarter1, year2, quarter2] = twoYearRangeMatch;
        if (year1 === year2) return `${quarter1} - ${quarter2} ${year1}`;
        return `${quarter1} ${year1} - ${quarter2} ${year2}`;
    }
    // Pattern: QX YYYY - QY YYYY (e.g., "Q1 2024 - Q2 2025") - already normalized format
    const alreadyNormalizedRangePattern = /^Q([1-4])\s+(\d{4})\s*-\s*Q([1-4])\s+(\d{4})$/;
    const alreadyNormalizedMatch = alreadyNormalizedRangePattern.exec(timeFrame);
    if (alreadyNormalizedMatch) // Already in normalized format, return as-is
    return timeFrame;
    // Pattern: QX - QY YYYY (e.g., "Q3 - Q4 2024") - already normalized format
    const alreadyNormalizedSameYearRangePattern = /^Q([1-4])\s*-\s*Q([1-4])\s+(\d{4})$/;
    const alreadyNormalizedSameYearMatch = alreadyNormalizedSameYearRangePattern.exec(timeFrame);
    if (alreadyNormalizedSameYearMatch) // Already in normalized format, return as-is
    return timeFrame;
    // Return as-is if no pattern matches (already normalized or different format)
    return timeFrame;
}
function $c1e231f117ad5b91$export$6df6eeaa7a8a9e78(feature) {
    return {
        ...feature,
        timeFrame: $c1e231f117ad5b91$var$normalizeTimeFrame(feature.timeFrame)
    };
}
function $c1e231f117ad5b91$export$a75feafd6c41cba5(features) {
    return features.map((feature)=>$c1e231f117ad5b91$export$6df6eeaa7a8a9e78(feature));
}

});

parcelRegister("7pPqA", function(module, exports) {
$parcel$export(module.exports, "getQueryParamFromWindow", function () { return $310042fbac99da87$export$c88f6acd6921f5e8; });
$parcel$export(module.exports, "setQueryParam", function () { return $310042fbac99da87$export$8abc040b5116ed65; });
$parcel$export(module.exports, "setQueryParams", function () { return $310042fbac99da87$export$7755017099c85a0d; });
$parcel$export(module.exports, "setSlug", function () { return $310042fbac99da87$export$8863edec1beb539e; });
$parcel$export(module.exports, "getSlugFromWindow", function () { return $310042fbac99da87$export$e5c851c2cbeb3bc9; });
$parcel$export(module.exports, "clearSlug", function () { return $310042fbac99da87$export$497d95d751f2c8ad; });

var $3fFrT = parcelRequire("3fFrT");
/**
 * Extracts the locale prefix from a URL pathname if present
 * Returns undefined for default locale (en) or if no locale prefix exists
 */ function $310042fbac99da87$var$getLocaleFromPath(pathname) {
    const pathParts = pathname.split("/").filter(Boolean);
    const firstPart = pathParts[0];
    if (firstPart && (0, $3fFrT.LOCALES).includes(firstPart)) return firstPart;
    return undefined;
}
function $310042fbac99da87$export$95fd5664a53dd0c5(param, search) {
    const urlParams = new URLSearchParams(search);
    const value = urlParams.get(param);
    return value ? value.split(";") : [];
}
function $310042fbac99da87$export$c88f6acd6921f5e8(param) {
    return $310042fbac99da87$export$95fd5664a53dd0c5(param, window.location.search);
}
function $310042fbac99da87$export$8abc040b5116ed65(key, values) {
    if (typeof window === "undefined") return;
    const urlParams = new URLSearchParams(window.location.search);
    const value = values.join(";");
    if (value) urlParams.set(key, value);
    else urlParams.delete(key);
    // Build query string manually to avoid URL-encoding semicolons
    const queryString = Array.from(urlParams.entries()).map(([k, v])=>{
        const encodedKey = encodeURIComponent(k);
        // Keep semicolons unencoded in values
        const encodedValue = v.split(";").map((part)=>encodeURIComponent(part)).join(";");
        return `${encodedKey}=${encodedValue}`;
    }).join("&");
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""}${window.location.hash}`;
    window.history.pushState({}, "", newUrl);
}
function $310042fbac99da87$export$7755017099c85a0d(params) {
    Object.entries(params).forEach(([key, values])=>{
        $310042fbac99da87$export$8abc040b5116ed65(key, values);
    });
}
function $310042fbac99da87$export$8863edec1beb539e(value, opts = {}) {
    if (typeof window === "undefined") return;
    const { basePath: basePath } = opts;
    // Extract locale from current URL path
    const currentLocale = $310042fbac99da87$var$getLocaleFromPath(window.location.pathname);
    let newPath;
    if (basePath) {
        // Treat basePath as non-changeable
        const basePathParts = basePath.split("/").filter(Boolean);
        // If a part exists after the base path, remove it (it will be replaced by the new slug)
        // If no part exists after the base path, remove nothing (just append the new slug)
        // Result is always: [locale] + basePath + new slug
        if (currentLocale) newPath = `/${currentLocale}/${basePathParts.join("/")}/${value}`;
        else newPath = `/${basePathParts.join("/")}/${value}`;
    } else {
        // Original behavior when basePath is not specified
        const pathParts = window.location.pathname.split("/").filter(Boolean);
        newPath = pathParts.length > 0 ? `/${pathParts.join("/")}/${value}` : `/${value}`;
    }
    const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
    window.history.pushState({}, "", newUrl);
}
function $310042fbac99da87$export$29f5936f887dc758(pathname, opts = {}) {
    // either /roadmap/cloud or /roadmap/data-center
    const { basePath: basePath } = opts;
    const currentPathParts = pathname.split("/").filter(Boolean);
    if (basePath) {
        const basePathParts = basePath.split("/").filter(Boolean);
        // Set offeset for locale if it exists
        const currentLocale = $310042fbac99da87$var$getLocaleFromPath(pathname);
        const offset = currentLocale ? 1 : 0;
        // Check if current path starts with base path (accounting for locale offset)
        const startsWithBase = basePathParts.every((part, index)=>currentPathParts[index + offset] === part);
        if (startsWithBase && currentPathParts.length > basePathParts.length + offset) // Return the part after the basePath (accounting for locale offset)
        return currentPathParts[basePathParts.length + offset];
        // No part exists after the basePath, return undefined
        return undefined;
    } else // No basePath specified, return the last path part
    return currentPathParts.length > 0 ? currentPathParts[currentPathParts.length - 1] : undefined;
}
function $310042fbac99da87$export$e5c851c2cbeb3bc9(opts = {}) {
    return $310042fbac99da87$export$29f5936f887dc758(window.location.pathname, opts);
}
function $310042fbac99da87$export$497d95d751f2c8ad(opts = {}) {
    if (typeof window === "undefined") return;
    const { basePath: basePath } = opts;
    // Extract locale from current URL path
    const currentLocale = $310042fbac99da87$var$getLocaleFromPath(window.location.pathname);
    const currentPathParts = window.location.pathname.split("/").filter(Boolean);
    if (basePath) {
        const basePathParts = basePath.split("/").filter(Boolean);
        // Calculate offset for locale if it exists
        const offset = currentLocale ? 1 : 0;
        // Check if current path starts with base path (accounting for locale offset)
        const startsWithBase = basePathParts.every((part, index)=>currentPathParts[index + offset] === part);
        // Only clear if there's a part after the base path
        if (startsWithBase && currentPathParts.length > basePathParts.length + offset) {
            // Remove the part after the basePath, preserving locale
            let newPath;
            if (currentLocale) newPath = `/${currentLocale}/${basePathParts.join("/")}`;
            else newPath = `/${basePathParts.join("/")}`;
            const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
            window.history.pushState({}, "", newUrl);
        }
    // If no part exists after the base path, don't change the URL
    } else {
        // No basePath specified, use original behavior
        const pathParts = [
            ...currentPathParts
        ];
        if (pathParts.length > 0) pathParts.pop();
        const newPath = pathParts.length > 0 ? `/${pathParts.join("/")}` : "/";
        const newUrl = `${newPath}${window.location.search}${window.location.hash}`;
        window.history.pushState({}, "", newUrl);
    }
}

});



parcelRegister("ghWaY", function(module, exports) {
$parcel$export(module.exports, "CloudRoadmapSubscriptionForm", function () { return $1e06e34af93c7062$export$8792f89e1deb1e3; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6nmH5 = parcelRequire("6nmH5");
const $1e06e34af93c7062$export$8792f89e1deb1e3 = (props)=>{
    const { lastUpdated: lastUpdated } = props;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nmH5.RoadmapSubscriptionForm), {
        lastUpdated: lastUpdated,
        formId: "a9ce9de2-9120-4fa9-a982-12a369254cad",
        formImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5i7x2g3g1ap10qp6r31tyi2tw4ho75dq.png",
            alt: intl.formatMessage({
                id: "roadmapSubscription.image.alt",
                defaultMessage: "Cloud Roadmap"
            })
        },
        heading: intl.formatMessage({
            id: "roadmapSubscription.heading",
            defaultMessage: "Cloud Roadmap"
        }),
        description: intl.formatMessage({
            id: "roadmapSubscription.description",
            defaultMessage: "Check out the latest features in Cloud and learn about what we're working on. Subscribe to receive an email each quarter highlighting our newly released features, updated time frames, and more."
        })
    });
};

});
parcelRegister("6nmH5", function(module, exports) {
$parcel$export(module.exports, "RoadmapSubscriptionForm", function () { return $5922717f55943bb5$export$d9154e81ff5ef57d; });
/* roadmap-subscription-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $5Ntyw = parcelRequire("5Ntyw");

var $lqyi6 = parcelRequire("lqyi6");

var $jE3Ci = parcelRequire("jE3Ci");

var $kbpa7 = parcelRequire("kbpa7");

var $OKl9V = parcelRequire("OKl9V");

var $7iwdN = parcelRequire("7iwdN");
// Constants
const $5922717f55943bb5$var$EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $5922717f55943bb5$var$FORM_CONFIG = {
    locale: "US-CA",
    site: "atlassian"
};
// Helper function
const $5922717f55943bb5$var$isValidEmail = (email)=>{
    return $5922717f55943bb5$var$EMAIL_REGEX.test(email);
};
// Format english date with suffixes
const $5922717f55943bb5$var$getOrdinalSuffix = (day, locale)=>{
    if (locale.startsWith("en")) {
        if (day > 3 && day < 21) return "th";
        switch(day % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }
    return "";
};
const $5922717f55943bb5$var$formatDateWithIntl = (isoDate, locale)=>{
    try {
        const date = new Date(isoDate);
        const intlLocale = locale || "en-US";
        const month = new Intl.DateTimeFormat(intlLocale, {
            month: "long",
            timeZone: "UTC"
        }).format(date);
        const day = date.getUTCDate();
        const year = date.getUTCFullYear();
        const ordinal = $5922717f55943bb5$var$getOrdinalSuffix(day, intlLocale);
        return `${month} ${day}${ordinal}, ${year}`;
    } catch  {
        return isoDate;
    }
};
const $5922717f55943bb5$export$d9154e81ff5ef57d = (props)=>{
    const [email, setEmail] = (0, $1oC0p.useState)("");
    const [honeypot, setHoneypot] = (0, $1oC0p.useState)("");
    const [isSubmitted, setIsSubmitted] = (0, $1oC0p.useState)(false);
    const [isLoading, setIsLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)("");
    const bxpClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const intl = (0, $8e22h.default)();
    const { locale: locale } = (0, $7iwdN.useRoadmapFeaturesContext)();
    const lastUpdatedDate = $5922717f55943bb5$var$formatDateWithIntl(props.lastUpdated, locale);
    const handleSubmit = (0, $1oC0p.useCallback)(async (e)=>{
        e.preventDefault();
        // Honeypot check - silent return if bot
        if (honeypot) return;
        // Validate email
        if (!email || !$5922717f55943bb5$var$isValidEmail(email)) {
            setError(intl.formatMessage({
                id: "roadmapSubscription.error.invalidEmail",
                defaultMessage: "Enter a valid email address."
            }));
            return;
        }
        setIsLoading(true);
        setError("");
        try {
            if (!bxpClient?.updateConsentPreferences) throw new Error("Consent service unavailable");
            await bxpClient.updateConsentPreferences({
                locale: $5922717f55943bb5$var$FORM_CONFIG.locale,
                formId: props.formId,
                site: $5922717f55943bb5$var$FORM_CONFIG.site,
                email: email,
                formUrl: window.location.href,
                consentLabelText: "",
                privacyPolicyText: "",
                consentCheckboxValue: true
            });
            setIsSubmitted(true);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : intl.formatMessage({
                id: "roadmapSubscription.error.serverError",
                defaultMessage: "There was a server error submitting. Please try again."
            });
            setError(errorMessage);
        } finally{
            setIsLoading(false);
        }
    }, [
        email,
        honeypot,
        bxpClient
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "roadmap-subscription-form",
        className: (0, $2jatx.default)([
            "_6rthgktf _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1fra _kqswh2mm _ahbq1wug _12l21wug"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1n261g80 _zulp1ylp _4cvr1y6m"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _1e0c1txw _1bah1h6o _4cvr1fhb _1f49kb7n _xg5ucs5v _1u0vkb7n _xz68kb7n _jueshwvj _o3vb1fhb"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthd439 _1e0c1txw _2lx21bp4 _1bahesu3 _4t3i1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: props.formImage.src,
                                    alt: props.formImage.alt
                                },
                                style: {
                                    width: "100%",
                                    height: "auto",
                                    maxHeight: "100%"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1ogm _1e0c1txw _2lx21bp4 _zulpgktf _1f49cs5v _xg5ukb7n _1u0vkb7n _xz68kb7n _jues1ssb"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulpftgi _1n261g80"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                                        text: intl.formatMessage({
                                            id: "roadmapSubscription.lastUpdated",
                                            defaultMessage: "Last Updated"
                                        }),
                                        appearance: "purple"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8"
                                        ]),
                                        children: [
                                            "\xa0",
                                            lastUpdatedDate
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_1wybckbl _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz4cjiy"
                                ]),
                                children: props.heading
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1wyb7vkz _vwz4yu22 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: props.description
                            }),
                            !isSubmitted ? /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                                onSubmit: handleSubmit,
                                noValidate: true,
                                "aria-label": intl.formatMessage({
                                    id: "roadmapSubscription.form.ariaLabel",
                                    defaultMessage: "Roadmap subscription form"
                                }),
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulp1crf _p12fdgin"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                        htmlFor: "email-subscription",
                                        className: (0, $2jatx.default)([
                                            "_1wybdlk8 _k48pni7l _1e0c1ule"
                                        ]),
                                        children: intl.formatMessage({
                                            id: "roadmapSubscription.emailLabel",
                                            defaultMessage: "Your company email"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulp1crf _4cvr1fhb"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                type: "email",
                                                name: "email",
                                                id: "email-subscription",
                                                value: email,
                                                onChange: (e)=>setEmail(e.target.value),
                                                required: true,
                                                disabled: isLoading,
                                                "aria-invalid": !!error,
                                                "aria-describedby": error ? "email-error" : undefined,
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _ca0q19bv _u5f31crf _n3td19bv _19bv1crf _1wybdlk8 _19it1hn0 _2rko1y44 _12ji1r31 _1qu2glyw _12y31o36 _858u17la _7ehikpqy"
                                                ]),
                                                style: {
                                                    "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                                type: "submit",
                                                variant: "primary",
                                                size: "large",
                                                isDisabled: isLoading,
                                                isLoading: isLoading,
                                                dataEventProps: {
                                                    "data-product-key": "roadmap",
                                                    "data-event": "clicked",
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "form",
                                                    "data-label": "subscribeButton"
                                                },
                                                className: (0, $2jatx.default)([
                                                    "_ca0q19bv _u5f31tcg _n3td19bv _19bv1tcg _1wyb7vkz _k48pni7l _syazcd5j _bfhk17la _19itglyw _2rko1y44 _80omtlke _v564z97a _o5721q9c _m45j17la _wa112nsj _1j551ck0 _j5dh13gf"
                                                ]),
                                                style: {
                                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                },
                                                children: intl.formatMessage({
                                                    id: "roadmapSubscription.button.subscribe",
                                                    defaultMessage: "Subscribe"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswstnw _1e02xq2a _1bsbt94y _4t3it94y _1reo15vq _18m915vq"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                            type: "text",
                                            name: "list_name",
                                            "aria-label": intl.formatMessage({
                                                id: "roadmapSubscription.honeypot.ariaLabel",
                                                defaultMessage: "Keep this field blank"
                                            }),
                                            value: honeypot,
                                            onChange: (e)=>setHoneypot(e.target.value),
                                            tabIndex: -1
                                        })
                                    }),
                                    error && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        id: "email-error",
                                        role: "alert",
                                        className: (0, $2jatx.default)([
                                            "_syaz1uxz _1wybdlk8 _1pfhftgi"
                                        ]),
                                        style: {
                                            "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red"))
                                        },
                                        children: error
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                role: "status",
                                "aria-live": "polite",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulp1crf _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rko1y44"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $OKl9V.Icon), {
                                        name: "checkmarkcircle",
                                        size: "small",
                                        color: "var(--ds-icon-success, #6A9A23)"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb7vkz"
                                        ]),
                                        children: intl.formatMessage({
                                            id: "roadmapSubscription.success.message",
                                            defaultMessage: "Thanks for subscribing!"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "status",
                                "aria-live": "polite",
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulp1crf _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rko1y44"
                                ])
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $5922717f55943bb5$var$parentContainerStyle = null;
const $5922717f55943bb5$var$containerStyle = null;
const $5922717f55943bb5$var$rowStyle = null;
const $5922717f55943bb5$var$leftColumnStyle = null;
const $5922717f55943bb5$var$rightColumnStyle = null;
const $5922717f55943bb5$var$lastUpdatedContainerStyle = null;
const $5922717f55943bb5$var$dateTextStyle = null;
const $5922717f55943bb5$var$headingStyle = null;
const $5922717f55943bb5$var$descriptionStyle = null;
const $5922717f55943bb5$var$formStyle = null;
const $5922717f55943bb5$var$labelStyle = null;
const $5922717f55943bb5$var$emailInputContainerStyle = null;
const $5922717f55943bb5$var$emailInputStyle = null;
const $5922717f55943bb5$var$honeypotStyle = null;
const $5922717f55943bb5$var$submitButtonStyle = null;
const $5922717f55943bb5$var$errorStyle = null;
const $5922717f55943bb5$var$successMessageContainerStyle = null;
const $5922717f55943bb5$var$successMessageTextStyle = null;
const $5922717f55943bb5$var$imageContainerStyle = null;

});


parcelRegister("8zfxq", function(module, exports) {
$parcel$export(module.exports, "DataCenterRoadmapSubscriptionForm", function () { return $d8b41fff14bc5e04$export$e25b0a8474e430cf; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $6nmH5 = parcelRequire("6nmH5");
const $d8b41fff14bc5e04$export$e25b0a8474e430cf = (props)=>{
    const { lastUpdated: lastUpdated } = props;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nmH5.RoadmapSubscriptionForm), {
        lastUpdated: lastUpdated,
        formId: "16f4d97b-db1e-49ba-9edd-61a5ae678459",
        formImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2nl3q4f4uqjjnr853405jk53476o6r8r.png",
            alt: intl.formatMessage({
                id: "roadmapSubscription.data-center.image.alt",
                defaultMessage: "Data Center Roadmap"
            })
        },
        heading: intl.formatMessage({
            id: "roadmapSubscription.data-center.heading",
            defaultMessage: "Data Center Roadmap"
        }),
        description: intl.formatMessage({
            id: "roadmapSubscription.data-center.description",
            defaultMessage: "Check out the latest features in Data Center and learn about what we\u2019re working on. Subscribe to receive an email each quarter highlighting our newly released features, updated time frames, and more."
        })
    });
};

});

parcelRegister("fboYQ", function(module, exports) {
$parcel$export(module.exports, "useQuery", function () { return $e0787dfb3b69a913$export$dd0a697e1782aedd; });

var $1oC0p = parcelRequire("1oC0p");

var $hoxx0 = parcelRequire("hoxx0");
function $e0787dfb3b69a913$export$dd0a697e1782aedd(props) {
    const { locale: locale, roadmapName: roadmapName } = props;
    const [result, setResult] = (0, $1oC0p.useState)(undefined);
    const [pending, setPending] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        setPending(true);
        (0, $hoxx0.getRoadmapFeatures)({
            locale: locale,
            limit: (0, $hoxx0.ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE),
            roadmapName: roadmapName
        }).then(setResult).finally(()=>{
            setPending(false);
        });
    }, []);
    return {
        result: result,
        pending: pending
    };
}

});

parcelRegister("1xzPJ", function(module, exports) {
$parcel$export(module.exports, "Cards", function () { return $798cc825a6441e0c$export$c8d38e0dcc0f5a1; });
/* cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2LBZM = parcelRequire("2LBZM");

var $20kWR = parcelRequire("20kWR");

var $i2afm = parcelRequire("i2afm");
const $798cc825a6441e0c$export$c8d38e0dcc0f5a1 = ()=>{
    const intl = (0, $8e22h.default)();
    const features = (0, $2LBZM.useFilteredAndSortedRoadmapFeatures)();
    if (!features) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1ejb"
                ]),
                children: features.length === 0 ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bah1h6o _4cvr1h6o _1yt4oahv _syazazsu"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        children: intl.formatMessage({
                            id: "roadmapFeatures.noResults",
                            defaultMessage: "No Results"
                        })
                    })
                }) : features.map((data)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $20kWR.Card), {
                        data: data
                    }, data.slug))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i2afm.SelectedFeatureModal), {})
        ]
    });
};
const $798cc825a6441e0c$var$cardsCss = null;
const $798cc825a6441e0c$var$noResultsCss = null;

});
parcelRegister("20kWR", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $66d70741ba057020$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $iPPTB = parcelRequire("iPPTB");

var $jE3Ci = parcelRequire("jE3Ci");

var $bNzAT = parcelRequire("bNzAT");

var $2LBZM = parcelRequire("2LBZM");

var $8xJXU = parcelRequire("8xJXU");

var $5M3ad = parcelRequire("5M3ad");
const $66d70741ba057020$export$60332b2344f7fe41 = (props)=>{
    const { data: data } = props;
    const intl = (0, $8e22h.default)();
    const learnMoreLabel = intl.formatMessage({
        id: "roadmapFeatures.learnMore",
        defaultMessage: "Learn more"
    });
    const setSelectedFeature = (0, $2LBZM.useSetSelectedFeature)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (0, $1oC0p.useCallback)(()=>{
        setSelectedFeature({
            slug: data.slug,
            pid: data.pid
        });
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "card",
            actionSubjectId: "roadmapFeatureCard",
            source: "roadmap",
            attributes: {
                label: data.title,
                slug: data.slug
            }
        }).fire();
    }, [
        setSelectedFeature,
        createAnalyticsEvent,
        data.slug,
        data.pid,
        data.title
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleClick();
        }
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        role: "button",
        tabIndex: 0,
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c11p5 _yv0e1kd1 _2z051wug _zulp1e2i _4cvrv2br _1bahv2br _1yt41ejb _19ityzqy _bfhkcd5j _2rkovwyg _80omtlke _vchhusvi _v564slvs _o7ks1kw8 _1dbz130s _1mjb1txw _na0i1bp4 _2osnutpp"
        ]),
        style: {
            "--_r91gx3": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.light400")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.light0")),
            "--_19sjjnh": (0, $6ZVlx.default)((0, $bNzAT.default)("corner.radius.card"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rthutpp"
                        ]),
                        children: data.title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_6rthutpp"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8xJXU.FeatureDescription), {
                            content: data.description
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            text: learnMoreLabel,
                            "aria-label": learnMoreLabel,
                            href: data.slug,
                            type: "primary",
                            isStyleOnly: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: data.category.roadmapCategoryNameExternal
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq",
                    "_1pfhyh40"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5M3ad.StatusLozenge), {
                    text: data.status.roadmapStatusNameExternal
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq"
                ]),
                children: data.timeFrame
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h _1af81osq",
                    "_1pfhyh40",
                    "_1e0c1txw _1n261g80 _zulp1b66"
                ]),
                children: data.appsCollection.items.map((app)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                        text: app.roadmapAppNameExternal,
                        appearance: "neutral"
                    }, app.filterQueryParam))
            })
        ]
    });
};
const $66d70741ba057020$var$cardRowCss = null;
const $66d70741ba057020$var$cellCss = null;
const $66d70741ba057020$var$titleCss = null;
const $66d70741ba057020$var$descriptionCss = null;
const $66d70741ba057020$var$lozengeCellCss = null;
const $66d70741ba057020$var$appsCell = null;

});
parcelRegister("8xJXU", function(module, exports) {
$parcel$export(module.exports, "FeatureDescription", function () { return $d9c1fa5ed5ffbd36$export$4f8b226fdcec19c2; });

var $7VQPk = parcelRequire("7VQPk");

var $gA8LO = parcelRequire("gA8LO");

var $lTkkF = parcelRequire("lTkkF");
const $d9c1fa5ed5ffbd36$export$4f8b226fdcec19c2 = (props)=>{
    const html = (0, $gA8LO.documentToHtmlString)(props.content.json);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
        text: html
    });
};

});

parcelRegister("5M3ad", function(module, exports) {
$parcel$export(module.exports, "StatusLozenge", function () { return $db082f33ca913662$export$f72db4ad1e9b3e6d; });

var $7VQPk = parcelRequire("7VQPk");

var $jE3Ci = parcelRequire("jE3Ci");
const $db082f33ca913662$export$f72db4ad1e9b3e6d = (props)=>{
    const statusColor = $db082f33ca913662$var$getStatusColor(props.text.toLowerCase());
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
        text: props.text,
        appearance: statusColor
    });
};
const $db082f33ca913662$var$getStatusColor = (status)=>{
    let statusColor = "neutral";
    if (status === "future") statusColor = "purple";
    if (status === "coming soon") statusColor = "saffron";
    if (status === "released") statusColor = "lime";
    if (status === "completed") statusColor = "neutral";
    return statusColor;
};

});


parcelRegister("i2afm", function(module, exports) {
$parcel$export(module.exports, "SelectedFeatureModal", function () { return $c3c189e8679067b6$export$ef9ca2eb313283f6; });
/* selected-feature-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $660KI = parcelRequire("660KI");

var $kbpa7 = parcelRequire("kbpa7");

var $2LBZM = parcelRequire("2LBZM");

var $8xJXU = parcelRequire("8xJXU");

var $5M3ad = parcelRequire("5M3ad");
const $c3c189e8679067b6$var$PRIMARY_BLACK = (0, $kbpa7.wacToken)("color.primary.black");
const $c3c189e8679067b6$var$NEUTRAL_LIGHT = (0, $kbpa7.wacToken)("color.neutral.dark800");
const $c3c189e8679067b6$export$ef9ca2eb313283f6 = ()=>{
    const selectedFeature = (0, $2LBZM.useSelectedFeatureData)();
    const clearSelectedFeature = (0, $2LBZM.useClearSelectedFeature)();
    const [isCopied, setIsCopied] = (0, $1oC0p.useState)(false);
    const intl = (0, $8e22h.default)();
    /**
   * NOTE: We cannot use className="eyebrow-lg" and className="h4" here because:
   *
   * 1. The Modal component wraps the title prop in <p className="card-title">, which creates
   *    invalid HTML nesting when we pass a fragment with <p> and <h4> elements. Browsers
   *    auto-correct this invalid structure, which breaks CSS selector matching.
   *
   * 2. When using both className and css prop together, Compiled CSS may not properly merge
   *    the styles. The css prop styles can override or interfere with className-based styles
   *    from TypographyStyles, even when they don't explicitly conflict.
   *
   * 3. CSS specificity issues: The parent .card-title class combined with how Compiled CSS
   *    generates atomic CSS classes can cause the TypographyStyles className selectors to
   *    not match correctly in this nested context.
   *
   * Therefore, we manually apply the eyebrow-lg and h4 styles via the css prop to ensure
   * they work correctly. These styles match the definitions in typography-styles.tsx.
   */ const header = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_ect4bzd7 _k48p1fw0 _1wyb1j6v _vwz41k8s _1p1dangw _syazpu0n _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rthu2gc"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                    "--_1m80sa1": (0, $6ZVlx.default)($c3c189e8679067b6$var$NEUTRAL_LIGHT)
                },
                children: selectedFeature?.category.roadmapCategoryNameExternal
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_ect41pz4 _k48p1fw0 _syazqgwi _1wyb1k92 _vwz41slo _1lzoimiu _119z1m1q _3p1c1k8s _py5ol07h _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                    "--_1t10uu9": (0, $6ZVlx.default)($c3c189e8679067b6$var$PRIMARY_BLACK)
                },
                children: selectedFeature?.title
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $660KI.Modal), {
        isOpen: !!selectedFeature,
        closeModal: clearSelectedFeature,
        title: header,
        width: "medium",
        closeLabel: intl.formatMessage({
            id: "SelectedFeatureModal.close",
            defaultMessage: "Close"
        }),
        children: selectedFeature && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8xJXU.FeatureDescription), {
                    content: selectedFeature.description
                }),
                selectedFeature.relatedLinksCollection?.items && selectedFeature.relatedLinksCollection.items.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhpxbi _6rthpxbi"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulpu2gc"
                        ]),
                        children: selectedFeature.relatedLinksCollection.items.map((link, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    text: link.ctaButtonText,
                                    href: link.ctaUrl,
                                    type: "primary",
                                    "aria-label": link.ctaButtonText,
                                    dataEventProps: {
                                        "data-product-key": "roadmap",
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "modal"
                                    }
                                })
                            }, index))
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                    htmlFor: "shareable-url-input",
                                    children: intl.formatMessage({
                                        id: "SelectedFeatureModal.share",
                                        defaultMessage: "Share this update:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _zulppxbi _4cvr1h6o"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                            id: "shareable-url-input",
                                            readOnly: true,
                                            value: $c3c189e8679067b6$var$getShareableUrl(),
                                            className: (0, $2jatx.default)([
                                                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _4t3ixy5q _19it1mpr _2rko1mok _1yt4h8dc _kqswh2mm _152t1l04"
                                            ]),
                                            style: {
                                                "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                            size: "small",
                                            onClick: ()=>{
                                                navigator.clipboard.writeText($c3c189e8679067b6$var$getShareableUrl());
                                                setIsCopied(true);
                                                setTimeout(()=>{
                                                    setIsCopied(false);
                                                }, 2000);
                                            },
                                            dataEventProps: {
                                                "data-product-key": "roadmap",
                                                "data-event": "clicked",
                                                "data-event-component": "button",
                                                "data-event-container": "modal"
                                            },
                                            children: isCopied ? intl.formatMessage({
                                                id: "SelectedFeatureModal.linkCopied",
                                                defaultMessage: "Link Copied"
                                            }) : intl.formatMessage({
                                                id: "SelectedFeatureModal.copyLink",
                                                defaultMessage: "Copy link"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _zulp1y44"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5M3ad.StatusLozenge), {
                                    text: selectedFeature.status.roadmapStatusNameExternal
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    children: selectedFeature.timeFrame
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                intl.formatMessage({
                                    id: "SelectedFeatureModal.availableIn",
                                    defaultMessage: "This update is available in:"
                                }),
                                "\xa0",
                                selectedFeature.appsCollection.items.map((item)=>item.roadmapAppNameExternal).join(", ")
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
function $c3c189e8679067b6$var$getShareableUrl() {
    return window.location.href;
}

});


parcelRegister("cwkIh", function(module, exports) {
$parcel$export(module.exports, "ColumnHeaders", function () { return $b36c734c8491a922$export$945861bc4c775e51; });
/* column-headers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $2LBZM = parcelRequire("2LBZM");

var $1OYBO = parcelRequire("1OYBO");
const $b36c734c8491a922$export$42bd9088661ffb03 = "minmax(0, 4fr) minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2.1fr)";
const $b36c734c8491a922$export$945861bc4c775e51 = ()=>{
    const intl = (0, $8e22h.default)();
    const titleSortProps = (0, $2LBZM.useSort)("title");
    const categorySortProps = (0, $2LBZM.useSort)("category");
    const statusSortProps = (0, $2LBZM.useSort)("status");
    const timeFrameSortProps = (0, $2LBZM.useSort)("timeFrame");
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c11p5 _yv0e1kd1 _2z051wug _zulp1e2i _4cvr1h6o _1bahv2br _1yt4vu7j _179ryzqy _syaz1sqi _1wyb1crf _y3gn1e5h _vchhusvi _1mjbglyw"
        ]),
        style: {
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                ...titleSortProps,
                sortable: true,
                label: intl.formatMessage({
                    id: "roadmapFeatures.update",
                    defaultMessage: "Update"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                ...categorySortProps,
                sortable: true,
                label: intl.formatMessage({
                    id: "roadmapFeatures.category",
                    defaultMessage: "Category"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                ...statusSortProps,
                sortable: true,
                label: intl.formatMessage({
                    id: "roadmapFeatures.status",
                    defaultMessage: "Status"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                ...timeFrameSortProps,
                sortable: true,
                label: intl.formatMessage({
                    id: "roadmapFeatures.time",
                    defaultMessage: "Time"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OYBO.ColumnHeader), {
                sortable: false,
                label: intl.formatMessage({
                    id: "roadmapFeatures.apps",
                    defaultMessage: "Apps"
                })
            })
        ]
    });
};
const $b36c734c8491a922$var$headerRowCss = null;

});
parcelRegister("1OYBO", function(module, exports) {
$parcel$export(module.exports, "ColumnHeader", function () { return $80d006960efe257e$export$5667c09b71ee0f05; });
/* column-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eY3N6 = parcelRequire("eY3N6");
const $80d006960efe257e$export$5667c09b71ee0f05 = (props)=>{
    const { label: label, sortable: sortable, sortDirection: sortDirection, onClick: onClick } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const sortSymbol = sortDirection === "asc" ? "\u2191" : sortDirection === "desc" ? "\u2193" : "";
    const handleClick = ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "sortColumn",
            source: "roadmapFeatures",
            attributes: {
                label: label,
                sortDirection: sortDirection
            }
        }).fire();
        onClick?.();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_k48pni7l _o5721q9c _y3gn1e5h _1e0c116y _4cvr1h6o _zulp1y44"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
            type: "button",
            onClick: handleClick,
            className: (0, $2jatx.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _11q7glyw _1e0c116y _4cvr1h6o _zulp1y44 _11c81kw7 _syaz1kw7 _80omtlke _d0altlke"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_vwz4cjiy _1wyb7vkz"
                    ]),
                    children: label
                }),
                sortable && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _4cvr1h6o _1bah1h6o _1bsb1crf _4t3i1crf _1wyb7vkz"
                    ]),
                    children: sortSymbol ?? /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1e0c1o8l _1bsbftgi _4t3iftgi"
                        ])
                    })
                })
            ]
        })
    });
};
const $80d006960efe257e$var$headerCellCss = null;
const $80d006960efe257e$var$labelTextCss = null;
const $80d006960efe257e$var$headerButtonCss = null;
const $80d006960efe257e$var$sortIconWrapperCss = null;
const $80d006960efe257e$var$sortIconPlaceholderCss = null;

});


parcelRegister("l5Cys", function(module, exports) {
$parcel$export(module.exports, "Layout", function () { return $ba7cbf8f19b1a13e$export$c84671f46d6a1ca; });
/* layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $ba7cbf8f19b1a13e$export$c84671f46d6a1ca = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c11p5 _2z051wug _1p571ejb _19pkidpf _2hwx1wug _otyridpf _18u01wug _vchhusvi"
        ]),
        children: [
            props.columnHeaders,
            props.cards
        ]
    });
};
const $ba7cbf8f19b1a13e$var$layoutCss = null;

});

parcelRegister("gBTmU", function(module, exports) {
$parcel$export(module.exports, "RoadmapSubNav", function () { return $01679870f9c69967$export$4202a6ef24dd93ce; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $jIii1 = parcelRequire("jIii1");
const $01679870f9c69967$export$4202a6ef24dd93ce = ({ className: className })=>{
    const intl = (0, $8e22h.default)();
    const ROADMAP_NAV_CONFIG = {
        heading: {
            label: intl.formatMessage({
                id: "roadmapSubNav.heading",
                defaultMessage: "Roadmaps"
            }),
            linkUrl: (0, $jQ0cd.useLocalizedHref)("/roadmap/cloud")
        },
        navItems: [
            {
                label: intl.formatMessage({
                    id: "roadmapSubNav.cloud",
                    defaultMessage: "Cloud"
                }),
                linkUrl: (0, $jQ0cd.useLocalizedHref)("/roadmap/cloud")
            },
            {
                label: intl.formatMessage({
                    id: "roadmapSubNav.dataCenter",
                    defaultMessage: "Data Center"
                }),
                linkUrl: (0, $jQ0cd.useLocalizedHref)("/roadmap/data-center")
            }
        ],
        cta: {
            label: intl.formatMessage({
                id: "roadmapSubNav.exploreMigration",
                defaultMessage: "Explore how to migrate"
            }),
            linkUrl: "/migration"
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jIii1.SubNav), {
        headingLabel: ROADMAP_NAV_CONFIG.heading.label,
        headingLinkUrl: ROADMAP_NAV_CONFIG.heading.linkUrl,
        navItems: ROADMAP_NAV_CONFIG.navItems.map((item)=>({
                label: item.label,
                linkUrl: item.linkUrl
            })),
        cta: {
            label: ROADMAP_NAV_CONFIG.cta.label,
            linkUrl: ROADMAP_NAV_CONFIG.cta.linkUrl
        },
        className: className
    });
};
$01679870f9c69967$export$4202a6ef24dd93ce.displayName = "RoadmapSubNav";

});
parcelRegister("jIii1", function(module, exports) {
$parcel$export(module.exports, "SubNav", function () { return $ef3257635b4117cf$export$4a51633636d7017c; });
/* subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $5RBBI = parcelRequire("5RBBI");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $ef3257635b4117cf$var$NAV_HEIGHT = 68;
const $ef3257635b4117cf$var$subNavContainerCss = null;
const $ef3257635b4117cf$var$subNavWrapperCss = null;
const $ef3257635b4117cf$var$subNavWrapperAtTopCss = null;
const $ef3257635b4117cf$var$subNavInnerCss = null;
const $ef3257635b4117cf$var$headingLinkCss = null;
const $ef3257635b4117cf$var$desktopNavCss = null;
const $ef3257635b4117cf$var$navListCss = null;
const $ef3257635b4117cf$var$navItemLinkCss = null;
const $ef3257635b4117cf$var$navItemLinkActiveCss = null;
const $ef3257635b4117cf$var$mobileNavCss = null;
const $ef3257635b4117cf$var$mobileDropdownButtonCss = null;
const $ef3257635b4117cf$var$chevronIconCss = null;
const $ef3257635b4117cf$var$chevronIconRotatedCss = null;
const $ef3257635b4117cf$var$mobileDropdownCss = null;
const $ef3257635b4117cf$var$mobileDropdownListCss = null;
const $ef3257635b4117cf$var$mobileDropdownItemCss = null;
const $ef3257635b4117cf$var$mobileDropdownLinkCss = null;
const $ef3257635b4117cf$var$mobileDropdownLinkActiveCss = null;
const $ef3257635b4117cf$var$mobileCTACss = null;
const $ef3257635b4117cf$var$isLinkActive = (linkUrl)=>{
    if (typeof window === "undefined") return false;
    const currentPath = window.location.pathname;
    const linkPath = new URL(linkUrl, window.location.origin).pathname;
    return currentPath === linkPath || currentPath.startsWith(linkPath + "/");
};
const $ef3257635b4117cf$var$useSubNavAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const fireNavLinkClicked = (0, $1oC0p.useCallback)((label, container)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "subNavLink",
            source: container,
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireMobileDropdownClicked = (0, $1oC0p.useCallback)((isOpen)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "mobileDropdown",
            source: "roadmapSubnav",
            attributes: {
                action: isOpen ? "close" : "open"
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireNavLinkClicked: fireNavLinkClicked,
        fireMobileDropdownClicked: fireMobileDropdownClicked
    };
};
const $ef3257635b4117cf$export$4a51633636d7017c = ({ headingLabel: headingLabel, headingLinkUrl: headingLinkUrl, navItems: navItems, cta: cta, className: className })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $1oC0p.useState)(false);
    const [isAtTop, setIsAtTop] = (0, $1oC0p.useState)(false);
    const dropdownId = (0, $1oC0p.useId)();
    const { fireNavLinkClicked: fireNavLinkClicked, fireMobileDropdownClicked: fireMobileDropdownClicked } = $ef3257635b4117cf$var$useSubNavAnalytics();
    const navRef = (0, $1oC0p.useRef)(null);
    const containerRef = (0, $1oC0p.useRef)(null);
    // handle z-index based on scroll position
    // when scrolled >= 68px (nav height), subnav overlaps nav, so set z-index to 10
    (0, $1oC0p.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollY = window.scrollY || window.pageYOffset;
            setIsAtTop(scrollY >= $ef3257635b4117cf$var$NAV_HEIGHT);
        };
        // check initial scroll position
        handleScroll();
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const toggleDropdown = (0, $1oC0p.useCallback)(()=>{
        setIsDropdownOpen((prev)=>{
            fireMobileDropdownClicked(prev);
            return !prev;
        });
    }, [
        fireMobileDropdownClicked
    ]);
    const closeDropdown = (0, $1oC0p.useCallback)(()=>{
        setIsDropdownOpen(false);
    }, []);
    const handleDropdownKeyDown = (0, $1oC0p.useCallback)((event)=>{
        if (event.key === "Escape" && isDropdownOpen) setIsDropdownOpen(false);
    }, [
        isDropdownOpen
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_152tidpf _kqsw1if8 _1pfh1cg9 _1bsb1osq _1pbykb7n",
            isAtTop && "_1pbyzo7u",
            className
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            ref: navRef,
            role: "navigation",
            "aria-label": `${headingLabel} navigation`,
            className: (0, $2jatx.default)([
                "_kqsw1if8 _152tidpf _1bsb1osq _bfhkcd5j _v564guk9 _1pbykb7n _ahbq1vh9 _3l1aidpf _161bidpf"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _4t3ivbgk _p12f1fra _195g1wug _1pbykb7n _12l21stb _161bidpf _165tt9kd _pdlm1ejb"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: headingLinkUrl,
                            "data-testid": "subnav-heading-link",
                            onClick: ()=>fireNavLinkClicked(headingLabel, "roadmap"),
                            className: (0, $2jatx.default)([
                                "_syaz1hlo _4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41pz4 _1wyb1k92 _k48pni7l _vwz4cjiy _1o9zidpf _30l31ep1 _1ygb8djs _1ah3v77o _1baslb4i _3p1c1k8s"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800")),
                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                            },
                            children: headingLabel
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0cglyw _dm251txw _1jsv1h6o _glte1osq _msup1yb4 _pdlmxy5q"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                    role: "list",
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulp1ejb _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                    ]),
                                    children: navItems.map((item, index)=>{
                                        const isActive = $ef3257635b4117cf$var$isLinkActive(item.linkUrl);
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                href: item.linkUrl,
                                                "data-testid": `subnav-item-${index}`,
                                                "aria-current": isActive ? "page" : undefined,
                                                onClick: ()=>fireNavLinkClicked(item.label, "roadmapSubnav"),
                                                className: (0, $2jatx.default)([
                                                    "_syaz1hlo _4bfu1r31 _1hmsglyw _ajmmnqa1 _ect4bzd7 _1wyb1j6v _k48pbfng _1yt4hyhw _2rkolb4i _v564h5h4 _30l31ep1 _1ygb8djs _1ah3v77o",
                                                    isActive && "_syaz1ep1 _k48pni7l _179r5gue _2rkoidpf"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800")),
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                },
                                                children: item.label
                                            })
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "secondary",
                                    href: cta.linkUrl,
                                    "data-testid": "subnav-cta",
                                    dataEventProps: {
                                        "data-product-key": "roadmap",
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "roadmapSubnav"
                                    },
                                    children: cta.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _zulppxbi _1bsb1osq _1bah1yb4 _kqsw1if8 _152tidpf _dm25glyw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: toggleDropdown,
                                    onKeyDown: handleDropdownKeyDown,
                                    "aria-expanded": isDropdownOpen,
                                    "aria-controls": dropdownId,
                                    "aria-haspopup": "true",
                                    "data-testid": "subnav-mobile-dropdown-button",
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulpu2gc _bfhk1j28 _19itglyw _80omtlke _ect4bzd7 _1wyboxwj _k48pbfng _syaz1hlo _1yt41bs6 _2rkolb4i _irr3150w _1ygb8djs _1ah3v77o"
                                    ]),
                                    style: {
                                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                        "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_v564kete",
                                            isDropdownOpen && "_t9ec1sub"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                                            label: isDropdownOpen ? "Close navigation menu" : "Open navigation menu",
                                            color: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    variant: "secondary",
                                    href: cta.linkUrl,
                                    "data-testid": "subnav-mobile-cta",
                                    dataEventProps: {
                                        "data-product-key": "roadmap",
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "roadmapSubnav"
                                    },
                                    className: (0, $2jatx.default)([
                                        "_bfhkcd5j"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                    },
                                    children: cta.label
                                })
                            ]
                        })
                    ]
                }),
                isDropdownOpen && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    id: dropdownId,
                    "data-testid": "subnav-mobile-dropdown",
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152t1osq _1e02idpf _rjxpidpf _bfhkcd5j _179r1k0a _1pbyqfx8 _dm25glyw"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        role: "list",
                        className: (0, $2jatx.default)([
                            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                        ]),
                        children: navItems.map((item, index)=>{
                            const isActive = $ef3257635b4117cf$var$isLinkActive(item.linkUrl);
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_179r5y0l _8gg5glyw"
                                ]),
                                style: {
                                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: item.linkUrl,
                                    onClick: closeDropdown,
                                    "data-testid": `subnav-mobile-item-${index}`,
                                    "aria-current": isActive ? "page" : undefined,
                                    className: (0, $2jatx.default)([
                                        "_1e0c1ule _syaz1hlo _4bfu1r31 _1hmsglyw _ajmmnqa1 _ect4bzd7 _1wyb1j6v _k48pbfng _1yt4pxbi _irr31rga _30l31ep1 _1ygb8djs _1ah31i6y",
                                        isActive && "_bfhk150w _syaz1ep1 _k48pni7l"
                                    ]),
                                    style: {
                                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                        "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
                                        "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800")),
                                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                        "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                                    },
                                    children: item.label
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
$ef3257635b4117cf$export$4a51633636d7017c.displayName = "SubNav";

});



parcelRegister("6smfw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ead486866758e335$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $9mOHh = parcelRequire("9mOHh");
const $ead486866758e335$var$UniformRovoChatBox = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9mOHh.RovoChatBoxContainer), {});
};
var $ead486866758e335$export$2e2bcd8739ae039 = $ead486866758e335$var$UniformRovoChatBox;

});
parcelRegister("9mOHh", function(module, exports) {
$parcel$export(module.exports, "ChatHeader", function () { return $d988f9da35c79665$export$1263ff8fe28ec69f; });
$parcel$export(module.exports, "RovoChatBoxContainer", function () { return $d988f9da35c79665$export$acbe8b1c07595f91; });
/* chat.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2u2Jd = parcelRequire("2u2Jd");

var $eY3N6 = parcelRequire("eY3N6");

var $hLJF4 = parcelRequire("hLJF4");

var $iSeHD = parcelRequire("iSeHD");

var $5AtlP = parcelRequire("5AtlP");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $3riD8 = parcelRequire("3riD8");

var $9jvKE = parcelRequire("9jvKE");

var $ewaN9 = parcelRequire("ewaN9");

var $l9P27 = parcelRequire("l9P27");
const $d988f9da35c79665$var$sectionStyles = null;
const $d988f9da35c79665$var$chatHeaderContainerStyles = null;
const $d988f9da35c79665$var$rovoLoaderStyles = null;
const $d988f9da35c79665$var$h1Styles = null;
const $d988f9da35c79665$var$textfieldContainerStyles = null;
const $d988f9da35c79665$var$ctaButtonStyles = null;
const $d988f9da35c79665$var$disabledInteractionCss = null;
const $d988f9da35c79665$var$RovoPillButton = ({ isDisabled: isDisabled, onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const askRovoLabel = intl.formatMessage({
        id: "RovoChat.askRovo",
        defaultMessage: "Ask Rovo"
    });
    const tooltipContent = intl.formatMessage({
        id: "RovoChat.writePromptTooltip",
        defaultMessage: "Write a prompt"
    });
    const button = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        variant: "primary",
        size: "small",
        onClick: isDisabled ? undefined : onClick,
        dataEventProps: {
            "data-product-key": "rovo",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "rovoChatBox"
        },
        className: (0, $2jatx.default)([
            "_1tke1ylp",
            isDisabled && "_lcxvglyw _80om73ad"
        ]),
        children: askRovoLabel
    });
    // Only show tooltip when button is disabled (no text entered)
    if (isDisabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            style: {
                display: "inline-block"
            },
            children: button
        })
    });
    // No tooltip when button is enabled (user has typed something)
    return button;
};
const $d988f9da35c79665$var$inputStyles = null;
const $d988f9da35c79665$var$chatBoxContainerStyles = null;
const $d988f9da35c79665$var$getNamedHeader = (firstName)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "RovoChat.greeting",
        defaultMessage: "Hey {name},{br}let's get to work",
        values: {
            name: (0, $5AtlP.getFirstName)(firstName),
            br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
        }
    });
};
const $d988f9da35c79665$export$1263ff8fe28ec69f = ()=>{
    const { isUserLoggedIn: isUserLoggedIn, name: name } = (0, $3riD8.useLoggedInUser)();
    const firstName = (0, $5AtlP.getFirstName)(name ?? "");
    // If 'gwp-9000-new-rovo-video-hero' is enabled, <h1> shows the video; else, Rovo Chat Header uses <h1>.
    // Check feature flag at render time to allow tests to mock it properly
    const isNewRovoVideoHeroEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp9000NewRovoVideoHero);
    const getMessage = ()=>{
        if (isUserLoggedIn && firstName) return $d988f9da35c79665$var$getNamedHeader(firstName);
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "RovoChat.greeting",
            defaultMessage: "Hey there,{br}ready to get to work?",
            values: {
                br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
            }
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_p12fbxu3 _1bsb1osq _y3gn1h6o _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpa982 _1p57a982 _gy1pa982 _6rth1tcg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1j2z _4t3i1j2z _1ul914no _1tke14no _p12f14no _c71l14no _19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3 _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _1e0c1ule _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2u2Jd))), {
                    options: {
                        loop: true,
                        autoplay: true,
                        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($l9P27))),
                        rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                        }
                    },
                    height: 36,
                    width: 36
                })
            }),
            isNewRovoVideoHeroEnabled ? /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz48vuz _1wybckbl _k48p9y44"
                ]),
                children: getMessage()
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz48vuz _1wybckbl _k48p9y44"
                ]),
                children: getMessage()
            })
        ]
    });
};
const $d988f9da35c79665$export$e7a1e4b67bd87c97 = ({ textareaRef: externalRef, value: externalValue, onValueChange: onValueChange, previewValue: previewValue })=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const hasTrackedTyping = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(false);
    // Attribution for the productionized `gwp-8979-rovo-chat-on-wac` experiment.
    (0, $izdHQ.useFeatureExposed)("gwp-8979-rovo-chat-on-wac", "Test");
    const defaultPlaceholder = intl.formatMessage({
        id: "RovoChat.placeholder",
        defaultMessage: "Find something, plan something, or make something"
    });
    const placeholder = previewValue || defaultPlaceholder;
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(null);
    const textareaRef = externalRef || internalRef;
    const MAX_HEIGHT = 140; // keep in sync with inputStyles.maxHeight
    const resizeToContent = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(()=>{
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = "auto";
        const next = Math.min(el.scrollHeight, MAX_HEIGHT);
        el.style.height = `${next}px`;
    }, [
        textareaRef,
        MAX_HEIGHT
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(()=>{
        resizeToContent();
    }, [
        resizeToContent
    ]);
    const handleChange = ()=>{
        resizeToContent();
    };
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState("");
    const displayValue = externalValue ?? value;
    const fireTypingAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(()=>{
        if (!hasTrackedTyping.current && analyticsClient) {
            hasTrackedTyping.current = true;
            createAnalyticsEvent({
                product: "marketing",
                platform: "web",
                eventType: "ui",
                action: "typed",
                actionSubject: "textInput",
                actionSubjectId: "rovoChatBox",
                attributes: {
                    url: location.href
                }
            }).fire();
        }
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const handleClick = ()=>{
        const prompt = displayValue.trim();
        if (!prompt) return;
        // Fire analytics event for submission
        if (analyticsClient) createAnalyticsEvent({
            product: "marketing",
            platform: "web",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "rovoChatBox",
            attributes: {
                url: location.href,
                promptLength: prompt.length
            }
        }).fire();
        const chatUrl = new URL("https://home.atlassian.com/chat");
        chatUrl.searchParams.set("rovoChatPathway", "chat");
        chatUrl.searchParams.set("rovoChatPrompt", prompt);
        const loginUrl = `https://id.atlassian.com/login?continue=${encodeURIComponent(chatUrl.toString())}`;
        console.log("generated URL: ", loginUrl);
        window.location.assign(loginUrl);
    };
    const isButtonDisabled = !displayValue.trim();
    const handleKeyDown = (e)=>{
        // Submit on Enter (but allow Shift+Enter for new lines)
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleClick();
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1xup _2lx21bp4 _4cvr1fhb _zulputpp _vchhusvi _2rko1crf _19it1k0a _11q71j9a _16qs130s _1yt41s3g _1jj0utpp _14b5cv93 _1reo15vq _18m915vq"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("textarea", {
                ref: textareaRef,
                tabIndex: 0,
                placeholder: placeholder,
                maxLength: 1000,
                value: displayValue,
                onChange: (e)=>{
                    const newValue = e.target.value;
                    setValue(newValue);
                    onValueChange?.(newValue);
                    handleChange(e);
                    // Fire analytics event on first character typed
                    if (newValue.length > 0) fireTypingAnalytics();
                },
                onKeyDown: handleKeyDown,
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1tkegktf _c71l11ux _18m91wug _19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb7vkz _ect41kw7 _vwz4bs82 _slp31hna _1i4q1hna _o5721jtm _14zgglyw _nt751r31 _49pcglyw _1hvw1o36"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _1bahesu3 _1bsb1osq _zulpu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($d988f9da35c79665$var$RovoPillButton, {
                    isDisabled: isButtonDisabled,
                    onClick: handleClick
                })
            })
        ]
    });
};
const $d988f9da35c79665$export$acbe8b1c07595f91 = ()=>{
    const [chatValue, setChatValue] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState("");
    const [previewValue, setPreviewValue] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState("");
    const textareaRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(null);
    const handleColdStartButtonClick = (prompt)=>{
        setChatValue(prompt);
        setPreviewValue(""); // Clear preview when button is clicked
    };
    const handleColdStartButtonHover = (prompt)=>{
        // Only show preview if there's no current value
        if (!chatValue) setPreviewValue(prompt);
    };
    const handleColdStartButtonHoverEnd = ()=>{
        setPreviewValue("");
    };
    // Auto-focus textarea on mount
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(()=>{
        textareaRef.current?.focus({
            preventScroll: true
        });
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _p12fcv93 _1bsb1osq _zulpftgi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($d988f9da35c79665$export$e7a1e4b67bd87c97, {
                textareaRef: textareaRef,
                value: chatValue,
                onValueChange: setChatValue,
                previewValue: previewValue
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ewaN9.ColdStartButtonsRow), {
                onButtonClick: handleColdStartButtonClick,
                onButtonHover: handleColdStartButtonHover,
                onButtonHoverEnd: handleColdStartButtonHoverEnd
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9jvKE.AIFooter), {})
        ]
    });
};
const $d988f9da35c79665$export$9b4d0c63c2bc86a3 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($d988f9da35c79665$export$1263ff8fe28ec69f, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($d988f9da35c79665$export$acbe8b1c07595f91, {})
        ]
    });
};

});
parcelRegister("9jvKE", function(module, exports) {
$parcel$export(module.exports, "AIFooter", function () { return $dd34a5a7e0bde922$export$b209bc813a85fb1d; });
/* ai-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");

var $LlYs2 = parcelRequire("LlYs2");
const $dd34a5a7e0bde922$var$footerStyles = null;
const $dd34a5a7e0bde922$var$contentStyles = null;
const $dd34a5a7e0bde922$var$linkStyles = null;
const $dd34a5a7e0bde922$var$iconStyles = null;
const $dd34a5a7e0bde922$var$textStyles = null;
const $dd34a5a7e0bde922$export$b209bc813a85fb1d = ({ href: href = "https://www.atlassian.com/trust/atlassian-intelligence" })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _vchhusvi"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulp1y44 _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bah1h6o _4cvr1h6o _syazdgkc"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LlYs2))), {
                        label: "Information",
                        size: "small"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: (0, $2jatx.default)([
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_ect4ttxp _k48pi7a9 _1wyb1crf _vwz47vkz _syaz1rpy _1iqs1rm4 _zg8l4jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "RovoChat.usesAI",
                            defaultMessage: "Uses AI. Verify results."
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("ewaN9", function(module, exports) {
$parcel$export(module.exports, "ColdStartButtonsRow", function () { return $f3203383727f3391$export$f8e46ea9cdd11698; });
/* cold-starts-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $FI4AH = parcelRequire("FI4AH");

var $6zF1U = parcelRequire("6zF1U");

var $bZmYH = parcelRequire("bZmYH");

var $kbpa7 = parcelRequire("kbpa7");
const $f3203383727f3391$var$buttonStyles = null;
const $f3203383727f3391$var$iconStyles = null;
const $f3203383727f3391$var$textStyles = null;
const $f3203383727f3391$var$buttonsContainerStyles = null;
const $f3203383727f3391$export$b99f19cc0647223e = ({ icon: icon, buttonText: buttonText, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        onClick: onClick,
        type: "button",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulpi2wt _1yt4h8dc _2rko1y44 _19it1k0a _11q71rga _80omtlke _v5641gvb _1tkezwfg _19lc150w _4cvxnqye _1snt1rga _pojju4vp _1ygb8djs _1ah3yh40 _j6xtu4vp _q4ztnqye"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
            "--_1a8xanm": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light600")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4zeyy _k48p1nn1 _1wybdlk8 _vwz41yan _y3gn1h6o _syaz1yg0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _o5721q9c"
                ]),
                style: {
                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                },
                children: buttonText
            })
        ]
    });
};
const $f3203383727f3391$export$f8e46ea9cdd11698 = ({ onButtonClick: onButtonClick, onButtonHover: onButtonHover, onButtonHoverEnd: onButtonHoverEnd })=>{
    const intl = (0, $8e22h.default)();
    const coldStartButtons = [
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($FI4AH))), {
                label: "Chart trend up"
            }),
            labelId: "RovoChat.coldStart.stayUpToDate",
            label: intl.formatMessage({
                id: "RovoChat.coldStart.stayUpToDate",
                defaultMessage: "Stay up to date"
            }),
            prompt: intl.formatMessage({
                id: "RovoChat.coldStart.stayUpToDatePrompt",
                defaultMessage: "What's new this week that I should know about?"
            })
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                label: "Search"
            }),
            labelId: "RovoChat.coldStart.findInformation",
            label: intl.formatMessage({
                id: "RovoChat.coldStart.findInformation",
                defaultMessage: "Find information"
            }),
            prompt: intl.formatMessage({
                id: "RovoChat.coldStart.findInformationPrompt",
                defaultMessage: "Help me find information about [topic or process]"
            })
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zF1U))), {
                label: "Lightbulb"
            }),
            labelId: "RovoChat.coldStart.brainstormIdeas",
            label: intl.formatMessage({
                id: "RovoChat.coldStart.brainstormIdeas",
                defaultMessage: "Brainstorm ideas"
            }),
            prompt: intl.formatMessage({
                id: "RovoChat.coldStart.brainstormIdeasPrompt",
                defaultMessage: "Let's brainstorm ideas for [project, campaign, or topic]."
            })
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulpftgi _ca0q7vkz _u5f31crf _n3td7vkz _19bv1crf _1bsb1osq _1bah1h6o _1n261g80"
        ]),
        children: coldStartButtons.map((button)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                onMouseEnter: ()=>onButtonHover?.(button.prompt),
                onMouseLeave: ()=>onButtonHoverEnd?.(),
                onFocus: ()=>onButtonHover?.(button.prompt),
                onBlur: ()=>onButtonHoverEnd?.(),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($f3203383727f3391$export$b99f19cc0647223e, {
                    icon: button.icon,
                    buttonText: button.label,
                    onClick: ()=>onButtonClick?.(button.prompt)
                })
            }, button.labelId);
        })
    });
};

});

parcelRegister("l9P27", function(module, exports) {
module.exports = JSON.parse("{\"assets\":[{\"id\":\"58\",\"layers\":[{\"ind\":57,\"ty\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"rc\",\"p\":{\"a\":0,\"k\":[18.5,30]},\"r\":{\"a\":0,\"k\":0},\"s\":{\"a\":0,\"k\":[37,60]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,0]},\"o\":{\"a\":0,\"k\":0}}]},{\"ind\":0,\"ty\":4,\"ks\":{\"s\":{\"a\":0,\"k\":[133.33,133.33]}},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[1.67,-0.92],[0.04,-0.02],[0.41,-1.27],[0,-0.57],[0,0],[0,0],[0,0],[0,-2.55],[0,0],[0.23,-0.7],[0.03,-0.07],[0,0],[0,1.95],[0,0],[1.68,0.97],[0,0]],\"o\":[[-1.65,-0.95],[-0.03,0.02],[-1.18,0.69],[-0.16,0.52],[0,0],[0,0],[0,0],[2.21,1.27],[0,0],[0,0.75],[-0.02,0.07],[0,0],[1.69,-0.97],[0,0],[0,-1.94],[0,0],[0,0]],\"v\":[[8.5,0.73],[3.15,0.68],[3.05,0.74],[0.59,3.79],[0.34,5.44],[0.34,12.63],[7.12,16.54],[9.35,17.82],[12.92,24],[12.92,42.55],[12.57,44.73],[12.5,44.96],[24.59,37.98],[27.31,33.27],[27.31,14.71],[24.59,10.01],[21.5,8.23]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.31,0.32,0.35,1]},\"r\":2,\"o\":{\"a\":0,\"k\":100}},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]}]}]},{\"id\":\"61\",\"layers\":[{\"ind\":60,\"ty\":0,\"parent\":56,\"ks\":{},\"w\":37,\"h\":60,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"58\"},{\"ind\":56,\"ty\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[18.5,30]},\"p\":{\"a\":0,\"k\":[18.5,93]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"53\",\"layers\":[{\"ind\":6,\"ty\":4,\"parent\":5,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":5,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":8,\"ty\":4,\"parent\":7,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":7,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,912]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":10,\"ty\":4,\"parent\":9,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":9,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,684]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":12,\"ty\":4,\"parent\":11,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":11,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,456]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":14,\"ty\":4,\"parent\":13,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":13,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,228]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":16,\"ty\":4,\"parent\":15,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":15,\"ty\":3,\"parent\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":18,\"ty\":4,\"parent\":17,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":17,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1311]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":20,\"ty\":4,\"parent\":19,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":19,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1083]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":22,\"ty\":4,\"parent\":21,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":21,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,855]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":24,\"ty\":4,\"parent\":23,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":23,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,627]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":26,\"ty\":4,\"parent\":25,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":25,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,399]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":28,\"ty\":4,\"parent\":27,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":27,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,171]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":30,\"ty\":4,\"parent\":29,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":29,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1254]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":32,\"ty\":4,\"parent\":31,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":31,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1026]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":34,\"ty\":4,\"parent\":33,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":33,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,798]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":36,\"ty\":4,\"parent\":35,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":35,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,570]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":38,\"ty\":4,\"parent\":37,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":37,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,342]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":40,\"ty\":4,\"parent\":39,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":39,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,114]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":42,\"ty\":4,\"parent\":41,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":41,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1197]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":44,\"ty\":4,\"parent\":43,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":43,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,969]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":46,\"ty\":4,\"parent\":45,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":45,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,741]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":48,\"ty\":4,\"parent\":47,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":47,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,513]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":50,\"ty\":4,\"parent\":49,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":49,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,285]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":52,\"ty\":4,\"parent\":51,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":51,\"ty\":3,\"parent\":4,\"ks\":{\"p\":{\"a\":0,\"k\":[0,57]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":4,\"ty\":3,\"parent\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[28.5,700.5]},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[28.5,-439.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":192,\"s\":[28.5,-325.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":384,\"s\":[28.5,-211.5],\"h\":1}]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":3,\"ty\":3,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"120\",\"layers\":[{\"ind\":119,\"ty\":4,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"rc\",\"p\":{\"a\":0,\"k\":[18,30]},\"r\":{\"a\":0,\"k\":0},\"s\":{\"a\":0,\"k\":[36,60]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0,0,0]},\"o\":{\"a\":0,\"k\":0}}]},{\"ind\":0,\"ty\":4,\"ks\":{\"s\":{\"a\":0,\"k\":[133.33,133.33]}},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,-1.95],[0,0],[-1.68,-0.97],[0,0],[0,0],[-1.67,0.92],[-0.04,0.02],[-0.41,1.27],[0,0.57],[0,0],[0,0],[0,0],[0,2.55],[0,0],[-0.22,0.7],[-0.03,0.07]],\"o\":[[0,0],[-1.69,0.97],[0,0],[0,1.94],[0,0],[0,0],[1.66,0.95],[0.03,-0.02],[1.19,-0.68],[0.17,-0.52],[0,0],[0,0],[0,0],[-2.21,-1.27],[0,0],[0,-0.75],[0.03,-0.07],[0,0]],\"v\":[[14.81,0],[2.72,6.97],[0,11.68],[0,30.24],[2.73,34.95],[5.59,36.61],[18.8,44.23],[24.16,44.28],[24.26,44.21],[26.72,41.16],[26.98,39.52],[26.98,32.33],[19.98,28.3],[17.96,27.13],[14.39,20.96],[14.39,2.41],[14.73,0.23],[14.81,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.31,0.32,0.35,1]},\"r\":2,\"o\":{\"a\":0,\"k\":100}},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]},{\"ty\":\"tr\",\"o\":{\"a\":0,\"k\":100}}]}]}]},{\"id\":\"123\",\"layers\":[{\"ind\":122,\"ty\":0,\"parent\":118,\"ks\":{},\"w\":36,\"h\":60,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"120\"},{\"ind\":118,\"ty\":3,\"ks\":{\"a\":{\"a\":0,\"k\":[18,30]},\"p\":{\"a\":0,\"k\":[39,168.63]}},\"ip\":0,\"op\":385,\"st\":0}]},{\"id\":\"115\",\"layers\":[{\"ind\":68,\"ty\":4,\"parent\":67,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":67,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,57]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":70,\"ty\":4,\"parent\":69,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":69,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,285]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":72,\"ty\":4,\"parent\":71,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":71,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1197]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":74,\"ty\":4,\"parent\":73,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":73,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,969]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":76,\"ty\":4,\"parent\":75,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":75,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,741]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":78,\"ty\":4,\"parent\":77,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.988,0.655,0]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":77,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,513]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":80,\"ty\":4,\"parent\":79,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":79,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,114]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":82,\"ty\":4,\"parent\":81,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":81,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,342]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":84,\"ty\":4,\"parent\":83,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":83,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1254]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":86,\"ty\":4,\"parent\":85,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":85,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1026]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":88,\"ty\":4,\"parent\":87,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":87,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,798]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":90,\"ty\":4,\"parent\":89,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.094,0.408,0.859]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":89,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,570]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":92,\"ty\":4,\"parent\":91,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":91,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,171]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":94,\"ty\":4,\"parent\":93,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":93,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,399]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":96,\"ty\":4,\"parent\":95,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":95,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1311]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":98,\"ty\":4,\"parent\":97,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":97,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1083]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":100,\"ty\":4,\"parent\":99,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":99,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,855]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":102,\"ty\":4,\"parent\":101,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.416,0.604,0.137]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":101,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,627]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":104,\"ty\":4,\"parent\":103,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":103,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,0]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":106,\"ty\":4,\"parent\":105,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":105,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,228]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":108,\"ty\":4,\"parent\":107,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":107,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,1140]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":110,\"ty\":4,\"parent\":109,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":109,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,912]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":112,\"ty\":4,\"parent\":111,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":111,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,684]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":114,\"ty\":4,\"parent\":113,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0,\"shapes\":[{\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"c\":true,\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,33],[57,0],[57,57],[0,90],[0,33]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]]}}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.686,0.349,0.882]},\"o\":{\"a\":0,\"k\":100}}]},{\"ind\":113,\"ty\":3,\"parent\":66,\"ks\":{\"p\":{\"a\":0,\"k\":[0,456]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":66,\"ty\":3,\"parent\":65,\"ks\":{\"a\":{\"a\":0,\"k\":[28.5,700.5]},\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[28.5,700.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":192,\"s\":[28.5,586.5],\"i\":{\"x\":[1,0.5],\"y\":[1,1]},\"o\":{\"x\":[0,0.5],\"y\":[0,0]}},{\"t\":384,\"s\":[28.5,472.5],\"h\":1}]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":65,\"ty\":3,\"ks\":{\"p\":{\"a\":0,\"k\":[1,229]}},\"ip\":0,\"op\":385,\"st\":0}]}],\"fr\":60,\"h\":64,\"ip\":0,\"layers\":[{\"ind\":63,\"ty\":0,\"td\":1,\"parent\":2,\"ks\":{},\"w\":37,\"h\":123,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"61\"},{\"ind\":55,\"ty\":0,\"tt\":1,\"parent\":2,\"ks\":{\"a\":{\"a\":0,\"k\":[0,1140]}},\"w\":57,\"h\":2541,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"53\"},{\"ind\":2,\"ty\":3,\"parent\":1,\"ks\":{\"p\":{\"a\":0,\"k\":[25,-63]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":125,\"ty\":0,\"td\":1,\"parent\":64,\"ks\":{},\"w\":57,\"h\":199,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"123\"},{\"ind\":117,\"ty\":0,\"tt\":1,\"parent\":64,\"ks\":{\"a\":{\"a\":0,\"k\":[1,229]}},\"w\":58,\"h\":1630,\"ip\":0,\"op\":385,\"st\":0,\"refId\":\"115\"},{\"ind\":64,\"ty\":3,\"parent\":1,\"ks\":{\"p\":{\"a\":0,\"k\":[-17,-134.63]}},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":1,\"ty\":3,\"parent\":0,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0},{\"ind\":0,\"ty\":3,\"ks\":{},\"ip\":0,\"op\":385,\"st\":0}],\"meta\":{\"g\":\"https://jitter.video\"},\"op\":384,\"v\":\"5.7.4\",\"w\":64}");

});



parcelRegister("2Oxuw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $312f7aad558dbf1f$export$2e2bcd8739ae039; });
/* rovo-chat-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $312f7aad558dbf1f$var$uniformSlotContainerCss = null;
const $312f7aad558dbf1f$var$UniformRovoChatContainer = ()=>{
    const contentContainerRef = (0, $1oC0p.useRef)(null);
    const [interacting, setInteracting] = (0, $1oC0p.useState)(false);
    const interactingRef = (0, $1oC0p.useRef)(interacting);
    (0, $1oC0p.useEffect)(()=>{
        interactingRef.current = interacting;
    }, [
        interacting
    ]);
    // On-load
    (0, $1oC0p.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let cleanup;
        let wheelTimeout = null;
        let keyTimeout = null;
        const container = contentContainerRef.current;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (!interactingRef.current) setInteracting(true);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            };
            // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener("wheel", onWheel, {
                    passive: false
                });
                window.addEventListener("touchmove", onTouchMove, {
                    passive: false
                });
                window.addEventListener("touchend", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("touchcancel", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("keydown", onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener("wheel", onWheel);
                window.removeEventListener("touchmove", onTouchMove);
                window.removeEventListener("touchend", onTouchEnd);
                window.removeEventListener("touchcancel", onTouchEnd);
                window.removeEventListener("keydown", onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents();
            // Content container click interactions
            if (container) container.addEventListener("click", handleFirstClick, {
                once: true
            });
            // Also listen for global clicks as fallback
            const handleGlobalClick = ()=>{
                handleFirstInteraction();
                window.removeEventListener("click", handleGlobalClick);
            };
            window.addEventListener("click", handleGlobalClick);
            // Store cleanup function
            cleanup = ()=>{
                enableScrollEvents();
                if (container) container.removeEventListener("click", handleFirstClick);
                window.removeEventListener("click", handleGlobalClick);
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer?.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (container) observer.observe(container);
        // Cleanup - ensure scroll events are always re-enabled
        return ()=>{
            if (observer && container) observer.unobserve(container);
            if (cleanup) cleanup();
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhk1rga"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _1bsb2faw _4t3i1wug _1reo15vq _18m915vq _3zmjv4q2",
                    "_t9eccvni"
                ]),
                style: {
                    "--_182sf68": (0, $6ZVlx.default)(interacting ? "translateX(-120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1bsb2faw _4t3i1wug _1reo15vq _18m915vq _1fbdv4q2",
                    "_t9eccfs3"
                ]),
                style: {
                    "--_1tebple": (0, $6ZVlx.default)(interacting ? "translateX(120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: contentContainerRef,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4t3i1o9t _c71l1o9t _1reo15vq _18m915vq _kqswh2mm _1xloz8o0 _1jopz8o0 _165tcv93 _1jc2cv93"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                    name: "chatContent"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$imageStyles,
                    className: (0, $2jatx.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $312f7aad558dbf1f$var$imageStyles
                })
            })
        ]
    });
};
var $312f7aad558dbf1f$export$2e2bcd8739ae039 = $312f7aad558dbf1f$var$UniformRovoChatContainer;
const $312f7aad558dbf1f$var$desktopAssetStyle = {
    width: "787px"
};
const $312f7aad558dbf1f$var$desktopLeftAssetCss = null;
const $312f7aad558dbf1f$var$desktopRightAssetCss = null;
const $312f7aad558dbf1f$var$desktopCss = null;
const $312f7aad558dbf1f$var$tabletCss = null;
const $312f7aad558dbf1f$var$mobileCss = null;
const $312f7aad558dbf1f$var$imageStyles = {
    width: "100%",
    display: "block"
};
const $312f7aad558dbf1f$var$sectionCss = null;

});

parcelRegister("4Aw5W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61a1b380208f9747$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $9mOHh = parcelRequire("9mOHh");
const $61a1b380208f9747$var$UniformRovoChatHeader = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9mOHh.ChatHeader), {});
};
var $61a1b380208f9747$export$2e2bcd8739ae039 = $61a1b380208f9747$var$UniformRovoChatHeader;

});

parcelRegister("4LrCk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14b3a29ed349294b$export$2e2bcd8739ae039; });
/* rovo-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $iBzDE = parcelRequire("iBzDE");

var $awV4v = parcelRequire("awV4v");
// Helper function for scroll event management (extracted to reduce complexity)
const $14b3a29ed349294b$var$createScrollEventHandlers = (handleFirstInteraction, enableScrollEvents, wheelTimeout, keyTimeout)=>{
    const preventDefault = (e)=>{
        e.preventDefault();
        handleFirstInteraction();
    };
    const onWheel = (e)=>{
        preventDefault(e);
        if (wheelTimeout.current) clearTimeout(wheelTimeout.current);
        wheelTimeout.current = setTimeout(enableScrollEvents, 20);
    };
    const onKeyDown = (e)=>{
        preventDefault(e);
        if (keyTimeout.current) clearTimeout(keyTimeout.current);
        keyTimeout.current = setTimeout(enableScrollEvents, 20);
    };
    const onTouchMove = (e)=>{
        preventDefault(e);
    };
    const onTouchEnd = ()=>{
        enableScrollEvents();
    };
    return {
        onWheel: onWheel,
        onKeyDown: onKeyDown,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
};
const $14b3a29ed349294b$export$9b3d5715b22fca44 = ({ defaultHeading: defaultHeading, defaultSubheading: defaultSubheading, videoCarousel: videoCarousel, primaryCtaLabel: primaryCtaLabel, primaryCtaHref: primaryCtaHref, headingTag: headingTag = "h1", flattenData: flattenData = true })=>{
    const uniqueId = (0, $1oC0p.useId)();
    const headingId = `rovo-hero-heading-${uniqueId}`;
    const ctaButtonId = `rovo-hero-cta-${uniqueId}`;
    const videoCarouselData = flattenData ? (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $1oC0p.useRef)([]);
    const videoContainerRef = (0, $1oC0p.useRef)(null);
    const { firePlayPauseClicked: firePlayPauseClicked, fireTeamSelected: fireTeamSelected } = (0, $iBzDE.useRovoHeroAnalytics)();
    const [current, setCurrent] = (0, $1oC0p.useState)(-1);
    const currentRef = (0, $1oC0p.useRef)(current);
    const [playing, setPlaying] = (0, $1oC0p.useState)(true);
    const [durations, setDurations] = (0, $1oC0p.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $1oC0p.useState)(0);
    const [viewportWidth, setViewportWidth] = (0, $1oC0p.useState)(typeof window !== "undefined" ? window.innerWidth : 0);
    (0, $1oC0p.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]);
    // Helper function for setting up video durations (using useCallback to make it stable)
    const setupVideoDurations = (0, $1oC0p.useCallback)(()=>{
        videoCarouselData.forEach((_, idx)=>{
            const video = videoRefs.current[idx];
            if (!video) return;
            if (video.readyState >= 1) setDurations((durs)=>{
                const copy = [
                    ...durs
                ];
                copy[idx] = video.duration;
                return copy;
            });
            else video.onloadedmetadata = ()=>{
                setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
            };
        });
    }, [
        videoCarouselData
    ]);
    // Helper to set up scroll blocking and event listeners (using useCallback to reduce complexity)
    const setupScrollBlockingAndEvents = (0, $1oC0p.useCallback)((handleFirstInteraction, wheelTimeout, keyTimeout)=>{
        const enableScrollEvents = (handlers)=>{
            window.removeEventListener("wheel", handlers.onWheel);
            window.removeEventListener("touchmove", handlers.onTouchMove);
            window.removeEventListener("touchend", handlers.onTouchEnd);
            window.removeEventListener("touchcancel", handlers.onTouchEnd);
            window.removeEventListener("keydown", handlers.onKeyDown);
            if (wheelTimeout.current) clearTimeout(wheelTimeout.current);
            if (keyTimeout.current) clearTimeout(keyTimeout.current);
        };
        const handlers = $14b3a29ed349294b$var$createScrollEventHandlers(handleFirstInteraction, ()=>enableScrollEvents(handlers), wheelTimeout, keyTimeout);
        const handleFirstClick = ()=>{
            handleFirstInteraction();
            enableScrollEvents(handlers);
        };
        // Block scroll events
        window.addEventListener("wheel", handlers.onWheel, {
            passive: false
        });
        window.addEventListener("touchmove", handlers.onTouchMove, {
            passive: false
        });
        window.addEventListener("touchend", handlers.onTouchEnd, {
            passive: false
        });
        window.addEventListener("touchcancel", handlers.onTouchEnd, {
            passive: false
        });
        window.addEventListener("keydown", handlers.onKeyDown, {
            passive: false
        });
        return {
            handleFirstClick: handleFirstClick,
            enableScrollEvents: ()=>enableScrollEvents(handlers)
        };
    }, []);
    // On-load
    (0, $1oC0p.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let cleanup;
        const wheelTimeout = {
            current: null
        };
        const keyTimeout = {
            current: null
        };
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (currentRef.current === -1) setCurrent(0);
            };
            const { handleFirstClick: handleFirstClick, enableScrollEvents: enableScrollEvents } = setupScrollBlockingAndEvents(handleFirstInteraction, wheelTimeout, keyTimeout);
            // Video container click interactions
            const container = videoContainerRef.current;
            if (container) container.addEventListener("pointerdown", handleFirstClick, {
                once: true
            });
            // Video durations
            setupVideoDurations();
            // Store cleanup function
            cleanup = ()=>{
                enableScrollEvents();
                if (container) {
                    container.removeEventListener("pointerdown", handleFirstInteraction);
                    container.removeEventListener("keydown", handleFirstInteraction);
                }
            };
        }
        // Intersection Observer setup
        const videoContainer = videoContainerRef.current;
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer?.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (videoContainer) observer.observe(videoContainer);
        // Cleanup - ensure scroll events are always re-enabled
        return ()=>{
            if (observer && videoContainer) observer.unobserve(videoContainer);
            if (cleanup) cleanup();
        };
    }, [
        setupVideoDurations,
        setupScrollBlockingAndEvents
    ]);
    // Video handlers - using useCallback to reduce complexity
    const handleEnded = (0, $1oC0p.useCallback)(()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    }, [
        current,
        videoCarouselData.length
    ]);
    const togglePlay = (0, $1oC0p.useCallback)(()=>{
        setPlaying((p)=>{
            firePlayPauseClicked(p ? "pause" : "play");
            return !p;
        });
    }, [
        firePlayPauseClicked
    ]);
    const handleTeamClick = (0, $1oC0p.useCallback)((idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        const team = videoCarouselData[idx]?.team ?? String(idx);
        fireTeamSelected(team);
        setCurrent(idx);
        setPlaying(true);
    }, [
        current,
        fireTeamSelected,
        videoCarouselData
    ]);
    // Pause/play current video
    (0, $1oC0p.useEffect)(()=>{
        if (current === -1) return;
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]);
    const currentDuration = durations[current] || 10;
    // Responsive asset type - extracted to reduce complexity
    (0, $1oC0p.useEffect)(()=>{
        const breakpoints = [
            768,
            1024
        ];
        const prevWidth = {
            current: window.innerWidth
        };
        let resizeTimeout;
        const crossedBreakpoint = (prev, curr)=>breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? "desktop" : viewportWidth >= 768 ? "tablet" : "mobile";
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhk1rga"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _3zmjv4q2",
                    "_t9ec1qbm"
                ]),
                style: {
                    "--_12q5zt9": (0, $6ZVlx.default)(current !== -1 ? "translateX(-120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1fbdv4q2",
                    "_t9ecc5kj"
                ]),
                style: {
                    "--_1ylu95p": (0, $6ZVlx.default)(current !== -1 ? "translateX(120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _1rjcxncg _133i1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o"
                            ]),
                            children: [
                                defaultSubheading && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_16mf1pz4 _12n91k8s _179m1k92 _1k84oxwj",
                                        "body-lg subheading"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                    },
                                    children: defaultSubheading
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_4cvr1h6o _1pfhpxbi"
                                    ]),
                                    children: headingTag === "h1" ? /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                        id: headingId,
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        id: headingId,
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    })
                                }),
                                primaryCtaLabel && primaryCtaHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261g80 _zulputpp _1bah1h6o _1mou1ejb _urukpxbi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        id: ctaButtonId,
                                        href: primaryCtaHref,
                                        ariaLabelledby: `${ctaButtonId} ${headingId}`,
                                        dataEventProps: {
                                            "data-product-key": "uniform",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "heroSection"
                                        },
                                        className: (0, $2jatx.default)([
                                            "_3fcw1q9c _1cqs1j6v _1bys1k92 _1jw8bfng"
                                        ]),
                                        children: primaryCtaLabel
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: videoContainerRef,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e021ssb _t9eczr6s",
                            "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                                    ref: (el)=>videoRefs.current[idx] = el,
                                    src: assetType === "desktop" ? desktopVideoSrc : assetType === "tablet" ? tabletVideoSrc : mobileVideoSrc,
                                    muted: true,
                                    playsInline: true,
                                    onEnded: handleEnded,
                                    autoPlay: idx === current && playing,
                                    controls: false,
                                    "aria-label": ariaLabel,
                                    preload: "auto",
                                    poster: (assetType === "desktop" ? desktopPoster : assetType === "tablet" ? tabletPoster : mobilePoster) ?? undefined,
                                    className: (0, $2jatx.default)([
                                        "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje",
                                        "_3um01ppy _4t3io5ou"
                                    ]),
                                    style: {
                                        "--_1wpk543": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? "visible" : "hidden"),
                                        "--_1b1vnti": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? "100%" : 0)
                                    }
                                }, team))
                        })
                    }),
                    current !== -1 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _y44v1dy3 _1e0c11p5 _yv0e1qft _476dutpp _19d71wug _zzszh9n0"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: togglePlay,
                                    "aria-label": intl.formatMessage(playing ? {
                                        id: "rovo-hero.pause",
                                        defaultMessage: "Pause"
                                    } : {
                                        id: "rovo-hero.play",
                                        defaultMessage: "Play"
                                    }),
                                    "aria-pressed": playing,
                                    className: (0, $2jatx.default)([
                                        "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1ygb8djs _1ah3yh40 _1tzgkb7n _1acakb7n"
                                    ]),
                                    style: {
                                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_4t3izwfg _1bsbzwfg _bfhk1aeo _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31s03 _1tjq1s1x"
                                        ]),
                                        style: {
                                            "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000")),
                                            "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                                            "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300"))
                                        },
                                        children: playing ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.pause",
                                                defaultMessage: "Pause"
                                            })
                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.play",
                                                defaultMessage: "Play"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq"
                                    ]),
                                    children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>handleTeamClick(idx),
                                            "aria-label": intl.formatMessage({
                                                id: "rovo-hero.team-button",
                                                defaultMessage: "Play {team} video"
                                            }, {
                                                team: team
                                            }),
                                            "aria-pressed": idx === current,
                                            className: (0, $2jatx.default)([
                                                "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _ect41pz4 _1wyb1j6v _k48p1fw0 _vwz41k8s _1ygb8djs _1ah3yh40",
                                                "_syazxvv5 _d0al18ta"
                                            ]),
                                            style: {
                                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                                "--_145xjfw": (0, $6ZVlx.default)(idx === current ? (0, $kbpa7.wacToken)("color.primary.blue") : (0, $kbpa7.wacToken)("color.neutral.light800")),
                                                "--_1sd2kd4": (0, $6ZVlx.default)(idx === current ? "auto" : "pointer")
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhku4vp _1mou1ilp",
                                                        idx === 0 && "_2rkonggr",
                                                        idx === videoCarouselData.length - 1 && "_2rkof82g"
                                                    ]),
                                                    style: {
                                                        "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                                                    },
                                                    children: idx === current && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3i1osq _1bsb1osq _bfhk17la _kqswstnw _1e02idpf _152tidpf",
                                                            "_y44v1gj6 _1y0c1j4f",
                                                            "fillBar"
                                                        ]),
                                                        style: {
                                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                                            "--_1fmqpqp": (0, $6ZVlx.default)(currentDuration, "s"),
                                                            "--_snrfvu": (0, $6ZVlx.default)(playing ? "running" : "paused")
                                                        }
                                                    }, fillBarResetKey)
                                                }),
                                                team
                                            ]
                                        }, team))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$imageStyles,
                    className: (0, $2jatx.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $14b3a29ed349294b$var$imageStyles
                })
            })
        ]
    });
};
/* eslint-enable complexity */ const $14b3a29ed349294b$var$UniformRovoHeroWithFeatureGate = (props)=>{
    const isGwp10221 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10221RovoProductTourFixScrollAnimation);
    if (isGwp10221) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $awV4v.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($14b3a29ed349294b$export$9b3d5715b22fca44, {
        ...props
    });
};
var $14b3a29ed349294b$export$2e2bcd8739ae039 = $14b3a29ed349294b$var$UniformRovoHeroWithFeatureGate;
const $14b3a29ed349294b$var$desktopAssetStyle = {
    width: "787px"
};
const $14b3a29ed349294b$var$desktopLeftAssetCss = null;
const $14b3a29ed349294b$var$desktopRightAssetCss = null;
const $14b3a29ed349294b$var$desktopCss = null;
const $14b3a29ed349294b$var$tabletCss = null;
const $14b3a29ed349294b$var$mobileCss = null;
const $14b3a29ed349294b$var$imageStyles = {
    width: "100%",
    display: "block"
};
const $14b3a29ed349294b$var$sectionCss = null;
const $14b3a29ed349294b$var$containerCss = null;
const $14b3a29ed349294b$var$subheadingCss = null;
const $14b3a29ed349294b$var$headingContainerCss = null;
const $14b3a29ed349294b$var$headingCss = null;
const $14b3a29ed349294b$var$mainHeadingCss = null;
const $14b3a29ed349294b$var$ctaContainerCss = null;
const $14b3a29ed349294b$var$ctaCss = null;
const $14b3a29ed349294b$var$videoContainerCss = null;
const $14b3a29ed349294b$var$videoDimensionsCss = null;
const $14b3a29ed349294b$var$videoCss = null;
const $14b3a29ed349294b$var$fadeIn = null;
const $14b3a29ed349294b$var$controlContainerCss = null;
const $14b3a29ed349294b$var$barContainerCss = null;
const $14b3a29ed349294b$var$buttonCss = null;
const $14b3a29ed349294b$var$buttonCirlceCss = null;
const $14b3a29ed349294b$var$firstBarCss = null;
const $14b3a29ed349294b$var$lastBarCss = null;
const $14b3a29ed349294b$var$barbuttonCss = null;
const $14b3a29ed349294b$var$barCss = null;
const $14b3a29ed349294b$var$fillBarCss = null;
const $14b3a29ed349294b$var$fill = null;

});
parcelRegister("iBzDE", function(module, exports) {
$parcel$export(module.exports, "useRovoHeroAnalytics", function () { return $bbd9a66500e3e4bd$export$b341deb4ffc5f20b; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $bbd9a66500e3e4bd$export$b341deb4ffc5f20b() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const firePlayPauseClicked = (0, $1oC0p.useCallback)((label)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "playPause",
            source: "heroSection",
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireTeamSelected = (0, $1oC0p.useCallback)((team)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "teamSelector",
            source: "heroSection",
            attributes: {
                team: team
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        firePlayPauseClicked: firePlayPauseClicked,
        fireTeamSelected: fireTeamSelected
    };
}

});

parcelRegister("awV4v", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $db601b64e1cb1430$export$2e2bcd8739ae039; });
/* rovo-hero-gwp10221.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $iBzDE = parcelRequire("iBzDE");
const $db601b64e1cb1430$var$UniformRovoHero = ({ defaultHeading: defaultHeading, defaultSubheading: defaultSubheading, videoCarousel: videoCarousel, primaryCtaLabel: primaryCtaLabel, primaryCtaHref: primaryCtaHref, headingTag: headingTag = "h1", flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $1oC0p.useRef)([]);
    const videoContainerRef = (0, $1oC0p.useRef)(null);
    const [current, setCurrent] = (0, $1oC0p.useState)(-1);
    const currentRef = (0, $1oC0p.useRef)(current);
    const [playing, setPlaying] = (0, $1oC0p.useState)(true);
    const [durations, setDurations] = (0, $1oC0p.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $1oC0p.useState)(0);
    // @ts-expect-error never read
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const prevViewportWidth = (0, $1oC0p.useRef)(typeof window !== "undefined" ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $1oC0p.useState)(typeof window !== "undefined" ? window.innerWidth : 0);
    (0, $1oC0p.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]);
    // On-load
    (0, $1oC0p.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let wheelTimeout = null;
        let keyTimeout = null;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (currentRef.current === -1) setCurrent(0);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            };
            // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener("wheel", onWheel, {
                    passive: false
                });
                window.addEventListener("touchmove", onTouchMove, {
                    passive: false
                });
                window.addEventListener("touchend", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("touchcancel", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("keydown", onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener("wheel", onWheel);
                window.removeEventListener("touchmove", onTouchMove);
                window.removeEventListener("touchend", onTouchEnd);
                window.removeEventListener("touchcancel", onTouchEnd);
                window.removeEventListener("keydown", onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents();
            // Video container click interactions
            const container = videoContainerRef.current;
            if (container) container.addEventListener("pointerdown", handleFirstClick, {
                once: true
            });
            // Video durations
            videoCarouselData.forEach((_, idx)=>{
                const video = videoRefs.current[idx];
                if (!video) return;
                if (video.readyState >= 1) setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
                else video.onloadedmetadata = ()=>{
                    setDurations((durs)=>{
                        const copy = [
                            ...durs
                        ];
                        copy[idx] = video.duration;
                        return copy;
                    });
                };
            });
            // Cleanup
            return ()=>{
                enableScrollEvents();
                if (container) {
                    container.removeEventListener("pointerdown", handleFirstInteraction);
                    container.removeEventListener("keydown", handleFirstInteraction);
                }
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer?.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (videoContainerRef.current) observer.observe(videoContainerRef.current);
        // Cleanup
        return ()=>{
            if (observer && videoContainerRef.current) observer.unobserve(videoContainerRef.current);
        };
    }, []);
    // Play next video on end, looping
    const handleEnded = ()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    };
    // Pause/play current video
    (0, $1oC0p.useEffect)(()=>{
        if (current === -1) return;
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]);
    const { firePlayPauseClicked: firePlayPauseClicked, fireTeamSelected: fireTeamSelected } = (0, $iBzDE.useRovoHeroAnalytics)();
    // Pause/play toggle
    const togglePlay = ()=>{
        setPlaying((p)=>{
            firePlayPauseClicked(p ? "pause" : "play");
            return !p;
        });
    };
    // Jump to a specific video and start from beginning
    const handleTeamClick = (idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        const team = videoCarouselData[idx]?.team ?? String(idx);
        fireTeamSelected(team);
        setCurrent(idx);
        setPlaying(true);
    };
    const currentDuration = durations[current] || 10;
    // Responsive asset type
    (0, $1oC0p.useEffect)(()=>{
        let resizeTimeout;
        const breakpoints = [
            768,
            1024
        ];
        // Store previous width outside the handler so it persists
        const prevViewportWidth = {
            current: window.innerWidth
        };
        function crossedBreakpoint(prev, curr) {
            return breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        }
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevViewportWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevViewportWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? "desktop" : viewportWidth >= 768 ? "tablet" : "mobile";
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhk1rga"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _3zmjv4q2",
                    "_t9ec1qbm"
                ]),
                style: {
                    "--_12q5zt9": (0, $6ZVlx.default)(current !== -1 ? "translateX(-120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $db601b64e1cb1430$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1fbdv4q2",
                    "_t9ecc5kj"
                ]),
                style: {
                    "--_1ylu95p": (0, $6ZVlx.default)(current !== -1 ? "translateX(120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $db601b64e1cb1430$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _1rjcxncg _133i1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o"
                            ]),
                            children: [
                                defaultSubheading && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_16mf1pz4 _12n91k8s _179m1k92 _1k84oxwj",
                                        "body-lg subheading"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                    },
                                    children: defaultSubheading
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_4cvr1h6o _1pfhpxbi"
                                    ]),
                                    children: headingTag === "h1" ? /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    })
                                }),
                                primaryCtaLabel && primaryCtaHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261g80 _zulputpp _1bah1h6o _1mou1ejb _urukpxbi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                        href: primaryCtaHref,
                                        dataEventProps: {
                                            "data-product-key": "uniform",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "heroSection"
                                        },
                                        className: (0, $2jatx.default)([
                                            "_3fcw1q9c _1cqs1j6v _1bys1k92 _1jw8bfng"
                                        ]),
                                        children: primaryCtaLabel
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: videoContainerRef,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e021ssb _t9eczr6s",
                            "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                                    ref: (el)=>videoRefs.current[idx] = el,
                                    src: assetType === "desktop" ? desktopVideoSrc : assetType === "tablet" ? tabletVideoSrc : mobileVideoSrc,
                                    muted: true,
                                    playsInline: true,
                                    onEnded: handleEnded,
                                    autoPlay: idx === current && playing,
                                    controls: false,
                                    "aria-label": ariaLabel,
                                    preload: "auto",
                                    poster: (assetType === "desktop" ? desktopPoster : assetType === "tablet" ? tabletPoster : mobilePoster) ?? undefined,
                                    className: (0, $2jatx.default)([
                                        "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje",
                                        "_3um01ppy _4t3io5ou"
                                    ]),
                                    style: {
                                        "--_1wpk543": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? "visible" : "hidden"),
                                        "--_1b1vnti": (0, $6ZVlx.default)(idx === current || idx === 0 && current === -1 ? "100%" : 0)
                                    }
                                }, team))
                        })
                    }),
                    current !== -1 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _y44v1dy3 _1e0c11p5 _yv0e1qft _476dutpp _19d71wug _zzszh9n0"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: togglePlay,
                                    "aria-label": intl.formatMessage(playing ? {
                                        id: "rovo-hero.pause",
                                        defaultMessage: "Pause"
                                    } : {
                                        id: "rovo-hero.play",
                                        defaultMessage: "Play"
                                    }),
                                    "aria-pressed": playing,
                                    className: (0, $2jatx.default)([
                                        "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1ygb8djs _1ah3yh40 _1tzgkb7n _1acakb7n"
                                    ]),
                                    style: {
                                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_4t3izwfg _1bsbzwfg _bfhk1aeo _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31s03 _1tjq1s1x"
                                        ]),
                                        style: {
                                            "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000")),
                                            "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                                            "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300"))
                                        },
                                        children: playing ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.pause",
                                                defaultMessage: "Pause"
                                            })
                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.play",
                                                defaultMessage: "Play"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq"
                                    ]),
                                    children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>handleTeamClick(idx),
                                            "aria-label": intl.formatMessage({
                                                id: "rovo-hero.team-button",
                                                defaultMessage: "Play {team} video"
                                            }, {
                                                team: team
                                            }),
                                            "aria-pressed": idx === current,
                                            className: (0, $2jatx.default)([
                                                "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _ect41pz4 _1wyb1j6v _k48p1fw0 _vwz41k8s _1ygb8djs _1ah3yh40",
                                                "_syazxvv5 _d0al18ta"
                                            ]),
                                            style: {
                                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                                "--_145xjfw": (0, $6ZVlx.default)(idx === current ? (0, $kbpa7.wacToken)("color.primary.blue") : (0, $kbpa7.wacToken)("color.neutral.light800")),
                                                "--_1sd2kd4": (0, $6ZVlx.default)(idx === current ? "auto" : "pointer")
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhku4vp _1mou1ilp",
                                                        idx === 0 && "_2rkonggr",
                                                        idx === videoCarouselData.length - 1 && "_2rkof82g"
                                                    ]),
                                                    style: {
                                                        "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                                                    },
                                                    children: idx === current && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_4t3i1osq _1bsb1osq _bfhk17la _kqswstnw _1e02idpf _152tidpf",
                                                            "_y44v1gj6 _1y0c1j4f",
                                                            "fillBar"
                                                        ]),
                                                        style: {
                                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                                            "--_1fmqpqp": (0, $6ZVlx.default)(currentDuration, "s"),
                                                            "--_snrfvu": (0, $6ZVlx.default)(playing ? "running" : "paused")
                                                        }
                                                    }, fillBarResetKey)
                                                }),
                                                team
                                            ]
                                        }, team))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $db601b64e1cb1430$var$imageStyles,
                    className: (0, $2jatx.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $db601b64e1cb1430$var$imageStyles
                })
            })
        ]
    });
};
var $db601b64e1cb1430$export$2e2bcd8739ae039 = $db601b64e1cb1430$var$UniformRovoHero;
const $db601b64e1cb1430$var$desktopAssetStyle = {
    width: "787px"
};
const $db601b64e1cb1430$var$desktopLeftAssetCss = null;
const $db601b64e1cb1430$var$desktopRightAssetCss = null;
const $db601b64e1cb1430$var$desktopCss = null;
const $db601b64e1cb1430$var$tabletCss = null;
const $db601b64e1cb1430$var$mobileCss = null;
const $db601b64e1cb1430$var$imageStyles = {
    width: "100%",
    display: "block"
};
const $db601b64e1cb1430$var$sectionCss = null;
const $db601b64e1cb1430$var$containerCss = null;
const $db601b64e1cb1430$var$subheadingCss = null;
const $db601b64e1cb1430$var$headingContainerCss = null;
const $db601b64e1cb1430$var$headingCss = null;
const $db601b64e1cb1430$var$mainHeadingCss = null;
const $db601b64e1cb1430$var$ctaContainerCss = null;
const $db601b64e1cb1430$var$ctaCss = null;
const $db601b64e1cb1430$var$videoContainerCss = null;
const $db601b64e1cb1430$var$videoDimensionsCss = null;
const $db601b64e1cb1430$var$videoCss = null;
const $db601b64e1cb1430$var$fadeIn = null;
const $db601b64e1cb1430$var$controlContainerCss = null;
const $db601b64e1cb1430$var$barContainerCss = null;
const $db601b64e1cb1430$var$buttonCss = null;
const $db601b64e1cb1430$var$buttonCirlceCss = null;
const $db601b64e1cb1430$var$firstBarCss = null;
const $db601b64e1cb1430$var$lastBarCss = null;
const $db601b64e1cb1430$var$barbuttonCss = null;
const $db601b64e1cb1430$var$barCss = null;
const $db601b64e1cb1430$var$fillBarCss = null;
const $db601b64e1cb1430$var$fill = null;

});


parcelRegister("v15B3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4094c0fa404a407$export$2e2bcd8739ae039; });
/* scrollable-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2VIbp = parcelRequire("2VIbp");

var $bSVv5 = parcelRequire("bSVv5");

var $jE3Ci = parcelRequire("jE3Ci");

var $kbpa7 = parcelRequire("kbpa7");
const $d4094c0fa404a407$var$messages = (0, $fnHPc.defineMessages)({
    scrollableRegionLabel: {
        id: "UniformScrollableHeroCards.scrollableRegionLabel",
        defaultMessage: "Scrollable content"
    }
});
/** Maps Uniform scrollable lozenge color (incl. saffron) to design Lozenge appearance. */ const $d4094c0fa404a407$var$scrollableLozengeColorToAppearance = (color)=>{
    switch(color){
        case "blue":
        case "neutral":
        case "saffron":
        case "lime":
        case "purple":
            return color;
        default:
            return "neutral";
    }
};
const $d4094c0fa404a407$var$backgroundColorMap = {
    blue100: (0, $kbpa7.wacToken)("color.extended.blue100"),
    primaryBlack: (0, $kbpa7.wacToken)("color.primary.black"),
    light100: (0, $kbpa7.wacToken)("color.neutral.light100")
};
const $d4094c0fa404a407$var$UniformScrollableHeroCards = (props)=>{
    const intl = (0, $8e22h.default)();
    const { flattenData: flattenData = true, backgroundColor: backgroundColor = "blue100", scrollableRegionLabel: scrollableRegionLabel = intl.formatMessage($d4094c0fa404a407$var$messages.scrollableRegionLabel) } = props;
    let { scrollableCard: scrollableCard } = props;
    if (flattenData) {
        const flattened = (0, $2VIbp.flattenScrollableCardProps)(props);
        scrollableCard = flattened.scrollableCard;
    }
    const containerBackgroundColor = $d4094c0fa404a407$var$backgroundColorMap[backgroundColor];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            background: containerBackgroundColor
        },
        className: (0, $2jatx.default)([
            "_1rjcpxbi _18zr1jfw _1bhl1ejb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            "aria-label": scrollableRegionLabel,
            // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
            tabIndex: 0,
            className: (0, $2jatx.default)([
                "_1bsb1s9t _p12f1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _9nneu2gc _1yt4u2gc _zulp1ejb _85i51ejb _1reo1wug _rjfvx6dd _1fjgurpi _a5o91kbs _15peu2gc _1v6m1rga _gce7u2gc _aayn1q9v _155au2gc _1w1e15zi _2osnpxbi"
            ]),
            style: {
                "--_o8nmkh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue500")),
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            },
            children: scrollableCard?.map((card, index)=>{
                const cardContent = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jE3Ci.Lozenge), {
                            appearance: $d4094c0fa404a407$var$scrollableLozengeColorToAppearance(card.scrollableCardLozengeColor),
                            text: card.scrollableCardLozengeText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_18s86fpf _1yt414kv _th3simiu _lrmn10nf",
                                "scrollable-card-title"
                            ]),
                            children: card.scrollableCardTitle
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                            src: card.scrollableCardImage,
                            alt: card.scrollableCardAltText ?? ""
                        })
                    ]
                });
                return card.scrollableCardUrl?.path ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                    href: card.scrollableCardUrl.path,
                    "aria-label": card.scrollableCardUrl.alt || card.scrollableCardTitle,
                    className: (0, $2jatx.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q7cd5j _2rkovwyg _16qst7xp _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf",
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazn7od _80omtlke _v564iooc _1llwjtcz _1dbz130s _y2mv1mie"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                        "--_o8nmkh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue500"))
                    },
                    children: cardContent
                }, index) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q7cd5j _2rkovwyg _16qst7xp _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                    },
                    children: cardContent
                }, index);
            })
        })
    });
};
const $d4094c0fa404a407$var$containerStyles = null;
const $d4094c0fa404a407$var$scrollableContainer = null;
const $d4094c0fa404a407$var$titleStyles = null;
const $d4094c0fa404a407$var$cardWrapper = null;
const $d4094c0fa404a407$var$clickableCardStyles = null;
var $d4094c0fa404a407$export$2e2bcd8739ae039 = $d4094c0fa404a407$var$UniformScrollableHeroCards;

});
parcelRegister("2VIbp", function(module, exports) {
$parcel$export(module.exports, "flattenScrollableCardProps", function () { return $2f8a6ad73f8e2a83$export$f91448e13674e82b; });

var $f2QWG = parcelRequire("f2QWG");
const $2f8a6ad73f8e2a83$export$f91448e13674e82b = (props)=>{
    return {
        ...props,
        scrollableCard: (0, $f2QWG.flattenValues)(props.scrollableCard)
    };
};

});


parcelRegister("71GXn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0984c2e73b0694a4$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $5f18E = parcelRequire("5f18E");

var $j5L4q = parcelRequire("j5L4q");
const $0984c2e73b0694a4$var$UniformSideNav = ({ component: component })=>{
    const slotItems = component.slots?.["sideNavItems"] ?? null;
    if (!slotItems) return;
    const sideNavItems = (0, $j5L4q.transformNavItemData)(slotItems);
    const props = {
        title: component.parameters?.["title"]?.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5f18E.SideNav), {
        ...props
    });
};
var $0984c2e73b0694a4$export$2e2bcd8739ae039 = $0984c2e73b0694a4$var$UniformSideNav;

});
parcelRegister("5f18E", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $0ecd955324bfea13$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $46Ma8 = parcelRequire("46Ma8");

var $bxChG = parcelRequire("bxChG");

var $50Va3 = parcelRequire("50Va3");

var $7HoXo = parcelRequire("7HoXo");

var $kbpa7 = parcelRequire("kbpa7");
const $0ecd955324bfea13$var$MobileExpandableNav = ({ title: title, children: children })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $1oC0p.useState)(0);
    const navRef = (0, $1oC0p.useRef)(null);
    const buttonRef = (0, $1oC0p.useRef)(null);
    const contentRef = (0, $1oC0p.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    };
    // Calculate button position for nav positioning
    (0, $1oC0p.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []);
    // Prevent body scroll when nav is open
    (0, $1oC0p.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]);
    // Handle click outside to close nav
    (0, $1oC0p.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: navRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                type: "button",
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1wqb _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _kqswh2mm _1pbyibnn _irr3u4vp _s51sxy5q"
                ]),
                style: {
                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxChG))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46Ma8))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "eyebrow-md",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: contentRef,
                id: "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_bfhkcd5j _1bsb1osq _18zr1wqb _v564vpel _1reo1wug _18m91wug _s51sxy5q",
                    isExpanded ? "_kqsw1n9t _152t1um1 _dk5didpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51wqb _18zr1wqb _s51sxy5q" : "_kqsw1n9t _c71lidpf _tzy4idpf _lcxvglyw _152tidpf _dk5didpf _1bsbauwl"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $6ZVlx.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1reo1wug _18m91wug"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $0ecd955324bfea13$export$6b43f262d1299a2e = ({ sideNavItems: sideNavItems })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t _1reo1wug _18m91wug _1jc21nkh _1xey1k0a",
            "sidenav-menu"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
        },
        children: sideNavItems.map((sideNavItem)=>{
            if (sideNavItem.type === "collection") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50Va3.SideNavCollection), {
                type: "collection",
                collectionName: sideNavItem.collectionName,
                sideNavItems: sideNavItem.sideNavItems,
                depth: 0
            }, sideNavItem.collectionName);
            if (sideNavItem.type === "link") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7HoXo.SideNavLink), {
                dataEventProps: sideNavItem.dataEventProps,
                type: "link",
                text: sideNavItem.text,
                href: sideNavItem.href,
                anchors: sideNavItem.anchors,
                depth: 0
            }, sideNavItem.text);
            return null;
        })
    });
};
const $0ecd955324bfea13$export$1a35787d6353cf6a = ({ title: title, sideNavItems: sideNavItems })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
                id: "side-nav-desktop",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.desktop.label",
                    defaultMessage: `{hub_topics} desktop navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_19ityzqy _2rkovwyg _1yt4v47k _85i51wqb _4t3i1ns9"
                ]),
                style: {
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1tke1wqb _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
                id: "side-nav-tablet-mobile",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.mobile.label",
                    defaultMessage: `{hub_topics} mobile navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_dm25glyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$var$MobileExpandableNav, {
                    title: title,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                })
            })
        ]
    });
};
const $0ecd955324bfea13$var$desktopCss = null;
const $0ecd955324bfea13$var$tabletMobileCss = null;
const $0ecd955324bfea13$var$listCss = null;
const $0ecd955324bfea13$var$containerCss = null;
const $0ecd955324bfea13$var$desktopTitleCss = null;
const $0ecd955324bfea13$var$mobileIconCss = null;
const $0ecd955324bfea13$var$mobileExpandableButtonCss = null;
const $0ecd955324bfea13$var$mobileNavContentCss = null;
const $0ecd955324bfea13$var$mobileNavContentCollapsedCss = null;
const $0ecd955324bfea13$var$mobileInnerContentCss = null;

});
parcelRegister("bxChG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8670793cd6a627cd$var$_react = $8670793cd6a627cd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8670793cd6a627cd$var$_baseNew = $8670793cd6a627cd$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8670793cd6a627cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8670793cd6a627cd$var$MinusIcon = (props)=>/*#__PURE__*/ $8670793cd6a627cd$var$_react.default.createElement($8670793cd6a627cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$8670793cd6a627cd$var$MinusIcon.displayName = 'MinusIcon';
var $8670793cd6a627cd$var$_default = module.exports.default = $8670793cd6a627cd$var$MinusIcon;

});

parcelRegister("50Va3", function(module, exports) {
$parcel$export(module.exports, "SideNavCollection", function () { return $b6213a9c990feedf$export$fe1fe92908738381; });
/* side-nav-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $g3AHF = parcelRequire("g3AHF");

var $kbpa7 = parcelRequire("kbpa7");

var $7HoXo = parcelRequire("7HoXo");

var $hUjxd = parcelRequire("hUjxd");
const $b6213a9c990feedf$var$MAX_DEPTH = 2;
const $b6213a9c990feedf$export$fe1fe92908738381 = ({ collectionName: collectionName, depth: depth = 0, sideNavItems: sideNavItems })=>{
    // Recursively check if any child link (including in nested collections) is active
    const currRoute = (0, $hUjxd.getCurrRoute)();
    const checkItems = (items)=>{
        return items.some((item)=>{
            if (item.type === "link") return currRoute === item.href;
            if (item.type === "collection") return checkItems(item.sideNavItems);
            return false;
        });
    };
    const isExpanded = checkItems(sideNavItems);
    if (depth >= $b6213a9c990feedf$var$MAX_DEPTH) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _1e0c1txw _4cvr1h6o _2yuyidpf",
            "_1q511hly _85i513kw _1qt71y8y"
        ]),
        style: {
            "--_hv9tvx": (0, $6ZVlx.default)(depth === 0 ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"),
            "--_101944t": (0, $6ZVlx.default)(depth === 0 ? "var(--ds-space-200, 16px)" : "var(--ds-space-050, 4px)"),
            "--_1jm1u1b": (0, $6ZVlx.default)(depth === 0 ? 0 : "var(--ds-space-050, 4px)")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g3AHF.Expand), {
            eventDataName: collectionName,
            actionSubject: "linkButton",
            label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: depth === 0 ? "h6" : "body-md",
                style: {
                    fontFamily: (0, $kbpa7.wacToken)("font.charlie.text")
                },
                children: collectionName
            }),
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_qtt8glyw _18s8ze3t _1yt4ze3t"
                ]),
                children: sideNavItems.map((sideNavItem)=>{
                    if (sideNavItem.type === "collection") return /*#__PURE__*/ (0, $7VQPk.jsx)($b6213a9c990feedf$export$fe1fe92908738381, {
                        type: "collection",
                        collectionName: sideNavItem.collectionName,
                        sideNavItems: sideNavItem.sideNavItems,
                        depth: depth + 1
                    }, sideNavItem.collectionName);
                    if (sideNavItem.type === "link") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7HoXo.SideNavLink), {
                        dataEventProps: sideNavItem.dataEventProps,
                        type: "link",
                        text: sideNavItem.text,
                        href: sideNavItem.href,
                        anchors: sideNavItem.anchors,
                        depth: depth + 1
                    }, sideNavItem.text);
                    return null;
                })
            })
        })
    }, collectionName);
};
const $b6213a9c990feedf$var$listStyleNoneCss = null;
const $b6213a9c990feedf$var$listItemCss = null;

});
parcelRegister("7HoXo", function(module, exports) {
$parcel$export(module.exports, "SideNavLink", function () { return $c9ec576db80f44f7$export$ed4b92678aaeea6b; });
/* side-nav-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kKKSr = parcelRequire("kKKSr");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $hUjxd = parcelRequire("hUjxd");
const $c9ec576db80f44f7$export$ed4b92678aaeea6b = ({ text: text, href: href, dataEventProps: dataEventProps, anchors: anchors, depth: depth = 0, isAnchorLink: isAnchorLink = false, isAnchorAtTop: isAnchorAtTop = false })=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(href);
    const { headingIdAtTop: headingIdAtTop } = (0, $hUjxd.useHeadingAtTop)(anchors);
    const currRoute = (0, $hUjxd.getCurrRoute)();
    const isActive = currRoute === href;
    const shouldShowIcon = isActive && !headingIdAtTop && !isAnchorLink || isAnchorAtTop;
    const shouldBold = isActive && !isAnchorLink || isAnchorAtTop;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t",
            "_1e0c1ule",
            depth === 0 && "_1rjcpxbi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                href: localizedHref,
                ...dataEventProps,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o",
                    depth > 0 && "_1rjcu2gc",
                    !isActive && !isAnchorAtTop && "_ll8p17la"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1tcg _4t3i1tcg _1e0c1txw _1o9zidpf _4cvr1h6o _1bah1h6o _12l21b66 _1wpz1y6m"
                        ]),
                        children: shouldShowIcon && /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kKKSr))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: depth === 0 || shouldBold ? "h6" : "body-md",
                        style: {
                            fontFamily: (0, $kbpa7.wacToken)("font.charlie.text")
                        },
                        children: text
                    })
                ]
            }),
            anchors && anchors.length > 0 && isActive && /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_qtt8glyw _18s8ze3t _1yt4ze3t",
                    "_bozgxy5q"
                ]),
                children: anchors.map((anchor)=>{
                    const anchorIsAtTop = headingIdAtTop === anchor.id;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c9ec576db80f44f7$export$ed4b92678aaeea6b, {
                        dataEventProps: dataEventProps,
                        type: "link",
                        href: `${localizedHref}#${anchor.id}`,
                        text: anchor.text,
                        depth: depth + 1,
                        isAnchorLink: true,
                        isAnchorAtTop: anchorIsAtTop
                    }, anchor.id);
                })
            })
        ]
    });
};
const $c9ec576db80f44f7$var$listStyleNoneCss = null;
const $c9ec576db80f44f7$var$listItemCss = null;
const $c9ec576db80f44f7$var$navLinkCss = null;
const $c9ec576db80f44f7$var$navLinkHoverCss = null;
const $c9ec576db80f44f7$var$subLevelLinkCss = null;
const $c9ec576db80f44f7$var$dotContainerCss = null;

});
parcelRegister("kKKSr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::91b7b1dd505c61eb66599e7102bdd558>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1bc7751f247f560$var$_react = $f1bc7751f247f560$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f1bc7751f247f560$var$_baseNew = $f1bc7751f247f560$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f1bc7751f247f560$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightExtraLarge".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing the thickest border stroke width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1bc7751f247f560$var$StrokeWeightExtraLargeIcon = (props)=>/*#__PURE__*/ $f1bc7751f247f560$var$_react.default.createElement($f1bc7751f247f560$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0" clip-rule="evenodd"/>`
    }, props));
$f1bc7751f247f560$var$StrokeWeightExtraLargeIcon.displayName = 'StrokeWeightExtraLargeIcon';
var $f1bc7751f247f560$var$_default = module.exports.default = $f1bc7751f247f560$var$StrokeWeightExtraLargeIcon;

});

parcelRegister("hUjxd", function(module, exports) {
$parcel$export(module.exports, "getCurrRoute", function () { return $c6090ca8172758e6$export$846018c5dc1df5c3; });
$parcel$export(module.exports, "useHeadingAtTop", function () { return $c6090ca8172758e6$export$ff897c2042dc87d8; });

var $1oC0p = parcelRequire("1oC0p");

var $3fFrT = parcelRequire("3fFrT");
const $c6090ca8172758e6$export$846018c5dc1df5c3 = ()=>{
    let currRoute = window.location.pathname;
    if (currRoute === "/uniform-preview") {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const pathParam = urlParams.get("path");
        currRoute = pathParam ? decodeURIComponent(pathParam) : "";
    }
    // Remove locale
    for (const locale of (0, $3fFrT.LOCALES))if (currRoute.startsWith(`/${locale}/`)) {
        currRoute = currRoute.slice(`/${locale}`.length);
        break;
    }
    return currRoute;
};
const $c6090ca8172758e6$export$ff897c2042dc87d8 = (anchors)=>{
    const [headingIdAtTop, setHeadingIdAtTop] = (0, $1oC0p.useState)(null);
    const [validAnchorIds, setValidAnchorIds] = (0, $1oC0p.useState)(new Set());
    const headingIdRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        const bodyContent = document.getElementById("body-content");
        if (!anchors || anchors.length === 0 || !bodyContent) {
            setValidAnchorIds((prevValidIds)=>{
                if (prevValidIds.size > 0) return new Set();
                return prevValidIds;
            });
            return;
        }
        // Handle scroll to anchored section
        document.documentElement.style.scrollBehavior = "smooth";
        const headerHeightStr = getComputedStyle(document.documentElement).getPropertyValue("--wae-header-height").trim();
        document.documentElement.style.scrollPaddingTop = headerHeightStr || "80px";
        // Used below to calculate distance from top of viewport
        const headerHeight = parseInt(headerHeightStr.replace("px", ""), 10) || 80;
        const anchorHeadings = anchors.map((anchor)=>document.getElementById(`${anchor.id}`)).filter((heading)=>heading instanceof HTMLElement);
        // Check which heading is at the top of the viewport
        const checkHeadingAtTop = ()=>{
            const viewportTop = window.scrollY + headerHeight;
            let headingAtTop = null;
            for (const heading of anchorHeadings){
                const rect = heading?.getBoundingClientRect();
                const headingTop = window.scrollY + (rect?.top ?? 0);
                if (headingTop >= viewportTop - 100 && headingTop <= viewportTop + 100) headingAtTop = heading;
            }
            if (headingAtTop) {
                const newId = headingAtTop.id;
                if (newId !== headingIdRef.current) {
                    headingIdRef.current = newId;
                    setHeadingIdAtTop(newId);
                }
            }
        };
        // Create intersection observer to detect when headings reach the top
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const rect = entry.boundingClientRect;
                    const viewportTop = headerHeight;
                    // Check if heading is at the top of the viewport (within 100px)
                    if (rect.top >= viewportTop - 100 && rect.top <= viewportTop + 100) {
                        const id = entry.target.id;
                        if (id !== headingIdRef.current) {
                            headingIdRef.current = id;
                            setHeadingIdAtTop(id);
                        }
                    }
                }
            });
        }, {
            root: null,
            rootMargin: `${-headerHeight}px 0px 0px 0px`,
            threshold: [
                0,
                0.1,
                0.5,
                0.9,
                1
            ]
        });
        // Observe all headings
        anchorHeadings.forEach((heading)=>observer.observe(heading));
        // Scroll to anchor element
        const scrollToAnchor = (hash)=>{
            if (!hash) return;
            const targetHeading = anchorHeadings.find((h)=>h.id === hash);
            if (targetHeading) // Use requestAnimationFrame to ensure DOM is ready
            requestAnimationFrame(()=>{
                targetHeading.scrollIntoView({
                    behavior: "smooth"
                });
            });
        };
        // Check on scroll
        const handleScroll = ()=>{
            checkHeadingAtTop();
        };
        // Handle hash changes (e.g., when clicking anchor links)
        const handleHashChange = ()=>{
            const hash = window.location.hash.slice(1); // Remove '#'
            scrollToAnchor(hash);
        };
        // Initial check
        checkHeadingAtTop();
        // Scroll to anchor on initial page load if hash is present
        const initialHash = window.location.hash.slice(1);
        if (initialHash) // Use a small timeout to ensure page is fully rendered
        setTimeout(()=>{
            scrollToAnchor(initialHash);
        }, 100);
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        window.addEventListener("resize", handleScroll, {
            passive: true
        });
        window.addEventListener("hashchange", handleHashChange);
        // Cleanup
        return ()=>{
            anchorHeadings.forEach((heading)=>observer.unobserve(heading));
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
            window.removeEventListener("hashchange", handleHashChange);
            document.documentElement.style.scrollBehavior = "";
            document.documentElement.style.scrollPaddingTop = "";
        };
    }, [
        anchors
    ]);
    // Update URL anchor when heading changes
    (0, $1oC0p.useEffect)(()=>{
        if (headingIdAtTop) {
            const currentHash = window.location.hash.slice(1); // Remove '#'
            if (currentHash !== headingIdAtTop) {
                const newUrl = `${window.location.pathname}${window.location.search}#${headingIdAtTop}`;
                window.history.replaceState(null, "", newUrl); // update URL without adding to history
            }
        }
    }, [
        headingIdAtTop
    ]);
    return {
        headingIdAtTop: headingIdAtTop,
        validAnchorIds: validAnchorIds
    };
};

});




parcelRegister("j5L4q", function(module, exports) {
$parcel$export(module.exports, "transformNavItemData", function () { return $ec6d0de2a0c3a497$export$bbcc1b49937dee22; });
const $ec6d0de2a0c3a497$export$bbcc1b49937dee22 = (slots)=>{
    return slots.map((childComponent)=>{
        const childProps = childComponent.parameters ?? {};
        if (childComponent.type === "sideNavLink") {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const anchors = childProps["anchors"]?.value;
            return {
                type: "link",
                text: childProps["text"]?.value,
                href: childProps["href"]?.value,
                anchors: anchors ? anchors.map((anchor)=>{
                    return {
                        text: anchor?.fields?.text?.value,
                        id: anchor?.fields?.id?.value
                    };
                }) : null,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "sideNav",
                    "data-event": "clicked"
                }
            };
        }
        if (childComponent.type === "sideNavCollection") return {
            type: "collection",
            collectionName: childProps["collectionName"]?.value,
            sideNavItems: $ec6d0de2a0c3a497$export$bbcc1b49937dee22(childComponent.slots?.["sideNavItems"])
        };
        return;
    });
};

});


parcelRegister("3DCiB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6e00143a5b9453fa$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $50Va3 = parcelRequire("50Va3");

var $j5L4q = parcelRequire("j5L4q");
const $6e00143a5b9453fa$var$UniformSideNavCollection = ({ component: component })=>{
    const slotItems = component.slots?.["sideNavItems"] ?? null;
    if (!slotItems) return;
    const sideNavItems = (0, $j5L4q.transformNavItemData)(slotItems);
    const props = {
        type: "collection",
        collectionName: component.parameters?.["collectionName"]?.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50Va3.SideNavCollection), {
        ...props
    });
};
var $6e00143a5b9453fa$export$2e2bcd8739ae039 = $6e00143a5b9453fa$var$UniformSideNavCollection;

});

parcelRegister("acEyk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d6c9de186a63542c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $7HoXo = parcelRequire("7HoXo");
const $d6c9de186a63542c$var$UniformSideNavLink = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7HoXo.SideNavLink), {
        ...props,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "sideNav",
            "data-event": "clicked"
        }
    });
};
var $d6c9de186a63542c$export$2e2bcd8739ae039 = $d6c9de186a63542c$var$UniformSideNavLink;

});

parcelRegister("ies6q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8d6774ae7c2be16$export$2e2bcd8739ae039; });
/* sign-up-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $6KUQg = parcelRequire("6KUQg");

var $irRyj = parcelRequire("irRyj");

var $32ARy = parcelRequire("32ARy");

var $5tLnS = parcelRequire("5tLnS");

var $kbpa7 = parcelRequire("kbpa7");

var $4X0dO = parcelRequire("4X0dO");

var $gIKKj = parcelRequire("gIKKj");

var $1ka2O = parcelRequire("1ka2O");

var $i4BST = parcelRequire("i4BST");

var $bry8i = parcelRequire("bry8i");
const $b8d6774ae7c2be16$export$143e70f94b3fb702 = (providerList)=>{
    return providerList.reduce((previous, key)=>({
            ...previous,
            [key.toLowerCase()]: key
        }), {});
};
const $b8d6774ae7c2be16$var$SERVICE_COLLECTION_COBRANDING = "wac--service-collection-jsm-cobranding";
const $b8d6774ae7c2be16$var$JSM_SERVICE_MANAGEMENT_PATH = "/software/jira/service-management";
const $b8d6774ae7c2be16$var$UniformSignUpForm = ({ socialProviders: socialProviders, helpText: helpText, textColor: textColor = "default", inline: inline = false })=>{
    const intl = (0, $8e22h.default)();
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const location = (0, $1ka2O.useLocation)();
    const isJsmServiceManagementPage = location.pathname.includes($b8d6774ae7c2be16$var$JSM_SERVICE_MANAGEMENT_PATH);
    const servCoLofiBackgroundExperiment = (0, $gIKKj.useExperiment)((0, $4X0dO.experiments).servCoLofiBackground);
    const servCoLofiBackground = servCoLofiBackgroundExperiment.type === "enrolled" ? servCoLofiBackgroundExperiment.value : (0, $4X0dO.experiments).servCoLofiBackground.defaultValue;
    // Defer site naming continueUrl override — only fires for Jira variant users
    // (the hook handles product-key gating internally).
    const getContinueUrl = (0, $5tLnS.useDeferSiteNamingContinueUrl)();
    const defaultHelpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperTextTeam26",
        defaultMessage: "Use a work email to find teammates and get access to Rovo AI"
    });
    const configuredHelpText = helpText?.trim();
    const emailHelpText = configuredHelpText || defaultHelpText;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            textColor === "light" && "_syazcd5j"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
            identityCobranding: servCoLofiBackground && isJsmServiceManagementPage ? $b8d6774ae7c2be16$var$SERVICE_COLLECTION_COBRANDING : undefined,
            getContinueUrl: getContinueUrl,
            Login: null,
            Separator: inline ? null : undefined,
            Error: inline ? null : undefined,
            Input: inline ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bry8i.InlineInputSubmitSocial), {
                helpText: configuredHelpText
            }) : isWacRefresh ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {
                helpText: emailHelpText
            }) : undefined,
            Submit: inline ? null : undefined,
            Social: inline ? null : socialProviders?.length ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
                providers: $b8d6774ae7c2be16$export$143e70f94b3fb702(socialProviders)
            }) : undefined
        })
    });
};
var $b8d6774ae7c2be16$export$2e2bcd8739ae039 = $b8d6774ae7c2be16$var$UniformSignUpForm;
const $b8d6774ae7c2be16$var$lightTextColorCss = null;

});
parcelRegister("bry8i", function(module, exports) {
$parcel$export(module.exports, "InlineInputSubmitSocial", function () { return $cf45e524158d5f0c$export$4fe054d3cd5243b3; });
/* inline-input-submit-social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $cGEBM = parcelRequire("cGEBM");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");

var $kbpa7 = parcelRequire("kbpa7");

var $ieOG3 = parcelRequire("ieOG3");

var $5UiwV = parcelRequire("5UiwV");

var $2BAOV = parcelRequire("2BAOV");

var $iMoR7 = parcelRequire("iMoR7");
const $cf45e524158d5f0c$export$4fe054d3cd5243b3 = ({ helpText: helpText })=>{
    const intl = (0, $8e22h.default)();
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const defaultHelpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperTextTeam26",
        defaultMessage: "Use a work email to find teammates and get access to Rovo AI"
    });
    const emailHelpText = helpText?.trim() || defaultHelpText;
    const errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    const placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    (0, $1oC0p.useEffect)(()=>{
        const valid = (0, $gM7M2.emailIsValid)(email);
        if (!valid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(valid);
        setIsEmailValid(valid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _zulp1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                className: (0, $2jatx.default)([
                    "_syaz1kw7 _ect4bzd7 _k48powjs _1wybdlk8 _13ioglyw",
                    "_ahbq1tcg _12l21tcg"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: placeholderText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c1txw _zulppxbi _1bsb1osq _1gde1bp4 _8164utpp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _d4lf1h90 _1xlockbl _dwk3usvi _q8t51h6o _1jb3cd5j _z21jyzqy _1kkm1ylp _1lp7vrvc _19wgutpp",
                            isValid === undefined && "_zvlo4r28 _idgh1qnu",
                            isValid === false && "_xqvj1uxz _nxbcch7t",
                            isValid === true && "_xqvj1ddq _nxbcqjfz"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                            "--_2z8vrb": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue600")),
                            "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                            "--_sktsbj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime600"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1bsb1osq _89vyidpf _5rvh1wug _32nkidpf _wws01wug"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ieOG3.InlineInput), {
                                        email: email,
                                        setEmail: setEmail,
                                        isValid: isValid,
                                        setValid: setValid,
                                        errorMessageText: errorMessageText
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_ahbq1tcg _12l21tcg",
                                            "_476d1y44"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                                htmlFor: "inline_email_embedded_signup_input",
                                                className: (0, $2jatx.default)([
                                                    "_ect4bzd7 _1wyb1crf _vwz4bs82 _1pfhi2wt _tzy4txnc",
                                                    "_181nglyw"
                                                ]),
                                                style: {
                                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                                },
                                                children: emailHelpText
                                            }),
                                            isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                role: "alert",
                                                className: (0, $2jatx.default)([
                                                    "_181nglyw",
                                                    "_syaz1uxz _1wybepq8 _vwz4bs82"
                                                ]),
                                                style: {
                                                    "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                                    "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                                                },
                                                children: errorMessageText
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2BAOV.InlineSubmit), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5UiwV.InlineSeparator), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iMoR7.SocialButton), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_ahbq1tcg _12l21tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                        htmlFor: "inline_email_embedded_signup_input",
                        className: (0, $2jatx.default)([
                            "_ect4bzd7 _1wyb1crf _vwz4bs82 _1pfhi2wt _tzy4txnc",
                            "_sugaglyw"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: emailHelpText
                    }),
                    isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        role: "alert",
                        className: (0, $2jatx.default)([
                            "_sugaglyw",
                            "_syaz1uxz _1wybepq8 _vwz4bs82"
                        ]),
                        style: {
                            "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                            "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                        },
                        children: errorMessageText
                    }) : null
                ]
            })
        ]
    });
};
const $cf45e524158d5f0c$var$containerCss = null;
const $cf45e524158d5f0c$var$labelCss = null;
const $cf45e524158d5f0c$var$inputSubmitSocialContainerCss = null;
const $cf45e524158d5f0c$var$inputSubmitGroupCss = null;
const $cf45e524158d5f0c$var$inputSubmitGroupFocusCss = null;
const $cf45e524158d5f0c$var$inputCss = null;
const $cf45e524158d5f0c$var$helpTextContainerCss = null;
const $cf45e524158d5f0c$var$helpTextMobileCss = null;
const $cf45e524158d5f0c$var$helpTextCss = null;
const $cf45e524158d5f0c$var$helpErrorTextMobileCss = null;
const $cf45e524158d5f0c$var$helpErrorTextDesktopCss = null;
const $cf45e524158d5f0c$var$errorMessageCss = null;
const $cf45e524158d5f0c$var$inlineInputInvalidCss = null;
const $cf45e524158d5f0c$var$inputValidCss = null;

});
parcelRegister("ieOG3", function(module, exports) {
$parcel$export(module.exports, "InlineInput", function () { return $11df3b80482dd58e$export$36d3e0619bb09209; });
/* inline-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $78jg9 = parcelRequire("78jg9");

var $kInl4 = parcelRequire("kInl4");

var $8KJ2x = parcelRequire("8KJ2x");

var $cGEBM = parcelRequire("cGEBM");

var $gM7M2 = parcelRequire("gM7M2");

var $kbpa7 = parcelRequire("kbpa7");
const $11df3b80482dd58e$export$36d3e0619bb09209 = ({ email: email, setEmail: setEmail, isValid: isValid, setValid: setValid, errorMessageText: errorMessageText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const intl = (0, $8e22h.default)();
    const placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    const validMessage = intl.formatMessage({
        id: "gwp.accountSignin.validEmailIcon",
        defaultMessage: "Email is valid"
    });
    (0, $1oC0p.useEffect)(()=>{
        const valid = (0, $gM7M2.emailIsValid)(email);
        if (!valid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(valid);
        setIsEmailValid(valid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3ickbl _vchhusvi _1bsb1osq _1e0c1txw _4cvr1h6o _7yjtidpf _ldgnidpf _un3pidpf _29hzidpf _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _k8em1osq _bhl91osq _1xlo1osq _1j30cd5j _1o4gyzqy _a5zt1ylp",
            isValid === false && "_1s801uxz _13z4ch7t",
            isValid === true && "_1s801ddq _13z4qjfz"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
            "--_sktsbj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime600"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: "",
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _4t3i1osq _hbmn1rnp _pytk1osq _1rwq1j28 _psgk1hlo _1heubzd7 _125xf6fq _1yzy15vq _bgrh15vq _v69ygrf3 _ogxmmccc _1qtqgrf3 _n9z4a982 _509t1l2s _yizhowjs _ixrd1txw _hlcb1h6o _5ce6nqye _1wb7f6fq _1k9xmzrp _1gzemzrp _zt0yglyw _zbayidpf _bp7oagmp _k8em1osq _6kab1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                            "--_1a8xanm": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light600"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                ...fieldProps,
                                autoComplete: "email",
                                id: "inline_email_embedded_signup_input",
                                "aria-label": placeholderText,
                                onBlur: ()=>setIsReadyForInvalid(true),
                                onChange: (e)=>{
                                    setEmail(e.target.value);
                                    setTypeAheadEmail(e.target.value);
                                    fieldProps.onChange(e);
                                },
                                placeholder: placeholderText,
                                testId: "email_field",
                                type: "email",
                                value: email
                            }),
                            isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1wpz1h6o _1752gktf _w8l5gktf _chtu1tcg",
                                    "_syaz1uxz"
                                ]),
                                style: {
                                    "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kInl4))), {
                                    label: errorMessageText
                                })
                            }) : isValid === true ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1wpz1h6o _1752gktf _w8l5gktf _chtu1tcg",
                                    "_1nj11ddq"
                                ]),
                                style: {
                                    "--_sktsbj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime600"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78jg9))), {
                                    label: validMessage
                                })
                            }) : null
                        ]
                    })
                })
        })
    });
};
const $11df3b80482dd58e$var$containerCss = null;
const $11df3b80482dd58e$var$inlineInputCss = null;
const $11df3b80482dd58e$var$inlineInputInvalidCss = null;
const $11df3b80482dd58e$var$inlineInputValidCss = null;
const $11df3b80482dd58e$var$iconCss = null;
const $11df3b80482dd58e$var$invalidIconCss = null;
const $11df3b80482dd58e$var$validIconCss = null;

});
parcelRegister("kInl4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7adb5fd03a25925a35432d6cd30431e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f14a0553115fd956$var$_react = $f14a0553115fd956$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f14a0553115fd956$var$_baseNew = $f14a0553115fd956$var$_interopRequireDefault((parcelRequire("jcI35")));
function $f14a0553115fd956$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowDanger".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing statuses that signal critical issues that demand attention
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f14a0553115fd956$var$StatusWorkflowDangerIcon = (props)=>/*#__PURE__*/ $f14a0553115fd956$var$_react.default.createElement($f14a0553115fd956$var$_baseNew.default, Object.assign({
        name: "StatusWorkflowDangerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-7V9h1.5V3.5z" clip-rule="evenodd"/>`
    }, props));
$f14a0553115fd956$var$StatusWorkflowDangerIcon.displayName = 'StatusWorkflowDangerIcon';
var $f14a0553115fd956$var$_default = module.exports.default = $f14a0553115fd956$var$StatusWorkflowDangerIcon;

});


parcelRegister("5UiwV", function(module, exports) {
$parcel$export(module.exports, "InlineSeparator", function () { return $a6dd9f4a57acb821$export$55fab221c0b96fcc; });
/* inline-separator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
const $a6dd9f4a57acb821$export$55fab221c0b96fcc = ()=>{
    const intl = (0, $8e22h.default)();
    const separatorText = intl.formatMessage({
        id: "embeddedSignup.separator.or",
        defaultMessage: "or"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1wpz1h6o _syaz1hlo _1o9zidpf _ect4bzd7 _1wybf6fq _vwz41f4h _y3gn1h6o _o5721q9c"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
        },
        children: separatorText
    });
};
const $a6dd9f4a57acb821$var$inlineSeparatorCss = null;

});

parcelRegister("2BAOV", function(module, exports) {
$parcel$export(module.exports, "InlineSubmit", function () { return $ccddc125f5ee162e$export$7839993e4eae1cc3; });
/* inline-submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $cGEBM = parcelRequire("cGEBM");

var $lqyi6 = parcelRequire("lqyi6");
const $ccddc125f5ee162e$export$7839993e4eae1cc3 = ()=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    const buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        type: "submit",
        disabled: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        "data-testid": "embedded-signup-submit",
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "signup",
            "data-label": buttonText,
            "data-label-english": "Sign up"
        },
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _ect41kw7 _1wybf6fq _k48p1nn1 _4t3ickbl _1bah1h6o _1ul91wug _o5721q9c _1bsb1ns9 _15fl1n1a _1d2w1n1a _1svy1n1a _seovidpf _1rfm1osq _1rkb1osq"
        ]),
        children: buttonText
    });
};
const $ccddc125f5ee162e$var$buttonCss = null;

});

parcelRegister("iMoR7", function(module, exports) {
$parcel$export(module.exports, "SocialButton", function () { return $0d3eb5f998e1413a$export$6d89b1d283cda84a; });
/* social-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $jUqeL = parcelRequire("jUqeL");

var $cGEBM = parcelRequire("cGEBM");

var $lqyi6 = parcelRequire("lqyi6");

var $kbpa7 = parcelRequire("kbpa7");
const $0d3eb5f998e1413a$export$6d89b1d283cda84a = ()=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lqyi6.Button), {
        role: "link",
        "aria-label": intl.formatMessage({
            id: "social.label.signup",
            defaultMessage: "sign up with {provider}"
        }, {
            provider: "Google"
        }),
        onClick: ()=>onClickSocialButton("google"),
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "signup",
            "data-label": "sign up with Google",
            "data-label-english": "sign up with Google"
        },
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhkcd5j _19itlfd3 _vchhusvi _syazd34b _1e0c1txw _ect41kw7 _1wybf6fq _k48p1nn1 _zulp1kwk _4t3ickbl _1bah1h6o _1ul91wug _o5721q9c _1bsb1ns9 _erubf6fq _xwbjf6fq _jomr150w _irr3150w _1rfm1osq _1rkb1osq"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUqeL.ProviderLogo), {
                logo: "google"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: "Google"
            })
        ]
    });
};
const $0d3eb5f998e1413a$var$buttonCss = null;

});



parcelRegister("dXwUh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66223983e87b0882$export$2e2bcd8739ae039; });
/* single-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");
// eslint-disable-next-line complexity
const $66223983e87b0882$var$UniformSingleTab = (props)=>{
    const { orientation: orientation = {
        mobile: "vertical"
    }, gap: gap = {
        mobile: "0"
    } } = props;
    const gapObject = {
        mobile: gap.mobile ?? "0",
        // @ts-ignore
        tablet: gap?.tablet ?? gap.mobile ?? "0",
        // @ts-ignore
        desktop: gap?.desktop ?? gap?.tablet ?? gap.mobile ?? "0"
    };
    const styles = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        // @ts-ignore
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: // @ts-ignore
        orientation.desktop || // @ts-ignore
        orientation.tablet || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1wug _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6"
        ]),
        style: {
            "--_rkv8x9": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $6ZVlx.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $6ZVlx.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $6ZVlx.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $6ZVlx.default)(orientationObject.desktop === "horizontal" ? "row" : "column")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
            name: "tabContents"
        })
    });
};
var $66223983e87b0882$export$2e2bcd8739ae039 = $66223983e87b0882$var$UniformSingleTab;

});

parcelRegister("aeR15", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d6734395d472436$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $87vyU = parcelRequire("87vyU");

var $kK9LF = parcelRequire("kK9LF");
const $5d6734395d472436$var$mapCardsToSlidingLayout = (cards)=>cards.map((card)=>({
            title: card.title,
            color: card.color,
            icon: card.icon,
            ctaLinkUrl: card.ctaLinkUrl,
            ctaLinkText: card.ctaLinkText
        }));
const $5d6734395d472436$var$UniformSlidingLayout = (props)=>{
    const { brightnessMode: brightnessMode = "light", colorMode: colorMode = "none", flattenData: flattenData = true } = props;
    let { cards: cards } = props;
    if (flattenData) cards = (0, $87vyU.flattenSlidingLayoutCardProps)(props).cards;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kK9LF.SlidingLayout), {
        cards: $5d6734395d472436$var$mapCardsToSlidingLayout(cards),
        brightnessMode: brightnessMode,
        colorMode: colorMode
    });
};
var $5d6734395d472436$export$2e2bcd8739ae039 = $5d6734395d472436$var$UniformSlidingLayout;

});
parcelRegister("87vyU", function(module, exports) {
$parcel$export(module.exports, "flattenSlidingLayoutCardProps", function () { return $823cac3ca669dfae$export$5f5dbdd0872865aa; });

var $f2QWG = parcelRequire("f2QWG");
const $823cac3ca669dfae$export$5f5dbdd0872865aa = (props)=>{
    return {
        ...props,
        cards: (0, $f2QWG.flattenValues)(props.cards)
    };
};

});

parcelRegister("kK9LF", function(module, exports) {
$parcel$export(module.exports, "SlidingLayout", function () { return $734e627ca5482ae7$export$bd6d395cec230f31; });
/* sliding-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $734e627ca5482ae7$var$SWITCH_DELAY_MS = 2000;
const $734e627ca5482ae7$var$CONTAINER_GAP_PX = "var(--ds-space-300, 24px)";
const $734e627ca5482ae7$var$intervalFeaturedShrinking = "25%, 100%";
const $734e627ca5482ae7$var$intervalClickedToFeatured = "25%, 65%";
const $734e627ca5482ae7$var$intervalOtherCardExpanding = "37%, 50%";
const $734e627ca5482ae7$var$intervalOtherCardShrinking = "75%, 100%";
const $734e627ca5482ae7$var$featuredFromLeftToLeftSmallTop = null;
const $734e627ca5482ae7$var$featuredFromLeftToLeftSmallBottom = null;
const $734e627ca5482ae7$var$featuredFromRightToRightSmallTop = null;
const $734e627ca5482ae7$var$featuredFromRightToRightSmallBottom = null;
const $734e627ca5482ae7$var$smallTopFromLeftSmallToLeftFeatured = null;
const $734e627ca5482ae7$var$smallBottomFromLeftSmallToLeftFeatured = null;
const $734e627ca5482ae7$var$smallTopFromRightSmallToRightFeatured = null;
const $734e627ca5482ae7$var$smallBottomFromRightSmallToRightFeatured = null;
const $734e627ca5482ae7$var$smallTopFromLeftToRight = null;
const $734e627ca5482ae7$var$smallBottomFromLeftToRight = null;
const $734e627ca5482ae7$var$smallTopFromRightToLeft = null;
const $734e627ca5482ae7$var$smallBottomFromRightToLeft = null;
const $734e627ca5482ae7$var$slidingLayoutSectionStyle = null;
const $734e627ca5482ae7$var$slidingLayoutContainerInnerStyle = null;
const $734e627ca5482ae7$var$slidingLayoutStyles = null;
const $734e627ca5482ae7$var$cardStyles = null;
const $734e627ca5482ae7$var$clickableElementStyle = null;
const $734e627ca5482ae7$var$cardInnerStyle = null;
const $734e627ca5482ae7$var$cardPadding = null;
const $734e627ca5482ae7$var$cardContentStyle = null;
const $734e627ca5482ae7$var$cardTitleStyle = null;
const $734e627ca5482ae7$var$getCardColor = (color, brightnessMode, colorMode)=>{
    const tree = {
        default: {
            light: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.neutral.light200"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.neutral.light200"),
                borderColor: (0, $kbpa7.wacToken)("color.neutral.light0"),
                buttonColor: (0, $kbpa7.wacToken)("color.neutral.light0")
            },
            dark: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.neutral.light1000"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.neutral.light1000"),
                borderColor: (0, $kbpa7.wacToken)("color.neutral.light1000"),
                buttonColor: (0, $kbpa7.wacToken)("color.neutral.light1000")
            }
        },
        purple: {
            light: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.extended.purple200"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.extended.purple200"),
                borderColor: (0, $kbpa7.wacToken)("color.extended.purple500"),
                buttonColor: (0, $kbpa7.wacToken)("color.extended.purple500")
            },
            dark: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.extended.purple500"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.extended.purple500"),
                borderColor: (0, $kbpa7.wacToken)("color.extended.purple500"),
                buttonColor: (0, $kbpa7.wacToken)("color.extended.purple500")
            }
        },
        saffron: {
            light: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.extended.saffron200"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.extended.saffron200"),
                borderColor: (0, $kbpa7.wacToken)("color.extended.saffron500"),
                buttonColor: (0, $kbpa7.wacToken)("color.extended.saffron500")
            },
            dark: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.extended.saffron600"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.extended.saffron600"),
                borderColor: (0, $kbpa7.wacToken)("color.extended.saffron600"),
                buttonColor: (0, $kbpa7.wacToken)("color.extended.saffron600")
            }
        },
        lime: {
            light: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.extended.lime200"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.extended.lime200"),
                borderColor: (0, $kbpa7.wacToken)("color.extended.lime500"),
                buttonColor: (0, $kbpa7.wacToken)("color.extended.lime500")
            },
            dark: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.extended.lime500"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.extended.lime500"),
                borderColor: (0, $kbpa7.wacToken)("color.extended.lime500"),
                buttonColor: (0, $kbpa7.wacToken)("color.extended.lime500")
            }
        },
        blue: {
            light: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.extended.blue200"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.extended.blue200"),
                borderColor: (0, $kbpa7.wacToken)("color.extended.blue500"),
                buttonColor: (0, $kbpa7.wacToken)("color.extended.blue700")
            },
            dark: {
                none: "",
                backgroundColor: (0, $kbpa7.wacToken)("color.extended.blue700"),
                polygonBackgroundColor: (0, $kbpa7.wacToken)("color.extended.blue700"),
                borderColor: (0, $kbpa7.wacToken)("color.extended.blue500"),
                buttonColor: (0, $kbpa7.wacToken)("color.extended.blue700")
            }
        }
    };
    const palette = tree[color] ?? tree.default;
    return palette[brightnessMode][colorMode];
};
const $734e627ca5482ae7$export$bd6d395cec230f31 = ({ cards: cards, brightnessMode: brightnessMode = "light", colorMode: colorMode = "none" })=>{
    const intl = (0, $8e22h.default)();
    const normalizedCards = [
        0,
        1,
        2
    ].map((index)=>({
            title: cards[index]?.title ?? "",
            color: cards[index]?.color ?? "default",
            ctaLinkUrl: cards[index]?.ctaLinkUrl ?? "#",
            ctaLinkText: cards[index]?.ctaLinkText ?? "Visit link",
            icon: cards[index]?.icon
        }));
    const [cardRoles, setCardRoles] = (0, $1oC0p.useState)([
        "smallTop",
        "smallBottom",
        "featured"
    ]);
    const [featuredSide, setFeaturedSide] = (0, $1oC0p.useState)("right");
    const [isSwitching, setIsSwitching] = (0, $1oC0p.useState)(false);
    const [animationContext, setAnimationContext] = (0, $1oC0p.useState)(null);
    const [containerWidthPx, setContainerWidthPx] = (0, $1oC0p.useState)(0);
    const animationTimeoutRef = (0, $1oC0p.useRef)(null);
    const containerRef = (0, $1oC0p.useRef)(null);
    const clearAnimationTimer = ()=>{
        if (animationTimeoutRef.current !== null) {
            clearTimeout(animationTimeoutRef.current);
            animationTimeoutRef.current = null;
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        return clearAnimationTimer;
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        const containerElement = containerRef.current;
        if (!containerElement) return;
        const updateContainerWidth = ()=>{
            setContainerWidthPx(containerElement.getBoundingClientRect().width);
        };
        updateContainerWidth();
        const resizeObserver = new ResizeObserver(updateContainerWidth);
        resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    const handleExpand = (index)=>{
        if (isSwitching || cardRoles[index] === "featured") return;
        const currentFeaturedIndex = cardRoles.findIndex((role)=>role === "featured");
        if (currentFeaturedIndex === -1) return;
        const clickedRole = cardRoles[index];
        if (!clickedRole) return;
        const otherSmallIndex = cardRoles.findIndex((role, cardIndex)=>role !== "featured" && cardIndex !== index);
        const otherSmallRole = cardRoles[otherSmallIndex];
        if (otherSmallIndex === -1 || !otherSmallRole || otherSmallRole === "featured") return;
        const nextFeaturedSide = featuredSide === "left" ? "right" : "left";
        clearAnimationTimer();
        setIsSwitching(true);
        setAnimationContext({
            clickedIndex: index,
            featuredIndex: currentFeaturedIndex,
            otherIndex: otherSmallIndex,
            clickedRole: clickedRole,
            otherRole: otherSmallRole,
            nextFeaturedSide: nextFeaturedSide
        });
        animationTimeoutRef.current = window.setTimeout(()=>{
            setCardRoles((currentRoles)=>{
                const nextRoles = [
                    ...currentRoles
                ];
                nextRoles[index] = "featured";
                nextRoles[currentFeaturedIndex] = clickedRole;
                return nextRoles;
            });
            setFeaturedSide(nextFeaturedSide);
            setAnimationContext(null);
            setIsSwitching(false);
            clearAnimationTimer();
        }, $734e627ca5482ae7$var$SWITCH_DELAY_MS);
    };
    const containerHeightPx = colorMode === "polygonBackgroundColor" ? 544 : 484;
    const getCardArea = (index)=>cardRoles[index] ?? "smallTop";
    const getAnimationParticipant = (index)=>{
        if (!animationContext) return undefined;
        if (index === animationContext.clickedIndex) return "clicked";
        if (index === animationContext.featuredIndex) return "featured";
        if (index === animationContext.otherIndex) return "other";
        return undefined;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1yt41ejb _17jj1hlo _r232cd5j",
            `style_${colorMode} brightness_${brightnessMode}`
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbg505 _p12f1osq"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: containerRef,
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1tke1hqu _kqswh2mm _1e0c11p5 _zulp1ejb _yv0e16hb _2z05fsjm _51kj1ule _18reu60i _14wb1p52 _1mjb1txw _na0i1bp4 _2osn1ejb _1kne1wug _1jgoidpf",
                    `sliding-layout-container style_${colorMode} featured-side_${featuredSide} ${isSwitching ? "is-switching" : ""}`
                ]),
                style: {
                    "--sliding-layout-container-width": `${containerWidthPx}px`,
                    "--sliding-layout-container-height": `${containerHeightPx}px`,
                    "--sliding-layout-gap": $734e627ca5482ae7$var$CONTAINER_GAP_PX,
                    "--sl-small-width": "calc((var(--sliding-layout-container-width) - (2 * var(--sliding-layout-gap))) / 3)",
                    "--sl-featured-width": "calc((2 * var(--sl-small-width)) + var(--sliding-layout-gap))",
                    "--sl-small-height": "calc((var(--sliding-layout-container-height) - var(--sliding-layout-gap)) / 2)",
                    "--sl-height-featured": "var(--sliding-layout-container-height)",
                    "--sl-left-featured-left": "0px",
                    "--sl-left-featured-right": "calc(var(--sliding-layout-container-width) - var(--sl-featured-width))",
                    "--sl-left-small-on-right-side": "calc(var(--sliding-layout-container-width) - var(--sl-small-width))",
                    "--sl-left-small-on-left-side": "0px",
                    "--sl-top-featured": "0px",
                    "--sl-top-small-top": "0px",
                    "--sl-top-small-bottom": "calc(var(--sl-small-height) + var(--sliding-layout-gap))",
                    "--sl-animation-duration": `${$734e627ca5482ae7$var$SWITCH_DELAY_MS}ms`
                },
                children: normalizedCards.map((card, index)=>{
                    const cardArea = getCardArea(index);
                    const isFeatured = cardArea === "featured";
                    const participant = getAnimationParticipant(index);
                    const isAnimating = Boolean(participant && animationContext);
                    const directionClass = animationContext ? animationContext.nextFeaturedSide : "none";
                    const clickedRoleClass = animationContext ? animationContext.clickedRole : "none";
                    const cardStyle = {
                        "--sliding-layout-card-color": $734e627ca5482ae7$var$getCardColor(card.color ?? "default", brightnessMode, colorMode)
                    };
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _k8m01l1k _1oec1doz _6fl41ytf _2rkovwyg _1m9pau6p _uumyhg3g _1kua1vcn _12ygstnw _3mrk1kv4 _1tij1ytf _1l5dq7pw _5g2ekb7n _1p9bglyw _1fnro96w _nwzl17cu _8skb1mzr _e176oycg _3yyk1pb8 _161ga5ei _1run11tz _8onc1wmx _lemzt88j _ix9gcp8f _ehvy1jsu _vrrtsi3p _emf4egat _1idj11wp _j1pdcs5v _z115h2mm _1s4p1osq _nqop1wug _16mq1wug _1kne1wug _rqkdglyw _13hzglyw _1jgoidpf _f19eglyw _ahee1ule _qeckglyw _15dkglyw _1vmpidpf _xvf3gx0z _1nu6idpf _zs4repas _o83e1x9s _1e5rgoum _19frcd5j _16ygpmk4 _fszcpmk4 _154zpmk4 _zc5t1hlo _ztaucd5j _1tymcd5j _1mipcd5j _1wicwzwm _8dmgwzwm _1xvwnqa1 _7locnqa1 _facyt94y _b3xzt94y _wibwxv17 _5z0rxv17 _sxj2t7xp _1ih0t7xp _1654130s _12ye130s _1h4h1sjd _1enm1sjd _ewbhyh40 _19zrnqa1 _1wtaidpf _1u3nnqa1 _1m651vwv _1hxmyh40 _14fs1sjd _285b1sjd _qodz1o8l _pogitlke _pfk4glyw _8r1bkb7n _1k8vnqa1 _y6hxrwpw _lxl41ekt _1g6q1ssb _197k19bv _f9ti19bv _76jg19bv _1o8j19bv _dztwgktf _19qnyh40 _53ln1crf _1o0k1ul9 _12id14y2 _1pt919bv _62ym14y2 _5r4j19bv _1xkst94y _1u891sjd _7vrn1sjd _gicdcd5j _10ql1sjd _17551j28 _qll91j28 _bld21j28 _1kmi1j28 _1igy1r31 _k6sx1r31 _1lh31r31 _1x171r31 _9h8w1sjd _nb7o1sjd _1ies1hlo _n76r1hlo _eai01hlo _o9ia1hlo _15dccd5j _1l3ocd5j _ozv11hlo _1wky1hlo _1xw31hlo _jjgt1hlo _120q1sjd _zfdc1sjd _1jk8cd5j _1thmcd5j _d2y9cd5j _1q5ocd5j _1u8ncd5j _10q0pmk4 _zme9pmk4 _5ypzcd5j _2vetcd5j _dhogcd5j _d8vjcd5j _ywwk1sjd _17051sjd _17vgpmk4 _xplkkb7n _6jpk1kw7 _qv791kw7 _1xrw1hlo _1fak1hlo _qg6kcd5j _17u2cd5j _hu5z1hlo _1oge1hlo _zu6l1sjd _m64l1sjd _v562cd5j _m5jb1sjd _9qticd5j _ndaccd5j _1fzy1hlo _tfzm1hlo _exmncd5j _hhmgcd5j _1uuo1sjd _15e81sjd _1r3cpmk4 _a44i1sjd",
                            `card${index} switching_${isSwitching} style_${colorMode} brightness_${brightnessMode} color_${card.color} side_${featuredSide} role_${cardArea} ${isFeatured && !isSwitching ? "featured" : "small"} ${isAnimating ? "is-animating" : ""} ${participant ? `participant_${participant}` : ""} clicked-role_${clickedRoleClass} direction_${directionClass}`
                        ]),
                        style: {
                            ...cardStyle,
                            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                            "--_15esrws": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.quick-entrance")),
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000")),
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _1bsb1osq _4t3i1osq _z115h2mm",
                                "card-inner" + index
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1yt41ejb _h2snoahv",
                                    `card-padding style_${colorMode}`
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_8hrz1nty _v564f1gs _p12f1f28 _8fz61j3l _1qkj18ws _1q8u1h7a",
                                        isFeatured && !isSwitching ? "featured" : "small"
                                    ]),
                                    children: [
                                        card.icon && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                            image: {
                                                width: 30,
                                                height: 30,
                                                src: card.icon,
                                                alt: ""
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                            className: (0, $2jatx.default)([
                                                "_vwz4cjiy _k48p9y44 _1wyb1ejb _18s812pl"
                                            ]),
                                            children: card.title
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            className: `buttonelement expander style_${colorMode} brightness_${brightnessMode}`,
                                            children: "\uFF0B"
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                            disabled: isSwitching,
                                            className: (0, $2jatx.default)([
                                                "_19itglyw _kqswstnw _1r04idpf _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _y4c0glyw _1mjbglyw",
                                                `clickable-element ${isFeatured ? "featured" : "small"}`
                                            ]),
                                            onClick: ()=>handleExpand(index),
                                            "aria-label": intl.formatMessage({
                                                id: "adg4.sliding-layout.expand-button-aria-label",
                                                defaultMessage: "Expand"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                            className: `buttonelement visitor style_${colorMode} brightness_${brightnessMode} color_${card.color}`,
                                            href: card.ctaLinkUrl,
                                            children: card.ctaLinkText
                                        })
                                    ]
                                })
                            })
                        })
                    }, card.title);
                })
            })
        })
    });
};

});


parcelRegister("kfc2o", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $27eb9bd54e7ff40d$export$2e2bcd8739ae039; });
/* split-color-background-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");
const $27eb9bd54e7ff40d$var$UniformSplitColorBackgroundContainer = ({ topColor: topColor, bottomColor: bottomColor, sectionDivider: sectionDivider, extendBackgroundColor: extendBackgroundColor })=>{
    const baseStyle = null;
    const minHeightStyle = null;
    const horizontalStyle = null;
    const highLeftStyle = null;
    const highRightStyle = null;
    const polygonStyle = null;
    const coverStyles = null;
    const sectionDividerComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3iq9zu _1bsb1osq _11q7jj3k _152t1ssb _t9ec1i34 _1kt9b3bt _cfu11ule _kfgt1osq _1mp41osq _1cs8stnw _iajmidpf _1rus1utj",
            bottomColor === "transparent" && sectionDivider === "high-left" && "_mkrz7yzi",
            bottomColor === "transparent" && sectionDivider === "high-right" && "_mkrz1swj",
            bottomColor === "transparent" && sectionDivider === "polygon" && "_mkrz1ljl",
            sectionDivider === "high-left" && "_tgsmte2m",
            sectionDivider === "high-right" && "_tgsmrjfx",
            sectionDivider === "polygon" && "_tgsmwog4"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        }
    });
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsbauwl _4t3i1osq _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s",
            sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        },
        children: sectionDivider && sectionDividerComponent
    });
    const slotWrapper = ({ items: items })=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _9luy1wqb _ce5au29b _wfa7llbu",
            sectionDivider && "_1tkeq9zu",
            !extendBackgroundColor && sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !extendBackgroundColor && !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $6ZVlx.default)(topColor),
            "--_130a3qa": (0, $6ZVlx.default)(bottomColor)
        },
        children: [
            sectionDivider && !extendBackgroundColor && sectionDividerComponent,
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "component",
                wrapperComponent: sectionDivider ? slotWrapper : undefined
            })
        ]
    });
};
var $27eb9bd54e7ff40d$export$2e2bcd8739ae039 = $27eb9bd54e7ff40d$var$UniformSplitColorBackgroundContainer;

});

parcelRegister("3rWcE", function(module, exports) {
$parcel$export(module.exports, "UniformStatsSection", function () { return $b524ec055947d1b4$export$a5aec67e611930b9; });

var $7VQPk = parcelRequire("7VQPk");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");
const $b524ec055947d1b4$export$a5aec67e611930b9 = (props)=>{
    const statsProps = {
        headerText: props.title,
        bigStat: {
            stat: props.primaryStatNumber,
            statText: props.primaryStatDescription,
            statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: props.primaryStatSymbolCharacter,
                symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: props.secondaryStatNumber,
                statText: props.secondaryStatDescription,
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.secondaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            },
            {
                stat: props.tertiaryStatNumber,
                statText: props.tertiaryStatDescription,
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.tertiaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Fnxt.Stats), {
        ...statsProps
    });
};

});

parcelRegister("j4sH0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b09338c9a9b6a724$export$2e2bcd8739ae039; });
/* sub-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $b09338c9a9b6a724$var$lightTextStyles = null;
const $b09338c9a9b6a724$var$isDarkBackgroundColor = (color)=>{
    return color ? [
        "#1868DB",
        "#101214"
    ].includes(color) : false;
};
const $b09338c9a9b6a724$var$UniformsubProduct = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3i7urh _1bsb7urh"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: props.imageUrl,
                            alt: props.imageAlt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4bzd7 _1wyb1l3r _zg8l4jg8 _k48p1nn1 _vwz4dlk8",
                    $b09338c9a9b6a724$var$isDarkBackgroundColor(props.backgroundColor) && "_syazcd5j"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: props.title
            })
        ]
    });
};
var $b09338c9a9b6a724$export$2e2bcd8739ae039 = $b09338c9a9b6a724$var$UniformsubProduct;

});

parcelRegister("evFps", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $97121cc693296ff7$export$2e2bcd8739ae039; });
/* tabs-12-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $2axoc = parcelRequire("2axoc");

var $kbpa7 = parcelRequire("kbpa7");

var $7kpd6 = parcelRequire("7kpd6");

var $cwAPf = parcelRequire("cwAPf");

var $i4BST = parcelRequire("i4BST");
const $97121cc693296ff7$var$uniformTabsContainerStyles = null;
const $97121cc693296ff7$var$UniformTabs12Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false, tabSize: tabSize = "large" })=>{
    const isWacRefresh = (0, $i4BST.useWacRefresh)();
    const renderTabs = (0, $1oC0p.useCallback)(({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            const params = // @ts-expect-error props doesn't exist on type
            item.props?.children?.props?.data?.parameters;
            return {
                id: params?.id?.value ?? `tab-${index}`,
                title: params?.title?.value,
                iconUrl: params?.iconUrl?.value,
                tabComponent: item
            };
        });
        if (isWacRefresh) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwAPf.TabsSection), {
            tabsData: tabsData,
            tabSize: tabSize
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kpd6.TabsSection), {
            alignment: "center",
            tabsData: tabsData,
            tabSize: tabSize,
            bgColor: bgColor,
            enableRovoBorder: enableRovoBorder,
            enableResponsiveTabSize: enableResponsiveTabSize
        });
    }, [
        bgColor,
        enableRovoBorder,
        enableResponsiveTabSize
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "8",
                tabletLayout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                    title: headerText,
                    text: subHeaderText,
                    titleAs: "h2",
                    alignment: isWacRefresh ? {
                        mobile: "start",
                        tablet: "center",
                        desktop: "center"
                    } : "center"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $97121cc693296ff7$export$2e2bcd8739ae039 = $97121cc693296ff7$var$UniformTabs12Col;

});
parcelRegister("7kpd6", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $55e394e1b826b27b$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $4q5Ua = parcelRequire("4q5Ua");

var $6Iidb = parcelRequire("6Iidb");

var $kFhJA = parcelRequire("kFhJA");

var $aeZV4 = parcelRequire("aeZV4");
const $55e394e1b826b27b$export$502de1d4d55224c1 = ({ alignment: alignment = "start", tabsData: tabsData, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $aeZV4.Tabs), {
            tabIds: tabsData.map((tab)=>tab.id),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Iidb.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $4q5Ua.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        tabSize === "large" && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $kFhJA.TabPanel), {
                            panelIndex: index,
                            id: tab.id || `tab-${index}`,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});
parcelRegister("4q5Ua", function(module, exports) {
$parcel$export(module.exports, "DraggableTab", function () { return $2726a747230786c6$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $aeZV4 = parcelRequire("aeZV4");
const $2726a747230786c6$export$3a29ca89d63c5c20 = ({ id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false, children: children, ...props })=>{
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $aeZV4.useTabsContext)();
    const startX = (0, $1oC0p.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $1oC0p.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
        // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            if (tabRef.current.parentElement?.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: "smooth"
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event("select"));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        startX.current = e.clientX ?? 0;
        props.onMouseDown?.(e);
    };
    const onClick = (0, $1oC0p.useCallback)((e)=>{
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        props.onClick?.(e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === "Space" || e.code === "Enter") {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === "bgWhite" ? (0, $kbpa7.wacToken)("color.neutral.light200") : (0, $kbpa7.wacToken)("color.neutral.light0");
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...props,
        // @ts-expect-error not on type
        ref: tabRef,
        className: className,
        children: !!children ? /*#__PURE__*/ (0, $1oC0p.cloneElement)(children, {
            onMouseDown: onMouseDown,
            onClick: onClick,
            onKeyDown: onKeyDown,
            ...dataEventProps
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
            type: "button",
            id: `tab${id}`,
            role: "tab",
            "aria-selected": isTabSelected,
            "aria-controls": `panel${id}`,
            "aria-label": label,
            title: label,
            tabIndex: isTabSelected ? 0 : -1,
            className: (0, $2jatx.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko17td _19itq75r _80omtlke _4cvx17la _8y9r1hlo",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1ybm _1s7917la",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === "large" && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === "small" && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === "large" && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === "small" && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? "currentTab" : ""}`
            ]),
            // how to adjust for different page? or just remove?
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            // @ts-expect-error not on type
            onMouseDown: onMouseDown,
            // @ts-expect-error not on type
            onClick: onClick,
            onKeyDown: onKeyDown,
            ...dataEventProps,
            style: {
                "--_7aj7gm": (0, $6ZVlx.default)(tabColor),
                "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill")),
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        !enableResponsiveTabSize && tabSize === "large" && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === "small" && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: `${iconUrl || ""}`,
                        alt: "",
                        draggable: false
                    })
                }),
                title
            ]
        })
    });
};
$2726a747230786c6$export$3a29ca89d63c5c20.tabsRole = "Tab";

});
parcelRegister("aeZV4", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return $0f3c3abb0b914582$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $0f3c3abb0b914582$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $aHkxS = parcelRequire("aHkxS");

var $jgQie = parcelRequire("jgQie");
const $0f3c3abb0b914582$var$TabsContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $0f3c3abb0b914582$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $1oC0p.useContext)($0f3c3abb0b914582$var$TabsContext);
    if (!context) throw new Error("useTabsContext must be used within Tabs");
    return context;
};
let $0f3c3abb0b914582$var$nextId = 0;
function $0f3c3abb0b914582$var$getTabIndexFromUrl(tabIds) {
    if (typeof window === "undefined") return null;
    const params = new URLSearchParams(window.location.search);
    const tabParam = params.get("tab");
    if (!tabParam) return null;
    const index = tabIds.indexOf(tabParam);
    return index !== -1 ? index : null;
}
const $0f3c3abb0b914582$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, tabIds: externalTabIds, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const resolvedInitialTab = (()=>{
        if (externalTabIds && externalTabIds.length > 0) {
            const urlIndex = $0f3c3abb0b914582$var$getTabIndexFromUrl(externalTabIds);
            if (urlIndex !== null) return urlIndex;
        }
        return initialTab ?? 0;
    })();
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(resolvedInitialTab);
    const [userSelected, setUserSelected] = (0, $1oC0p.useState)(false);
    const [focus, setFocus] = (0, $1oC0p.useState)(false);
    const tabIds = (0, $1oC0p.useRef)([]);
    const contextId = (0, $1oC0p.useRef)(`:tabs:${id ? id : $0f3c3abb0b914582$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD,
        ...useInViewOptionsContainer
    });
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $jgQie.deepForEach)(children, (child)=>{
            if ((0, $jgQie.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        const tabsCount = getTabsCount();
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - tabsCount;
        // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
        // Map children to dynamically setup refs
        return (0, $jgQie.deepMap)(children, (child)=>{
            let result = child;
            // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement;
            // Get the active element id
            const activeElementId = windowAvailable ? window.document.activeElement?.id : null;
            // Clone TabList and Tab components to have refs
            if ((0, $jgQie.isTabList)(child)) {
                let listIndex = 0;
                // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $1oC0p.Children).toArray(child.props.children).filter((0, $jgQie.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                    children: (0, $jgQie.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $1oC0p.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $jgQie.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = {
                    ...existingProps,
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                };
                panelIndex++;
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, props);
            }
            return result;
        });
    }
    const unsetUserSelected = ()=>{
        setUserSelected(false);
    };
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
        setUserSelected(true);
        if (externalTabIds && externalTabIds.length > tabIndex && typeof window !== "undefined") {
            const params = new URLSearchParams(window.location.search);
            params.set("tab", externalTabIds[tabIndex]);
            const newUrl = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
            window.history.replaceState(null, "", newUrl);
        }
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true);
        // This prevents scrollbars from moving around
        e.preventDefault();
    };
    // Reset the userSelected state when the section is visible again
    (0, $1oC0p.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]);
    // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($0f3c3abb0b914582$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            unsetUserSelected: unsetUserSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("jgQie", function(module, exports) {
$parcel$export(module.exports, "isTab", function () { return $5fe887815c1bacdb$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $5fe887815c1bacdb$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $5fe887815c1bacdb$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $5fe887815c1bacdb$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $5fe887815c1bacdb$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $5fe887815c1bacdb$export$519ada94592b97fc; });

var $1oC0p = parcelRequire("1oC0p");
function $5fe887815c1bacdb$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $5fe887815c1bacdb$export$bdc9792d96913679 = $5fe887815c1bacdb$var$makeTypeChecker("Tab");
const $5fe887815c1bacdb$export$9c326233b9ae5588 = $5fe887815c1bacdb$var$makeTypeChecker("TabList");
const $5fe887815c1bacdb$export$9e12445c79db89b = $5fe887815c1bacdb$var$makeTypeChecker("TabPanel");
const $5fe887815c1bacdb$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $5fe887815c1bacdb$var$isTabChild(child) {
    return $5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9c326233b9ae5588(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child);
}
function $5fe887815c1bacdb$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($5fe887815c1bacdb$export$dbaa4172856e20ab(child)) return (0, $1oC0p.cloneElement)(child, {
        ...child.props,
        ...additionalProps
    });
    return child;
}
function $5fe887815c1bacdb$export$ce7eaaed37329a1b(children, callback) {
    return (0, $1oC0p.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($5fe887815c1bacdb$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $1oC0p.cloneElement)(child, {
            ...child.props,
            children: $5fe887815c1bacdb$export$ce7eaaed37329a1b(child.props.children, callback)
        });
        return child;
    });
}
function $5fe887815c1bacdb$export$519ada94592b97fc(children, callback) {
    return (0, $1oC0p.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($5fe887815c1bacdb$export$9c326233b9ae5588(child)) callback(child, index);
            $5fe887815c1bacdb$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});



parcelRegister("6Iidb", function(module, exports) {
$parcel$export(module.exports, "DraggableTabList", function () { return $5334c6b54e489af6$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $aeZV4 = parcelRequire("aeZV4");
const $5334c6b54e489af6$export$dbb4ac5a817c6612 = ({ alignment: alignment = "start", tabSize: // @ts-expect-error unused
// eslint-disable-next-line @typescript-eslint/no-unused-vars
tabSize = "large", children: children })=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const mouseDown = (0, $1oC0p.useRef)(false);
    const startX = (0, $1oC0p.useRef)(0);
    const scrollLeft = (0, $1oC0p.useRef)(0);
    const canDrag = (0, $1oC0p.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $aeZV4.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        if (!canDrag.current) return;
        // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener("mouseup", stopDragging);
        document.addEventListener("mousemove", move);
        mouseDown.current = true;
        startX.current = (touch && touch.touches[0] ? touch.touches[0].clientX : mouse?.clientX) ?? 0;
        scrollLeft.current = containerRef.current?.scrollLeft ?? 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
        // Stop listening for mouseup and mousemove events
        document.removeEventListener("mouseup", stopDragging);
        document.removeEventListener("mousemove", move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $1oC0p.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector(".tab-panels");
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute("style", `padding-left: calc(${tabPanelsStyle?.marginLeft} + ${tabPanelsStyle?.paddingLeft});`);
                } else if (alignment === "start") containerRef.current.setAttribute("style", "margin-inline: 0px; padding-inline: 0px;");
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1reo15vq _p12f1osq _195g1wug _18zrzwfg _11q81vi7 _su071wqb _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-expect-error type
            onTouchStart: (e)=>startDragging(undefined, e),
            // @ts-expect-error type
            onMouseDown: (e)=>startDragging(e),
            onTouchEnd: (e)=>{
                // @ts-expect-error type
                move(undefined, e);
                stopDragging();
            },
            // @ts-expect-error type
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $5334c6b54e489af6$var$tabsContainerStyles = null;
$5334c6b54e489af6$export$dbb4ac5a817c6612.tabsRole = "TabList";

});

parcelRegister("kFhJA", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $73f95d72bd57759d$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");

var $jgQie = parcelRequire("jgQie");

var $aeZV4 = parcelRequire("aeZV4");
const $73f95d72bd57759d$var$hidePanelStyle = null;
const $73f95d72bd57759d$export$3d96ec278d3efce4 = ({ forceRender: forceRender, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole, ...props })=>{
    const { isCurrentTab: isCurrentTab } = (0, $aeZV4.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { css: existingCss, ...propsWithoutCss } = props;
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith("aria-") && key !== "role"));
    const inlineHideStyle = !isTabSelected && !forceRender ? {
        display: "none"
    } : undefined;
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...filteredProps,
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$73f95d72bd57759d$export$3d96ec278d3efce4.tabsRole = "TabPanel";

});


parcelRegister("cwAPf", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $0addd04cdd862bb0$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kbpa7 = parcelRequire("kbpa7");

var $60ByZ = parcelRequire("60ByZ");

var $lDmb2 = parcelRequire("lDmb2");

var $1dc5i = parcelRequire("1dc5i");
const $0addd04cdd862bb0$var$getResolvedTabId = (tab, index)=>tab.id ?? `tab-${index + 1}`;
const $0addd04cdd862bb0$var$getTabIdFromHash = (tabsData)=>{
    if (typeof window === "undefined") return undefined;
    const hash = window.location.hash.slice(1);
    return tabsData.find((tab, index)=>$0addd04cdd862bb0$var$getResolvedTabId(tab, index) === hash) ? hash : undefined;
};
const $0addd04cdd862bb0$var$sectionStyles = null;
const $0addd04cdd862bb0$var$tabListInnerContainerStyles = null;
// Single-cell grid that stacks every TabPanel in the same `gridArea: 1 / 1`,
// so the active panel and inactive panels share the same screen position.
// The container auto-sizes to the tallest panel — no layout shift between
// tabs, and we get a true opacity-only cross-fade. Same idiom as
// `customer-testimonials` (panel grid: 1fr / 1fr). Spec: GWP-11578.
const $0addd04cdd862bb0$var$panelStackStyles = null;
const $0addd04cdd862bb0$export$502de1d4d55224c1 = ({ tabsData: tabsData, tabSize: tabSize = "large" })=>{
    const [activeTabId, setActiveTabId] = (0, $1oC0p.useState)(()=>$0addd04cdd862bb0$var$getTabIdFromHash(tabsData) ?? (tabsData[0] ? $0addd04cdd862bb0$var$getResolvedTabId(tabsData[0], 0) : undefined));
    const handleTabSelect = (tabId)=>{
        setActiveTabId(tabId);
        // Update URL hash without scrolling
        window.history.replaceState(null, "", `#${tabId}`);
    };
    // Listen for browser back/forward navigation
    (0, $1oC0p.useEffect)(()=>{
        const handleHashChange = ()=>{
            const tabId = $0addd04cdd862bb0$var$getTabIdFromHash(tabsData);
            if (tabId) setActiveTabId(tabId);
        };
        window.addEventListener("hashchange", handleHashChange);
        return ()=>{
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, [
        tabsData
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpoahv _pdlmxncg _1es1idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "10",
                tabletLayout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_195g1wug _p12f1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lDmb2.TabList), {
                        activeTabId: activeTabId,
                        children: tabsData.map((tab, index)=>{
                            const resolvedId = $0addd04cdd862bb0$var$getResolvedTabId(tab, index);
                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $60ByZ.Tab), {
                                tabId: resolvedId,
                                index: index,
                                title: tab.title,
                                isActive: resolvedId === activeTabId,
                                onTabSelect: handleTabSelect,
                                tabSize: tabSize
                            }, resolvedId);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _yv0ehkll _2z05hkll"
                    ]),
                    children: tabsData.map((tab, index)=>{
                        const resolvedId = $0addd04cdd862bb0$var$getResolvedTabId(tab, index);
                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1dc5i.TabPanel), {
                            id: resolvedId,
                            isActive: resolvedId === activeTabId,
                            children: tab.tabComponent
                        }, resolvedId);
                    })
                })
            })
        ]
    });
};

});
parcelRegister("60ByZ", function(module, exports) {
$parcel$export(module.exports, "Tab", function () { return $cac7b5f11fd9c462$export$3e41faf802a29e71; });
/* tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");
const $cac7b5f11fd9c462$var$listItemStyles = null;
const $cac7b5f11fd9c462$var$tabLinkStyles = null;
const $cac7b5f11fd9c462$var$inactiveTabStyles = null;
const $cac7b5f11fd9c462$var$activeTabStyles = null;
const $cac7b5f11fd9c462$var$largeTabSizingStyles = null;
const $cac7b5f11fd9c462$var$smallTabSizingStyles = null;
const $cac7b5f11fd9c462$export$3e41faf802a29e71 = ({ tabId: tabIdProp, index: index = 0, title: title, isActive: isActive = false, onTabSelect: onTabSelect, tabSize: tabSize })=>{
    const tabId = tabIdProp ?? `tab-${index}`;
    const tabRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = (0, $1oC0p.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "tab",
            actionSubjectId: "wacRefreshTab",
            source: "tabsMenu",
            attributes: {
                label: title,
                tabId: tabId,
                tabIndex: index
            }
        }).fire();
        onTabSelect?.(tabId);
    }, [
        onTabSelect,
        tabId,
        title,
        index,
        createAnalyticsEvent
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onTabSelect?.(tabId);
            return;
        }
        const currentTab = tabRef.current;
        const tabList = currentTab?.closest('[role="tablist"]');
        if (!tabList || !currentTab) return;
        const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
        const currentIndex = tabs.indexOf(currentTab);
        if (currentIndex === -1) return;
        let nextIndex = null;
        switch(e.key){
            case "ArrowRight":
                nextIndex = (currentIndex + 1) % tabs.length;
                break;
            case "ArrowLeft":
                nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                break;
            case "Home":
                nextIndex = 0;
                break;
            case "End":
                nextIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        e.preventDefault();
        tabs[nextIndex]?.click();
    }, [
        onTabSelect,
        tabId
    ]);
    // Track previous active state to only focus on changes, not initial mount
    const wasActive = (0, $1oC0p.useRef)(isActive);
    (0, $1oC0p.useEffect)(()=>{
        if (isActive && !wasActive.current && tabRef.current) tabRef.current.focus();
        wasActive.current = isActive;
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        "data-tab-id": tabId,
        role: "presentation",
        className: (0, $2jatx.default)([
            "_kqswh2mm _1pbykb7n _1hu1v2br _1e0c1txw _qtt8glyw _80omtlke"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            ref: tabRef,
            href: `#${tabId}`,
            role: "tab",
            id: `tab-${tabId}`,
            "aria-controls": tabId,
            "aria-selected": isActive,
            tabIndex: isActive ? 0 : -1,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            // Disable the browser's built-in link-drag behavior. Without
            // this, mousedown + small movement on the anchor fires
            // `dragstart` instead of `click`, silently swallowing the
            // tab selection.
            draggable: false,
            onDragStart: (e)=>e.preventDefault(),
            "data-event-container": "tab",
            "data-event-id": tabId,
            "data-event-label": title,
            className: (0, $2jatx.default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _1rjcu2gc _o5721q9c _2rko17td _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke _v564cpn1 _12ji1r31 _1qu2glyw _12y31o36 _uiztglyw _1mymglyw _sedtglyw _k48pbfng",
                tabSize === "large" && "_1wybf6fq _vwz41ou6 _18zr1ejb _3p1cgktf _py5o1f4h _owpuxy5q _fz891tcg _1ol9zwfg _ecdx1jfw",
                tabSize === "small" && "_1wyb7vkz _vwz41tcg _18zrv47k _owpu1f4h _fz89f6fq _1ol91ou6 _ecdxxy5q",
                isActive ? "_syazcd5j _1j301hlo _1ygb1uu4 _1ah3myb0" : "_syaz1hlo _1j30150w _1ygbyxmz _1ah312gs _o7ksglyw _30l317la"
            ]),
            style: {
                "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill")),
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
            },
            children: title
        })
    });
};

});

parcelRegister("lDmb2", function(module, exports) {
$parcel$export(module.exports, "TabList", function () { return $121910c2e808e15b$export$e51a686c67fdaa2d; });
/* tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $28sf5 = parcelRequire("28sf5");
const $121910c2e808e15b$var$tabListStyles = null;
const $121910c2e808e15b$var$highlightStyles = null;
const $121910c2e808e15b$var$tabListContainerStyles = null;
const $121910c2e808e15b$var$scrollAreaStyles = null;
const $121910c2e808e15b$var$navButtonStyles = null;
const $121910c2e808e15b$var$hiddenNavButtonStyles = null;
const $121910c2e808e15b$var$fadeBaseStyles = null;
const $121910c2e808e15b$var$fadeStartStyles = null;
const $121910c2e808e15b$var$fadeEndStyles = null;
const $121910c2e808e15b$var$hiddenFadeStyles = null;
const $121910c2e808e15b$export$e51a686c67fdaa2d = ({ children: children, activeTabId: activeTabId })=>{
    const intl = (0, $8e22h.default)();
    const { scrollableRef: scrollableRef, highlightRef: highlightRef, isPreviousInactive: isPreviousInactive, isNextInactive: isNextInactive, handleScroll: handleScroll } = (0, $28sf5.useScrollableTabList)(activeTabId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScrollLeft = (0, $1oC0p.useCallback)(()=>{
        handleScroll(-1);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "scrollTabsLeft",
            source: "tabScrollControl",
            attributes: {
                label: "scroll tabs left"
            }
        }).fire();
    }, [
        handleScroll,
        createAnalyticsEvent
    ]);
    const handleScrollRight = (0, $1oC0p.useCallback)(()=>{
        handleScroll(1);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "scrollTabsRight",
            source: "tabScrollControl",
            attributes: {
                label: "scroll tabs right"
            }
        }).fire();
    }, [
        handleScroll,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _11q7150w _1j301j28 _2rko1jfw _1yt4u2gc _1bsb1ns9 _p12f1osq"
        ]),
        style: {
            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleScrollLeft,
                "aria-label": intl.formatMessage({
                    id: "tab-list.scroll-left",
                    defaultMessage: "Scroll tabs left"
                }),
                tabIndex: isPreviousInactive ? -1 : 0,
                "aria-hidden": isPreviousInactive,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19itglyw _80omtlke _1yt4119w _1ul91ejb _1tke1ejb _syaz1hlo _1o9zidpf _tzy4kb7n _v5641hrg _sugaglyw",
                    isPreviousInactive && "_tzy4idpf _lcxvglyw _1bsbidpf _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "7",
                    height: "12",
                    viewBox: "0 0 7 12",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M5.8335 10.8333L0.833496 5.83334L5.8335 0.833344",
                        stroke: (0, $kbpa7.wacToken)("color.primary.black"),
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _u7coidpf _1bsb1ejb _lcxvglyw _1pbycs5v _v5641hrg",
                            "_1e02idpf _11q71dsl",
                            isPreviousInactive && "_tzy4idpf"
                        ]),
                        style: {
                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                        ref: scrollableRef,
                        role: "tablist",
                        "aria-orientation": "horizontal",
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e0c1txw _4cvr1h6o _1bsb1osq _1reo15zi _rjfvx6dd _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kpfhglyw _8164u2gc _1uvfzwfg _1wwwzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                ref: highlightRef,
                                "aria-hidden": "true",
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _4t3i1osq _2rkoxy5q _11q71hlo _sugaglyw _v5641r0g _lcxvglyw _sedtglyw"
                                ]),
                                style: {
                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                }
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _u7coidpf _1bsb1ejb _lcxvglyw _1pbycs5v _v5641hrg",
                            "_rjxpidpf _11q7cwo5",
                            isNextInactive && "_tzy4idpf"
                        ]),
                        style: {
                            "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: handleScrollRight,
                "aria-label": intl.formatMessage({
                    id: "tab-list.scroll-right",
                    defaultMessage: "Scroll tabs right"
                }),
                tabIndex: isNextInactive ? -1 : 0,
                "aria-hidden": isNextInactive,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _11q7glyw _19itglyw _80omtlke _1yt4119w _1ul91ejb _1tke1ejb _syaz1hlo _1o9zidpf _tzy4kb7n _v5641hrg _sugaglyw",
                    isNextInactive && "_tzy4idpf _lcxvglyw _1bsbidpf _1ul9idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "7",
                    height: "12",
                    viewBox: "0 0 7 12",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0.833496 10.8333L5.8335 5.83334L0.833496 0.833344",
                        stroke: (0, $kbpa7.wacToken)("color.primary.black"),
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    });
};

});
parcelRegister("28sf5", function(module, exports) {
$parcel$export(module.exports, "useScrollableTabList", function () { return $ef69e28b94f66947$export$370d3ad9e0600bac; });

var $1oC0p = parcelRequire("1oC0p");
const $ef69e28b94f66947$var$SCROLL_AMOUNT = 200;
const $ef69e28b94f66947$var$SCROLL_PADDING = 48;
const $ef69e28b94f66947$var$prefersReducedMotion = ()=>typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $ef69e28b94f66947$export$370d3ad9e0600bac = (activeTabId)=>{
    const scrollableRef = (0, $1oC0p.useRef)(null);
    const highlightRef = (0, $1oC0p.useRef)(null);
    const [isPreviousInactive, setIsPreviousInactive] = (0, $1oC0p.useState)(true);
    const [isNextInactive, setIsNextInactive] = (0, $1oC0p.useState)(true);
    const isFirstRender = (0, $1oC0p.useRef)(true);
    const isManualScrolling = (0, $1oC0p.useRef)(false);
    const isProgrammaticScroll = (0, $1oC0p.useRef)(false);
    const manualScrollTimeoutRef = (0, $1oC0p.useRef)();
    // Suppress auto-centering for a duration after manual scrolling
    const markManualScroll = (0, $1oC0p.useCallback)(()=>{
        isManualScrolling.current = true;
        if (manualScrollTimeoutRef.current) clearTimeout(manualScrollTimeoutRef.current);
        manualScrollTimeoutRef.current = setTimeout(()=>{
            isManualScrolling.current = false;
        }, 500);
    }, []);
    // Measure and position the highlight behind the active tab
    const updateHighlightPosition = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        const highlight = highlightRef.current;
        if (!scrollable || !highlight || !activeTabId) return;
        const activeTab = scrollable.querySelector(`[data-tab-id="${activeTabId}"]`);
        if (!activeTab) return;
        const listRect = scrollable.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();
        const left = tabRect.left - listRect.left + scrollable.scrollLeft;
        const width = tabRect.width;
        highlight.style.left = `${left}px`;
        highlight.style.width = `${width}px`;
    }, [
        activeTabId
    ]);
    // Scroll the active tab into the center of the visible area
    const scrollActiveTabIntoView = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || !activeTabId) return;
        const activeTab = scrollable.querySelector(`[data-tab-id="${activeTabId}"]`);
        if (!activeTab) return;
        const scrollableWidth = scrollable.offsetWidth;
        const tabLeft = activeTab.offsetLeft;
        const tabWidth = activeTab.offsetWidth;
        const targetScroll = tabLeft - (scrollableWidth - tabWidth) / 2;
        isProgrammaticScroll.current = true;
        scrollable.scrollTo({
            left: targetScroll,
            behavior: $ef69e28b94f66947$var$prefersReducedMotion() ? "auto" : "smooth"
        });
    }, [
        activeTabId
    ]);
    // Update nav button visibility based on scroll position
    const updateNavButtonVisibility = (0, $1oC0p.useCallback)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        const atEnd = scrollable.scrollLeft > scrollable.scrollWidth - scrollable.offsetWidth - $ef69e28b94f66947$var$SCROLL_PADDING * 0.75;
        const atStart = scrollable.scrollLeft <= $ef69e28b94f66947$var$SCROLL_PADDING;
        setIsNextInactive(atEnd);
        setIsPreviousInactive(atStart);
    }, []);
    // Scroll the tab list by a fixed amount
    const handleScroll = (0, $1oC0p.useCallback)((direction)=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        markManualScroll();
        isProgrammaticScroll.current = true;
        scrollable.scrollTo({
            top: 0,
            left: scrollable.scrollLeft + $ef69e28b94f66947$var$SCROLL_AMOUNT * direction,
            behavior: $ef69e28b94f66947$var$prefersReducedMotion() ? "auto" : "smooth"
        });
    }, [
        markManualScroll
    ]);
    // Position highlight on first render without transition
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (isFirstRender.current) {
            const highlight = highlightRef.current;
            if (highlight) highlight.style.transition = "none";
            requestAnimationFrame(()=>{
                updateHighlightPosition();
                requestAnimationFrame(()=>{
                    if (highlight) highlight.style.transition = "";
                    isFirstRender.current = false;
                });
            });
        }
    }, [
        updateHighlightPosition
    ]);
    // Update highlight and scroll into view on subsequent tab changes
    (0, $1oC0p.useEffect)(()=>{
        if (!isFirstRender.current) {
            updateHighlightPosition();
            scrollActiveTabIntoView();
        }
    }, [
        updateHighlightPosition,
        scrollActiveTabIntoView
    ]);
    // Recalculate highlight position and scroll on container resize (debounced)
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || typeof ResizeObserver !== "function") return;
        let rafId = null;
        const observer = new ResizeObserver(()=>{
            if (rafId !== null) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(()=>{
                updateHighlightPosition();
                if (!isManualScrolling.current) scrollActiveTabIntoView();
                rafId = null;
            });
        });
        observer.observe(scrollable);
        return ()=>{
            if (rafId !== null) cancelAnimationFrame(rafId);
            if (manualScrollTimeoutRef.current) clearTimeout(manualScrollTimeoutRef.current);
            observer.disconnect();
        };
    }, [
        updateHighlightPosition,
        scrollActiveTabIntoView
    ]);
    // Detect manual (user-initiated) horizontal scrolling on the tab list
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable) return;
        const onScroll = ()=>{
            if (isProgrammaticScroll.current) {
                isProgrammaticScroll.current = false;
                return;
            }
            markManualScroll();
        };
        scrollable.addEventListener("scroll", onScroll, {
            passive: true
        });
        return ()=>{
            scrollable.removeEventListener("scroll", onScroll);
        };
    }, [
        markManualScroll
    ]);
    // Set up IntersectionObserver to track scroll position for nav buttons
    (0, $1oC0p.useEffect)(()=>{
        const scrollable = scrollableRef.current;
        if (!scrollable || typeof window.IntersectionObserver !== "function") return;
        const options = {
            root: scrollable,
            rootMargin: `0px ${$ef69e28b94f66947$var$SCROLL_PADDING * 0.75}px 0px 0px`,
            threshold: [
                0.1,
                0.9,
                1.0
            ]
        };
        const observer = new IntersectionObserver(()=>{
            updateNavButtonVisibility();
        }, options);
        const firstItem = scrollable.querySelector("li:first-of-type");
        const lastItem = scrollable.querySelector("li:last-of-type");
        if (firstItem) observer.observe(firstItem);
        if (lastItem) observer.observe(lastItem);
        updateNavButtonVisibility();
        return ()=>{
            observer.disconnect();
        };
    }, [
        updateNavButtonVisibility
    ]);
    return {
        scrollableRef: scrollableRef,
        highlightRef: highlightRef,
        isPreviousInactive: isPreviousInactive,
        isNextInactive: isNextInactive,
        handleScroll: handleScroll
    };
};

});


parcelRegister("1dc5i", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $fb7ea0e2b2e15ff6$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
// All panels are kept in the DOM and stacked in the same CSS grid cell so we can
// cross-fade between them without any layout shift. This matches the canonical
// WAC stacked-cross-fade idiom used in `customer-testimonials` and
// `hero-carousel` (gridArea "1 / 1" + opacity transition). Spec: GWP-11578.
const $fb7ea0e2b2e15ff6$var$panelStyles = null;
const $fb7ea0e2b2e15ff6$var$activePanelStyles = null;
const $fb7ea0e2b2e15ff6$export$3d96ec278d3efce4 = ({ children: children, id: id, isActive: isActive = true, ...rest })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: id,
        role: "tabpanel",
        "aria-labelledby": `tab-${id}`,
        // Inactive panels are visually invisible (opacity 0) and not
        // interactive (pointer-events: none + tabIndex: -1). They still
        // exist in the accessibility tree so screen readers can navigate,
        // but `aria-hidden` keeps them out of the announcement queue.
        tabIndex: isActive ? 0 : -1,
        "aria-hidden": !isActive,
        ...rest,
        className: (0, $2jatx.default)([
            "_nd5l1ekt _tzy4idpf _lcxvglyw _v564v7pp _sedtglyw",
            isActive && "_tzy4kb7n _lcxv1wug"
        ]),
        style: {
            "--_1yae2au": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.duration.400ms")),
            "--_1xciwtr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease40-in-out"))
        },
        children: children
    });
};

});



parcelRegister("eWY7v", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bd4a0508f0e82f76$export$2e2bcd8739ae039; });
/* tabs-8-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $01zo5 = parcelRequire("01zo5");

var $2axoc = parcelRequire("2axoc");

var $7kpd6 = parcelRequire("7kpd6");
const $bd4a0508f0e82f76$var$uniformTabsContainerStyles = null;
const $bd4a0508f0e82f76$var$UniformTabs8Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = "bgWhite" })=>{
    const renderTabs = ({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            const params = // @ts-ignore
            item.props?.children?.props?.data?.parameters;
            return {
                id: params?.id?.value ?? `tab-${index}`,
                title: params?.title?.value,
                tabComponent: item
            };
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kpd6.TabsSection), {
            alignment: "start",
            tabsData: tabsData,
            tabSize: "small",
            bgColor: bgColor
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
                title: headerText,
                titleAs: "h2",
                alignment: "start",
                text: subHeaderText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $bd4a0508f0e82f76$export$2e2bcd8739ae039 = $bd4a0508f0e82f76$var$UniformTabs8Col;

});

parcelRegister("gSQsG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4d767380087f2189$export$2e2bcd8739ae039; });
/* teamwork-graph.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $01zo5 = parcelRequire("01zo5");

var $dZNgt = parcelRequire("dZNgt");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $UMzWl = parcelRequire("UMzWl");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $iRMRa = parcelRequire("iRMRa");

var $fk4mX = parcelRequire("fk4mX");
const $4d767380087f2189$var$GRID_IMG = "https://dam-cdn.atl.orangelogic.com/AssetLink/857qv237n203wnkea8wgamk2a2us4uy2.png";
const $4d767380087f2189$var$JIRA_IMG = "https://dam-cdn.atl.orangelogic.com/AssetLink/jc0417320bg81b53h4sgs70q6l464500.svg";
const $4d767380087f2189$var$textPosition = {
    x: 22,
    y: 70
};
const $4d767380087f2189$var$videoPosition = {
    x: 68,
    y: 47
};
const $4d767380087f2189$var$vidFrontDimension = 560;
const $4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS = [
    {
        x: 105,
        y: 20
    },
    {
        x: 0,
        y: 20
    }
];
const $4d767380087f2189$var$LOZENGE_POSITIONS = [
    {
        x: $4d767380087f2189$var$videoPosition.x - 1,
        y: $4d767380087f2189$var$videoPosition.y + 11
    },
    {
        x: $4d767380087f2189$var$videoPosition.x + 2,
        y: $4d767380087f2189$var$videoPosition.y + 18
    },
    {
        x: $4d767380087f2189$var$videoPosition.x + 4,
        y: $4d767380087f2189$var$videoPosition.y + 25
    }
];
const $4d767380087f2189$var$LOZENGE_ATTRIBUTES = {
    shape: "rectangle",
    color: "blue600",
    textColor: "white",
    fontFamily: "charlie",
    fontWeight: 400,
    imagePlacement: "outsideLeading",
    size: 40,
    opacity: 0
};
const $4d767380087f2189$var$ICON_SHRUNKEN_SIZE = 38;
const $4d767380087f2189$var$ICON_NORMAL_SIZE = 72;
const $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE = 100;
const $4d767380087f2189$var$AVATAR_NORMAL_SIZE = 220;
const $4d767380087f2189$var$PILL_SHRUNKEN_SIZE = 45;
const $4d767380087f2189$var$PILL_NORMAL_SIZE = 65;
const $4d767380087f2189$var$FRAME_1_LEAVING_NODES_REF = {
    x: 32,
    y: 40
};
const $4d767380087f2189$var$FRAME_1_LEAVING_NODES_ANCHOR_AT_ZOOM = {
    x: 100,
    y: 40
};
const $4d767380087f2189$var$FRAME_1_LEAVING_POSITION_SCALE = 2.2;
function $4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(nodeX, nodeY) {
    return {
        x: $4d767380087f2189$var$FRAME_1_LEAVING_NODES_ANCHOR_AT_ZOOM.x + $4d767380087f2189$var$FRAME_1_LEAVING_POSITION_SCALE * (nodeX - $4d767380087f2189$var$FRAME_1_LEAVING_NODES_REF.x),
        y: $4d767380087f2189$var$FRAME_1_LEAVING_NODES_ANCHOR_AT_ZOOM.y + $4d767380087f2189$var$FRAME_1_LEAVING_POSITION_SCALE * (nodeY - $4d767380087f2189$var$FRAME_1_LEAVING_NODES_REF.y)
    };
}
/* frame 1 */ const $4d767380087f2189$var$FRAME_1_ZOOMIN_START = 3;
const $4d767380087f2189$var$FRAME_1_ZOOMIN_END = 9;
const $4d767380087f2189$var$FRAME_1_ADJUST_1_START = 9;
const $4d767380087f2189$var$FRAME_1_ADJUST_1_END = 11;
const $4d767380087f2189$var$FRAME_1_ADJUST_2_START = 11;
const $4d767380087f2189$var$FRAME_1_ADJUST_2_END = 13;
const $4d767380087f2189$var$FRAME_1_ADJUST_3_START = 13;
const $4d767380087f2189$var$FRAME_1_ADJUST_3_END = 15;
/* transition from frame 1 to frame 2 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START = 15;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END = 19;
/* frame 2 */ const $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_1 = 19;
const $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_2 = 20;
const $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_3 = 21;
const $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_START = 25;
const $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_END = 26;
/* transition from frame 2 to frame 3 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START = 29;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END = 33;
/* frame 3 */ const $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_1 = 33;
const $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_2 = 34;
const $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_3 = 35;
const $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_START = 39;
const $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_END = 40;
/* transition from frame 3 to frame 4 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START = 43;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END = 47;
/* frame 4 */ const $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_1 = 47;
const $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_2 = 48;
const $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_3 = 49;
const $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_START = 53;
const $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_END = 54;
/* transition from frame 4 to frame 5 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START = 57;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END = 61;
/* frame 5 */ const $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_1 = 61;
const $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_2 = 62;
const $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_3 = 63;
const $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_START = 67;
const $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_END = 68;
/* transition from frame 5 to frame 6 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START = 72;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END = 76;
/* frame 6 */ const $4d767380087f2189$var$FRAME_6_ADJUST_1_START = 76;
const $4d767380087f2189$var$FRAME_6_ADJUST_1_END = 79;
const $4d767380087f2189$var$FRAME_6_ADJUST_2_START = 79;
const $4d767380087f2189$var$FRAME_6_ADJUST_2_END = 82;
const $4d767380087f2189$var$FRAME_6_ADJUST_3_START = 82;
const $4d767380087f2189$var$FRAME_6_ADJUST_3_END = 84;
/* transition from frame 6 to frame 7 */ const $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START = 87;
const $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END = 91;
/* frame 7 */ const $4d767380087f2189$var$FRAME_7_ADJUST_1_START = 91;
const $4d767380087f2189$var$FRAME_7_ADJUST_1_END = 92;
const $4d767380087f2189$var$FRAME_7_ADJUST_2_START = 94;
const $4d767380087f2189$var$FRAME_7_ADJUST_2_END = 97;
const $4d767380087f2189$var$FRAME_7_ADJUST_3_START = 97;
const $4d767380087f2189$var$FRAME_7_ADJUST_3_END = 100;
const $4d767380087f2189$var$FRAME_6_NODES_SHRINKING = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
    width: 1,
    height: 1,
    size: 1,
    opacity: 0,
    x: 18.6,
    y: 74.9
};
const $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
    x: -150
};
const $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
    x: -50,
    y: -50
};
const $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
    x: -50,
    y: 150
};
const $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
    x: 150,
    y: -50
};
const $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT = {
    delay: 0,
    duration: 0,
    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
    x: -150
};
const $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH = 768;
const $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_HEIGHT_SCALE = $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH / 440;
const $4d767380087f2189$var$scaledMobileTeamworkGraphHeight = (heightAt440)=>Math.round(heightAt440 * $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_HEIGHT_SCALE);
const $4d767380087f2189$var$mobileHeadingCss = {
    fontSize: "4rem"
};
const $4d767380087f2189$var$mobileDescriptionCss = {
    fontSize: "3rem"
};
const $4d767380087f2189$var$desktopHeadingCss = {
    fontSize: "2rem"
};
const $4d767380087f2189$var$desktopDescriptionCSS = {
    fontSize: "1.5rem"
};
const $4d767380087f2189$var$stickyWrapperCss = null;
const $4d767380087f2189$var$navigationContainerCss = null;
const $4d767380087f2189$var$progressTimelineCss = null;
const $4d767380087f2189$var$skipButtonCss = null;
const $4d767380087f2189$var$barsCss = null;
const $4d767380087f2189$var$barsBehindCss = null;
const $4d767380087f2189$var$barsFrontCss = null;
const $4d767380087f2189$var$gradientOverlayStyle = null;
const $4d767380087f2189$var$teamworkGraphDesktopOnlyStyles = null;
const $4d767380087f2189$var$teamworkGraphMobileOnlyStyles = null;
const $4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages = (0, $fnHPc.defineMessages)({
    frame2Heading: {
        id: "teamworkGraph.frame2.heading.default",
        defaultMessage: "With shared data from everywhere"
    },
    frame2Description: {
        id: "teamworkGraph.frame2.description.default",
        defaultMessage: "Connect data from every source to bring context to decisions, ideas, and workflows"
    },
    frame3Heading: {
        id: "teamworkGraph.frame3.heading.default",
        defaultMessage: "Connected to impact"
    },
    frame3Description: {
        id: "teamworkGraph.frame3.description.default",
        defaultMessage: "Teams and AI operate with awareness of priorities and time progress."
    },
    frame4Heading: {
        id: "teamworkGraph.frame4.heading.default",
        defaultMessage: "In sync across every team"
    },
    frame4Description: {
        id: "teamworkGraph.frame4.description.default",
        defaultMessage: "Shared context means AI outputs are relevant and you never miss a beat."
    },
    frame5Heading: {
        id: "teamworkGraph.frame5.heading.default",
        defaultMessage: "Getting it 'Done' faster"
    },
    frame5Description: {
        id: "teamworkGraph.frame5.description.default",
        defaultMessage: "When teams are aligned and context-aware, they tap into Rovo to get their work done faster, with confidence."
    }
});
const $4d767380087f2189$var$TEAMWORK_GRAPH_SKIP_SCROLL_MS = 1600;
const $4d767380087f2189$var$TEAMWORK_GRAPH_SKIP_SCROLL_TOP_PADDING_PX = 16;
const $4d767380087f2189$export$e061a00b0877e539 = [
    0,
    $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
    $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
    $4d767380087f2189$var$FRAME_1_ADJUST_3_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
    $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_3,
    $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
    $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_3,
    $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
    $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_3,
    $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
    $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_3,
    $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
    $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
    $4d767380087f2189$var$FRAME_6_ADJUST_3_END,
    $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
    $4d767380087f2189$var$FRAME_7_ADJUST_2_END,
    100
];
const $4d767380087f2189$export$bc031c6e33a9c0cf = [
    ...$4d767380087f2189$export$e061a00b0877e539
];
function $4d767380087f2189$var$easeInOutCubicSkipScroll(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
/* eslint-disable complexity */ const $4d767380087f2189$var$UniformTeamworkGraph = (props)=>{
    const { frame1Heading: frame1Heading, frame1Subheading: frame1Subheading, frame2Heading: frame2Heading, frame2Description: frame2Description, frame2VideoUrl: frame2VideoUrl, frame2VideoImg: frame2VideoImg, frame3Heading: frame3Heading, frame3Description: frame3Description, frame3VideoUrl: frame3VideoUrl, frame3VideoImg: frame3VideoImg, frame4Heading: frame4Heading, frame4Description: frame4Description, frame4VideoUrl: frame4VideoUrl, frame4VideoImg: frame4VideoImg, frame5Heading: frame5Heading, frame5Description: frame5Description, frame5VideoUrl: frame5VideoUrl, frame5VideoImg: frame5VideoImg, frame7Heading: frame7Heading, stickyHeight: // scrollMagnetAnchors = DEFAULT_SCROLL_MAGNET_ANCHORS,
    // scrollMagnetMinProgressDelta,
    // scrollMagnetDirectionBias,
    stickyHeight = 1950, onDesktopScrollPhaseProgressChange: onDesktopScrollPhaseProgressChange } = props;
    // const orderedScrollMagnetAnchors = [...scrollMagnetAnchors].sort(
    //     (left, right) => left - right
    // );
    // checks if this is being rendered in a Safari browser
    const isSafariBrowser = typeof navigator !== "undefined" && /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
    const bgImageSafari = (src)=>{
        if (isSafariBrowser) return src;
        return undefined;
    };
    const htmlVideoSafari = (src)=>{
        if (isSafariBrowser) return null;
        return /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
            style: {
                width: "100%",
                height: "100%",
                position: "relative",
                borderRadius: "10px",
                pointerEvents: "none"
            },
            src: src,
            autoPlay: true,
            muted: true,
            loop: true,
            playsInline: true
        });
    };
    const intl = (0, $8e22h.default)();
    const frame2HeadingWithDefault = frame2Heading || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame2Heading);
    const frame2DescriptionWithDefault = frame2Description || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame2Description);
    const frame3HeadingWithDefault = frame3Heading || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame3Heading);
    const frame3DescriptionWithDefault = frame3Description || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame3Description);
    const frame4HeadingWithDefault = frame4Heading || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame4Heading);
    const frame4DescriptionWithDefault = frame4Description || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame4Description);
    const frame5HeadingWithDefault = frame5Heading || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame5Heading);
    const frame5DescriptionWithDefault = frame5Description || intl.formatMessage($4d767380087f2189$var$teamworkGraphFrameCopyDefaultMessages.frame5Description);
    const pullingInContextString = intl.formatMessage({
        id: "teamworkGraph.framesAl.pullingInContext",
        defaultMessage: "Pulling in context..."
    });
    const teamworkGraphMobileNodesA = [
        {
            id: "mobile-component-A-grid-left",
            x: 30,
            y: 0,
            width: 800,
            height: 1600,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/7862q04hkv188isqi7vuls055j6f64fq.png"
        },
        {
            id: "mobile-component-A-dot-top-left",
            x: 3,
            y: -2,
            shape: "circle",
            bgColor: "transparent",
            size: 1
        },
        {
            id: "mobile-component-A-dot-top-right",
            x: 101,
            y: 9,
            shape: "circle",
            bgColor: "transparent",
            size: 1
        },
        {
            id: "mobile-component-A-dot-right-bottom",
            x: 101,
            y: 89,
            shape: "circle",
            bgColor: "transparent",
            size: 1
        },
        {
            id: "mobile-component-A-avatar-blue-top",
            x: 50,
            y: 50,
            shape: "circle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/vvs64iqhos5vy1u702ok4u50s42m10ii.png",
            size: 425
        },
        {
            id: "mobile-component-A-icon-figma-top",
            x: 70,
            y: 0,
            size: 130,
            shape: "rectangle",
            borderColor: "white",
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg"
        },
        {
            id: "mobile-component-A-rectangle-project",
            x: 3,
            y: 13,
            shape: "rectangle",
            bgColor: "black",
            borderColor: "blue600",
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.project",
                defaultMessage: "Project"
            }),
            textColor: "white",
            size: 130
        },
        {
            id: "mobile-component-A-hex-wrench-1",
            x: 20,
            y: 26,
            shape: "hexagon",
            size: 70,
            bgColor: "blue600",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/x6bd18r1i1qx1k7xt61pbnnskyf76y4r.svg"
        },
        {
            id: "mobile-component-A-hex-wrench-2",
            x: 80,
            y: 33,
            shape: "hexagon",
            size: 70,
            bgColor: "blue600",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/x6bd18r1i1qx1k7xt61pbnnskyf76y4r.svg"
        },
        {
            id: "mobile-component-A-icon-circle-arrow",
            x: 97,
            y: 52,
            size: 130,
            shape: "rectangle",
            bgColor: "black",
            borderColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/6k3dp10ut224t4oa4ih2ns74gx2r07yh.svg"
        },
        {
            id: "mobile-component-A-icon-microsoft-teams",
            x: 3,
            y: 50,
            size: 130,
            shape: "rectangle",
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FS.png"
        },
        {
            id: "mobile-component-A-rectangle-prompt",
            borderColor: "rainbowRovo",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/82b230b227f1f2nass7sp15dt05ib3ni.jpg",
            x: 50,
            y: 88,
            width: 800,
            height: 285,
            shape: "rectangle"
        }
    ];
    const teamworkGraphMobileNodesB = [
        {
            id: "mobile-component-B-dot-top",
            x: 50,
            y: 0,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-B-dot-left-bottom",
            x: -1,
            y: 40,
            shape: "circle",
            bgColor: "transparent",
            size: 1
        },
        {
            id: "mobile-component-B-dot-right-bottom",
            x: 101,
            y: 89,
            shape: "circle",
            bgColor: "transparent",
            size: 1
        },
        {
            id: "mobile-component-B-grid-right",
            x: 60,
            y: 50,
            width: 800,
            height: 1600,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/58tq64t0d72pjl8y7cgijgl8ag5a23tf.png"
        },
        {
            id: "mobile-component-B-icon-confluence",
            x: 50,
            y: 7,
            size: 130,
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/i8rco43kk1s7kmr72f303wo4esw3s57j.svg"
        },
        {
            id: "mobile-component-B-icon-figma-bottom",
            x: 87,
            y: 43,
            size: 130,
            shape: "rectangle",
            borderColor: "white",
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg"
        },
        {
            id: "mobile-component-B-lozenge-marketing-veronica",
            x: 55,
            y: 54,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.marketingVeronica",
                defaultMessage: "Marketing / Veronica"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-B-lozenge-meeting-recordings",
            x: 50,
            y: 62,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.meetingRecordings",
                defaultMessage: "Meeting Recordings"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-B-lozenge-campaign-ad-refresh",
            x: 45,
            y: 70,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.campaignAdRefresh",
                defaultMessage: "Campaign Ad Refresh"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-B-rectangle-assets",
            x: 37,
            y: 87,
            width: 700,
            height: 400,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/ycp11j6s2wt83bh3wy7713h1r85mv8ex.png"
        }
    ];
    const teamworkGraphMobileNodesC = [
        {
            id: "mobile-component-C-dot-top",
            x: 10,
            y: 0,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-C-icon-figma-bottom",
            x: 12,
            y: 91,
            size: 130,
            shape: "rectangle",
            borderColor: "white",
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg"
        },
        {
            id: "mobile-component-C-dot-left",
            x: -2,
            y: 15,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-C-frame-text",
            x: 50,
            y: 50,
            shape: "rectangle",
            bgColor: "transparent",
            width: 700,
            height: 800,
            textColor: "white",
            fontFamily: "charlie",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$mobileHeadingCss,
                        children: frame2HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$mobileDescriptionCss,
                        children: frame2DescriptionWithDefault
                    })
                ]
            })
        }
    ];
    const teamworkGraphMobileNodesD = [
        {
            id: "mobile-component-D-dot-top",
            x: 15,
            y: 0,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-D-dot-right",
            x: 101,
            y: 0,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-D-icon-gdrive",
            x: 80,
            y: 10,
            size: 130,
            shape: "rectangle",
            borderColor: "white",
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/x6fti424cg1dyn52m750hns8386vyw2o.svg"
        },
        {
            id: "mobile-component-D-lozenge-strategy-brief",
            x: 45,
            y: 35,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.strategyBrief",
                defaultMessage: "Strategy Brief"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-D-lozenge-portal-repo-20",
            x: 50,
            y: 45,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.portalRepo2",
                defaultMessage: "Portal Repo 2.0"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-D-lozenge-okr",
            x: 65,
            y: 55,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.okrAdd300kAccounts",
                defaultMessage: "[01.KR2] Add 300k accounts"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-D-rectangle-in-progress",
            x: 62,
            y: 84,
            width: 700,
            height: 400,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/q2408086s36q3g576cw1b2042ni4t57c.png"
        }
    ];
    const teamworkGraphMobileNodesE = [
        {
            id: "mobile-component-E-dot-top",
            x: 80,
            y: 0,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-E-dot-left",
            x: 0,
            y: 80,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-E-icon-sharepoint-bottom",
            x: 80,
            y: 91,
            size: 130,
            shape: "rectangle",
            borderColor: "white",
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EWOC.svg"
        },
        {
            id: "mobile-component-E-frame-text",
            x: 50,
            y: 50,
            shape: "rectangle",
            bgColor: "transparent",
            width: 700,
            height: 800,
            textColor: "white",
            fontFamily: "charlie",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$mobileHeadingCss,
                        children: frame3HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$mobileDescriptionCss,
                        children: frame3DescriptionWithDefault
                    })
                ]
            })
        }
    ];
    const teamworkGraphMobileNodesF = [
        {
            id: "mobile-component-F-dot-top",
            x: 80,
            y: 0,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-F-dot-left",
            x: 0,
            y: 20,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-F-lozenge-portal-redesign-brainstorm",
            x: 58,
            y: 34,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.portalRedesignBrainstorm",
                defaultMessage: "Portal Redesign Brainstorm"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-F-lozenge-portal-designs",
            x: 65,
            y: 44,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.portalDesigns",
                defaultMessage: "Portal Designs"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-F-lozenge-okr",
            x: 50,
            y: 54,
            text: intl.formatMessage({
                id: "teamworkGraph.mobile.frameFokrLabel",
                defaultMessage: "[O1.KR2] Add 300k accounts"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-F-rectangle-comment",
            x: 42,
            y: 84,
            width: 700,
            height: 400,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/2gf42uyw6x35g346v1337b15dx434t0a.png"
        },
        {
            id: "mobile-component-F-dot-bottom-right",
            x: 0,
            y: 100,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        }
    ];
    const teamworkGraphMobileNodesG = [
        {
            id: "mobile-component-G-frame-text",
            x: 50,
            y: 50,
            shape: "rectangle",
            bgColor: "transparent",
            width: 700,
            height: 800,
            textColor: "white",
            fontFamily: "charlie",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$mobileHeadingCss,
                        children: frame4HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$mobileDescriptionCss,
                        children: frame4DescriptionWithDefault
                    })
                ]
            })
        }
    ];
    const teamworkGraphMobileNodesH = [
        {
            id: "mobile-component-H-dot-top-left",
            x: -5,
            y: 0,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-H-dot-top-right",
            x: 111,
            y: 0,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-H-dot-middle-left",
            x: -20,
            y: 60,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-H-icon-figma",
            x: 70,
            y: 18,
            size: 130,
            shape: "rectangle",
            borderColor: "white",
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg"
        },
        {
            id: "mobile-component-H-icon-microsoft",
            x: 14,
            y: 30,
            size: 130,
            shape: "rectangle",
            borderColor: "white",
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/72jyk7b1r48ul3cb6qusr6b1yu61td3t.svg"
        },
        {
            id: "mobile-component-H-lozenge-partner-research-notes",
            x: 50,
            y: 40,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.partnerResearchNotes",
                defaultMessage: "Partner Research Notes"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-H-lozenge-fin-300",
            x: 55,
            y: 50,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.fin300AccountMicroservice",
                defaultMessage: "FIN-300: Account Microservice"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-H-lozenge-design-walkthrough",
            x: 65,
            y: 60,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.designWalkthrough",
                defaultMessage: "Design Walkthrough"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie"
        },
        {
            id: "mobile-component-H-rectangle-avatars",
            x: 65,
            y: 84,
            width: 700,
            height: 400,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/32agfh01wn5t07ah5781p287ap8sxoh4.png"
        },
        {
            id: "mobile-component-H-dot-bottom",
            x: 20,
            y: 100,
            size: 20,
            shape: "circle"
        }
    ];
    const teamworkGraphMobileNodesI = [
        {
            id: "mobile-component-I-frame-text",
            x: 50,
            y: 25,
            shape: "rectangle",
            bgColor: "transparent",
            width: 700,
            height: 800,
            textColor: "white",
            fontFamily: "charlie",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$mobileHeadingCss,
                        children: frame5HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$mobileDescriptionCss,
                        children: frame5DescriptionWithDefault
                    })
                ]
            })
        },
        {
            id: "mobile-component-I-dot-top",
            x: 20,
            y: 0,
            size: 20,
            shape: "circle"
        },
        {
            id: "mobile-component-I-dot-mid",
            x: 10,
            y: 40,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-I-dot-left-mid",
            x: -9,
            y: 60,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-I-dot-right-mid",
            x: 110,
            y: 60,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-I-dot-left-bottom",
            x: -9,
            y: 90,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-I-dot-right-bottom",
            x: 111,
            y: 90,
            size: 1,
            shape: "circle",
            bgColor: "transparent"
        },
        {
            id: "mobile-component-I-avatar-blue",
            x: 50,
            y: 80,
            shape: "circle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/vvs64iqhos5vy1u702ok4u50s42m10ii.png",
            size: 425
        }
    ];
    /* desktop nodes */ const teamworkGraphAllFramesNodes = [
        {
            id: "perpetual-grid",
            x: 150,
            y: 99,
            width: 880,
            height: 700,
            opacity: 0,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: $4d767380087f2189$var$GRID_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    opacity: 1,
                    x: 100,
                    y: 99
                },
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    opacity: 1,
                    x: 50,
                    y: 0
                },
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    opacity: 1,
                    x: 0,
                    y: 99
                },
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    opacity: 1,
                    x: 99,
                    y: 0
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-grid-center",
            x: 20,
            y: 42,
            width: 440,
            height: 350,
            opacity: 0,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: $4d767380087f2189$var$GRID_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 50,
                    y: 50,
                    width: 880,
                    height: 701,
                    opacity: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-text-get-knowledge-flowing",
            x: 28,
            y: 18,
            shape: "rectangle",
            width: 500,
            height: 200,
            bgColor: "transparent",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    textAlign: "left"
                },
                children: frame1Heading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(frame1Heading) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                    node: frame1Heading["root"] || frame1Heading
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "gwp.refresh.teamworkGraph.frame1.heading",
                        values: (0, $iRMRa.DEFAULT_VALUES),
                        defaultMessage: "Get knowledge <br></br> <strong>flowing</strong>"
                    })
                })
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: -50,
                    y: -100,
                    opacity: 0,
                    size: 180
                }
            ]
        },
        {
            id: "frame-1-text-starts-with-context",
            x: 28,
            y: 83,
            shape: "rectangle",
            width: 500,
            height: 300,
            bgColor: "transparent",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    frame1Subheading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(frame1Subheading) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                        node: frame1Subheading["root"] || frame1Subheading
                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                style: $4d767380087f2189$var$desktopHeadingCss,
                                children: intl.formatMessage({
                                    id: "gwp.refresh.teamworkGraph.frame1.subheading",
                                    defaultMessage: "It all starts with context\u2026"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                style: $4d767380087f2189$var$desktopDescriptionCSS,
                                children: intl.formatMessage({
                                    id: "gwp.refresh.teamworkGraph.frame1.description",
                                    defaultMessage: "Link teams, work, and goals to unlock context right in your flow of work."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        bgColor: "bgBlackBlue",
                        href: "/platform/teamwork-graph",
                        "aria-label": intl.formatMessage({
                            id: "gwp.refresh.teamworkGraph.frame1.link",
                            defaultMessage: "Explore Teamwork Graph"
                        }),
                        text: intl.formatMessage({
                            id: "gwp.refresh.teamworkGraph.frame1.link",
                            defaultMessage: "Explore Teamwork Graph"
                        }),
                        dataEventProps: {
                            "data-product-key": "uniform",
                            "data-event": "clicked",
                            "data-event-component": "link",
                            "data-event-container": "teamworkGraph",
                            "data-label": "Explore Teamwork Graph",
                            "data-label-english": "Explore Teamwork Graph"
                        }
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: -18,
                    y: 150,
                    opacity: 1,
                    size: 130
                }
            ]
        },
        {
            id: "all-frames-behind-avatar-blue",
            x: 20,
            y: 42,
            shape: "circle",
            size: 1,
            opacity: 0,
            bgColor: "blue800",
            borderColor: "blue400",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 50,
                    y: 50,
                    opacity: 0.5,
                    size: 320
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 50,
                    y: 50,
                    opacity: 0.2,
                    size: 300
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    opacity: 0,
                    x: 150,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 50,
                    y: 50,
                    size: 210
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_2_END,
                    x: 50,
                    y: 50,
                    size: 350,
                    opacity: 0.5
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_3_END,
                    x: 50,
                    y: 50,
                    size: 1,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-squiggle",
            x: 28,
            y: 31,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/xcosenf3w13o8pq585o705fxys5q03x2.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 50,
                    y: 50,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-avatar-blue",
            x: 20,
            y: 42,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/vvs64iqhos5vy1u702ok4u50s42m10ii.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 50,
                    y: 50,
                    opacity: 1,
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-pill-project",
            x: 9,
            y: 33,
            shape: "pill",
            size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4RZ.svg",
            imagePlacement: "insideLeading",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.project",
                defaultMessage: "Project"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 20,
                    y: 20,
                    opacity: 1,
                    size: $4d767380087f2189$var$PILL_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-agent-top",
            x: 27,
            y: 40.5,
            shape: "circle",
            size: 1,
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZG.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 74,
                    y: 44,
                    size: 30
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-agent-left",
            x: 22,
            y: 48,
            shape: "circle",
            size: 1,
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZH.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 65,
                    y: 64,
                    size: 30
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-agent-right",
            x: 31,
            y: 46,
            shape: "circle",
            size: 1,
            bgColor: "transparent",
            opacity: 1,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZF.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 88,
                    y: 59,
                    size: 30
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-loom-to-shrink",
            x: 27,
            y: 48,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/4t8837ogw4s4t31c7x0hgfb523o7s4v1.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 76,
                    y: 65,
                    opacity: 1,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-shrink-to-microsoft-teams",
            x: 27,
            y: 48,
            shape: "rectangle",
            size: 1,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N54W.png",
            borderColor: "white",
            borderWidth: 2,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 76,
                    y: 65,
                    opacity: 1,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-icon-circle-arrow-with-sprint-text",
            x: 12,
            y: 47,
            shape: "rectangle",
            size: 1,
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.sprint",
                defaultMessage: "Sprint"
            }),
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZE.svg",
            imagePlacement: "insideLeading",
            borderColor: "blue600",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 25,
                    y: 50,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-icon-circle-arrow",
            x: 12,
            y: 47,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "blue600",
            opacity: 1,
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/6k3dp10ut224t4oa4ih2ns74gx2r07yh.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 25,
                    y: 50,
                    size: 1,
                    opacity: 0
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-icon-figma",
            x: 18,
            y: 53,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 20,
                    y: 75,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-icon-people-team-with-team-text",
            x: 27,
            y: 61,
            shape: "rectangle",
            size: 1,
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.teamtext",
                defaultMessage: "Team"
            }),
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZC.svg",
            imagePlacement: "insideLeading",
            borderColor: "blue600",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 20,
                    y: 75,
                    opacity: 1,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-icon-people-team",
            x: 27,
            y: 61,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "blue600",
            opacity: 1,
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/301nl85gds5kr47oo2125d47333e6c73.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 20,
                    y: 75,
                    opacity: 0,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-icon-jira",
            x: 8,
            y: 60,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "blue600",
            bgImage: $4d767380087f2189$var$JIRA_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 10,
                    y: 50,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-chip-team-r",
            x: 32,
            y: 40,
            shape: "rectangle",
            size: 1,
            opacity: 0,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZC.svg",
            imagePlacement: "insideLeading",
            borderColor: "blue500",
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.team",
                defaultMessage: "Team"
            }),
            textColor: "white",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 70,
                    y: 25,
                    opacity: 0,
                    size: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 74,
                    y: 15,
                    size: 1,
                    opacity: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_2_END,
                    x: 74,
                    y: 15,
                    size: 46,
                    opacity: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_3_END,
                    x: 95,
                    y: 22,
                    size: 46,
                    opacity: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-chip-video-tr",
            x: 32,
            y: 40,
            shape: "rectangle",
            size: 1,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZD.svg",
            imagePlacement: "insideLeading",
            borderColor: "blue500",
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.video",
                defaultMessage: "Video"
            }),
            textColor: "white",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 70,
                    y: 25,
                    size: 46
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 74,
                    y: 15,
                    size: 46,
                    opacity: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-chip-video-left",
            x: -30,
            y: 50,
            shape: "rectangle",
            size: 1,
            opacity: 0,
            bgColor: "black",
            borderColor: "blue500",
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.video",
                defaultMessage: "Video"
            }),
            textColor: "white",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 3,
                    y: 34,
                    opacity: 1,
                    size: 46
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-icon-behind-microsoft-teams",
            x: 32,
            y: 40,
            shape: "circle",
            size: 1,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(32, 40),
                    size: 1,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-microsoft-teams-to-shrink",
            x: 32,
            y: 40,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N54W.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 90,
                    y: 40,
                    opacity: 0,
                    size: 1
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-1-shrink-to-icon-loom",
            x: 32,
            y: 40,
            shape: "rectangle",
            size: 1,
            opacity: 0,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/4t8837ogw4s4t31c7x0hgfb523o7s4v1.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    x: 90,
                    y: 40,
                    opacity: 1,
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        /* nodes that go away */ {
            id: "frame-1-pill-work-item",
            x: 34,
            y: 54,
            shape: "pill",
            size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S2.svg",
            imagePlacement: "insideLeading",
            borderColor: "lime400",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.workItem",
                defaultMessage: "Work Item"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(34, 54),
                    size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-avatar-green",
            x: 42,
            y: 35,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: "lime500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/ppop74d2k67771avyr8hs635pkasin70.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(42, 35),
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-rocket",
            x: 50,
            y: 33,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "lime500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ql83bjjch2xkvh7643ki04g3k2vkj1p.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(50, 33),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-brackets",
            x: 39,
            y: 45,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "lime500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/u33nvnm154b801i82t4075s0j0f2q727.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(39, 45),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-bitbucket",
            x: 45,
            y: 51,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "lime500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/s6xb2173woj4m00n36b754t44126al0l.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(45, 51),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-pill-roadmap",
            x: 67,
            y: 15,
            shape: "pill",
            size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S2.svg",
            imagePlacement: "insideLeading",
            borderColor: "purple500",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.roadmap",
                defaultMessage: "Roadmap"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(67, 15),
                    size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-avatar-purple",
            x: 75,
            y: 37,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: "purple500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/yk6fc6h475wmi67s827prloh073l01g1.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(75, 37),
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-lightbulb",
            x: 77,
            y: 23,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "purple500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/1di7856lu37ve153ja4m4wcg17b8y26j.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(77, 23),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-video",
            x: 57,
            y: 25,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "purple500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/0qdhoxv5o6b3mleiuc6ej43re1gsn8b0.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(57, 25),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-target",
            x: 70,
            y: 47,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "purple500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/65wycilre16o225ia50e84d3a22ch140.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(70, 47),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-bookmark",
            x: 67,
            y: 32,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "purple500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/2v746wlx1l1r41a6s5p63e7y102ko2l4.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(67, 32),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-jpd",
            x: 84,
            y: 30,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "purple500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/klkr50gx181r0p8chweefx38e7hf48s1.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(84, 30),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-avatar-yellow",
            x: 63,
            y: 54,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: "yellow300",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/ua8r3l3j055g4k8t3vcw5x0qd3b3b3wa.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(63, 54),
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-lightning-bolt",
            x: 59,
            y: 41,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "yellow300",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/uo0v4gsxcfjo34e3evp630ba0653j558.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(59, 41),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-jsm",
            x: 57,
            y: 60,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "yellow300",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/nj3c8i7014gw1sba21en752f0q4pq0sx.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(57, 60),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-bell",
            x: 69,
            y: 65,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "yellow300",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/3gjch6tk0wbw3801u4656e82213h5xvm.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(69, 65),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-pill-focus-area",
            x: 84,
            y: 70,
            shape: "pill",
            size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S7.svg",
            imagePlacement: "insideLeading",
            borderColor: "yellow500",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame1.focusArea",
                defaultMessage: "Focus Area"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(84, 70),
                    size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-avatar-orange",
            x: 92,
            y: 47,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE,
            bgColor: "yellow500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/5o2o2enoi03yotn523u7t1505kw351en.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(92, 47),
                    size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-dollar",
            x: 81,
            y: 43,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "yellow500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/qmtxbl7050fm60rs86110t4h8553436v.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(81, 43),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-star-talent",
            x: 88,
            y: 59,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "yellow500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/fwhk18bh22311008ugi5s2i62s5iv632.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(88, 59),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-csm",
            x: 52,
            y: 50,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "yellow300",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N54R.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(52, 50),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-microsoft",
            x: 93,
            y: 31,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/72jyk7b1r48ul3cb6qusr6b1yu61td3t.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(93, 31),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-gdrive",
            x: 62,
            y: 71,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/x6fti424cg1dyn52m750hns8386vyw2o.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(62, 71),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        {
            id: "frame-1-icon-sharepoint",
            x: 75,
            y: 57,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N539.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ZOOMIN_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ZOOMIN_END,
                    ...$4d767380087f2189$var$frame1NodeLeavingZoomEndPosition(75, 57),
                    size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
                    opacity: 0
                }
            ]
        },
        /* frame 2 bridging elements */ {
            id: "frame-1-and-2-bridge",
            x: 101,
            y: 80,
            shape: "circle",
            size: 5,
            bgColor: "blue300",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 50,
                    y: 80
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_2_END,
                    x: 120,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 20,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-1-prompt-box",
            x: 101,
            y: 80,
            shape: "rectangle",
            size: 1,
            width: 1,
            height: 1,
            opacity: 1,
            borderColor: "rainbowRovo",
            bgColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MT.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_1_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_1_ADJUST_1_END,
                    x: 50,
                    y: 80,
                    opacity: 1,
                    width: 350,
                    height: 115
                },
                $4d767380087f2189$var$ZOOMED_IN_NODES_SHIFTING_LEFT
            ]
        },
        /* frame 2 */ {
            id: "frame-2-text",
            x: $4d767380087f2189$var$textPosition.x + 100,
            y: $4d767380087f2189$var$textPosition.y,
            width: 300,
            height: 400,
            opacity: 0,
            shape: "rectangle",
            fontFamily: "charlie",
            fontWeight: 400,
            bgColor: "transparent",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$desktopHeadingCss,
                        children: frame2HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$desktopDescriptionCSS,
                        children: frame2DescriptionWithDefault
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    opacity: 1,
                    x: $4d767380087f2189$var$textPosition.x,
                    y: $4d767380087f2189$var$textPosition.y
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-icon-confluence",
            x: 120,
            y: 30,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            opacity: 1,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MY.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 20,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-icon-hubspot",
            x: 140,
            y: 15,
            shape: "rectangle",
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MV.svg",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 40,
                    y: 15
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-icon-figma",
            x: 175,
            y: 30,
            shape: "rectangle",
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 75,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-dot-top-right",
            x: 225,
            y: -10,
            shape: "circle",
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 125,
                    y: -10
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-dot-top",
            x: 125,
            y: -50,
            shape: "circle",
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 25,
                    y: -50
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-rovo-prompt-text",
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            shape: "rectangle",
            size: 70,
            fontFamily: "charlie",
            fontWeight: 400,
            bgColor: "neutral900",
            borderColor: "rainbowRovo",
            borderRadius: 5,
            text: pullingInContextString,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S0.svg",
            imagePlacement: "insideLeading",
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-lozenge-1",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FX.svg",
            text: intl.formatMessage({
                id: "teamworkGraph.frame2.lozenge1",
                defaultMessage: "Marketing / Veronica"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[0].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[0].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-lozenge-2",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FS.png",
            text: intl.formatMessage({
                id: "teamworkGraph.frame2.lozenge1",
                defaultMessage: "Meeting Recordings"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[1].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[1].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-lozenge-3",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FT.png",
            text: intl.formatMessage({
                id: "teamworkGraph.frame2.lozenge1",
                defaultMessage: "Campaign Ad Refresh"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_2_PULLING_CONTEXT_STEP_3,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[2].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[2].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        {
            id: "frame-2-video-expand",
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y,
            shape: "rectangle",
            width: 10,
            height: 10,
            opacity: 0,
            bgColor: "neutral800",
            borderColor: "rainbowRovo",
            borderRadius: 10,
            bgImage: bgImageSafari(frame2VideoImg || "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N40J.webp"),
            htmlContent: htmlVideoSafari(frame2VideoUrl || "https://dam-cdn.atl.orangelogic.com/AssetLink/elqg4r36c8cgw17o0yh87a6ghe6s5e75.webm"),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_2_VIDEO_EXPAND_END,
                    width: $4d767380087f2189$var$vidFrontDimension,
                    height: $4d767380087f2189$var$vidFrontDimension,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_2_NODES_SHIFTING_UP_LEFT
            ]
        },
        /* frame 3 */ {
            id: "frame-3-text",
            x: $4d767380087f2189$var$textPosition.x + 100,
            y: $4d767380087f2189$var$textPosition.y + 100,
            width: 300,
            height: 400,
            opacity: 0,
            shape: "rectangle",
            fontFamily: "charlie",
            fontWeight: 400,
            bgColor: "transparent",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$desktopHeadingCss,
                        children: frame3HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$desktopDescriptionCSS,
                        children: frame3DescriptionWithDefault
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    opacity: 1,
                    x: $4d767380087f2189$var$textPosition.x,
                    y: $4d767380087f2189$var$textPosition.y
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "frame-3-icon-gdrive",
            x: 220,
            y: 130,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/x6fti424cg1dyn52m750hns8386vyw2o.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 120,
                    y: 130
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 20,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "frame-3-icon-cursor",
            x: 250,
            y: 170,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MZ.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 150,
                    y: 170
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 50,
                    y: 70
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "frame-3-dot-bottom",
            x: 230,
            y: 210,
            shape: "rectangle",
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: 130,
                    y: 210
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 30,
                    y: 110
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "behind-frame-3-and-5-dot-1",
            x: 183,
            y: 130,
            shape: "rectangle",
            size: 5,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 83,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 65,
                    y: 20
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 0
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "behind-frame-3-and-5-dot-2",
            x: 183,
            y: 130,
            shape: "rectangle",
            size: 5,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 83,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 65,
                    y: 20
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-3-and-5-icon-jira",
            x: 183,
            y: 130,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9C.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 83,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 65,
                    y: 20
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-3-dot-left",
            x: 0,
            y: 200,
            shape: "circle",
            size: 15,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: -50,
                    y: 100
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "frame-3-and-5-dot-right-bottom",
            x: 250,
            y: 200,
            shape: "circle",
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 150,
                    y: 100
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT,
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 0,
                    y: 0
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-3-rovo-prompt-text",
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            shape: "rectangle",
            size: 70,
            fontFamily: "charlie",
            fontWeight: 400,
            bgColor: "neutral900",
            borderColor: "rainbowRovo",
            borderRadius: 5,
            text: pullingInContextString,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S0.svg",
            imagePlacement: "insideLeading",
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "frame-3-lozenge-1",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4G0.svg",
            text: intl.formatMessage({
                id: "teamworkGraph.frame3.lozenge1",
                defaultMessage: "Strategy Brief"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[0].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[0].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "frame-3-lozenge-2",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4G1.svg",
            text: intl.formatMessage({
                id: "teamworkGraph.frame3.lozenge1",
                defaultMessage: "Portal Repo 2.0"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[1].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[1].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "frame-3-lozenge-3",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FZ.png",
            text: intl.formatMessage({
                id: "teamworkGraph.frame3.lozenge1",
                defaultMessage: "Portal Feature Gates"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_3_PULLING_CONTEXT_STEP_3,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[2].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[2].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        {
            id: "frame-3-video-expand",
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            shape: "rectangle",
            width: 10,
            height: 10,
            opacity: 0,
            bgColor: "neutral800",
            borderColor: "rainbowRovo",
            borderRadius: 10,
            bgImage: bgImageSafari(frame3VideoImg || "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N40H.webp"),
            htmlContent: htmlVideoSafari(frame3VideoUrl || "https://dam-cdn.atl.orangelogic.com/AssetLink/30e047lljh5y7j5n433ls66055u8t018.webm"),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y,
                    width: 1,
                    height: 1,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_3_VIDEO_EXPAND_END,
                    width: $4d767380087f2189$var$vidFrontDimension,
                    height: $4d767380087f2189$var$vidFrontDimension,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        /* bridge from frame 3 to frame 4 */ {
            id: "frame-3-and-4-bridge",
            x: 222,
            y: 120,
            shape: "circle",
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_2_TO_3_END,
                    x: 122,
                    y: 20
                },
                $4d767380087f2189$var$FRAME_3_NODES_SHIFTING_DOWN_LEFT
            ]
        },
        /* frame 4 */ {
            id: "frame-4-icon-loom",
            x: 120,
            y: -80,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9D.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 20,
                    y: 20
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-icon-sharepoint",
            x: 170,
            y: -70,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N539.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 70,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-icon-canva",
            x: 150,
            y: -90,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5Q6.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 50,
                    y: 10
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-dot-top",
            x: 175,
            y: -90,
            shape: "circle",
            size: 4,
            opacity: 1,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 75,
                    y: -10
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-dot-right",
            x: 205,
            y: -20,
            shape: "circle",
            size: 4,
            opacity: 1,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: 105,
                    y: 80
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-text",
            x: $4d767380087f2189$var$textPosition.x + 100,
            y: $4d767380087f2189$var$textPosition.y - 100,
            width: 300,
            height: 400,
            opacity: 0,
            shape: "rectangle",
            fontFamily: "charlie",
            fontWeight: 400,
            bgColor: "transparent",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$desktopHeadingCss,
                        children: frame4HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$desktopDescriptionCSS,
                        children: frame4DescriptionWithDefault
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    opacity: 1,
                    x: $4d767380087f2189$var$textPosition.x,
                    y: $4d767380087f2189$var$textPosition.y
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-rovo-prompt-text",
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            shape: "rectangle",
            size: 70,
            fontFamily: "charlie",
            fontWeight: 400,
            bgColor: "neutral900",
            borderColor: "rainbowRovo",
            borderRadius: 5,
            text: pullingInContextString,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S0.svg",
            imagePlacement: "insideLeading",
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-lozenge-1",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z2.svg",
            text: intl.formatMessage({
                id: "teamworkGraph.frame4.lozenge1",
                defaultMessage: "Portal Redesign Brainstorm"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[0].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[0].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-lozenge-2",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z3.svg",
            text: intl.formatMessage({
                id: "teamworkGraph.frame4.lozenge1",
                defaultMessage: "Portal Designs"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[1].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[1].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-lozenge-3",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z4.svg",
            text: intl.formatMessage({
                id: "teamworkGraph.frame4.lozenge1",
                defaultMessage: " [O1.KR2] Add 300K Accounts"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_1_TO_2_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_4_PULLING_CONTEXT_STEP_3,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[2].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[2].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        {
            id: "frame-4-video-expand",
            x: $4d767380087f2189$var$videoPosition.x + 100,
            y: $4d767380087f2189$var$videoPosition.y - 100,
            shape: "rectangle",
            width: 10,
            height: 10,
            opacity: 0,
            bgColor: "neutral800",
            borderColor: "rainbowRovo",
            borderRadius: 10,
            bgImage: bgImageSafari(frame4VideoImg || "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N40I.webp"),
            htmlContent: htmlVideoSafari(frame4VideoUrl || "https://dam-cdn.atl.orangelogic.com/AssetLink/ny32egn16elq2656p0mpl83368pr3wlx.webm"),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_3_TO_4_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y,
                    width: 1,
                    height: 1,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_4_VIDEO_EXPAND_END,
                    width: $4d767380087f2189$var$vidFrontDimension,
                    height: $4d767380087f2189$var$vidFrontDimension,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_4_NODES_SHIFTING_UP_RIGHT
            ]
        },
        /* frame 5 */ {
            id: "frame-5-text",
            x: $4d767380087f2189$var$textPosition.x - 100,
            y: $4d767380087f2189$var$textPosition.y + 100,
            width: 300,
            height: 400,
            opacity: 0,
            shape: "rectangle",
            fontFamily: "charlie",
            fontWeight: 400,
            bgColor: "transparent",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        style: $4d767380087f2189$var$desktopHeadingCss,
                        children: frame5HeadingWithDefault
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        style: $4d767380087f2189$var$desktopDescriptionCSS,
                        children: frame5DescriptionWithDefault
                    })
                ]
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    opacity: 1,
                    x: $4d767380087f2189$var$textPosition.x,
                    y: $4d767380087f2189$var$textPosition.y
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-5-rovo-prompt-text",
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            shape: "rectangle",
            size: 70,
            fontFamily: "charlie",
            fontWeight: 400,
            bgColor: "neutral900",
            borderColor: "rainbowRovo",
            borderRadius: 5,
            text: pullingInContextString,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4S0.svg",
            imagePlacement: "insideLeading",
            animationPhases: [
                {
                    delay: 0,
                    duration: 1,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-5-lozenge-1",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4YZ.png",
            text: intl.formatMessage({
                id: "teamworkGraph.frame5.lozenge1",
                defaultMessage: "Partner Calls"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[0].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[0].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-5-lozenge-2",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z0.svg",
            text: intl.formatMessage({
                id: "teamworkGraph.frame5.lozenge1",
                defaultMessage: "FIN-300: Account Microservice"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_2,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[1].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[1].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-5-lozenge-3",
            ...$4d767380087f2189$var$LOZENGE_ATTRIBUTES,
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z1.svg",
            text: intl.formatMessage({
                id: "teamworkGraph.frame5.lozenge1",
                defaultMessage: "Design Walkthrough"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_1,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_5_PULLING_CONTEXT_STEP_3,
                    x: $4d767380087f2189$var$LOZENGE_POSITIONS[2].x,
                    y: $4d767380087f2189$var$LOZENGE_POSITIONS[2].y,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-5-icon-microsoft",
            shape: "rectangle",
            x: -60,
            y: 177,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA0.svg",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: 40,
                    y: 77
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        {
            id: "frame-5-video-expand",
            x: $4d767380087f2189$var$videoPosition.x - 100,
            y: $4d767380087f2189$var$videoPosition.y + 100,
            shape: "rectangle",
            width: 10,
            height: 10,
            opacity: 0,
            bgColor: "neutral800",
            borderColor: "rainbowRovo",
            borderRadius: 10,
            bgImage: bgImageSafari(frame5VideoImg || "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N40G.webp"),
            htmlContent: htmlVideoSafari(frame5VideoUrl || "https://dam-cdn.atl.orangelogic.com/AssetLink/jl7534n20m4g3xtquu6wn3i5i13113q5.webm"),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_4_TO_5_END,
                    x: $4d767380087f2189$var$videoPosition.x,
                    y: $4d767380087f2189$var$videoPosition.y,
                    width: 1,
                    height: 1,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_5_VIDEO_EXPAND_END,
                    width: $4d767380087f2189$var$vidFrontDimension,
                    height: $4d767380087f2189$var$vidFrontDimension,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_5_NODES_SHIFTING_LEFT
            ]
        },
        /* frame 6 */ {
            id: "frame-6-grid-left",
            x: 150,
            y: 30,
            width: 880,
            height: 701,
            opacity: 0,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: $4d767380087f2189$var$GRID_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 0,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-grid-right",
            x: 200,
            y: 90,
            width: 880,
            height: 701,
            opacity: 0,
            shape: "rectangle",
            bgColor: "transparent",
            bgImage: $4d767380087f2189$var$GRID_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 100,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-behind-assets-top",
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-behind-assets-bottom",
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 7.4,
                    y: 70
                }
            ]
        },
        {
            id: "frame-6-behind-in-progress-top",
            x: 180,
            y: 30,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: "frame-6-behind-in-progress-bottom",
            x: 180,
            y: 30,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 30.7,
                    y: 63.8
                }
            ]
        },
        {
            id: "frame-6-behind-done-top",
            x: 195,
            y: 80,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 95,
                    y: 80
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 33.1,
                    y: 82.6
                }
            ]
        },
        {
            id: "frame-6-behind-done-bottom",
            x: 195,
            y: 80,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 95,
                    y: 80
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-lozenge-marketing-team",
            x: 110,
            y: 20,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.marketingTeam",
                defaultMessage: "Marketing team"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FX.svg",
            imagePlacement: "outsideLeading",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            size: 20,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 10,
                    y: 25,
                    opacity: 0,
                    size: 20
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 10,
                    y: 30,
                    opacity: 1,
                    size: 30
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-lozenge-meeting-recordings",
            x: 113,
            y: 20,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.meetingRecordings",
                defaultMessage: "Meeting Recordings"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FS.png",
            imagePlacement: "outsideLeading",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            size: 20,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 10,
                    y: 25,
                    opacity: 0,
                    size: 20
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_2_END,
                    x: 13,
                    y: 35,
                    opacity: 1,
                    size: 30
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-lozenge-campaign-ad-refresh",
            x: 116,
            y: 20,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.campaignAdRefresh",
                defaultMessage: "Campaign Ad Refresh"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MU.png",
            imagePlacement: "outsideLeading",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            size: 20,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 10,
                    y: 25,
                    opacity: 0,
                    size: 20
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_3_END,
                    x: 16,
                    y: 40,
                    opacity: 1,
                    size: 30
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-rectangle-assets",
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: "rectangle",
            width: 100,
            height: 50,
            opacity: 0,
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/n77suu8uq6g15lwd755l77a3833ai6b3.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1],
                    width: 200,
                    height: 100,
                    opacity: 1
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "final-screen-behind-squiggle-to-idea",
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: "circle",
            opacity: 0,
            size: 1,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1],
                    opacity: 0,
                    size: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 1.6,
                    y: 49,
                    opacity: 1
                }
            ]
        },
        {
            id: "final-screen-icon-squiggle",
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: "rectangle",
            size: 1,
            opacity: 0,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/xcosenf3w13o8pq585o705fxys5q03x2.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1],
                    opacity: 0,
                    size: 1
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 7.4,
                    y: 70,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
                    opacity: 1
                }
            ]
        },
        {
            id: "frame-6-dot-offscreen-bottom-left",
            x: 100,
            y: 100,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: -30,
                    y: 100
                }
            ]
        },
        {
            id: "frame-6-icon-figma",
            x: 150,
            y: 97,
            shape: "rectangle",
            borderColor: "white",
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/pjx7hy131bqolmfog4go5ej85dxwm7k7.svg",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 50,
                    y: 97
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-behind-comment",
            x: 120,
            y: 75,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 20,
                    y: 75
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 16.4,
                    y: 91.3
                }
            ]
        },
        {
            id: "frame-6-rectangle-comment",
            x: 120,
            y: 75,
            shape: "rectangle",
            width: 100,
            height: 50,
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/2gf42uyw6x35g346v1337b15dx434t0a.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 20,
                    y: 75,
                    width: 200,
                    height: 100
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-behind-from-assets-to-avatars-rectangle",
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 40,
                    y: 5
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-rectangle-avatars",
            x: 140,
            y: 5,
            shape: "rectangle",
            width: 200,
            height: 100,
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/32agfh01wn5t07ah5781p287ap8sxoh4.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 40,
                    y: 5
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-rectangle-in-progress",
            x: 180,
            y: 30,
            shape: "rectangle",
            width: 200,
            height: 100,
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/426lxf8r1u73b7e5768ts0dd2w26n11l.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-icon-loom",
            x: 80,
            y: 30,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            opacity: 0,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/4t8837ogw4s4t31c7x0hgfb523o7s4v1.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 30.7,
                    y: 63.8,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
                    opacity: 1
                }
            ]
        },
        {
            id: "frame-6-rectangle-done",
            x: 195,
            y: 80,
            shape: "rectangle",
            width: 200,
            height: 100,
            bgColor: "transparent",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/b4d1tn2sdy0s36i56c857db6w1k1u2b4.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 95,
                    y: 80
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-icon-confluence",
            x: 95,
            y: 80,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            opacity: 0,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MY.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 33.1,
                    y: 82.6,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE,
                    opacity: 1
                }
            ]
        },
        {
            id: "frame-6-behind-from-in-progress-to-avatar",
            x: 180,
            y: 30,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: "frame-6-behind-from-done-to-avatar",
            x: 195,
            y: 80,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 95,
                    y: 80
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: "frame-6-behind-from-assets-to-avatar",
            ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[0],
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    ...$4d767380087f2189$var$RECTANGLE_ASSETS_POSITIONS[1]
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: "frame-6-behind-from-comment-to-avatar",
            x: 120,
            y: 75,
            shape: "circle",
            size: 4,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 20,
                    y: 75
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_6_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_6_ADJUST_1_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9
                }
            ]
        },
        {
            id: "final-screen-behind-avatar-blue-to-jpd",
            x: 150,
            y: 50,
            shape: "circle",
            size: 1,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 16.6,
                    y: 44.2
                }
            ]
        },
        {
            id: "final-screen-avatar-blue",
            x: 150,
            y: 50,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/vvs64iqhos5vy1u702ok4u50s42m10ii.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 50,
                    y: 50
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.6,
                    y: 74.9,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-6-lozenge-partner-research",
            x: 140,
            y: 15,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.partnerCalls",
                defaultMessage: "Partner Calls"
            }),
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4YZ.png",
            imagePlacement: "outsideLeading",
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 40
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-lozenge-fin-300",
            x: 143,
            y: 20,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.fin300AccountMicroservice",
                defaultMessage: "FIN-300: Account Microservice"
            }),
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z0.svg",
            imagePlacement: "outsideLeading",
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 43
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-design-demo",
            x: 143,
            y: 25,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.designDemo",
                defaultMessage: "Design Demo"
            }),
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z1.svg",
            imagePlacement: "outsideLeading",
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 43
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-lozenge-portal-redesign-brainstorm",
            x: 123,
            y: 85,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.portalRedesignBrainstorm",
                defaultMessage: "Portal Redesign Brainstorm"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z2.svg",
            imagePlacement: "outsideLeading",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 23
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-lozenge-portal-designs",
            x: 123,
            y: 90,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.portalDesigns",
                defaultMessage: "Portal Designs"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z3.svg",
            imagePlacement: "outsideLeading",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 23
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-okr",
            x: 126,
            y: 95,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.okrAdd300kAccounts",
                defaultMessage: "[01.KR2] Add 300k accounts"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z4.svg",
            imagePlacement: "outsideLeading",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 26
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-lozenge-strategy-brief",
            x: 180,
            y: 40,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.strategyBrief",
                defaultMessage: "Strategy Brief"
            }),
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4Z2.svg",
            imagePlacement: "outsideLeading",
            shape: "rectangle",
            bgColor: "blue600",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-lozenge-portal-feature-gates",
            x: 183,
            y: 45,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.portalFeatureGates",
                defaultMessage: "Portal Feature Gates"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4FZ.png",
            imagePlacement: "outsideLeading",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 83
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        {
            id: "frame-6-portal-repo-2-point-0",
            x: 186,
            y: 50,
            size: 30,
            text: intl.formatMessage({
                id: "teamworkGraph.frame6.portalRepo2",
                defaultMessage: "Portal Repo 2.0"
            }),
            shape: "rectangle",
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4G1.svg",
            imagePlacement: "outsideLeading",
            textColor: "white",
            fontFamily: "charlie",
            fontWeight: 400,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 86
                },
                $4d767380087f2189$var$FRAME_6_NODES_SHRINKING
            ]
        },
        /* frame 7 */ {
            id: "frame-7-center-text",
            x: 140,
            y: 45,
            shape: "rectangle",
            width: 700,
            height: 200,
            opacity: 0,
            bgColor: "transparent",
            htmlContent: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    textAlign: "center"
                },
                children: frame7Heading && !(0, $dZNgt.isRichTextValueConsideredEmpty)(frame7Heading) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformRichTextNode), {
                    node: frame7Heading["root"] || frame7Heading
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "gwp.refresh.teamworkGraph.frame7.heading",
                        values: (0, $iRMRa.DEFAULT_VALUES),
                        defaultMessage: "So you can make <br></br> <strong>smarter moves, faster</strong>"
                    })
                })
            }),
            textColor: "white",
            fontWeight: 400,
            fontFamily: "charlie",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 40,
                    y: 45,
                    opacity: 0
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_1_END,
                    x: 50,
                    y: 45,
                    opacity: 1
                }
            ]
        },
        {
            id: "frame-7-pill-meeting-notes",
            x: 20,
            y: 75,
            shape: "rectangle",
            size: 20,
            opacity: 0,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50K.svg",
            imagePlacement: "insideLeading",
            borderColor: "blue600",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame7.meetingNotes",
                defaultMessage: "Meeting notes"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 16.4,
                    y: 91.3,
                    size: 47,
                    opacity: 1
                }
            ]
        },
        /* frame 7 — enter from off-screen during 6 to 7 transition */ {
            id: "frame-7-icon-hubspot",
            x: 0,
            y: -100,
            shape: "rectangle",
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MV.svg",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 5,
                    y: 5,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-dot-x-30-y-0",
            x: 90,
            y: -100,
            shape: "circle",
            size: 1,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 30,
                    y: -4
                }
            ]
        },
        {
            id: "frame-7-dot-x-50-y-0",
            x: 150,
            y: -100,
            shape: "circle",
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 50,
                    y: -4
                }
            ]
        },
        {
            id: "frame-7-dot-x-60-y-0",
            x: 200,
            y: -100,
            shape: "circle",
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 60,
                    y: -4
                }
            ]
        },
        {
            id: "frame-7-dot-x-65-y-0",
            x: 250,
            y: -100,
            shape: "circle",
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 65,
                    y: 0
                }
            ]
        },
        {
            id: "frame-7-dot-x-70-y-0",
            x: 260,
            y: -100,
            shape: "circle",
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 70,
                    y: -4
                }
            ]
        },
        {
            id: "frame-7-dot-x-80-y-0",
            x: 300,
            y: -100,
            shape: "circle",
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 80,
                    y: -4
                }
            ]
        },
        {
            id: "frame-7-icon-jira-top",
            x: 100,
            y: -99,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "blue600",
            bgImage: $4d767380087f2189$var$JIRA_IMG,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 38.4,
                    y: 1,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-focus-top",
            x: 200,
            y: -57,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "orange300",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MW.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 63.6,
                    y: 3.8,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-behind-avatar-lime-top",
            x: 250,
            y: -71,
            shape: "circle",
            size: 1,
            opacity: 0,
            bgColor: "lime800",
            borderColor: "lime500",
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 81.8,
                    y: 8.8
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_2_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: "frame-7-avatar-lime-top",
            x: 250,
            y: -71,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: "lime500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N520.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 81.8,
                    y: 8.8,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-pill-campaign",
            x: 90,
            y: -99,
            shape: "rectangle",
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50N.svg",
            imagePlacement: "insideLeading",
            borderColor: "blue600",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame7.campaign",
                defaultMessage: "Campaign"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 18.2,
                    y: 8.8,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-pill-pr",
            x: 300,
            y: -100,
            shape: "rectangle",
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N4ZC.svg",
            imagePlacement: "insideLeading",
            borderColor: "lime500",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame7.pullRequestAbbrev",
                defaultMessage: "PR",
                description: "Abbreviation for pull request, shown on a small pill label in a marketing animation"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 98.1,
                    y: 10,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-behind-avatar-orange",
            x: 200,
            y: -60,
            shape: "circle",
            size: 1,
            opacity: 0,
            bgColor: "orange800",
            borderColor: "orange300",
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 53,
                    y: 17.5
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_1_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: "frame-7-avatar-orange",
            x: 200,
            y: -60,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: "orange300",
            textColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N51Z.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 53,
                    y: 17.5,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-bookmark",
            x: 90,
            y: -70,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/2v746wlx1l1r41a6s5p63e7y102ko2l4.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 27.7,
                    y: 17.7,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-bitbucket",
            x: 300,
            y: -20,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "lime500",
            textColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/s6xb2173woj4m00n36b754t44126al0l.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 92.3,
                    y: 22.9,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-rovo-dev",
            x: 250,
            y: -20,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "lime400",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MX.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 71.6,
                    y: 24.9,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-behind-avatar-purple",
            x: 50,
            y: -96,
            shape: "circle",
            size: 1,
            opacity: 0,
            bgColor: "purple800",
            borderColor: "purple500",
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 8,
                    y: 27.6
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_2_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: "frame-7-avatar-purple",
            x: 50,
            y: -96,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: "purple500",
            textColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N51X.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 8,
                    y: 27.6,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-pill-goal",
            x: 225,
            y: -10,
            shape: "rectangle",
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50M.svg",
            imagePlacement: "insideLeading",
            borderColor: "orange300",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame7.goal",
                defaultMessage: "Goal"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 61.4,
                    y: 31.1,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-purple-jpd",
            x: 70,
            y: -20,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "purple500",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/67p4f030jo35j028ayr2hw4tioa5i200.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 16.6,
                    y: 44.2,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-pill-idea",
            x: 20,
            y: -20,
            shape: "rectangle",
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50L.svg",
            imagePlacement: "insideLeading",
            borderColor: "purple500",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame7.idea",
                defaultMessage: "Idea"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 1.6,
                    y: 49,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        /* frame 7 nodes moving downward */ {
            id: "frame-7-behind-avatar-saffron",
            x: 280,
            y: 22,
            shape: "circle",
            size: 1,
            opacity: 0,
            bgColor: "blue600",
            borderColor: "blue400",
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 86.4,
                    y: 52
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_1_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: "frame-7-avatar-saffron",
            x: 280,
            y: 22,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: "blue600",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N521.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 86.4,
                    y: 52,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-rocket",
            x: 200,
            y: 20,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/ptn36e828x7k02745o673wfoe4mpofj2.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 57.1,
                    y: 62,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-target",
            x: 300,
            y: 63.5,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/65wycilre16o225ia50e84d3a22ch140.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 96.1,
                    y: 63.5,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-behind-loom",
            x: 180,
            y: 30,
            shape: "rectangle",
            size: 1,
            opacity: 0,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_5_TO_6_END,
                    x: 80,
                    y: 30
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 30.7,
                    y: 63.8
                }
            ]
        },
        {
            id: "frame-7-icon-bell",
            x: 250,
            y: 25,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/3gjch6tk0wbw3801u4656e82213h5xvm.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 71.2,
                    y: 64.3,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-csm",
            x: 150,
            y: 40,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "yellow300",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N54R.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 46.1,
                    y: 73.7,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-gdrive",
            x: 270,
            y: 78.1,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "black",
            borderColor: "white",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA5.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 87.9,
                    y: 78.1,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-icon-behind-confluence",
            x: 100,
            y: 80,
            shape: "circle",
            size: 1,
            bgColor: "transparent",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 33.1,
                    y: 82.6
                }
            ]
        },
        {
            id: "frame-7-icon-jsm",
            x: 200,
            y: 40,
            shape: "rectangle",
            size: $4d767380087f2189$var$ICON_NORMAL_SIZE,
            bgColor: "yellow300",
            bgImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/nj3c8i7014gw1sba21en752f0q4pq0sx.svg",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 58.8,
                    y: 87.1,
                    size: $4d767380087f2189$var$ICON_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-dot-x-0-y-90",
            x: 100,
            y: 90,
            shape: "circle",
            size: 1,
            opacity: 0,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 0,
                    y: 90
                }
            ]
        },
        {
            id: "frame-7-behind-avatar-lime-bottom",
            x: 250,
            y: 91.8,
            shape: "circle",
            size: 1,
            opacity: 0,
            bgColor: "lime800",
            borderColor: "lime500",
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 76.5,
                    y: 91.8
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_2_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_2_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: "frame-7-avatar-lime-bottom",
            x: 250,
            y: 91.8,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: "lime400",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N522.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 76.5,
                    y: 91.8,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-pill-release",
            x: 300,
            y: 92.5,
            shape: "rectangle",
            size: $4d767380087f2189$var$PILL_NORMAL_SIZE,
            bgColor: "black",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N50J.svg",
            imagePlacement: "insideLeading",
            borderColor: "lime500",
            textColor: "white",
            text: intl.formatMessage({
                id: "teamworkGraph.frame7.release",
                defaultMessage: "Release"
            }),
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 92.8,
                    y: 92.5,
                    size: $4d767380087f2189$var$PILL_SHRUNKEN_SIZE
                }
            ]
        },
        {
            id: "frame-7-behind-avatar-yellow",
            x: 150,
            y: 99,
            shape: "circle",
            size: 1,
            opacity: 0,
            bgColor: "yellow700",
            borderColor: "yellow400",
            borderWidth: 8,
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 47.5,
                    y: 99
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_1_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_1_END,
                    opacity: 0.2,
                    size: 150
                },
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$FRAME_7_ADJUST_3_START,
                    scrollWindowEnd: $4d767380087f2189$var$FRAME_7_ADJUST_3_END,
                    opacity: 0.05,
                    size: 1
                }
            ]
        },
        {
            id: "frame-7-avatar-yellow",
            x: 150,
            y: 99,
            shape: "circle",
            size: $4d767380087f2189$var$AVATAR_NORMAL_SIZE,
            bgColor: "yellow400",
            bgImage: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N51Y.png",
            animationPhases: [
                {
                    delay: 0,
                    duration: 0,
                    scrollWindowStart: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_START,
                    scrollWindowEnd: $4d767380087f2189$var$TRANSITION_FROM_FRAME_6_TO_7_END,
                    x: 47.5,
                    y: 99,
                    size: $4d767380087f2189$var$AVATAR_SHRUNKEN_SIZE
                }
            ]
        }
    ];
    const sectionRef = (0, $1oC0p.useRef)(null);
    const desktopShellRef = (0, $1oC0p.useRef)(null);
    const skipTargetRef = (0, $1oC0p.useRef)(null);
    const skipScrollRafRef = (0, $1oC0p.useRef)(0);
    const skipScrollMountedRef = (0, $1oC0p.useRef)(true);
    const skipAnimatingRef = (0, $1oC0p.useRef)(false);
    const hasEverFullyScrolledPastSectionRef = (0, $1oC0p.useRef)(false);
    const prevDesktopScrollPhaseRef = (0, $1oC0p.useRef)("track");
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [percentageScrolled, setPercentageScrolled] = (0, $1oC0p.useState)(0);
    const [hasScrolledPast, setHasScrolledPast] = (0, $1oC0p.useState)(false);
    const [hasScrolledAboveAgain, setHasScrolledAboveAgain] = (0, $1oC0p.useState)(false);
    const [desktopScrollPhase, setDesktopScrollPhase] = (0, $1oC0p.useState)("track");
    /** Holds the graph at final scroll progress (same as natural dock) while skipping. */ const [skipEndFrameHold, setSkipEndFrameHold] = (0, $1oC0p.useState)(false);
    const [skipScrollAnimating, setSkipScrollAnimating] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (prevDesktopScrollPhaseRef.current === "docked" && desktopScrollPhase === "track") hasEverFullyScrolledPastSectionRef.current = false;
        prevDesktopScrollPhaseRef.current = desktopScrollPhase;
    }, [
        desktopScrollPhase
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (hasScrolledPast && skipEndFrameHold) setSkipEndFrameHold(false);
    }, [
        hasScrolledPast,
        skipEndFrameHold
    ]);
    (0, $1oC0p.useEffect)(()=>{
        skipScrollMountedRef.current = true;
        return ()=>{
            skipScrollMountedRef.current = false;
            if (skipScrollRafRef.current !== 0) {
                cancelAnimationFrame(skipScrollRafRef.current);
                skipScrollRafRef.current = 0;
            }
        };
    }, []);
    const handleDesktopSkipClick = (0, $1oC0p.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            source: "teamworkGraph"
        }).fire();
        if (skipAnimatingRef.current) return;
        const target = skipTargetRef.current;
        if (!target) return;
        skipAnimatingRef.current = true;
        setSkipScrollAnimating(true);
        setSkipEndFrameHold(true);
        const startY = window.scrollY;
        const endY = Math.max(0, Math.round(target.getBoundingClientRect().top + window.scrollY - $4d767380087f2189$var$TEAMWORK_GRAPH_SKIP_SCROLL_TOP_PADDING_PX));
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReducedMotion || Math.abs(endY - startY) < 2) {
            window.scrollTo(0, endY);
            skipAnimatingRef.current = false;
            setSkipScrollAnimating(false);
            target.focus({
                preventScroll: true
            });
            return;
        }
        const t0 = performance.now();
        const duration = $4d767380087f2189$var$TEAMWORK_GRAPH_SKIP_SCROLL_MS;
        const step = (now)=>{
            if (!skipScrollMountedRef.current) {
                skipAnimatingRef.current = false;
                setSkipScrollAnimating(false);
                return;
            }
            const t = Math.min(1, (now - t0) / duration);
            const y = startY + (endY - startY) * $4d767380087f2189$var$easeInOutCubicSkipScroll(t);
            window.scrollTo(0, y);
            if (t < 1) skipScrollRafRef.current = requestAnimationFrame(step);
            else {
                skipScrollRafRef.current = 0;
                skipAnimatingRef.current = false;
                setSkipScrollAnimating(false);
                target.focus({
                    preventScroll: true
                });
            }
        };
        skipScrollRafRef.current = requestAnimationFrame(step);
    }, [
        createAnalyticsEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const section = sectionRef.current;
        if (!section) return;
        const updateSectionScrollState = ()=>{
            const el = sectionRef.current;
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const fullyPast = rect.bottom <= 0;
            setPercentageScrolled(rect.top * -1 / rect.height * 100);
            setHasScrolledPast(fullyPast);
            if (fullyPast) hasEverFullyScrolledPastSectionRef.current = true;
            setHasScrolledAboveAgain(hasEverFullyScrolledPastSectionRef.current && !fullyPast);
            setDesktopScrollPhase((phase)=>{
                if (phase === "track") return fullyPast ? "docked" : "track";
                const shell = desktopShellRef.current;
                if (shell) {
                    const shellTop = shell.getBoundingClientRect().top;
                    if (shellTop > 6) return "track";
                }
                return "docked";
            });
        };
        updateSectionScrollState();
        window.addEventListener("scroll", updateSectionScrollState, {
            passive: true
        });
        window.addEventListener("resize", updateSectionScrollState);
        const ro = new ResizeObserver(updateSectionScrollState);
        ro.observe(section);
        const shell = desktopShellRef.current;
        if (shell) ro.observe(shell);
        return ()=>{
            window.removeEventListener("scroll", updateSectionScrollState);
            window.removeEventListener("resize", updateSectionScrollState);
            ro.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: {
            margin: "0",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _uwwnglyw _mkl21kxc _7vpg15vq _1io315vq",
                    `desktop_container_${desktopScrollPhase} scroll_past_${hasScrolledPast} scroll_above_again_${hasScrolledAboveAgain}`
                ]),
                ref: desktopShellRef,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: `tall_height_${desktopScrollPhase}`,
                    ref: sectionRef,
                    style: {
                        position: "relative",
                        minHeight: `${stickyHeight}vh`
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _p12f1osq _kqsw1if8 _19pkidpf _2hwx1wug _otyridpf _18u01wug _152tdvcx _1e02idpf",
                            `sticky_${desktopScrollPhase}`
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                                // scrollMagnetAnchors={orderedScrollMagnetAnchors}
                                // scrollMagnetMinProgressDelta={
                                //     scrollMagnetMinProgressDelta
                                // }
                                // scrollMagnetDirectionBias={
                                //     scrollMagnetDirectionBias
                                // }
                                bgColor: "black",
                                animationPhasesDrive: "scroll",
                                scrollSectionRef: sectionRef,
                                scrollPhaseProgressOverride: desktopScrollPhase === "docked" || skipEndFrameHold ? 1 : null,
                                onScrollPhaseProgressChange: onDesktopScrollPhaseProgressChange,
                                nodes: teamworkGraphAllFramesNodes,
                                connectors: (0, $fk4mX.teamworkGraphAllFramesConnectors),
                                useOnlyExplicitConnectors: true,
                                connectorColor: "blue300",
                                connectorWidth: 3,
                                replayOnVisible: false,
                                useViewportDimensions: true,
                                fontFamily: "monospace",
                                animateOnLoad: false
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _1r04idpf _1bsb1osq _4t3i10fc _lcxvglyw _1pbycs5v _17djb3bt _147jb3bt _175istnw _1nwdstnw _ozr6idpf _yotaidpf _k71uidpf _1ckaidpf _21xqoyl8 _6h4ooyl8 _11951osq _axqm1osq _1a3tglyw _1vuxglyw _110xcs5v _gwe3cs5v _14ux1wug _4o4c1mgz _7rhxidpf _k71u1wug _isey1pyf"
                                ]),
                                style: {
                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _kqswstnw _1pby11wp _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152t1us8 _u7co1wug _1e02idpf _rjxpidpf _1bsb1nrf _1e0c1txw _zulpu2gc _1yt44jca",
                                    "navigation-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1bsb1osq _4t3iftgi _16jlkb7n _lcxvglyw _1pbycs5v _1reo15vq _18m915vq _2rko17td",
                                            "progress-timeline"
                                        ]),
                                        style: {
                                            "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _4t3iftgi _kqswstnw _1e0c1txw _2lx2vrvc _zulpftgi",
                                                    "_bfhk1533",
                                                    "bars behind"
                                                ]),
                                                style: {
                                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1bsb1osq _4t3iftgi _kqswstnw _1e0c1txw _2lx2vrvc _zulpftgi",
                                                    "_bfhk17la",
                                                    "bars front"
                                                ]),
                                                style: {
                                                    clipPath: `polygon(0 0, ${percentageScrolled}% 0, ${percentageScrolled}% 100%, 0 100%)`,
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: "skip-button-area",
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                            className: (0, $2jatx.default)([
                                                "_bfhk1d0o _80omtlke _1e0c1o8l _syazcd5j _19it1hdd _2rko17td _1yt44jca _ect41pz4 _1wybutpp _vwz4kb7n _irr36rs1",
                                                skipScrollAnimating && "_lcxvglyw _tzy41cit",
                                                "skip-button"
                                            ]),
                                            href: "#skip-graph",
                                            "aria-busy": skipScrollAnimating,
                                            "aria-disabled": skipScrollAnimating,
                                            onClick: handleDesktopSkipClick,
                                            style: {
                                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                                "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill")),
                                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                            },
                                            children: intl.formatMessage({
                                                id: "teamworkGraph.skipButton",
                                                defaultMessage: "Skip"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _uwwn1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    style: {
                        width: "100%",
                        margin: "0 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesA,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsA),
                            connectorColor: "blue600",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(537)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesB,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsB),
                            connectorColor: "blue600",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(705)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesC,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsC),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(330)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesD,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsD),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(550)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesE,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsE),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(330)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesF,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsF),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(550)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesG,
                            useOnlyExplicitConnectors: true,
                            connectors: [],
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(300)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesH,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsH),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(550)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $UMzWl.SpiderWebContainer), {
                            bgColor: "black",
                            nodes: teamworkGraphMobileNodesI,
                            useOnlyExplicitConnectors: true,
                            connectors: (0, $fk4mX.teamworkGraphMobileConnectorsI),
                            connectorColor: "blue300",
                            connectorWidth: 3,
                            width: $4d767380087f2189$var$MOBILE_TEAMWORK_GRAPH_WIDTH,
                            height: $4d767380087f2189$var$scaledMobileTeamworkGraphHeight(800)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: skipTargetRef,
                className: "skip-to-bottom",
                id: "skip-graph",
                tabIndex: -1
            })
        ]
    });
};
var $4d767380087f2189$export$2e2bcd8739ae039 = $4d767380087f2189$var$UniformTeamworkGraph;

});
parcelRegister("UMzWl", function(module, exports) {
$parcel$export(module.exports, "SpiderWebContainer", function () { return $0d50d6616177f8b7$export$5c2ce7618e6623c7; });
/* spiderweb-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iZj3A = parcelRequire("iZj3A");

var $idRu8 = parcelRequire("idRu8");

var $hNner = parcelRequire("hNner");

var $kCguZ = parcelRequire("kCguZ");

var $7h9Nf = parcelRequire("7h9Nf");

var $iDO3O = parcelRequire("iDO3O");

var $ldiHh = parcelRequire("ldiHh");

var $29NYv = parcelRequire("29NYv");

var $hiPUj = parcelRequire("hiPUj");

var $gHYtp = parcelRequire("gHYtp");
const $0d50d6616177f8b7$var$NODE_STAGGER = 0.06;
const $0d50d6616177f8b7$var$EDGE_DELAY_BASE = 0.3;
const $0d50d6616177f8b7$var$EDGE_STAGGER = 0.08;
const $0d50d6616177f8b7$var$NODE_ENTRANCE_DURATION_SEC = 0.6;
const $0d50d6616177f8b7$var$CONNECTOR_SOLID_DRAW_DURATION_SEC = 1;
const $0d50d6616177f8b7$var$CONNECTOR_DASHED_ENTRANCE_DURATION_SEC = 0.8;
const $0d50d6616177f8b7$var$OVERLAP_LOAD_ENTRANCE_FADE_SEC = 0.5;
const $0d50d6616177f8b7$var$ANIMATED_CONNECTOR_SHAPE_OPACITY_SEC = 0.6;
const $0d50d6616177f8b7$var$ANIMATED_CONNECTOR_SHAPE_APPEAR_OFFSET_SEC = 1;
/**
 * `animation-play-state` does not inherit; this scopes `paused` to all descendants
 * (and common pseudo-elements) so keyframe animations freeze in place.
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors -- intentional descendant `animation-play-state` (non-inherited) */ const $0d50d6616177f8b7$var$spiderwebPauseScopeStyle = null;
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors */ function $0d50d6616177f8b7$var$clampLoadEntranceSpeedMultiplier(raw) {
    const m = raw ?? 1;
    if (!Number.isFinite(m) || m <= 0) return 1;
    return Math.min(10, Math.max(0.25, m));
}
function $0d50d6616177f8b7$var$computePhaseClockStartOffsetSec(animateOnLoad, nodeCount, edgeCount, nodeTotalDuration, connectorType, nodeStagger, nodeEntranceDurationSec, edgeDelayBase, edgeStagger, solidDrawDurationSec, dashedFadeDurationSec) {
    if (!animateOnLoad) return 0;
    const lastNodeDelay = nodeCount > 0 ? (nodeCount - 1) * nodeStagger : 0;
    const nodeEntranceEndSec = lastNodeDelay + nodeEntranceDurationSec;
    const connectorEntranceEndSec = edgeCount === 0 ? 0 : nodeTotalDuration + edgeDelayBase + Math.max(0, edgeCount - 1) * edgeStagger + (connectorType === "dashed" ? dashedFadeDurationSec : solidDrawDurationSec);
    return Math.max(nodeEntranceEndSec, connectorEntranceEndSec);
}
function $0d50d6616177f8b7$var$createNodeEntranceDelayFn(animateOnLoad, nodeStagger) {
    return (index)=>animateOnLoad ? index * nodeStagger : 0;
}
function $0d50d6616177f8b7$var$createConnectorEntranceDelayFn(animateOnLoad, nodeTotalDuration, edgeDelayBase, edgeStagger) {
    return (index)=>animateOnLoad ? nodeTotalDuration + edgeDelayBase + index * edgeStagger : 0;
}
function $0d50d6616177f8b7$var$overlapEntranceDelayValue(animateOnLoad, nodeTotalDuration, edgeDelayBase) {
    return animateOnLoad ? nodeTotalDuration + edgeDelayBase * 0.5 : 0;
}
function $0d50d6616177f8b7$var$openNodeModalIfPresent(node, setExpandingNodeId, setActiveModal) {
    if (!node.modalContent) return;
    setExpandingNodeId(node.id);
    setTimeout(()=>{
        setActiveModal(node.modalContent ?? null);
    }, 200);
}
function $0d50d6616177f8b7$var$resolveAnimationFlags(prefersReducedMotion, isVisible) {
    return {
        animated: prefersReducedMotion || isVisible,
        phaseMotionActive: !prefersReducedMotion && isVisible
    };
}
function $0d50d6616177f8b7$var$spiderWebDimensionValues(width, height) {
    return {
        widthValue: width ?? "100%",
        heightValue: height ?? 600
    };
}
function $0d50d6616177f8b7$var$computeViewBoxHeight(width, height, useViewportDimensions) {
    if (useViewportDimensions) return 0, $hNner.VIEWBOX_SCALE;
    if (typeof width === "number" && typeof height === "number") return Math.round((0, $hNner.VIEWBOX_SCALE) * height / width);
    return 0, $hNner.VIEWBOX_SCALE;
}
function $0d50d6616177f8b7$var$buildContainerStyle(width, height, bgColor, maxHeightViewport, useViewportDimensions) {
    const bg = bgColor !== undefined ? (0, $hNner.getFillColor)(bgColor) : undefined;
    if (useViewportDimensions) return {
        position: "relative",
        backgroundColor: bg,
        overflow: "hidden",
        width: "100vw",
        height: "90vh"
    };
    const hasExplicitWidth = width && typeof width === "number" || typeof width === "string";
    const hasExplicitHeight = height && typeof height === "number" || typeof height === "string";
    return {
        position: "relative",
        backgroundColor: bg,
        overflow: "hidden",
        maxWidth: width,
        width: "100%",
        maxHeight: maxHeightViewport ? "90vh" : !hasExplicitWidth && !hasExplicitHeight ? height : undefined,
        height: hasExplicitHeight && !hasExplicitWidth ? height : undefined,
        aspectRatio: hasExplicitWidth && hasExplicitHeight ? `${width} / ${height}` : undefined
    };
}
const $0d50d6616177f8b7$export$5c2ce7618e6623c7 = ({ nodes: nodes, connectors: explicitConnectors, useOnlyExplicitConnectors: useOnlyExplicitConnectors = false, connectorShape: connectorShape = "straight", connectorType: connectorType = "solid", bgColor: bgColor, width: width, height: height, maxNeighbors: maxNeighbors = 3, connectorColor: connectorColor = "neutral700", connectorWidth: connectorWidth = 2, fontFamily: fontFamily = "monospace", animateOnLoad: animateOnLoad = true, loadEntranceSpeedMultiplier: loadEntranceSpeedMultiplier, replayOnVisible: replayOnVisible = false, maxHeightViewport: maxHeightViewport = false, useViewportDimensions: useViewportDimensions = false, showAnimationPauseControl: showAnimationPauseControl = false, animationPhasesDrive: animationPhasesDrive = "time", scrollSectionRef: scrollSectionRef, scrollMagnetAnchors: scrollMagnetAnchors, scrollMagnetMinProgressDelta: scrollMagnetMinProgressDelta, scrollMagnetSettleDebounceMs: scrollMagnetSettleDebounceMs, scrollMagnetDurationMs: scrollMagnetDurationMs, scrollMagnetDirectionDeadbandPx: scrollMagnetDirectionDeadbandPx, scrollMagnetDirectionBias: scrollMagnetDirectionBias, scrollPhaseProgressOverride: scrollPhaseProgressOverride, onScrollPhaseProgressChange: onScrollPhaseProgressChange, onSvgCanvasClick: onSvgCanvasClick, onNodeClick: onNodeClick, focusedConnector: focusedConnector, nodeFocus: nodeFocus })=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const isVisible = (0, $iDO3O.useSpiderWebIntersectionVisibility)(containerRef, replayOnVisible);
    const prefersReducedMotion = (0, $29NYv.useSpiderWebReducedMotion)();
    const [activeModal, setActiveModal] = (0, $1oC0p.useState)(null);
    const [expandingNodeId, setExpandingNodeId] = (0, $1oC0p.useState)(null);
    const [animationsPaused, setAnimationsPaused] = (0, $1oC0p.useState)(false);
    const { animated: animated, phaseMotionActive: phaseMotionActive } = $0d50d6616177f8b7$var$resolveAnimationFlags(prefersReducedMotion, isVisible);
    const entranceM = $0d50d6616177f8b7$var$clampLoadEntranceSpeedMultiplier(loadEntranceSpeedMultiplier);
    const loadEntranceTimings = (0, $1oC0p.useMemo)(()=>({
            nodeStagger: $0d50d6616177f8b7$var$NODE_STAGGER / entranceM,
            edgeDelayBase: $0d50d6616177f8b7$var$EDGE_DELAY_BASE / entranceM,
            edgeStagger: $0d50d6616177f8b7$var$EDGE_STAGGER / entranceM,
            nodeEntranceDurationSec: $0d50d6616177f8b7$var$NODE_ENTRANCE_DURATION_SEC / entranceM,
            connectorSolidDrawDurationSec: $0d50d6616177f8b7$var$CONNECTOR_SOLID_DRAW_DURATION_SEC / entranceM,
            connectorDashedFadeDurationSec: $0d50d6616177f8b7$var$CONNECTOR_DASHED_ENTRANCE_DURATION_SEC / entranceM,
            overlapFadeDurationSec: $0d50d6616177f8b7$var$OVERLAP_LOAD_ENTRANCE_FADE_SEC / entranceM,
            animatedShapeOpacityDurationSec: $0d50d6616177f8b7$var$ANIMATED_CONNECTOR_SHAPE_OPACITY_SEC / entranceM,
            animatedShapeAppearOffsetSec: $0d50d6616177f8b7$var$ANIMATED_CONNECTOR_SHAPE_APPEAR_OFFSET_SEC / entranceM
        }), [
        entranceM
    ]);
    const nodeTotalDuration = nodes.length * loadEntranceTimings.nodeStagger;
    const { connectorConfigs: connectorConfigs, resolvedConnectors: resolvedConnectors } = (0, $kCguZ.useSpiderWebConnectorPlan)(nodes, maxNeighbors, explicitConnectors, useOnlyExplicitConnectors, connectorShape, connectorType);
    const phaseClockStartOffsetSec = (0, $1oC0p.useMemo)(()=>$0d50d6616177f8b7$var$computePhaseClockStartOffsetSec(animateOnLoad, nodes.length, connectorConfigs.length, nodeTotalDuration, connectorType, loadEntranceTimings.nodeStagger, loadEntranceTimings.nodeEntranceDurationSec, loadEntranceTimings.edgeDelayBase, loadEntranceTimings.edgeStagger, loadEntranceTimings.connectorSolidDrawDurationSec, loadEntranceTimings.connectorDashedFadeDurationSec), [
        animateOnLoad,
        nodes.length,
        connectorConfigs.length,
        nodeTotalDuration,
        connectorType,
        loadEntranceTimings.connectorDashedFadeDurationSec,
        loadEntranceTimings.connectorSolidDrawDurationSec,
        loadEntranceTimings.edgeDelayBase,
        loadEntranceTimings.edgeStagger,
        loadEntranceTimings.nodeEntranceDurationSec,
        loadEntranceTimings.nodeStagger
    ]);
    const skipLoadEntrance = !animateOnLoad;
    const nodeEntranceDelay = (0, $1oC0p.useMemo)(()=>$0d50d6616177f8b7$var$createNodeEntranceDelayFn(animateOnLoad, loadEntranceTimings.nodeStagger), [
        animateOnLoad,
        loadEntranceTimings.nodeStagger
    ]);
    const connectorEntranceDelay = (0, $1oC0p.useMemo)(()=>$0d50d6616177f8b7$var$createConnectorEntranceDelayFn(animateOnLoad, nodeTotalDuration, loadEntranceTimings.edgeDelayBase, loadEntranceTimings.edgeStagger), [
        animateOnLoad,
        loadEntranceTimings.edgeDelayBase,
        loadEntranceTimings.edgeStagger,
        nodeTotalDuration
    ]);
    const overlapEntranceDelay = $0d50d6616177f8b7$var$overlapEntranceDelayValue(animateOnLoad, nodeTotalDuration, loadEntranceTimings.edgeDelayBase);
    const hasAnyPhases = (0, $1oC0p.useMemo)(()=>(0, $ldiHh.anyNodeHasPhases)(nodes), [
        nodes
    ]);
    const scrollPhasesEnabled = animationPhasesDrive === "scroll" && hasAnyPhases;
    const scrollProgressOverride01 = typeof scrollPhaseProgressOverride === "number" && Number.isFinite(scrollPhaseProgressOverride) ? Math.min(1, Math.max(0, scrollPhaseProgressOverride)) : null;
    const scrollProgressListenerEnabled = scrollPhasesEnabled && scrollProgressOverride01 === null;
    const { progress: scrollPhaseProgress, isAttached: scrollProgressAttached } = (0, $7h9Nf.useSpiderwebDocumentSectionProgress)(scrollSectionRef, scrollProgressListenerEnabled);
    const effectiveScrollProgress = scrollProgressOverride01 !== null ? scrollProgressOverride01 : scrollPhaseProgress;
    (0, $1oC0p.useEffect)(()=>{
        onScrollPhaseProgressChange?.(effectiveScrollProgress);
    }, [
        effectiveScrollProgress,
        onScrollPhaseProgressChange
    ]);
    const scrollMagnetEnabled = scrollProgressListenerEnabled && !prefersReducedMotion && (scrollMagnetAnchors?.length ?? 0) > 0;
    (0, $hiPUj.useSpiderwebScrollMagnet)(scrollSectionRef, {
        enabled: scrollMagnetEnabled,
        anchors: scrollMagnetAnchors,
        minProgressDelta: scrollMagnetMinProgressDelta,
        settleDebounceMs: scrollMagnetSettleDebounceMs,
        scrollMagnetDurationMs: scrollMagnetDurationMs,
        scrollMagnetDirectionDeadbandPx: scrollMagnetDirectionDeadbandPx,
        scrollMagnetDirectionBias: scrollMagnetDirectionBias
    });
    const phaseDriveActive = animationPhasesDrive === "scroll" ? scrollProgressOverride01 !== null ? true : scrollProgressAttached : phaseMotionActive;
    const effectivePhaseClockOffsetSec = animationPhasesDrive === "scroll" ? 0 : phaseClockStartOffsetSec;
    const nodePositions = (0, $ldiHh.useSpiderwebPhasePositions)(nodes, phaseDriveActive, effectivePhaseClockOffsetSec, animationsPaused, {
        drive: animationPhasesDrive,
        scrollProgress: effectiveScrollProgress
    });
    const aspectCorrection = (0, $gHYtp.useSpiderwebViewportAspect)(useViewportDimensions, useViewportDimensions ? containerRef : undefined);
    const handleNodeActivate = (0, $1oC0p.useCallback)((node)=>{
        onNodeClick?.(node);
        $0d50d6616177f8b7$var$openNodeModalIfPresent(node, setExpandingNodeId, setActiveModal);
    }, [
        onNodeClick
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const root = containerRef.current;
        if (!root) return;
        const svg = root.querySelector("svg");
        if (!(svg instanceof SVGSVGElement)) return;
        if (animationsPaused) svg.pauseAnimations?.();
        else svg.unpauseAnimations?.();
    }, [
        animationsPaused
    ]);
    const { widthValue: widthValue, heightValue: heightValue } = $0d50d6616177f8b7$var$spiderWebDimensionValues(width, height);
    const viewBoxHeight = $0d50d6616177f8b7$var$computeViewBoxHeight(widthValue, heightValue, useViewportDimensions);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: containerRef,
        "data-spiderweb-animations-paused": animationsPaused ? "true" : undefined,
        style: $0d50d6616177f8b7$var$buildContainerStyle(width, height, bgColor, maxHeightViewport, useViewportDimensions),
        className: (0, $2jatx.default)([
            "_17pstrqk _95fktrqk _1wvttrqk"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $idRu8.SpiderWebContainerGraph), {
                viewBoxHeight: viewBoxHeight,
                useViewportDimensions: useViewportDimensions,
                aspectCorrection: aspectCorrection,
                resolvedConnectors: resolvedConnectors,
                nodes: nodes,
                animated: animated,
                skipLoadEntrance: skipLoadEntrance,
                connectorColor: connectorColor,
                connectorWidth: connectorWidth,
                connectorEntranceDelay: connectorEntranceDelay,
                nodeEntranceDelay: nodeEntranceDelay,
                overlapEntranceDelay: overlapEntranceDelay,
                nodeLoadEntranceDurationSec: loadEntranceTimings.nodeEntranceDurationSec,
                connectorLoadEntranceSolidDrawDurationSec: loadEntranceTimings.connectorSolidDrawDurationSec,
                connectorLoadEntranceDashedFadeDurationSec: loadEntranceTimings.connectorDashedFadeDurationSec,
                connectorLoadEntranceAnimatedShapeOpacityDurationSec: loadEntranceTimings.animatedShapeOpacityDurationSec,
                connectorLoadEntranceAnimatedShapeAppearOffsetSec: loadEntranceTimings.animatedShapeAppearOffsetSec,
                overlapLoadEntranceFadeDurationSec: loadEntranceTimings.overlapFadeDurationSec,
                fontFamily: fontFamily,
                expandingNodeId: expandingNodeId,
                onNodeActivate: handleNodeActivate,
                allowNodeActivationWithoutModal: onNodeClick !== undefined,
                nodePositions: nodePositions,
                onSvgCanvasClick: onSvgCanvasClick,
                focusedConnector: focusedConnector,
                nodeFocus: nodeFocus
            }),
            showAnimationPauseControl ? /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                style: {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    zIndex: 1
                },
                onClick: ()=>setAnimationsPaused((p)=>!p),
                children: animationsPaused ? "Resume animations" : "Pause animations"
            }) : null,
            activeModal && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iZj3A.AnimatedModal), {
                content: activeModal,
                onClose: ()=>{
                    setActiveModal(null);
                    setExpandingNodeId(null);
                }
            })
        ]
    });
}; /* eslint-enable complexity */ 

});
parcelRegister("iZj3A", function(module, exports) {
$parcel$export(module.exports, "AnimatedModal", function () { return $aeefb446612be563$export$e22fc00ba90d846a; });
/* animated-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $aeefb446612be563$var$animationDuration = "1.5s";
const $aeefb446612be563$var$contentRevealingKeyframes = null;
const $aeefb446612be563$var$expandingWhiteBackgroundKeyframes = null;
const $aeefb446612be563$var$dialogShiftingDownwardKeyframes = null;
const $aeefb446612be563$var$modalTopBarKeyframes = null;
const $aeefb446612be563$var$modalBackgroundStyle = null;
const $aeefb446612be563$var$modalBackgroundOverlayStyle = null;
const $aeefb446612be563$var$modalDialogStyle = null;
const $aeefb446612be563$var$modalTopBarStyle = null;
const $aeefb446612be563$var$expandingWhiteBackgroundStyle = null;
const $aeefb446612be563$var$contentRevealingStyle = null;
const $aeefb446612be563$var$headingStyle = null;
const $aeefb446612be563$var$closeButtonStyle = null;
const $aeefb446612be563$var$modalBackgroundOverlayButtonStyle = null;
const $aeefb446612be563$export$e22fc00ba90d846a = ({ content: content, onClose: onClose })=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const [isClosing, setIsClosing] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        requestAnimationFrame(()=>setIsOpen(true));
    }, []);
    const handleClose = (0, $1oC0p.useCallback)(()=>{
        setIsClosing(true);
        setTimeout(()=>onClose?.(), 250);
    }, [
        onClose
    ]);
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === "Escape") handleClose();
    }, [
        handleClose
    ]);
    (0, $1oC0p.useEffect)(()=>{
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        handleKeyDown
    ]);
    const entered = isOpen && !isClosing;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "aria-hidden": !entered,
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1r04idpf _1pbyzo7u"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_4t3i1kxc _1bsbauwl _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1bah1h6o _4cvr1h6o _1reo1wug _18m91wug"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    type: "button",
                    "aria-label": "Close modal",
                    onClick: handleClose,
                    style: {
                        // eslint-disable-next-line -- scrim overlay; no scrim token for rgba
                        backgroundColor: entered ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0)"
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _kqswstnw _1r04idpf _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _v564pw66"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": content.heading ?? "Modal",
                    "aria-labelledby": "anim-modal-heading",
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _18s8mvv2 _1pbykb7n _1yt4xy5q _p12fbxu3 _1bsb1vuk _1o51q7pw _j7hquaoh _5sag12o8 _1pgl1jtp"
                    ]),
                    style: {
                        "--_15esrws": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.quick-entrance"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1pby1mrw _kqswstnw _1r04idpf _2rkovwyg _19pkidpf _2hwx1wug _otyridpf _18u01wug _j7hq1or7 _5sag12o8 _1pgl1jtp _bfhkcd5j _16qsazvq"
                            ]),
                            style: {
                                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                                "--_15esrws": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.quick-entrance")),
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4ivgg _1bsb1osq _1o51q7pw _j7hq1q4n _5sag12o8 _1pgl1jtp"
                            ]),
                            style: {
                                "--_15esrws": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.quick-entrance"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    type: "button",
                                    onClick: handleClose,
                                    "aria-label": "Close modal",
                                    className: (0, $2jatx.default)([
                                        "_kqswstnw _152tidpf _rjxpidpf _11q7glyw _19itglyw _1wybv47k _80omtlke _syaz1yg0 _vwz4kb7n _1yt41b66"
                                    ]),
                                    style: {
                                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                    },
                                    children: "\xd7"
                                }),
                                content.heading && /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                                    id: "anim-modal-heading",
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _4cvr1h6o _zulp7vkz _18s812pl _1wybgktf _k48pni7l"
                                    ]),
                                    children: [
                                        content.icon && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Image), {
                                            src: content.icon,
                                            alt: content.heading ?? "",
                                            width: 24,
                                            height: 24
                                        }),
                                        content.heading
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_mkrz1k1d _j7hq1s68 _5sag12o8 _1pgl1jtp"
                            ]),
                            style: {
                                "--_15esrws": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.quick-entrance"))
                            },
                            children: [
                                content.text && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: content.text
                                }),
                                content.image && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Image), {
                                    src: content.image,
                                    alt: content.heading ?? ""
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("idRu8", function(module, exports) {
$parcel$export(module.exports, "SpiderWebContainerGraph", function () { return $3236218b2d24e80d$export$1a6bb9c248933ce1; });

var $7VQPk = parcelRequire("7VQPk");

var $8LkZ1 = parcelRequire("8LkZ1");

var $g14gy = parcelRequire("g14gy");

var $dhl4q = parcelRequire("dhl4q");

var $hNner = parcelRequire("hNner");
function $3236218b2d24e80d$var$toCenterPct(layout) {
    if (!layout) return undefined;
    return {
        x: layout.x,
        y: layout.y
    };
}
const $3236218b2d24e80d$export$1a6bb9c248933ce1 = ({ viewBoxHeight: viewBoxHeight, useViewportDimensions: useViewportDimensions = false, aspectCorrection: aspectCorrection, resolvedConnectors: resolvedConnectors, nodes: nodes, animated: animated, skipLoadEntrance: skipLoadEntrance, connectorColor: connectorColor, connectorWidth: connectorWidth, connectorEntranceDelay: connectorEntranceDelay, nodeEntranceDelay: nodeEntranceDelay, overlapEntranceDelay: overlapEntranceDelay, nodeLoadEntranceDurationSec: nodeLoadEntranceDurationSec, connectorLoadEntranceSolidDrawDurationSec: connectorLoadEntranceSolidDrawDurationSec, connectorLoadEntranceDashedFadeDurationSec: connectorLoadEntranceDashedFadeDurationSec, connectorLoadEntranceAnimatedShapeOpacityDurationSec: connectorLoadEntranceAnimatedShapeOpacityDurationSec, connectorLoadEntranceAnimatedShapeAppearOffsetSec: connectorLoadEntranceAnimatedShapeAppearOffsetSec, overlapLoadEntranceFadeDurationSec: overlapLoadEntranceFadeDurationSec, fontFamily: fontFamily, expandingNodeId: expandingNodeId, onNodeActivate: onNodeActivate, allowNodeActivationWithoutModal: allowNodeActivationWithoutModal, nodePositions: nodePositions, onSvgCanvasClick: onSvgCanvasClick, focusedConnector: focusedConnector, nodeFocus: nodeFocus })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        viewBox: `0 0 ${(0, $hNner.VIEWBOX_SCALE)} ${viewBoxHeight}`,
        preserveAspectRatio: useViewportDimensions ? "none" : "xMidYMid meet",
        style: {
            width: "100%",
            height: "100%",
            display: "block"
        },
        children: [
            onSvgCanvasClick ? /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: 0,
                y: 0,
                width: (0, $hNner.VIEWBOX_SCALE),
                height: viewBoxHeight,
                fill: "transparent",
                pointerEvents: "all",
                style: {
                    cursor: "inherit"
                },
                onClick: (e)=>{
                    const svg = e.currentTarget.ownerSVGElement;
                    if (!svg) return;
                    onSvgCanvasClick((0, $hNner.clientPointToSpiderWebPercent)(svg, e.clientX, e.clientY, viewBoxHeight));
                }
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                children: resolvedConnectors.map((connector, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LkZ1.WebConnector), {
                        connector: connector,
                        animated: animated,
                        delay: connectorEntranceDelay(i),
                        loadEntranceSolidDrawDurationSec: connectorLoadEntranceSolidDrawDurationSec,
                        loadEntranceDashedFadeDurationSec: connectorLoadEntranceDashedFadeDurationSec,
                        loadEntranceAnimatedShapeOpacityDurationSec: connectorLoadEntranceAnimatedShapeOpacityDurationSec,
                        loadEntranceAnimatedShapeAppearOffsetSec: connectorLoadEntranceAnimatedShapeAppearOffsetSec,
                        skipLoadEntrance: skipLoadEntrance,
                        color: connector.color ?? connectorColor,
                        strokeWidth: connectorWidth,
                        isAnimated: connector.isAnimated,
                        animationColor: connector.animationColor,
                        viewBoxHeight: viewBoxHeight,
                        fromPct: $3236218b2d24e80d$var$toCenterPct(nodePositions.get(connector.from.id)),
                        toPct: $3236218b2d24e80d$var$toCenterPct(nodePositions.get(connector.to.id)),
                        isFocused: focusedConnector !== undefined && focusedConnector.from === connector.from.id && focusedConnector.to === connector.to.id,
                        aspectCorrection: aspectCorrection
                    }, `${connector.from.id}-${connector.to.id}`))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                style: {
                    isolation: "isolate"
                },
                children: nodes.map((node, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $g14gy.WebNode), {
                        node: node,
                        animated: animated,
                        delay: nodeEntranceDelay(i),
                        loadEntranceDurationSec: nodeLoadEntranceDurationSec,
                        skipLoadEntrance: skipLoadEntrance,
                        onClick: allowNodeActivationWithoutModal || node.modalContent ? ()=>onNodeActivate(node) : undefined,
                        fontFamily: fontFamily,
                        isExpanding: expandingNodeId === node.id,
                        viewBoxHeight: viewBoxHeight,
                        aspectCorrection: aspectCorrection,
                        layoutPct: nodePositions.get(node.id),
                        focusVariant: nodeFocus?.nodeId === node.id ? nodeFocus.variant : undefined
                    }, node.id))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dhl4q.WebOverlapLayers), {
                nodes: nodes,
                viewBoxHeight: viewBoxHeight,
                animated: animated,
                delay: overlapEntranceDelay,
                loadEntranceFadeDurationSec: overlapLoadEntranceFadeDurationSec,
                skipLoadEntrance: skipLoadEntrance,
                nodePositions: nodePositions
            })
        ]
    });

});
parcelRegister("8LkZ1", function(module, exports) {
$parcel$export(module.exports, "WebConnector", function () { return $0a666eee294a6ae9$export$4c805283e52a8c6; });
/* spiderweb-connector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $hNner = parcelRequire("hNner");
const $0a666eee294a6ae9$var$focusColor = "hotpink";
const $0a666eee294a6ae9$var$focusDasharray = "10 10";
const $0a666eee294a6ae9$var$activeSelectionKeyframes = null;
const $0a666eee294a6ae9$var$activeConnectorCss = null;
const $0a666eee294a6ae9$var$DEFAULT_SOLID_DRAW_SEC = 1;
const $0a666eee294a6ae9$var$DEFAULT_DASHED_FADE_SEC = 0.8;
const $0a666eee294a6ae9$var$DEFAULT_ANIMATED_SHAPE_OPACITY_SEC = 0.6;
const $0a666eee294a6ae9$var$DEFAULT_ANIMATED_SHAPE_APPEAR_OFFSET_SEC = 1;
const $0a666eee294a6ae9$export$2327170491d03b31 = ({ connectorShape: connectorShape, fromId: fromId, toId: toId, animated: animated, delay: delay, skipLoadEntrance: skipLoadEntrance = false, animationColor: animationColor, length: length, animatedShapeOpacityDurationSec: animatedShapeOpacityDurationSec, animatedShapeAppearOffsetSec: animatedShapeAppearOffsetSec, aspectCorrection: aspectCorrection })=>{
    const appearDelay = delay + animatedShapeAppearOffsetSec;
    const style = animated ? skipLoadEntrance ? {
        opacity: 1
    } : {
        opacity: 1,
        transition: `opacity ${animatedShapeOpacityDurationSec}s ease ${appearDelay}s`
    } : {
        opacity: 0
    };
    const acX = aspectCorrection?.scaleX ?? 1;
    const acY = aspectCorrection?.scaleY ?? 1;
    const shapeTransform = acX !== 1 || acY !== 1 ? `scaleX(${acX}) scaleY(${acY})` : undefined;
    const duration = 10;
    const squarePath = "m-5-9h10c2.2 0 4 1.8 4 4v10c0 2.2-1.8 4-4 4h-10c-2.2 0-4-1.8-4-4v-10c0-2.2 1.8-4 4-4z";
    const circlePath = "m0 9c-5 0-9-4-9-9 0-5 4-9 9-9 5 0 9 4 9 9 0 5-4 9-9 9z";
    const pillPath = "m-19-9h38c5 0 9 4 9 9 0 5-4 9-9 9h-38c-5 0-9-4-9-9 0-5 4-9 9-9z";
    const trianglePath = "m-5-8l15 8-15 8z";
    const hexagonPath = "m7.8-4.6v9.2l-8 4.6-8-4.6v-9.2l8-4.6z";
    const colorMap = {
        lime: [
            (0, $kbpa7.wacToken)("color.extended.lime500"),
            (0, $kbpa7.wacToken)("color.extended.lime100"),
            (0, $kbpa7.wacToken)("color.extended.lime300"),
            (0, $kbpa7.wacToken)("color.extended.lime500"),
            (0, $kbpa7.wacToken)("color.extended.lime200"),
            (0, $kbpa7.wacToken)("color.extended.lime400"),
            (0, $kbpa7.wacToken)("color.extended.lime200")
        ],
        purple: [
            (0, $kbpa7.wacToken)("color.extended.purple500"),
            (0, $kbpa7.wacToken)("color.extended.purple100"),
            (0, $kbpa7.wacToken)("color.extended.purple300"),
            (0, $kbpa7.wacToken)("color.extended.purple500"),
            (0, $kbpa7.wacToken)("color.extended.purple200"),
            (0, $kbpa7.wacToken)("color.extended.purple400"),
            (0, $kbpa7.wacToken)("color.extended.purple200")
        ],
        blue: [
            (0, $kbpa7.wacToken)("color.extended.blue500"),
            (0, $kbpa7.wacToken)("color.extended.blue800"),
            (0, $kbpa7.wacToken)("color.extended.blue600"),
            (0, $kbpa7.wacToken)("color.extended.blue300"),
            (0, $kbpa7.wacToken)("color.extended.blue700"),
            (0, $kbpa7.wacToken)("color.extended.blue400"),
            (0, $kbpa7.wacToken)("color.extended.blue600")
        ],
        yellow: [
            (0, $kbpa7.wacToken)("color.extended.yellow500"),
            (0, $kbpa7.wacToken)("color.extended.yellow100"),
            (0, $kbpa7.wacToken)("color.extended.yellow300"),
            (0, $kbpa7.wacToken)("color.extended.yellow500"),
            (0, $kbpa7.wacToken)("color.extended.yellow200"),
            (0, $kbpa7.wacToken)("color.extended.yellow400"),
            (0, $kbpa7.wacToken)("color.extended.yellow200")
        ],
        neutral: [
            (0, $kbpa7.wacToken)("color.neutral.light500"),
            (0, $kbpa7.wacToken)("color.neutral.light300"),
            (0, $kbpa7.wacToken)("color.neutral.light100"),
            (0, $kbpa7.wacToken)("color.neutral.light400"),
            (0, $kbpa7.wacToken)("color.neutral.light600"),
            (0, $kbpa7.wacToken)("color.neutral.light200"),
            (0, $kbpa7.wacToken)("color.neutral.light500")
        ]
    };
    const participatingShapes = [
        {
            shape: "circle",
            path: circlePath,
            delay: 0,
            fill: colorMap[animationColor][0]
        },
        {
            shape: connectorShape === "orthogonal" || shapeTransform !== undefined ? "hexagon" : "pill",
            path: connectorShape === "orthogonal" || shapeTransform !== undefined ? hexagonPath : pillPath,
            delay: 5,
            fill: colorMap[animationColor][1]
        },
        {
            shape: "triangle",
            path: trianglePath,
            delay: 2,
            fill: colorMap[animationColor][2]
        },
        {
            shape: "circle",
            path: circlePath,
            delay: 3,
            fill: colorMap[animationColor][3]
        },
        {
            shape: "triangle",
            path: trianglePath,
            delay: 9,
            fill: colorMap[animationColor][4]
        },
        {
            shape: "square",
            path: squarePath,
            delay: 1,
            fill: colorMap[animationColor][5]
        },
        {
            shape: "hexagon",
            path: hexagonPath,
            delay: 8,
            fill: colorMap[animationColor][6]
        }
    ];
    if (length < 400) participatingShapes.splice(-2, 2);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
        style: style,
        children: participatingShapes.map((shape, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                className: `anim-shape-animated`,
                fill: shape.fill,
                d: shape.path,
                style: shape.shape !== "pill" && shape.shape !== "triangle" ? {
                    transform: shapeTransform
                } : undefined,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("animateMotion", {
                    rotate: `${shape.shape === "circle" || shape.shape === "hexagon" || shape.shape === "square" ? "0" : "auto"}`,
                    dur: duration,
                    begin: `-${shape.delay}s;op.end-${shape.delay}s`,
                    repeatCount: "indefinite",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("mpath", {
                        href: `#connector-${fromId}-${toId}`
                    })
                })
            }, `anim-shape-${index}`))
    });
};
const $0a666eee294a6ae9$export$4c805283e52a8c6 = ({ connector: connector, animated: animated, delay: delay, loadEntranceSolidDrawDurationSec: loadEntranceSolidDrawDurationSec = $0a666eee294a6ae9$var$DEFAULT_SOLID_DRAW_SEC, loadEntranceDashedFadeDurationSec: loadEntranceDashedFadeDurationSec = $0a666eee294a6ae9$var$DEFAULT_DASHED_FADE_SEC, loadEntranceAnimatedShapeOpacityDurationSec: loadEntranceAnimatedShapeOpacityDurationSec = $0a666eee294a6ae9$var$DEFAULT_ANIMATED_SHAPE_OPACITY_SEC, loadEntranceAnimatedShapeAppearOffsetSec: loadEntranceAnimatedShapeAppearOffsetSec = $0a666eee294a6ae9$var$DEFAULT_ANIMATED_SHAPE_APPEAR_OFFSET_SEC, skipLoadEntrance: skipLoadEntrance = false, color: color = "neutral400", strokeWidth: strokeWidth = 2, isAnimated: isAnimated = false, animationColor: animationColor = "blue", viewBoxHeight: viewBoxHeight, fromPct: fromPct, toPct: toPct, isFocused: isFocused = false, aspectCorrection: aspectCorrection })=>{
    const strokeColor = (0, $hNner.getFillColor)(color);
    const focusWidth = strokeWidth + 10;
    const pathRef = (0, $1oC0p.useRef)(null);
    const lastMeasuredDRef = (0, $1oC0p.useRef)(null);
    const [pathLength, setPathLength] = (0, $1oC0p.useState)(null);
    const d = (0, $hNner.generatePathD)(connector, viewBoxHeight, fromPct, toPct);
    const estimatedLength = (0, $hNner.estimatePathLength)(connector, viewBoxHeight, fromPct, toPct);
    const length = Math.max(Number(pathLength ?? 0), estimatedLength) * 2;
    const isDashed = connector.connectorType === "dashed";
    (0, $1oC0p.useLayoutEffect)(()=>{
        const path = pathRef.current;
        if (!path || isDashed) return;
        lastMeasuredDRef.current = d;
        try {
            const total = path.getTotalLength();
            if (Number.isFinite(total) && total > 0) setPathLength(total);
        } catch  {
        /* JSDOM (and some edge environments) omit or break SVG path length APIs */ }
    }, [
        d,
        isDashed
    ]);
    if (isDashed) {
        const style = animated ? skipLoadEntrance ? {
            opacity: 1
        } : {
            opacity: 1,
            transition: `opacity ${loadEntranceDashedFadeDurationSec}s ease ${delay}s`
        } : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            id: `connector-group-${connector.from.id}-${connector.to.id}`,
            children: [
                isFocused ? /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    className: "connector-focus-halo",
                    d: d,
                    fill: "none",
                    stroke: $0a666eee294a6ae9$var$focusColor,
                    strokeWidth: focusWidth,
                    strokeLinecap: "butt",
                    strokeDasharray: $0a666eee294a6ae9$var$focusDasharray,
                    vectorEffect: "non-scaling-stroke",
                    style: style
                }) : null,
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: `connector-${connector.from.id}-${connector.to.id}`,
                    d: d,
                    fill: "none",
                    stroke: strokeColor,
                    strokeWidth: strokeWidth,
                    strokeDasharray: "8 6",
                    strokeLinecap: "round",
                    style: style,
                    vectorEffect: "non-scaling-stroke"
                }),
                isAnimated && /*#__PURE__*/ (0, $7VQPk.jsx)($0a666eee294a6ae9$export$2327170491d03b31, {
                    connectorShape: connector.connectorShape,
                    animationColor: animationColor,
                    fromId: connector.from.id,
                    toId: connector.to.id,
                    animated: animated,
                    delay: delay,
                    skipLoadEntrance: skipLoadEntrance,
                    length: length,
                    animatedShapeOpacityDurationSec: loadEntranceAnimatedShapeOpacityDurationSec,
                    animatedShapeAppearOffsetSec: loadEntranceAnimatedShapeAppearOffsetSec,
                    aspectCorrection: aspectCorrection
                })
            ]
        });
    }
    const style = animated ? skipLoadEntrance ? {
        opacity: 1,
        strokeDashoffset: 0
    } : {
        opacity: 1,
        strokeDashoffset: 0,
        transition: `opacity 0.01s linear ${delay}s,
stroke-dashoffset ${loadEntranceSolidDrawDurationSec}s ease ${delay}s`
    } : {
        opacity: 0,
        strokeDashoffset: length
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
        id: `connector-group-${connector.from.id}-${connector.to.id}`,
        children: [
            isFocused ? /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                className: (0, $2jatx.default)([
                    "_j7hq14tt _5sag1bs3 _tip812c5 _1pgl605o",
                    "connector-focus-halo"
                ]),
                d: d,
                fill: "none",
                stroke: $0a666eee294a6ae9$var$focusColor,
                strokeWidth: focusWidth,
                strokeLinecap: "butt",
                strokeDasharray: $0a666eee294a6ae9$var$focusDasharray,
                style: style,
                vectorEffect: "non-scaling-stroke"
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                ref: pathRef,
                id: `connector-${connector.from.id}-${connector.to.id}`,
                d: d,
                fill: "none",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeDasharray: length,
                strokeLinecap: "round",
                style: style,
                vectorEffect: "non-scaling-stroke"
            }),
            isAnimated && /*#__PURE__*/ (0, $7VQPk.jsx)($0a666eee294a6ae9$export$2327170491d03b31, {
                connectorShape: connector.connectorShape,
                animationColor: animationColor,
                fromId: connector.from.id,
                toId: connector.to.id,
                animated: animated,
                delay: delay,
                skipLoadEntrance: skipLoadEntrance,
                length: length,
                animatedShapeOpacityDurationSec: loadEntranceAnimatedShapeOpacityDurationSec,
                animatedShapeAppearOffsetSec: loadEntranceAnimatedShapeAppearOffsetSec,
                aspectCorrection: aspectCorrection
            })
        ]
    });
}; /* eslint-enable complexity */ 

});
parcelRegister("hNner", function(module, exports) {
$parcel$export(module.exports, "VIEWBOX_SCALE", function () { return $d748960a540715c7$export$64bc08fea759b9f0; });
$parcel$export(module.exports, "getFillColor", function () { return $d748960a540715c7$export$c78c40f1f2c127ae; });
$parcel$export(module.exports, "pctToViewBox", function () { return $d748960a540715c7$export$3899a5677ef1fc8d; });
$parcel$export(module.exports, "pctToViewBoxY", function () { return $d748960a540715c7$export$78e6a7e9bbdd8e96; });
$parcel$export(module.exports, "clientPointToSpiderWebPercent", function () { return $d748960a540715c7$export$7853a2ad444a524a; });
$parcel$export(module.exports, "autoConnectNodes", function () { return $d748960a540715c7$export$33c89f7587b9100f; });
$parcel$export(module.exports, "resolveConnectors", function () { return $d748960a540715c7$export$c8a0ea4291e0d0f3; });
$parcel$export(module.exports, "generatePathD", function () { return $d748960a540715c7$export$b22c80dd8dfa9662; });
$parcel$export(module.exports, "getHexagonPoints", function () { return $d748960a540715c7$export$dc05ac4d5f7de039; });
$parcel$export(module.exports, "getTrianglePoints", function () { return $d748960a540715c7$export$d95c9ca32019fe2f; });
$parcel$export(module.exports, "estimatePathLength", function () { return $d748960a540715c7$export$8adba9b7b71a99aa; });
$parcel$export(module.exports, "LEADING_ICON_INSIDE_GAP_RATIO", function () { return $d748960a540715c7$export$d59c3929577b30f7; });
$parcel$export(module.exports, "LEADING_INSIDE_EXTRA_WIDTH_RATIO", function () { return $d748960a540715c7$export$7a959807e0cf14c4; });
$parcel$export(module.exports, "LEADING_ICON_OUTSIDE_GAP_RATIO", function () { return $d748960a540715c7$export$fb4aa8c61dd87a93; });
$parcel$export(module.exports, "leadingInsideIconSidePx", function () { return $d748960a540715c7$export$41a49f5d92e754fc; });
$parcel$export(module.exports, "effectiveLeadingImagePlacement", function () { return $d748960a540715c7$export$a81692d9beb437d2; });
$parcel$export(module.exports, "getRectangleBorderRadius", function () { return $d748960a540715c7$export$8d8431c26588b0d5; });
$parcel$export(module.exports, "getNodeLayoutDimensions", function () { return $d748960a540715c7$export$35acfb30685caca9; });
$parcel$export(module.exports, "getNodeOverlapLayout", function () { return $d748960a540715c7$export$a46bd226a7cc59a4; });

var $kbpa7 = parcelRequire("kbpa7");
const $d748960a540715c7$export$64bc08fea759b9f0 = 1000;
function $d748960a540715c7$export$c78c40f1f2c127ae(color) {
    if (color === "transparent") return "transparent";
    if (color === "white") return (0, $kbpa7.wacToken)("color.neutral.light0");
    if (color === "black") return (0, $kbpa7.wacToken)("color.primary.black");
    if (color.includes("secondary")) return (0, $kbpa7.wacToken)(`color.secondary.${color.replace("secondary", "")}`);
    const colorType = color.includes("neutral") ? "neutral" : "extended";
    const colorValue = color.includes("neutral") ? color.replace("neutral", "light") : color;
    return (0, $kbpa7.wacToken)(`color.${colorType}.${colorValue}`);
}
function $d748960a540715c7$export$3899a5677ef1fc8d(pct) {
    return pct / 100 * $d748960a540715c7$export$64bc08fea759b9f0;
}
function $d748960a540715c7$export$78e6a7e9bbdd8e96(pct, viewBoxHeight) {
    return pct / 100 * viewBoxHeight;
}
function $d748960a540715c7$export$7853a2ad444a524a(svg, clientX, clientY, viewBoxHeight) {
    if (viewBoxHeight <= 0) return {
        x: 0,
        y: 0
    };
    const pt = svg.createSVGPoint();
    pt.x = clientX;
    pt.y = clientY;
    const ctm = svg.getScreenCTM();
    if (!ctm) return {
        x: 0,
        y: 0
    };
    const p = pt.matrixTransform(ctm.inverse());
    const x = p.x / $d748960a540715c7$export$64bc08fea759b9f0 * 100;
    const y = p.y / viewBoxHeight * 100;
    return {
        x: Math.round(x * 10) / 10,
        y: Math.round(y * 10) / 10
    };
}
function $d748960a540715c7$var$euclidean(a, b) {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
}
function $d748960a540715c7$var$connectorKey(a, b) {
    return a < b ? `${a}::${b}` : `${b}::${a}`;
}
function $d748960a540715c7$export$33c89f7587b9100f(nodes, maxNeighbors, explicitConnectors) {
    const seen = new Set();
    const connectionCount = new Map();
    const result = [];
    if (explicitConnectors) for (const connector of explicitConnectors){
        const key = $d748960a540715c7$var$connectorKey(connector.from, connector.to);
        if (!seen.has(key)) {
            seen.add(key);
            result.push(connector);
            connectionCount.set(connector.from, (connectionCount.get(connector.from) ?? 0) + 1);
            connectionCount.set(connector.to, (connectionCount.get(connector.to) ?? 0) + 1);
        }
    }
    for (const node of nodes){
        const currentCount = connectionCount.get(node.id) ?? 0;
        if (currentCount >= maxNeighbors) continue;
        const others = nodes.filter((n)=>n.id !== node.id).map((n)=>({
                node: n,
                dist: $d748960a540715c7$var$euclidean(node, n)
            })).sort((a, b)=>a.dist - b.dist);
        for (const { node: neighbor } of others){
            if ((connectionCount.get(node.id) ?? 0) >= maxNeighbors) break;
            const key = $d748960a540715c7$var$connectorKey(node.id, neighbor.id);
            if (seen.has(key)) continue;
            seen.add(key);
            result.push({
                from: node.id,
                to: neighbor.id
            });
            connectionCount.set(node.id, (connectionCount.get(node.id) ?? 0) + 1);
            connectionCount.set(neighbor.id, (connectionCount.get(neighbor.id) ?? 0) + 1);
        }
    }
    return result;
}
const $d748960a540715c7$var$SHAPE_CYCLE = [
    "arced",
    "straight",
    "curvy",
    "orthogonal"
];
function $d748960a540715c7$export$c8a0ea4291e0d0f3(connectorConfigs, nodes, globalConnectorShape, globalConnectorType) {
    const nodeMap = new Map(nodes.map((n)=>[
            n.id,
            n
        ]));
    return connectorConfigs.map((cfg, index)=>{
        const from = nodeMap.get(cfg.from);
        const to = nodeMap.get(cfg.to);
        if (!from || !to) return null;
        let shape = cfg.connectorShape ?? globalConnectorShape;
        if (shape === "mixed") shape = $d748960a540715c7$var$SHAPE_CYCLE[index % $d748960a540715c7$var$SHAPE_CYCLE.length] ?? "arced";
        const type = cfg.connectorType ?? globalConnectorType;
        return {
            from: from,
            to: to,
            connectorShape: shape,
            connectorType: type,
            index: index,
            connectorBias: cfg.connectorBias,
            isAnimated: cfg.isAnimated,
            color: cfg.color,
            animationColor: cfg.animationColor
        };
    }).filter((e)=>e !== null);
}
function $d748960a540715c7$var$resolveBendSign(connector) {
    if (connector.connectorBias === "positive") return 1;
    if (connector.connectorBias === "negative") return -1;
    return connector.index % 2 === 0 ? 1 : -1;
}
/* true = move horizontally first, false = vertical first */ function $d748960a540715c7$var$resolveOrthogonalHorizontalFirst(connector) {
    if (connector.connectorBias === "positive") return true;
    if (connector.connectorBias === "negative") return false;
    return connector.index % 2 === 0;
}
function $d748960a540715c7$export$b22c80dd8dfa9662(connector, viewBoxHeight = $d748960a540715c7$export$64bc08fea759b9f0, fromPct, toPct) {
    const fx = fromPct?.x ?? connector.from.x;
    const fy = fromPct?.y ?? connector.from.y;
    const tx = toPct?.x ?? connector.to.x;
    const ty = toPct?.y ?? connector.to.y;
    const x1 = $d748960a540715c7$export$3899a5677ef1fc8d(fx);
    const y1 = $d748960a540715c7$export$78e6a7e9bbdd8e96(fy, viewBoxHeight);
    const x2 = $d748960a540715c7$export$3899a5677ef1fc8d(tx);
    const y2 = $d748960a540715c7$export$78e6a7e9bbdd8e96(ty, viewBoxHeight);
    if (connector.connectorShape === "straight") return `M ${x1} ${y1} L ${x2} ${y2}`;
    if (connector.connectorShape === "orthogonal") {
        if ($d748960a540715c7$var$resolveOrthogonalHorizontalFirst(connector)) return `M ${x1} ${y1} L ${x2} ${y1} L ${x2} ${y2}`;
        return `M ${x1} ${y1} L ${x1} ${y2} L ${x2} ${y2}`;
    }
    const dx = x2 - x1;
    const dy = y2 - y1;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist === 0) return `M ${x1} ${y1} L ${x2} ${y2}`;
    const nx = -dy / dist;
    const ny = dx / dist;
    if (connector.connectorShape === "arced") {
        const mx = (x1 + x2) / 2;
        const my = (y1 + y2) / 2;
        const offset = dist * 0.25;
        const direction = $d748960a540715c7$var$resolveBendSign(connector);
        const qx = mx + nx * offset * direction;
        const qy = my + ny * offset * direction;
        return `M ${x1} ${y1} Q ${qx} ${qy} ${x2} ${y2}`;
    }
    if (connector.connectorShape === "curvy") {
        const offset = dist * 0.35;
        const direction = $d748960a540715c7$var$resolveBendSign(connector);
        const cx1 = x1 + dx * 0.33 + nx * offset * direction;
        const cy1 = y1 + dy * 0.33 + ny * offset * direction;
        const cx2 = x1 + dx * 0.66 - nx * offset * direction;
        const cy2 = y1 + dy * 0.66 - ny * offset * direction;
        return `M ${x1} ${y1} C ${cx1} ${cy1} ${cx2} ${cy2} ${x2} ${y2}`;
    }
    return `M ${x1} ${y1} L ${x2} ${y2}`;
}
function $d748960a540715c7$export$dc05ac4d5f7de039(cx, cy, r) {
    const points = [];
    for(let i = 0; i < 6; i++){
        const angle = Math.PI / 3 * i - Math.PI / 2;
        points.push(`${cx + r * Math.cos(angle)},${cy + r * Math.sin(angle)}`);
    }
    return points.join(" ");
}
function $d748960a540715c7$export$d95c9ca32019fe2f(cx, cy, r) {
    const top = `${cx},${cy - r}`;
    const bottomLeft = `${cx - r * 0.866},${cy + r * 0.5}`;
    const bottomRight = `${cx + r * 0.866},${cy + r * 0.5}`;
    return `${top} ${bottomLeft} ${bottomRight}`;
}
function $d748960a540715c7$export$8adba9b7b71a99aa(connector, viewBoxHeight = $d748960a540715c7$export$64bc08fea759b9f0, fromPct, toPct) {
    const fx = fromPct?.x ?? connector.from.x;
    const fy = fromPct?.y ?? connector.from.y;
    const tx = toPct?.x ?? connector.to.x;
    const ty = toPct?.y ?? connector.to.y;
    const x1 = $d748960a540715c7$export$3899a5677ef1fc8d(fx);
    const y1 = $d748960a540715c7$export$78e6a7e9bbdd8e96(fy, viewBoxHeight);
    const x2 = $d748960a540715c7$export$3899a5677ef1fc8d(tx);
    const y2 = $d748960a540715c7$export$78e6a7e9bbdd8e96(ty, viewBoxHeight);
    const dx = x2 - x1;
    const dy = y2 - y1;
    const straightDist = Math.sqrt(dx * dx + dy * dy);
    if (connector.connectorShape === "arced") return straightDist * 1.2;
    if (connector.connectorShape === "curvy") return straightDist * 1.5;
    if (connector.connectorShape === "orthogonal") return Math.abs(dx) + Math.abs(dy);
    return straightDist;
}
const $d748960a540715c7$var$DEFAULT_NODE_SIZE = 100;
const $d748960a540715c7$var$PILL_ASPECT = 2.8;
const $d748960a540715c7$var$PILL_HORIZONTAL_PADDING = 0.8;
const $d748960a540715c7$var$RECTANGLE_HORIZONTAL_PADDING = 0.8;
const $d748960a540715c7$var$MONOSPACE_CHAR_WIDTH_RATIO = 0.6;
const $d748960a540715c7$export$d59c3929577b30f7 = 0.3;
const $d748960a540715c7$export$7a959807e0cf14c4 = 0.0005;
const $d748960a540715c7$export$fb4aa8c61dd87a93 = 0.14;
const $d748960a540715c7$export$ad3ca81369e18f68 = 1.15;
function $d748960a540715c7$export$41a49f5d92e754fc(node, maxBodySide) {
    const size = node.size ?? $d748960a540715c7$var$DEFAULT_NODE_SIZE;
    const fontFamily = node.fontFamily ?? "monospace";
    const labelLayoutFontSize = fontFamily === "monospace" ? size * 0.3 : size * 0.4;
    const desired = labelLayoutFontSize * $d748960a540715c7$export$ad3ca81369e18f68;
    return Math.min(Math.max(4, desired), maxBodySide);
}
function $d748960a540715c7$export$a81692d9beb437d2(node) {
    const raw = node.imagePlacement ?? "background";
    if (raw === "background" || !node.bgImage || !node.text || node.shape !== "pill" && node.shape !== "rectangle") return "background";
    return raw;
}
const $d748960a540715c7$var$RECTANGLE_RX_DEFAULT_DIVISOR = 4;
function $d748960a540715c7$export$8d8431c26588b0d5(node, rectangleWidth, rectangleHeight) {
    if (node.shape !== "rectangle") return 0;
    const minSide = Math.min(rectangleWidth, rectangleHeight);
    if (minSide <= 0) return 0;
    const maxRx = minSide / 2;
    const defaultRx = minSide / $d748960a540715c7$var$RECTANGLE_RX_DEFAULT_DIVISOR;
    const raw = node.borderRadius ?? defaultRx;
    return Math.min(Math.max(0, raw), maxRx);
}
/* eslint-disable-next-line complexity -- mirrors WebNode pill/rectangle leading layout */ function $d748960a540715c7$var$computeNodeBoxWidths(node) {
    const size = node.size ?? $d748960a540715c7$var$DEFAULT_NODE_SIZE;
    const fontFamily = node.fontFamily ?? "monospace";
    const labelLayoutFontSize = fontFamily === "monospace" ? size * 0.3 : size * 0.4;
    const placement = $d748960a540715c7$export$a81692d9beb437d2(node);
    const textStretchW = node.text && (node.shape === "pill" || node.shape === "rectangle") ? node.text.length * labelLayoutFontSize * $d748960a540715c7$var$MONOSPACE_CHAR_WIDTH_RATIO : 0;
    const pillBodyTextWidth = node.shape === "pill" && node.text ? textStretchW + size * $d748960a540715c7$var$PILL_HORIZONTAL_PADDING : size * $d748960a540715c7$var$PILL_ASPECT;
    let pillWidth = pillBodyTextWidth;
    if (node.shape === "pill" && node.text && node.bgImage && placement === "insideLeading") {
        const iconSide = $d748960a540715c7$export$41a49f5d92e754fc(node, size);
        pillWidth = pillBodyTextWidth + iconSide + size * $d748960a540715c7$export$d59c3929577b30f7 + size * $d748960a540715c7$export$7a959807e0cf14c4;
    }
    const rectangleHeight = node.height ?? size;
    const rectangleBodyTextWidth = node.shape === "rectangle" && node.text ? textStretchW + size * $d748960a540715c7$var$RECTANGLE_HORIZONTAL_PADDING : size;
    let rectangleWidth = node.width ?? (node.shape === "rectangle" && node.text ? rectangleBodyTextWidth : size);
    if (node.width === undefined && node.shape === "rectangle" && node.text && node.bgImage && placement === "insideLeading") {
        const iconSide = $d748960a540715c7$export$41a49f5d92e754fc(node, rectangleHeight);
        rectangleWidth = rectangleBodyTextWidth + iconSide + rectangleHeight * $d748960a540715c7$export$d59c3929577b30f7 + Math.max(size, rectangleHeight) * $d748960a540715c7$export$7a959807e0cf14c4;
    }
    return {
        size: size,
        pillWidth: pillWidth,
        rectangleWidth: rectangleWidth,
        rectangleHeight: rectangleHeight
    };
}
function $d748960a540715c7$export$35acfb30685caca9(node) {
    const { size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight } = $d748960a540715c7$var$computeNodeBoxWidths(node);
    switch(node.shape){
        case "pill":
            return {
                size: size,
                boxWidth: pillWidth,
                boxHeight: size
            };
        case "rectangle":
            return {
                size: size,
                boxWidth: rectangleWidth,
                boxHeight: rectangleHeight
            };
        default:
            return {
                size: size,
                boxWidth: size,
                boxHeight: size
            };
    }
}
function $d748960a540715c7$export$a46bd226a7cc59a4(node, viewBoxHeight, centerPct) {
    const size = centerPct?.size !== undefined ? centerPct.size : node.size ?? $d748960a540715c7$var$DEFAULT_NODE_SIZE;
    const nodeForDims = {
        ...node,
        size: size
    };
    const dims = $d748960a540715c7$export$35acfb30685caca9(nodeForDims);
    const boxW = centerPct?.width !== undefined ? centerPct.width : dims.boxWidth;
    const boxH = centerPct?.height !== undefined ? centerPct.height : dims.boxHeight;
    const r = size / 2;
    const pillWidth = node.shape === "pill" ? boxW : size * $d748960a540715c7$var$PILL_ASPECT;
    const rectangleWidth = node.shape === "rectangle" ? boxW : dims.boxWidth;
    const rectangleHeight = node.shape === "rectangle" ? boxH : dims.boxHeight;
    const px = centerPct?.x ?? node.x;
    const py = centerPct?.y ?? node.y;
    const rectangleBorderRadius = node.shape === "rectangle" ? $d748960a540715c7$export$8d8431c26588b0d5(node, rectangleWidth, rectangleHeight) : undefined;
    return {
        cx: $d748960a540715c7$export$3899a5677ef1fc8d(px),
        cy: $d748960a540715c7$export$78e6a7e9bbdd8e96(py, viewBoxHeight),
        r: r,
        size: size,
        pillWidth: pillWidth,
        rectangleWidth: rectangleWidth,
        rectangleHeight: rectangleHeight,
        rectangleBorderRadius: rectangleBorderRadius,
        rotate: node.rotate ?? 0,
        shape: node.shape
    };
}

});


parcelRegister("g14gy", function(module, exports) {
$parcel$export(module.exports, "WebNode", function () { return $601e0abd0af527cc$export$7bcfb4ff058df62d; });
/* spiderweb-node.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $kbpa7 = parcelRequire("kbpa7");

var $75Q24 = parcelRequire("75Q24");

var $hNner = parcelRequire("hNner");
const $601e0abd0af527cc$var$activeSelectionKeyframes = null;
const $601e0abd0af527cc$var$groupStyle = null;
const $601e0abd0af527cc$var$DEFAULT_SIZE = 100;
const $601e0abd0af527cc$var$PILL_ASPECT = 2.8;
const $601e0abd0af527cc$var$PILL_HORIZONTAL_PADDING = 0.8;
const $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING = 0.8;
const $601e0abd0af527cc$var$MONOSPACE_CHAR_WIDTH_RATIO = 0.6;
function $601e0abd0af527cc$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
/* eslint-disable complexity */ const $601e0abd0af527cc$var$DEFAULT_LOAD_ENTRANCE_DURATION_SEC = 0.6;
const $601e0abd0af527cc$export$7bcfb4ff058df62d = ({ node: node, animated: animated, delay: delay, loadEntranceDurationSec: loadEntranceDurationSec = $601e0abd0af527cc$var$DEFAULT_LOAD_ENTRANCE_DURATION_SEC, skipLoadEntrance: skipLoadEntrance = false, fontFamily: fontFamily = "monospace", onClick: onClick, isExpanding: isExpanding = false, viewBoxHeight: viewBoxHeight, aspectCorrection: aspectCorrection, layoutPct: layoutPct, focusVariant: focusVariant })=>{
    const [isHovered, setIsHovered] = (0, $1oC0p.useState)(false);
    const px = layoutPct?.x ?? node.x;
    const py = layoutPct?.y ?? node.y;
    const outerOpacity = $601e0abd0af527cc$var$clamp01(layoutPct?.opacity ?? node.opacity ?? 1);
    const cx = (0, $hNner.pctToViewBox)(px);
    const cy = (0, $hNner.pctToViewBoxY)(py, viewBoxHeight ?? (0, $hNner.VIEWBOX_SCALE));
    const size = layoutPct?.size ?? node.size ?? $601e0abd0af527cc$var$DEFAULT_SIZE;
    /** Base `node.size` can differ when scroll phases animate `layoutPct.size`. */ const nodeForInsideLeadingIconLayout = {
        ...node,
        size: size
    };
    const r = size / 2;
    const hasModal = !!node.modalContent;
    const patternId = `img-${node.id}`;
    const clipId = `clip-${node.id}`;
    const clipIconId = `clip-icon-${node.id}`;
    const resolvedFontFamilyForLayout = node.fontFamily ?? fontFamily;
    const labelLayoutFontSize = resolvedFontFamilyForLayout === "monospace" ? size * 0.3 : size * 0.4;
    const imagePlacement = (0, $hNner.effectiveLeadingImagePlacement)(node);
    const useLeadingIcon = !!node.bgImage && !!node.text && imagePlacement !== "background" && (node.shape === "pill" || node.shape === "rectangle");
    const useFullBleedBgImage = !node.bgImage || !useLeadingIcon;
    const textStretchW = node.text && (node.shape === "pill" || node.shape === "rectangle") ? node.text.length * labelLayoutFontSize * $601e0abd0af527cc$var$MONOSPACE_CHAR_WIDTH_RATIO : 0;
    const pillBodyTextWidth = node.shape === "pill" && node.text ? textStretchW + size * $601e0abd0af527cc$var$PILL_HORIZONTAL_PADDING : size * $601e0abd0af527cc$var$PILL_ASPECT;
    let pillWidth = layoutPct?.width ?? (node.shape === "pill" && node.text ? pillBodyTextWidth : size * $601e0abd0af527cc$var$PILL_ASPECT);
    if (layoutPct?.width === undefined && node.shape === "pill" && node.text && node.bgImage && imagePlacement === "insideLeading") {
        const iconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, size);
        const insideGap = size * (0, $hNner.LEADING_ICON_INSIDE_GAP_RATIO);
        const extraSlack = size * (0, $hNner.LEADING_INSIDE_EXTRA_WIDTH_RATIO);
        pillWidth = pillBodyTextWidth + iconSide + insideGap + extraSlack;
    }
    const rectangleHeight = layoutPct?.height ?? node.height ?? size;
    let rectangleWidth = layoutPct?.width ?? node.width ?? (node.shape === "rectangle" && node.text ? textStretchW + size * $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING : size);
    const rectangleBodyTextWidth = node.shape === "rectangle" && node.text ? textStretchW + size * $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING : size;
    if (layoutPct?.width === undefined && node.width === undefined && node.shape === "rectangle" && node.text && node.bgImage && imagePlacement === "insideLeading") {
        const iconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, rectangleHeight);
        const insideGap = rectangleHeight * (0, $hNner.LEADING_ICON_INSIDE_GAP_RATIO);
        const extraSlack = Math.max(size, rectangleHeight) * (0, $hNner.LEADING_INSIDE_EXTRA_WIDTH_RATIO);
        rectangleWidth = rectangleBodyTextWidth + iconSide + insideGap + extraSlack;
    }
    const rectangleRx = (0, $hNner.getRectangleBorderRadius)(node, rectangleWidth, rectangleHeight);
    let leadingIconGeom = null;
    if (useLeadingIcon && node.shape === "pill") {
        const outsideIconSide = size;
        const insideIconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, size);
        const outsideGap = size * (0, $hNner.LEADING_ICON_OUTSIDE_GAP_RATIO);
        const sidePad = size * $601e0abd0af527cc$var$PILL_HORIZONTAL_PADDING / 2;
        if (imagePlacement === "insideLeading") leadingIconGeom = {
            x: -pillWidth / 2 + sidePad,
            y: -insideIconSide / 2,
            w: insideIconSide,
            h: insideIconSide,
            rx: 0
        };
        else leadingIconGeom = {
            x: -pillWidth / 2 - outsideGap - outsideIconSide,
            y: -r,
            w: outsideIconSide,
            h: outsideIconSide,
            rx: 0
        };
    } else if (useLeadingIcon && node.shape === "rectangle") {
        const outsideIconSide = rectangleHeight;
        const insideIconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, rectangleHeight);
        const outsideGap = rectangleHeight * (0, $hNner.LEADING_ICON_OUTSIDE_GAP_RATIO);
        const sidePad = size * $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING / 2;
        if (imagePlacement === "insideLeading") leadingIconGeom = {
            x: -rectangleWidth / 2 + sidePad,
            y: -insideIconSide / 2,
            w: insideIconSide,
            h: insideIconSide,
            rx: 0
        };
        else leadingIconGeom = {
            x: -rectangleWidth / 2 - outsideGap - outsideIconSide,
            y: -rectangleHeight / 2,
            w: outsideIconSide,
            h: outsideIconSide,
            rx: 0
        };
    }
    const rotation = node.rotate ? `rotate(${node.rotate}deg)` : "";
    const tx = !isExpanding && isHovered ? cx + 2 : cx;
    const ty = !isExpanding && isHovered ? cy - 5 : cy;
    const innerScale = isExpanding ? 1.25 : animated ? 1 : 0;
    const acX = aspectCorrection?.scaleX ?? 1;
    const acY = aspectCorrection?.scaleY ?? 1;
    let innerTransition;
    if (isExpanding) innerTransition = "opacity 0.3s ease, transform 0.3s ease";
    else if (isHovered) innerTransition = "opacity 0.3s ease, transform 0.3s ease";
    else if (animated) innerTransition = skipLoadEntrance ? undefined : `opacity ${loadEntranceDurationSec}s ease ${delay}s, transform ${loadEntranceDurationSec}s ease ${delay}s`;
    const positionOuterStyle = {
        transform: `translate(${tx}px, ${ty}px)`,
        transformOrigin: "0 0",
        transition: "none",
        mixBlendMode: isExpanding || isHovered ? "normal" : node.mixBlendMode ?? "normal",
        opacity: outerOpacity
    };
    const textColor = (0, $hNner.getFillColor)(node.textColor ?? "white");
    const innerStyle = {
        "transform": `scale(${innerScale * acX}, ${innerScale * acY}) ${rotation}`,
        "transformOrigin": "0 0",
        "--node-text-color": textColor,
        ...innerTransition ? {
            transition: innerTransition
        } : {}
    };
    const clickable = !!onClick;
    const groupProps = {
        style: {
            cursor: clickable ? "pointer" : "default"
        },
        onClick: clickable ? ()=>onClick?.() : undefined,
        role: clickable ? "button" : undefined,
        tabIndex: clickable ? 0 : undefined,
        onKeyDown: clickable ? (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick?.();
            }
        } : undefined
    };
    const modalPointerHandlers = hasModal ? {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    } : {};
    const fill = (0, $hNner.getFillColor)(node.bgColor ?? "blue500");
    const isRovoRainbowBorder = node.borderColor === "rainbowRovo";
    const solidBorderColor = node.borderColor && node.borderColor !== "rainbowRovo" ? node.borderColor : undefined;
    const defaultStrokeWidth = node.borderWidth ?? 2;
    const stroke = solidBorderColor ? (0, $hNner.getFillColor)(solidBorderColor) : "none";
    const strokeWidth = solidBorderColor ? defaultStrokeWidth : 0;
    const rovoRingWidth = node.borderWidth ?? 6;
    const rovoRainbowLayer = isRovoRainbowBorder && (node.shape === "pill" || node.shape === "rectangle") ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $75Q24.RovoRainbowBorder), {
        nodeId: node.id,
        shape: node.shape === "pill" ? "pill" : "rectangle",
        innerWidth: node.shape === "pill" ? pillWidth : rectangleWidth,
        innerHeight: node.shape === "pill" ? size : rectangleHeight,
        innerRectangleBorderRadius: node.shape === "rectangle" ? rectangleRx : undefined,
        ringWidth: rovoRingWidth
    }) : null;
    const nodeFontFamily = node.fontFamily ?? fontFamily;
    const typeFace = nodeFontFamily === "charlie" ? (0, $kbpa7.wacToken)("font.charlie.display") : "monospace";
    const defaultFontWeight = nodeFontFamily === "charlie" ? 600 : 400;
    const textFontWeight = node.fontWeight ?? defaultFontWeight;
    const renderDefs = ()=>{
        if (!node.bgImage) return null;
        if (useLeadingIcon && leadingIconGeom) {
            const g = leadingIconGeom;
            return /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: clipIconId,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        x: g.x,
                        y: g.y,
                        width: g.w,
                        height: g.h,
                        rx: g.rx
                    })
                })
            });
        }
        let clipShape;
        switch(node.shape){
            case "circle":
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    cx: 0,
                    cy: 0,
                    r: r
                });
                break;
            case "pill":
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: -pillWidth / 2,
                    y: -r,
                    width: pillWidth,
                    height: size,
                    rx: r
                });
                break;
            case "rectangle":
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: -rectangleWidth / 2,
                    y: -rectangleHeight / 2,
                    width: rectangleWidth,
                    height: rectangleHeight,
                    rx: rectangleRx
                });
                break;
            case "hexagon":
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                    points: (0, $hNner.getHexagonPoints)(0, 0, r)
                });
                break;
            case "triangle":
                clipShape = /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                    points: (0, $hNner.getTrianglePoints)(0, 0, r)
                });
                break;
        }
        const imgW = node.shape === "rectangle" ? rectangleWidth : size;
        const imgH = node.shape === "rectangle" ? rectangleHeight : size;
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: clipId,
                    children: clipShape
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("pattern", {
                    id: patternId,
                    patternUnits: "objectBoundingBox",
                    width: "1",
                    height: "1",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                        href: node.bgImage,
                        x: -imgW / 2,
                        y: -imgH / 2,
                        width: imgW,
                        height: imgH,
                        preserveAspectRatio: "xMidYMid slice"
                    })
                })
            ]
        });
    };
    const renderShape = ()=>{
        const clipPath = node.bgImage && useFullBleedBgImage ? `url(#${clipId})` : undefined;
        switch(node.shape){
            case "circle":
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                            cx: 0,
                            cy: 0,
                            r: r,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -r,
                            y: -r,
                            width: size,
                            height: size,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
            case "pill":
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            x: -pillWidth / 2,
                            y: -r,
                            width: pillWidth,
                            height: size,
                            rx: r,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -pillWidth / 2,
                            y: -r,
                            width: pillWidth,
                            height: size,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
            case "rectangle":
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            x: -rectangleWidth / 2,
                            y: -rectangleHeight / 2,
                            width: rectangleWidth,
                            height: rectangleHeight,
                            rx: rectangleRx,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -rectangleWidth / 2,
                            y: -rectangleHeight / 2,
                            width: rectangleWidth,
                            height: rectangleHeight,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
            case "hexagon":
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                            points: (0, $hNner.getHexagonPoints)(0, 0, r),
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -r,
                            y: -r,
                            width: size,
                            height: size,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
            case "triangle":
                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                            points: (0, $hNner.getTrianglePoints)(0, 0, r),
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            vectorEffect: "non-scaling-stroke"
                        }),
                        node.bgImage && useFullBleedBgImage && /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                            href: node.bgImage,
                            x: -r,
                            y: -r,
                            width: size,
                            height: size,
                            clipPath: clipPath,
                            preserveAspectRatio: "xMidYMid slice"
                        })
                    ]
                });
        }
    };
    const renderLeadingIconStack = ()=>{
        if (!useLeadingIcon || !leadingIconGeom || !node.bgImage) return null;
        const g = leadingIconGeom;
        return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
                href: node.bgImage,
                x: g.x,
                y: g.y,
                width: g.w,
                height: g.h,
                clipPath: `url(#${clipIconId})`,
                preserveAspectRatio: "xMidYMid slice"
            })
        });
    };
    const renderText = ()=>{
        const textSize = nodeFontFamily === "monospace" ? size * 0.3 : size * 0.4;
        if (!node.text) return null;
        let textAnchor = "middle";
        let textX = 0;
        if (useLeadingIcon && imagePlacement === "insideLeading" && node.shape === "pill") {
            textAnchor = "start";
            const sidePad = size * $601e0abd0af527cc$var$PILL_HORIZONTAL_PADDING / 2;
            const gap = size * (0, $hNner.LEADING_ICON_INSIDE_GAP_RATIO);
            const iconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, size);
            textX = -pillWidth / 2 + sidePad + iconSide + gap;
        } else if (useLeadingIcon && imagePlacement === "insideLeading" && node.shape === "rectangle") {
            textAnchor = "start";
            const sidePad = size * $601e0abd0af527cc$var$RECTANGLE_HORIZONTAL_PADDING / 2;
            const gap = rectangleHeight * (0, $hNner.LEADING_ICON_INSIDE_GAP_RATIO);
            const iconSide = (0, $hNner.leadingInsideIconSidePx)(nodeForInsideLeadingIconLayout, rectangleHeight);
            textX = -rectangleWidth / 2 + sidePad + iconSide + gap;
        }
        return /*#__PURE__*/ (0, $7VQPk.jsx)("text", {
            x: textX,
            y: 0,
            textAnchor: textAnchor,
            dominantBaseline: "central",
            fill: textColor,
            fontSize: textSize,
            fontWeight: textFontWeight,
            fontFamily: typeFace,
            pointerEvents: "none",
            children: node.text
        });
    };
    const renderRectangleHtmlContent = ()=>{
        if (node.shape !== "rectangle" || node.htmlContent === undefined || node.htmlContent === null) return null;
        const w = rectangleWidth;
        const h = rectangleHeight;
        const xhtmlWrapperStyle = {
            width: "100%",
            height: "100%",
            margin: 0,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            fontFamily: typeFace,
            color: textColor,
            lineHeight: 1.35,
            WebkitFontSmoothing: "antialiased"
        };
        return /*#__PURE__*/ (0, $7VQPk.jsx)("foreignObject", {
            x: -w / 2,
            y: -h / 2,
            width: w,
            height: h,
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
                xmlns: "http://www.w3.org/1999/xhtml",
                style: xhtmlWrapperStyle
            }, node.htmlContent)
        });
    };
    const focusClass = focusVariant === "node-edit" ? "spiderweb-node--focus-node-edit" : focusVariant === "connector" ? "spiderweb-node--focus-connector" : "";
    return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
        className: (0, $2jatx.default)([
            "_yc581r31 _ymio1r31 _18xqglyw _ypr0glyw _1bjo1o36 _zcxs1o36 _dl451q9v _uzb71q9v _1xkmgq9o _1okygq9o _7fy219bv _masb19bv _1npv452u _1ljw452u _1lfl1bs3 _9gqo1bs3 _t8mz12c5 _1shr12c5 _1uaj605o _1pn9605o _kja3tlke _1ugbewfl _ao4wewfl _5wjo1gnr _1bcy1gnr _9qyu1gnr _1oxm1gnr _qayc1gnr _1pnf1gnr _179o1gnr _oimw1f33 _16or1f33 _1oy11f33 _17651f33 _8qwq1f33 _ohkf1f33 _16dt1f33 _1rc3idpf _1t2iidpf _d7tpidpf _17opidpf _sk07idpf _1a7ridpf _9ersidpf _kgp4idpf _151didpf _1libidpf _1t7eidpf _1nvlidpf _6d9lidpf _922midpf _1duf1kwk _n6e41kwk _unli1kwk _1po11kwk _7n4p1kwk _1x7n1kwk _13il1kwk _7clvidpf _543pidpf _w6r8idpf _ol08idpf _mpitidpf _1jrwidpf _okkmidpf _fp9j1gnr _1yk91gnr _8izd1gnr _1f981gnr _gw491gnr _iree1gnr _1klh1gnr _pf5l1nn1 _1444viql _jl4d1wto _4rdb1k8s _11sg1k8s",
            `
        ${hasModal ? "modal-interactive" : ""}
        ${hasModal && isHovered ? "modal-hovered" : ""}
        ${focusClass}
        `
        ]),
        id: `node-group-${node.id}`,
        "data-modal-interactive": hasModal ? true : undefined,
        ...groupProps,
        ...modalPointerHandlers,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            style: positionOuterStyle,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    style: innerStyle,
                    children: [
                        rovoRainbowLayer,
                        renderDefs(),
                        renderShape(),
                        renderLeadingIconStack(),
                        renderRectangleHtmlContent(),
                        renderText()
                    ]
                }),
                focusVariant === "connector" && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            fill: "black",
                            width: 170,
                            height: 40,
                            y: -25,
                            x: -80
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("text", {
                            fill: "white",
                            x: -70,
                            children: "Select another node"
                        })
                    ]
                })
            ]
        })
    });
}; /* eslint-enable complexity */ 

});
parcelRegister("75Q24", function(module, exports) {
$parcel$export(module.exports, "RovoRainbowBorder", function () { return $be99f48601e89603$export$2b048a65f5dc1409; });

var $7VQPk = parcelRequire("7VQPk");

var $hNner = parcelRequire("hNner");
const $be99f48601e89603$var$ROVO_QUADRANT_COLORS = [
    "lime500",
    "yellow400",
    "purple500",
    "blue500"
];
function $be99f48601e89603$var$safeNodeIdForSvg(nodeId) {
    return nodeId.replace(/[^\w.-]/g, "_");
}
const $be99f48601e89603$export$2b048a65f5dc1409 = ({ nodeId: nodeId, shape: shape, innerWidth: innerWidth, innerHeight: innerHeight, innerRectangleBorderRadius: innerRectangleBorderRadius, ringWidth: ringWidth })=>{
    const B = ringWidth;
    const W_out = innerWidth + 2 * B;
    const H_out = innerHeight + 2 * B;
    const x0 = -W_out / 2;
    const y0 = -H_out / 2;
    const halfW = W_out / 2;
    const halfH = H_out / 2;
    const rxOut = shape === "pill" ? H_out / 2 : innerRectangleBorderRadius !== undefined ? Math.min(innerRectangleBorderRadius + B, Math.min(W_out, H_out) / 2) : Math.min(W_out, H_out) / 4;
    const sid = $be99f48601e89603$var$safeNodeIdForSvg(nodeId);
    const clipId = (q)=>`rr-${sid}-${q}`;
    const clips = /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                id: clipId("tl"),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: x0,
                    y: y0,
                    width: halfW,
                    height: halfH
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                id: clipId("tr"),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: 0,
                    y: y0,
                    width: halfW,
                    height: halfH
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                id: clipId("bl"),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: x0,
                    y: 0,
                    width: halfW,
                    height: halfH
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                id: clipId("br"),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                    x: 0,
                    y: 0,
                    width: halfW,
                    height: halfH
                })
            })
        ]
    });
    const outerRectAttrs = {
        x: x0,
        y: y0,
        width: W_out,
        height: H_out,
        rx: rxOut
    };
    const quadrants = [
        "tl",
        "tr",
        "bl",
        "br"
    ].map((q, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            clipPath: `url(#${clipId(q)})`,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                ...outerRectAttrs,
                fill: (0, $hNner.getFillColor)($be99f48601e89603$var$ROVO_QUADRANT_COLORS[i] || "lime500")
            })
        }, q));
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            clips,
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                className: "spiderweb-node__rovo-rainbow-border",
                pointerEvents: "none",
                children: quadrants
            })
        ]
    });
};

});


parcelRegister("dhl4q", function(module, exports) {
$parcel$export(module.exports, "WebOverlapLayers", function () { return $13171dd67522f5be$export$c70c1f7696a29479; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $hNner = parcelRequire("hNner");
function $13171dd67522f5be$var$localToWorld(lx, ly, L) {
    const rad = L.rotate * Math.PI / 180;
    const c = Math.cos(rad);
    const s = Math.sin(rad);
    return [
        L.cx + lx * c - ly * s,
        L.cy + lx * s + ly * c
    ];
}
function $13171dd67522f5be$var$worldToLocal(wx, wy, L) {
    const dx = wx - L.cx;
    const dy = wy - L.cy;
    const rad = -L.rotate * Math.PI / 180;
    const c = Math.cos(rad);
    const s = Math.sin(rad);
    return [
        dx * c - dy * s,
        dx * s + dy * c
    ];
}
function $13171dd67522f5be$var$layoutWorldAabb(L) {
    const { r: r, size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight, shape: shape } = L;
    const corners = (()=>{
        switch(shape){
            case "circle":
                return [
                    [
                        -r,
                        -r
                    ],
                    [
                        r,
                        -r
                    ],
                    [
                        r,
                        r
                    ],
                    [
                        -r,
                        r
                    ]
                ];
            case "pill":
                {
                    const x0 = -pillWidth / 2;
                    const x1 = pillWidth / 2;
                    const y0 = -r;
                    const y1 = -r + size;
                    return [
                        [
                            x0,
                            y0
                        ],
                        [
                            x1,
                            y0
                        ],
                        [
                            x1,
                            y1
                        ],
                        [
                            x0,
                            y1
                        ]
                    ];
                }
            case "rectangle":
                {
                    const rh = rectangleHeight;
                    const x0 = -rectangleWidth / 2;
                    const x1 = rectangleWidth / 2;
                    const y0 = -rh / 2;
                    const y1 = rh / 2;
                    return [
                        [
                            x0,
                            y0
                        ],
                        [
                            x1,
                            y0
                        ],
                        [
                            x1,
                            y1
                        ],
                        [
                            x0,
                            y1
                        ]
                    ];
                }
            case "hexagon":
                {
                    const pts = [];
                    for(let i = 0; i < 6; i++){
                        const a = Math.PI / 3 * i - Math.PI / 2;
                        pts.push([
                            r * Math.cos(a),
                            r * Math.sin(a)
                        ]);
                    }
                    return pts;
                }
            case "triangle":
                return [
                    [
                        0,
                        -r
                    ],
                    [
                        -r * 0.866,
                        r * 0.5
                    ],
                    [
                        r * 0.866,
                        r * 0.5
                    ]
                ];
            default:
                return [
                    [
                        -r,
                        -r
                    ],
                    [
                        r,
                        -r
                    ],
                    [
                        r,
                        r
                    ],
                    [
                        -r,
                        r
                    ]
                ];
        }
    })();
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (const [lx, ly] of corners){
        const [wx, wy] = $13171dd67522f5be$var$localToWorld(lx, ly, L);
        minX = Math.min(minX, wx);
        maxX = Math.max(maxX, wx);
        minY = Math.min(minY, wy);
        maxY = Math.max(maxY, wy);
    }
    return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
    };
}
function $13171dd67522f5be$var$intersectWorldAabbs(a, b) {
    const minX = Math.max(a.minX, b.minX);
    const maxX = Math.min(a.maxX, b.maxX);
    const minY = Math.max(a.minY, b.minY);
    const maxY = Math.min(a.maxY, b.maxY);
    if (minX >= maxX || minY >= maxY) return null;
    return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
    };
}
function $13171dd67522f5be$var$pointInLocalHexagon(lx, ly, r) {
    const vx = [];
    const vy = [];
    for(let i = 0; i < 6; i++){
        const a = Math.PI / 3 * i - Math.PI / 2;
        vx.push(r * Math.cos(a));
        vy.push(r * Math.sin(a));
    }
    let inside = false;
    for(let i = 0; i < 6; i++){
        const j = (i + 5) % 6;
        const xi = vx[i];
        const yi = vy[i];
        const xj = vx[j];
        const yj = vy[j];
        if (yi > ly !== yj > ly && lx < (xj - xi) * (ly - yi) / (yj - yi + 1e-12) + xi) inside = !inside;
    }
    return inside;
}
function $13171dd67522f5be$var$pointInLocalTriangle(lx, ly, r) {
    const x1 = 0;
    const y1 = -r;
    const x2 = -r * 0.866;
    const y2 = r * 0.5;
    const x3 = r * 0.866;
    const y3 = r * 0.5;
    const sign = (p1x, p1y, p2x, p2y, p3x, p3y)=>(p1x - p3x) * (p2y - p3y) - (p2x - p3x) * (p1y - p3y);
    const d1 = sign(lx, ly, x1, y1, x2, y2);
    const d2 = sign(lx, ly, x2, y2, x3, y3);
    const d3 = sign(lx, ly, x3, y3, x1, y1);
    const hasNeg = d1 < -0.000001 || d2 < -0.000001 || d3 < -0.000001;
    const hasPos = d1 > 1e-6 || d2 > 1e-6 || d3 > 1e-6;
    return !(hasNeg && hasPos);
}
function $13171dd67522f5be$var$pointInLocalShape(lx, ly, L) {
    const { r: r, size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight, shape: shape } = L;
    switch(shape){
        case "circle":
            return lx * lx + ly * ly <= r * r + 1e-6;
        case "pill":
            return lx >= -pillWidth / 2 - 1e-6 && lx <= pillWidth / 2 + 1e-6 && ly >= -r - 1e-6 && ly <= -r + size + 1e-6;
        case "rectangle":
            {
                const rh = rectangleHeight;
                return lx >= -rectangleWidth / 2 - 1e-6 && lx <= rectangleWidth / 2 + 1e-6 && ly >= -rh / 2 - 1e-6 && ly <= rh / 2 + 1e-6;
            }
        case "hexagon":
            return $13171dd67522f5be$var$pointInLocalHexagon(lx, ly, r);
        case "triangle":
            return $13171dd67522f5be$var$pointInLocalTriangle(lx, ly, r);
        default:
            return lx * lx + ly * ly <= r * r + 1e-6;
    }
}
function $13171dd67522f5be$var$pointInWorldShape(wx, wy, L) {
    const [lx, ly] = $13171dd67522f5be$var$worldToLocal(wx, wy, L);
    return $13171dd67522f5be$var$pointInLocalShape(lx, ly, L);
}
const $13171dd67522f5be$var$INTERSECTION_AABB_GRID = 56;
function $13171dd67522f5be$var$getShapeIntersectionAabb(Ls, Lt) {
    const ab = $13171dd67522f5be$var$intersectWorldAabbs($13171dd67522f5be$var$layoutWorldAabb(Ls), $13171dd67522f5be$var$layoutWorldAabb(Lt));
    if (!ab) return null;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    let found = false;
    const gw = $13171dd67522f5be$var$INTERSECTION_AABB_GRID;
    const w = ab.maxX - ab.minX;
    const h = ab.maxY - ab.minY;
    for(let i = 0; i <= gw; i++)for(let j = 0; j <= gw; j++){
        const x = ab.minX + i / gw * w;
        const y = ab.minY + j / gw * h;
        if ($13171dd67522f5be$var$pointInWorldShape(x, y, Ls) && $13171dd67522f5be$var$pointInWorldShape(x, y, Lt)) {
            found = true;
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
    }
    if (!found) return null;
    const pad = Math.max((maxX - minX) * 0.02, (maxY - minY) * 0.02, 0.5);
    return {
        minX: minX - pad,
        maxX: maxX + pad,
        minY: minY - pad,
        maxY: maxY + pad
    };
}
function $13171dd67522f5be$var$clipPathShape(L) {
    const { cx: cx, cy: cy, r: r, size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight, rectangleBorderRadius: rectangleBorderRadius, rotate: rotate, shape: shape } = L;
    const tf = `translate(${cx},${cy}) rotate(${rotate})`;
    switch(shape){
        case "circle":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: cx,
                cy: cy,
                r: r
            });
        case "pill":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: -pillWidth / 2,
                y: -r,
                width: pillWidth,
                height: size,
                rx: r,
                transform: tf
            });
        case "rectangle":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: -rectangleWidth / 2,
                y: -rectangleHeight / 2,
                width: rectangleWidth,
                height: rectangleHeight,
                rx: rectangleBorderRadius ?? Math.min(rectangleWidth, rectangleHeight) / 4,
                transform: tf
            });
        case "hexagon":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: (0, $hNner.getHexagonPoints)(0, 0, r),
                transform: tf
            });
        case "triangle":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: (0, $hNner.getTrianglePoints)(0, 0, r),
                transform: tf
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: cx,
                cy: cy,
                r: r
            });
    }
}
function $13171dd67522f5be$var$renderFilledShape(L, fill, fillOpacity) {
    const { r: r, size: size, pillWidth: pillWidth, rectangleWidth: rectangleWidth, rectangleHeight: rectangleHeight, rectangleBorderRadius: rectangleBorderRadius, shape: shape } = L;
    const op = fillOpacity !== undefined ? {
        fillOpacity: fillOpacity
    } : {};
    const cssFill = (0, $hNner.getFillColor)(fill);
    switch(shape){
        case "circle":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: 0,
                cy: 0,
                r: r,
                fill: cssFill,
                ...op
            });
        case "pill":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: -pillWidth / 2,
                y: -r,
                width: pillWidth,
                height: size,
                rx: r,
                fill: cssFill,
                ...op
            });
        case "rectangle":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: -rectangleWidth / 2,
                y: -rectangleHeight / 2,
                width: rectangleWidth,
                height: rectangleHeight,
                rx: rectangleBorderRadius ?? Math.min(rectangleWidth, rectangleHeight) / 4,
                fill: cssFill,
                ...op
            });
        case "hexagon":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: (0, $hNner.getHexagonPoints)(0, 0, r),
                fill: cssFill,
                ...op
            });
        case "triangle":
            return /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: (0, $hNner.getTrianglePoints)(0, 0, r),
                fill: cssFill,
                ...op
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: 0,
                cy: 0,
                r: r,
                fill: cssFill,
                ...op
            });
    }
}
function $13171dd67522f5be$var$resolveIntersectionImageAabb(Ls, Lt) {
    const tight = $13171dd67522f5be$var$getShapeIntersectionAabb(Ls, Lt);
    if (tight) return tight;
    const loose = $13171dd67522f5be$var$intersectWorldAabbs($13171dd67522f5be$var$layoutWorldAabb(Ls), $13171dd67522f5be$var$layoutWorldAabb(Lt));
    if (loose) {
        const cx = (loose.minX + loose.maxX) / 2;
        const cy = (loose.minY + loose.maxY) / 2;
        const side = Math.max(Math.min(loose.maxX - loose.minX, loose.maxY - loose.minY, 48), 6);
        return {
            minX: cx - side / 2,
            maxX: cx + side / 2,
            minY: cy - side / 2,
            maxY: cy + side / 2
        };
    }
    const cx = (Ls.cx + Lt.cx) / 2;
    const cy = (Ls.cy + Lt.cy) / 2;
    const s = Math.min(Ls.r, Lt.r, 24) * 0.5;
    return {
        minX: cx - s,
        maxX: cx + s,
        minY: cy - s,
        maxY: cy + s
    };
}
function $13171dd67522f5be$var$renderOverlapImageInIntersection(href, aabb) {
    const w = Math.max(aabb.maxX - aabb.minX, 1);
    const h = Math.max(aabb.maxY - aabb.minY, 1);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("image", {
        href: href,
        x: aabb.minX,
        y: aabb.minY,
        width: w,
        height: h,
        preserveAspectRatio: "xMidYMid slice"
    });
}
function $13171dd67522f5be$var$normalizeOverlapFill(fill) {
    if (typeof fill === "string") return {
        color: fill
    };
    return {
        color: fill.color,
        backgroundImage: fill.backgroundImage
    };
}
const $13171dd67522f5be$var$DEFAULT_OVERLAP_FADE_DURATION_SEC = 0.5;
const $13171dd67522f5be$export$c70c1f7696a29479 = ({ nodes: nodes, viewBoxHeight: viewBoxHeight, animated: animated = false, delay: delay = 0, loadEntranceFadeDurationSec: loadEntranceFadeDurationSec = $13171dd67522f5be$var$DEFAULT_OVERLAP_FADE_DURATION_SEC, skipLoadEntrance: skipLoadEntrance = false, nodePositions: nodePositions })=>{
    const reactId = (0, $1oC0p.useId)().replace(/:/g, "");
    const nodeMap = (0, $1oC0p.useMemo)(()=>new Map(nodes.map((n)=>[
                n.id,
                n
            ])), [
        nodes
    ]);
    const { clipIds: clipIds, layers: layers } = (0, $1oC0p.useMemo)(()=>{
        const clipIds = new Set();
        const layers = [];
        for (const node of nodes){
            if (!node.overlapColors?.length) continue;
            for (const entry of node.overlapColors){
                const otherId = entry.elementIdToOverlap;
                const otherNode = nodeMap.get(otherId);
                if (!otherNode) continue;
                const parsed = $13171dd67522f5be$var$normalizeOverlapFill({
                    color: entry.color,
                    backgroundImage: entry.backgroundImage
                });
                if (!parsed.color && !parsed.backgroundImage) continue;
                clipIds.add(otherId);
                const Ls = (0, $hNner.getNodeOverlapLayout)(node, viewBoxHeight, nodePositions?.get(node.id));
                const Lt = (0, $hNner.getNodeOverlapLayout)(otherNode, viewBoxHeight, nodePositions?.get(otherId));
                let imageAabb;
                if (parsed.backgroundImage) {
                    clipIds.add(node.id);
                    imageAabb = $13171dd67522f5be$var$resolveIntersectionImageAabb(Ls, Lt);
                }
                layers.push({
                    sourceId: node.id,
                    targetId: otherId,
                    parsed: parsed,
                    imageAabb: imageAabb
                });
            }
        }
        return {
            clipIds: clipIds,
            layers: layers
        };
    }, [
        nodes,
        nodeMap,
        viewBoxHeight,
        nodePositions
    ]);
    const clipId = (nodeId)=>`overlap-clip-${reactId}-${nodeId}`;
    if (layers.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: nodes.filter((n)=>clipIds.has(n.id)).map((n)=>{
                    const L = (0, $hNner.getNodeOverlapLayout)(n, viewBoxHeight, nodePositions?.get(n.id));
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: clipId(n.id),
                        clipPathUnits: "userSpaceOnUse",
                        children: $13171dd67522f5be$var$clipPathShape(L)
                    }, clipId(n.id));
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                style: {
                    isolation: "isolate",
                    pointerEvents: "none",
                    opacity: animated ? 1 : 0,
                    ...animated && skipLoadEntrance ? {} : {
                        transition: `opacity ${loadEntranceFadeDurationSec}s ease ${delay}s`
                    }
                },
                children: layers.map(({ sourceId: sourceId, targetId: targetId, parsed: parsed, imageAabb: imageAabb })=>{
                    const source = nodeMap.get(sourceId);
                    if (!source) return null;
                    const L = (0, $hNner.getNodeOverlapLayout)(source, viewBoxHeight, nodePositions?.get(sourceId));
                    const hasImage = Boolean(parsed.backgroundImage);
                    const hasColor = Boolean(parsed.color);
                    if (hasImage && imageAabb) return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        style: {
                            mixBlendMode: "normal"
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                            clipPath: `url(#${clipId(targetId)})`,
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                                clipPath: `url(#${clipId(sourceId)})`,
                                children: [
                                    hasColor && parsed.color ? /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                        transform: `translate(${L.cx},${L.cy}) rotate(${L.rotate})`,
                                        children: $13171dd67522f5be$var$renderFilledShape(L, parsed.color)
                                    }) : null,
                                    $13171dd67522f5be$var$renderOverlapImageInIntersection(parsed.backgroundImage ?? "", imageAabb)
                                ]
                            })
                        })
                    }, `${sourceId}-${targetId}`);
                    const fillContent = parsed.color !== undefined ? $13171dd67522f5be$var$renderFilledShape(L, parsed.color) : null;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                        style: {
                            mixBlendMode: "normal"
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                            clipPath: `url(#${clipId(targetId)})`,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                transform: `translate(${L.cx},${L.cy}) rotate(${L.rotate})`,
                                children: fillContent
                            })
                        })
                    }, `${sourceId}-${targetId}`);
                })
            })
        ]
    });
};

});


parcelRegister("kCguZ", function(module, exports) {
$parcel$export(module.exports, "useSpiderWebConnectorPlan", function () { return $aaba49e65f69a395$export$e2164034fb892369; });

var $1oC0p = parcelRequire("1oC0p");

var $hNner = parcelRequire("hNner");
function $aaba49e65f69a395$export$e2164034fb892369(nodes, maxNeighbors, explicitConnectors, useOnlyExplicitConnectors, connectorShape, connectorType) {
    const connectorConfigs = (0, $1oC0p.useMemo)(()=>explicitConnectors && useOnlyExplicitConnectors ? explicitConnectors : (0, $hNner.autoConnectNodes)(nodes, maxNeighbors, explicitConnectors), [
        nodes,
        maxNeighbors,
        explicitConnectors,
        useOnlyExplicitConnectors
    ]);
    const resolvedConnectors = (0, $1oC0p.useMemo)(()=>(0, $hNner.resolveConnectors)(connectorConfigs, nodes, connectorShape, connectorType), [
        connectorConfigs,
        nodes,
        connectorShape,
        connectorType
    ]);
    return {
        connectorConfigs: connectorConfigs,
        resolvedConnectors: resolvedConnectors
    };
}

});

parcelRegister("7h9Nf", function(module, exports) {
$parcel$export(module.exports, "getNearestVerticalScrollContainer", function () { return $4a81c6d16703993d$export$5b614bdf9b8b0d5b; });
$parcel$export(module.exports, "computeDocumentSectionScrollProgress", function () { return $4a81c6d16703993d$export$da68696ce9c4a3f0; });
$parcel$export(module.exports, "useSpiderwebDocumentSectionProgress", function () { return $4a81c6d16703993d$export$234e79cf56f5baa8; });

var $1oC0p = parcelRequire("1oC0p");
function $4a81c6d16703993d$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
function $4a81c6d16703993d$export$5b614bdf9b8b0d5b(start) {
    let el = start;
    while(el){
        const { overflowY: overflowY } = getComputedStyle(el);
        const canScrollY = (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") && el.scrollHeight > el.clientHeight + 1;
        if (canScrollY) return el;
        el = el.parentElement;
    }
    return null;
}
function $4a81c6d16703993d$export$da68696ce9c4a3f0(section, scrollRoot) {
    if (scrollRoot) {
        const maxScroll = Math.max(0, scrollRoot.scrollHeight - scrollRoot.clientHeight);
        if (maxScroll <= 0) return 0;
        return $4a81c6d16703993d$var$clamp01(scrollRoot.scrollTop / maxScroll);
    }
    const trackH = section.offsetHeight;
    const viewH = window.innerHeight;
    const scrollable = trackH - viewH;
    const rect = section.getBoundingClientRect();
    if (scrollable <= 0) {
        if (rect.bottom <= 0) return 1;
        if (rect.top >= viewH) return 0;
        const past = Math.min(Math.max(-rect.top, 0), trackH);
        return trackH <= 0 ? 0 : $4a81c6d16703993d$var$clamp01(past / trackH);
    }
    const scrolled = Math.min(Math.max(-rect.top, 0), scrollable);
    return $4a81c6d16703993d$var$clamp01(scrolled / scrollable);
}
function $4a81c6d16703993d$export$234e79cf56f5baa8(sectionRef, enabled) {
    const [progress, setProgress] = (0, $1oC0p.useState)(0);
    const [isAttached, setIsAttached] = (0, $1oC0p.useState)(false);
    const isAttachedRef = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (!enabled || !sectionRef) {
            setProgress(0);
            if (isAttachedRef.current) {
                isAttachedRef.current = false;
                setIsAttached(false);
            }
            return;
        }
        let detach;
        let pollRafId = 0;
        let scrollFlushRafId = 0;
        let cancelled = false;
        const attach = (target)=>{
            const scrollContainer = $4a81c6d16703993d$export$5b614bdf9b8b0d5b(target);
            const flushProgress = ()=>{
                if (!cancelled) setProgress($4a81c6d16703993d$export$da68696ce9c4a3f0(target, scrollContainer));
            };
            const scheduleScrollFlush = ()=>{
                if (scrollFlushRafId !== 0) return;
                scrollFlushRafId = requestAnimationFrame(()=>{
                    scrollFlushRafId = 0;
                    flushProgress();
                });
            };
            flushProgress();
            isAttachedRef.current = true;
            setIsAttached(true);
            if (scrollContainer) scrollContainer.addEventListener("scroll", scheduleScrollFlush, {
                passive: true
            });
            else window.addEventListener("scroll", scheduleScrollFlush, {
                passive: true
            });
            window.addEventListener("resize", flushProgress);
            const ro = new ResizeObserver(flushProgress);
            ro.observe(target);
            if (scrollContainer) ro.observe(scrollContainer);
            detach = ()=>{
                cancelAnimationFrame(scrollFlushRafId);
                scrollFlushRafId = 0;
                if (scrollContainer) scrollContainer.removeEventListener("scroll", scheduleScrollFlush);
                else window.removeEventListener("scroll", scheduleScrollFlush);
                window.removeEventListener("resize", flushProgress);
                ro.disconnect();
                if (!cancelled) {
                    isAttachedRef.current = false;
                    setIsAttached(false);
                    setProgress(0);
                }
            };
        };
        const el = sectionRef.current;
        if (el) {
            attach(el);
            return ()=>{
                cancelled = true;
                detach?.();
            };
        }
        const poll = ()=>{
            if (cancelled) return;
            const node = sectionRef.current;
            if (node) {
                attach(node);
                return;
            }
            pollRafId = requestAnimationFrame(poll);
        };
        pollRafId = requestAnimationFrame(poll);
        return ()=>{
            cancelled = true;
            cancelAnimationFrame(pollRafId);
            detach?.();
        };
    }, [
        enabled,
        sectionRef
    ]);
    return {
        progress: progress,
        isAttached: isAttached
    };
}

});

parcelRegister("iDO3O", function(module, exports) {
$parcel$export(module.exports, "useSpiderWebIntersectionVisibility", function () { return $3aade048a6a44afa$export$5c64e593c0ce10f0; });

var $1oC0p = parcelRequire("1oC0p");
const $3aade048a6a44afa$var$INTERSECTION_THRESHOLD = 0.3;
function $3aade048a6a44afa$export$5c64e593c0ce10f0(containerRef, replayOnVisible) {
    const [isVisible, setIsVisible] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const options = {
            threshold: $3aade048a6a44afa$var$INTERSECTION_THRESHOLD
        };
        if (!replayOnVisible) {
            const observer = new IntersectionObserver(([entry])=>{
                if (entry?.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            }, options);
            observer.observe(el);
            return ()=>observer.disconnect();
        }
        const observer = new IntersectionObserver(([entry])=>{
            if (entry) setIsVisible(entry.isIntersecting);
        }, options);
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        containerRef,
        replayOnVisible
    ]);
    return isVisible;
}

});

parcelRegister("ldiHh", function(module, exports) {
$parcel$export(module.exports, "anyNodeHasPhases", function () { return $bb5461f936702316$export$5343c19e01c17c38; });
$parcel$export(module.exports, "useSpiderwebPhasePositions", function () { return $bb5461f936702316$export$f63a5d7448e5031b; });

var $1oC0p = parcelRequire("1oC0p");

var $fVNxT = parcelRequire("fVNxT");

var $8uyM5 = parcelRequire("8uyM5");

var $hNner = parcelRequire("hNner");
function $bb5461f936702316$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $bb5461f936702316$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
function $bb5461f936702316$var$clampMinSize(v) {
    return Math.max(1, v);
}
function $bb5461f936702316$var$dimsForSize(node, sz) {
    return (0, $hNner.getNodeLayoutDimensions)({
        ...node,
        size: sz
    });
}
function $bb5461f936702316$export$e7b17d4d0ffa305d(node, baseX, baseY, baseOpacity, phases, t) {
    const o0 = $bb5461f936702316$var$clamp01(baseOpacity);
    if (!phases?.length) return {
        x: baseX,
        y: baseY,
        opacity: o0
    };
    const bases = (0, $hNner.getNodeLayoutDimensions)(node);
    let x = baseX;
    let y = baseY;
    let opacity = o0;
    let sz = bases.size;
    let bw = bases.boxWidth;
    let bh = bases.boxHeight;
    let tAcc = 0;
    for (const p of phases){
        const holdEnd = tAcc + (p?.delay ?? 0);
        if (t < holdEnd) return {
            x: x,
            y: y,
            opacity: opacity,
            size: sz,
            width: bw,
            height: bh
        };
        tAcc = holdEnd;
        const moveEnd = tAcc + (p?.duration ?? 0);
        const opacityStart = opacity;
        const opacityEnd = p.opacity !== undefined ? $bb5461f936702316$var$clamp01(p.opacity) : opacity;
        const szStart = sz;
        const bwStart = bw;
        const bhStart = bh;
        const szEnd = p.size !== undefined ? $bb5461f936702316$var$clampMinSize(p.size) : szStart;
        const bwEnd = p.width !== undefined ? p.width : p.size !== undefined ? $bb5461f936702316$var$dimsForSize(node, szEnd).boxWidth : bwStart;
        const bhEnd = p.height !== undefined ? p.height : p.size !== undefined ? $bb5461f936702316$var$dimsForSize(node, szEnd).boxHeight : bhStart;
        if (t < moveEnd) {
            const u = (p?.duration ?? 0) > 0 ? (t - tAcc) / (p?.duration ?? 0) : 1;
            const e = $bb5461f936702316$var$easeInOutCubic(Math.min(1, Math.max(0, u)));
            const szMid = szStart + (szEnd - szStart) * e;
            const opacityMid = opacityStart + (opacityEnd - opacityStart) * e;
            const xEnd = p.x !== undefined ? p.x : x;
            const yEnd = p.y !== undefined ? p.y : y;
            let bwMid;
            if (p.width !== undefined) bwMid = bwStart + (bwEnd - bwStart) * e;
            else if (p.size !== undefined) bwMid = $bb5461f936702316$var$dimsForSize(node, szMid).boxWidth;
            else bwMid = bwStart;
            let bhMid;
            if (p.height !== undefined) bhMid = bhStart + (bhEnd - bhStart) * e;
            else if (p.size !== undefined) bhMid = $bb5461f936702316$var$dimsForSize(node, szMid).boxHeight;
            else bhMid = bhStart;
            return {
                x: x + (xEnd - x) * e,
                y: y + (yEnd - y) * e,
                opacity: opacityMid,
                size: szMid,
                width: bwMid,
                height: bhMid
            };
        }
        tAcc = moveEnd;
        x = p.x !== undefined ? p.x : x;
        y = p.y !== undefined ? p.y : y;
        opacity = opacityEnd;
        sz = szEnd;
        bw = bwEnd;
        bh = bhEnd;
    }
    return {
        x: x,
        y: y,
        opacity: opacity,
        size: sz,
        width: bw,
        height: bh
    };
}
function $bb5461f936702316$export$9e4cfa56a09d0b34(phases) {
    if (!phases?.length) return 0;
    if ((0, $fVNxT.animationPhasesUseScrollWindows)(phases)) return Math.max(0, ...phases.map((p)=>p.scrollWindowEnd ?? 0));
    let total = 0;
    for (const p of phases)total += p.delay + p.duration;
    return total;
}
function $bb5461f936702316$export$5343c19e01c17c38(nodes) {
    return nodes.some((n)=>n.animationPhases?.length);
}
function $bb5461f936702316$export$f63a5d7448e5031b(nodes, active, phaseClockStartOffsetSec, animationsPaused, options) {
    const drive = options?.drive ?? "time";
    const scrollProgress = options?.scrollProgress ?? 0;
    const baseMap = (0, $1oC0p.useMemo)(()=>{
        const m = new Map();
        for (const n of nodes)m.set(n.id, {
            x: n.x,
            y: n.y,
            opacity: $bb5461f936702316$var$clamp01(n.opacity ?? 1)
        });
        return m;
    }, [
        nodes
    ]);
    const hasPhases = (0, $1oC0p.useMemo)(()=>$bb5461f936702316$export$5343c19e01c17c38(nodes), [
        nodes
    ]);
    const maxDurationSec = (0, $1oC0p.useMemo)(()=>{
        let max = 0;
        for (const n of nodes)max = Math.max(max, $bb5461f936702316$export$9e4cfa56a09d0b34(n.animationPhases));
        return max;
    }, [
        nodes
    ]);
    const [liveMap, setLiveMap] = (0, $1oC0p.useState)(()=>baseMap);
    (0, $1oC0p.useEffect)(()=>{
        setLiveMap(new Map(baseMap));
    }, [
        baseMap
    ]);
    const pausedRef = (0, $1oC0p.useRef)(animationsPaused);
    pausedRef.current = animationsPaused;
    const frozenScrollProgressRef = (0, $1oC0p.useRef)(0);
    const wasAnimationPausedRef = (0, $1oC0p.useRef)(false);
    const [scrollPauseEpoch, setScrollPauseEpoch] = (0, $1oC0p.useState)(0);
    (0, $1oC0p.useLayoutEffect)(()=>{
        if (drive !== "scroll") return;
        if (animationsPaused && !wasAnimationPausedRef.current) {
            frozenScrollProgressRef.current = scrollProgress;
            setScrollPauseEpoch((e)=>e + 1);
        }
        wasAnimationPausedRef.current = animationsPaused;
    }, [
        drive,
        animationsPaused,
        scrollProgress
    ]);
    const effectiveScrollProgress = drive === "scroll" && animationsPaused ? frozenScrollProgressRef.current : scrollProgress;
    const scrollDerivedMap = (0, $1oC0p.useMemo)(()=>{
        if (drive !== "scroll" || !active || !hasPhases) return baseMap;
        const m = new Map();
        const scrollPercent100 = effectiveScrollProgress * 100;
        for (const n of nodes){
            (0, $fVNxT.assertConsistentScrollWindows)(n.id, n.animationPhases);
            const phases = n.animationPhases;
            if ((0, $fVNxT.animationPhasesUseScrollWindows)(phases)) m.set(n.id, (0, $fVNxT.getLayoutAtScrollWindows)(n, n.x, n.y, n.opacity ?? 1, phases || [], scrollPercent100));
            else {
                const t = effectiveScrollProgress * (0, $8uyM5.ANIMATION_PHASES_SCROLL_TIMELINE_UNITS_DEFAULT);
                m.set(n.id, $bb5461f936702316$export$e7b17d4d0ffa305d(n, n.x, n.y, n.opacity ?? 1, phases, t));
            }
        }
        return m;
    }, [
        drive,
        active,
        hasPhases,
        nodes,
        baseMap,
        effectiveScrollProgress,
        scrollProgress,
        animationsPaused,
        scrollPauseEpoch
    ]);
    const timelineStartMsRef = (0, $1oC0p.useRef)(null);
    const pauseClockRef = (0, $1oC0p.useRef)({
        totalPausedMs: 0,
        segmentStartMs: null
    });
    const lastNodesKeyRef = (0, $1oC0p.useRef)("");
    (0, $1oC0p.useEffect)(()=>{
        if (drive !== "time" || !active || !hasPhases) return;
        const applyLayouts = (elapsedSec)=>{
            const m = new Map();
            const scrollPctFromTime = maxDurationSec > 0 ? Math.min(100, elapsedSec / maxDurationSec * 100) : 0;
            for (const n of nodes){
                const phases = n.animationPhases;
                const layout = (0, $fVNxT.animationPhasesUseScrollWindows)(phases) && phases?.length ? (0, $fVNxT.getLayoutAtScrollWindows)(n, n.x, n.y, n.opacity ?? 1, phases, scrollPctFromTime) : $bb5461f936702316$export$e7b17d4d0ffa305d(n, n.x, n.y, n.opacity ?? 1, phases, elapsedSec);
                m.set(n.id, layout);
            }
            setLiveMap(m);
        };
        if (maxDurationSec <= 0) {
            applyLayouts(0);
            return;
        }
        const nodesKey = nodes.map((n)=>n.id).join("|");
        if (lastNodesKeyRef.current !== nodesKey) {
            lastNodesKeyRef.current = nodesKey;
            timelineStartMsRef.current = null;
            pauseClockRef.current = {
                totalPausedMs: 0,
                segmentStartMs: null
            };
        }
        if (timelineStartMsRef.current === null) timelineStartMsRef.current = performance.now();
        const start = timelineStartMsRef.current;
        let frame = 0;
        const offset = Math.max(0, phaseClockStartOffsetSec);
        const tick = ()=>{
            const pc = pauseClockRef.current;
            if (pausedRef.current) {
                if (pc.segmentStartMs === null) pc.segmentStartMs = performance.now();
            } else if (pc.segmentStartMs !== null) {
                pc.totalPausedMs += performance.now() - pc.segmentStartMs;
                pc.segmentStartMs = null;
            }
            let extraPauseMs = pc.totalPausedMs;
            if (pausedRef.current && pc.segmentStartMs !== null) extraPauseMs += performance.now() - pc.segmentStartMs;
            const wallSec = (performance.now() - start - extraPauseMs) / 1000;
            const phaseSec = Math.max(0, wallSec - offset);
            applyLayouts(phaseSec);
            const done = phaseSec >= maxDurationSec + 0.016;
            if (done) return;
            if (pausedRef.current) return;
            frame = requestAnimationFrame(tick);
        };
        frame = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(frame);
    }, [
        drive,
        active,
        hasPhases,
        maxDurationSec,
        nodes,
        phaseClockStartOffsetSec,
        animationsPaused
    ]);
    if (!active || !hasPhases) return baseMap;
    if (drive === "scroll") return scrollDerivedMap;
    return liveMap;
}

});
parcelRegister("fVNxT", function(module, exports) {
$parcel$export(module.exports, "assertConsistentScrollWindows", function () { return $33c93afd8b1ce3e2$export$b59b19c04e0cd254; });
$parcel$export(module.exports, "animationPhasesUseScrollWindows", function () { return $33c93afd8b1ce3e2$export$bdca61665be3badc; });
$parcel$export(module.exports, "getLayoutAtScrollWindows", function () { return $33c93afd8b1ce3e2$export$11bc621456d0053f; });

var $hNner = parcelRequire("hNner");
function $33c93afd8b1ce3e2$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $33c93afd8b1ce3e2$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
function $33c93afd8b1ce3e2$var$clampMinSize(v) {
    return Math.max(1, v);
}
function $33c93afd8b1ce3e2$var$dimsForSize(node, sz) {
    return (0, $hNner.getNodeLayoutDimensions)({
        ...node,
        size: sz
    });
}
function $33c93afd8b1ce3e2$export$b59b19c04e0cd254(nodeId, phases) {
    if (!phases?.length) return;
    const anyMarked = phases.some((p)=>p.scrollWindowStart !== undefined || p.scrollWindowEnd !== undefined);
    if (!anyMarked) return;
    if (!$33c93afd8b1ce3e2$export$bdca61665be3badc(phases)) throw new Error(`SpiderWeb node "${nodeId}": set scrollWindowStart and scrollWindowEnd on every phase, or on none.`);
}
function $33c93afd8b1ce3e2$export$bdca61665be3badc(phases) {
    if (!phases?.length) return false;
    return phases.every((p)=>p.scrollWindowStart !== undefined && p.scrollWindowEnd !== undefined);
}
function $33c93afd8b1ce3e2$export$a83e3b3235ff3c93(scrollWindowStart, scrollWindowEnd, target) {
    return {
        delay: 0,
        duration: 0,
        scrollWindowStart: scrollWindowStart,
        scrollWindowEnd: scrollWindowEnd,
        ...target.x !== undefined ? {
            x: target.x
        } : {},
        ...target.y !== undefined ? {
            y: target.y
        } : {},
        ...target.opacity !== undefined ? {
            opacity: target.opacity
        } : {},
        ...target.size !== undefined ? {
            size: target.size
        } : {},
        ...target.width !== undefined ? {
            width: target.width
        } : {},
        ...target.height !== undefined ? {
            height: target.height
        } : {}
    };
}
function $33c93afd8b1ce3e2$export$11bc621456d0053f(node, baseX, baseY, baseOpacity, phases, scrollPercent100) {
    const o0 = $33c93afd8b1ce3e2$var$clamp01(baseOpacity);
    const bases = (0, $hNner.getNodeLayoutDimensions)(node);
    let x = baseX;
    let y = baseY;
    let opacity = o0;
    let sz = bases.size;
    let bw = bases.boxWidth;
    let bh = bases.boxHeight;
    const sorted = [
        ...phases
    ].sort((a, b)=>(a.scrollWindowStart ?? 0) - (b.scrollWindowStart ?? 0));
    for (const p of sorted){
        const ws = p.scrollWindowStart ?? 0;
        const we = p.scrollWindowEnd ?? 0;
        if (we <= ws) continue;
        if (scrollPercent100 < ws) return {
            x: x,
            y: y,
            opacity: opacity,
            size: sz,
            width: bw,
            height: bh
        };
        const opacityStart = opacity;
        const opacityEnd = p.opacity !== undefined ? $33c93afd8b1ce3e2$var$clamp01(p.opacity) : opacity;
        const szStart = sz;
        const bwStart = bw;
        const bhStart = bh;
        const szEnd = p.size !== undefined ? $33c93afd8b1ce3e2$var$clampMinSize(p.size) : szStart;
        const bwEnd = p.width !== undefined ? p.width : p.size !== undefined ? $33c93afd8b1ce3e2$var$dimsForSize(node, szEnd).boxWidth : bwStart;
        const bhEnd = p.height !== undefined ? p.height : p.size !== undefined ? $33c93afd8b1ce3e2$var$dimsForSize(node, szEnd).boxHeight : bhStart;
        if (scrollPercent100 < we) {
            const span = we - ws;
            const u = span > 0 ? (scrollPercent100 - ws) / span : 1;
            const e = $33c93afd8b1ce3e2$var$easeInOutCubic(Math.min(1, Math.max(0, u)));
            const szMid = szStart + (szEnd - szStart) * e;
            const opacityMid = opacityStart + (opacityEnd - opacityStart) * e;
            const xEnd = p.x !== undefined ? p.x : x;
            const yEnd = p.y !== undefined ? p.y : y;
            let bwMid;
            if (p.width !== undefined) bwMid = bwStart + (bwEnd - bwStart) * e;
            else if (p.size !== undefined) bwMid = $33c93afd8b1ce3e2$var$dimsForSize(node, szMid).boxWidth;
            else bwMid = bwStart;
            let bhMid;
            if (p.height !== undefined) bhMid = bhStart + (bhEnd - bhStart) * e;
            else if (p.size !== undefined) bhMid = $33c93afd8b1ce3e2$var$dimsForSize(node, szMid).boxHeight;
            else bhMid = bhStart;
            return {
                x: x + (xEnd - x) * e,
                y: y + (yEnd - y) * e,
                opacity: opacityMid,
                size: szMid,
                width: bwMid,
                height: bhMid
            };
        }
        x = p.x !== undefined ? p.x : x;
        y = p.y !== undefined ? p.y : y;
        opacity = opacityEnd;
        sz = szEnd;
        bw = bwEnd;
        bh = bhEnd;
    }
    return {
        x: x,
        y: y,
        opacity: opacity,
        size: sz,
        width: bw,
        height: bh
    };
}

});

parcelRegister("8uyM5", function(module, exports) {
$parcel$export(module.exports, "ANIMATION_PHASES_SCROLL_TIMELINE_UNITS_DEFAULT", function () { return $c8cbf9fc738b688c$export$c4b0c59bc522bccc; });
const $c8cbf9fc738b688c$export$e787a4c2b0ebce40 = [
    "lime100",
    "lime200",
    "lime300",
    "lime400",
    "lime500",
    "lime600",
    "lime700",
    "lime800",
    "lime900",
    "purple100",
    "purple200",
    "purple300",
    "purple400",
    "purple500",
    "purple600",
    "purple700",
    "purple800",
    "purple900",
    "blue100",
    "blue200",
    "blue300",
    "blue400",
    "blue500",
    "blue600",
    "blue700",
    "blue800",
    "blue900",
    "yellow100",
    "yellow200",
    "yellow300",
    "yellow400",
    "yellow500",
    "yellow600",
    "yellow700",
    "yellow800",
    "yellow900",
    "neutral100",
    "neutral200",
    "neutral300",
    "neutral400",
    "neutral500",
    "neutral600",
    "neutral700",
    "neutral800",
    "neutral900",
    "orange100",
    "orange200",
    "orange300",
    "orange400",
    "orange500",
    "orange600",
    "orange700",
    "orange800",
    "orange900",
    "saffron100",
    "saffron200",
    "saffron300",
    "saffron400",
    "saffron500",
    "saffron600",
    "saffron700",
    "saffron800",
    "saffron900",
    "white",
    "black",
    "secondarynavy",
    "secondarygreen",
    "secondaryred",
    "transparent"
];
const $c8cbf9fc738b688c$export$c4b0c59bc522bccc = 100;

});


parcelRegister("29NYv", function(module, exports) {
$parcel$export(module.exports, "useSpiderWebReducedMotion", function () { return $ff75bf1daecde24a$export$6bfdea9e4d732151; });

var $1oC0p = parcelRequire("1oC0p");
function $ff75bf1daecde24a$export$6bfdea9e4d732151() {
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
        setPrefersReducedMotion(mq.matches);
        const handler = (e)=>setPrefersReducedMotion(e.matches);
        mq.addEventListener("change", handler);
        return ()=>mq.removeEventListener("change", handler);
    }, []);
    return prefersReducedMotion;
}

});

parcelRegister("hiPUj", function(module, exports) {
$parcel$export(module.exports, "useSpiderwebScrollMagnet", function () { return $b2d50ed954fc873c$export$c86862ef68734dc4; });

var $1oC0p = parcelRequire("1oC0p");

var $7h9Nf = parcelRequire("7h9Nf");
function $b2d50ed954fc873c$var$clamp01(v) {
    return Math.min(1, Math.max(0, v));
}
function $b2d50ed954fc873c$export$bd5ac7dcb10bc8e2(raw) {
    if (!raw?.length) return [];
    const roundedKeys = new Set();
    const out = [];
    for (const x of raw){
        if (!Number.isFinite(x)) continue;
        const pct = Math.min(100, Math.max(0, x));
        const c = $b2d50ed954fc873c$var$clamp01(pct / 100);
        const key = Math.round(c * 1e5);
        if (roundedKeys.has(key)) continue;
        roundedKeys.add(key);
        out.push(c);
    }
    out.sort((a, b)=>a - b);
    return out;
}
function $b2d50ed954fc873c$export$ebd5525c2b6f70e(progress, anchors) {
    if (anchors.length === 0) return null;
    const p = $b2d50ed954fc873c$var$clamp01(progress);
    const firstAtOrAhead = anchors.find((a)=>a >= p);
    if (firstAtOrAhead !== undefined) return firstAtOrAhead;
    const tail = anchors.at(-1);
    return tail === undefined ? null : tail;
}
function $b2d50ed954fc873c$var$pickNearestByMetric(values, metric) {
    const first = values[0];
    if (first === undefined) return undefined;
    let best = first;
    let bestM = metric(best);
    for(let i = 1; i < values.length; i++){
        const v = values[i];
        if (v === undefined) continue;
        const m = metric(v);
        if (m < bestM) {
            bestM = m;
            best = v;
        }
    }
    return best;
}
function $b2d50ed954fc873c$export$262742de863515b3(progress, anchors, lastScrollDeltaPx, scrollDeadbandPx, directionBias) {
    if (anchors.length === 0) return null;
    const p = $b2d50ed954fc873c$var$clamp01(progress);
    const dead = scrollDeadbandPx;
    const ahead = anchors.filter((a)=>a > p);
    const behind = anchors.filter((a)=>a < p);
    if (lastScrollDeltaPx > dead) {
        const pick = $b2d50ed954fc873c$var$pickNearestByMetric(ahead, (a)=>a - p);
        if (pick !== undefined) return pick;
        const tail = anchors.at(-1);
        return tail === undefined ? null : tail;
    }
    if (lastScrollDeltaPx < -dead) {
        const pick = $b2d50ed954fc873c$var$pickNearestByMetric(behind, (a)=>p - a);
        if (pick !== undefined) return pick;
        return anchors[0] ?? null;
    }
    const normalizedDirectionBias = $b2d50ed954fc873c$var$clamp01(directionBias);
    const oppositeDirectionPenalty = 1 + normalizedDirectionBias * 8;
    const pick = $b2d50ed954fc873c$var$pickNearestByMetric(anchors, (a)=>{
        const delta = a - p;
        const absDelta = Math.abs(delta);
        if (lastScrollDeltaPx > 0 && delta < 0) return absDelta * oppositeDirectionPenalty;
        if (lastScrollDeltaPx < 0 && delta > 0) return absDelta * oppositeDirectionPenalty;
        return absDelta;
    });
    return pick === undefined ? null : pick;
}
function $b2d50ed954fc873c$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $b2d50ed954fc873c$var$getScrollMagnetEndpoints(section, scrollContainer, progress) {
    const p = $b2d50ed954fc873c$var$clamp01(progress);
    if (scrollContainer) {
        const maxScroll = Math.max(0, scrollContainer.scrollHeight - scrollContainer.clientHeight);
        if (maxScroll <= 1) return null;
        return {
            mode: "element",
            el: scrollContainer,
            startTop: scrollContainer.scrollTop,
            endTop: p * maxScroll
        };
    }
    const trackH = section.offsetHeight;
    const viewH = window.innerHeight;
    const scrollable = trackH - viewH;
    if (scrollable <= 1) return null;
    const rect = section.getBoundingClientRect();
    const endY = window.scrollY + rect.top + p * scrollable;
    return {
        mode: "window",
        startY: window.scrollY,
        endY: Math.max(0, endY)
    };
}
function $b2d50ed954fc873c$var$runScrollMagnetEase(endpoints, durationMs, isCancelled, onRafScheduled, onRafCleared) {
    const startTime = performance.now();
    const step = ()=>{
        if (isCancelled()) {
            onRafCleared();
            return;
        }
        const now = performance.now();
        const t = Math.min(1, (now - startTime) / durationMs);
        const e = $b2d50ed954fc873c$var$easeInOutCubic(t);
        if (endpoints.mode === "window") {
            const y = endpoints.startY + (endpoints.endY - endpoints.startY) * e;
            window.scrollTo(0, y);
        } else {
            const top = endpoints.startTop + (endpoints.endTop - endpoints.startTop) * e;
            endpoints.el.scrollTop = top;
        }
        if (t < 1) onRafScheduled(requestAnimationFrame(step));
        else onRafCleared();
    };
    onRafScheduled(requestAnimationFrame(step));
}
const $b2d50ed954fc873c$var$DEFAULT_MIN_DELTA = 0.004;
/** No `scroll` events for this long before we consider a settle (ms). */ const $b2d50ed954fc873c$var$DEFAULT_SETTLE_MS = 200;
const $b2d50ed954fc873c$var$DEFAULT_SUPPRESS_MS = 380;
/** Eased magnet scroll; a bit longer than typical native `smooth` scrolling. */ const $b2d50ed954fc873c$var$DEFAULT_MAGNET_DURATION_MS = 2000;
const $b2d50ed954fc873c$var$DEFAULT_DIRECTION_DEADBAND_PX = 2;
const $b2d50ed954fc873c$var$DEFAULT_DIRECTION_BIAS = 0;
function $b2d50ed954fc873c$export$c86862ef68734dc4(sectionRef, { enabled: enabled, anchors: anchors, minProgressDelta: minProgressDelta = $b2d50ed954fc873c$var$DEFAULT_MIN_DELTA, settleDebounceMs: settleDebounceMs = $b2d50ed954fc873c$var$DEFAULT_SETTLE_MS, suppressSettleMs: suppressSettleMs = $b2d50ed954fc873c$var$DEFAULT_SUPPRESS_MS, scrollMagnetDurationMs: scrollMagnetDurationMs = $b2d50ed954fc873c$var$DEFAULT_MAGNET_DURATION_MS, scrollMagnetDirectionDeadbandPx: scrollMagnetDirectionDeadbandPx = $b2d50ed954fc873c$var$DEFAULT_DIRECTION_DEADBAND_PX, scrollMagnetDirectionBias: scrollMagnetDirectionBias = $b2d50ed954fc873c$var$DEFAULT_DIRECTION_BIAS }) {
    const anchorsKey = (0, $1oC0p.useMemo)(()=>anchors === undefined || anchors.length === 0 ? "" : anchors.map((a)=>Number(a).toFixed(5)).join("|"), [
        anchors
    ]);
    const normalizedAnchors = (0, $1oC0p.useMemo)(()=>{
        if (anchorsKey === "") return [];
        const parsed = anchorsKey.split("|").map((s)=>Number(s));
        return $b2d50ed954fc873c$export$bd5ac7dcb10bc8e2(parsed);
    }, [
        anchorsKey
    ]);
    const minDeltaRef = (0, $1oC0p.useRef)(minProgressDelta);
    const settleMsRef = (0, $1oC0p.useRef)(settleDebounceMs);
    const suppressMsRef = (0, $1oC0p.useRef)(suppressSettleMs);
    const durationMsRef = (0, $1oC0p.useRef)(scrollMagnetDurationMs);
    const directionDeadbandPxRef = (0, $1oC0p.useRef)(scrollMagnetDirectionDeadbandPx);
    const directionBiasRef = (0, $1oC0p.useRef)(scrollMagnetDirectionBias);
    minDeltaRef.current = minProgressDelta;
    settleMsRef.current = settleDebounceMs;
    suppressMsRef.current = suppressSettleMs;
    durationMsRef.current = scrollMagnetDurationMs;
    directionDeadbandPxRef.current = scrollMagnetDirectionDeadbandPx;
    directionBiasRef.current = scrollMagnetDirectionBias;
    (0, $1oC0p.useEffect)(()=>{
        if (!enabled || !sectionRef || normalizedAnchors.length === 0 || minProgressDelta <= 0) return;
        let cancelled = false;
        let pollRafId = 0;
        let detach;
        let settleTimerId = 0;
        let suppressUntil = 0;
        let settleVerifyRafId = 0;
        const attach = (section)=>{
            const scrollContainer = (0, $7h9Nf.getNearestVerticalScrollContainer)(section);
            let magnetAnimRaf = 0;
            let lastScrollYForIntent = scrollContainer ? scrollContainer.scrollTop : window.scrollY;
            let lastIntentScrollDeltaPx = 0;
            const getScrollY = ()=>scrollContainer ? scrollContainer.scrollTop : window.scrollY;
            const clearMagnetAnim = ()=>{
                if (magnetAnimRaf !== 0) {
                    cancelAnimationFrame(magnetAnimRaf);
                    magnetAnimRaf = 0;
                }
            };
            const tryMagnet = ()=>{
                if (cancelled || performance.now() < suppressUntil) return;
                const p = (0, $7h9Nf.computeDocumentSectionScrollProgress)(section, scrollContainer);
                const minD = minDeltaRef.current;
                for (const a of normalizedAnchors){
                    if (Math.abs(a - p) < minD) return;
                }
                const target = $b2d50ed954fc873c$export$262742de863515b3(p, normalizedAnchors, lastIntentScrollDeltaPx, directionDeadbandPxRef.current, directionBiasRef.current);
                if (target === null) return;
                const endpoints = $b2d50ed954fc873c$var$getScrollMagnetEndpoints(section, scrollContainer, target);
                if (!endpoints) return;
                const durationMs = Math.max(120, durationMsRef.current);
                const startPx = endpoints.mode === "window" ? endpoints.startY : endpoints.startTop;
                const endPx = endpoints.mode === "window" ? endpoints.endY : endpoints.endTop;
                if (Math.abs(endPx - startPx) < 0.5) return;
                clearMagnetAnim();
                suppressUntil = performance.now() + durationMs + Math.max(120, suppressMsRef.current);
                $b2d50ed954fc873c$var$runScrollMagnetEase(endpoints, durationMs, ()=>cancelled, (id)=>{
                    magnetAnimRaf = id;
                }, ()=>{
                    magnetAnimRaf = 0;
                });
            };
            const scheduleSettle = ()=>{
                if (cancelled) return;
                if (settleVerifyRafId !== 0) {
                    cancelAnimationFrame(settleVerifyRafId);
                    settleVerifyRafId = 0;
                }
                if (performance.now() < suppressUntil) {
                    window.clearTimeout(settleTimerId);
                    settleTimerId = 0;
                    return;
                }
                window.clearTimeout(settleTimerId);
                settleTimerId = window.setTimeout(()=>{
                    settleTimerId = 0;
                    const yIdle = getScrollY();
                    settleVerifyRafId = requestAnimationFrame(()=>{
                        settleVerifyRafId = 0;
                        if (cancelled || performance.now() < suppressUntil) return;
                        if (Math.abs(getScrollY() - yIdle) > 0.5) return;
                        tryMagnet();
                    });
                }, settleMsRef.current);
            };
            const onScroll = ()=>{
                const y = getScrollY();
                if (performance.now() < suppressUntil) lastScrollYForIntent = y;
                else {
                    const delta = y - lastScrollYForIntent;
                    lastScrollYForIntent = y;
                    const db = directionDeadbandPxRef.current;
                    if (Math.abs(delta) >= db) lastIntentScrollDeltaPx = delta;
                }
                scheduleSettle();
            };
            const scrollTarget = scrollContainer ?? window;
            scrollTarget.addEventListener("scroll", onScroll, {
                passive: true
            });
            detach = ()=>{
                window.clearTimeout(settleTimerId);
                settleTimerId = 0;
                if (settleVerifyRafId !== 0) {
                    cancelAnimationFrame(settleVerifyRafId);
                    settleVerifyRafId = 0;
                }
                clearMagnetAnim();
                scrollTarget.removeEventListener("scroll", onScroll);
            };
        };
        const el = sectionRef.current;
        if (el) {
            attach(el);
            return ()=>{
                cancelled = true;
                detach?.();
            };
        }
        const poll = ()=>{
            if (cancelled) return;
            const node = sectionRef.current;
            if (node) {
                attach(node);
                return;
            }
            pollRafId = requestAnimationFrame(poll);
        };
        pollRafId = requestAnimationFrame(poll);
        return ()=>{
            cancelled = true;
            cancelAnimationFrame(pollRafId);
            detach?.();
        };
    }, [
        enabled,
        normalizedAnchors,
        sectionRef
    ]);
}

});

parcelRegister("gHYtp", function(module, exports) {
$parcel$export(module.exports, "useSpiderwebViewportAspect", function () { return $fd0a2876732bc244$export$a8bf72a0ed443cbd; });

var $1oC0p = parcelRequire("1oC0p");
const $fd0a2876732bc244$var$IDENTITY = {
    scaleX: 1,
    scaleY: 1
};
function $fd0a2876732bc244$var$computeCorrection(w, h) {
    if (w <= 0 || h <= 0) return $fd0a2876732bc244$var$IDENTITY;
    return {
        scaleX: Math.sqrt(h / w),
        scaleY: Math.sqrt(w / h)
    };
}
function $fd0a2876732bc244$export$a8bf72a0ed443cbd(active, sizeSourceRef) {
    const [dims, setDims] = (0, $1oC0p.useState)(()=>typeof window !== "undefined" ? {
            w: window.innerWidth,
            h: window.innerHeight
        } : {
            w: 1,
            h: 1
        });
    (0, $1oC0p.useEffect)(()=>{
        if (!active) return;
        if (!sizeSourceRef) {
            const update = ()=>setDims({
                    w: window.innerWidth,
                    h: window.innerHeight
                });
            update();
            window.addEventListener("resize", update);
            return ()=>window.removeEventListener("resize", update);
        }
        const measure = ()=>{
            const el = sizeSourceRef.current;
            if (!el) return;
            const w = el.clientWidth;
            const h = el.clientHeight;
            setDims((prev)=>prev.w === w && prev.h === h ? prev : {
                    w: w,
                    h: h
                });
        };
        const el = sizeSourceRef.current;
        if (!el) return;
        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        return ()=>{
            ro.disconnect();
        };
    }, [
        active,
        sizeSourceRef
    ]);
    return (0, $1oC0p.useMemo)(()=>active ? $fd0a2876732bc244$var$computeCorrection(dims.w, dims.h) : $fd0a2876732bc244$var$IDENTITY, [
        active,
        dims.w,
        dims.h
    ]);
}

});


parcelRegister("fk4mX", function(module, exports) {
$parcel$export(module.exports, "teamworkGraphAllFramesConnectors", function () { return $f9897010521bbd9d$export$756326ff129c0dcc; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsA", function () { return $f9897010521bbd9d$export$b965507d386cb99d; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsB", function () { return $f9897010521bbd9d$export$dd9213ac7d5a9d04; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsC", function () { return $f9897010521bbd9d$export$621ed6415af9863e; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsD", function () { return $f9897010521bbd9d$export$74d164615ea757fb; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsE", function () { return $f9897010521bbd9d$export$a2089f34a89c6aea; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsF", function () { return $f9897010521bbd9d$export$c30288e07ec1214e; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsH", function () { return $f9897010521bbd9d$export$b558969562a813f5; });
$parcel$export(module.exports, "teamworkGraphMobileConnectorsI", function () { return $f9897010521bbd9d$export$f08b61eee7038f83; });
const $f9897010521bbd9d$export$756326ff129c0dcc = [
    {
        from: "frame-1-pill-project",
        to: "frame-1-avatar-blue",
        connectorType: "dashed",
        color: "blue600"
    },
    {
        from: "frame-1-pill-project",
        to: "frame-1-icon-circle-arrow",
        color: "blue600"
    },
    {
        from: "frame-1-icon-jira",
        to: "frame-1-icon-circle-arrow",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-figma",
        to: "frame-1-icon-circle-arrow",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "blue500"
    },
    {
        from: "frame-1-avatar-blue",
        to: "frame-1-agent-left",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "blue500"
    },
    {
        from: "frame-1-agent-left",
        to: "frame-1-loom-to-shrink",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "blue500"
    },
    {
        from: "frame-1-microsoft-teams-to-shrink",
        to: "frame-1-agent-right",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "blue500"
    },
    {
        from: "frame-1-agent-right",
        to: "frame-1-loom-to-shrink",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "blue500"
    },
    {
        from: "frame-1-avatar-blue",
        to: "frame-1-icon-squiggle",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "blue600"
    },
    {
        from: "frame-1-avatar-blue",
        to: "frame-1-icon-chat",
        connectorShape: "arced",
        connectorType: "dashed",
        color: "blue600"
    },
    {
        from: "frame-1-avatar-blue",
        to: "frame-1-icon-figma",
        connectorType: "dashed",
        color: "blue600"
    },
    {
        from: "frame-1-icon-figma",
        to: "frame-1-icon-people-team",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-chat",
        to: "frame-1-icon-trello",
        connectorShape: "arced",
        color: "blue600"
    },
    {
        from: "frame-1-icon-sharepoint",
        to: "frame-1-pill-focus-area",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-star-talent",
        to: "frame-1-pill-focus-area",
        color: "yellow500"
    },
    {
        from: "frame-1-avatar-green",
        to: "frame-1-icon-bitbucket",
        connectorType: "dashed",
        color: "lime500"
    },
    {
        from: "frame-1-pill-roadmap",
        to: "frame-1-icon-lightbulb",
        connectorShape: "arced",
        connectorType: "dashed",
        connectorBias: "negative",
        color: "purple500"
    },
    {
        from: "frame-1-icon-bookmark",
        to: "frame-1-icon-lightbulb",
        color: "purple500"
    },
    {
        from: "frame-1-icon-bookmark",
        to: "frame-1-icon-target",
        color: "purple500"
    },
    {
        from: "frame-1-icon-jpd",
        to: "frame-1-icon-lightbulb",
        connectorShape: "curvy",
        connectorBias: "negative",
        color: "purple500"
    },
    {
        from: "frame-1-avatar-purple",
        to: "frame-1-icon-lightbulb",
        connectorType: "dashed",
        color: "purple500"
    },
    {
        from: "frame-1-avatar-purple",
        to: "frame-1-icon-target",
        connectorShape: "arced",
        connectorType: "dashed",
        connectorBias: "negative",
        color: "purple500"
    },
    {
        from: "frame-1-icon-lightning-bolt",
        to: "frame-1-icon-target",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-sharepoint",
        to: "frame-1-icon-target",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-video",
        to: "frame-1-icon-bookmark",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-lightning-bolt",
        to: "frame-1-icon-bookmark",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "neutral500"
    },
    {
        from: "frame-1-avatar-yellow",
        to: "frame-1-icon-lightning-bolt",
        connectorType: "dashed",
        color: "yellow300"
    },
    {
        from: "frame-1-avatar-yellow",
        to: "frame-1-icon-bell",
        connectorShape: "arced",
        connectorType: "dashed",
        connectorBias: "negative",
        color: "yellow300"
    },
    {
        from: "frame-1-avatar-yellow",
        to: "frame-1-icon-jsm",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "yellow300"
    },
    {
        from: "frame-1-icon-sharepoint",
        to: "frame-1-icon-star-talent",
        color: "yellow500"
    },
    {
        from: "frame-1-avatar-orange",
        to: "frame-1-icon-star-talent",
        connectorShape: "arced",
        connectorType: "dashed",
        color: "yellow500"
    },
    {
        from: "frame-1-icon-dollar",
        to: "frame-1-avatar-orange",
        connectorShape: "arced",
        connectorType: "dashed",
        color: "yellow500"
    },
    {
        from: "frame-1-avatar-blue",
        to: "frame-1-agent-top",
        connectorType: "dashed",
        color: "blue600"
    },
    {
        from: "frame-1-agent-top",
        to: "frame-1-microsoft-teams-to-shrink",
        connectorType: "dashed",
        color: "blue600"
    },
    {
        from: "frame-1-icon-brackets",
        to: "frame-1-icon-behind-microsoft-teams",
        color: "lime500"
    },
    {
        from: "frame-1-icon-bitbucket",
        to: "frame-1-icon-rocket",
        color: "lime500"
    },
    {
        from: "frame-1-icon-lightning-bolt",
        to: "frame-1-icon-rocket",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-bookmark",
        to: "frame-1-pill-roadmap",
        color: "purple500"
    },
    {
        from: "frame-1-pill-work-item",
        to: "frame-1-icon-bitbucket",
        connectorShape: "curvy",
        connectorBias: "positive",
        color: "lime500"
    },
    {
        from: "frame-1-icon-lightning-bolt",
        to: "frame-1-icon-csm",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-lightning-bolt",
        to: "frame-1-icon-video",
        color: "neutral500",
        connectorShape: "arced",
        connectorBias: "negative"
    },
    {
        from: "frame-1-pill-roadmap",
        to: "frame-1-icon-video",
        color: "neutral500",
        connectorShape: "arced",
        connectorBias: "positive"
    },
    {
        from: "frame-1-icon-brackets",
        to: "frame-1-pill-work-item",
        color: "lime500"
    },
    {
        from: "frame-1-icon-behind-microsoft-teams",
        to: "frame-1-avatar-green",
        connectorShape: "arced",
        connectorType: "dashed",
        connectorBias: "negative",
        color: "lime500"
    },
    {
        from: "frame-1-icon-csm",
        to: "frame-1-avatar-yellow",
        connectorShape: "arced",
        color: "neutral500"
    },
    {
        from: "frame-1-icon-sharepoint",
        to: "frame-1-avatar-orange",
        connectorShape: "arced",
        connectorBias: "negative",
        connectorType: "dashed",
        color: "yellow500"
    },
    {
        from: "frame-1-icon-sharepoint",
        to: "frame-1-icon-dollar",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "yellow500"
    },
    {
        from: "frame-1-icon-jsm",
        to: "frame-1-icon-gdrive",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "yellow300"
    },
    {
        from: "frame-1-icon-microsoft",
        to: "frame-1-icon-dollar",
        color: "yellow500"
    },
    {
        from: "frame-1-icon-microsoft",
        to: "frame-1-icon-jpd",
        color: "purple500"
    },
    {
        from: "frame-1-microsoft-teams-to-shrink",
        to: "frame-1-chip-video-tr",
        color: "blue500"
    },
    {
        from: "frame-1-prompt-box",
        to: "frame-1-and-2-bridge",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true,
        color: "blue300"
    },
    {
        from: "frame-1-chip-team-r",
        to: "frame-1-chip-video-tr",
        connectorShape: "straight",
        color: "blue500"
    },
    /* frame 2 */ {
        to: "frame-2-dot-left",
        from: "frame-2-icon-confluence",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "frame-2-icon-confluence",
        to: "frame-2-dot-top",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "frame-2-icon-confluence",
        to: "frame-2-icon-hubspot",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "frame-2-icon-hubspot",
        to: "frame-2-icon-figma",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        from: "frame-2-icon-figma",
        to: "frame-2-dot-top-right",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    /* frame 3 */ {
        from: "frame-2-icon-confluence",
        to: "frame-3-icon-gdrive",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        from: "frame-3-icon-gdrive",
        to: "frame-3-icon-cursor",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "frame-3-icon-cursor",
        to: "frame-3-dot-bottom",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        to: "frame-3-dot-left",
        from: "frame-3-icon-gdrive",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        to: "frame-3-and-5-icon-jira",
        from: "frame-3-icon-gdrive",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        from: "frame-3-and-5-icon-jira",
        to: "frame-3-and-5-dot-right-bottom",
        connectorShape: "curvy",
        isAnimated: true,
        connectorBias: "positive"
    },
    /* bridge from frame 3 to frame 4 */ {
        to: "frame-3-and-5-icon-jira",
        from: "frame-4-icon-loom",
        connectorShape: "curvy",
        isAnimated: true,
        connectorBias: "positive"
    },
    /* frame 4 */ {
        from: "frame-4-dot-top",
        to: "frame-4-icon-canva",
        isAnimated: true
    },
    {
        from: "frame-4-dot-right",
        to: "frame-4-icon-sharepoint",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        from: "frame-4-icon-canva",
        to: "frame-4-icon-loom",
        isAnimated: true
    },
    {
        from: "frame-4-icon-sharepoint",
        to: "frame-4-icon-loom",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    /* bridge from frame 5 to frame 6 */ {
        from: "frame-5-behind-figma",
        to: "frame-6-behind-rectangle-assets",
        connectorShape: "curvy",
        connectorBias: "negative"
    },
    {
        from: "behind-frame-3-and-5-dot-1",
        to: "behind-frame-3-and-5-dot-2",
        connectorShape: "curvy",
        isAnimated: true,
        connectorBias: "negative"
    },
    /* frame 6 */ {
        to: "frame-6-dot-offscreen-bottom-left",
        from: "frame-6-behind-comment",
        connectorShape: "arced",
        connectorBias: "positive"
    },
    {
        to: "frame-6-icon-figma",
        from: "frame-6-rectangle-comment",
        connectorShape: "arced",
        connectorBias: "negative"
    },
    {
        to: "frame-6-rectangle-avatars",
        from: "frame-6-behind-in-progress-top",
        connectorShape: "curvy",
        connectorBias: "negative"
    },
    {
        to: "frame-6-icon-figma",
        from: "frame-6-behind-done-bottom",
        connectorShape: "arced",
        isAnimated: true,
        connectorBias: "positive"
    },
    {
        from: "frame-6-behind-assets-bottom",
        to: "frame-6-behind-from-assets-to-avatar",
        color: "blue500",
        connectorShape: "curvy",
        connectorBias: "negative"
    },
    {
        from: "frame-6-behind-assets-top",
        to: "frame-6-behind-from-assets-to-avatars-rectangle",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "frame-6-behind-comment",
        to: "frame-6-behind-from-comment-to-avatar",
        connectorShape: "arced",
        color: "blue500",
        connectorBias: "positive"
    },
    {
        to: "frame-6-behind-in-progress-bottom",
        from: "frame-6-behind-from-in-progress-to-avatar",
        color: "blue500",
        connectorShape: "arced",
        connectorBias: "positive"
    },
    {
        from: "frame-6-behind-done-top",
        to: "frame-6-behind-from-done-to-avatar",
        color: "blue500",
        connectorShape: "curvy",
        connectorBias: "positive"
    },
    /* frame 7 connectors */ {
        to: "final-screen-behind-avatar-blue-to-jpd",
        from: "final-screen-avatar-blue",
        color: "neutral500"
    },
    {
        to: "final-screen-behind-squiggle-to-idea",
        from: "final-screen-icon-squiggle",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-bookmark",
        to: "frame-7-icon-purple-jpd",
        color: "neutral500"
    },
    {
        from: "frame-7-avatar-purple",
        to: "frame-7-icon-purple-jpd",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "neutral500"
    },
    {
        from: "frame-7-pill-campaign",
        to: "frame-7-avatar-purple",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "neutral500"
    },
    {
        from: "frame-7-pill-campaign",
        to: "frame-7-icon-hubspot",
        connectorShape: "arced",
        connectorBias: "negative"
    },
    {
        from: "frame-7-pill-campaign",
        to: "frame-7-dot-x-30-y-0",
        connectorShape: "arced",
        color: "blue600",
        connectorBias: "negative"
    },
    {
        from: "frame-7-avatar-purple",
        to: "frame-7-pill-idea",
        color: "neutral500"
    },
    {
        from: "frame-7-behind-loom",
        to: "frame-7-icon-csm",
        color: "blue300"
    },
    {
        from: "frame-7-icon-behind-confluence",
        to: "frame-7-icon-csm",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-bell",
        to: "frame-7-avatar-lime-bottom",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-rocket",
        to: "frame-7-icon-bell",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-rocket",
        to: "frame-7-icon-csm",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "yellow400"
    },
    {
        from: "frame-7-avatar-yellow",
        to: "frame-7-icon-csm",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "yellow400"
    },
    {
        from: "frame-7-avatar-yellow",
        to: "frame-7-icon-jsm",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-csm",
        to: "frame-7-icon-jsm",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-bell",
        to: "frame-7-icon-jsm",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-bitbucket",
        to: "frame-7-avatar-saffron",
        connectorBias: "negative",
        connectorShape: "arced",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-bell",
        to: "frame-7-avatar-saffron",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "blue600"
    },
    {
        from: "frame-7-avatar-saffron",
        to: "frame-7-icon-gdrive",
        color: "blue600"
    },
    {
        from: "frame-7-icon-target",
        to: "frame-7-avatar-saffron",
        color: "blue600"
    },
    {
        from: "frame-7-pill-release",
        to: "frame-7-avatar-lime-bottom",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-gdrive",
        to: "frame-7-avatar-lime-bottom",
        color: "neutral500"
    },
    {
        from: "frame-7-avatar-lime-top",
        to: "frame-7-pill-pr",
        color: "lime500"
    },
    {
        from: "frame-7-avatar-lime-top",
        to: "frame-7-icon-rovo-dev",
        color: "lime500"
    },
    {
        from: "frame-7-avatar-lime-top",
        to: "frame-7-icon-bitbucket",
        color: "lime500"
    },
    {
        from: "frame-7-dot-x-50-y-0",
        to: "frame-7-avatar-orange",
        color: "orange300"
    },
    {
        from: "frame-7-icon-focus-top",
        to: "frame-7-avatar-orange",
        color: "orange300"
    },
    {
        from: "frame-7-icon-focus-top",
        to: "frame-7-dot-x-60-y-0"
    },
    {
        from: "frame-7-icon-focus-top",
        to: "frame-7-dot-x-65-y-0"
    },
    {
        from: "frame-7-icon-jira-top",
        to: "frame-7-avatar-orange",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "orange300"
    },
    {
        from: "frame-7-pill-goal",
        to: "frame-7-avatar-orange",
        connectorShape: "arced",
        connectorBias: "negative",
        color: "orange300"
    },
    {
        from: "frame-7-pill-campaign",
        to: "frame-7-icon-bookmark",
        color: "neutral500"
    },
    {
        from: "frame-7-icon-bookmark",
        to: "frame-7-icon-jira-top",
        connectorShape: "arced",
        color: "neutral500"
    },
    {
        from: "frame-7-avatar-lime-top",
        to: "frame-7-icon-focus-top",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "neutral500"
    },
    {
        from: "frame-7-avatar-lime-top",
        to: "frame-7-dot-x-80-y-0",
        color: "lime500"
    },
    {
        from: "frame-7-icon-behind-confluence",
        to: "frame-7-avatar-yellow",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "yellow400"
    },
    {
        from: "frame-7-icon-jsm",
        to: "frame-7-avatar-lime-bottom",
        connectorShape: "arced",
        color: "neutral500"
    },
    {
        from: "frame-7-dot-x-0-y-90",
        to: "pill-meeting-notes",
        connectorShape: "arced",
        connectorBias: "positive",
        color: "blue600"
    }
];
const $f9897010521bbd9d$export$b965507d386cb99d = [
    {
        from: "mobile-component-A-icon-figma-top",
        to: "mobile-component-A-avatar-blue-top",
        connectorShape: "arced",
        connectorBias: "negative"
    },
    {
        from: "mobile-component-A-hex-wrench-2",
        to: "mobile-component-A-avatar-blue-top"
    },
    {
        from: "mobile-component-A-rectangle-prompt",
        to: "mobile-component-A-avatar-blue-top",
        color: "blue300"
    },
    {
        from: "mobile-component-A-hex-wrench-1",
        to: "mobile-component-A-avatar-blue-top"
    },
    {
        from: "mobile-component-A-hex-wrench-1",
        to: "mobile-component-A-rectangle-project"
    },
    {
        from: "mobile-component-A-icon-microsoft-teams",
        to: "mobile-component-A-rectangle-project"
    },
    {
        from: "mobile-component-A-icon-circle-arrow",
        to: "mobile-component-A-avatar-blue-top",
        connectorShape: "arced",
        connectorBias: "negative"
    },
    {
        from: "mobile-component-A-rectangle-project",
        to: "mobile-component-A-dot-top-left"
    },
    {
        from: "mobile-component-A-hex-wrench-2",
        to: "mobile-component-A-dot-top-right",
        connectorShape: "arced",
        connectorBias: "positive"
    }
];
const $f9897010521bbd9d$export$dd9213ac7d5a9d04 = [
    {
        from: "mobile-component-B-icon-confluence",
        to: "mobile-component-B-dot-top",
        color: "blue300"
    },
    {
        from: "mobile-component-B-icon-confluence",
        to: "mobile-component-B-dot-left-bottom",
        color: "blue300",
        isAnimated: true,
        connectorShape: "arced",
        connectorBias: "negative"
    },
    {
        from: "mobile-component-B-icon-confluence",
        to: "mobile-component-B-icon-figma-bottom",
        color: "blue300",
        isAnimated: true,
        connectorShape: "arced",
        connectorBias: "positive"
    },
    {
        to: "mobile-component-B-dot-right-bottom",
        from: "mobile-component-B-icon-figma-bottom",
        color: "blue300",
        isAnimated: true,
        connectorShape: "arced",
        connectorBias: "positive"
    },
    {
        from: "mobile-component-B-icon-confluence",
        to: "mobile-component-B-rectangle-assets",
        color: "blue300",
        isAnimated: true,
        connectorShape: "curvy",
        connectorBias: "positive",
        animationColor: "blue"
    }
];
const $f9897010521bbd9d$export$621ed6415af9863e = [
    {
        from: "mobile-component-C-dot-top",
        to: "mobile-component-C-icon-figma-bottom",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true,
        animationColor: "blue"
    },
    {
        from: "mobile-component-C-dot-top",
        to: "mobile-component-C-dot-left",
        connectorShape: "arced",
        connectorBias: "negative"
    }
];
const $f9897010521bbd9d$export$74d164615ea757fb = [
    {
        from: "mobile-component-D-dot-top",
        to: "mobile-component-D-icon-gdrive",
        isAnimated: true,
        connectorShape: "arced",
        connectorBias: "positive"
    },
    {
        from: "mobile-component-D-icon-gdrive",
        to: "mobile-component-D-dot-right",
        connectorShape: "arced",
        connectorBias: "positive"
    },
    {
        from: "mobile-component-D-dot-top",
        to: "mobile-component-D-rectangle-in-progress",
        isAnimated: true,
        connectorShape: "arced",
        connectorBias: "negative"
    }
];
const $f9897010521bbd9d$export$a2089f34a89c6aea = [
    {
        from: "mobile-component-E-dot-top",
        to: "mobile-component-E-icon-sharepoint-bottom",
        isAnimated: true,
        connectorShape: "arced",
        connectorBias: "negative"
    },
    {
        from: "mobile-component-E-icon-sharepoint-bottom",
        to: "mobile-component-E-dot-left",
        connectorShape: "arced",
        isAnimated: true,
        connectorBias: "negative"
    }
];
const $f9897010521bbd9d$export$c30288e07ec1214e = [
    {
        from: "mobile-component-F-dot-top",
        to: "mobile-component-F-dot-left",
        isAnimated: true,
        connectorShape: "arced",
        connectorBias: "negative"
    },
    {
        from: "mobile-component-F-dot-top",
        to: "mobile-component-F-rectangle-comment",
        connectorShape: "arced",
        isAnimated: true,
        connectorBias: "negative"
    },
    {
        to: "mobile-component-F-dot-bottom-right",
        from: "mobile-component-F-rectangle-comment",
        connectorShape: "arced",
        isAnimated: true,
        connectorBias: "positive"
    }
];
const $f9897010521bbd9d$export$b558969562a813f5 = [
    {
        from: "mobile-component-H-dot-top-left",
        to: "mobile-component-H-icon-figma",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        to: "mobile-component-H-dot-top-right",
        from: "mobile-component-H-icon-figma",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        from: "mobile-component-H-dot-top-left",
        to: "mobile-component-H-icon-microsoft",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        to: "mobile-component-H-dot-middle-left",
        from: "mobile-component-H-icon-microsoft",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "mobile-component-H-dot-top-left",
        to: "mobile-component-H-rectangle-avatars",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        to: "mobile-component-H-dot-bottom",
        from: "mobile-component-H-rectangle-avatars",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    }
];
const $f9897010521bbd9d$export$f08b61eee7038f83 = [
    {
        from: "mobile-component-I-dot-top",
        to: "mobile-component-I-dot-mid",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        from: "mobile-component-I-dot-mid",
        to: "mobile-component-I-avatar-blue",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "mobile-component-I-dot-mid",
        to: "mobile-component-I-dot-left-mid",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "mobile-component-I-dot-mid",
        to: "mobile-component-I-dot-right-mid",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    },
    {
        from: "mobile-component-I-avatar-blue",
        to: "mobile-component-I-dot-left-bottom",
        connectorShape: "arced",
        connectorBias: "negative",
        isAnimated: true
    },
    {
        from: "mobile-component-I-avatar-blue",
        to: "mobile-component-I-dot-right-bottom",
        connectorShape: "arced",
        connectorBias: "positive",
        isAnimated: true
    }
];

});


parcelRegister("gP8Hr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bccaaeb31231192a$export$2e2bcd8739ae039; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $1pIeE = parcelRequire("1pIeE");

var $iHYHa = parcelRequire("iHYHa");

var $dziIc = parcelRequire("dziIc");

var $2WL8B = parcelRequire("2WL8B");

var $lqyi6 = parcelRequire("lqyi6");

var $17RBn = parcelRequire("17RBn");

var $jQ0cd = parcelRequire("jQ0cd");
const $bccaaeb31231192a$var$UniformTemplateModalButton = (props)=>{
    const { text: text, productKey: productKey, templateName: templateName, pluginModuleKey: pluginModuleKey, href: href } = props;
    const { openModalForTemplate: openModalForTemplate } = (0, $iHYHa.useSiteSelectorContext)();
    const { setTemplate: setTemplate } = (0, $1pIeE.useProductTemplateContext)();
    // AIS = Atlassian Identity Service - provides user's existing Atlassian sites
    const aisSites = (0, $2WL8B.useSitesWithCurrentProduct)();
    const locale = (0, $17RBn.useLocale)();
    const localizedSignupHref = (0, $jQ0cd.useLocalizedHref)("/try/cloud/signup");
    const [buttonProps, setButtonProps] = (0, $1oC0p.useState)({
        href: $bccaaeb31231192a$var$getDefaultHref({
            productKey: productKey,
            locale: locale
        })
    });
    const fullStargateProductKey = productKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${productKey}.ondemand`;
    (0, $1oC0p.useEffect)(()=>{
        if (pluginModuleKey && productKey) {
            const templateData = {
                templateId: pluginModuleKey,
                templateName: templateName,
                productKey: fullStargateProductKey
            };
            setTemplate(templateData);
            // Get site URLs for the current product
            const siteUrls = aisSites?.map((site)=>site.url) ?? [];
            // Determine action based on user's sites
            const action = (0, $dziIc.getTemplateAction)({
                templateData: templateData,
                siteUrls: siteUrls,
                localizedSignupHref: localizedSignupHref
            });
            if (action.type === "modal") setButtonProps({
                onClick: (event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                    openModalForTemplate(templateData);
                }
            });
            else setButtonProps({
                href: action.href
            });
        } else if (href) setButtonProps({
            href: (0, $jQ0cd.getLocalizedHref)({
                href: href,
                locale: locale
            })
        });
        return ()=>{
            setTemplate(null);
        };
    }, [
        openModalForTemplate,
        templateName,
        pluginModuleKey,
        fullStargateProductKey,
        href,
        productKey,
        locale,
        aisSites,
        localizedSignupHref,
        setTemplate
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        ...buttonProps,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "modal"
        },
        children: text
    });
};
function $bccaaeb31231192a$var$getDefaultHref(args) {
    const { locale: locale, productKey: productKey } = args;
    if (productKey === "jira-software") return (0, $jQ0cd.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira&edition=free",
        locale: locale
    });
    if (productKey === "confluence") return (0, $jQ0cd.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=confluence&edition=free",
        locale: locale
    });
    if (productKey === "jira-service-management") return (0, $jQ0cd.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira-service-management&edition=free",
        locale: locale
    });
    return "";
}
var $bccaaeb31231192a$export$2e2bcd8739ae039 = $bccaaeb31231192a$var$UniformTemplateModalButton;

});
parcelRegister("dziIc", function(module, exports) {
$parcel$export(module.exports, "getTemplateAction", function () { return $bbf78a31d6ae35df$export$4935503ffd4d8306; });

var $20OkY = parcelRequire("20OkY");

var $lact3 = parcelRequire("lact3");
const $bbf78a31d6ae35df$export$4935503ffd4d8306 = (params)=>{
    const { templateData: templateData, siteUrls: siteUrls, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    // If user has existing sites, show modal
    if (siteUrls.length > 0) return {
        type: "modal",
        templateData: templateData
    };
    // Otherwise, redirect directly
    const href = $bbf78a31d6ae35df$var$getRedirectHref({
        templateData: templateData,
        redirectToIdentity: redirectToIdentity,
        internalLinkAfterIdentity: internalLinkAfterIdentity,
        localizedSignupHref: localizedSignupHref
    });
    return {
        type: "redirect",
        href: href
    };
};
const $bbf78a31d6ae35df$var$getRedirectHref = (params)=>{
    const { templateData: templateData, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    const { templateId: templateId, templateName: templateName } = templateData;
    if (redirectToIdentity && internalLinkAfterIdentity) return $bbf78a31d6ae35df$var$getIdentityUrl(templateId, templateName, internalLinkAfterIdentity);
    return $bbf78a31d6ae35df$var$getCloudSignupUrl(templateData, localizedSignupHref, internalLinkAfterIdentity);
};
const $bbf78a31d6ae35df$var$isJiraProduct = (productKey)=>{
    return [
        (0, $20OkY.ProductKeys).JIRA_CORE,
        (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
    ].includes(productKey);
};
const $bbf78a31d6ae35df$var$getCloudSignupUrl = (templateData, localizedSignupHref, internalLinkAfterIdentity)=>{
    const { templateId: templateId, templateName: templateName, productKey: productKey } = templateData;
    let url = `${localizedSignupHref}?product=${productKey}&templateId=${templateId}&edition=free`;
    if ($bbf78a31d6ae35df$var$isJiraProduct(productKey)) {
        const urlParams = new URLSearchParams(location.search);
        if (!urlParams.has("p")) urlParams.append("templateModal", templateId);
        url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
    } else if (productKey === (0, $20OkY.ProductKeys).CONFLUENCE) {
        const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity ?? ""}?templateId=${templateId + encodeURIComponent("&templateName=" + encodeURIComponent(templateName))}`;
        url = `${url}&continue=${encodeURIComponent(continueUrl)}`;
    }
    return url;
};
const $bbf78a31d6ae35df$var$getIdentityUrl = (templateId, templateName, internalLinkAfterIdentity)=>{
    const loginUrl = `${(0, $lact3.getIdentityBaseUrl)()}/login?`;
    const continueUrl = `${(0, $lact3.getWacIntegrationUrl)()}${internalLinkAfterIdentity}?templateName=${encodeURIComponent(templateName)}&templateId=${templateId}`;
    return `${loginUrl}&continue=${encodeURIComponent(continueUrl)}`;
};

});


parcelRegister("cwpkM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0641dc4fa0c9006d$export$2e2bcd8739ae039; });
/* template-preview.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1wldG = parcelRequire("1wldG");

var $e3eMt = parcelRequire("e3eMt");
const $0641dc4fa0c9006d$var$UniformTemplatePreview = ({ templatePreview: templatePreview, templateType: templateType })=>{
    if (!templatePreview) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_y3gn1h6o _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e3eMt.UniformTemplatePreviewWindow), {
            url: templatePreview.file.url ?? "",
            alt: templatePreview.description ?? "",
            templateType: templateType || (0, $1wldG.TemplateType).Page
        })
    });
};
const $0641dc4fa0c9006d$var$templatePreviewSection = null;
var $0641dc4fa0c9006d$export$2e2bcd8739ae039 = $0641dc4fa0c9006d$var$UniformTemplatePreview;

});
parcelRegister("e3eMt", function(module, exports) {
$parcel$export(module.exports, "UniformTemplatePreviewWindow", function () { return $d2c1227d2c24707c$export$7796399069f4fd6e; });
/* template-preview-window.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kz1DD = parcelRequire("kz1DD");

var $eY3N6 = parcelRequire("eY3N6");

var $1wldG = parcelRequire("1wldG");

var $kbpa7 = parcelRequire("kbpa7");

var $gRDcE = parcelRequire("gRDcE");

var $yKFYG = parcelRequire("yKFYG");
const $d2c1227d2c24707c$var$previewTopBar = null;
const $d2c1227d2c24707c$var$previewBarDot = null;
const $d2c1227d2c24707c$var$previewImage = null;
const $d2c1227d2c24707c$export$7796399069f4fd6e = ({ url: url, alt: alt, templateType: templateType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const templatePreview = null;
    const previewScreenshot = null;
    const whiteboardPreviewWrapper = null;
    const zoomControls = null;
    const zoomControl = null;
    const regionLabel = intl.formatMessage({
        id: "template-preview.scrollable-content",
        defaultMessage: "Scrollbar"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ]),
        children: templateType === (0, $1wldG.TemplateType).Whiteboard ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkvejh"
                    ]),
                    style: {
                        "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    role: "region",
                    "aria-label": regionLabel,
                    className: (0, $2jatx.default)([
                        "_4t3i1gwv _18m91wug _bfhkcd5j _1yxn1b66 _1ein1b66 _19it1k0a _11qbbn52 _12fm15vq",
                        "_80om1qgj _ou2u1osq"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kz1DD.TransformWrapper), {
                        children: ({ zoomIn: zoomIn, zoomOut: zoomOut })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kz1DD.TransformComponent), {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                            src: url,
                                            alt: alt,
                                            className: (0, $2jatx.default)([
                                                "_1bsb1osq _p12f1osq"
                                            ])
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulpu2gc _kqswstnw _u7copxbi _rjxppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    zoomIn();
                                                    createAnalyticsEvent({
                                                        eventType: "ui",
                                                        action: "clicked",
                                                        actionSubject: "button",
                                                        actionSubjectId: "zoomIn",
                                                        source: "templatePreview"
                                                    }).fire();
                                                },
                                                "aria-label": intl.formatMessage({
                                                    id: "template-preview.zoom-in",
                                                    defaultMessage: "Zoom In"
                                                }),
                                                className: (0, $2jatx.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gRDcE.ZoomIn), {
                                                    size: "16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    zoomOut();
                                                    createAnalyticsEvent({
                                                        eventType: "ui",
                                                        action: "clicked",
                                                        actionSubject: "button",
                                                        actionSubjectId: "zoomOut",
                                                        source: "templatePreview"
                                                    }).fire();
                                                },
                                                "aria-label": intl.formatMessage({
                                                    id: "template-preview.zoom-out",
                                                    defaultMessage: "Zoom Out"
                                                }),
                                                className: (0, $2jatx.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $yKFYG.ZoomOut), {
                                                    size: "16"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkvejh"
                    ]),
                    style: {
                        "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    role: "region",
                    "aria-label": regionLabel,
                    className: (0, $2jatx.default)([
                        "_4t3i1gwv _18m91wug _bfhkcd5j _1yxn1b66 _1ein1b66 _19it1k0a _11qbbn52 _12fm15vq"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: url,
                        alt: alt,
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};

});


parcelRegister("aSmcz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("eFi9k")).default; });

var $eFi9k = parcelRequire("eFi9k");

});
parcelRegister("eFi9k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fc721b325f003ef7$export$2e2bcd8739ae039; });
/* templates-search-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $foNCS = parcelRequire("foNCS");

var $a1X32 = parcelRequire("a1X32");

var $h6Fsc = parcelRequire("h6Fsc");

var $bZmYH = parcelRequire("bZmYH");

var $kbpa7 = parcelRequire("kbpa7");

var $3lGAh = parcelRequire("3lGAh");

var $cP432 = parcelRequire("cP432");

var $H7SCD = parcelRequire("H7SCD");

var $f4mYE = parcelRequire("f4mYE");
const $fc721b325f003ef7$var$SEARCH_QUERY_PARAM = "term";
const $fc721b325f003ef7$var$INVERSE_TEXT_COLOR = "var(--ds-text-inverse, #FFFFFF)";
const $fc721b325f003ef7$var$messages = (0, $fnHPc.defineMessages)({
    heading: {
        id: "templates-search-bar.heading",
        defaultMessage: "Search all templates below"
    },
    subheading: {
        id: "templates-search-bar.subheading",
        defaultMessage: "Find Atlassian templates in one place."
    },
    placeholder: {
        id: "templates-search-bar.placeholder",
        defaultMessage: "Search templates"
    },
    clearSearch: {
        id: "templates-search-bar.clear-search",
        defaultMessage: "Clear search"
    },
    allSearchResults: {
        id: "templates-search-bar.all-search-results",
        defaultMessage: "All search results"
    }
});
const $fc721b325f003ef7$var$DEFAULT_PROPS = {
    suggestionLabelPath: "fields.templateNameExternal",
    suggestionProductPath: "fields.product.0.fields.productNameReference.fields.productName",
    suggestionHrefPath: "fields.fullUrlSlug",
    maxSuggestions: 6
};
const $fc721b325f003ef7$var$handleSuggestionKeyDown = ({ event: event, suggestions: suggestions, activeIndex: activeIndex, setActiveIndex: setActiveIndex, setValue: setValue, submitSearch: submitSearch })=>{
    if (event.key === "ArrowDown") {
        event.preventDefault();
        setActiveIndex((current)=>Math.min(current + 1, suggestions.length - 1));
        return;
    }
    if (event.key === "ArrowUp") {
        event.preventDefault();
        setActiveIndex((current)=>Math.max(current - 1, 0));
        return;
    }
    if (event.key === "Enter" && activeIndex >= 0) {
        event.preventDefault();
        const suggestion = suggestions[activeIndex];
        if (!suggestion) return;
        if (suggestion.href) {
            window.location.href = suggestion.href;
            return;
        }
        setValue(suggestion.queryValue);
        submitSearch(suggestion.queryValue);
    }
};
/** Suggestions from the gallery's shared items + config (so they match the gallery); falls back to the `items` prop when there's no gallery context. */ const $fc721b325f003ef7$var$useSuggestions = ({ rawItems: rawItems, query: query, labelPath: labelPath, productPath: productPath, hrefPath: hrefPath, maxSuggestions: maxSuggestions })=>{
    const galleryConfig = (0, $foNCS.useFilterableGalleryLoader)()?.galleryConfig ?? null;
    const items = (0, $1oC0p.useMemo)(()=>galleryConfig?.items ?? $fc721b325f003ef7$var$normaliseItems(rawItems), [
        galleryConfig,
        rawItems
    ]);
    return (0, $1oC0p.useMemo)(()=>$fc721b325f003ef7$var$buildSuggestions({
            query: query,
            items: items,
            labelPath: labelPath,
            productPath: productPath,
            hrefPath: hrefPath,
            searchConfiguration: galleryConfig?.searchConfiguration,
            featuredItemSlugs: galleryConfig?.featuredItemSlugs ?? [],
            maxSuggestions: maxSuggestions
        }), [
        query,
        items,
        labelPath,
        productPath,
        hrefPath,
        galleryConfig,
        maxSuggestions
    ]);
};
const $fc721b325f003ef7$var$TemplatesSearchBar = ({ heading: heading, subheading: subheading, placeholder: placeholder, items: rawItems, suggestionLabelPath: suggestionLabelPath = $fc721b325f003ef7$var$DEFAULT_PROPS.suggestionLabelPath, suggestionProductPath: suggestionProductPath = $fc721b325f003ef7$var$DEFAULT_PROPS.suggestionProductPath, suggestionHrefPath: suggestionHrefPath = $fc721b325f003ef7$var$DEFAULT_PROPS.suggestionHrefPath, maxSuggestions: maxSuggestions = $fc721b325f003ef7$var$DEFAULT_PROPS.maxSuggestions })=>{
    const intl = (0, $8e22h.default)();
    // Search bar chrome is localized from the active page locale; the default
    // (English) locale resolves to the original copy. CMS-provided overrides
    // take precedence. See GWP-12213.
    const resolvedHeading = heading ?? intl.formatMessage($fc721b325f003ef7$var$messages.heading);
    const resolvedSubheading = subheading ?? intl.formatMessage($fc721b325f003ef7$var$messages.subheading);
    const resolvedPlaceholder = placeholder ?? intl.formatMessage($fc721b325f003ef7$var$messages.placeholder);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "data-testid": "templates-search-bar",
        className: (0, $2jatx.default)([
            "_bfhk1hlo _syazcd5j _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _ca0qys9h _u5f31tcg _n3tdys9h _19bv1tcg _1reoewfl _18m9ewfl _1kmxvbgk _1ggm7vkz _1ykzvbgk _1mae7vkz"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_syaz1gfe _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb8pqr _vwz41btq _k48p1fw0 _1cqsviql",
                    "templates-search-bar-heading"
                ]),
                style: {
                    color: $fc721b325f003ef7$var$INVERSE_TEXT_COLOR
                },
                children: resolvedHeading
            }),
            resolvedSubheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syaz1gfe _18s81yj3 _1wyb1k92 _vwz419ii",
                    "templates-search-bar-subheading"
                ]),
                style: {
                    color: $fc721b325f003ef7$var$INVERSE_TEXT_COLOR
                },
                children: resolvedSubheading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($fc721b325f003ef7$var$TemplatesSearchForm, {
                placeholder: resolvedPlaceholder,
                rawItems: rawItems,
                suggestionLabelPath: suggestionLabelPath,
                suggestionProductPath: suggestionProductPath,
                suggestionHrefPath: suggestionHrefPath,
                maxSuggestions: maxSuggestions
            })
        ]
    });
};
const $fc721b325f003ef7$var$TemplatesSearchForm = ({ placeholder: placeholder, rawItems: rawItems, suggestionLabelPath: suggestionLabelPath, suggestionProductPath: suggestionProductPath, suggestionHrefPath: suggestionHrefPath, maxSuggestions: maxSuggestions })=>{
    const intl = (0, $8e22h.default)();
    const [value, setValue] = (0, $1oC0p.useState)("");
    const [isFocused, setIsFocused] = (0, $1oC0p.useState)(false);
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(-1);
    const suggestions = $fc721b325f003ef7$var$useSuggestions({
        rawItems: rawItems,
        query: value,
        labelPath: suggestionLabelPath,
        productPath: suggestionProductPath,
        hrefPath: suggestionHrefPath,
        maxSuggestions: maxSuggestions
    });
    const shouldShowSuggestions = isFocused && value.trim().length > 0 && suggestions.length > 0;
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window === "undefined") return;
        const hydrateFromUrl = ()=>{
            const params = new URLSearchParams(window.location.search);
            setValue(params.get($fc721b325f003ef7$var$SEARCH_QUERY_PARAM) ?? "");
        };
        hydrateFromUrl();
        window.addEventListener("popstate", hydrateFromUrl);
        return ()=>window.removeEventListener("popstate", hydrateFromUrl);
    }, []);
    const submitSearch = (nextValue = value)=>{
        $fc721b325f003ef7$var$writeSearchQuery(nextValue);
        setIsFocused(false);
        setActiveIndex(-1);
    };
    const clearSearch = ()=>{
        setValue("");
        $fc721b325f003ef7$var$writeSearchQuery("");
        setActiveIndex(-1);
    };
    const submitAllSearchResults = ()=>{
        submitSearch();
        (0, $f4mYE.dispatchShowAllFilterableGalleryItems)(value);
    };
    const handleKeyDown = (event)=>{
        if (!shouldShowSuggestions) return;
        $fc721b325f003ef7$var$handleSuggestionKeyDown({
            event: event,
            suggestions: suggestions,
            activeIndex: activeIndex,
            setActiveIndex: setActiveIndex,
            setValue: setValue,
            submitSearch: submitSearch
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
        role: "search",
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) setIsFocused(false);
        },
        onFocus: ()=>setIsFocused(true),
        onSubmit: (event)=>{
            event.preventDefault();
            submitAllSearchResults();
        },
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _p12fbxu3 _1pfh1ady"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1ylp _2rkogktf _bfhkcd5j _1e0c1txw _4cvr1h6o _ca0qidpf _u5f37vkz _n3tdidpf _19bvgktf _syaz1hlo"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        "aria-hidden": "true",
                        className: (0, $2jatx.default)([
                            "_syazdgkc _1e0c1txw _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _12l2utpp"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))), {
                            label: "",
                            size: "medium"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                        "aria-label": placeholder,
                        placeholder: placeholder,
                        value: value,
                        onChange: (event)=>{
                            setValue(event.target.value);
                            setIsFocused(true);
                            setActiveIndex(-1);
                        },
                        onKeyDown: handleKeyDown,
                        className: (0, $2jatx.default)([
                            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _bfhk1j28 _syaz1hlo _1wyb1j6v _vwz4bs82 _ect41kw7"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    }),
                    value && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        type: "button",
                        "aria-label": intl.formatMessage($fc721b325f003ef7$var$messages.clearSearch),
                        onClick: clearSearch,
                        className: (0, $2jatx.default)([
                            "_bfhk1j28 _19itidpf _syaz1hlo _80omtlke _1e0c1txw _4cvr1h6o _1bah1h6o _16jlidpf _1o9zidpf _i0dl1wug _1yt41b66"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))), {
                            label: "",
                            size: "medium"
                        })
                    })
                ]
            }),
            shouldShowSuggestions && /*#__PURE__*/ (0, $7VQPk.jsx)($fc721b325f003ef7$var$SuggestionsPanel, {
                suggestions: suggestions,
                activeIndex: activeIndex,
                query: value,
                setActiveIndex: setActiveIndex,
                onSelect: (suggestion)=>{
                    setValue(suggestion.queryValue);
                    submitSearch(suggestion.queryValue);
                },
                onAllResults: submitAllSearchResults,
                allResultsLabel: intl.formatMessage($fc721b325f003ef7$var$messages.allSearchResults)
            })
        ]
    });
};
const $fc721b325f003ef7$var$normaliseItems = (rawItems)=>{
    if (Array.isArray(rawItems)) return rawItems;
    if ((0, $3lGAh.isContentfulEnvelope)(rawItems)) return rawItems.items;
    return [];
};
const $fc721b325f003ef7$var$resolveStrings = (item, path)=>(0, $H7SCD.coerceToPrimitiveArray)((0, $H7SCD.resolveFieldPath)(item, path));
const $fc721b325f003ef7$var$resolveString = (item, path)=>$fc721b325f003ef7$var$resolveStrings(item, path)[0];
/** Fallback config (when the gallery shares none) ranking title above product, over the search bar's own display paths. */ const $fc721b325f003ef7$var$buildRankingConfig = (labelPath, productPath)=>({
        keys: [
            {
                name: labelPath,
                weight: 1
            },
            ...productPath ? [
                {
                    name: productPath,
                    weight: 0.7
                }
            ] : []
        ]
    });
/** Builds the dropdown: the raw query first, then items ranked by the same search the gallery uses, deduped by display label. */ const $fc721b325f003ef7$var$buildSuggestions = ({ query: query, items: items, labelPath: labelPath, productPath: productPath, hrefPath: hrefPath, searchConfiguration: searchConfiguration, featuredItemSlugs: featuredItemSlugs, maxSuggestions: maxSuggestions })=>{
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return [];
    const lowerQuery = trimmedQuery.toLowerCase();
    const suggestionLimit = Math.max(maxSuggestions, 0);
    if (suggestionLimit === 0) return [];
    const suggestions = [
        {
            id: `query-${lowerQuery}`,
            label: trimmedQuery,
            queryValue: trimmedQuery
        }
    ];
    if (suggestionLimit === 1) return suggestions;
    const rankedItems = (0, $H7SCD.searchWithFeaturedBoost)(items, trimmedQuery, searchConfiguration ?? $fc721b325f003ef7$var$buildRankingConfig(labelPath, productPath), featuredItemSlugs);
    const seen = new Set([
        lowerQuery
    ]);
    for (const item of rankedItems){
        const title = $fc721b325f003ef7$var$resolveString(item, labelPath);
        if (!title) continue;
        const product = $fc721b325f003ef7$var$resolveString(item, productPath);
        const label = product ? `${title} - ${product} Template` : title;
        const key = label.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);
        const href = $fc721b325f003ef7$var$resolveString(item, hrefPath);
        suggestions.push({
            id: key,
            label: label,
            queryValue: title,
            href: href || undefined
        });
        if (suggestions.length >= suggestionLimit) break;
    }
    return suggestions;
};
const $fc721b325f003ef7$var$writeSearchQuery = (query)=>{
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const trimmedQuery = query.trim();
    if (trimmedQuery) params.set($fc721b325f003ef7$var$SEARCH_QUERY_PARAM, trimmedQuery);
    else params.delete($fc721b325f003ef7$var$SEARCH_QUERY_PARAM);
    const nextSearch = params.toString();
    const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ""}${window.location.hash}`;
    if (nextUrl !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
        window.history.pushState({}, "", nextUrl);
        window.dispatchEvent(new Event("popstate"));
    }
    window.dispatchEvent(new CustomEvent((0, $cP432.GALLERY_SEARCH_EVENT), {
        detail: {
            query: trimmedQuery
        }
    }));
};
const $fc721b325f003ef7$var$SuggestionsPanel = ({ suggestions: suggestions, activeIndex: activeIndex, query: query, setActiveIndex: setActiveIndex, onSelect: onSelect, onAllResults: onAllResults, allResultsLabel: allResultsLabel })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "templates-search-suggestions",
        className: (0, $2jatx.default)([
            "_kqswstnw _1pbyqfx8 _152t8vuz _1e02idpf _1bsb1osq _bfhkcd5j _syaz1hlo _2rkogktf _ca0q1ou6 _u5f31f4h _n3tdqslr _19bv1f4h _y3gn1e5h _19ithueu _16qs130s"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx21bp4 _zulpu2gc"
                ]),
                children: suggestions.map((suggestion, index)=>{
                    const sharedCss = [
                        $fc721b325f003ef7$var$suggestionButtonStyle,
                        index === activeIndex ? $fc721b325f003ef7$var$activeSuggestionStyle : null
                    ];
                    const label = /*#__PURE__*/ (0, $7VQPk.jsx)($fc721b325f003ef7$var$HighlightedText, {
                        text: suggestion.label,
                        query: query
                    });
                    // href → link to the template; no href (typed-query row) →
                    // button that runs the search, not an <a href=""> that reloads.
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        children: suggestion.href ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "aria-label": suggestion.label,
                            href: suggestion.href,
                            onMouseDown: (event)=>event.preventDefault(),
                            onMouseEnter: ()=>setActiveIndex(index),
                            onFocus: ()=>setActiveIndex(index),
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _19itidpf _bfhk1j28 _syaz1hlo _80omtlke _1e0c1ule _y3gn1e5h _1yt418iy _1tkezwfg _1wyb1j6v _vwz4bs82 _ect41kw7",
                                index === activeIndex && "_bfhk150w"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                            },
                            children: label
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            "aria-label": suggestion.label,
                            onMouseDown: (event)=>event.preventDefault(),
                            onMouseEnter: ()=>setActiveIndex(index),
                            onFocus: ()=>setActiveIndex(index),
                            onClick: ()=>onSelect(suggestion),
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _19itidpf _bfhk1j28 _syaz1hlo _80omtlke _1e0c1ule _y3gn1e5h _1yt418iy _1tkezwfg _1wyb1j6v _vwz4bs82 _ect41kw7",
                                index === activeIndex && "_bfhk150w"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                            },
                            children: label
                        })
                    }, suggestion.id);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                type: "button",
                onMouseDown: (event)=>event.preventDefault(),
                onClick: onAllResults,
                className: (0, $2jatx.default)([
                    "_19itidpf _bfhk1j28 _syaz13af _80omtlke _1e0c116y _4cvr1h6o _zulp1b66 _1pfhpxbi _1yt418iy _1wyb1j6v _k48pni7l _ect41kw7 _13ix150w _irr3150w _mizu1r31 _1dit1r31 _ra3xglyw _ksodglyw _128midpf _4hz8idpf"
                ]),
                style: {
                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                },
                children: [
                    allResultsLabel,
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1X32))), {
                        label: "",
                        size: "small"
                    })
                ]
            })
        ]
    });
const $fc721b325f003ef7$var$HighlightedText = ({ text: text, query: query })=>{
    const trimmedQuery = query.trim();
    const index = text.toLowerCase().indexOf(trimmedQuery.toLowerCase());
    if (!trimmedQuery || index < 0) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: text
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            text.slice(0, index),
            /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: text.slice(index, index + trimmedQuery.length)
            }),
            text.slice(index + trimmedQuery.length)
        ]
    });
};
const $fc721b325f003ef7$var$sectionStyle = null;
const $fc721b325f003ef7$var$headingStyle = null;
const $fc721b325f003ef7$var$subheadingStyle = null;
const $fc721b325f003ef7$var$searchFormStyle = null;
const $fc721b325f003ef7$var$inputShellStyle = null;
const $fc721b325f003ef7$var$searchIconStyle = null;
const $fc721b325f003ef7$var$inputStyle = null;
const $fc721b325f003ef7$var$clearButtonStyle = null;
const $fc721b325f003ef7$var$suggestionsPanelStyle = null;
const $fc721b325f003ef7$var$suggestionsListStyle = null;
const $fc721b325f003ef7$var$suggestionButtonStyle = null;
const $fc721b325f003ef7$var$activeSuggestionStyle = null;
const $fc721b325f003ef7$var$allResultsButtonStyle = null;
var $fc721b325f003ef7$export$2e2bcd8739ae039 = $fc721b325f003ef7$var$TemplatesSearchBar;

});


parcelRegister("11uBo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fd0ee32942954c5a$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $dZNgt = parcelRequire("dZNgt");

var $lTkkF = parcelRequire("lTkkF");

var $jsxHL = parcelRequire("jsxHL");

var $faxYF = parcelRequire("faxYF");
const $fd0ee32942954c5a$export$bd5da47596094494 = ({ text: text, uniformRichText: uniformRichText, style: style = "body-lg", alignment: alignment = "left", tagType: tagType })=>{
    const hasRichText = !(0, $dZNgt.isRichTextValueConsideredEmpty)(uniformRichText);
    // defaults to p when no tagType is provided
    // Use div instead of p when rich text is present to avoid nested <p> tags
    const Component = hasRichText && (!tagType || tagType === "p") ? "div" : tagType || "p";
    const [textRef, textColor] = (0, $faxYF.useStylePropertyVariableValueFromParent)("--dxp-container-text-color");
    const alignmentStyle = null;
    const boldStyling = null;
    const resetMargin = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)(Component, {
            ref: textRef,
            className: (0, $2jatx.default)([
                style?.includes("bold") && "_3dt51fw0",
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                "_y3gnoues",
                style
            ]),
            style: {
                ...textColor ? {
                    color: textColor
                } : undefined,
                "--_1v0xqnb": (0, $6ZVlx.default)(alignment)
            },
            children: !(0, $dZNgt.isRichTextValueConsideredEmpty)(uniformRichText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTkkF.RichTextComponent), {
                uniformParameter: "uniformRichText"
            }) : text
        })
    });
};
var $fd0ee32942954c5a$export$2e2bcd8739ae039 = $fd0ee32942954c5a$export$bd5da47596094494;

});

parcelRegister("hnLdc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $961aae6f61765b8c$export$2e2bcd8739ae039; });
/* text-with-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jsxHL = parcelRequire("jsxHL");

var $11uBo = parcelRequire("11uBo");

var $2ggtO = parcelRequire("2ggtO");
const $961aae6f61765b8c$export$69f8fbc89c62ee2a = "body-md";
const $961aae6f61765b8c$export$8cea64591eaafc6 = (props)=>{
    const { text: text, style: style = $961aae6f61765b8c$export$69f8fbc89c62ee2a, icon: icon } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "data-testid": "TextWithIcon-icon",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ggtO.Icon), {
                        name: icon,
                        size: style === "body-sm" ? "small" : "medium"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        style === "body-sm" && "_1pfht94y",
                        style === "body-md" && "_1pfh1l7b"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $11uBo.default), {
                        text: text,
                        style: style
                    })
                })
            ]
        })
    });
};
const $961aae6f61765b8c$var$wrapperCss = null;
const $961aae6f61765b8c$var$smTextCss = null;
const $961aae6f61765b8c$var$mdTextCss = null;
var $961aae6f61765b8c$export$2e2bcd8739ae039 = $961aae6f61765b8c$export$8cea64591eaafc6;

});
parcelRegister("2ggtO", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $74139676dd5cc642$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $f3oWf = parcelRequire("f3oWf");
const $74139676dd5cc642$export$f04a61298a47a40f = (props)=>{
    const { name: name, size: size } = props;
    if (!name) return /*#__PURE__*/ (0, $7VQPk.jsx)($74139676dd5cc642$var$GlyphIcon, {
        size: size,
        name: "TaskInProgressIcon"
    });
    // @ts-ignore
    const { version: version } = (0, $f3oWf.iconMapping)[name];
    if (version === "glyph") return /*#__PURE__*/ (0, $7VQPk.jsx)($74139676dd5cc642$var$GlyphIcon, {
        ...props
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($74139676dd5cc642$var$CoreIcon, {
        ...props
    });
};
const $74139676dd5cc642$var$iconWrapperSmallCss = null;
const $74139676dd5cc642$var$iconWrapperMediumCss = null;
const $74139676dd5cc642$var$CoreIcon = (props)=>{
    const { name: name, size: size } = props;
    // @ts-ignore
    const BaseIcon = (0, $f3oWf.iconMapping)[name].component;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        // @ts-ignore
        className: (0, $2jatx.default)([
            size === "small" && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "medium" && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)(BaseIcon, {
            icon: name
        })
    });
};
const $74139676dd5cc642$var$GlyphIcon = (props)=>{
    const { name: name, size: size } = props;
    // @ts-ignore
    const BaseGlyphIcon = (0, $f3oWf.iconMapping)[name].component;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        // @ts-ignore
        className: (0, $2jatx.default)([
            size === "small" && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "small" && "_17521o4j",
            size === "medium" && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "medium" && "_1q511lya _17521txs"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)(BaseGlyphIcon, {
            icon: name,
            size: size
        })
    });
};
const $74139676dd5cc642$var$glyphIconWrapperSmallCss = null;
const $74139676dd5cc642$var$glyphIconWrapperMediumCss = null;

});
parcelRegister("f3oWf", function(module, exports) {
$parcel$export(module.exports, "iconMapping", function () { return $e4f57aa48d72479d$export$82f701de2810d5a7; });

var $cnoa5 = parcelRequire("cnoa5");

var $hegho = parcelRequire("hegho");

var $hXSMk = parcelRequire("hXSMk");

var $j1ciw = parcelRequire("j1ciw");

var $glYau = parcelRequire("glYau");

var $9Cyyz = parcelRequire("9Cyyz");

var $4szpS = parcelRequire("4szpS");

var $26k9M = parcelRequire("26k9M");

var $9lp51 = parcelRequire("9lp51");

var $4ZYjw = parcelRequire("4ZYjw");

var $87kcI = parcelRequire("87kcI");

var $bOuCy = parcelRequire("bOuCy");

var $lfTOg = parcelRequire("lfTOg");

var $7H8sx = parcelRequire("7H8sx");

var $efg6m = parcelRequire("efg6m");

var $eOOWL = parcelRequire("eOOWL");

var $35vmV = parcelRequire("35vmV");

var $7NfvL = parcelRequire("7NfvL");

var $gNuc8 = parcelRequire("gNuc8");

var $a9Umc = parcelRequire("a9Umc");

var $aSr2F = parcelRequire("aSr2F");

var $9tc44 = parcelRequire("9tc44");

var $fBECg = parcelRequire("fBECg");

var $9dCmO = parcelRequire("9dCmO");

var $lshIt = parcelRequire("lshIt");

var $dmI5f = parcelRequire("dmI5f");

var $ppCkT = parcelRequire("ppCkT");

var $b2tob = parcelRequire("b2tob");

var $2lAyB = parcelRequire("2lAyB");

var $5alrx = parcelRequire("5alrx");

var $eMDDH = parcelRequire("eMDDH");

var $10jed = parcelRequire("10jed");

var $cB1fn = parcelRequire("cB1fn");

var $b0jeq = parcelRequire("b0jeq");

var $j0gMs = parcelRequire("j0gMs");

var $kbgnS = parcelRequire("kbgnS");

var $7JEHy = parcelRequire("7JEHy");

var $96j6d = parcelRequire("96j6d");

var $7Xpzl = parcelRequire("7Xpzl");

var $6zF1U = parcelRequire("6zF1U");

var $6ED9p = parcelRequire("6ED9p");

var $3GRvb = parcelRequire("3GRvb");

var $kzcfD = parcelRequire("kzcfD");

var $gsdeR = parcelRequire("gsdeR");

var $WKTmf = parcelRequire("WKTmf");

var $aZNQ9 = parcelRequire("aZNQ9");

var $kVLN7 = parcelRequire("kVLN7");

var $3nGGx = parcelRequire("3nGGx");

var $gXz9s = parcelRequire("gXz9s");

var $PQhz5 = parcelRequire("PQhz5");

var $bf5rK = parcelRequire("bf5rK");

var $gvZeq = parcelRequire("gvZeq");

var $7surG = parcelRequire("7surG");

var $ggVkr = parcelRequire("ggVkr");

var $iMdbU = parcelRequire("iMdbU");

var $7pQ29 = parcelRequire("7pQ29");

var $hp8xM = parcelRequire("hp8xM");

var $6QMjb = parcelRequire("6QMjb");

var $8TzqB = parcelRequire("8TzqB");

var $7v2eo = parcelRequire("7v2eo");

var $dTWad = parcelRequire("dTWad");

var $ePHAx = parcelRequire("ePHAx");

var $bZmYH = parcelRequire("bZmYH");

var $lVBDF = parcelRequire("lVBDF");

var $5ABRP = parcelRequire("5ABRP");

var $cBEbW = parcelRequire("cBEbW");

var $l6HGO = parcelRequire("l6HGO");

var $8pvt1 = parcelRequire("8pvt1");

var $3dYrz = parcelRequire("3dYrz");

var $gjva1 = parcelRequire("gjva1");

var $fLF1J = parcelRequire("fLF1J");

var $hKesO = parcelRequire("hKesO");

var $g7U5A = parcelRequire("g7U5A");

var $kHMU7 = parcelRequire("kHMU7");

var $ehGJT = parcelRequire("ehGJT");

var $k2zyM = parcelRequire("k2zyM");

var $2GO8b = parcelRequire("2GO8b");

var $dTPlE = parcelRequire("dTPlE");

var $8BlKa = parcelRequire("8BlKa");

var $6xXDI = parcelRequire("6xXDI");

var $5nJnO = parcelRequire("5nJnO");
const $e4f57aa48d72479d$export$82f701de2810d5a7 = {
    TimelineIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fLF1J))),
        version: "core"
    },
    CalendarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lfTOg))),
        version: "core"
    },
    CameraIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7H8sx))),
        version: "core"
    },
    WarningIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kHMU7))),
        version: "core"
    },
    TeamsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gjva1))),
        version: "core"
    },
    ChangesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($efg6m))),
        version: "core"
    },
    ChartBarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eOOWL))),
        version: "core"
    },
    BriefcaseIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($87kcI))),
        version: "core"
    },
    AutomationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9Cyyz))),
        version: "core"
    },
    BugIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bOuCy))),
        version: "core"
    },
    DepartmentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ppCkT))),
        version: "core"
    },
    EyeOpenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5alrx))),
        version: "core"
    },
    BranchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4ZYjw))),
        version: "core"
    },
    PhoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7pQ29))),
        version: "core"
    },
    PremiumIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hp8xM))),
        version: "core"
    },
    CommentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))),
        version: "core"
    },
    Page: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($PQhz5))),
        version: "core"
    },
    PageIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($PQhz5))),
        version: "core"
    },
    PersonAddIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ggVkr))),
        version: "core"
    },
    PersonAddedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iMdbU))),
        version: "core"
    },
    LobbyBellIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kzcfD))),
        version: "core"
    },
    InformationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7Xpzl))),
        version: "core"
    },
    PriorityMajorIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8TzqB))),
        version: "core"
    },
    OfficeBuildingIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3nGGx))),
        version: "core"
    },
    ChartTrendIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gNuc8))),
        version: "core"
    },
    CheckboxCheckedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9tc44))),
        version: "core"
    },
    GoalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7JEHy))),
        version: "core"
    },
    ScreenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ePHAx))),
        version: "core"
    },
    BookWithBookmarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9lp51))),
        version: "core"
    },
    PagesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bf5rK))),
        version: "core"
    },
    ChartMatrixIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7NfvL))),
        version: "core"
    },
    RoadmapIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dTWad))),
        version: "core"
    },
    ShowMoreVerticalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5ABRP))),
        version: "core"
    },
    TagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8pvt1))),
        version: "core"
    },
    MarketplaceIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($WKTmf))),
        version: "core"
    },
    AngleBracketsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($j1ciw))),
        version: "core"
    },
    ProjectIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7v2eo))),
        version: "core"
    },
    BoardIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($26k9M))),
        version: "core"
    },
    MegaphoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aZNQ9))),
        version: "core"
    },
    TransitionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hKesO))),
        version: "core"
    },
    VideoIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g7U5A))),
        version: "core"
    },
    StarStarredIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($l6HGO))),
        version: "core"
    },
    EmojiIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2lAyB))),
        version: "core"
    },
    TaskInProgressIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3dYrz))),
        version: "core"
    },
    FormsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kbgnS))),
        version: "core"
    },
    FilesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($b0jeq))),
        version: "core"
    },
    FlagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($j0gMs))),
        version: "core"
    },
    FileIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cB1fn))),
        version: "core"
    },
    ListBulletedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6ED9p))),
        version: "core"
    },
    SmartLinkListIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cBEbW))),
        version: "core"
    },
    MagicWandIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gsdeR))),
        version: "core"
    },
    OperationsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gXz9s))),
        version: "core"
    },
    DecisionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dmI5f))),
        version: "core"
    },
    FeedbackIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eMDDH))),
        version: "core"
    },
    ObjectiveIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kVLN7))),
        version: "core"
    },
    PresenterModeIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6QMjb))),
        version: "core"
    },
    BacklogIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4szpS))),
        version: "core"
    },
    SearchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bZmYH))),
        version: "core"
    },
    EditIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($b2tob))),
        version: "core"
    },
    CheckMarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aSr2F))),
        version: "core"
    },
    CheckCircleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($a9Umc))),
        version: "core"
    },
    ListChecklistIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3GRvb))),
        version: "core"
    },
    ArchiveBoxIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($glYau))),
        version: "core"
    },
    AlertIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hXSMk))),
        version: "core"
    },
    RoadmapsPlanIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8BlKa))),
        version: "core"
    },
    PeopleGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gvZeq))),
        version: "core"
    },
    BrowserExtensionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($k2zyM))),
        version: "core"
    },
    SyncIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6xXDI))),
        version: "core"
    },
    NotepadIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2GO8b))),
        version: "core"
    },
    PageLiveDocIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dTPlE))),
        version: "core"
    },
    AiAgentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cnoa5))),
        version: "core"
    },
    AiChatIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hegho))),
        version: "core"
    },
    ChartBubbleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($35vmV))),
        version: "core"
    },
    CloudArrowUpIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fBECg))),
        version: "core"
    },
    DataFlowIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lshIt))),
        version: "core"
    },
    FieldCheckboxGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($10jed))),
        version: "core"
    },
    GridIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($96j6d))),
        version: "core"
    },
    LightbulbIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6zF1U))),
        version: "core"
    },
    PersonIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7surG))),
        version: "core"
    },
    ShareIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lVBDF))),
        version: "core"
    },
    WorkItemsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ehGJT))),
        version: "core"
    },
    ViewsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5nJnO))),
        version: "core"
    }
};

});
parcelRegister("j1ciw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd87a66aae0d7ce4$var$_react = $dd87a66aae0d7ce4$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dd87a66aae0d7ce4$var$_baseNew = $dd87a66aae0d7ce4$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $dd87a66aae0d7ce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd87a66aae0d7ce4$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $dd87a66aae0d7ce4$var$_react.default.createElement($dd87a66aae0d7ce4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$dd87a66aae0d7ce4$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $dd87a66aae0d7ce4$var$_default = module.exports.default = $dd87a66aae0d7ce4$var$AngleBracketsIcon;

});

parcelRegister("glYau", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be7d47ad00f4bda6$var$_react = $be7d47ad00f4bda6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $be7d47ad00f4bda6$var$_baseNew = $be7d47ad00f4bda6$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $be7d47ad00f4bda6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be7d47ad00f4bda6$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $be7d47ad00f4bda6$var$_react.default.createElement($be7d47ad00f4bda6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$be7d47ad00f4bda6$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $be7d47ad00f4bda6$var$_default = module.exports.default = $be7d47ad00f4bda6$var$ArchiveBoxIcon;

});

parcelRegister("4ZYjw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a3ba4fc78c82d2f$var$_react = $3a3ba4fc78c82d2f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3a3ba4fc78c82d2f$var$_baseNew = $3a3ba4fc78c82d2f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $3a3ba4fc78c82d2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a3ba4fc78c82d2f$var$BranchIcon = (props)=>/*#__PURE__*/ $3a3ba4fc78c82d2f$var$_react.default.createElement($3a3ba4fc78c82d2f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3a3ba4fc78c82d2f$var$BranchIcon.displayName = 'BranchIcon';
var $3a3ba4fc78c82d2f$var$_default = module.exports.default = $3a3ba4fc78c82d2f$var$BranchIcon;

});

parcelRegister("87kcI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e8ea64a8ad4d13f$var$_react = $5e8ea64a8ad4d13f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5e8ea64a8ad4d13f$var$_baseNew = $5e8ea64a8ad4d13f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5e8ea64a8ad4d13f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e8ea64a8ad4d13f$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $5e8ea64a8ad4d13f$var$_react.default.createElement($5e8ea64a8ad4d13f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$5e8ea64a8ad4d13f$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $5e8ea64a8ad4d13f$var$_default = module.exports.default = $5e8ea64a8ad4d13f$var$BriefcaseIcon;

});

parcelRegister("7NfvL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d0119e14b14178352097aaf532e33e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ac9243d88762656$var$_react = $5ac9243d88762656$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5ac9243d88762656$var$_baseNew = $5ac9243d88762656$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5ac9243d88762656$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartMatrix".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Matrix view in in JPD, and other matrix charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ac9243d88762656$var$ChartMatrixIcon = (props)=>/*#__PURE__*/ $5ac9243d88762656$var$_react.default.createElement($5ac9243d88762656$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 4.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.25 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5.5 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2m5.5-9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m8 3.5a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M10.5 8A1.75 1.75 0 1 1 14 8a1.75 1.75 0 0 1-3.5 0m-5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$5ac9243d88762656$var$ChartMatrixIcon.displayName = 'ChartMatrixIcon';
var $5ac9243d88762656$var$_default = module.exports.default = $5ac9243d88762656$var$ChartMatrixIcon;

});

parcelRegister("aSr2F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7eb3ec80aea1436f$var$_react = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7eb3ec80aea1436f$var$_baseNew = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $7eb3ec80aea1436f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7eb3ec80aea1436f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7eb3ec80aea1436f$var$_react.default.createElement($7eb3ec80aea1436f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$7eb3ec80aea1436f$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $7eb3ec80aea1436f$var$_default = module.exports.default = $7eb3ec80aea1436f$var$CheckMarkIcon;

});

parcelRegister("kbgnS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb118b4320ed1979$var$_react = $eb118b4320ed1979$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $eb118b4320ed1979$var$_baseNew = $eb118b4320ed1979$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $eb118b4320ed1979$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb118b4320ed1979$var$FormIcon = (props)=>/*#__PURE__*/ $eb118b4320ed1979$var$_react.default.createElement($eb118b4320ed1979$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$eb118b4320ed1979$var$FormIcon.displayName = 'FormIcon';
var $eb118b4320ed1979$var$_default = module.exports.default = $eb118b4320ed1979$var$FormIcon;

});

parcelRegister("gsdeR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b57d69a7e6f53846886bde82f36883e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa987cbb111f216$var$_react = $bfa987cbb111f216$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bfa987cbb111f216$var$_baseNew = $bfa987cbb111f216$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bfa987cbb111f216$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfa987cbb111f216$var$MagicWandIcon = (props)=>/*#__PURE__*/ $bfa987cbb111f216$var$_react.default.createElement($bfa987cbb111f216$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$bfa987cbb111f216$var$MagicWandIcon.displayName = 'MagicWandIcon';
var $bfa987cbb111f216$var$_default = module.exports.default = $bfa987cbb111f216$var$MagicWandIcon;

});

parcelRegister("WKTmf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b09caa48a867fe5$var$_react = $0b09caa48a867fe5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0b09caa48a867fe5$var$_baseNew = $0b09caa48a867fe5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $0b09caa48a867fe5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b09caa48a867fe5$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $0b09caa48a867fe5$var$_react.default.createElement($0b09caa48a867fe5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$0b09caa48a867fe5$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $0b09caa48a867fe5$var$_default = module.exports.default = $0b09caa48a867fe5$var$MarketplaceIcon;

});

parcelRegister("aZNQ9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80164316c36f26ef$var$_react = $80164316c36f26ef$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $80164316c36f26ef$var$_baseNew = $80164316c36f26ef$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $80164316c36f26ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80164316c36f26ef$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $80164316c36f26ef$var$_react.default.createElement($80164316c36f26ef$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$80164316c36f26ef$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $80164316c36f26ef$var$_default = module.exports.default = $80164316c36f26ef$var$MegaphoneIcon;

});

parcelRegister("kVLN7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3ce33e03a650826$var$_react = $f3ce33e03a650826$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f3ce33e03a650826$var$_baseNew = $f3ce33e03a650826$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f3ce33e03a650826$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3ce33e03a650826$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $f3ce33e03a650826$var$_react.default.createElement($f3ce33e03a650826$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$f3ce33e03a650826$var$ObjectiveIcon.displayName = 'ObjectiveIcon';
var $f3ce33e03a650826$var$_default = module.exports.default = $f3ce33e03a650826$var$ObjectiveIcon;

});

parcelRegister("gXz9s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c58d6c629e1736c9$var$_react = $c58d6c629e1736c9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c58d6c629e1736c9$var$_baseNew = $c58d6c629e1736c9$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c58d6c629e1736c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c58d6c629e1736c9$var$OperationsIcon = (props)=>/*#__PURE__*/ $c58d6c629e1736c9$var$_react.default.createElement($c58d6c629e1736c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$c58d6c629e1736c9$var$OperationsIcon.displayName = 'OperationsIcon';
var $c58d6c629e1736c9$var$_default = module.exports.default = $c58d6c629e1736c9$var$OperationsIcon;

});

parcelRegister("6QMjb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::975f3556f302c98e53e9a5c512ff1020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fcd12739890eab7$var$_react = $4fcd12739890eab7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4fcd12739890eab7$var$_baseNew = $4fcd12739890eab7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4fcd12739890eab7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4fcd12739890eab7$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $4fcd12739890eab7$var$_react.default.createElement($4fcd12739890eab7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.628.896-2.276a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$4fcd12739890eab7$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $4fcd12739890eab7$var$_default = module.exports.default = $4fcd12739890eab7$var$PresenterModeIcon;

});

parcelRegister("8TzqB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff5f3689a11c3468e5139786a8e64251>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $679ef10acd2bbfb1$var$_react = $679ef10acd2bbfb1$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $679ef10acd2bbfb1$var$_baseNew = $679ef10acd2bbfb1$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $679ef10acd2bbfb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMajor".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for major work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $679ef10acd2bbfb1$var$PriorityMajorIcon = (props)=>/*#__PURE__*/ $679ef10acd2bbfb1$var$_react.default.createElement($679ef10acd2bbfb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 4.75-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625L2.913 6 8 2.65 13.087 6zm0 4.5-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353zm0 4.5-5.5-3.626a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 11.65l5.087 3.353z"/>`
    }, props));
$679ef10acd2bbfb1$var$PriorityMajorIcon.displayName = 'PriorityMajorIcon';
var $679ef10acd2bbfb1$var$_default = module.exports.default = $679ef10acd2bbfb1$var$PriorityMajorIcon;

});

parcelRegister("7v2eo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $575d28b81906db7e$var$_react = $575d28b81906db7e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $575d28b81906db7e$var$_baseNew = $575d28b81906db7e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $575d28b81906db7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $575d28b81906db7e$var$ProjectIcon = (props)=>/*#__PURE__*/ $575d28b81906db7e$var$_react.default.createElement($575d28b81906db7e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$575d28b81906db7e$var$ProjectIcon.displayName = 'ProjectIcon';
var $575d28b81906db7e$var$_default = module.exports.default = $575d28b81906db7e$var$ProjectIcon;

});

parcelRegister("ePHAx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc7a3db189edd40$var$_react = $acc7a3db189edd40$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $acc7a3db189edd40$var$_baseNew = $acc7a3db189edd40$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $acc7a3db189edd40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc7a3db189edd40$var$ScreenIcon = (props)=>/*#__PURE__*/ $acc7a3db189edd40$var$_react.default.createElement($acc7a3db189edd40$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$acc7a3db189edd40$var$ScreenIcon.displayName = 'ScreenIcon';
var $acc7a3db189edd40$var$_default = module.exports.default = $acc7a3db189edd40$var$ScreenIcon;

});

parcelRegister("5ABRP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02df73cd5dddff20d82e48f58fe7ce92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $411db02b8e362021$var$_react = $411db02b8e362021$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $411db02b8e362021$var$_baseNew = $411db02b8e362021$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $411db02b8e362021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $411db02b8e362021$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $411db02b8e362021$var$_react.default.createElement($411db02b8e362021$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$411db02b8e362021$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $411db02b8e362021$var$_default = module.exports.default = $411db02b8e362021$var$ShowMoreVerticalIcon;

});

parcelRegister("cBEbW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0cf5658da3b79d5f876ad9c272a691a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92d81dfa59bd0691$var$_react = $92d81dfa59bd0691$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $92d81dfa59bd0691$var$_baseNew = $92d81dfa59bd0691$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $92d81dfa59bd0691$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92d81dfa59bd0691$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $92d81dfa59bd0691$var$_react.default.createElement($92d81dfa59bd0691$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$92d81dfa59bd0691$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $92d81dfa59bd0691$var$_default = module.exports.default = $92d81dfa59bd0691$var$SmartLinkListIcon;

});

parcelRegister("8pvt1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::338651941b03ec38a528c6808ae2ffcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61f91141962a089c$var$_react = $61f91141962a089c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $61f91141962a089c$var$_baseNew = $61f91141962a089c$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $61f91141962a089c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61f91141962a089c$var$TagIcon = (props)=>/*#__PURE__*/ $61f91141962a089c$var$_react.default.createElement($61f91141962a089c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$61f91141962a089c$var$TagIcon.displayName = 'TagIcon';
var $61f91141962a089c$var$_default = module.exports.default = $61f91141962a089c$var$TagIcon;

});

parcelRegister("3dYrz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::350d68f25c9b4e9b7a6f8128f373fbcc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $259178d3a19d4fdf$var$_react = $259178d3a19d4fdf$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $259178d3a19d4fdf$var$_baseNew = $259178d3a19d4fdf$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $259178d3a19d4fdf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskInProgress".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for in progress task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $259178d3a19d4fdf$var$TaskInProgressIcon = (props)=>/*#__PURE__*/ $259178d3a19d4fdf$var$_react.default.createElement($259178d3a19d4fdf$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h7.646L6.97 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1.542a6.501 6.501 0 1 0 0-1.5M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$259178d3a19d4fdf$var$TaskInProgressIcon.displayName = 'TaskInProgressIcon';
var $259178d3a19d4fdf$var$_default = module.exports.default = $259178d3a19d4fdf$var$TaskInProgressIcon;

});

parcelRegister("hKesO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ceb1f3baa60c34d4$var$_react = $ceb1f3baa60c34d4$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ceb1f3baa60c34d4$var$_baseNew = $ceb1f3baa60c34d4$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ceb1f3baa60c34d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ceb1f3baa60c34d4$var$TransitionIcon = (props)=>/*#__PURE__*/ $ceb1f3baa60c34d4$var$_react.default.createElement($ceb1f3baa60c34d4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$ceb1f3baa60c34d4$var$TransitionIcon.displayName = 'TransitionIcon';
var $ceb1f3baa60c34d4$var$_default = module.exports.default = $ceb1f3baa60c34d4$var$TransitionIcon;

});

parcelRegister("5nJnO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5412db8dd6dbd639e997b10aa14b104a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb24de21519b485$var$_react = $3eb24de21519b485$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3eb24de21519b485$var$_baseNew = $3eb24de21519b485$var$_interopRequireDefault((parcelRequire("jcI35")));
function $3eb24de21519b485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Views".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing saved views.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb24de21519b485$var$ViewsIcon = (props)=>/*#__PURE__*/ $3eb24de21519b485$var$_react.default.createElement($3eb24de21519b485$var$_baseNew.default, Object.assign({
        name: "ViewsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 5.5H6v6h5a.5.5 0 0 0 .5-.5zm-9 5.5a.5.5 0 0 0 .5.5h1.5v-6h-2zm9-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1h9zm1.5 8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 12.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$3eb24de21519b485$var$ViewsIcon.displayName = 'ViewsIcon';
var $3eb24de21519b485$var$_default = module.exports.default = $3eb24de21519b485$var$ViewsIcon;

});




parcelRegister("hTage", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b04807a9d06153e2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $f2QWG = parcelRequire("f2QWG");

var $j60mo = parcelRequire("j60mo");
const $b04807a9d06153e2$var$UniformValueProps = ({ title: title, subtitle: subtitle, cards: cards, mediaAspectRatio: mediaAspectRatio })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = (0, $f2QWG.flattenValues)(cards);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j60mo.default), {
        title: title,
        subtitle: subtitle,
        cards: flattenedCards,
        mediaAspectRatio: mediaAspectRatio
    });
};
var $b04807a9d06153e2$export$2e2bcd8739ae039 = $b04807a9d06153e2$var$UniformValueProps;

});
parcelRegister("j60mo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13c7e41ebe801b17$export$2e2bcd8739ae039; });
/* value-props.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $d4i8K = parcelRequire("d4i8K");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $jlQlZ = parcelRequire("jlQlZ");
const $13c7e41ebe801b17$var$DEFAULT_CYCLE_DURATION_MS = 6000;
const $13c7e41ebe801b17$var$containerCss = null;
const $13c7e41ebe801b17$var$titleContainerCss = null;
const $13c7e41ebe801b17$var$zeroMarginCss = null;
const $13c7e41ebe801b17$var$mobileSectionCss = null;
const $13c7e41ebe801b17$var$desktopSectionCss = null;
const $13c7e41ebe801b17$var$nonDesktopSectionCss = null;
const $13c7e41ebe801b17$var$mediaCss = null;
const $13c7e41ebe801b17$var$standaloneMediaCss = null;
const $13c7e41ebe801b17$var$cardsRowCss = null;
const $13c7e41ebe801b17$var$cardListCss = null;
const $13c7e41ebe801b17$var$mediaFillCss = null;
const $13c7e41ebe801b17$var$mediaAspectRatio1x1Css = null;
const $13c7e41ebe801b17$var$mediaAspectRatio16x9Css = null;
const $13c7e41ebe801b17$var$mediaContainerCss = null;
const $13c7e41ebe801b17$var$mobileInlineMediaCss = null;
const $13c7e41ebe801b17$var$mediaLayerCss = null;
const $13c7e41ebe801b17$var$mediaLayerActiveCss = null;
const $13c7e41ebe801b17$var$mediaLayerInactiveCss = null;
const $13c7e41ebe801b17$var$fadeUpDelay01Css = null;
const $13c7e41ebe801b17$var$fadeUpDelay02Css = null;
const $13c7e41ebe801b17$var$fadeUpDelay03Css = null;
const $13c7e41ebe801b17$var$mobileCardListWrapperCss = null;
const $13c7e41ebe801b17$var$mobileBottomFadeCss = null;
const $13c7e41ebe801b17$var$mobileBottomFadeVisibleCss = null;
const $13c7e41ebe801b17$var$mobileBottomFadeHiddenCss = null;
const $13c7e41ebe801b17$var$fadeUpCss = null;
// Applied when IO fires — unpauses the fade-up animation
const $13c7e41ebe801b17$var$fadeUpActiveCss = null;
const $13c7e41ebe801b17$var$VideoContent = ({ card: card, isActive: isActive, videoType: videoType, onDuration: onDuration, onPlayingChange: onPlayingChange })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // Reset to start and optimistically signal playing when card becomes active.
    (0, $1oC0p.useEffect)(()=>{
        const video = videoRef.current;
        if (!video) return;
        if (!isActive) {
            onPlayingChange?.(false);
            return;
        }
        video.currentTime = 0;
        if (video.readyState >= 1 && video.duration && isFinite(video.duration)) onDuration?.(Math.round(video.duration * 1000));
        onPlayingChange?.(true);
        video.play().catch(()=>{
            onPlayingChange?.(false);
        });
    }, [
        isActive,
        onDuration,
        onPlayingChange
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const video = videoRef.current;
        if (!video) return;
        const handleMetadata = ()=>{
            if (video.duration && isFinite(video.duration)) onDuration?.(Math.round(video.duration * 1000));
        };
        const handlePlaying = ()=>onPlayingChange?.(true);
        const handleNotPlaying = ()=>onPlayingChange?.(false);
        if (video.readyState >= 1) handleMetadata();
        video.addEventListener("loadedmetadata", handleMetadata);
        video.addEventListener("playing", handlePlaying);
        video.addEventListener("pause", handleNotPlaying);
        video.addEventListener("waiting", handleNotPlaying);
        return ()=>{
            video.removeEventListener("loadedmetadata", handleMetadata);
            video.removeEventListener("playing", handlePlaying);
            video.removeEventListener("pause", handleNotPlaying);
            video.removeEventListener("waiting", handleNotPlaying);
        };
    }, [
        onDuration,
        onPlayingChange
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
        ref: videoRef,
        "data-value-props-video": true,
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        "aria-label": isActive ? card.mediaAlt || card.title : undefined,
        "aria-hidden": !isActive,
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1osq _5ral1dfr _1e0c1ule"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
            src: card.videoSrc,
            type: `video/${videoType}`
        })
    });
};
const $13c7e41ebe801b17$var$MediaContent = ({ card: card, isActive: isActive = true, onDuration: onDuration, onPlayingChange: onPlayingChange })=>{
    if (card.imageSrc) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
        src: card.imageSrc,
        alt: isActive ? card.mediaAlt || card.title : "",
        "aria-hidden": !isActive,
        className: (0, $2jatx.default)([
            "_1bsb1osq _4t3i1osq _5ral1dfr _1e0c1ule"
        ])
    });
    if (card.videoSrc) {
        const videoFormat = card.videoSrc.split(".").at(-1);
        const videoType = videoFormat === "webm" ? "webm" : "mp4";
        return /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$VideoContent, {
            card: card,
            isActive: isActive,
            videoType: videoType,
            onDuration: onDuration,
            onPlayingChange: onPlayingChange
        });
    }
    return null;
};
const $13c7e41ebe801b17$var$MediaStack = /*#__PURE__*/ (0, $1oC0p.memo)(({ cards: cards, activeIndex: activeIndex, mediaAspectRatio: mediaAspectRatio, onDuration: onDuration, onPlayingChange: onPlayingChange })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb1osq _1reo15vq _18m915vq _2rkovwyg",
            mediaAspectRatio === "16 / 9" && "_1h1tcq2i",
            mediaAspectRatio === "1 / 1" && "_1h1t1ekt"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
        },
        children: cards.map((card, index)=>{
            const isCardActive = index === activeIndex;
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": !isCardActive,
                className: (0, $2jatx.default)([
                    "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq _tnoqv7pp",
                    isCardActive && "_tzy4kb7n",
                    !isCardActive && "_tzy4idpf _lcxvglyw"
                ]),
                style: {
                    "--_1yae2au": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.duration.400ms")),
                    "--_1xciwtr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease40-in-out"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$MediaContent, {
                    card: card,
                    isActive: isCardActive,
                    onDuration: isCardActive ? onDuration : undefined,
                    onPlayingChange: isCardActive ? onPlayingChange : undefined
                })
            }, index);
        })
    }));
const $13c7e41ebe801b17$var$CardListItem = /*#__PURE__*/ (0, $1oC0p.memo)(({ card: card, index: index, activeIndex: activeIndex, dataEventProps: dataEventProps, isPlaying: isPlaying, cycleDurationMs: cycleDurationMs, activeVideoDurationMs: activeVideoDurationMs, isActiveVideoPlaying: isActiveVideoPlaying, onCardClick: onCardClick, onAdvance: onAdvance, onPlayPauseToggle: onPlayPauseToggle, mediaTile: mediaTile })=>{
    const isActive = index === activeIndex;
    const onActivate = (0, $1oC0p.useCallback)(()=>onCardClick(index), [
        onCardClick,
        index
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jlQlZ.ValuePropCard), {
                card: card,
                isActive: isActive,
                index: index,
                dataEventProps: dataEventProps,
                onActivate: onActivate,
                isPlaying: isPlaying,
                onAdvance: onAdvance,
                cycleDurationMs: cycleDurationMs,
                activeVideoDurationMs: isActive ? activeVideoDurationMs : null,
                isActiveVideoPlaying: isActive ? isActiveVideoPlaying : false,
                onPlayPauseToggle: onPlayPauseToggle
            }),
            isActive && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule _476dutpp _1rfm1osq _1cro1wwu _wqfn1014 _1e0rljc1 _dqw81hrf"
                ]),
                style: {
                    "--_1yae2au": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.duration.400ms")),
                    "--_1xciwtr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease40-in-out"))
                },
                children: mediaTile
            })
        ]
    });
});
const $13c7e41ebe801b17$var$CardListSection = /*#__PURE__*/ (0, $1oC0p.memo)(({ cards: cards, activeIndex: activeIndex, dataEventProps: dataEventProps, isPlaying: isPlaying, cycleDurationMs: cycleDurationMs, activeVideoDurationMs: activeVideoDurationMs, isActiveVideoPlaying: isActiveVideoPlaying, onCardClick: onCardClick, onAdvance: onAdvance, onPlayPauseToggle: onPlayPauseToggle, mediaTile: mediaTile, ulRef: ulRef, minHeight: minHeight, showMobileFade: showMobileFade })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1fhb _zulppxbi _8164idpf",
            showMobileFade !== undefined && "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                ref: ulRef,
                style: minHeight !== undefined ? {
                    minHeight: minHeight
                } : undefined,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _a64kxy5q _1oyh1wqb"
                ]),
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$CardListItem, {
                        card: card,
                        index: index,
                        activeIndex: activeIndex,
                        dataEventProps: dataEventProps,
                        isPlaying: isPlaying,
                        cycleDurationMs: cycleDurationMs,
                        activeVideoDurationMs: activeVideoDurationMs,
                        isActiveVideoPlaying: isActiveVideoPlaying,
                        onCardClick: onCardClick,
                        onAdvance: onAdvance,
                        onPlayPauseToggle: onPlayPauseToggle,
                        mediaTile: mediaTile
                    }, index))
            }),
            showMobileFade !== undefined && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": true,
                "data-testid": "value-props-mobile-bottom-fade",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf _rjxpidpf _u7coidpf _4t3it9kd _1pbycs5v _11q71m2d _lcxvglyw _181nglyw _tnoqih65",
                    showMobileFade ? "_tzy4kb7n" : "_tzy4idpf"
                ]),
                style: {
                    "--_1xciwtr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease40-in-out"))
                }
            })
        ]
    }));
const $13c7e41ebe801b17$var$ValueProps = ({ title: title, subtitle: subtitle, cards: cards, mediaAspectRatio: mediaAspectRatio = "1 / 1", dataEventProps: dataEventProps, cycleDurationMs: cycleDurationMs = $13c7e41ebe801b17$var$DEFAULT_CYCLE_DURATION_MS })=>{
    // ── State ────────────────────────────────────────────────────────────────
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(0);
    const [isPlaying, setIsPlaying] = (0, $1oC0p.useState)(false);
    const [activeVideoDurationMs, setActiveVideoDurationMs] = (0, $1oC0p.useState)(null);
    const [isActiveVideoPlaying, setIsActiveVideoPlaying] = (0, $1oC0p.useState)(false);
    const [cardListMinHeight, setCardListMinHeight] = (0, $1oC0p.useState)(undefined);
    const [tabletCardListMinHeight, setTabletCardListMinHeight] = (0, $1oC0p.useState)(undefined);
    const [fadeVisible, setFadeVisible] = (0, $1oC0p.useState)(false);
    const [hasEnteredView, setHasEnteredView] = (0, $1oC0p.useState)(false);
    // ── Refs ─────────────────────────────────────────────────────────────────
    const containerRef = (0, $1oC0p.useRef)(null);
    const cardListRef = (0, $1oC0p.useRef)(null);
    const tabletCardListRef = (0, $1oC0p.useRef)(null);
    const { ref: ioRef, inView: inView } = (0, $jKShK.useInView)({
        threshold: 0.35
    });
    const fadeTimerRef = (0, $1oC0p.useRef)(null);
    // ── Effects ──────────────────────────────────────────────────────────────
    (0, $1oC0p.useEffect)(()=>{
        if (inView) {
            setActiveIndex(0);
            setFadeVisible(false);
            setIsPlaying(!(0, $d4i8K.isReducedMotion)());
            setHasEnteredView(true);
        } else setIsPlaying(false);
    }, [
        inView
    ]);
    (0, $1oC0p.useLayoutEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        const videos = container.querySelectorAll("video[data-value-props-video]");
        videos.forEach((video)=>{
            if (isPlaying) // eslint-disable-next-line @typescript-eslint/no-empty-function
            video.play().catch(()=>{});
            else video.pause();
        });
    }, [
        isPlaying,
        activeIndex
    ]);
    (0, $1oC0p.useEffect)(()=>{
        setActiveVideoDurationMs(null);
    }, [
        activeIndex
    ]);
    // Track each section's card list max height and lock it as min-height
    // so the column never shrinks when an active card collapses.
    (0, $1oC0p.useEffect)(()=>{
        const observers = [];
        const rafIds = [];
        const watch = (el, setter)=>{
            if (!el) return;
            let rafId = 0;
            const observer = new ResizeObserver(()=>{
                cancelAnimationFrame(rafId);
                rafId = requestAnimationFrame(()=>{
                    const h = el.getBoundingClientRect().height;
                    setter(h);
                });
                rafIds.push(rafId);
            });
            observer.observe(el);
            observers.push(observer);
        };
        watch(cardListRef.current, (h)=>setCardListMinHeight((prev)=>prev === undefined || h > prev ? h : prev));
        watch(tabletCardListRef.current, (h)=>setTabletCardListMinHeight((prev)=>prev === undefined || h > prev ? h : prev));
        return ()=>{
            observers.forEach((o)=>o.disconnect());
            rafIds.forEach((id)=>cancelAnimationFrame(id));
        };
    }, []);
    // ── Handlers ─────────────────────────────────────────────────────────────
    const handleAdvance = (0, $1oC0p.useCallback)(()=>{
        setActiveIndex((prev)=>(prev + 1) % cards.length);
    }, [
        cards.length
    ]);
    const handleCardClick = (0, $1oC0p.useCallback)((index)=>{
        if (index === activeIndex) return;
        setActiveIndex(index);
        setIsPlaying(!(0, $d4i8K.isReducedMotion)());
        // Mobile bottom fade — manual select only, not auto-advance
        if (!(0, $d4i8K.isReducedMotion)()) {
            if (fadeTimerRef.current) clearTimeout(fadeTimerRef.current);
            setFadeVisible(true);
            fadeTimerRef.current = setTimeout(()=>{
                setFadeVisible(false);
                fadeTimerRef.current = null;
            }, 1800);
        }
    }, [
        activeIndex
    ]);
    const handlePlayPauseToggle = (0, $1oC0p.useCallback)(()=>{
        setIsPlaying((prev)=>!prev);
    }, []);
    const handleVideoDuration = (0, $1oC0p.useCallback)((ms)=>{
        setActiveVideoDurationMs(ms);
    }, []);
    const handleVideoPlayingChange = (0, $1oC0p.useCallback)((playing)=>{
        setIsActiveVideoPlaying(playing);
    }, []);
    const setContainerRef = (0, $1oC0p.useCallback)((node)=>{
        containerRef.current = node;
        ioRef(node);
    }, [
        ioRef
    ]);
    // ── Early return ─────────────────────────────────────────────────────────
    if (!cards || cards.length === 0) return null;
    const activeCard = cards[activeIndex];
    const mediaTile = /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$MediaStack, {
        cards: cards,
        activeIndex: activeIndex,
        mediaAspectRatio: mediaAspectRatio,
        onDuration: handleVideoDuration,
        onPlayingChange: handleVideoPlayingChange
    });
    const mediaContent = activeCard && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _1ul9idpf _1rfm1osq",
            "_sugaglyw"
        ]),
        children: mediaTile
    });
    const sharedCardListProps = {
        cards: cards,
        activeIndex: activeIndex,
        dataEventProps: dataEventProps,
        isPlaying: isPlaying,
        cycleDurationMs: cycleDurationMs,
        activeVideoDurationMs: activeVideoDurationMs,
        isActiveVideoPlaying: isActiveVideoPlaying,
        onCardClick: handleCardClick,
        onAdvance: handleAdvance,
        onPlayPauseToggle: handlePlayPauseToggle,
        mediaTile: mediaTile
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: setContainerRef,
        "data-testid": "value-props",
        className: (0, $2jatx.default)([
            "_1rjcys9h _1e0c1txw _2lx21bp4 _zulpxncg _13og16xz _133ixncg _8164xy5q"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                layout: "8-4",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "_1e0c1txw _2lx21bp4 _zulpu2gc _109k8k1a"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_tzy4idpf _1crop1f2 _wqfn9cwz _1e0r5ucs _dqw8q7pw _1c1qtrqk _bl8a1wwu _2hwz1q10 _1gx9p3kn _3e9gq7pw _1dwqtrqk",
                                    hasEnteredView && "_1c1qo91m _1dwqo91m",
                                    "_ju251yx9"
                                ]),
                                style: {
                                    "--_1d1hez4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.duration.200ms"))
                                },
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_tzy4idpf _1crop1f2 _wqfn9cwz _1e0r5ucs _dqw8q7pw _1c1qtrqk _bl8a1wwu _2hwz1q10 _1gx9p3kn _3e9gq7pw _1dwqtrqk",
                                    hasEnteredView && "_1c1qo91m _1dwqo91m",
                                    "_ju25fnf5",
                                    "body-lg"
                                ]),
                                style: {
                                    "--_1d1hez4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.duration.200ms"))
                                },
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _1crop1f2 _wqfn9cwz _1e0r5ucs _dqw8q7pw _1c1qtrqk _bl8a1wwu _2hwz1q10 _1gx9p3kn _3e9gq7pw _1dwqtrqk",
                    hasEnteredView && "_1c1qo91m _1dwqo91m",
                    subtitle ? "_ju25188d" : "_ju25fnf5"
                ]),
                style: {
                    "--_1d1hez4": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.duration.200ms"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _dm251ule"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                            layout: "6-6",
                            verticalAlignment: "center",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$CardListSection, {
                                    ...sharedCardListProps,
                                    ulRef: cardListRef,
                                    minHeight: cardListMinHeight
                                }),
                                mediaContent
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _181n1ule _dm25glyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                            layout: "6-6",
                            verticalAlignment: "center",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$CardListSection, {
                                    ...sharedCardListProps,
                                    ulRef: tabletCardListRef,
                                    minHeight: tabletCardListMinHeight
                                }),
                                mediaContent
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _181nglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                            layout: "6-6",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)($13c7e41ebe801b17$var$CardListSection, {
                                    ...sharedCardListProps,
                                    showMobileFade: fadeVisible
                                }),
                                mediaContent
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $13c7e41ebe801b17$export$2e2bcd8739ae039 = $13c7e41ebe801b17$var$ValueProps;

});
parcelRegister("jlQlZ", function(module, exports) {
$parcel$export(module.exports, "ValuePropCard", function () { return $46cd2396a421c6d3$export$6de1d248f98ef1d; });
/* value-prop-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iPPTB = parcelRequire("iPPTB");

var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");
const $46cd2396a421c6d3$var$DEFAULT_CYCLE_DURATION_MS = 6000;
const $46cd2396a421c6d3$var$prefersReducedMotion = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $46cd2396a421c6d3$var$cardWrapperCss = null;
const $46cd2396a421c6d3$var$containerCss = null;
const $46cd2396a421c6d3$var$inCardPlayPauseCss = null;
const $46cd2396a421c6d3$var$cardContainerFocusCss = null;
const $46cd2396a421c6d3$var$progressBarContainerCss = null;
const $46cd2396a421c6d3$var$progressBarContainerActiveCss = null;
const $46cd2396a421c6d3$var$progressBarContainerInactiveCss = null;
const $46cd2396a421c6d3$var$barVisibleCss = null;
const $46cd2396a421c6d3$var$barHiddenCss = null;
const $46cd2396a421c6d3$var$progressBarFillKeyframes = null;
const $46cd2396a421c6d3$var$progressBarFillCss = null;
const $46cd2396a421c6d3$var$contentCss = null;
const $46cd2396a421c6d3$var$titleCss = null;
const $46cd2396a421c6d3$var$inactiveTitleCss = null;
const $46cd2396a421c6d3$var$cardHoverTitleCss = null;
const $46cd2396a421c6d3$var$descriptionCss = null;
const $46cd2396a421c6d3$var$linkContainerCss = null;
const $46cd2396a421c6d3$var$bodyExpandCss = null;
const $46cd2396a421c6d3$var$bodyExpandActiveCss = null;
const $46cd2396a421c6d3$var$bodyExpandInactiveCss = null;
const $46cd2396a421c6d3$var$bodyInnerCss = null;
const $46cd2396a421c6d3$var$gradientMaskCss = null;
const $46cd2396a421c6d3$var$gradientMaskVisibleCss = null;
const $46cd2396a421c6d3$var$gradientMaskHiddenCss = null;
function $46cd2396a421c6d3$var$computeFillBarState({ card: card, isActive: isActive, isPlaying: isPlaying, isActiveVideoPlaying: isActiveVideoPlaying, activeVideoDurationMs: activeVideoDurationMs, cycleDurationMs: cycleDurationMs }) {
    const showBar = isActive;
    const fillDurationMs = card.videoSrc && activeVideoDurationMs ? activeVideoDurationMs : cycleDurationMs;
    const isFillBarRunning = card.videoSrc ? isPlaying && isActiveVideoPlaying : isPlaying;
    return {
        showBar: showBar,
        fillDurationMs: fillDurationMs,
        isFillBarRunning: isFillBarRunning
    };
}
const $46cd2396a421c6d3$var$CardBody = /*#__PURE__*/ (0, $1oC0p.memo)(({ card: card, isActive: isActive, dataEventProps: dataEventProps })=>{
    const [isTransitioning, setIsTransitioning] = (0, $1oC0p.useState)(false);
    const isFirstRender = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if ($46cd2396a421c6d3$var$prefersReducedMotion) return;
        setIsTransitioning(true);
        const t = setTimeout(()=>setIsTransitioning(false), 600);
        return ()=>clearTimeout(t);
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1rjcu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3 _v5641plk",
                    !isActive && "_syaz1c7a",
                    `card-title-sm${!isActive ? " card-inactive-title" : ""}`
                ]),
                style: {
                    "--_12o779w": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.duration.250ms")),
                    "--_1xciwtr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease40-in-out")),
                    "--_1ayut75": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light500"))
                },
                children: card.title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "aria-hidden": !isActive,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c11p5 _1bsb1osq _1reozryt _18m9zryt",
                    isActive ? "_2z05hkll _tzy4kb7n _1pfhu2gc _10t81iqs _xrrpcbtt _1xq5p4r4" : "_2z0563bf _tzy4idpf _1pfhidpf"
                ]),
                style: {
                    "--_fcduk8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease.cubic-out"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1tkeidpf _1reo15vq _18m915vq"
                        ]),
                        children: [
                            card.description && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "body-md"
                                ]),
                                children: card.description
                            }),
                            isActive && card.linkText && card.linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1q51u2gc"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    "aria-label": card.linkText,
                                    text: card.linkText,
                                    href: card.linkHref,
                                    type: "primary",
                                    dataEventProps: dataEventProps,
                                    anchorProps: {
                                        tabIndex: 0
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": true,
                        "data-testid": "value-prop-gradient-mask",
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1e02idpf _rjxpidpf _u7coidpf _4t3i1f4h _11q71m2d _lcxvglyw _tnoq1mbg",
                            isTransitioning ? "_tzy4kb7n" : "_tzy4idpf"
                        ])
                    })
                ]
            })
        ]
    });
});
function $46cd2396a421c6d3$var$buildInteractiveProps(isActive, title, onActivate, handleKeyDown) {
    if (isActive) return {
        "aria-label": title
    };
    return {
        "role": "button",
        "tabIndex": 0,
        "aria-pressed": false,
        "aria-label": title,
        "onClick": onActivate,
        "onKeyDown": handleKeyDown
    };
}
const $46cd2396a421c6d3$export$6de1d248f98ef1d = ({ card: card, isActive: isActive, index: index, dataEventProps: dataEventProps, onActivate: onActivate, isPlaying: isPlaying = true, onAdvance: onAdvance, cycleDurationMs: cycleDurationMs = $46cd2396a421c6d3$var$DEFAULT_CYCLE_DURATION_MS, activeVideoDurationMs: activeVideoDurationMs = null, isActiveVideoPlaying: isActiveVideoPlaying = false, onPlayPauseToggle: onPlayPauseToggle, fillColor: fillColor })=>{
    const { showBar: showBar, fillDurationMs: fillDurationMs, isFillBarRunning: isFillBarRunning } = $46cd2396a421c6d3$var$computeFillBarState({
        card: card,
        isActive: isActive,
        isPlaying: isPlaying,
        isActiveVideoPlaying: isActiveVideoPlaying,
        activeVideoDurationMs: activeVideoDurationMs,
        cycleDurationMs: cycleDurationMs
    });
    const handleKeyDown = (0, $1oC0p.useCallback)((e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onActivate?.();
        }
    }, [
        onActivate
    ]);
    const interactiveProps = (0, $1oC0p.useMemo)(()=>$46cd2396a421c6d3$var$buildInteractiveProps(isActive, card.title, onActivate, handleKeyDown), [
        isActive,
        card.title,
        onActivate,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm",
            !isActive && "_1wnbgspj _1k3sgspj"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: [
            isActive && onPlayPauseToggle && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: (el)=>{
                    const button = el?.querySelector("button");
                    if (button) button.tabIndex = 0;
                },
                className: (0, $2jatx.default)([
                    "_kqswpfqs _6rthu2gc _1rqistnw _1ob9idpf _isae1rgy _12ho1ssb _sfej1i34 _1t06u6a3"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                    isPlaying: Boolean(isPlaying),
                    onToggle: onPlayPauseToggle,
                    mediaLabel: card.title
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "data-testid": `value-prop-card-${index}`,
                "data-active": isActive,
                ...interactiveProps,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc _zulppxbi _80omtlke _y3gn1e5h _1bsb1osq",
                    "_1ygb7g83 _1ah3yh40 _1basi2wt"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": !showBar,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsbi2wt _1o9zidpf _2rkogktf _1reo15vq _18m915vq _kqswh2mm _tnoqzz1x",
                            isActive && "_bfhk1ybm",
                            !isActive && "_bfhk1j28",
                            showBar && "_tzy4kb7n",
                            !showBar && "_tzy4idpf"
                        ]),
                        style: {
                            "--_12o779w": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.duration.250ms")),
                            "--_1xciwtr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("motion.easing.ease40-in-out")),
                            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                        },
                        children: isActive && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            onAnimationEnd: onAdvance,
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3iidpf _bfhk17la _j7hqoqos _1pglp3kn _1o51q7pw"
                            ]),
                            style: {
                                animationDuration: `${fillDurationMs}ms`,
                                animationPlayState: isFillBarRunning ? "running" : "paused",
                                ...fillColor ? {
                                    backgroundColor: fillColor
                                } : undefined,
                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($46cd2396a421c6d3$var$CardBody, {
                        card: card,
                        isActive: isActive,
                        dataEventProps: dataEventProps
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("3QKwy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3060f0168074f205$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");
const $3060f0168074f205$var$UniformVariant = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "content"
    });
};
var $3060f0168074f205$export$2e2bcd8739ae039 = $3060f0168074f205$var$UniformVariant;

});

parcelRegister("lEcJc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bb51508c51ba651c$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $01zo5 = parcelRequire("01zo5");
const $bb51508c51ba651c$var$UniformVariantContainer = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $01zo5.UniformSlot), {
        name: "content"
    });
var $bb51508c51ba651c$export$2e2bcd8739ae039 = $bb51508c51ba651c$var$UniformVariantContainer;

});

parcelRegister("1GX5U", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b0a9b5927ee6753$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $lE15B = parcelRequire("lE15B");
const $3b0a9b5927ee6753$var$UniformVideo = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        ...props
    });
};
var $3b0a9b5927ee6753$export$2e2bcd8739ae039 = $3b0a9b5927ee6753$var$UniformVideo;

});

parcelRegister("fzMpf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ccbd79059002b008$export$2e2bcd8739ae039; });
/* video-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $f2QWG = parcelRequire("f2QWG");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $kbpa7 = parcelRequire("kbpa7");

var $a83FW = parcelRequire("a83FW");
const $ccbd79059002b008$var$UniformVideoCarousel = ({ videoCarousel: videoCarousel, flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $f2QWG.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $1oC0p.useRef)([]);
    const videoContainerRef = (0, $1oC0p.useRef)(null);
    const [current, setCurrent] = (0, $1oC0p.useState)(0);
    const currentRef = (0, $1oC0p.useRef)(current);
    const [playing, setPlaying] = (0, $1oC0p.useState)(true);
    const [durations, setDurations] = (0, $1oC0p.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $1oC0p.useState)(0);
    // @ts-ignore
    const prevViewportWidth = (0, $1oC0p.useRef)(typeof window !== "undefined" ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $1oC0p.useState)(typeof window !== "undefined" ? window.innerWidth : 0);
    (0, $1oC0p.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]);
    // On-load - set up video durations
    (0, $1oC0p.useEffect)(()=>{
        // Video durations
        videoCarouselData.forEach((_, idx)=>{
            const video = videoRefs.current[idx];
            if (!video) return;
            if (video.readyState >= 1) setDurations((durs)=>{
                const copy = [
                    ...durs
                ];
                copy[idx] = video.duration;
                return copy;
            });
            else video.onloadedmetadata = ()=>{
                setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
            };
        });
    }, [
        videoCarouselData
    ]);
    // Play next video on end, looping
    const handleEnded = ()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    };
    // Pause/play current video
    (0, $1oC0p.useEffect)(()=>{
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]);
    const { firePlayPauseClicked: firePlayPauseClicked, fireTeamSelected: fireTeamSelected } = (0, $a83FW.useVideoCarouselAnalytics)();
    // Pause/play toggle
    const togglePlay = ()=>{
        setPlaying((p)=>{
            firePlayPauseClicked(p ? "pause" : "play");
            return !p;
        });
    };
    // Jump to a specific video and start from beginning
    const handleTeamClick = (idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        const team = videoCarouselData[idx]?.team ?? String(idx);
        fireTeamSelected(team);
        setCurrent(idx);
        setPlaying(true);
    };
    const currentDuration = durations[current] || 10;
    // Responsive asset type
    (0, $1oC0p.useEffect)(()=>{
        let resizeTimeout;
        const breakpoints = [
            768,
            1024
        ];
        // Store previous width outside the handler so it persists
        const prevViewportWidth = {
            current: window.innerWidth
        };
        function crossedBreakpoint(prev, curr) {
            return breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        }
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevViewportWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevViewportWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? "desktop" : viewportWidth >= 768 ? "tablet" : "mobile";
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: videoContainerRef,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e021ssb _t9eczr6s",
                    "_1bsb1osq _4t3ieo28 _1vkh124j _tnru1jje"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                    ]),
                    children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                            ref: (el)=>videoRefs.current[idx] = el,
                            src: assetType === "desktop" ? desktopVideoSrc : assetType === "tablet" ? tabletVideoSrc : mobileVideoSrc,
                            muted: true,
                            playsInline: true,
                            onEnded: handleEnded,
                            autoPlay: idx === current && playing,
                            controls: false,
                            "aria-label": ariaLabel || intl.formatMessage({
                                id: "video-carousel.video-label",
                                defaultMessage: "{team} video"
                            }, {
                                team: team
                            }),
                            preload: "auto",
                            poster: (assetType === "desktop" ? desktopPoster : assetType === "tablet" ? tabletPoster : mobilePoster) ?? undefined,
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3ieo28 _1vkh124j _tnru1jje",
                                "_1e0c1ule _3um0ceft _4t3iq0p9 _5ral1dfr"
                            ]),
                            style: {
                                "--_1ktsfil": (0, $6ZVlx.default)(idx === current ? "visible" : "hidden"),
                                "--_18c8iaj": (0, $6ZVlx.default)(idx === current ? "100%" : 0)
                            }
                        }, team))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _1e0c11p5 _yv0e15eh _1ul9idpf _476dutpp _19d71wug _zzszh9n0"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            type: "button",
                            onClick: togglePlay,
                            "aria-label": intl.formatMessage(playing ? {
                                id: "rovo-hero.pause",
                                defaultMessage: "Pause"
                            } : {
                                id: "rovo-hero.play",
                                defaultMessage: "Play"
                            }),
                            "aria-pressed": playing,
                            className: (0, $2jatx.default)([
                                "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1ygb8djs _1ah3yh40 _1tzgkb7n _1acakb7n"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4t3izwfg _1bsbzwfg _bfhk1aeo _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31s03 _1tjq1s1x"
                                ]),
                                style: {
                                    "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000")),
                                    "--_1mbq9ci": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark800")),
                                    "--_1jncskl": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark300"))
                                },
                                children: playing ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                                    label: intl.formatMessage({
                                        id: "rovo-hero.pause",
                                        defaultMessage: "Pause"
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                    label: intl.formatMessage({
                                        id: "rovo-hero.play",
                                        defaultMessage: "Play"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq _1ul9idpf _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>handleTeamClick(idx),
                                    "aria-label": intl.formatMessage({
                                        id: "video-carousel.team-button",
                                        defaultMessage: "Play {team} video"
                                    }, {
                                        team: team
                                    }),
                                    "aria-pressed": idx === current,
                                    className: (0, $2jatx.default)([
                                        "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1ul9idpf _1o9zkb7n _ect41pz4 _1wyb1j6v _k48p1fw0 _vwz41k8s _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1ygb8djs _1ah3yh40",
                                        "_syazxvv5 _d0al18ta"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                        "--_145xjfw": (0, $6ZVlx.default)(idx === current ? (0, $kbpa7.wacToken)("color.primary.blue") : (0, $kbpa7.wacToken)("color.neutral.light800")),
                                        "--_1sd2kd4": (0, $6ZVlx.default)(idx === current ? "auto" : "pointer")
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhku4vp _1mou1ilp",
                                                idx === 0 && "_2rkonggr",
                                                idx === videoCarouselData.length - 1 && "_2rkof82g"
                                            ]),
                                            style: {
                                                "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                                            },
                                            children: idx === current && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3i1osq _1bsb1osq _bfhk17la _kqswstnw _1e02idpf _152tidpf",
                                                    "_y44v1gj6 _1y0c1j4f",
                                                    "fillBar"
                                                ]),
                                                style: {
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                                    "--_1fmqpqp": (0, $6ZVlx.default)(currentDuration, "s"),
                                                    "--_snrfvu": (0, $6ZVlx.default)(playing ? "running" : "paused")
                                                }
                                            }, fillBarResetKey)
                                        }),
                                        team
                                    ]
                                }, team))
                        })
                    ]
                })
            })
        ]
    });
};
var $ccbd79059002b008$export$2e2bcd8739ae039 = $ccbd79059002b008$var$UniformVideoCarousel;
const $ccbd79059002b008$var$containerCss = null;
const $ccbd79059002b008$var$videoContainerCss = null;
const $ccbd79059002b008$var$videoDimensionsCss = null;
const $ccbd79059002b008$var$videoCss = null;
const $ccbd79059002b008$var$controlContainerCss = null;
const $ccbd79059002b008$var$barContainerCss = null;
const $ccbd79059002b008$var$buttonCss = null;
const $ccbd79059002b008$var$buttonCirlceCss = null;
const $ccbd79059002b008$var$firstBarCss = null;
const $ccbd79059002b008$var$lastBarCss = null;
const $ccbd79059002b008$var$barbuttonCss = null;
const $ccbd79059002b008$var$barCss = null;
const $ccbd79059002b008$var$fillBarCss = null;
const $ccbd79059002b008$var$fill = null;

});
parcelRegister("a83FW", function(module, exports) {
$parcel$export(module.exports, "useVideoCarouselAnalytics", function () { return $c5c412151d6a4fe0$export$10e1b210df4c0057; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");
function $c5c412151d6a4fe0$export$10e1b210df4c0057() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const firePlayPauseClicked = (0, $1oC0p.useCallback)((label)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "playPause",
            source: "videoCarousel",
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireTeamSelected = (0, $1oC0p.useCallback)((team)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "teamSelector",
            source: "videoCarousel",
            attributes: {
                team: team
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        firePlayPauseClicked: firePlayPauseClicked,
        fireTeamSelected: fireTeamSelected
    };
}

});



parcelRegister("g70ym", function(module, exports) {
$parcel$export(module.exports, "UniformMissingComponent", function () { return $ff4b1737eead1b52$export$ec79654869ecfe2e; });
/* uniform-missing-component.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $ff4b1737eead1b52$export$ec79654869ecfe2e = ({ componentName: componentName })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        id: `UNIFORM-MISSING-COMPONENT-${componentName}`,
        "data-nosnippet": true,
        "aria-hidden": true,
        className: (0, $2jatx.default)([
            "_1e0cglyw"
        ])
    });
};

});



//# sourceMappingURL=index.ca6f2f6b.js.map
